/**
 * @preserve Personetics story widget 
 * API version: v2.0
 * Client version: 2018.2.2.0.story-client-open-bank.2.5.0.0_2022-08-11 08:37
 * Generated on: 08-23-22
 */

(function(window, Personetics, undefined){

	Personetics.processor = Personetics.processor || {};
	var templateDateRegex = /Date\s+([A-Za-z\.\[\]\(\)\'\,\_0-9]*)(?:\s+format='(.*)')?/;
	var templateEmojiRegex = /Emoji\s+([A-Za-z\.\[\]\(\)\'\,\_0-9]*)?/;
	var templateAmountRegex = /Amount\s+([A-Za-z\d\.\[\]\(\)\'\,\_\/\*\+\-]*)(?:\s+format='([#0,\.\+ \-@]*)')?(?:\s+currency='(.*)')?/;/**space for support space in the format */
	var templateStringRegex = /String\s+([A-Za-z\d\.\[\]\(\)\'\,\/\*\+\-]*)?(?:\s+maxLength='(.*)')?/;
	var nodeTypes = ["BinaryExpression", "UnaryExpression", "Identifier", "Literal", "ArrayExpression", "MemberExpression", "CallExpression"];

	Personetics.processor.PExp = function PExp(expStr) {
		this.str = this.compile(expStr);
		try {
			this.exp = jsep(this.str);
		}
		catch(e){
            this.err(e, "PExp('" + this.str + "') Error -Invalid expression: '" + expStr + "'", true);
		}
	};
	Personetics.processor.PExp.prototype.binops = {
		"+" : function(a, b) { return a + b; },
		"-" : function(a, b) { return a - b; },
		"*" : function(a, b) { return a * b; },
		"/" : function(a, b) { if(b == 0) return 0; return a / b; },
		"%" : function(a, b) { return a % b; },
		"==" : function(a, b) { return a == b; },
		"!=" : function(a, b) { return a != b; },
		"<" : function(a, b) { return a < b; },
		"<=" : function(a, b) { return a <= b; },
		">" : function(a, b) { return a > b; },
		">=" : function(a, b) { return a >= b; }
	};
	Personetics.processor.PExp.prototype.unops = {
		"-" : function(a) { return -a; },
		"+" : function(a) { return a; }
	};
	
	Personetics.processor.PExp.prototype.compile = function compile(exp){
		var originalExp = exp;
		var dateMatch = exp.match(templateDateRegex);
        var value;
        var format;

		if(dateMatch){			
			 value = dateMatch[1];
			 format = null;

			if(dateMatch.length > 2 && dateMatch[2])
				format = "'" + dateMatch[2] + "'";
			exp = "utils.formatDate(" + value + "," + format + ")";
		}

		var amountMatch = exp.match(templateAmountRegex);
		if(amountMatch){
			value = amountMatch[1];
			format = null;
			var currency = null;

			var amountMatch2 = amountMatch[2];
			if(typeof amountMatch2 !== 'undefined' && amountMatch2 !== null && amountMatch2.length > 0)
				format = "'" + amountMatch[2] + "'";

			if(typeof amountMatch[3] !== 'undefined' && amountMatch[3] !== null)
				//this string  " ' $ " is problematic with replace so
				//currency must be wraped with "" instead of '' 
				// currency = '"' + amountMatch[3] + '"';
				// currency symbol evaluated as expression
            	currency = amountMatch[3];
			if(typeof currency == 'string')
			{
				//trim
                currency = currency.replace(/^\s+|\s+$/g, '');
                if(currency === ''){
                    currency = '""';
                }
			}
			exp = "utils.formatAmount(" + value + ", " + currency + ", " + format + ")";
			exp = originalExp.replace(templateAmountRegex, exp);	
		}

		//match emojis
		var emojiMatch = exp.match(templateEmojiRegex);
		if(emojiMatch){
			exp = "'{{" + exp + "}}'"
		}

        /**
         * String Format match
         * */
        var stringMatch = exp.match(templateStringRegex);
        var maxLength = null;
        if(stringMatch){
        	value = stringMatch[1];
        	var stringMatch2 = stringMatch[2];
            if(typeof stringMatch2 !== 'undefined' && stringMatch2 !== null && stringMatch2.length > 0)
                maxLength = /*"'" +*/ stringMatch[2] /*+ "'"*/;

            exp = "utils.limitString("+ value + "," + maxLength + ")";
            exp = originalExp.replace(templateStringRegex, exp);
        }

		return exp;
	};
	
	Personetics.processor.PExp.prototype.eval = function(ctx, parentCtx, options) {
		var errorObj = null;
		var hasError = false;
		try {

			Personetics.log("PExp: attempting to evaluate expression: '" + this.str + "'");

			var result = this.evalNode(this.exp, ctx, parentCtx, options);
			if(typeof result === 'undefined' || result === null) {
				hasError = true;
                errorObj = this.err(null, "PExp.eval('" + this.str + "') Error - Invalid result after evaluating expression: '" + result + "'", false);
            }
		}
		catch(e){
			hasError = true;
            errorObj = this.err(e, "PExp.eval('" + this.str + "') Error - Could not evaluate expression", false);
    	}

        if(hasError) {
            this.err(errorObj, null, true);
        }
        else {
            var resStr = result;
            try {
                resStr = JSON.stringify(result);
            }
            catch (e){
            resStr = result;
        }
			Personetics.log("Result: " + resStr);
            return result;
        }
	};

	Personetics.processor.PExp.prototype.evalNode = function(node, ctx, parentCtx, options) {
		var me = this;
		var val;
		if(node.type === "BinaryExpression") {
			var leftArg = this.evalNode(node.left, ctx, parentCtx, options);
			var rightArg = this.evalNode(node.right, ctx, parentCtx, options);
			val = this.binops[node.operator](leftArg, rightArg);

		} else if(node.type === "UnaryExpression") {
			val = this.unops[node.operator](this.evalNode(node.argument, ctx, parentCtx, options));

		} else if(node.type === "Identifier") {
			val = Personetics.processor.PUtils.getUtilsInstance(node.name, ctx, parentCtx);
			if (typeof val === "undefined" || val === null)
				val = this.getChild(ctx, node.name, ctx, parentCtx, options);

				// try to get value from parent context
				if(typeof parentCtx !== 'undefined' && parentCtx !== null) {
					if (typeof val === 'undefined' || val === null) {
						val = this.getChild(parentCtx, node.name, ctx, parentCtx, options);
					}
					// removed: this special case breaks other cases, where val is a string
					// else {
					// 	// special case: value in child context is NaN. Check if parent context has a similar value. If
					// 	// it doesn't, return child value
					// 	if (isNaN(val)) {
					// 		var oldVal = val;
                    //
					// 		try {
					// 			val = this.getChild(parentCtx, node.name, options);
					// 			if (typeof val === 'undefined' || val === null)
					// 				val = oldVal;
					// 		}
					// 		catch(e){
					// 			// do nothing
					// 		}
					// 	}
					// }
				}

			} else if(node.type === "Literal") {
				val = node.value;

		} else if(node.type === "ArrayExpression") {
			var arr = [];
			for(key in node.elements){
				var item = node.elements[key];
				var arrVal = me.evalNode(item, ctx, parentCtx, options);
				arr.push(arrVal)
			}
			val = arr;

		} else if(node.type === "MemberExpression") {
			var obj = this.evalNode(node.object, ctx, parentCtx, options);
			if (node.property.type == "Identifier")
				val = this.getChild(obj, node.property.name, ctx, parentCtx, options);
			else {
				var prop = this.evalNode(node.property, obj, parentCtx, options);
				val = this.getChild(obj, prop, options, ctx, parentCtx, options);
			}
			if (typeof(val) == 'function') {
				var bfunc = new PBoundFunction(obj,val);
				val = bfunc;
			}

		} else if(node.type === "CallExpression") {
			var callee = this.evalNode(node.callee, ctx, parentCtx, options);
			var args = [];
			for(var key in node.arguments){
				var arg = node.arguments[key];
				var argVal = me.evalNode(arg, ctx, parentCtx, options);
				args.push(argVal);
			}
			if (!callee || !PBoundFunction.prototype.isPrototypeOf(callee))
				this.err({"message": "TypeError: Cannot find function '" + node.callee.property.name + "' of '" + node.callee.object.name + "'"}, null, true);

			val = callee.call(args);
		}
		return val;
	};

    /**
	 * evaluate an object's member property
     * @param obj the parent object
     * @param prop the property's name
     * @param ctx the current context
     * @param parentCtx the current parent context
     * @param options custom options
     * @returns the property's value
     */
	Personetics.processor.PExp.prototype.getChild = function(obj, prop, ctx, parentCtx, options) {
		if (!obj)
			return obj;

		// try to get the value using the parent object's get() method
		var child;
		if (Personetics.processor.PDataSource.prototype.isPrototypeOf(obj))
			child = obj.get(prop, options);

		// try to get as a JavaScript object's property
		if (typeof child == 'undefined' || child == null)
			child = obj[prop];

		return child;
	};

    Personetics.processor.PExp.prototype.isNode = function(node){
        var isNode = false;
        if(node && node.hasOwnProperty("type")){
            var type = node.type;
            isNode = nodeTypes.indexOf(type) >= 0;
        }
        return isNode;
    };

	Personetics.processor.PExp.prototype.err = function err(e, errorMessage, throwException) {
		throwException = typeof throwException !== 'undefined' && throwException !== null && throwException != false;

        var msg = null;
        var stack = null;
        if(typeof e !== 'undefined' && e !== null) {
            if(typeof e === "object") {
                if (e.hasOwnProperty("message"))
                    msg = e.message;
                if (e.hasOwnProperty("stack"))
                    stack = e.stack;
            }
            else if(typeof e === "string"){
                msg = e;
            }
        }

        errorMessage = errorMessage ? msg ? errorMessage + "\n\t Error message: " + msg : errorMessage : msg ? msg : "";

        var errorObj = {message: errorMessage, stack: stack};

        if(throwException)
            throw errorObj;
        else {
            return errorObj;
        }
	};

	var PExpCtx = function PExpCtx(parent) {
		this.parent = parent
	};

	PExpCtx.prototype.get = function(name) {
	};

	PExpCtx.prototype.getParent = function() {
	};

	var PObjWrapper = function PObjWrapper(obj) {
		this.obj = obj
	};

	PObjWrapper.get = function(name) {
	};

	var PBoundFunction = function PBoundFunction(obj,func) {
		if (!obj)
			throw "No obj provided to bound function";

		this.obj = obj;
		this.func = func;
	};

	PBoundFunction.prototype.call = function(args) {
		return this.func.apply(this.obj,args);
	};

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

	Personetics.processor = Personetics.processor || {};

	Personetics.processor.PExp.prototype.logicOps = {
        "||": function(a,b){ return a || b},
        "&&": function(a,b){ return a && b}
    };

	Personetics.processor.PExp.prototype.evalNode = function(node, ctx, parentCtx, options) {
		var me = this;
		var val;
		if(node.type === "BinaryExpression") {
			var leftArg = this.evalNode(node.left, ctx, parentCtx, options);
			var rightArg = this.evalNode(node.right, ctx, parentCtx, options);
			val = this.binops[node.operator](leftArg, rightArg);
		} else if (node.type === "LogicalExpression"){
			var leftArg = this.evalNode(node.left, ctx, parentCtx, options);
			var rightArg = this.evalNode(node.right, ctx, parentCtx, options);
			val = this.logicOps[node.operator](leftArg, rightArg);
		} else if(node.type === "UnaryExpression") {
			val = this.unops[node.operator](this.evalNode(node.argument, ctx, parentCtx, options));
		} else if(node.type === "Identifier") {
			val = Personetics.processor.PUtils.getUtilsInstance(node.name, ctx, parentCtx);
			if (typeof val === "undefined" || val === null)
				val = this.getChild(ctx, node.name, ctx, parentCtx, options);

				// try to get value from parent context
				if(typeof parentCtx !== 'undefined' && parentCtx !== null) {
					if (typeof val === 'undefined' || val === null) {
						val = this.getChild(parentCtx, node.name, ctx, parentCtx, options);
					}
				}

			} else if(node.type === "Literal") {
				val = node.value;

		} else if(node.type === "ArrayExpression") {
			var arr = [];
			for(key in node.elements){
				var item = node.elements[key];
				var arrVal = me.evalNode(item, ctx, parentCtx, options);
				arr.push(arrVal)
			}
			val = arr;

		} else if(node.type === "MemberExpression") {
			var obj = this.evalNode(node.object, ctx, parentCtx, options);
			if (node.property.type == "Identifier")
				val = this.getChild(obj, node.property.name, ctx, parentCtx, options);
			else {
				var prop = this.evalNode(node.property, obj, parentCtx, options);
				val = this.getChild(obj, prop, options, ctx, parentCtx, options);
			}
			if (typeof(val) == 'function') {
				var bfunc = new PBoundFunction(obj,val);
				val = bfunc;
			}

		} else if(node.type === "CallExpression") {
			var callee = this.evalNode(node.callee, ctx, parentCtx, options);
			var args = [];
			for(var key in node.arguments){
				var arg = node.arguments[key];
				var argVal = me.evalNode(arg, ctx, parentCtx, options);
				args.push(argVal);
			}
			if (!callee || !PBoundFunction.prototype.isPrototypeOf(callee))
				this.err({"message": "TypeError: Cannot find function '" + node.callee.property.name + "' of '" + node.callee.object.name + "'"}, null, true);

			val = callee.call(args);
		}
		return val;
	};

	var PBoundFunction = function PBoundFunction(obj,func) {
		if (!obj)
			throw "No obj provided to bound function";

		this.obj = obj;
		this.func = func;
	};

	PBoundFunction.prototype.call = function(args) {
		return this.func.apply(this.obj,args);
	};

})(window, window.Personetics = window.Personetics || {});

(function (window, Personetics, undefined) {
	var persoDict = function persoDict() {
		this.monthNames = {
			"en-short": ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
				"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			en: ["January", "February", "March", "April", "May", "June",
				"July", "August", "September", "October", "November", "December"],
			he: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני",
				"יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
			"he-short": ["ינו'", "פבר'", "מרץ", "אפר'", "מאי", "יונ'",
				"יול'", "אוג'", "ספט'", "אוק'", "נוב'", "דצמ'"],
			"es-short": ["Ene", "Feb", "Mar", "Abr", "May", "Jun",
				"Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
			"es": ["enero", "febrero", "marzo", "abril", "mayo", "junio",
				"julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
			"fr": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
				"Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
			"fr-short": ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun",
				"Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"],
			"th":["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
				"กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
			"th-short":["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
				"ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
			"de":["Januar", "Februar", "März", "April", "Mai", "Juni",
				"Juli", "August", "September", "Oktober", "November", "Dezember"],
			"de-short":["Jan.", "Feb.", "März", "Apr.", "Mai", "Jun.",
				"Jul.", "Aug.", "Sept.", "Okt.", "Nov.", "Dez."]
		};

		this.weekDays = {
			en: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			es: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
			de: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
			fr:["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
		};
	}

	Personetics.pstoryDictionary = new persoDict();

})(window, window.Personetics = window.Personetics || {});

(function (window, Personetics, undefined) {
    Personetics.pstoryDictionary.monthNames["es"] = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
})(window, window.Personetics = window.Personetics || {});
(function (window, Personetics, undefined) {

	var pUtils = function () {
		this._instance = {};

		this.utilsFactory = {
			"utils": utils,
			"dateUtils": date,
			"amountUtils": amount
		};
	};

	pUtils.prototype.getUtilsInstance = function (instanceName, context, parentContext) {
		if (this.utilsFactory.hasOwnProperty(instanceName)) {
			if (!this._instance.hasOwnProperty(instanceName)) {
				var clazz = this.utilsFactory[instanceName];
				this._instance[instanceName] = new clazz(context, parentContext);
			}
			else {
				var myUtils = this._instance[instanceName];
				if (typeof myUtils.context == 'undefined' || myUtils.context == null)
					myUtils.setContext(context, parentContext);
			}
		}
		return this._instance[instanceName];
	};

	var amount = function (context, parentContext) {
		this.context = context;
		this.parentContext = parentContext;
	};

	amount.prototype.setContext = function (context, parentContext) {
		this.context = context || this.context;
		this.parentContext = parentContext || this.parentContext;
	};

	var date = function (context, parentContext) {
		this.context = context;
		this.parentContext = parentContext;
		this.monthNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
		this.monthNames = Personetics.pstoryDictionary.monthNames;
	};
	date.prototype.getMonthName = function(lang){
		var names = this.monthNames[lang];
        if (!names) {
            names = this.monthNames["en"];
        }

        return names;
	}
    date.prototype.getMonthNumber =function(lang,monthName){
        return this.monthNames[lang].indexOf(monthName.replace(/'/gi, ''));
    }
	date.prototype.setContext = function (context, parentContext) {
		this.context = context || this.context;
		this.parentContext = parentContext || this.parentContext;
	};

	date.prototype.getday = function (dateStr, modifier) {
		return this.getDay(dateStr, modifier);
	};

	date.prototype.getDay = function (dateStr, modifier) {
		var result;
		Personetics.verbose("Calling dateUtils.getDay(" + dateStr + ", " + modifier + ")");
        var parsedDateStr = dateStr.split('.')[0].replace(/T/g, ' ');
        parsedDateStr = parsedDateStr.split('-').join('/');
        dateStr = (isNaN(Date.parse(parsedDateStr))) ? dateStr : parsedDateStr;
        var d = new Date(dateStr);
		var day = d.getDate();
		var parsedModifier = parseInt(modifier);
		if (!isNaN(parsedModifier)) {
			d.setDate(day + parsedModifier);
			result = d.getDate();
		}
		else {
			result = day;
		}

		Personetics.verbose("Result: " + result);

		return result;
	};

	date.prototype.getmonth = function (dateStr, modifier) {
		return this.getMonth(dateStr, modifier);
	};
	date.prototype.getMonth = function (dateStr, modifier) {
		var result;
		Personetics.verbose("Calling dateUtils.getMonth(" + dateStr + ", " + modifier + ")");
        var parsedDateStr = dateStr.split('.')[0].replace(/T/g, ' ');
        parsedDateStr = parsedDateStr.split('-').join('/');
        dateStr = (isNaN(Date.parse(parsedDateStr))) ? dateStr : parsedDateStr;

        var d = new Date(dateStr);
		var month = d.getMonth();
		if (month != undefined && month != null && !isNaN(month)) {
			month = d.getMonth() + 1;
		}
		else {
			try {
				if (typeof dateStr === 'string') {
					if (!isNaN(dateStr)) {
						month = parseInt(dateStr);
					}
				}
				else
					month = dateStr;

			} catch (e) {
				Personetics.verbose("dateUtils.getMonth(): invalid input + '" + dateStr + "'");
				return dateStr;
			}
		}

		if (modifier) {
			var place = month + modifier;
			var monthNumbersLength = this.monthNumbers.length;
			if (place >= monthNumbersLength) {
				place -= monthNumbersLength;
			}
			else if (place <= 0) {
				place = monthNumbersLength + place;
			}
			result = place;
		}
		else {
			result = month;
		}

		Personetics.verbose("Result: " + result);

		return result;
	};

	date.prototype.getdatemonth = function (dateStr, modifier) {
		return this.getDateMonth(dateStr, modifier);
	};
	date.prototype.getDateMonth = function (dateStr, modifier) {
		var result;
		Personetics.verbose("Calling dateUtils.getDateMonth(" + dateStr + ", " + modifier + ")");
        var parsedDateStr = dateStr.split('.')[0].replace(/T/g, ' ');
        parsedDateStr = parsedDateStr.split('-').join('/');
        dateStr = (isNaN(Date.parse(parsedDateStr))) ? dateStr : parsedDateStr;

        var d = new Date(dateStr);
		var month = d.getMonth() + 1;
		var year = d.getFullYear();
		var day = d.getDate();
		if (month == undefined && month == null && isNaN(month)) {
			Personetics.verbose("dateUtils.getDateMonth(): invalid input + '" + dateStr + "'");
			return dateStr;
		}

		if (modifier) {
			var newMonth = month + modifier;
			var monthNumbersLength = this.monthNumbers.length;
			if (newMonth >= monthNumbersLength) {
				newMonth -= monthNumbersLength;
				year = year + 1;
			}
			else if (newMonth <= 0) {
				newMonth = monthNumbersLength + newMonth;
				year = year - 1;
			}
			if (newMonth < 10)
				newMonth = '0' + newMonth;
			if (day < 10)
				day = '0' + day;
			var newDate = year + '-' + newMonth + '-' + day;
			result = newDate;
		}
		else {
			result = dateStr;
		}

		Personetics.verbose("Result: " + result);

		return result;
	};

	var utils = function (context, parentContext) {
		this.context = context;
		this.parentContext = parentContext;
		this.monthNames = Personetics.pstoryDictionary.monthNames;		
		this.weekDays = Personetics.pstoryDictionary.weekDays;
		this.defaultCurrency = "";
		this.tableJoinTypes = {
			INNER: "INNER",
			LEFT: "LEFT"
		}
	};
	utils.prototype.setContext = function (context, parentContext) {
		this.context = context || this.context;
		this.parentContext = parentContext || this.parentContext;
	};

	utils.prototype.monthname = function (dateStr, short, lowerCase) {
		return this.monthName(dateStr, short, lowerCase);
	};

	utils.prototype.monthName = function (dateStr, short, lowerCase) {
		var result;
		Personetics.verbose("Calling utils.monthName(" + dateStr + ", " + short + "," + lowerCase + ")");

		if (!(parseInt(dateStr) == dateStr)) {/**safari bug */
			var d = new Date(dateStr);
			var month = d.getMonth();
			if (month != undefined && month != null && !isNaN(month)) {
				month = d.getMonth();
			}
		}
		else {
			try {
				var dn = parseInt(dateStr);
				if (dn >= 1 && dn <= 12) {
					month = dn - 1;
				}
				else {
					Personetics.log("utils.monthName(): invalid month number + '" + dateStr + "'");
					return dateStr;
				}
			} catch (e) {
				Personetics.log("utils.monthName(): invalid input + '" + dateStr + "'");
				return dateStr;
			}
		}
		var lang = Personetics.processor.PStoryConfig.getConfig("lang");
		if (short == true || short == "MMM")// added temporary for RBC 
			lang = lang + "-short";
		var names = this.monthNames[lang];
		if (!names) {
			Personetics.verbose("utils.monthName(): month names not available + '" + names + "'");
			return dateStr;
		}

		result = names[month];
		if(lowerCase == true){
			result = result.toLowerCase();
		}

		Personetics.verbose("Result: " + result);

		return result;
	};

	utils.prototype.dayname = function (dateStr, short) {
		return this.dayName(dateStr, short);
	};

	utils.prototype.dayName = function (dateStr, short) {
		var result = "";
		if (!(parseInt(dateStr) == dateStr)) {/**safari bug */
			var d = new Date(dateStr);
			var weekday = d.getDay();
			if (weekday == undefined || weekday == null || isNaN(weekday)) {
				Personetics.verbose("utils.dayName(): invalid weekday");
				return result;
			}
		}
		else{
			Personetics.verbose("utils.dayName(): invalid date + '" + dateStr + "'");
		}
		var lang = Personetics.processor.PStoryConfig.getConfig("lang");
		var names = this.weekDays[lang];
		if (!names) {
			Personetics.verbose("utils.dayName(): weekdays names are not available for " + lang);
			return result;
		}
		result = names[weekday];
		return result;
	};

	utils.prototype.formatdate = function (dateStr, format, isAccessibilityFormat) {
		return this.formatDate(dateStr, format, isAccessibilityFormat);
	};

	utils.prototype.formatDate = function formatDate(dateStr, format, isAccessibilityFormat) {
		Personetics.verbose("Calling utils.formatDate(" + dateStr + ", " + format + ")");
		
		dateStr = dateStr.toString();
		if (typeof dateStr === 'undefined' || dateStr === null || dateStr.length <= 0)
			throw { message: "utils.formatDate(" + dateStr + ", " + format + ") Error: invalid dateStr parameter" };
		if (typeof format === "undefined" || format == null)
			format = Personetics.processor.PStoryConfig.getConfig("dateFormat");
		/**safari bug */
        var parsedDateStr = dateStr.split('.')[0].replace(/T/g, ' ');
        parsedDateStr = parsedDateStr.split('-').join('/');
        dateStr = (isNaN(Date.parse(parsedDateStr))) ? dateStr : parsedDateStr;
        var date = new Date(dateStr);

		var result = format;
		var arr = format.split(/[\s\/\\\-\:]/);
		var arr = format.match(/(dd|DD|d|mmmm|mmm|MMMMM|MMMM|MMM|mm|MM|m|M|YYYY|yy|YY|y|weekday)/g);

		var me = this;

		arr.forEach(function (dateFormatItem, index) {
			var dateFormatValue = me.dateFormatToDate(dateFormatItem, date, dateStr);
			if (dateFormatValue) {
				result = result.replace(dateFormatItem, dateFormatValue);
			}
		});
		if (isAccessibilityFormat) {
			result = this.createAccessibleDateText(result, dateStr, format);
		}

		Personetics.verbose("Result: " + result);

		return result;
	};

	utils.prototype.dateFormatToDate = function (formatItem, date, dateStr) {
		var result = null;
		switch (formatItem) {
			case "d":
				var day = date.getDate() + '';
				result = day;
				break;
			case "dd":
				var day = date.getDate() + '';
				var suffix = day.substring(day.length - 1);
				if (suffix == "1")
					result = day + "st";
				else if (suffix == "2")
					result = day + "nd";
				else if (suffix == "3")
					result = day + "rd";
				else if (day == "11" || day == "12" || day == "13")
					result = day + "th";
				else result = day + "th";
				break;
			case "DD":
				var day = date.getDate();
				if (day < 10)
					day = "0" + day;
				result = day;
				break;
			case "mmmm":
				result = this.monthName(dateStr, true, true);
				break;
			case "m":
			case "MMMM":
			case "MMMMM":
				result = this.monthName(dateStr);
				break;
			case "M":
			case "MMM":
				result = this.monthName(dateStr, true);
				break;
			case "mm":
				var monthNum = date.getMonth() + 1;
				result = monthNum;
				break;
			case "MM":
				var monthNum = date.getMonth() + 1;
				result = monthNum;
				if (monthNum < 10)
					result = "0" + result;
				break;
			case "mmm":
				var monthNum = date.getMonth() + 1;
				monthNum = monthNum + '';
				result = this.monthName(monthNum);
				break;
			case "y":
			case "YY":
			case "YYYY":
				result = date.getFullYear();
				break;
			case "yy":
				var fullYear = date.getFullYear().toString();
				result = fullYear.substring(2);
				break;
			case "weekday":
				result = this.dayName(dateStr);
				break;
			default:
				break;
		}

		return result;
	};

	utils.prototype.createAccessibleDateText = function createAccessibleDateText(result, dateStr, format) {
		accFormat = format.replace(/(mmm|MMM|mm|MM|m|M)/g, "m");
		accFormat = accFormat.replace(/DD/g, "dd");
		accFormat = accFormat.split(/[\/\\]/).join(' ');
		if (format === accFormat)
			return result;
		var accText = this.formatdate(dateStr, accFormat);
		var res = "<span class='perso-accessibility-wrapper' role='text'><span class='perso-accessibility-no-read' " +
			"aria-hidden='true'>" + result + "</span><span class='perso-accessibility-read'>" + accText + "</span></span>";
		return res;
	};

	utils.prototype.numberWithCommas = function (x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};

	/**format amount functions */
	var formatDefaultAmount = function formatDefaultAmount(amountStr){
		var formatObj = {
			minus: '',
			accessibilityMinus: '',
			number: '',
			dot: '',
			decimals: '',
			currency: ''
		}
		var value = amountStr.replace(/\,/g, '');
		value = parseFloat(value).toFixed(2);
		if(value < 0){
			value = Math.abs(value);
			value = value.toString();
			formatObj.minus ='-';
			formatObj.accessibilityMinus ='&minus;';
		}
		formatObj.number = parseInt(value);
		if(formatObj.number != value){
			formatObj.decimals = value.slice(-2);
			formatObj.dot = '.';
		}
		return formatObj;
	};

	var wrapAmountWithSpan = function wrapAmountWithSpan(formatObj){
		var objWithSpan ={
			minus: "<span class='perso-minus-sign'>" + formatObj.minus + "</span>",
			number: "<span class='perso-int-num'>" + formatObj.number + "</span>",
			dot: "<span class='perso-decimals-dot'>" + formatObj.dot + "</span>",
			decimals: "<span class='perso-decimals'>" + formatObj.decimals + "</span>",
			currency: "<span class='perso-currency'>" + formatObj.currency + "</span>"
		};
		var amount = formatObj.number + formatObj.dot + formatObj.decimals;
		var amountAccessibilityString = formatObj.accessibilityMinus + formatObj.currency  + amount;
		if(amount && amount.indexOf("0") === 0) {//patch for IE 11 - $0 exception
			amountAccessibilityString = formatObj.accessibilityMinus + formatObj.currency + formatObj.currency  + amount;
		}
		objWithSpan.amountAccessibilityString = "<span class='perso-amount' role='text' aria-label='" + amountAccessibilityString + "'>";
		objWithSpan.endSpan = "</span>";
		return objWithSpan;
	};

	var formatAmountOrderParts= function formatAmountOrderParts(fullformat, formatObj){
		var result;
		var amount = formatObj.number + formatObj.dot + formatObj.decimals;
		if(typeof fullformat == 'undefined' || fullformat == null || fullformat.indexOf("@") == -1){
			if (Personetics.processor.PStoryConfig.isRtl())
				result = formatObj.currency + formatObj.minus + amount;
			else
				result = formatObj.minus + formatObj.currency + amount;
		}
		else{
			fullformat = fullformat.replace(/\-/g, formatObj.minus);
			fullformat = fullformat.replace("@", formatObj.currency);
			fullformat = fullformat.replace(/(#((.)*(#|0))?)/g, amount);
			fullformat = fullformat.replace('+', '');
			result = fullformat;
		}
		if(typeof formatObj.amountAccessibilityString != 'undefined' && formatObj.amountAccessibilityString != null){
			result = formatObj.amountAccessibilityString + result + formatObj.endSpan;
		}
		return result;
	};
	utils.prototype.formatamount = function (amountStr, currency, fullformat) {
		return this.formatAmount(amountStr, currency, fullformat);
	};
	/**
	 * if there is no format or currency by default take it from the config. (for currency also useProjectDefaultCurrency)
	 * if there is no configuration for them the default format is #########.00 and the default currency is ''(empty string)
	 * examples of support formats:
	 * '@-###.###.###,00', '+### ### ###.00', '@#########', '-###,###,###.0'
	 * optional wrap the result with html span
	 * the @ and - signs in the format are optionals and define the
	 * @param {* - amount value for example 123.45} amountStr 
	 * @param {* - optional, the bank currency for example $, USD} currency 
	 * @param {* - optional, for example '###,###,###.00'} fullformat 
	 * @returns {}formmated number for example formatAmount('123456.78', '$', '###,###,###.0') will return 'USD123,456.7'.
	 */
	utils.prototype.formatAmount = function (amountStr, currency, fullformat) {
		Personetics.verbose("Calling utils.formatAmount(" + amountStr + ", " + currency + ", " + fullformat + ")");
		if (typeof amountStr === 'undefined' || amountStr == null)
			return null;
		/**parse amountStr to string*/
		amountStr = amountStr + '';
		if(typeof fullformat === 'undefined' || fullformat === null){
			fullformat =  Personetics.processor.PStoryConfig.getConfig("amountFormat");
		}

		// Amount have 5 parts: dot, currency, minus, number, decimals
		if(typeof currency === 'undefined' || currency === null 
			|| Personetics.processor.PStoryConfig.getConfig("useProjectDefaultCurrency") == true){
			currency = Personetics.processor.PStoryConfig.getConfig("currencySymbol");
		}
		var formatObj = {
			minus: '',//minus is empty for positive value;
			accessibilityMinus: '',
			number: '',
			dot: '',
			decimals: '',
			currency: currency
		}
		if(typeof fullformat == 'undefined' || fullformat == null || fullformat.length == 0){
			formatObj = formatDefaultAmount(amountStr);
		}
		else{
			var format = fullformat.match(/(#((.)*(#|0))?)/g)[0];
			//support use in full format with currency sign but without minus sign
			//we don't support minus sign place without currency sign
			if(fullformat.indexOf("-") == -1 && fullformat.indexOf("@") > -1){
				if (Personetics.processor.PStoryConfig.isRtl())
					fullformat = fullformat.replace("@", "@-");
				else
					fullformat = fullformat.replace("@", "-@");
			}

			/**set the decimals part */
			var matches = format.match(/0/g);
			var formatHelper = format;
			var fixed = matches ? matches.length : 0;
			var value = parseFloat(amountStr).toFixed(fixed);
			if (fixed > 0) {
				formatObj.dot = format[format.length - 1 - fixed];/**take the sign from the format and not always dot */
				fixed = fixed * -1;
				formatObj.decimals = value.slice(fixed);
				value = value.slice(0, fixed-1);/*remove dot and decimals*/
				formatHelper = format.slice(0, (fixed - 1));/*remove the decimals and the dot*/
			}

			/**check if the  format contain '+' we return absolute value */
			if(fullformat.indexOf('+') > -1){
				value = Math.abs(value);
				value = value +'';//parse to string
			}
			if (value.indexOf('-') > -1) {
				value = value.substring(1);
				formatObj.minus = "-";
				formatObj.accessibilityMinus = "&minus;"
			}

			/**add the commas to the value */
			matches = formatHelper.match(/[,/. ]/g);/**space for support space in the format */
			var srcFormat = formatHelper;		
			if (Array.isArray(matches)) {
				matches.reverse();
				matches.forEach(function (item, i) {
					var valueLength =  value.length;
					var formatLength = formatHelper.length;
					var helperIndex = formatHelper.lastIndexOf(item);
					var index = formatLength - helperIndex - 1;
					index = index + (srcFormat.length - formatLength);
					if (index >= valueLength) {
						return false;
					}
					index = index * -1;
					value = [value.slice(0, index), item, value.slice(index)].join('');
					formatHelper = formatHelper.slice(0, helperIndex);
				});
			}
			formatObj.number = value;
		}
		var supportHtmlTagInProcessor = Personetics.processor.PStoryConfig.getConfig("supportHtmlTagInProcessor");
		if (supportHtmlTagInProcessor === "true" || supportHtmlTagInProcessor === true) {
			formatObj = wrapAmountWithSpan(formatObj);
		}
		var resultStr = formatAmountOrderParts(fullformat, formatObj);
		Personetics.verbose("Result: " + resultStr);
		return resultStr;
	};
	/**end format amount functions*/
	utils.prototype.formatAmountInteger = function (amountStr, currency, format) {
		Personetics.verbose("Calling utils.formatAmountInteger(" + amountStr + ", " + currency + ", " + format + ")");

		amountStr = amountStr + '';
		currency = typeof currency === 'undefined' || currency === null ? Personetics.processor.PStoryConfig.getConfig("currencySymbol") : currency;
		if (typeof currency === 'undefined' || currency == null)
			currency = "";

		var value = amountStr.replace(/\,/g, '');
		value = parseInt(value);

		var resultStr;

		var unformattedStr = this.numberWithCommas(value);

		if (value < 0)
			resultStr = "-" + currency + unformattedStr.substring(1);
		//value = "-" + currency + Math.abs(value);
		else
			resultStr = currency + unformattedStr;

		Personetics.verbose("Result: " + resultStr);

		return resultStr;
	};

	utils.prototype.formatpercent = function formatpercent(amountStr) {
		return this.formatPercent(amountStr);
	};

	utils.prototype.formatPercent = function formatPercent(amountStr) {
		Personetics.verbose("Calling utils.formatPercent(" + amountStr + ")");
		var result = parseFloat(amountStr);
		result = result * 100;
		result = Math.round(result);
		result += "%";

		Personetics.verbose("Result: " + amount);

		return result;
	};

	utils.prototype.limitstring = function limitstring (string, maxLength){
		return this.limitString(string, maxLength);
	};
    utils.prototype.limitString = function limitString (string, maxLength){
        Personetics.verbose("Calling utils.limitString(" + string + ","+ maxLength + ")");
        var _numOfChars = maxLength || parseInt(Personetics.processor.PStoryConfig.getConfig("stringMaxLength"));
        var _ellipsisString = '...';
        var result = string;
        if(string.length > _numOfChars)
        	result = string.substring(0, _numOfChars - (_ellipsisString.length)) + _ellipsisString;
        return result;
    };

	utils.prototype.round = function round(amount) {
		Personetics.verbose("Calling utils.round(" + amount + ")");
		var numb = parseFloat(amount);
		numb = Math.round(numb);
		Personetics.verbose("Result: " + numb);
		return numb;
	};

	utils.prototype.abs = function abs(x) {
		Personetics.verbose("Calling utils.abs(" + x + ")");
		var result = null;
		if (typeof x !== 'undefined' && x !== null) {
			if (typeof (x) == "string")
				result = x.replace("-", "");
			else
				result = x;
			result = Math.abs(result);
		}

		Personetics.verbose("Result: " + result);

		return result;
	};

	utils.prototype.highlighttext = function (value) {
		return this.highlightText(value);
	};
	utils.prototype.highlightText = function (value) {
		return '<span class="perso-highlight">' + value + '</span>';
	};

	utils.prototype.join = function join(leftTable, rightTable, conditionExpStr, type) {
		var joinType = type || this.tableJoinTypes.INNER;

		var regexp = /(\w*)\.(\w*)([\=\!]+)(\w*)\.(\w*)/;

		var matches = conditionExpStr.match(regexp);
		if (matches) {
			var leftTableName = matches[1];
			var leftColName = matches[2];
			var middlePart = matches[3];
			var rightTableName = matches[4];
			var rightColName = matches[5];

			var newExp = "_JoinLeftTable.getValue(leftIndex,'" + leftColName + "')" + middlePart + "_JoinRightTable.getValue(rightIndex,'" + rightColName + "')";
			var leftSize = leftTable.size();
			var rightSize = rightTable.size();

			var cols = leftTable.data.cols;
			var colMap = leftTable.colMap;
			var colMapIndex = cols.length;
			if (Array.isArray(rightTable.data.cols)) {

				var ar = rightTable.data.cols;
				ar.forEach(function (col, index) {
					if (cols.indexOf(col) < 0) {
						cols.push(col);
						colMap[col] = colMapIndex;
						colMapIndex++;
					}
				});

			}

			var result = {
				type: "PTable",
				cols: cols,
				rows: []
			};
			var _context, _parentContext;
			var joinTables = {
				_JoinLeftTable: leftTable,
				_JoinRightTable: rightTable
			};
			if (typeof (this.parentContext) !== 'undefined' && this.parentContext != null) {
				_parentContext = this.parentContext;
				_context = this.context;
				_context._JoinLeftTable = leftTable;
				_context._JoinRightTable = rightTable;
			}
			else {
				_parentContext = this.context;
				_context = joinTables;
			}
			for (var leftIndex = 0; leftIndex < leftSize; leftIndex++) {

				var foundValue = false;
				for (var rightIndex = 0; rightIndex < rightSize; rightIndex++) {

					var exp = newExp.replace("leftIndex", leftIndex).replace("rightIndex", rightIndex);

					var conditionExp = new Personetics.processor.PExp(exp);
					try {
						var conditionValue = conditionExp.eval(_context, _parentContext);
					}
					catch (e) {
						throw {
							message: "utils.join() - Error: failed to evaluate join expression. Error message: " +
							e.message, stack: e.stack
						};
					}
					if (conditionValue) {
						foundValue = true;
						var newRow = new Array(cols.length);
						for (var colName in colMap) {
							if (colMap.hasOwnProperty(colName)) {
								var colIndex = colMap[colName];
								var value = leftTable.getValue(leftIndex, colName);
								if (!value)
									value = rightTable.getValue(rightIndex, colName);
								newRow[colIndex] = value;
							}
						}
						result.rows.push(newRow);
					}
				}


				if (!foundValue && joinType == this.tableJoinTypes.LEFT) {
					var newRow = new Array(cols.length);
					for (var colName in colMap) {
						if (colMap.hasOwnProperty(colName)) {
							var colIndex = colMap[colName];
							var value = leftTable.getValue(leftIndex, colName);
							if (!value)
								value = null;
							newRow[colIndex] = value;
						}
					}
					result.rows.push(newRow);
				}
			}

			var ptable = new Personetics.processor.PTable(result);

			return ptable;
		}
		else return leftTable;
	};

	pUtils.prototype.createSchemaFacts = function createSchemaFacts(factObj) {
		var schemaFacts = factObj.factsConfiguration.schemaFacts;
		var _parentContext = new Personetics.processor.PModel(this, factObj);
		var result = {
			newFacts:{

			}
		};
		schemaFacts.forEach(function (schemaFact, index) {
			var fact = schemaFact.fact;
			var cols = [];
			var colsExp = [];
			var attributesTypes = [];
			fact.cols.forEach(function (col, colIndex) {
				cols.push(col.name);
				var exp = new Personetics.processor.PExp(col.expression);
				colsExp.push(exp);
				attributesTypes.push(col.type);
			});
			var factResult = {
				type: fact.type,
				cols: cols,
				rows: [],
				attributesTypes: attributesTypes
			};

			var src = fact.source;
			var srcExp = new Personetics.processor.PExp(src);
			try {
				var sourceTable = srcExp.eval(_parentContext);
			}
			catch (e) {
				throw {
					message: "utils.createSchemaFacts() - Error: failed to evaluate schemaFact source expression. Error message: " +
						e.message, stack: e.stack
				};
			}
			if (sourceTable) {
				var table = sourceTable.getObjArray();
				table.forEach(function (row, rowIndex) {
					var newRow = [];
					colsExp.forEach(function (colExp, colIndex) {
						var objRow = new Personetics.processor.POptionModel(row, _parentContext);;
						try {
							var value = colExp.eval(objRow, _parentContext);
						}
						catch (e) {
							throw {
								message: "utils.createSchemaFacts() - Error: failed to evaluate schemaFact column expression. Error message: " +
									e.message, stack: e.stack
							};
						}
						if(typeof value != 'undefined' && value != null){
							newRow.push(value);
						}
					});
					factResult.rows.push(newRow);
				});
			}
			result.newFacts[fact.name] = factResult;
		});
		return result;
	};

	Personetics.processor = Personetics.processor || {};
	Personetics.processor.PUtils = new pUtils();

})(window, window.Personetics = window.Personetics || {});

(function (window, Personetics, undefined) {

    Personetics.processor.PUtils = Personetics.processor.PUtils || {};

    Personetics.processor.PUtils.utilsFactory.utils.prototype.formatDate = function formatDate(dateStr, format, isAccessibilityFormat, isNotNthDate) {
        Personetics.verbose("Calling utils.formatDate(" + dateStr + ", " + format + ")");
        if (typeof format === "undefined" || format == null) {
            if (isNotNthDate == "undefined" || !isNotNthDate) {
                var lang = Personetics.processor.PStoryConfig.getConfig("lang");
                var m = Personetics.utils.date.monthName(dateStr, lang, true);
                var d = Personetics.utils.date.dayNumber(dateStr.toString(), "DD");
                switch (lang) {
                    case "EN":
                    case "En":
                    case "eN":
                    case "en":
                        var date = Personetics.utils.date.nthDate(m + d, lang);
                        return date.split(' ').reverse().join(' ');
                    case "ES":
                    case "Es":
                    case "eS":
                    case "es":
                         var m = Personetics.utils.date.monthName(dateStr, lang, false);
                        return d + " de " + m;
                }
            }
        }

        dateStr = dateStr.toString();
        if (typeof dateStr === 'undefined' || dateStr === null || dateStr.length <= 0)
            throw { message: "utils.formatDate(" + dateStr + ", " + format + ") Error: invalid dateStr parameter" };
        if (typeof format === "undefined" || format == null)
            format = Personetics.processor.PStoryConfig.getConfig("dateFormat");
        /**safari bug */
        var parsedDateStr = dateStr.split('.')[0].replace(/T/g, ' ');
        parsedDateStr = parsedDateStr.split('-').join('/');
        dateStr = (isNaN(Date.parse(parsedDateStr))) ? dateStr : parsedDateStr;
        var date = new Date(dateStr);

        var result = format;
        var arr = format.split(/[\s\/\\\-\:]/);
        var arr = format.match(/(dd|DD|d|mmmm|mmm|MMMMM|MMMM|MMM|mm|MM|m|M|YYYY|yy|YY|y|weekday)/g);

        var me = this;

        arr.forEach(function (dateFormatItem, index) {
            var dateFormatValue = me.dateFormatToDate(dateFormatItem, date, dateStr);
            if (dateFormatValue) {
                result = result.replace(dateFormatItem, dateFormatValue);
            }
        });
        if (isAccessibilityFormat) {
            result = this.createAccessibleDateText(result, dateStr, format, isNotNthDate);
        }

        Personetics.verbose("Result: " + result);

        return result;
    };

    Personetics.processor.PUtils.utilsFactory.utils.prototype.createAccessibleDateText = function createAccessibleDateText(result, dateStr, format, isNotNthDate) {
        accFormat = format.replace(/(mmm|MMM|mm|MM|m|M)/g, "m");
        accFormat = accFormat.replace(/DD/g, "dd");
        accFormat = accFormat.split(/[\/\\]/).join(' ');
        if (format === accFormat)
            return result;
        var accText = this.formatdate(dateStr, accFormat, format, isNotNthDate);
        var res = "<span class='perso-accessibility-wrapper' role='text'><span class='perso-accessibility-no-read' " +
            "aria-hidden='true'>" + result + "</span><span class='perso-accessibility-read'>" + accText + "</span></span>";
        return res;
    };
    Personetics.processor.PUtils.utilsFactory.utils.prototype.formatdate = function (dateStr, format, isAccessibilityFormat, isNotNthDate) {
        return this.formatDate(dateStr, format, isAccessibilityFormat, isNotNthDate);
    };

})(window, window.Personetics = window.Personetics || {});
(function (window, Personetics, undefined) {

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.PStoryConfig = new function () {
        this.configMap = {
            "dateFormat": "MM/DD/YY",
            "amountFormat": "###,###,###",
            "currencySymbol": "$",
            "useProjectDefaultCurrency": false,
            "lang": "en",
            "supportHtmlTagInProcessor": "false",
            "stringMaxLength": "15",
            "context": "",
            "serverCallBack":""
        };

        this.getConfig = function (configId) {
            if (this.configMap.hasOwnProperty(configId)) {
                return this.configMap[configId];
            }
            return null;
        };

        this.setConfig = function (configId, configValue) {
            if (this.configMap.hasOwnProperty(configId) && configValue != 'undefined' && configValue != null) {
                this.configMap[configId] = configValue;
            }
        };

        this.rtlMap = {
            "en": false,
            "he": true
        };

        this.isRtl = function () {
            var lang = this.configMap["lang"];
            if (this.rtlMap.hasOwnProperty(lang)) {
                return this.rtlMap[lang];
            }
            return false;
        };
    };


})(window, window.Personetics = window.Personetics || {});
(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.PDataSource = function PDataSource(data) {
        this.data = data;
    };

    Personetics.processor.PDataSource.prototype.getType = function() {
        return this.type;
    };

    Personetics.processor.PDataSource.prototype.getData = function() {
        return this.data;
    };

    Personetics.processor.PDataSource.prototype.get = function(name) {
        var obj = this.data[name];
        if (!obj || !obj.type)
            return obj;

    //		if (obj.type == "Personetics.processor.PTable")
    //			return new Personetics.processor.PTable(obj)

        return obj;
    };


    Personetics.processor.PDataSource.prototype.getChild = function(obj, prop) {
        if (Personetics.processor.PDataSource.prototype.isPrototypeOf(obj))
            return obj.get(prop);
        return obj[prop];
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.PFuture = function PFuture(){
        Personetics.processor.PDataSource.call(this, { type: "future", future: true });

        this.type = "future";
        this.future = true;
    };

    Personetics.processor.PFuture.prototype = Object.create(Personetics.processor.PDataSource.prototype);

    Personetics.processor.Future = new Personetics.processor.PFuture();

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.POptionModel = function POptionModel(data, parentDataSource) {
        Personetics.processor.PDataSource.call(this, data);

        this.filteredFields = data.whiteListFields;
        this.parentDataSource = parentDataSource;
    };

    Personetics.processor.POptionModel.prototype = Object.create(Personetics.processor.PDataSource.prototype);

    Personetics.processor.POptionModel.prototype.get = function(name){
        // only properties in the white field are allowed. If no white field is specified, anything goes
        if(!this.filteredFields || this.filteredFields.hasOwnProperty(name)){
            // get the name specified by the filter, if filter exists
            var filterName = this.filteredFields ? this.filteredFields[name] : name;
            var value = Personetics.processor.PDataSource.prototype.get.call(this, filterName);

            //get value from ctx
            if(typeof value == 'undefined' || value == null){
                value = this[name];
            }

            // append parent context value, if exists
            if(typeof value == 'undefined' || value == null)
                value = this.parentDataSource.get(name);

            return value;
        }
        else{
            return "NOPE";
        }
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

	Personetics.processor = Personetics.processor || {};

	var PTableMappingMethods = {
		sum: {
			startValue: 0,
			method: function(group, newValue){
				return group.value + newValue;
			}
		},
		avg: {
			startValue: 0,
			method: function(group, newValue){
				var oldSize = group.size - 1;
				var oldAvg = group.value;
				var oldSum = oldSize * oldAvg;
				return (oldSum + newValue) / group.size;
			}
		},
		count: {
			startValue: 0,
			method: function(group, newValue){
				return group.size;
			}
		},
		standardDeviation: {
			startValue: 0,
			method: function(group, newValue, index, tableSize){
				if(group.size == 1)
					group.mem = {
						items: []
					};

				group.mem.items.push(newValue);

				if(index == tableSize - 1){
					var variance;
					var dev;
					var avg;
					var sum = 0;
					group.mem.items.forEach(group.mem.items, function(item, i){
						sum += item;
					});
					avg = sum / group.mem.items.length;

					group.mem.items.forEach(group.mem.items, function(item, i){
						var x = item - avg;
						dev += Math.pow(x,2)
					});
					variance = dev / group.mem.items.length;
					return Math.sqrt(variance);
				}
				else{
					return null;
				}
			}
		},
		min: {

		},
		max: {

		}
	};
	var PTableTypes ={
		PText: "PText",
		PNumber: "PNumber",
		PAmount: "PAmount"
	}
	Personetics.processor.PTable = function PTable(data) {

		Personetics.processor.PDataSource.call(this, data);

		this.name = data.name;
		this.colMap = {};
		this.data = { cols: [], rows: [] };
        this.attributesTypes = data.attributesTypes;
		this.filter.bind(this);
		this.loadTable(data);
	};

	Personetics.processor.PTable.prototype = Object.create(Personetics.processor.PDataSource.prototype);

    Personetics.processor.PTable.prototype.toString = function toString(){

    	var result = {
    		name: this.name,
            cols: this.data.cols,
			rows: this.data.rows,
            attributesTypes:this.data.attributesTypes,
            type:this.data.type
		};

		return JSON.stringify(result);

	};

	Personetics.processor.PTable.prototype.loadTable = function loadTable(data) {
		if (!data || data.future)
			return;

		this.data = data;
		var colMap = {};
		data.cols.forEach(function(header,i) {
			colMap[header] = i;
		});
		this.colMap = colMap;
	};

	Personetics.processor.PTable.prototype.loadObjArray = function loadObjArray(objArray) {
		if (!objArray)
			return;

		var colMap = {};
		var rows = [];
		var i = 0;

		// Collect cols
		objArray.forEach(function(obj) {
			for(var key in obj){
				if(obj.hasOwnProperty(key)){
					var colIndex = colMap[key];
					if (!colIndex) {
						colIndex = i++;
						colMap[key] = colIndex;
					}
				}
			}
		});
		this.colMap = colMap;

		// Create cols array
		var numCols = colMap.length;
		var cols = new Array(numCols);
		for(var key in colMap){
			if(colMap.hasOwnProperty(key)){
				var index = colMap[key];
				cols[index] = key;
			}
		}

		// Collect rows
		objArray.forEach(function(obj) {
			var row = new Array(numCols);
			for(var key in obj){
				if(obj.hasOwnProperty(key)){
					var value = obj[key];
					var colIndex = colMap[key];
					row[colIndex] = value;
				}
			}
			rows.push(row);
		});

		this.data = { cols: cols, rows: rows };
	};

	Personetics.processor.PTable.prototype.getObjArray = function getObjArray() {
		var arr = [];
		for (var row=0; row < this.getRowCount(); row++) {
			var obj = {};
			for(var col=0; col < this.data.cols.length; col++) {
				obj[this.data.cols[col]] =  getResultByType(this.data,col,row);
			}
			arr.push(obj);
		}
		return arr;
	};

	Personetics.processor.PTable.prototype.getColIndex = function getColIndex(name) {
		return this.colMap[name];
	};

	Personetics.processor.PTable.prototype.size = function size() {
		var result;
		if(!this.data.hasOwnProperty("rows")){
			result = 0;
		}
		else{
			result = this.data.rows.length;
		}
		Personetics.verbose("Calling '" + this.name + "'.size()");
        Personetics.verbose("Result: " + result);
		return result;
	};

	Personetics.processor.PTable.prototype.getrowcount = function getrowcount() {
		return this.getRowCount();
	};
	Personetics.processor.PTable.prototype.getRowCount = function getRowCount() {
		var result = this.data.rows.length;
        Personetics.verbose("Calling '" + this.name + "'.getRowCount()");
        Personetics.verbose("Result: " + result);
		return result;
	};

	Personetics.processor.PTable.prototype.getrow = function getrow(rowIndex) {
		return this.getRow(rowIndex);
	};
	Personetics.processor.PTable.prototype.getRow = function getRow(rowIndex) {
        var result = [];
        for(var i = 0; i < this.data.rows[rowIndex].length; i++) {
            result[i] =  getResultByType(this.data,i,rowIndex);
        }
        Personetics.verbose("Calling '" + this.name + "'.getRow(" + rowIndex + ")");
        Personetics.verbose("Result: " + JSON.stringify(result));
		return result;
	};

    Personetics.processor.PTable.prototype.getfirstrows = function getfirstrows(numOfRows){
        return this.getFirstRows(numOfRows);
    };
    Personetics.processor.PTable.prototype.getFirstRows = function getFirstRows(numOfRows){
        Personetics.verbose("Calling '" + this.name + "'.getFirstRows(" + numOfRows + ")");
        var table = this;
        if(table.getRowCount() > numOfRows){
            var rows = table.data.rows.slice(0, numOfRows);
            var resultTable = new Personetics.processor.PTable(
            	{
					cols:table.data.cols,
					rows: rows,
					name: this.name + ".getFirstRows(" + numOfRows + ")",
                    attributesTypes:table.data.attributesTypes,
                    type:table.data.type
            	});

            Personetics.verbose("Result: " + resultTable.toString());
            return resultTable;
        }
        else {
            Personetics.verbose("Result: " + table.toString());
            return table;
        }
    };

    Personetics.processor.PTable.prototype.getlastrows = function getlastrows(numOfRows){
        return this.getLastRows(numOfRows);
    };
    Personetics.processor.PTable.prototype.getLastRows = function getLastRows(numOfRows){
        Personetics.verbose("Calling '" + this.name + "'.getLastRows(" + numOfRows + ")");
        var table = this;
        if(table.getRowCount() > numOfRows){
            var rows = table.data.rows.slice(0 - numOfRows);
            var resultTable = new Personetics.processor.PTable({
            	cols:table.data.cols,
				rows: rows,
				name: this.name + ".getLastRows(" + numOfRows + ")",
                attributesTypes:this.data.attributesTypes,
                type:this.data.type
            });
            Personetics.verbose("Result: " + resultTable.toString());
            return resultTable;
        }
        else {
            Personetics.verbose("Result: " + table.toString());
            return table;
        }
    };

    Personetics.processor.PTable.prototype.getrowasobject = function getrowasobject(rowIndex) {
        return this.getRowAsObject(rowIndex);
    };
	Personetics.processor.PTable.prototype.getRowAsObject = function getRowAsObject(rowIndex) {
        Personetics.verbose("Calling '" + this.name + "'.getRowAsObject(" + rowIndex + ")");
		if(rowIndex < this.data.rows.length ) {
            var row = this.data.rows[rowIndex];
            var result = {};
            for (var colName in this.colMap) {
                if (this.colMap.hasOwnProperty(colName)) {
                    var index = this.colMap[colName];
                    result[colName] = row[index];
                }
            }
            Personetics.verbose("Result: " + JSON.stringify(result));
            return result;
        }
        else {
            Personetics.verbose("Result: ''");
            return '';
        }
	};

	Personetics.processor.PTable.prototype.getcolumn = function getcolumn(columnName){
		return this.getColumn(columnName);
	};
	Personetics.processor.PTable.prototype.getColumn = function getColumn(columnName){
		Personetics.verbose("Calling '" + this.name + "'.getColumn(" + columnName + ")");
		var rows = this.data.rows;
		var cols = [];
		var indexCol = this.colMap[columnName];
        if(typeof indexCol != 'undefined'){
            rows.forEach(function(row, index){
				cols.push(row[indexCol]);
			});
			Personetics.verbose("Result: " + JSON.stringify(cols));
			return cols;
        }
        else {
            Personetics.verbose("Result: null");
			return null;
        }
	};

	Personetics.processor.PTable.prototype.getvalue = function getvalue(rowIndex,colName) {
		return this.getValue(rowIndex,colName);
	};
	Personetics.processor.PTable.prototype.getValue = function getValue(rowIndex,colName) {
        Personetics.verbose("Calling '" + this.name + "'.getValue(" + rowIndex + ", " + colName + ")");
		var size = this.size();
		if(this.colMap.hasOwnProperty(colName) && size > rowIndex) {
            var colIndex = this.colMap[colName];
            var result = getResultByType(this.data,this.colMap[colName],rowIndex);
            Personetics.verbose("Result: " + result);
            return result;
        }
		else{
            Personetics.verbose("Result: null");
			return null;
		}
	};

	var getResultByType = function getResultByType(data,colIndex,rowIndex)
	{
        var type = data.hasOwnProperty("attributesTypes") && (typeof data.attributesTypes !== 'undefined') && (data.attributesTypes !== null) ? data.attributesTypes[colIndex] : "";
        switch (type) {
            case PTableTypes.PText:
                return getTextByLanguage(data.rows[rowIndex][colIndex]);
			case PTableTypes.PAmount:
			case PTableTypes.PNumber:
				return getNumberValue(data.rows[rowIndex][colIndex]);
            default:
                return data.rows[rowIndex][colIndex];
        }
	};

	var getTextByLanguage = function getTextByLanguage(row)
	{
        if(row === null) return row;
        if(row.hasOwnProperty(Personetics.processor.PStoryConfig.getConfig("lang"))){
            return row[Personetics.processor.PStoryConfig.getConfig("lang")];
        }
        else {
            if(typeof row !== "object")
            {
                return row;
            }
            var firstKey = (function getFirstKey(pTextObj) {
                for (var key in pTextObj) return key;
            })(row);

            if (firstKey) {
                return row[firstKey];
            }
        }
	};

	var getNumberValue = function getNumberValue(value){
		var result = parseFloat(value);
		if(isNaN(result) || !isFinite(result)){
			result = value
		}
		return result;
	};

	Personetics.processor.PTable.prototype.filter = function filter(colName, validValue) {
        Personetics.verbose("Calling '" + this.name + "'.filter(" + colName + ", " + validValue + ")");
        // edge cases: "all" or "undefined" - for "all", return all rows
		// for "undefined" - the requirement specifies that it is better to return irrelevant results rather than no results
		if (!validValue || validValue == "all") {
            Personetics.verbose("No validValue or no filter. Result: " + this.toString());
            return this;
        }

		var rows = [];
		var i;
		for (i = 0 ;i < this.getRowCount(); i++) {
			var val = this.getValue(i,colName);
			if (val == validValue)
				rows.push(this.getRow(i));
		}

		var table = new Personetics.processor.PTable({
			cols:this.data.cols,
			rows: rows,
			name: this.name + ".filter(" + colName + ", " + validValue + ")",
            attributesTypes:this.data.attributesTypes,
            type:this.data.type
		});

        Personetics.verbose("Result: " + table.toString());

		return table;
	};

	Personetics.processor.PTable.prototype.filterbynumber = function filterbynumber(colName, validValue){
		return this.filterByNumber(colName, validValue);
	};
	Personetics.processor.PTable.prototype.filterByNumber = function filterByNumber(colName, validValue){
		if(arguments.length > 2){
			var operator, amount;
			var exp = arguments[2];
			operator = exp;
			if(arguments.length > 3){
				var exp2 = arguments[3];
				amount = exp2
			}
		}
		else{
			return this.filter(colName, validValue);
		}
	};

	var getBackdate = function getBackDate(currentDate, numOfDaysBack) {
		var backdate = new Date(currentDate);
		var _numOfDaysBack = (numOfDaysBack) ? numOfDaysBack : 0;
		backdate = new Date(backdate.setDate(backdate.getDate() + _numOfDaysBack));
		//Set hours to 00:00:00
		var backdateObj =  new Date(backdate.setHours(0,0,0,0));
		return backdateObj;
	};

	Personetics.processor.PTable.prototype.filterByDays = function filterByDays(colName, currentDate, fromDate, toDate) {
        currentDate = getJsFormattedDate(currentDate);
        Personetics.verbose("Calling '" + this.name + "'.filterByDays(" + colName + ", " + currentDate + ", " + fromDate + ", " + toDate + ")");
		var _toDate = (typeof toDate !== 'undefined' && toDate !== null ) ? getBackdate(currentDate, toDate) : getBackdate(currentDate, 0);
		var _fromDate = getBackdate(currentDate, fromDate);
		var rows = [];
		for (var i = 0; i < this.getRowCount(); i++) {
			var val = this.getValue(i, colName);
			var dateVal = new Date(getJsFormattedDate(val));
			// to compare date without hours
			dateVal.setHours(0,0,0,0);
			if (typeof dateVal === 'object' && dateVal <= _toDate && dateVal >= _fromDate) {
				rows.push(this.getRow(i));
			}
		}

		var table = new Personetics.processor.PTable({
			cols: this.data.cols,
			rows: rows,
            name: this.name + ".filterByDays(" + colName + ", " + currentDate + ", " + fromDate + ", " + toDate + ")",
            attributesTypes:this.data.attributesTypes,
            type:this.data.type
		});
        Personetics.verbose("Result: " + table.toString());
		return table;
	};

	Personetics.processor.PTable.prototype.groupby = function groupby(keyFieldNames, valueFieldName, mappingMethod) {
		return this.groupBy(keyFieldNames, valueFieldName, mappingMethod);
	};

	Personetics.processor.PTable.prototype.groupBy = function groupBy(keyFieldNames, valueFieldName, mappingMethod) {
        Personetics.verbose("Calling '" + this.name + "'.groupBy(" + keyFieldNames + ", " + valueFieldName + ", " + mappingMethod + ")");

		var mapping;
		if(mappingMethod && PTableMappingMethods.hasOwnProperty(mappingMethod)){
			mapping = PTableMappingMethods[mappingMethod];
		}
		else{
			mapping = PTableMappingMethods.sum;
		}

		if (!Array.isArray(keyFieldNames))
			keyFieldNames = [keyFieldNames];

		var table = this;
		var cols = [];
		cols = cols.concat(keyFieldNames);
		cols.push(valueFieldName);

		var groupMap = {};
		var tableSize = table.getRowCount();
		for (var i=0;i<tableSize;i++) {
			var key = "";
			var keyValues = [];
			var keyFieldValues = [];

			// get values of all keys fields for this row
			for(var keyField in keyFieldNames){
				if(keyFieldNames.hasOwnProperty(keyField)){
					keyField = keyFieldNames[keyField];
					var keyFieldValue = table.getValue(i,keyField);
					keyFieldValues.push(keyFieldValue);
					key += JSON.stringify(keyFieldValue) + ",";
				}
			}

			// create group if not exist
			var group = groupMap[key];
			if (!group) {
				group = {
					key: key,
					keyValues: keyFieldValues,
					value: mapping.startValue,
					size: 0
				};
				groupMap[key] = group;
			}

			group.size++;

			// add value of value field to group value
			var value = table.getValue(i,valueFieldName);
			value = Number(value);
			group.value = mapping.method(group, value, i, tableSize);
		}

		var rows = [];
		for(group in groupMap){
			if(groupMap.hasOwnProperty(group)){
				var row = [];
				var groupValue = groupMap[group];
				for(j = 0; j < keyFieldNames.length; j++) {
					row.push(groupValue.keyValues[j]);
				}
				row.push(groupValue.value);
				rows.push(row);
			}
		}

		var resultTable = new Personetics.processor.PTable({
			cols: cols,
			rows: rows,
            name: this.name + ".groupBy(" + keyFieldNames + ", " + valueFieldName + ", " + mappingMethod + ")",
            attributesTypes:this.data.attributesTypes,
            type:this.data.type
		});

        Personetics.verbose("Result: " + resultTable.toString());

		return resultTable;
	};

	Personetics.processor.PTable.prototype.groupByExpression = function groupByExpression(expression){
        Personetics.verbose("Calling '" + this.name + "'.groupByExpression(" + expression + ")");
		var exp = new Personetics.processor.PExp(expression);

		var objArray = this.getObjArray();
		var rows = this.data.rows;
		var cols = this.data.cols;

		var groups = {};

		var me = this;
		if(Array.isArray(rows)){
			rows.forEach(function(row, index){
				var context = objArray[index];
				//TODO: pass parent context as well
				try {
                    var key = exp.eval(context);

                    if (!groups.hasOwnProperty(key)) {
                        groups[key] = [];
                    }
                    groups[key].push(row);
                }
                catch(e){
					Personetics.error(me.name + "'.groupByExpression(" + expression + ") Error: Failed to evaluate row " + index + ", ignoring row");
				}
			});
		}

		var tables = [];

		for(var key in groups){
			if(groups.hasOwnProperty(key)){
				var group = groups[key];
				var table = new Personetics.processor.PTable({
					cols: cols,
					rows: group,
                    name: this.name + ".groupByExpression(" + expression + ")",
                    attributesTypes:this.data.attributesTypes,
                    type:this.data.type
				});
				var resultTable = {
					table: table,
					groupedKey: key
				};
				tables.push(resultTable);
			}
		}

		//TODO: only do this code if debugging mode is on
		var res = "[";
		var sep = "";
		for(var k = 0; k < tables; k++){
			sep = ",";
			res += sep + tables[k].toString();
		}
		res += "]";
        Personetics.verbose("Result: " + res);
		return tables;
	};

	Personetics.processor.PTable.prototype.sortbydate = function sortbydate(colNames, direction){
		return this.sortByDate(colNames, direction);
	};
	Personetics.processor.PTable.prototype.sortByDate = function sortByDate(colNames, direction){
        Personetics.verbose("Calling '" + this.name + "'.sortByDate(" + colNames + ", " + direction + ")");
		var asc = 1;
		if(direction){
			if(direction.toLowerCase() == "asc"){
				asc = 1;
			}
			else if(direction.toLowerCase() == "desc"){
				asc = -1;
			}
		}

		var table = this;
		if (!Array.isArray(colNames))
			colNames = [colNames];
		var cols = [];
		colNames.forEach(function(name) {
			var col = table.colMap[name];
			cols.push(col);
		});

		var newRows = this.data.rows.slice(0);
		var length = newRows.length;
		var range;
		newRows.sort(function (a, b) {
			for (var i=0;i<cols.length;i++) {
				var col = cols[i];
				var valA = new Date(getJsFormattedDate(a[col])).getTime();
				var valB = new Date(getJsFormattedDate(b[col])).getTime();
				var val = valA - valB;
				if(val != 0){
					return asc * val;
				}
			}
			return 0;
		});

		var resultTable = new Personetics.processor.PTable(
			{
				cols: table.data.cols,
				rows: newRows,
				attributesTypes:table.data.attributesTypes,
                type:table.data.type
			});

        Personetics.verbose("Result: " + resultTable.toString());

		return resultTable;
    };
	Personetics.processor.PTable.prototype.sortbymonth = function sortbymonth(colNames, direction){
		return this.sortByMonth(colNames, direction);
	};
	Personetics.processor.PTable.prototype.sortByMonth = function sortByMonth(colNames, direction){
        Personetics.verbose("Calling '" + this.name + "'.sortByMonth(" + colNames + ", " + direction + ")");
	    var table = this;
		if (!Array.isArray(colNames))
			colNames = [colNames];
		var cols = [];
		colNames.forEach(function(name) {
			var col = table.colMap[name];
			cols.push(col);
		});
		var newRows = this.data.rows.slice(0);
		var range;
        newRows.sort(function (a, b) {
            for (var i=0;i<cols.length;i++) {
                var col = cols[i];
                var valA = parseInt(a[col]);
                var valB = parseInt(b[col]);
                return valA - valB;
            }
            return 0;
        });
        var range;
        var index = 0;
        for(var i = 1; i < newRows.length; i++) {
			range = Math.abs(newRows[i][0] - newRows[i - 1][0]);
			if(range > 1){
				index = i;
				break;
			}
            
		}
		var finalRows ;
		if(index > 0){
            finalRows = newRows.slice(index);
            finalRows = finalRows.concat(newRows.slice(0,index));
		}else{
			finalRows = newRows
		}
        if(direction && direction.toLowerCase() == "desc"){
            finalRows.reverse();
        }
		var resultTable = new Personetics.processor.PTable({
			cols: table.data.cols,
			rows: finalRows,
            name: this.name + ".sortByMonth(" + colNames + ", " + direction + ")",
            attributesTypes:table.data.attributesTypes,
            type:table.data.type
		});

		Personetics.verbose("Result: " + resultTable.toString());

		return resultTable;
	};

	Personetics.processor.PTable.prototype.sortby = function sortby(colNames, direction, type) {
		return this.sortBy(colNames, direction, type);
	};
	Personetics.processor.PTable.prototype.sortBy = function sortBy(colNames, direction, type) {
        Personetics.verbose("Calling '" + this.name + "'.sortBy(" + colNames + ", " + direction+ ", " + type + ")");
		var asc = 1;
		if(direction){
			if(direction.toLowerCase() == "asc"){
				asc = 1;
			}
			else if(direction.toLowerCase() == "desc"){
				asc = -1;
			}
		}

		var table = this;
		if (!Array.isArray(colNames))
			colNames = [colNames];
		var cols = [];
		colNames.forEach(function(name) {
			var col = table.colMap[name];
			cols.push(col);
		});

		var newRows = this.data.rows.slice(0);
		var length = newRows.length;
		var range;
		newRows.sort(function (a, b) {
			for (var i=0;i<cols.length;i++) {
				var col = cols[i];
				var valA = a[col];
				var valB = b[col];
				if (valA > valB) return asc;
				if (valA < valB) return -asc;
			}
			return 0;
		});

		var resultTable = new Personetics.processor.PTable(
			{
				cols: table.data.cols,
				rows: newRows,
                attributesTypes:table.data.attributesTypes,
                type:table.data.type
			});

		Personetics.verbose("Result: " + resultTable.toString());

		return resultTable;
	};
	Personetics.processor.PTable.prototype.getasgroupedTable = function getasgroupedTable(valueFunc) {
		return this.getAsGroupedTable(valueFunc);
	};
	Personetics.processor.PTable.prototype.getAsGroupedTable = function getAsGroupedTable(valueFunc) {
        Personetics.verbose("Calling '" + this.name + "'.getAsGroupedTable(" + valueFunc + ")");
		var groups = [];
		var curGroup;
		var valToIndices = {};
		var lastVal;
		if(Array.isArray(this.data.rows)){
			this.data.rows.forEach(function(row, i){
				var val = valueFunc(row).trim();
				var valIndex = valToIndices[val];
				if (typeof valIndex === 'undefined' || valIndex === null) {
					curGroup = {
						encValue: Personetics.utils.string.stripSpecialChars(val),
						value: val,
						rows: []
					};
					groups.push(curGroup);
					var index = groups.length - 1;
					valToIndices[val] = index;
				}
				else{
					curGroup = groups[valIndex];
				}
				var newRow = jQuery.extend({}, row);
				curGroup.rows.push(newRow);
			});
		}

		Personetics.verbose("Result: " + groups);

		return groups;
	};

	Personetics.processor.PTable.prototype.max = function max(colName) {
        Personetics.verbose("Calling '" + this.name + "'.max(" + colName + ")");
        var result = this.extremum(colName,function(extremeVal,val) { return extremeVal < val }, "max");
        Personetics.verbose("Result: " + result);
		return result;
	};

	Personetics.processor.PTable.prototype.min = function min(colName) {
        Personetics.verbose("Calling '" + this.name + "'.min(" + colName + ")");
		var result = this.extremum(colName,function(extremeVal,val) { return extremeVal > val }, "min");
        Personetics.verbose("Result: " + result);
        return result;
	};

	Personetics.processor.PTable.prototype.extremum = function extremum(colName,isNewExtremeFunc, callingMethodName) {
		if (this.getRowCount() == 0)
			return this;

		var colIndex = this.getColIndex(colName);
		var extremRow = this.data.rows[0];
		var extremVal = extremRow[colIndex];
		for (var i=0;i<this.getRowCount();i++) {
			var row = this.data.rows[i];
			var val = row[colIndex];
			var floatExtremVal = typeof(extremVal)=='string'? parseFloat(extremVal) :extremVal;
			var floatVal = typeof(val)=='string'? parseFloat(val) :val;
			if (isNewExtremeFunc(floatExtremVal,floatVal)) {
				extremVal = val;
				extremRow = row;
			}
		}

		// BUG: when changing i to j (duplicate var), model variable is not found?!
		// var extremRowObj = {};
		// for (var i=0;i<this.data.cols.length;i++)
		// 	extremRowObj[this.data.cols[i]] = extremRow[i];
		//
		// return extremRowObj;

		var resultTable = new Personetics.processor.PTable({
			cols: this.data.cols,
			rows: [extremRow],
            name: this.name + "." + callingMethodName + "(" + colName + ", " + isNewExtremeFunc + ")",
            attributesTypes:this.data.attributesTypes,
            type:this.data.type
		});
		return resultTable;
	};

	Personetics.processor.PTable.prototype.addComputedCol = function addComputedCol(colName,expStr) {
		var exp = new Personetics.processor.PExp(expStr);
		var newCols = this.data.cols.slice(0);
		newCols.push(colName);
		var newRows = [];
		var me = this;
		for (var i=0;i<this.getRowCount();i++) {
			var row = this.data.rows[i];
			//TODO: pass parent context as well
			try {
                var val = exp.eval(row);
                var newRow = row.slice(0);
                newRow.push(val);
                newRows.push(newRow);
            }
            catch(e){
                Personetics.error(me.name + "'.addComputedCol(" + colName + ", " + expStr + ") Error: Failed to " +
					"valuate row " + i + ", ignoring row");
            }
		}

		var resultTable = new Personetics.processor.PTable({
			cols: newCols,
			rows: newRows,
            name: this.name + ".addComputedCol(" + colName + ", " + expStr + ")",
            attributesTypes:this.data.attributesTypes,
            type:this.data.type
		});

		return resultTable;
	};

	Personetics.processor.PTable.prototype.map = function map(colName, mappingMethod, optStartVal){
		if (this.getRowCount() == 0)
			return optStartVal != undefined ? optStartVal : {};

		var colIndex = this.getColIndex(colName);
		var returnValue = optStartVal || 0;
		for(var i = 0; i < this.getRowCount(); i++){
			returnValue = mappingMethod(returnValue, this.getValue(i, colName));
		}

		return returnValue;
	};

	Personetics.processor.PTable.prototype.sum = function (colName) {
        Personetics.verbose("Calling '" + this.name + "'.sum(" + colName + ")");
		var result = this.map(colName, function(oldValue, newValue){

			var oldValueNum = oldValue;
			if(typeof oldValue === 'string')
				oldValueNum = parseFloat(oldValue);

			var newValueNum = newValue;
			if(typeof newValue === 'string')
				newValueNum = parseFloat(newValue);

			return oldValueNum + newValueNum;
		}, 0);

		Personetics.verbose("Result: " + result);

		return result;
	};

	Personetics.processor.PTable.prototype.avg = function (colName) {
        Personetics.verbose("Calling '" + this.name + "'.avg(" + colName + ")");
        var result = 0;
		if(this.getRowCount() > 0) {
            var sum = this.sum(colName);
            result = sum / this.getRowCount();
        }

        Personetics.verbose("Result: " + result);

        return result;
	};

	Personetics.processor.PTable.prototype.first = function first(colName){
        Personetics.verbose("Calling '" + this.name + "'.first(" + colName + ")");
        var result;
		var count = this.getRowCount();
		if(count > 0) {
			if(colName)
                result = this.getValue(0, colName);
			else {
				var rows = [];
				rows.push(this.getRow(0));
				var table = new Personetics.processor.PTable({
					cols: this.data.cols,
					rows: rows,
                    name: this.name + ".first(" + colName + ")",
                    attributesTypes:this.data.attributesTypes,
                    type:this.data.type
				});
                result = table.getObjArray()[0];
			}
		}
		else
            result = this;

		Personetics.verbose("Result: " + result);

		return result;
	};

	Personetics.processor.PTable.prototype.last = function(colName){
        Personetics.verbose("Calling '" + this.name + "'.last(" + colName + ")");
        var result;
		var count = this.getRowCount();
		if(count > 0) {
			if(colName)
                result = this.getValue(count - 1, colName);
			else
			{
				var rows = [];
				rows.push(this.getRow(count - 1));
				var table = new Personetics.processor.PTable({
					cols: this.data.cols,
					rows: rows,
                    name: this.name + ".last(" + colName + ")",
                    attributesTypes:this.data.attributesTypes,
                    type:this.data.type
				});
                result = table.getObjArray()[0];
			}
		}
		else{
			if(colName){
				if(colName == "month" || colName == "amount")
					return 0;
				else
                    result = null;
			}
			else{
                result = null;
			}
		}

		Personetics.verbose("Result: " + result);

		return result;
	};

	Personetics.processor.PTable.prototype.abs = function (colName){
        Personetics.verbose("Calling '" + this.name + "'.last(" + colName + ")");
        var i;
        var absRows = [];
        var colIndex = this.colMap[colName];
        for (i = 0; i < this.getRowCount(); i++) {
            var currentRow = this.getRow(i);
            var absRow = [];
            for(var j = 0; j < currentRow.length; j++){
                var value = currentRow[j];
                if(j == colIndex)
                    value = Math.abs(value);
                absRow.push(value);
            }
            absRows.push(absRow);
        }

        var result = new Personetics.processor.PTable({
            cols: this.data.cols,
            rows: absRows,
            name: this.name + ".abs(" + colName + ")",
            attributesTypes:this.data.attributesTypes,
            type:this.data.type
        });

        return result;
    };

	/**
	 * getJsFormattedDate(dateStr) -> convert JAVA format date to supported JS format
	 * */
	var getJsFormattedDate = function getJsFormattedDate(dateStr) {
        var parsedDateStr = dateStr.split('.')[0].replace(/T/g, ' ');
        parsedDateStr = parsedDateStr.split('-').join('/');
        var formattedDate = (isNaN(Date.parse(parsedDateStr))) ? dateStr : parsedDateStr;
        return formattedDate;
    }

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    var PrimitiveFactTypes = ["PNumber", "PAmount", "PDate", "PString"];
    Personetics.processor.PFact = function PFact(data, dataType, formats) {
        Personetics.processor.PTable.call(this, data);
        this.dataType = dataType;
        this.formats = formats;
        this.name = data.name;

        this.isPrimitive = PrimitiveFactTypes.indexOf(dataType) >= 0;
    };

    Personetics.processor.PFact.prototype = Object.create(Personetics.processor.PTable.prototype);

    Personetics.processor.PFact.prototype.get = function(key){
        var colName = key;
        if(this.isPrimitive)
            colName = "value";

        var value = this.getValue(0, colName);

        return value;
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){
    
    Personetics.processor = Personetics.processor || {};

    Personetics.processor.PQuery = function PQuery(cfg, model){
        this.queryName = cfg.queryName;
        this.model = model;
        this.preQueryParams = cfg.queryParams;
        this.queryParams = {};
        this.data = null;

        this.evalParams();
    };

    Personetics.processor.PQuery.prototype.evalParams = function() {
        var me = this;

        this.preQueryParams.forEach(function(paramObject, index) {
            var paramName = paramObject.paramName;
            var varName = paramObject.varName;
            var exp = new Personetics.processor.PExp(varName);
            var val = exp.eval(me.model);
            if(val) {
                me.queryParams[paramName] = val;
            }
        });
    };

    Personetics.processor.PQuery.prototype.getCacheKey = function() {
        var cacheKey = this.queryName + "?";
        for(var key in this.queryParams) {
            if(this.queryParams.hasOwnProperty(key)) {
                cacheKey += key + "=" + this.queryParams[val] + "&";
            }
        }
        return cacheKey;
    };

    Personetics.processor.PQuery.prototype.getData = function(block) {
        if (this.data)
            return this.data;

        if (!personetics.pserverProxy)
            return null;

        var query = this;
        personetics.getQueryData({
                id: block.story.insight.id,
                queryName: this.queryName,
                queryParams: this.queryParams
            },
            Personetics.bind(this, this.handleQuery)
        );

        return Personetics.processor.Future;
    };

    Personetics.processor.PQuery.prototype.handleQuery = function(data){
        this.model.handleQuery(this, data);
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

	Personetics.processor = Personetics.processor || {};


	Personetics.processor.PModel = function PModel(parent, options) {
		Personetics.processor.PDataSource.call(this, options.facts);
		this.initPModel(options.facts, options.expressions, options.externalParams);
		this.parent = parent;
	};

	Personetics.processor.PModel.prototype = Object.create(Personetics.processor.PDataSource.prototype);

	Personetics.processor.PModel.prototype.initPModel = function initPModel(facts, expressions, externalParams){
		this.factsConfigs = {};
		this.facts = facts;

		this.expressionsConfigs = {};
		this.expressions = expressions;

		this.varCfgs = {};
		this.varValues = {};
		this.externalParams = externalParams || {};

		/*varValues stay also after pevius dialog click*/
		this.varValuesForSave = {};

		this.queryCfgs = {};
		this.queryCache = {};

		this.exps = {};
		this.cache = {};
		this.staticCache = {};

		this.setupObjFactory();

		mapObjects(this.facts, this.factsConfigs);
		mapObjects(this.expressions, this.expressionsConfigs);

		this.listeners = [];
	};


	Personetics.processor.PModel.prototype.setFormats = function(formats){
		this.formats = formats;
	};

	Personetics.processor.PModel.prototype.setupObjFactory = function() {
		var model = this;

		this.objFactory = {};
		this.objFactory['PTable'] = function(data) {
			return new Personetics.processor.PTable(data);
		};
		this.objFactory['PObjList'] = function(data) {
			var table = new Personetics.processor.PTable();
			table.loadObjArray(data);
			return table;
		};

		this.objFactory['PFact'] = function(data, type){
			return new Personetics.processor.PFact(data, type, model.formats);
		};
	};

	Personetics.processor.PModel.prototype.createObj = function(type, data) {
		var obj = data;
		var modelType = type;
		if(type != "PTable" && type != "PObjList")
			modelType = "PFact";
		var creator = this.objFactory[modelType];
		if (creator)
			obj = creator(data, type);
		if(obj.isPrimitive)
			obj = obj.get();
		return obj;
	};

	Personetics.processor.PModel.prototype.test = function(id){
		var val = this.get(id, {test: true});
		return {
			success: val ? true : false,
			value: val
		};
	};

	Personetics.processor.PModel.prototype.get = function(id, options) {

		var errorMessage = "";
		var hasError = false;

		// try to get from cache
		var val = this.cache[id] || this.staticCache[id];
		if (typeof val !== 'undefined' && val !== null)
			return val;

		// try to evaluate using var
		var varCfg = this.varCfgs[id];
		if (!val && varCfg) {
			val = this.getVarValue(id);
		}

		// try to evaluate widget var
		var externalParams = this.externalParams[id];
		if (!val && externalParams) {
			val = externalParams;
		}

		// try to evaluate from story data - facts
		var dataCfg = this.factsConfigs[id];
		if (!val && dataCfg) {
			val = dataCfg;
			if (typeof val === 'undefined' || val === null) {
                Personetics.log("PStoryModel.get('" + id + "') - Error: fact exists but is invalid: '" + val + "'. " +
					"Trying to evaluate as expression");
            }
            else {
                if (dataCfg.type) {
                    val.name = id;
                    val = this.createObj(dataCfg.type, val);
                }
            }
		}

		// try to get from expressions
		var expDataCfg = this.expressionsConfigs[id];
		if (!val && expDataCfg) {
			var exp = new Personetics.processor.PExp(expDataCfg);
			try {
				val = exp.eval(this);
			}
			catch(e){
				Personetics.log("PStoryModel.get('" + id + "') Error - Invalid expression string: '" + expDataCfg + "'");
				val = null;
			}
			if (typeof val === 'undefined' || val === null) {
				Personetics.log("PStoryModel.get('" + id + "') - Error: expression exists but is invalid: '" + val + "'. " +
					"Trying to evaluate as expression");
			}
		}

		// this is problematic and can cause infinite loops
		if(typeof val === 'undefined' || val === null){
			if(this.lastGetValue && this.lastGetValue == id) {

				// break endless loop of PModel calling PExp calling model on a variable which can't be found in facts
				// or evaluated as expression
				// not logging because this code should return to the PModel.get method a few lines below
				this.lastGetValue = null;
				return null;
			}
			this.lastGetValue = id;
			var exp = new Personetics.processor.PExp(id);
			try {
                val = exp.eval(this, null, options);
                if(typeof val === 'undefined' || val === null) {
                    hasError = true;
                    errorMessage = "PStoryModel.get('" + id + "') - Error: Evaluating as expression returned an invalid result: '" + val + "'";
                }

            }
            catch(e){
				val = null;
                hasError = true;
				errorMessage = "PStoryModel.get('" + id + "') Error: Failed to evaluate as expression: \n\t" + e.message;
			}
		}

		if (typeof val !== 'undefined' && val !== null) {
			if(this.expressionsConfigs.hasOwnProperty(id)){
				this.staticCache[id] = val;
			} else{
				this.cache[id] = val;
			}
		}
		else {
                Personetics.error(errorMessage,null,options);
		}

		return val;
	};

	Personetics.processor.PModel.prototype.fetchFromSrc = function(block, src) {
		var errorMessage = null;
        var result = null;
		if(src == "query"){
			var queryObj = new Personetics.processor.PQuery({
				queryName: block.config.queryName,
				queryParams: block.config.queryParams
			}, this);

			this.currentQueryBlock = block;
			return queryObj.getData(block);
		}
		else {
			var exp = new Personetics.processor.PExp(src);
			try{
				result = exp.eval(this);
				if(typeof result === 'undefined' || result === null) {
                    errorMessage = this.err(null, "PStoryModel.fetchFromSrc('" + src + "') - Error: Evaluating as " +
						"expression returned an invalid result: '" + result + "'", false);
                }
			}
			catch(e){
                errorMessage = this.err(e, "PStoryModel.fetchFromSrc('" + src + "') - Error: Failed to evaluate " +
					"source as expression \n\t" + e.message, false);
				// throw "Source is not available: '" + src + "' - " + e || e.message;
			}

			if(errorMessage){
				Personetics.error(errorMessage);
			}
			return result;
		}
	};

	Personetics.processor.PModel.prototype.getData = function() {
		return this.facts;
	};

	Personetics.processor.PModel.prototype.setVarValue = function(key, value) {
		var me = this;
		if(!this.varCfgs.hasOwnProperty(key))
			this.varCfgs[key] = key;
		this.cache = {};
		var valueToSet = value ? value : null;
		this.varValues[key] = valueToSet;

		this.listeners.forEach(function(listenerObj, index){
			var listener = listenerObj.listener;
			var callback = listenerObj.callback;

			callback.call(listener, me.varValues);
		});
	};

	Personetics.processor.PModel.prototype.getVarValue = function(key) {
		return this.varValues[key];
	};

	Personetics.processor.PModel.prototype.handleQuery = function(query, queryData) {

		var params;
		if(typeof queryData !== 'undefined' && queryData !== null && queryData.hasOwnProperty("story")){
			if(queryData.story.hasOwnProperty("insightFacts"))
				params = queryData.story.insightFacts.query;
			else
				params = queryData.story.facts.query;

			params.name = "query";
			var dataObj = this.createObj(queryData.type, params);
			query.data = dataObj;

			var cacheKey = query.getCacheKey();
			this.queryCfgs[cacheKey] = query;
			this.factsConfigs["query"] = dataObj;
			if(this.currentQueryBlock)
				this.parent.handleQueryData(this.currentQueryBlock, dataObj);
		}

		Personetics.error("Personetics.processor.PModel.prototype.handleQuery - Invalid query params: " + JSON.stringify(queryData));
	};

    Personetics.processor.PModel.prototype.err = function err(e, errorMessage, throwException) {
        throwException = typeof throwException !== 'undefined' && throwException !== null && throwException != false;

        var msg = null;
        var stack = null;
        if(typeof e !== 'undefined' && e !== null) {
            if(typeof e === "object") {
                if (e.hasOwnProperty("message"))
                    msg = e.message;
                if (e.hasOwnProperty("stack"))
                    stack = e.stack;
            }
            else if(typeof e === "string"){
                msg = e;
            }
        }
        var result = errorMessage;
        if(msg && msg.length > 0)
            result += ". Cause: " + msg;

        if(throwException)
            throw {message: result, stack: stack};
        else
            return result + stack;
    };

	Personetics.processor.PModel.prototype.addListener = function(listener, callback){
		this.listeners.push({
			listener: listener,
			callback: callback
		});
	};

	var mapObjects = function mapObjects (obj, objConfig){
		for(var key in obj){
			if(obj.hasOwnProperty(key)){
				objConfig[key] = obj[key];
			}
		}
	};

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

	Personetics.processor = Personetics.processor || {};

	Personetics.processor.PModel.prototype.get = function(id, options) {

		var errorMessage = "";
		var hasError = false;

		// try to get from cache
		var val = this.cache[id] || this.staticCache[id];
		if (typeof val !== 'undefined' && val !== null)
			return val;

		// try to evaluate using var
		var varCfg = this.varCfgs[id];
		if (!val && varCfg) {
			val = this.getVarValue(id);
		}

		// try to evaluate widget var
		var externalParams = this.externalParams[id];
		if (!val && externalParams) {
			val = externalParams;
		}

		// try to evaluate from story data - facts
		var dataCfg = this.factsConfigs[id];
		if (!val && dataCfg) {
			val = dataCfg;
			if (typeof val === 'undefined' || val === null) {
                Personetics.log("PStoryModel.get('" + id + "') - Error: fact exists but is invalid: '" + val + "'. " +
					"Trying to evaluate as expression");
            }
            else {
                if (dataCfg.type) {
                    val.name = id;
                    val = this.createObj(dataCfg.type, val);
                }
            }
		}

		// try to get from expressions
		var expDataCfg = this.expressionsConfigs[id];
		if (!val && expDataCfg) {
			var exp = new Personetics.processor.PExp(expDataCfg);
			try {
				val = exp.eval(this);
			}
			catch(e){
				Personetics.log("PStoryModel.get('" + id + "') Error - Invalid expression string: '" + expDataCfg + "'");
				val = null;
			}
			if (typeof val === 'undefined' || val === null) {
				Personetics.log("PStoryModel.get('" + id + "') - Error: expression exists but is invalid: '" + val + "'. " +
					"Trying to evaluate as expression");
			}
		}

		// this is problematic and can cause infinite loops
		if(typeof val === 'undefined' || val === null){
			if(this.lastGetValue && this.lastGetValue == id) {

				// break endless loop of PModel calling PExp calling model on a variable which can't be found in facts
				// or evaluated as expression
				// not logging because this code should return to the PModel.get method a few lines below
				this.lastGetValue = null;
				return null;
			}
			this.lastGetValue = id;
			var exp = new Personetics.processor.PExp(id);
			try {
                val = exp.eval(this, null, options);
                if(typeof val === 'undefined' || val === null) {
                    hasError = true;
                    errorMessage = "PStoryModel.get('" + id + "') - Error: Evaluating as expression returned an invalid result: '" + val + "'";
                }

            }
            catch(e){
				val = null;
                hasError = true;
				errorMessage = "PStoryModel.get('" + id + "') Error: Failed to evaluate as expression: \n\t" + e.message;
			}
		}

		if (typeof val !== 'undefined' && val !== null) {
				this.cache[id] = val;
		}
		else {
                Personetics.error(errorMessage,null,options);
		}

		return val;
	};

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    var TemplateStartToken = "{{";
    var TemplateEndToken = "}}";
    var TemlateTokenRegex =/{{([^\n\t\v{}]*)}}/g;


    Personetics.processor.PTextTemplate = function PTextTemplate(textTemplate, globalContext) {
        this.textTemplate = textTemplate;
        this.globalContext = globalContext;
        this.tokens = {};

        this.compile();
    };

    Personetics.processor.PTextTemplate.prototype.compile = function(){
        if(this.textTemplate && this.textTemplate.length > 0) {
            var me = this;

            var matches = this.textTemplate.match(TemlateTokenRegex);
            if(matches) {
                matches.forEach(function (match, i) {
                    if (!me.tokens.hasOwnProperty(match)) {
                        var exp = match.replace(TemplateStartToken, "").replace(TemplateEndToken, "");

                        var token = {};

                        token.str = exp;
                        token.exp = new Personetics.processor.PExp(exp);

                        me.tokens[match] = token;
                    }
                });
            }
        }
    };

    Personetics.processor.PTextTemplate.prototype.process = function(context, parentContext, block){
        var textTemplate = this.textTemplate;
        var tokens = this.tokens;
        var me = this;

        for(var tokenName in tokens){
            if(tokens.hasOwnProperty(tokenName)) {
                var token = tokens[tokenName];
                var value;

                var data = context ? context : me.globalContext;
		        /*
                    in case eval function with data as a parameter throws error,
                    eval is invoked again with sending parentContext object.
                */
                try {
                    value = token.exp.eval(data, parentContext);
                }
                catch(e){
                    Personetics.error("PTextTemplate.process('" + this.textTemplate + "') - Error: Failed to evaluate " +
                        "token '" + token.str + ". Error message: " + e.message + e.stack);
                    value = "{{" + token.str + "}}";
                }

                // // escape tokens which have special regex characters in them
                // // TODO: create utility method
                // var tokenNameEscaped = tokenName.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

                // var regexp = new RegExp(tokenNameEscaped, "g");
                textTemplate = textTemplate.replace(tokenName, value);
            }
        }

        return textTemplate;
    };

    Personetics.processor.PTextTemplate.prototype.getTextTemplate = function(){
        return this.textTemplate;
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    var TemplateStartToken = "{{";
    var TemplateEndToken = "}}";
    var TemlateTokenRegex =/{{([^\n\t\v{}]*)}}/g;

    Personetics.processor.PTextTemplate.prototype.compile = function(){
        if(this.textTemplate && this.textTemplate.length > 0) {
            var me = this;

            var matches = this.textTemplate.match(TemlateTokenRegex);
            if(matches) {
                matches.forEach(function (match, i) {
                    if (!me.tokens.hasOwnProperty(match)) {
                        var exp = match.replace(TemplateStartToken, "").replace(TemplateEndToken, "");
                        if(me.globalContext.expressions && me.globalContext.expressions.hasOwnProperty(exp) && me.globalContext.expressions[exp]){
                            exp = me.globalContext.expressions[exp];
                        }
                        var token = {};

                        token.str = exp;
                        token.exp = new Personetics.processor.PExp(exp);

                        me.tokens[match] = token;
                    }
                });
            }
        }
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.BlockProcessor = function BlockProcessor(parent, config, texts, model, dlgId, index) {
        this.parent = parent;
        this.config = config;
        this.model = model;
        this.texts = texts;
        this.dlgId = dlgId;
        this.index = index;
    };

    // special code which should run before data procession
    Personetics.processor.BlockProcessor.prototype.initProcessor = function() {
    };

    // create the json object which will be rendered by block layout renderer
    Personetics.processor.BlockProcessor.prototype.processData = function(){
        this.layoutInstructions = this.copyConfig(this.config); 
        delete this.layoutInstructions.showIf;
        this.setDefaultSelectedValue();
        return this.layoutInstructions;
    };

    Personetics.processor.BlockProcessor.prototype.processText = function(textId, context, parentContext){
        var pTxt = this.getText(textId);
        if (!pTxt)
            return "-";
        return pTxt.process(context, parentContext, this);
    };

    Personetics.processor.BlockProcessor.prototype.getText = function(textId) {
        var txt;
        if (this.texts && this.texts.hasOwnProperty(textId)) {
            txt = new Personetics.processor.PTextTemplate(this.texts[textId], this.model);
        }
        return txt;
    };

    Personetics.processor.BlockProcessor.prototype.getRealValue = function(simpleValue){
        return simpleValue;
    };

    Personetics.processor.BlockProcessor.prototype.setSelectedValue = function(value){
        this.config.selected = value;
    };

    Personetics.processor.BlockProcessor.prototype.handleQueryData = function handleQueryData(data){
        this.doProcessData(data);
    };

    Personetics.processor.BlockProcessor.doProcessData = function doProcessData(data){
        throw "Personetics.processor.BlockProcessor.doProcessData - Not implemented for block class '" + this.config.type + "'";
    };
    
     Personetics.processor.BlockProcessor.prototype.setDefaultSelectedValue = function(){
        var value = this.getRealValue(this.config.selected);
        this.parent.setBlockVarValue(this.config, value);
    };

    Personetics.processor.BlockProcessor.prototype.copyConfig = function copyConfig(obj){
        var result = {};
        for(var key in obj){
            if(obj.hasOwnProperty(key)){
                var valueObj = obj[key];
                if(typeof valueObj !== 'undefined' && valueObj !== null) {
                    if (valueObj.constructor === [].constructor) {
                        var newAr = [];
                        valueObj.forEach(function (item, index) {
                            newAr.push(item);
                        });
                        result[key] = newAr;
                    }
                    else if (valueObj.constructor == {}.constructor) {
                        var newObj = this.copyConfig(valueObj);
                        result[key] = newObj;
                    }
                    else{
                        result[key] = valueObj;
                    }
                }
                else{
                    result[key] = valueObj;
                }
            }
        }
        return result;
    }

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.TextBlockProcessor = function TextBlockProcessor(parent, config, texts, model, dlgId, index) {
        Personetics.processor.BlockProcessor.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.TextBlockProcessor.prototype = Object.create(Personetics.processor.BlockProcessor.prototype);

    Personetics.processor.TextBlockProcessor.prototype.processData = function(){
        this.layoutInstructions = Personetics.processor.BlockProcessor.prototype.processData.call(this);

        var textConfig = this.config.txt || this.config.text;

        if(this.config.hasOwnProperty("txt"))
            delete this.layoutInstructions.txt;

        if(this.config.hasOwnProperty("text"))
            delete this.layoutInstructions.text;

        var txt = this.processText(textConfig, this.model);
        this.layoutInstructions.text = txt;

        return this.layoutInstructions;
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.ImageBlock = function ImageBlock(parent, config, texts, model, dlgId, index) {
        Personetics.processor.BlockProcessor.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.ImageBlock.prototype = Object.create(Personetics.processor.BlockProcessor.prototype);

    Personetics.processor.ImageBlock.prototype.processData = function(){
        this.layoutInstructions = Personetics.processor.BlockProcessor.prototype.processData.call(this);

        var imageSrc = this.processText(this.config.url, this.model);
        var altText = this.processText(this.config.alt, this.model);
        this.layoutInstructions.url = imageSrc;
        this.layoutInstructions.alt = altText;

        return this.layoutInstructions;
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};
    var TYPES = {
        STATIC: "static",
        NAVIGATE_TO_PAGE: "navigateToPage",
        DATA: "data"
    };
    Personetics.processor.OptionsProcessorBlock = function(parent, config, texts, model, dlgId, index) {
        Personetics.processor.BlockProcessor.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.OptionsProcessorBlock.prototype = Object.create(Personetics.processor.BlockProcessor.prototype);

    /**
     * Builds the option models
     */
    Personetics.processor.OptionsProcessorBlock.prototype.processData = function() {

        this.layoutInstructions = Personetics.processor.BlockProcessor.prototype.processData.call(this);

        var me = this;

        this.layoutInstructions.options = [];

        var opts = this.config.options;
        if (!opts || opts.length == 0)
            return;
        this.selectedOptId = null;

        if(this.config.selected) {
            if (this.config.selected.hasOwnProperty("id"))
                this.selectedOptId = this.config.selected.id;
            else
                this.selectedOptId = this.config.selected;
        }

        this.hasSelected = false;

        //this.handleOption(opts);
        opts.forEach(function(opt, i){
            if(!opt.hasOwnProperty("type"))
                opt.type = "static";
            me.handleOption(opt);
        });
	// don't set  first option as default selected if there is no default.
        /*if(!this.hasSelected){
            this.layoutOptions[0].selected = true;
            this.config.selected = this.layoutOptions[0].id;
        }*/
        this.setDefaultSelectedValue();
        return this.layoutInstructions;
    };

    Personetics.processor.OptionsProcessorBlock.prototype.addStaticOption = function(opt, selectedOptId){
        var optObj = {};
        optObj.id = this.getOptId(opt.id);
        optObj = this.addProperties(opt, optObj, selectedOptId);
        this.layoutInstructions.options.push(optObj);
    };
    Personetics.processor.OptionsProcessorBlock.prototype.addProperties = function(opt, optObj, selectedOptId){
        //id, selected
        optObj.id = (typeof optObj.id === 'undefined' || optObj.id === '-') ? opt.id : optObj.id;
        optObj.selected = false;

        //selected, hasSelected
        if (optObj.id == selectedOptId) {
            optObj.selected = true;
            this.hasSelected = true;
        }

        //class
        if(opt.hasOwnProperty('class')){
            optObj.class = opt.class;
        }

        //text
        var optModelObj = new Personetics.processor.POptionModel(opt, this.model);
        var optText = opt.txt || opt.text;
        optObj.text = this.processText(optText, optModelObj, this.model);

        //other
        if (typeof opt !== "undefined" && opt !== null) {
            for(var key in opt)
                if(opt.hasOwnProperty(key) && !optObj.hasOwnProperty(key))
                    optObj[key] = opt[key];
        }

        return optObj;
        
    };
    Personetics.processor.OptionsProcessorBlock.prototype.getOptId = function(optId){
        return this.processText(optId, this.model);
    };

    Personetics.processor.OptionsProcessorBlock.prototype.addDynamicOption = function(opt, selectedOptId){
        var me = this;
        
        if(opt.type == TYPES.DATA && opt.src && opt.src.length > 0){
            var table = this.model.fetchFromSrc(this, opt.src);
			if(typeof table !== 'undefined' && table !== null) {
                table = table.getObjArray();
                table.forEach(function(dataOpt){
                    dataOpt.text = opt.text || opt.txt;
                    dataOpt.text2 = opt.text2 || opt.txt2;
                    if(opt.action)
                        dataOpt.action = opt.action;
                    var optObj = {};
                    optObj = me.addProperties(dataOpt, optObj, selectedOptId, opt);
                    me.layoutInstructions.options.push(optObj);
                });
            }
        }
    };

    Personetics.processor.OptionsProcessorBlock.prototype.getRealValue = function(simpleValue){
        var realValue = simpleValue;
        this.layoutInstructions.options.forEach(function(optObj, i){
            if(optObj.id == simpleValue){
                realValue = optObj;
                return false;
            }
        });
        return realValue;
    };

    /**
     * Mark all options as not selected, mark option for specified option id as selected
     * @param optId
     */
    Personetics.processor.OptionsProcessorBlock.prototype.setSelectedValue = function(opt){
        var block = this;
        this.layoutInstructions.options.forEach(function(optObj, i){
            if(optObj.id == opt.id){
                optObj.selected = true;
                block.config.selected = optObj;
            }
            else{
                optObj.selected = false;
            }
        });
    };

    Personetics.processor.OptionsProcessorBlock.prototype.handleOption = function (opt) {
        var me = this;
        var typeHandled = false;
            switch (opt.type){
                case TYPES.STATIC:
                    me.addStaticOption(opt, me.selectedOptId);
                    typeHandled = true;
                    break;
                case TYPES.DATA:
                    me.addDynamicOption(opt, me.selectedOptId);
                    typeHandled = true;
                    break;
                default:
                    typeHandled = false;
            }

        return typeHandled;
    }

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};
    var TYPES = {
        NAVIGATE_TO_PAGE: "navigateToPage",
        TOGGLE: "toggle",
        PAYLOAD: "payload"
    };

    Personetics.processor.ButtonsProcessorBlock = function(parent, config, texts, model, dlgId, index) {
        Personetics.processor.OptionsProcessorBlock.call(this, parent, config, texts, model, dlgId, index);

        this.isAllNavigateTo = false;
    };

    Personetics.processor.ButtonsProcessorBlock.prototype = Object.create(Personetics.processor.OptionsProcessorBlock.prototype);

    Personetics.processor.ButtonsProcessorBlock.prototype.processData = function() {
        var me = this;

        if(this.config.hasOwnProperty("buttonType")){
            var buttonType = this.config.buttonType;
            if(buttonType == "navigateTo"){
                this.isAllNavigateTo = true;
            }
        }

        this.layoutInstructions = Personetics.processor.OptionsProcessorBlock.prototype.processData.call(this);

        this.layoutInstructions.id = this.config.index;

        if(this.layoutInstructions.hasOwnProperty("default"))
            delete this.layoutInstructions["default"];
        if(this.layoutInstructions.hasOwnProperty("selected"))
            delete this.layoutInstructions["selected"];

        return this.layoutInstructions;
    };

    Personetics.processor.ButtonsProcessorBlock.prototype.addProperties = function addProperties(opt, optObj, selectedOptId){
        optObj = Personetics.processor.OptionsProcessorBlock.prototype.addProperties.call(this, opt, optObj, selectedOptId);

        if (opt.type == TYPES.NAVIGATE_TO_PAGE  && opt.navigateTarget != null && opt.navigateTarget.length > 0) {
            if(typeof (optObj) !== "undefined" && optObj !== null){
                optObj.navigateTarget = this.evalNavigateTarget(opt.navigateTarget);
                addPayloadToNavigateTo.call(this,opt, optObj);
            }
        }

        if(this.isAllNavigateTo){
            if(typeof (optObj) !== "undefined" && optObj !== null){
                optObj.navigateTarget = this.evalNavigateTarget(opt.id);
                addPayloadToNavigateTo.call(this,opt, optObj);
            }
        }
        return optObj;        
    };

    function addPayloadToNavigateTo(preProccessOpt, newOpt){
        if(preProccessOpt.hasOwnProperty("payload") && preProccessOpt.payload) {
            var supportHtmlTagInProcessor = Personetics.processor.PStoryConfig.getConfig("supportHtmlTagInProcessor");
            Personetics.processor.PStoryConfig.setConfig("supportHtmlTagInProcessor",false);
            newOpt.payload = {};
            for (var key in preProccessOpt.payload){
                if(typeof preProccessOpt.payload[key] === "string"){
                    newOpt.payload[key] = this.processText(preProccessOpt.payload[key], this.model);
                }else {
                    newOpt.payload[key] = {};
                    processObjTexts.call(this, preProccessOpt.payload[key], newOpt.payload[key]);
                }
            }
            Personetics.processor.PStoryConfig.setConfig("supportHtmlTagInProcessor",supportHtmlTagInProcessor);
        }
    }

    function processObjTexts(currentObj, newObj){
        for (var key in currentObj) {
            if(typeof currentObj[key] === "string"){
                newObj[key] = this.processText(currentObj[key], this.model);
            }
            else{
                newObj[key] = {};
                processObjTexts.call(this, currentObj[key], newObj[key]);
            }
        }
    }

    Personetics.processor.ButtonsProcessorBlock.prototype.addToggleOption = function(opt, selectedOptId){
        if(typeof selectedOptId === 'undefined' || selectedOptId === null || selectedOptId.length == 0)
            selectedOptId = "off";
        this.hasSelected = true;
        this.prepareToggleButton(opt, selectedOptId);
    };

    Personetics.processor.ButtonsProcessorBlock.prototype.addNavigateToOption = function(opt, selectedOptId){
        var optObj = {};
        optObj.id = this.processText(opt.id, this.model);
        optObj = this.addProperties(opt, optObj, selectedOptId);
        this.layoutInstructions.options.push(optObj);      
    };

    Personetics.processor.ButtonsProcessorBlock.prototype.evalNavigateTarget = function evalNavigateTarget(navIdExpStr){
        var navIdExp = new Personetics.processor.PExp(navIdExpStr);
        var navId;
        try {
            navId = navIdExp.eval(this.model,null,{shouldDisplayError:false});
        }
        catch(e){
            navId = navIdExpStr;
        }
        return navId;
    };

    Personetics.processor.ButtonsProcessorBlock.prototype.prepareToggleButton = function(opt, selectedOptId){
        var txt;
        var toggleClass = "perso-toggle";
        var onObj = {
            type: opt.type
        };
        var offObj = {
            type: opt.type
        };
        // need to add class
        onObj.id = "on";
        onObj.class = toggleClass;
        onObj.on = true;
        onObj.off = false;
        onObj.selected = selectedOptId == "on" ;
        var optionObj = new Personetics.processor.POptionModel(onObj, this.model);

        var onTxtId = opt.onTxt || opt.onText;
        txt = this.processText(onTxtId, optionObj);
        onObj.text = txt;
        this.layoutInstructions.options.push(onObj);

        offObj.id = "off";
        offObj.class = toggleClass;
        offObj.on = false;
        offObj.off = true;
        offObj.selected = selectedOptId == "off" ;

        optionObj = new Personetics.processor.POptionModel(offObj, this.model);
        var offTxtId = opt.offTxt || opt.offText;
        txt = this.processText(offTxtId, optionObj);
        offObj.text = txt;
        this.layoutInstructions.options.push(offObj);

        /**stay open/close also if the previous dialog click */
        this.model.varValuesForSave[this.config.var] = true;
    };

    Personetics.processor.ButtonsProcessorBlock.prototype.handleOption = function(option){
        var me = this;
        var isTypeHandled = false;
        isTypeHandled = Personetics.processor.OptionsProcessorBlock.prototype.handleOption.call(this,option);
        if(!isTypeHandled) {
            switch (option.type) {
                case TYPES.TOGGLE:
                    me.addToggleOption(option, me.selectedOptId);
                    isTypeHandled = true;
                    break;
                case TYPES.NAVIGATE_TO_PAGE:
                case TYPES.PAYLOAD:
                    me.addNavigateToOption(option, me.selectedOptId);
                    isTypeHandled = true;
                    break;
                default:
                    isTypeHandled = false;
            }
        }
        return isTypeHandled;
    };

})(window, window.Personetics = window.Personetics || {});

(function (window, Personetics, undefined) {

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.AccountSelectorProcessorBlock = function AccountSelectorProcessorBlock(parent, config, texts, model, dlgId, index) {
        Personetics.processor.OptionsProcessorBlock.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.AccountSelectorProcessorBlock.prototype = Object.create(Personetics.processor.OptionsProcessorBlock.prototype);

    Personetics.processor.AccountSelectorProcessorBlock.prototype.addProperties = function (opt, optObj, selectedOptId) {
        var optObj = Personetics.processor.OptionsProcessorBlock.prototype.addProperties.call(this, opt, optObj, selectedOptId);
        //text2
        if (typeof opt.text2 != 'undefined') {
            var optModelObj = new Personetics.processor.POptionModel(opt, this.model);
            var optText2 = opt.text2;
            optObj.text2 = this.processText(optText2, optModelObj, this.model);
        }
        return optObj;
    };

    Personetics.processor.AccountSelectorProcessorBlock.prototype.processData = function () {
        this.config.options = [{
            type: 'data',
            src: this.config.src,
            text: this.config.accountText,
            text2: this.config.accountText2
        }];
        if (this.config.showAll) {
            var all = {
                text: this.config.allAccountsText,
                text2: this.config.allAccountsText2,                
                id: 'all',/*for we can process the id*/
                type: 'static'
            };
            this.config.options.push(all);
        }

        this.layoutInstructions = Personetics.processor.OptionsProcessorBlock.prototype.processData.call(this);

        delete this.layoutInstructions.src;
        delete this.layoutInstructions.allAccountsText;
        delete this.layoutInstructions.allAccountsText2;        
        delete this.layoutInstructions.accountText;
        delete this.layoutInstructions.showAll;
        if (this.layoutInstructions.hasOwnProperty("default"))
            delete this.layoutInstructions.default;
        if (this.layoutInstructions.hasOwnProperty("selected"))
            delete this.layoutInstructions.selected;

        this.layoutInstructions.id = this.config.index;

        return this.layoutInstructions;
    };

    Personetics.processor.AccountSelectorProcessorBlock.prototype.getOptId = function (optId) {
        return optId;
    }

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.TextBoxesProcessorBlock = function(parent, config, texts, model, dlgId, index) {
        Personetics.processor.OptionsProcessorBlock.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.TextBoxesProcessorBlock.prototype = Object.create(Personetics.processor.OptionsProcessorBlock.prototype);

    Personetics.processor.TextBoxesProcessorBlock.prototype.processData = function() {

        this.config.options = this.config.boxes;
        this.layoutInstructions = Personetics.processor.OptionsProcessorBlock.prototype.processData.call(this);
        this.layoutInstructions.options.forEach(function(opt) {
            if(opt.selected){
                delete opt.selected;
            }
        });

        delete this.layoutInstructions.boxes;

        return this.layoutInstructions;
    };

    Personetics.processor.TextBoxesProcessorBlock.prototype.handleOption = function (opt) {
        this.addStaticOption(opt, this.selectedOptId);
    };

    Personetics.processor.TextBoxesProcessorBlock.prototype.addStaticOption = function(opt, selectedOptId){
        var optObj = {};

        var optModelObj = new Personetics.processor.POptionModel(optObj, this.model);

        optObj.label = this.processText(opt.label, optModelObj, this.model);

        if(opt.image){
            optObj.image = this.processText(opt.image, optModelObj, this.model);
            if(!this.layoutInstructions.hasOwnProperty("hasImage")){
                this.layoutInstructions.hasImage = true;
            }
        }

        if(opt.hasOwnProperty('label2') && typeof opt.label2 !== 'undefined' && opt.label2 !== null){
            optObj.value = this.processText(opt.label2, optModelObj, this.model);
        } else {
            var optionObj = new Personetics.processor.POptionModel(opt, this.model);
            var valueExp = new Personetics.processor.PExp(opt.value);
            var value;
            try {
                value = valueExp.eval(optionObj);
            }
            catch (e) {
                Personetics.error("TextBoxesProcessorBlock.addStaticOption() Error: Failed to evaluate textBox value. " +
                    "Error message: " + e.message + e.stack);
                value = opt.value;
            }
            optObj.value = value;
        }

        this.layoutInstructions.options.push(optObj);
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){
    Personetics.processor = Personetics.processor || {};
    Personetics.processor.TabsProcessorBlock = function(parent, config, texts, model, dlgId, index) {
        Personetics.processor.OptionsProcessorBlock.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.TabsProcessorBlock.prototype = Object.create(Personetics.processor.OptionsProcessorBlock.prototype);

    Personetics.processor.TabsProcessorBlock.prototype.processData = function() {
        this.config.options = this.config.tabs;

        this.layoutInstructions = Personetics.processor.OptionsProcessorBlock.prototype.processData.call(this);
        this.layoutInstructions.id = this.config.index;
        this.layoutInstructions.class = this.config.class || "perso-tabs";

        return this.layoutInstructions;
    };
})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

	Personetics.processor = Personetics.processor || {};

	Personetics.processor.HBoxBlock = function HBoxBlock(parent, config, texts, model, dlgId, index) {
		Personetics.processor.BlockProcessor.call(this, parent, config, texts, model, dlgId, index);

		this.id = "block-layout_" + config.index;
		this.index = config.index;
		this.columns = [];
		this.processorFactory = parent.processorFactory;
	};

	Personetics.processor.HBoxBlock.prototype = Object.create(Personetics.processor.BlockProcessor.prototype);

	Personetics.processor.HBoxBlock.prototype.initProcessor = function(){
		Personetics.processor.BlockProcessor.prototype.initProcessor.call(this);

		var me = this;

		this.config.columns.forEach(function(columnConfig, index){
			var column = {
				width: columnConfig.width,
				"v-align": columnConfig["v-align"],
				blocks: []
			};

			if(columnConfig.hasOwnProperty("class"))
				column.class = columnConfig.class;

			columnConfig.blocks.forEach(function(blockCfg, jndex) {
				blockCfg.index = jndex;

				me.parent.evaluateDefault(blockCfg);

				var processor = me.parent.createProcessor(blockCfg, me.dlgId);
				// we want to include all blocks, even those we are not supposed to show
				column.blocks.push({processor: processor, config: blockCfg});
			});

			me.columns.push(column);
		});
	};

	Personetics.processor.HBoxBlock.prototype.processData = function(){
        	this.layoutInstructions = Personetics.processor.BlockProcessor.prototype.processData.call(this);

		var me = this;

        	this.layoutInstructions.columns = [];

		this.columns.forEach(function(column, index){

			var newColumn = {
				width: column.width,
				"v-align": column["v-align"],
				blocks: []
			};

			if(column.hasOwnProperty("class"))
				newColumn.class = column.class;

			column.blocks.forEach(function(block, jndex) {
				var processor = block.processor;
				var config = block.config;

				// we don't want to process blocks that shouldn't be shown
				var show = true;
				if (config.hasOwnProperty("showIf") && config.showIf !== null && config.showIf.length > 0) {
					var showIfExp = new Personetics.processor.PExp(config.showIf);
					try {
                        show = showIfExp.eval(me.model);
                    }
                    catch(e){
                        show = false;
                        Personetics.error("HBoxBlock.processData() Error: Failed to evaluate showIf property, not showing block. Error Message: " + e.message + e.stack);
					}
				}
				if (show) {
					var blockData = processor.processData();
					newColumn.blocks.push(blockData);
				}
			});

			if(newColumn.blocks.length > 0)
				me.layoutInstructions.columns.push(newColumn);

		});

		return this.layoutInstructions;
	};

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

	Personetics.processor = Personetics.processor || {};

	Personetics.processor.LayoutBlock = function LayoutBlock(parent, config, texts, model, dlgId, index) {
		Personetics.processor.BlockProcessor.call(this, parent, config, texts, model, dlgId, index);

		this.id = "block-layout_" + config.index;
		this.index = config.index;
		this.blocks = [];
		this.processorFactory = parent.processorFactory;
	};

	Personetics.processor.LayoutBlock.prototype = Object.create(Personetics.processor.BlockProcessor.prototype);

	Personetics.processor.LayoutBlock.prototype.initProcessor = function(){
		Personetics.processor.BlockProcessor.prototype.initProcessor.call(this);

		var me = this;
		this.blocks = [];

		this.config.blocks.forEach(function(blockConfig, index){
			
			//blockConfig.layout = blockConfig["layout"];
			blockConfig.index = index;
			var processor = me.parent.createProcessor(blockConfig, me.dlgId);
			// we want to include all blocks, even those we are not supposed to show
			me.blocks.push({processor: processor, config: blockConfig});
		});
	};

	Personetics.processor.LayoutBlock.prototype.processData = function(){
        this.layoutInstructions = Personetics.processor.BlockProcessor.prototype.processData.call(this);

		var me = this;

        this.layoutInstructions.layout = this.config["layout"];
        this.layoutInstructions.blocks = [];

		this.blocks.forEach(function(block, index){

			var newBlock = {
				layout: block.layout
			};
			
			var processor = block.processor;
			var config = block.config;

			// we don't want to process blocks that shouldn't be shown
			var show = true;
			if (config.showIf) {
				var showIfExp = new Personetics.processor.PExp(config.showIf);
				show = showIfExp.eval(me.model);
			}
			if (show) {
				var blockData = processor.processData();
				me.layoutInstructions.blocks.push(blockData);
				}
		});

		return this.layoutInstructions;
	};

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.DateBoxBlockProcessor = function DateBoxBlockProcessor(parent, config, texts, model, dlgId, index) {
        Personetics.processor.BlockProcessor.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.DateBoxBlockProcessor.prototype = Object.create(Personetics.processor.BlockProcessor.prototype);

    Personetics.processor.DateBoxBlockProcessor.prototype.processData = function(){
        this.layoutInstructions = Personetics.processor.BlockProcessor.prototype.processData.call(this);
        var txt = this.processText(this.config.date, this.model);
        this.layoutInstructions.date = txt;

        return this.layoutInstructions;
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.TableBlockProcessor = function TableBlockProcessor(parent, config, texts, model, dlgId, index) {
        Personetics.processor.BlockProcessor.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.TableBlockProcessor.prototype = Object.create(Personetics.processor.BlockProcessor.prototype);

    Personetics.processor.TableBlockProcessor.prototype.processData = function processData(){
        var config = this.config;
        var src = config.src;
        var table = this.model.fetchFromSrc(this, src);

        if(table == Personetics.processor.Future){
            return {
                type: config.type,
                future: true
            };
        }
        else {

            return this.doProcessData(table);
        }
    };

    Personetics.processor.TableBlockProcessor.prototype.doProcessData = function doProcessData(table){
        this.layoutInstructions = Personetics.processor.BlockProcessor.prototype.processData.call(this);

        delete this.layoutInstructions.src;

        var rows = [];
        if(typeof table !== 'undefined' && table !== null && table.hasOwnProperty("data")){
            this.layoutInstructions.rows = table.data.rows;
            this.layoutInstructions.cols = table.data.cols;
        }

        return this.layoutInstructions;
    };
    
})(window, window.Personetics = window.Personetics || {});
(function (window, Personetics, undefined) {

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.BarBlockProcessor = function BarBlockProcessor(parent, config, texts, model, dlgId, index) {
        Personetics.processor.BlockProcessor.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.BarBlockProcessor.prototype = Object.create(Personetics.processor.BlockProcessor.prototype);

    Personetics.processor.BarBlockProcessor.prototype.processData = function () {
        this.layoutInstructions = Personetics.processor.BlockProcessor.prototype.processData.call(this);

        var blockProcessor = this;
        var config = this.config;
        var src = config.src;
        var data = this.model.fetchFromSrc(this, src);

        this.layoutInstructions.direction = config.direction || "vertical";

        if (typeof data !== 'undefined' && data !== null) {

            var categories = this.getCategories();
            var accessibilityCategories = this.getCategories();
            /** multi series */
            var series = config.series;
            if (series) {
                var table = data.groupByExpression(categories.hasOwnProperty('key') ? categories.key : config.varSource);
                var categoriesArray = categories.categoriesArray;
                var seriesLabels = this.getSeries();
                this.seriesLabels = seriesLabels;
                if(typeof this.config.seriesNamesForDisplay !== 'undefined' && this.config.seriesNamesForDisplay !== null){
                    this.layoutInstructions.seriesNamesForDisplay = this.getSeriesNamesForDisplay();
                }
                
                var arr = [];

                // If seriesNames expression result is valid, sort the table grouping to match the order fiven in
                // seriesNames expression result
                if (typeof categoriesArray !== 'undefined' && categoriesArray !== null && categoriesArray.length > 0) {
                    categoriesArray.forEach(function (month, i) {
                        var item = table.filter(function (tableRow) {
                            return tableRow.groupedKey == month;
                        })[0];
                        var row = [];
                        if (typeof item !== 'undefined') {
                            row = item.table.getObjArray();

                        }
                        var newItem = blockProcessor.prepareDataByMode(row, seriesLabels, month);
                        arr.push(newItem);
                    });
                }
                // If seriesNames expression result is not valid, just add the groups in the order they came
                else {
                    table.forEach(function (tableItem, index) {
                        var row = tableItem.table.getObjArray();
                        var newItem = blockProcessor.prepareDataByMode(row, seriesLabels);
                        arr.push(newItem);
                    });
                }
                this.layoutInstructions.series = arr;
            }

            /** single series*/
            else {
                var rows = data.getObjArray();
                if (categories != null) {
                    var newData = this.prepareDataByCategories(rows, categories);
                }
                else {
                    var newData = this.prepareData(rows);
                }
                this.layoutInstructions.series = newData;
                this.seriesLabels = [""];
                if(config.hasOwnProperty('mode') && config.mode.length){
                    var mode = this.getMode();
                    this.layoutInstructions.mode =  (mode.length > 0) ? mode : '';
                }
            }
        }
        // don't select first item as selected if there is no default
        // if(result.series.length > 0 && !this.hasSelected){
        //     result.series[0].selected = true;
        // }

        if (this.layoutInstructions.hasOwnProperty("varSource"))
            delete this.layoutInstructions["varSource"];
        if (this.layoutInstructions.hasOwnProperty("default"))
            delete this.layoutInstructions["default"];
        if (this.layoutInstructions.hasOwnProperty("selected"))
            delete this.layoutInstructions["selected"];
        if (this.layoutInstructions.hasOwnProperty("seriesNames"))
            delete this.layoutInstructions["seriesNames"];

        delete this.layoutInstructions["x"];
        delete this.layoutInstructions["y"];
        delete this.layoutInstructions["label"];
        delete this.layoutInstructions["src"];

        this.layoutInstructions.categories = this.categories;
        this.layoutInstructions.seriesLabels = this.seriesLabels;
        if (accessibilityCategories != null) {
            accessibilityCategories["categoriesArray"].forEach(function (item, index) {
                var i = parseInt(item) - 1;
                accessibilityCategories[index] = Personetics.processor.PUtils.getUtilsInstance("dateUtils").getMonthName(Personetics.processor.PStoryConfig.getConfig("lang"))[i];
            });
        } else {
            accessibilityCategories = this.layoutInstructions.categories;
        }
        var accessCat = Object.keys(accessibilityCategories).map(function (key) { return accessibilityCategories[key]; });
        accessCat = accessCat.slice(0, accessCat.length - 2);
        this.layoutInstructions.accessibilityCategories = accessCat;


        if(typeof config.benchmarkLines != 'undefined'){
            var benchmarkLines = blockProcessor.prepareBenchmarkLines();
            this.layoutInstructions.benchmarkLines = benchmarkLines;
        }

        return this.layoutInstructions;
    };

    Personetics.processor.BarBlockProcessor.prototype.prepareDataByCategories = function prepareDataByCategories(rows, categories) {
        var blockProcessor = this;
        var config = this.config;

        var yFieldExp = new Personetics.processor.PExp(config.y);
        var xFieldExp = new Personetics.processor.PExp(config.x);

        var newData = [];
        this.categories = [];
        var categoriesKey = categories.key;
        categories.categoriesArray.forEach(function (category, index) {
            var newItem = {};
            newItem[categoriesKey] = category;
            newItem['amount'] = 0;
            newItem['sum'] = 0;

            rows.forEach(function (row, i) {
                if (row[categoriesKey] == category) {
                    newItem = row;
                    return false;
                }
            });

            var newRow = blockProcessor.prepareRow(newItem, xFieldExp, yFieldExp);
            newData.push(newRow);
        });

        return newData;
    };

    Personetics.processor.BarBlockProcessor.prototype.prepareDataByMode = function prepareDataByMode (rows, modes, month) {
        var blockProcessor = this;
        var config = this.config;

        var yFieldExp = new Personetics.processor.PExp(config.y);
        var xFieldExp = new Personetics.processor.PExp(config.x);

        var newData = [];
        this.categories = this.categories || [];
        var seriesMode = config.series;
        modes.forEach(function (mode, index) {
            var newItem = {};
            newItem['month'] = month;
            newItem[seriesMode] = mode;
            newItem['amount'] = 0;
            newItem['sum'] = 0;

            rows.forEach(function (row, i) {
                if (row[seriesMode] == mode) {
                    newItem = row;
                    return false;
                }
            });

            var newRow = blockProcessor.prepareRow(newItem, xFieldExp, yFieldExp);
            newData.push(newRow);
        });

        return newData;
    };

    Personetics.processor.BarBlockProcessor.prototype.prepareData = function prepareData(rows) {
        var blockProcessor = this;
        var config = this.config;

        var yFieldExp = new Personetics.processor.PExp(config.y);
        var xFieldExp = new Personetics.processor.PExp(config.x);

        var newData = [];
        this.categories = [];
        rows.forEach(function (row, i) {
            var newRow = blockProcessor.prepareRow(row, xFieldExp, yFieldExp);
            newData.push(newRow);
        });

        return newData;
    };

    Personetics.processor.BarBlockProcessor.prototype.prepareRow = function prepareRow(row, xFieldExp, yFieldExp) {
        var config = this.config;
        var newRow = {};
        if (this.config.hasOwnProperty("label")) {
            var label = this.processText(config.label, row, this.model);
            if (label != "-") {
                newRow.label = label.replace(/span/g, 'tspan');
            }
        }
        try {
            var yValue = yFieldExp.eval(row, this.model);
            newRow.value = yValue;
        }
        catch (e) {
            Personetics.error("BarBlockProcessor.prepareRow() Error: failed to evaluate block.y expression. Error message: " + e.message + e.stack);
            newRow.value = null;
        }

        var xValue = null;
        try {
            xValue = xFieldExp.eval(row, this.model);
        }
        catch (e) {
            Personetics.error("BarBlockProcessor.prepareRow() Error: failed to evaluate block.x expression. Error message: " + e.message + e.stack);
        }

        if(this.categories.indexOf(xValue) == -1){
            this.categories.push(xValue);}

        if(config.hasOwnProperty('series') && typeof config.series !== 'undefined'){
            newRow.mode = row[config.series];
        }
        /** properties required for item selection **/
        if (config.hasOwnProperty("var") && config.hasOwnProperty("default")) {
            newRow.category = row[config.varSource];

            newRow.selected = false;
            if (typeof config.selected !== 'undefined' && row[config.varSource] == config.selected) {
                newRow.selected = true;
            }
        }
        return newRow;
    };

    Personetics.processor.BarBlockProcessor.prototype.getCategories = function getCategories() {
        var result = null;
        if (this.config.hasOwnProperty("categories")) {
            var configCategories = this.config.categories;
            var categories = this.model.fetchFromSrc(this, configCategories);
            if (typeof categories !== 'undefined' && categories !== null) {
                var categoriesArray = categories.getObjArray();
                var key = categories.data.cols[0];
                var seriesNamesValues = categoriesArray.map(function (a) {
                    return a[key];
                });
                result = {
                    categoriesArray: seriesNamesValues,
                    key: key
                };
            }
        }
        return result;
    };

    Personetics.processor.BarBlockProcessor.prototype.getSeries = function getSeries() {
        var result = null;
        if (!this.config.hasOwnProperty("seriesNames")) {
            Personetics.log("Personetics.processor.BarBlockProcessor - Error: missing 'seriesNames' block property");
        }
        else {
            var seriesNames = this.model.fetchFromSrc(this, this.config.seriesNames);
            var seriesNamesArray = seriesNames.getObjArray();
            var key = seriesNames.data.cols[0];
            result = seriesNamesArray.map(function (a) {
                return a[key];
            });
        }
        return result;
    };

    Personetics.processor.BarBlockProcessor.prototype.getMode = function getMode() {
        var result = null;
        if (!this.config.hasOwnProperty("mode")) {
            Personetics.log("Personetics.processor.BarBlockProcessor - Error: missing 'mode' block property");
        }
        else {
            result = this.model.fetchFromSrc(this, this.config.mode);
        }
        return result;
    };
    
    Personetics.processor.BarBlockProcessor.prototype.getSeriesNamesForDisplay = function getSeriesNamesForDisplay(){
        var blockProcessor = this;
        var seriesNamesForDisplay = this.config.seriesNamesForDisplay;
        var result = seriesNamesForDisplay.map(function(seriesName){
            return blockProcessor.processText(seriesName, blockProcessor.model);
        })
        return result;
    };

    Personetics.processor.BarBlockProcessor.prototype.prepareBenchmarkLines = function prepareBenchmarkLines() {
        var blockProcessor = this;
        var benchmarkLines = [];
        this.config.benchmarkLines.forEach(function (benchmark, index) {
            var newBenchmark = {
                benchmarks:[]
            };
            var valueExp = new Personetics.processor.PExp(benchmark.value);
            newBenchmark.label = blockProcessor.processText(benchmark.label, blockProcessor.model);
            var value = valueExp.eval(blockProcessor.model);
            if (typeof value != 'undefined') {
                value.forEach(function (row, jIndex) {
                    var obj = {};
                    obj.label = blockProcessor.processText(benchmark.innerLabel, blockProcessor.model);
                    obj.value = row;
                    newBenchmark.benchmarks.push(obj);
                });
            }

            benchmarkLines.push(newBenchmark);
        });
        return benchmarkLines;
    };

})(window, window.Personetics = window.Personetics || {});

(function (window, Personetics, undefined) {
  Personetics.processor = Personetics.processor || {};

  Personetics.processor.BarBlockProcessor.prototype.prepareData =
    function prepareData(rows) {
      var blockProcessor = this;
      var config = this.config;

      if (config.type === "pin-graph" || config.type === "pin-chart") {
        var lang = Personetics.processor.PStoryConfig.getConfig("lang");
        switch (lang) {
          case "EN":
          case "En":
          case "eN":
          case "en":
            config.x = "utils.formatDate(date, 'DD MMM')";
            break;
          case "ES":
          case "es":
          case "eS":
            config.x = "utils.formatDate(date, 'DD MMM')";
            break;
          default:
            break;
        }
      }

      var yFieldExp = new Personetics.processor.PExp(config.y);
      var xFieldExp = new Personetics.processor.PExp(config.x);

      var newData = [];
      this.categories = [];
      rows.forEach(function (row, i) {
        var newRow = blockProcessor.prepareRow(row, xFieldExp, yFieldExp);
        newData.push(newRow);
      });

      return newData;
    };
})(window, (window.Personetics = window.Personetics || {}));

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.PieBlockProcessor = function PieBlockProcessor(parent, config, texts, model, dlgId, index) {
        Personetics.processor.BlockProcessor.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.PieBlockProcessor.prototype = Object.create(Personetics.processor.BlockProcessor.prototype);

    Personetics.processor.PieBlockProcessor.prototype.processData = function(){
        this.layoutInstructions = Personetics.processor.BlockProcessor.prototype.processData.call(this);

        var blockProcessor = this;
        var config = this.config;
        var src = config.src;
        var data = this.model.fetchFromSrc(this, src);

        if(config.hasOwnProperty("centerText"))
            var centerText = this.processText(config.centerText, this.model);
            if(centerText.length > 0){
                this.layoutInstructions.centerText = centerText.replace(/span/g,'tspan');
            }

        var selected = config.selected;
        var hasSelected = false;

        if(typeof data !== 'undefined' && data !== null){
            var slices = data.getObjArray();
            slices.forEach(function(slice, index){
                /**default select */
                slice.highlight = false;
                if (slice.category) {
                    slice.categoryId = slice.category;
                }
                /**should be before delete values */
                if(typeof selected !== 'undefined' &&
                 selected !== null &&
                  config.hasOwnProperty("varSource") &&
                (slice[config.varSource] == selected || (slice[config.varSource] != undefined && slice[config.varSource] == selected[config.varSource]))){
                    slice.highlight = true;
                    hasSelected = true;
                }
                
                if(config.hasOwnProperty("label")){
                    var label = blockProcessor.processText(config.label, slice, blockProcessor.model);
                    if(label.length > 0 && label != "-")
                        slice.label = label.replace(/span/g,'tspan');
                }
                if(slice.hasOwnProperty(config.sliceName)){
                    var category = slice[config.sliceName];
                    delete slice[config.sliceName];
                    slice.category = category;
                }

                slice.value = slice[config.sliceValue] || slice.amount;
                slice.index = ++index;

                delete slice[config.sliceValue];
            });

            this.layoutInstructions.slices = slices;
        }

        if(this.layoutInstructions.hasOwnProperty("varSource"))
            delete this.layoutInstructions["varSource"];
        if(this.layoutInstructions.hasOwnProperty("default"))
            delete this.layoutInstructions["default"];
        if(this.layoutInstructions.hasOwnProperty("selected"))
            delete this.layoutInstructions["selected"];
        if(this.layoutInstructions.hasOwnProperty("seriesNames"))
            delete this.layoutInstructions["seriesNames"];

        delete this.layoutInstructions["sliceName"];
        delete this.layoutInstructions["sliceValue"];
        delete this.layoutInstructions["label"];
        delete this.layoutInstructions["src"];

        return this.layoutInstructions;
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.PinBlockProcessor = function PinBlockProcessor(parent, config, texts, model, dlgId, index) {
        Personetics.processor.BarBlockProcessor.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.PinBlockProcessor.prototype = Object.create(Personetics.processor.BarBlockProcessor.prototype);

    // Personetics.processor.PinBlockProcessor.prototype.processData = function(){
    //     this.layoutInstructions = Personetics.processor.BarBlockProcessor.prototype.processData.call(this);
    //
    //     return this.data;
    // };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.LineBlockProcessor = function LineProcessor(parent, config, texts, model, dlgId, index) {
        Personetics.processor.BarBlockProcessor.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.LineBlockProcessor.prototype = Object.create(Personetics.processor.BarBlockProcessor.prototype);

    Personetics.processor.LineBlockProcessor.prototype.processData = function () {
        this.layoutInstructions = Personetics.processor.BarBlockProcessor.prototype.processData.call(this);
        var config = this.config;
        var highlightedCategories = null;
        if(config.highlightedCategory) {
            var highlightedCategoriesExp = new Personetics.processor.PExp(config.highlightedCategory);

            try {
                highlightedCategories = highlightedCategoriesExp.eval(this.model);
            }
            catch (e) {
                Personetics.error("LineBlockProcessor.processData() Error: failed to evaluate block.highlightedCategory expression. Error message: " + e.message + e.stack);
            }
        }

        delete this.layoutInstructions.label2;
        this.layoutInstructions.highlightedCategories = [highlightedCategories];
        return this.layoutInstructions;
    }
    Personetics.processor.LineBlockProcessor.prototype.prepareDataByCategories = function prepareDataByCategories(rows, categories){
        var blockProcessor = this;
        var config = this.config;

        var yFieldExp = new Personetics.processor.PExp(config.y);
        var xFieldExp = new Personetics.processor.PExp(config.x);

        var newData = [];
        this.categories = [];
        var categoriesKey = categories.key;
        categories.categoriesArray.forEach(function(category , index){
            var newItem = {};
            newItem[categoriesKey] = category;
            newItem['amount'] = 0;

            rows.forEach(function(row, i){
                if(row[categoriesKey] == category){
                    newItem = row;
                    return false;
                }
            });

            blockProcessor.prepareCategoryRow(newItem, xFieldExp, yFieldExp, categoriesKey);

        });

        rows.forEach(function(row,index){
            var newRow = blockProcessor.prepareSeriesRow(row, xFieldExp, yFieldExp, categoriesKey);
            newData.push(newRow);
        });


        return newData;
    };

    Personetics.processor.LineBlockProcessor.prototype.prepareSeriesRow = function prepareSeriesRow (row, xFieldExp, yFieldExp, key){
        var config = this.config;
        var newRow = {};
        var xValue = null;
        if(this.config.hasOwnProperty("label")) {
            var label = this.processText(config.label, row, this.model);
            if(label != "-"){
                newRow.label = label.replace(/span/g,'tspan');
            }
        }
        if(this.config.hasOwnProperty("label2")) {
            var label2 = this.processText(config.label2, row, this.model);
            if(label2 != "-"){
                newRow.label2 = label2.replace(/span/g,'tspan');
            }
        }

        try {
            xValue = xFieldExp.eval(row);
        }
        catch(e){
            Personetics.error("LineBlockProcessor.prepareRow() Error: failed to evaluate block.x expression. Error message: " + e.message + e.stack);
        }

        try {
            var yValue = yFieldExp.eval(row);
            newRow.value = yValue;
        }
        catch(e){
            Personetics.error("LineBlockProcessor.prepareRow() Error: failed to evaluate block.y expression. Error message: " + e.message + e.stack);
            newRow.value = null;
        }

        newRow.category = row[key];


        return newRow;
    };

    Personetics.processor.LineBlockProcessor.prototype.prepareCategoryRow = function prepareCategoryRow (row, xFieldExp, yFieldExp, key){
        var category = {};
        var xValue = null;
        try {
            xValue = xFieldExp.eval(row);
            category.label = xValue;
            category.value = row[key];
        }
        catch(e){
            Personetics.error("LineBlockProcessor.prepareRow() Error: failed to evaluate block.x expression. Error message: " + e.message + e.stack);
        }

        this.categories.push(category);
    };

})(window, window.Personetics = window.Personetics || {});
(function(window, Personetics, undefined){

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.CompareProcessorBlock = function(parent, config, texts, model, dlgId, index) {
        Personetics.processor.OptionsProcessorBlock.call(this, parent, config, texts, model, dlgId, index);
    };

    Personetics.processor.CompareProcessorBlock.prototype = Object.create(Personetics.processor.OptionsProcessorBlock.prototype);

    Personetics.processor.CompareProcessorBlock.prototype.processData = function() {

        this.config.options = this.config.series;
        this.layoutInstructions = Personetics.processor.OptionsProcessorBlock.prototype.processData.call(this);
        this.layoutInstructions.options.forEach(function(opt) {
            if(opt.selected){
                delete opt.selected;
            }
        });

        delete this.layoutInstructions.series;

        return this.layoutInstructions;
    };

    Personetics.processor.CompareProcessorBlock.prototype.handleOption = function (opt) {
        this.addStaticOption(opt, this.selectedOptId);
    };

    Personetics.processor.CompareProcessorBlock.prototype.addStaticOption = function(opt, selectedOptId){
        var optObj = {};
        this.layoutInstructions.seriesValues = this.layoutInstructions.seriesValues || [];
        var optModelObj = new Personetics.processor.POptionModel(optObj, this.model);

        optObj.id = opt.id;

        optObj.label1 = this.processText(opt.label1, optModelObj, this.model);
        optObj.label2 = this.processText(opt.label2, optModelObj, this.model);
        var optionObj = new Personetics.processor.POptionModel(opt, this.model);
        var valueExp = new Personetics.processor.PExp(opt.value);
        var value;
        try {
            value = valueExp.eval(optionObj);
        }
        catch(e){
            Personetics.error("CompareProcessorBlock.addStaticOption() Error: Failed to evaluate textBox value. " +
                "Error message: " + e.message + e.stack);
            value = opt.value;
        }
        optObj.value = Math.abs(value);
        if(optObj.id != 'series1'){
            if(optObj.value !== null && optObj.value > 0){
                this.layoutInstructions.seriesValues.push(optObj.value);
                this.layoutInstructions.options.push(optObj);
            }
        } else {
            this.layoutInstructions.seriesValues.push(optObj.value);
            this.layoutInstructions.options.push(optObj);
        }
    };

})(window, window.Personetics = window.Personetics || {});
(function (window, Personetics, undefined) {

    Personetics.processor = Personetics.processor || {};

    Personetics.processor.PAction = function PAction(actionDefinition) {
        this.action = {};
        this.compile(actionDefinition);
    };

    Personetics.processor.PAction.prototype.compile = function compile(actionDefinition) {
        var compiledAction = {};
        compiledAction.actionId = actionDefinition.actionId;
        compiledAction.actionType = actionDefinition.actionType;
        if(actionDefinition.payload){
            var payload = actionDefinition.payload;
            compiledAction.payload = {};
            for (var payloadKey in payload) {
                compiledAction.payload[payloadKey] = new Personetics.processor.PExp(payload[payloadKey]);
            };
        }
        this.compiledAction = compiledAction;
    };

    Personetics.processor.PAction.prototype.process = function process(context, parentContext) {
        
        actionResult = {
            actionId: this.compiledAction.actionId,
            actionType: this.compiledAction.actionType
        };
        
        if(this.compiledAction.payload){
            actionResult.payload = {};
            var payload = this.compiledAction.payload;
            for (var payloadKey in payload) {
                try{
                    actionResult.payload[payloadKey] = payload[payloadKey].eval(context, parentContext);
                }
                catch (e) {
                    Personetics.error("PAction.process() Error: Failed to evaluate payload value. " +
                        "Error message: " + e.message + e.stack);
                }
            };
        }
        
        return actionResult;
    };

})(window, window.Personetics = window.Personetics || {});

(function (window, Personetics, undefined) {

    window.PBlockProcessorManager = new function () {
        var instance = null;

        this.getInstance = function getInstance() {
            if (instance == null) {
                instance = new manager();
            }
            return instance
        };
    };

    var manager = function manager() {
        this.dialogsToBlocksMap = {};
        this.actionsMap = {};

        this.processorFactory = {
            "txt": Personetics.processor.TextBlockProcessor,
            "text": Personetics.processor.TextBlockProcessor,
            "number": Personetics.processor.NumberBlockProcessor,
            "amount": Personetics.processor.AmountBlockProcessor,
            "image": Personetics.processor.ImageBlock,
            "buttons": Personetics.processor.ButtonsProcessorBlock,
            "tabs": Personetics.processor.TabsProcessorBlock,
            "account-selector": Personetics.processor.AccountSelectorProcessorBlock,
            "entity-selector": Personetics.processor.EntitySelectorProcessorBlock,
            "textboxes": Personetics.processor.TextBoxesProcessorBlock,
            "h-box": Personetics.processor.HBoxBlock,
            "layout": Personetics.processor.LayoutBlock,
            "date-box": Personetics.processor.DateBoxBlockProcessor,
            "tranList": Personetics.processor.TableBlockProcessor,
            "bar-chart": Personetics.processor.BarBlockProcessor,
            "pie-chart": Personetics.processor.PieBlockProcessor,
            "arc-chart": Personetics.processor.PieBlockProcessor,
            "pin-graph": Personetics.processor.PinBlockProcessor,
            "pin-chart": Personetics.processor.PinBlockProcessor,
            "line-chart": Personetics.processor.LineBlockProcessor,
            "compare-block": Personetics.processor.CompareProcessorBlock
        };
    };

    manager.prototype.start = function start(options){
        this.storyDefinition = options.story;

        this.defaultLang = "en";

        if(typeof options.customizationOptions !== 'undefined' && options.customizationOptions !== null) {

            for(var key in options.customizationOptions)
            {
                if(options.customizationOptions.hasOwnProperty(key)) {
                    Personetics.processor.PStoryConfig.setConfig(key, options.customizationOptions[key]);
                }
            }
        }

        this.texts = options.texts;
        this.model = new Personetics.processor.PModel(this, options);

        window.model = this.model;

        // create processor list and evaluate default values
        this.initProcessors();
        this.initActions();
    };

    manager.prototype.initProcessors = function initProcessors() {
        var me = this;

        this.storyDefinition.dialogs.forEach(function (dlgConfig, index) {
            var dlgId = dlgConfig.id;

            me.dialogsToBlocksMap[dlgId] = {};

            if (dlgConfig.hasOwnProperty("class")) {
                me.dialogsToBlocksMap[dlgId]["class"] = dlgConfig.class;
            }

            dlgConfig.blocks.forEach(function (config, jndex) {
                var type = config.type;

                var processor = me.createProcessor(config, dlgId, jndex);

                if (processor) {
                    me.dialogsToBlocksMap[dlgId][jndex] = {
                        processor: processor,
                        previousData: null
                    };
                }
            });

        })
    };

    manager.prototype.createProcessor = function createProcessor(config, dlgId, blockIndex) {
        var type = config.type;
        var processorClass = this.processorFactory[type];
        if (processorClass) {
            var texts = null;
            if (this.texts.hasOwnProperty(dlgId)) {

                // take default language texts as baseline
                texts = this.texts[dlgId][this.defaultLang] || {};

                // if dialog has texts for project language, merge into baseline (override existing texts
                var lang = Personetics.processor.PStoryConfig.getConfig("lang");
                if (this.texts[dlgId].hasOwnProperty(lang)) {
                    var langTexts = this.texts[dlgId][lang];
                    for (var textId in langTexts) {
                        if (langTexts.hasOwnProperty(textId))
                            texts[textId] = langTexts[textId];
                    }
                }
            }
            var processor = new processorClass(this, config, texts, this.model, dlgId, blockIndex);
            processor.initProcessor();
            return processor;
        }
        else {
            Personetics.log("createProcessor() - invalid processor type '" + type + "'");
            return null;
        }

    };

    /**
     * Creates layout instructions for all dialogs. Converts dialogs into h-box blocks with a single column
     * @returns {Array}
     */
    manager.prototype.process = function process() {
        var result = [];
        for (var dlgId in this.dialogsToBlocksMap) {
            if (this.dialogsToBlocksMap.hasOwnProperty(dlgId)) {
                var dialogBlocks = this.dialogsToBlocksMap[dlgId];

                var blocks = [];

                var dialogClass = null;
                if (dialogBlocks.hasOwnProperty("class")) {
                    dialogClass = dialogBlocks.class;
                    delete dialogBlocks.class;
                }

                for (var index in dialogBlocks) {
                    if (dialogBlocks.hasOwnProperty(index)) {
                        var processorObj = dialogBlocks[index].processor;
                        var processor = processorObj;
                        var data = this.processBlock(processorObj, processor);
                        if (data)
                            blocks.push(data);
                    }
                }

                var hbox = {
                    type: "h-box",
                    class: "pstory-dialog-frame",
                    columns: [
                        {
                            width: 12,
                            blocks: blocks
                        }
                    ]
                };

                if (dialogClass !== null)
                    hbox.class = dialogClass;

                result.push(hbox);
            }
        }
        return result;
    };

    manager.prototype.processBlocks = function processBlocks(dialogConfig) {
        var result = [];
        var me = this;
        dialogConfig.blocks.forEach(function (blockCfg, index) {
            var data = me.processBlockConfig(dialogConfig.id, index);
            if (data)
                result.push(data);
        });
        return result;
    };

    manager.prototype.processBlockConfig = function processBlockConfig(dlgId, blockIndex) {

        if (this.dialogsToBlocksMap.hasOwnProperty(dlgId) && this.dialogsToBlocksMap[dlgId].hasOwnProperty(blockIndex)) {
            var processorObj = this.dialogsToBlocksMap[dlgId][blockIndex];
            var processor = processorObj.processor;

            return this.processBlock(processorObj, processor);
        }
    };

    manager.prototype.processBlock = function processBlock(processorObj, processor) {
        var result = null;
        var config = processor.config;
        var show = true;
        if (config.showIf) {
            var showIfExp = new Personetics.processor.PExp(config.showIf);

            try {
                show = showIfExp.eval(this.model);
            }
            catch (e) {
                show = false;
                Personetics.error("PBlockProcessorManager.processBlock() Error: Failed to evaluate showIf property, not showing block. Error Message: " + e.message + e.stack);
            }
        }
        if (show) {
            this.evaluateDefault(config);
            result = processor.processData();
            processorObj.previousData = result;
        }

        return result;
    };

    manager.prototype.evaluateDefault = function evaluateDefault(config) {
        // try to get block's variable's value from model
        var blockDefaultValue = this.getBlockVarValue(config);

        // if found a value, set as block's "selected" property
        if (typeof blockDefaultValue !== 'undefined' && blockDefaultValue !== null) {
            config.selected = blockDefaultValue;
        }
        // if no value was found, evaluate default expression and set this as "selected" property
        else {
            if (config.hasOwnProperty("default") && config.default != null && config.default.length > 0) {
                var defaultStr = config.default;
                var defaultExp = new Personetics.processor.PExp(defaultStr);
                try {
                    blockDefaultValue = defaultExp.eval(this.model);
                }
                catch (e) {
                    Personetics.error("PBlockProcessorManager.evaluateDefault() Error: Failed to evaluate " +
                        config.type + " block's default expression");
                }
                if (blockDefaultValue) {
                    config.selected = blockDefaultValue;
                    this.setBlockVarValue(config, blockDefaultValue);
                }
            }
        }
    };

    manager.prototype.resetVariables = function resetVariables(block) {
        if (block.var && !this.model.varValuesForSave[block.var]) {
            this.model.varValues[block.var] = null;
        }
    };

    manager.prototype.getBlockVarValue = function getBlockVarValue(blockConfig) {
        var varKey = blockConfig.var;
        if (typeof varKey !== 'undefined' && varKey !== null && varKey.length > 0)
            return this.model.getVarValue(varKey);
    };

    manager.prototype.setBlockVarValue = function setBlockVarValue(blockConfig, value) {
        var varKey = blockConfig.var;
        if (typeof varKey !== 'undefined' && varKey !== null && varKey.length > 0)
            this.model.setVarValue(varKey, value);
    };

    manager.prototype.getModel = function getModel() {
        return this.model;
    };

    manager.prototype.handleQueryData = function handleQueryData(data, block) {
        var processedData = block.doProcessData(data);
        this.story.handleQueryData(processedData, block);
    };

    manager.prototype.initActions = function initActions(){
        var me = this;
        this.actionsMap = {};
        var actions = me.storyDefinition.actions;
        if(actions){
            actions.forEach(function(action){
                var actionObj = new Personetics.processor.PAction(action);
                me.actionsMap[action.actionId] = actionObj;
            });
        }
    };

    manager.prototype.getAction = function getAction(actionId){
        if(this.actionsMap && this.actionsMap.hasOwnProperty(actionId)){
            var action = this.actionsMap[actionId];
            return action.process(this.model);
        }
        else Personetics.error("PBlockProcessorManager.getAction() Error: action " + actionId + "doesn't exist.");
    };

    manager.prototype.processActions = function processActions(){
        var actionsArray = [];
        for(var key in this.actionsMap){
            actionResult = this.actionsMap[key].process(this.model);
            actionsArray.push(actionResult);
        }
        return actionsArray;
    };

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, $, undefined){
    var Handlebars = Personetics.UI.Handlebars;
	Personetics.story = Personetics.story || {};

	Personetics.story.PCtrlBase = Base.extend({
		initialize: function(parent) {
			this.parent = parent;
			this.templates = [];
			this.partialTemplates = this.getPartialTemplates();
			this.initHandlebars();
		},
		start: function(){
				
		},
		getGraphPalette: function() {
			return null;
		},
		handleMessage: function(msg) {
		},
		initHandlebars: function() {
			this.handlebars = Handlebars.create();
			this.registerPartialTemplates();
		},
		getTemplateHtml: function(templateId,ctxObj) {
			var tmpl = this.getTemplate(templateId);
			var html = tmpl(ctxObj);
			return html;
		},
		getTemplate: function(templateId) {
			var template = this.templates[templateId];
			if (!template) {
				template = this.getPrecompiledTemplate(templateId);
				if (!template) {
					throw "Unknown template '" + templateId + "'";
				}
			}
			return template;
		},
		getPrecompiledTemplate: function(templateId) {
			var id = templateId;
			if (id.substr(0,1) == "#")
				id =  id.substr(1);
			var tmpl = Handlebars.templates[id];
			return tmpl;
		},
		compileTemplate: function(str) {
			return this.handlebars.compile(str);
		},
        getPartialTemplates: function getPartialTemplates() {
            return [{"name": "innerCard", "id": "pstory-block-account-selector-inner-card"},
                {"name": "innerCardDesktop", "id": "pstory-block-account-selector-inner-card-desktop"},
                {"name": "monthPicker", "id": "pstory-block-month-picker"}];
        },
		registerPartialTemplates: function registerPartialTemplates(){
			var me = this;
			this.partialTemplates.forEach(function(partial){
				var partialTemplate = Handlebars.templates[partial.id];
				if(typeof partialTemplate !== "undefined" && partialTemplate !== null)
					Handlebars.registerPartial(partial.name, partialTemplate);
			})
		}
	});
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
	Personetics.story = Personetics.story || {};
	Personetics.story.PBlockFactory = new function () {

		this.types = {
			"TYPE_CONTAINER": "layout"
		};

		this.blockFactoryMap = {};

		this.index = "0";

		this.registerBlock = function (type, config) {
			if (config.blockClass) {
				// from cache
				var entry = this.blockFactoryMap[type];
				if (!entry) {
					entry = {
						type: type,	// block type
						widthModes: {} // additional blocks based on screen width
					};
					this.blockFactoryMap[type] = entry;
				}
				// map block by class or by more specific css class
				var clazz = type;
				if (config.class) {
					clazz = config.class;
				}
				// map block by width mode
				var widthMode = "default";
				if (config.widthMode) {
					widthMode = config.widthMode;
				}
				if (typeof entry.widthModes[widthMode] == 'undefined') {
					entry.widthModes[widthMode] = {};
				}
				entry.widthModes[widthMode][clazz] = config.blockClass;
			}
		};

		this.createBlock = function (parent, layoutInstructions, story) {
			var block;
			var blockClass;
			var storyCfg = story.cfg;
			var type = layoutInstructions.type;
			if (type == this.types.TYPE_CONTAINER) {
				blockClass = Personetics.story.LayoutBlock;
				layoutInstructions.layoutId = "layout-" + this.index;
				this.index++;
			}
			else {
				var defaultMode = "default";
				var cClass = layoutInstructions.class || layoutInstructions.type;
				var widthMode = storyCfg.widthMode || defaultMode;
				var entry = this.blockFactoryMap[type];
				if (entry) {
					//if there is no definition by width mode
					if (typeof entry.widthModes[widthMode] == 'undefined') {
						widthMode = defaultMode;
					}
					//if there is no definition in the width mode by css class
					if (typeof entry.widthModes[widthMode][cClass] == 'undefined') {
						//if there is no definition also in default mode by css class take the default css class by specific width mode
						if (typeof entry.widthModes['default'][cClass] == 'undefined') {
							cClass = type;
						}
						else {
							//css class is first priority
							//width mode is second priority
							widthMode = defaultMode;
						}
					}

					blockClass = entry.widthModes[widthMode][cClass];
				}
				if (!blockClass) {
					blockClass = Personetics.story.Block;
					Personetics.log("Invalid block type '" + type + "'");
				}
			}

			block = new blockClass(parent, layoutInstructions, story);
			return block;
		};
	};
})(window, window.Personetics = window.Personetics || {}, jQuery);

// an abstract block class. All other blocks should extend it
(function(window, Personetics, $, undefined){
	Personetics.story = Personetics.story || {};

	Personetics.story.Block = Base.extend({
		initialize: function(parent, layoutInstructions, story) {
			this.parent = parent;
			this.story = story;
			this.layoutInstructions = layoutInstructions;
            this.isFirstBlock = false;

			// setup block's template
			var tmplId = this.getHtmlTemplateId(layoutInstructions.class);
			if (tmplId)
				this.template = this.story.templates[tmplId];

			if (tmplId && !this.template) {
				this.template   = this.story.getTemplate("#pstory-block-" + tmplId);
				if (!this.template)
					throw "Block template not found for: " + tmplId;

				this.story.templates[tmplId] = this.template;
			}
		},

		getHtmlTemplateId: function(clazz) {
			throw "No template id defined for block"
		},

		initBlock: function() {
		},

		handleQueryData: function(data){
			this.renderData(data);
			this.bindEvents();
		},

		setVisible: function(visible) {},

		beforeRender: function(el, layoutInstructions) {
			this.layoutInstructions = layoutInstructions;
			this.layoutInstructions.isFirstBlock = this.isFirstBlock;
		},

		render: function(el, layoutInstructions) {
			// don't override if saved in beforeRender
			this.layoutInstructions = this.layoutInstructions || layoutInstructions;
			this.el = el;
			var html = this.template(this.layoutInstructions);
			el.append(html);
			this.frameEl = el.find(".pstory-block-frame").last();
		},

		renderAgain: function(data){
			var html = this.template(data);
			$(this.frameEl).replaceWith(html);
		},

		renderData: function(data){},

		afterRender: function(el) {
			this.supportBlockCollapse = this.getSupportBlockCollapse();
			if(this.supportBlockCollapse){
				var params = this.getCollapseParams();
				this.collapseHelper = Personetics.story.BlockChartFactory.generateHelperClazz("collapseHelper", params);
			}
			//only call after render if render method didn't fail
			if(this.frameEl) {
				this.doScrollEvent(true);
			}
		},

		bindEvents: function() {},

		handleEvent: function handleEvent(args){
			var eventType = args[0];
			switch(eventType){
				// don't handle scroll event if rendering method failed
				case "scroll" : 
					if(this.frameEl){this.doScrollEvent(args);}
			}
		},

		getSupportBlockCollapse: function getSupportCollapse(){
			return false;
		},

		getCollapseParams: function getCollapseParams(){
			return {
				el: this.frameEl,
				type: this.layoutInstructions.type,
				uxCtrl: this.story.uxCtrl
			};
		},

		doScrollEvent: function doScrollEvent(){

		},
		notifyReportEvent: function(params){
                Personetics.utils.PEventReporting.setValue(params);
                Personetics.utils.PEventReporting.notifyEvent();
		},

        setIsFirstBlock: function setIsFirstBlock(valueToSet){
			this.isFirstBlock = valueToSet;
		},
		//check if the block is in the viewport
        isBlockPositionInViewport: function isBlockPositionInViewport(block){
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();
        
            var blockTop = $(block).offset().top;
            var blockBottom = blockTop + $(block).height() * this.getBlockPercentInViewportToStartAnimate();
        
            return blockBottom <= docViewBottom;
        },
        /**return as  decimal (1,0.5 atc...)*/
        getBlockPercentInViewportToStartAnimate: function(){
			if(this.story.cfg.widthMode === 'desktop'){
                return this.story.uxCtrl.getBlockPercentInViewportToStartAnimateDesktop(this.layoutInstructions.type);
            }
            return this.story.uxCtrl.getBlockPercentInViewportToStartAnimate(this.layoutInstructions.type);
        },

	});
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
	Personetics.story = Personetics.story || {};

	Personetics.story.LayoutBlock = Personetics.story.Block.extend({

		getHtmlTemplateId: function(clazz) {
			return "layout";
		},

		initialize: function(parent, layoutInstructions, story) {
			Personetics.story.Block.prototype.initialize.call(this, parent, layoutInstructions, story);
		},

		render: function(el, layoutInstructions){
			Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);

			this.contentEl = this.frameEl.find(".layout-block-content").last();
			this.renderBlocks(layoutInstructions);
		},

		renderBlocks: function(layoutInstructions){
			var me = this;
			$.each(layoutInstructions.blocks, function(index, blockLayoutInstructions){
				var blockRenderer = Personetics.story.PBlockFactory.createBlock(me, blockLayoutInstructions, me.story);
				blockRenderer.beforeRender(me.contentEl, blockLayoutInstructions);
				blockRenderer.render(me.contentEl, blockLayoutInstructions);
				blockRenderer.afterRender(me.contentEl);
				blockRenderer.bindEvents();
			});
		},
		
		afterRender: function(){
            var blockFrames = this.contentEl.children(".pstory-block-frame");
            var numOfChildren = blockFrames.length;
            var totalWidth = this.contentEl.width();
            var childWidth = Math.floor(totalWidth / numOfChildren) - 3;
			var layout = this.layoutInstructions.layout;
            if(layout == "horizontal"){
                blockFrames.addClass("perso-horizontal-block");
                blockFrames.each(function(){
                    $(this).css("width", childWidth);
                });
            }
        }
	});
})(window, window.Personetics = window.Personetics || {}, jQuery);


// an abstract block class. All other blocks should extend it
(function(window, Personetics, $, undefined){
	Personetics.story = Personetics.story || {};

	Personetics.story.HBoxBlock = Personetics.story.Block.extend({

		getHtmlTemplateId: function(clazz) {
			return "hbox";
		},

		initialize: function(parent, layoutInstructions, story) {
			Personetics.story.Block.prototype.initialize.call(this, parent, layoutInstructions, story);

			this.totalWidth = 12;
			this.colTemplate = this.story.getTemplate("#pstory-block-hbox-columns");
		},

		render: function(el, layoutInstructions){
			Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);

			this.contentEl = this.frameEl.find(".hbox-block-content").last();
			this.renderBlocks(layoutInstructions);
		},

		renderBlocks: function(layoutInstructions){
			var me = this;
			var colHtml = this.colTemplate(layoutInstructions);
			this.contentEl.append(colHtml);

			var columnContainers = this.contentEl.find(".pstory-hbox-column-frame");

			$.each(layoutInstructions.columns, function(index, col){
				var colEl = columnContainers[index];
				var blockEl = $(colEl).find(".pstory-hbox-blocks-container");

				$.each(col.blocks, function(jndex, blockLayoutInstructions){
					var blockRenderer = Personetics.story.PBlockFactory.createBlock(me, blockLayoutInstructions, me.story);
					blockRenderer.beforeRender(blockEl, blockLayoutInstructions);
					blockRenderer.render(blockEl, blockLayoutInstructions);
					blockRenderer.afterRender(blockEl);
					blockRenderer.bindEvents();
				});
			});
		},

		afterRender: function(){
			var totalWidth = this.totalWidth;
			var blockWidth = this.contentEl.width();
			var colEls = this.contentEl.find(".pstory-hbox-column-frame").each(function(){
				var weight = $(this).data("width");
				var width = Math.floor(weight / totalWidth * blockWidth);
				$(this).css("width", width);
			});
		}
	});
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.TextBlock = Personetics.story.Block.extend({
        getHtmlTemplateId: function (clazz) {
            switch (clazz) {
                case "note":
                case "perso-note":
                    return "txt-note";
                default:
                    return "txt";
            }
        },
        beforeRender: function beforeRender(el, layoutInstructions) {
            var block = this;
            var dateRegexTemplate = "[0-9]{2}([\\-/ \\.])[0-9]{2}[\\-/ \\.][0-9]{4}";
            var regexPattern = new RegExp(dateRegexTemplate)

            if (layoutInstructions.text.indexOf('{{Emoji') != -1) {
                var text = Personetics.utils.emojisHelper.parseEmoji(layoutInstructions.text);
                layoutInstructions.text = text;
            }

            if (this.textHasDate(layoutInstructions.text, regexPattern)) {
                block.isTextHasDate = true;
                var extractedDateStr = this.extractDateFromText(layoutInstructions.text, regexPattern, dateRegexTemplate);
                var lang = Personetics.processor.PStoryConfig.getConfig("lang");
                if (extractedDateStr && (lang === 'he' || lang === 'HE' || lang === 'He')) {
                    var formattedDateText = Personetics.utils.accessibility.formatAccessibleDate(extractedDateStr);
                    layoutInstructions.extractedDateStr = extractedDateStr;
                    layoutInstructions.formattedAccessibleDate = formattedDateText;
                }
            }

            Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            block.layoutInstructions = layoutInstructions;
        },
        render: function (el, layoutInstructions) {
            var param = layoutInstructions;
            if (layoutInstructions.class == "perso-H4" || layoutInstructions.class == "perso-H5")
                param.needAccessibility = true;
            var html = this.template(param);
            el.append(html);
            this.frameEl = el.find(".pstory-block-frame").last();
        },
        afterRender: function (el) {
            var block = this;
            if(block.isTextHasDate) {
                var elText = $(el).find('.pstory-block-content').text();
                if (block.layoutInstructions.hasOwnProperty('formattedAccessibleDate') && block.layoutInstructions.formattedAccessibleDate.length) {
                    block.replaceTextWithSpans($(el).find('.pstory-block-content'), elText);
                }
            }

        },
        extractDateFromText: function (text, regexPattern, dateRegexTemplate) {
            var extractedDate;
            if (text.length && regexPattern.test(text)) {
                extractedDate = text.match(dateRegexTemplate)[0];
            }
            return extractedDate;
        },
        textHasDate: function (text, regexPattern) {
            var hasDate = false;
            if (text.length && regexPattern.test(text)) {
                hasDate = true;
            }
            return hasDate;
        },
        replaceTextWithSpans: function (el,text) {
            var block = this;
            var $span = '<span aria-hidden="true">' + block.layoutInstructions.extractedDateStr + '</span>';
            var $accSpan = '<span class="perso-accessibility-read">' + block.layoutInstructions.formattedAccessibleDate + '</span>';
            var spans = $span + $accSpan;
            var replacedText = text.replace(block.layoutInstructions.extractedDateStr, spans);
            el[0].innerHTML = replacedText;
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.DateBoxBlock = Personetics.story.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "date-box";
        },
        render: function (el, layoutInstructions) {
            // don't override if saved in beforeRender
            var monthNames = [
                Personetics.dictionary.getText('lbljanuary'),
                Personetics.dictionary.getText('lblfebruary'),
                Personetics.dictionary.getText('lblmarch'),
                Personetics.dictionary.getText('lblapril'),
                Personetics.dictionary.getText('lblmay'),
                Personetics.dictionary.getText('lbljune'),
                Personetics.dictionary.getText('lbljuly'),
                Personetics.dictionary.getText('lblaugust'),
                Personetics.dictionary.getText('lblseptember'),
                Personetics.dictionary.getText('lbloctober'),
                Personetics.dictionary.getText('lblnovember'),
                Personetics.dictionary.getText('lbldecember')
            ];
            this.layoutInstructions = this.layoutInstructions || layoutInstructions;
            if (this.layoutInstructions.hasOwnProperty("date")) {
                var dateStr = this.layoutInstructions.date.trim();
                var date = new Date(dateStr);
                this.layoutInstructions.day = date.getDate();
                this.layoutInstructions.month = monthNames[date.getMonth()];
            }
            this.el = el;
            var html = this.template(this.layoutInstructions);
            el.append(html);
            this.frameEl = el.find(".pstory-block-content").last();
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.ImageBlock = Personetics.story.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "image";
        },
        beforeRender: function(el, layoutInstructions){
            Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            var url = this.layoutInstructions.url;
            if(url.indexOf("http") == 0)
                this.layoutInstructions.isAbsoluteURL = true;
            else
                this.layoutInstructions.url = url.substr(0, url.lastIndexOf('.')) || url;
        },

        afterRender: function(el){
            var element = this.frameEl.find('.pstory-block-content');
            var backgroundImage = element.css("backgroundImage");
            var imageSrc = backgroundImage
                .replace(/url\((['"])?(.*?)\1\)/gi, '$2')
                .split(',')[0];

            var image = new Image();
            var height, width;
            image.src = imageSrc;

            image.onload = function(){
                proportionWidth = this.width / element.width();
                proportionHeight = this.height / proportionWidth;
                
                
                element.css({
                    //width: width,
                    height: proportionHeight
                });
            };
             this.frameEl.find('.perso-introduce-personetics').attr("aria-label", Personetics.dictionary.getText("accessibilityIntroducePersonetics"));
             this.frameEl.find('.perso-introduce-personetics').attr("role", "img");
             
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.TableBlock = Personetics.story.Block.extend({

        getHtmlTemplateId: function(clazz) {
            var template;
            var classStr;
            var classes = clazz ? clazz.split(" ") : [];
            $.each(classes, function (index, className){
                  if (className.indexOf("perso-txlist") > -1) {
                      classStr = className.trim();
                      return false;
                  }
            });
            this.classStr = classStr;

            template = classStr ? "table-"+ classStr : "table";
            
            return template;
        },
        beforeRender: function(el, layoutInstructions){
            if(layoutInstructions.rows || layoutInstructions.groups) {
                Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
                this.addTexts();
                this.parseTableToObj();
                this.groupTable();
                this.formatTable();
                this.texts = {
                    tableTitle: Personetics.dictionary.getText("accessibilityTableTitle"),
                    tableStart: Personetics.dictionary.getText("accessibilityTableStart"),
                    tableEnd: Personetics.dictionary.getText("accessibilityTableEnd")
                };
                this.layoutInstructions.legendTexts = [
                    {
                        class: Personetics.dictionary.getText("lblScheduled").toLowerCase(),
                        text: Personetics.dictionary.getText("lblScheduled")
                    },
                    {
                        class: Personetics.dictionary.getText("lblEstimated").toLowerCase(),
                        text : Personetics.dictionary.getText("lblEstimated")
                    }
                ]
            }
            else{
                Personetics.log("TableBlock.beforeRender() Error: invalid rows property - not rendering");
            }
        },
        addTexts: function addTexts(){
            var balanceLabel = Personetics.dictionary.getText("lblbalance");
            this.layoutInstructions.balanceLabel = balanceLabel;
            var loadingText = Personetics.dictionary.getText("loading");
            this.layoutInstructions.loadingText = loadingText;            
        },
        parseTableToObj: function parseTableToObj(){
            var block = this;
            var data = [];
            $.each(this.layoutInstructions.rows, function(i, row){
                var newRow = {};
                $.each(block.layoutInstructions.cols, function(j, colName){
                    if(colName === 'isScheduled'){
                        if(row[j] === 'true'){
                            newRow[colName] = row[j];
                        } else {
                            newRow['isAnticipated'] = Personetics.dictionary.getText("lblAnticipated");
                        }
                    } else {
                        newRow[colName] = row[j];
                    }
                });
                data.push(newRow);
            });
            this.layoutInstructions.rows = data;
        },
        afterRender: function afterRender(el){
            // only call after render if render method didn't fail
            if(this.frameEl) {
                Personetics.story.Block.prototype.afterRender.call(this, el);
                this.addRoleAndDataForAccessibility();
                var lang = Personetics.processor.PStoryConfig.getConfig("lang");
                if(lang === 'he' || lang === 'HE' || lang === 'He') {
                    //format HE dates
                    var accElNoRead = el.find('.perso-accessibility-wrapper .perso-accessibility-no-read');
                    $.each(accElNoRead, function (index, accElNoRead) {
                        var accElRead = el.find('.perso-accessibility-wrapper .perso-accessibility-read');
                        var dateStr = accElNoRead.textContent;
                        var formattedDateText = Personetics.utils.accessibility.formatAccessibleDate(dateStr);
                        accElRead[index].textContent = formattedDateText;
                    });
                }
            }
        },
        addRoleAndDataForAccessibility: function addRoleAndDataForAccessibility(){
            //Override default pronounced text for table
            this.frameEl.find("table").attr('role', 'presentation');

            //Add hidden text
            var valuesElements = this.frameEl.find("td>span");
            var firstTableValue = valuesElements.first();
            var lastTableValue = valuesElements.last();
            firstTableValue.prepend('<span class="perso-accessibility-read">'+ this.texts.tableTitle + this.texts.tableStart + '</span>');
            lastTableValue.append('<span class="perso-accessibility-read">' + this.texts.tableEnd  + '</span>');

            //Role text for fix accessibility focus 
            firstTableValue.addClass('perso-accessibility-wrapper').attr('role', 'text');
            lastTableValue.addClass('perso-accessibility-wrapper').attr('role', 'text');
        },
        /**formatTable */
            formatTable: function formatTable(){
                var block = this;
                var formats = this.story.uxCtrl.getTablesFormat()["table-" + this.classStr];
                    if(!formats)
                        formats = this.story.uxCtrl.getTablesFormat()["table-default"];
                    if(formats){
                        if(this.isGroup == true){
                            $.each(this.layoutInstructions.groups, function(i, group){
                                block.formatRow(group, formats);
                                group.rows.forEach(function(row, j){
                                    block.formatRow(row, formats);
                                });
                            });
                        }
                        else{
                            $.each(this.layoutInstructions.rows, function(i, row){
                                block.formatRow(row, formats);
                            });
                        }
                    }
            },
            formatRow: function formatRow(row, formats){
                var block = this;
                $.each(formats.displayColumns, function(colName, format){
                    if(typeof row[colName] !== 'undefined' && row[colName] !== null){
                       var currencySymbol = row["currencyCd"];
                        if(typeof currencySymbol !== 'undefined'){
                            format.currencySymbol = currencySymbol;
                        }
                        row[colName] = block.formatTableHelper(colName, format, row[colName]);
                    }
                });
            },
            formatTableHelper : function formatTableHelper(type, format, element){
                var result = element;
                var utils = Personetics.processor.PUtils.getUtilsInstance("utils", this.model);
                switch (format.type){
                    case "date":
                        result = utils.formatDate(element, format.format, true);
                        break;
                    case "amount":
                       result = utils.formatAmount(element, format.currencySymbol, format.format, true);
                        break;

                }
                return result;

            },
       /*groupTable*/ 
            groupTable: function groupTable(){
                var block = this;
                if(typeof this.story.uxCtrl.getTablesFormat == 'function'){
                    var formats = this.story.uxCtrl.getTablesFormat();
                    var formatByType = formats["table-"+this.classStr];
                    if(typeof formatByType != 'undefined' && formatByType.isGroup == true && typeof formatByType.groupingField != 'undefined'){
                        this.isGroup = true;
                        var groups = {};
                        var groupingField = formatByType.groupingField;
                        $.each(this.layoutInstructions.rows, function(i, row){
                            var groupName = row[groupingField];
                            if(typeof groups[groupName] == 'undefined'){
                                groups[groupName] = {};
                                groups[groupName].rows = [];
                                var groupingValue = groupName.trim();
                                groups[groupName][groupingField] = groupingValue;
                                var groupingValueId = Personetics.utils.string.stripSpecialChars(groupingValue);
                                groups[groupName][groupingField + 'Id'] = groupingValueId;
                                //define optional
                                block.defineOptionalParameter(groups[groupName]);
                            }
                            block.setOptionalParameter(groups[groupName], row);
                            groups[groupName].rows.push(row);
                        });
                        
                        var dataGroup = [];
                        $.each(groups, function(index, group){
                            dataGroup.push(group);
                        });
                        
                        this.layoutInstructions.groups = dataGroup;
                        delete this.layoutInstructions.rows;
                    }
                }
            },
            defineOptionalParameter: function defineOptionalParameter(group) { },
            setOptionalParameter: function setOptionalParameter(group, row) { },

        render: function(el, layoutInstructions) {
            if(layoutInstructions.rows || layoutInstructions.groups) {
                var texts = {
                    loading: Personetics.dictionary.getText("loading")
                }
                var options = $.extend({texts: texts}, layoutInstructions)
                Personetics.story.Block.prototype.render.call(this, el, options);
            }
            else{
                Personetics.log("TableBlock.render() Error: invalid rows property - not rendering");
            }
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.OptionsBlock = Personetics.story.Block.extend({

        bindEvents: function() {
            this.frameEl.find(".pstory-button").bind("click", Personetics.bind(this, this.optionClickEvent));
            this.bindEvnetsForAnimation();
        },

        optionClickEvent: function(e){
            var target = $(e.currentTarget);
            var targetId = target.attr('pstory-id');//option id
            var action = target.attr('action-id');
            var prevSelected = this.frameEl.find('.pstory-button.selected');//seleced option           
            if(prevSelected.attr('pstory-id') != targetId){
                this.onInputSelect(e);
                var id = target.attr("pstory-id");
                this.currentSelectedOption = this.getOptionById(id);
                if (this.layoutInstructions.type === "Quiz" && this.story.cfg.widthMode === "desktop"){
                    this.setQuizAccessibility();
                }
                this.parent.notifyEvent(this, "setSelectedValue", this.currentSelectedOption);
                if(action){
                    this.parent.notifyEvent(this, "actionEvent", {actionId: action});
                }
                var params = {
                    value: this.layoutInstructions.type.toLowerCase() === "quiz" ? this.getQuizResult(this.layoutInstructions.options,target): this.getReportValue(target),
                    type: this.layoutInstructions.type
                };
                this.notifyReportEvent(params);
            }
        },
        getQuizResult:function(options,target)
        {
            for(var key in options)
            {
                if(options[key].id === target.attr("pstory-id"))
                {
                    if(options[key].answer === "true"){
                        return Personetics.dictionary.getText("right");
                    }
                    else{
                        return Personetics.dictionary.getText("wrong");
                    }
                }
            }
            return Personetics.dictionary.getText("wrong");
        },
        getOptionById: function getOptionById(id){
            return this.layoutInstructions.options.filter(function(opt){
                return opt.id == id;
            })[0];
        },

        //TODO: deprecate this method after implementing story rendering of page
        onInputSelect: function(e){
            var target = $(e.currentTarget);
            var otherButtons = $(this.frameEl).find('.pstory-button');
            otherButtons.removeClass('selected');
            target.addClass('selected');
        },

        bindEvnetsForAnimation: function bindEvnetsForAnimation(){
            
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.TextBoxes = Personetics.story.OptionsBlock.extend({
        getHtmlTemplateId: function(clazz) {
            return "textboxes";
        },

        afterRender: function() {
            this.boxesHeight();
            this.el.closest(".pstory-dialog-frame").addClass("pstory-dialog-frame-text-box")

        },
    
        boxesHeight: function boxesHeight(){
            var boxesEls = this.frameEl.find(".perso-textbox, .perso-textbox-with-image");
            var maxHeight = 0;
            boxesEls.each(function(){
                var height = $(this).height();
                if(height >= maxHeight)
                    maxHeight = height;
            });

            if(maxHeight > 0)
                boxesEls.css("minHeight", maxHeight);
        }

    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.CompareBlock = Personetics.story.OptionsBlock.extend({
        getHtmlTemplateId: function(clazz) {
            return "compare-block";
        },
        afterRender: function() {
            this.drawCompareableBars();
        },

        drawCompareableBars: function(){
            var block = this;
            block.minBarWidthInPercent = 10;
            block.maxBarWidthInPercent = 94;
            var options = block.layoutInstructions.options;
            var seriesValues = block.layoutInstructions.seriesValues;
            block.maxValue = Math.max.apply(null, seriesValues);
            var wrapperEl = block.frameEl.find('.perso-compareBlock-wrapper');
            block.wrapperWidth = wrapperEl.width();
            var HboxColumnFrameEl = block.frameEl.parents(".pstory-hbox-column-frame.right-separator");

            $.each(options,function(i,opt){
                var lastElmIndex = block.layoutInstructions.seriesValues.length - 1;
                var compareText = block.frameEl.find('.perso-compare').eq(lastElmIndex);
                var compareBarEl = block.frameEl.find('#' + opt.id+'_wrapper');
                if(compareBarEl.length > 0){
                    if(opt.value == block.maxValue){
                        compareBarEl.addClass('perso-compare-bar-wrapper perso-compare-bar-max-width');
                    } else {
                        var calcPercentWidth = (opt.value / block.maxValue) * block.maxBarWidthInPercent;
                        calcPercentWidth = (calcPercentWidth > block.minBarWidthInPercent) ? calcPercentWidth : block.minBarWidthInPercent;
                        compareBarEl.width(Math.round(calcPercentWidth)+'%');
                    }
                }
            });

            //center compare block when has 1 series
            if(seriesValues.length == 1 && HboxColumnFrameEl.length > 0){
                HboxColumnFrameEl.addClass('perso-single-compare');
            }

        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.ButtonsBlock = Personetics.story.OptionsBlock.extend({
        getHtmlTemplateId: function(clazz) {
            return "buttons";
        },

        beforeRender:function(el, layoutInstructions){
            Personetics.story.OptionsBlock.prototype.beforeRender.call(this, el, layoutInstructions);
            $.each(this.layoutInstructions.options, function(index, option){
                if(option.type == "toggle"){
                    option.toggleState = option.class + "-" + option.id;
                }
            });

            if(this.layoutInstructions.hasOwnProperty('class') && this.layoutInstructions.class.indexOf('perso-radio-buttons') > -1){
                this.layoutInstructions.typeRadio = true;
                this.layoutInstructions.type = "Quiz";
            }
        },

        optionClickEvent: function(e){
            var target = $(e.target);
            
            var navigateToData = typeof target.data("navigateToPayload") == "undefined" ? target.children('a').data("navigateToPayload") : target.data("navigateToPayload");
            if(navigateToData){

                this.doNavigateToPage(navigateToData);
                var target = $(e.currentTarget);
                var action = target.attr('action-id');
                if(action){
                    this.parent.notifyEvent(this, "actionEvent", {actionId: action});
                }
            }
            else{
                Personetics.story.OptionsBlock.prototype.optionClickEvent.call(this, e);
            }
            
        },

        buttonKyedownEvent: function(e){
            var target =  $(e.target);
            if(target.hasClass('pstory-radio-button')) {
                if ([13].indexOf(e.which) !== -1) {
                    target.click();
                   /* var input = target.find("input");
                    if(input.length) {
                        input[0].click();
                    }*/
                }
            }
        },

        afterRender: function (el) {
            Personetics.story.OptionsBlock.prototype.afterRender.call(this, el);
            if (this.layoutInstructions.buttonType === "navigateTo" && this.layoutInstructions.options.length) {
                var data = [];
               /* var buttonId = "#pstory-block-buttons_" + this.layoutInstructions.id;
                var navigateToLink = el.find(buttonId + " .pstory-link-navigateTo");*/

                $.each(this.layoutInstructions.options, function(index, option){
                    var navigateToLink = el.find('#'+option.id);
                    data[index] = {};
                    if (option.payload) {
                        data[index].navigateTarget = option.navigateTarget;
                        data[index].payload = option.payload;
                    } else {
                        data[index].navigateTarget = option.navigateTarget;
                    }
                    navigateToLink.length && navigateToLink.data("navigateToPayload", data[index]);
                });
            }
            else if (this.layoutInstructions.type === "Quiz" && this.story.cfg.widthMode === "desktop") {
                Personetics.utils.accessibility.trackFocus(this.frameEl);
                this.setQuizAccessibility();
            }
        },
        setQuizAccessibility:function(){
            var labls = this.frameEl.find("label");
            labls.map(function(index, item){
                var lblEl = $(item);
                var isChecked = lblEl.parent().hasClass("selected");
                var amountEl = lblEl.find(".perso-amount");
                var isCheckedText = isChecked ? Personetics.dictionary.getText("accessibilityChecked") :Personetics.dictionary.getText( "accessibilityUnchecked" );
                    var accessibilityLabel = Personetics.dictionary.getText("accessibilityRadioButton") + 
                        status + 
                        ", " + 
                        isCheckedText + 
                        ", " +
                        (index + 1) + 
                        " " +
                        Personetics.dictionary.getText("accessibilityOfLbl") +
                        " " + 
                        labls.length;
                if(!!window.MSInputMethodContext && !!document.documentMode) { //for JAWS on IE 11
                    var accessibilityHelperEl = lblEl.find(".accessibility-helper");
                    if (accessibilityHelperEl.length === 0) {
                        lblEl.append("<span class='accessibility-helper'></span>");
                        accessibilityHelperEl = lblEl.find(".accessibility-helper");
                    }
                    accessibilityHelperEl.attr("aria-label", accessibilityLabel);
                }else { //for NVDA on chrome
                     lblEl.attr("aria-label", amountEl.eq(0).attr("aria-label") + "-" + amountEl.eq(1).attr("aria-label") + ", "+ accessibilityLabel);
                }
            });
        },
        getReportValue:function(target){
            var value;
            if(target.attr("pstory-type-text") != undefined)
                value = target.attr("pstory-type-text");
            else{
                value = target.attr("pstory-id");
            }
            return value;
        },

        doNavigateToPage: function(navigateData){
            this.parent.notifyEvent(this, "doNavigateToPage", navigateData);
            var params = {
                value: navigateData.navigateTarget,
                type: "Navigation"
            };
            this.notifyReportEvent(params);
        },

        bindEvents: function() {
            Personetics.story.OptionsBlock.prototype.bindEvents.call(this);
            var radioButtonsContainer = this.el.find('.pstory-block-buttons.perso-radio-buttons');
            radioButtonsContainer.bind("keypress",".pstory-radio-button", Personetics.bind(this, this.buttonKyedownEvent));
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.NewButtonsBlock = Personetics.story.ButtonsBlock.extend({
        getHtmlTemplateId: function(clazz) {
            return "buttons-new";
        }

    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.AccountSelectorBlock = Personetics.story.OptionsBlock.extend({
        getHtmlTemplateId: function(clazz) {
            return "account-selector";
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.TabsBlock = Personetics.story.OptionsBlock.extend({
         getHtmlTemplateId: function(clazz) {
            return "tabs";
        },
        beforeRender: function(el, layoutInstructions) {
            Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.isDesktopMode = this.story.cfg.widthMode === 'desktop';
            this.layoutInstructions.isDesktopMode = this.isDesktopMode;
        },
         getOptionById: function getOptionById(id){
            return this.layoutInstructions.options.filter(function(tab){
                return tab.id == id;
            })[0];
        },
         afterRender: function afterRender(el){
           var selected = this.frameEl.find(".pstory-button.selected");
           this.changeSelectedTabAnimation(selected);
        },
        onInputSelect: function(e){
            Personetics.story.OptionsBlock.prototype.onInputSelect.call(this, e);
            var selected = $(e.currentTarget);
            selected.attr('aria-selected', true);
            selected.siblings('[role="tab"]').attr('aria-selected', false);
            
            this.changeSelectedTabAnimation(selected);
        },
        changeSelectedTabAnimation: function changeSelectedTabAnimation(selected){
            if(typeof selected === "undefined" || selected === null || selected.length == 0)
                return;
            var tabAnimatedBorder = $(this.frameEl).find(".pstory-tab-animated-border-bottom");
            var left = selected.offset().left - this.frameEl.offset().left;
            var width = selected.innerWidth();
            if(this.isDesktopMode){
                tabAnimatedBorder.css({ "left": left + 'px', width: width + 'px' });
            }else{
                tabAnimatedBorder.css({ "left": left > selected.width() ? this.frameEl.width() - tabAnimatedBorder.width() : left});
            }
        },
        getReportValue:function(target){
            var value = "Tab " + target.attr("value");
            return value;
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.SelectOneBlock = Personetics.story.OptionsBlock.extend({
        getHtmlTemplateId: function(clazz) {
            return "selectOne";
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 =  Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.D3BarChartBlock = Personetics.story.Block.extend({
        getHtmlTemplateId: function(clazz) {
            return "bar-chart";
        },
        beforeRender: function(el, layoutInstructions){
                Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
                var direction = this.layoutInstructions.direction;
                this.isSeries = (this.layoutInstructions.hasOwnProperty('seriesLabels') && this.layoutInstructions.seriesLabels.length && this.layoutInstructions.seriesLabels[0].length) ? true : false;
                this.chartType = this.getChartType(direction, this.isSeries);
                this.layoutInstructions.series = this.rebuildSeriesData(this.layoutInstructions.series);
                this.setSelected();
                this.barsDirection();
                this.beforeRenderChart(el);
                this.texts = {
                    accessibilityBarChartTitle: Personetics.dictionary.getText("accessibilityBarChartTitle"),
                    series: Personetics.dictionary.getText("accessibilitySeries"),
                    selected: Personetics.dictionary.getText("accessibilitySelected"),
                    notSelected: Personetics.dictionary.getText("accessibilityNotSelected"),
                    in: Personetics.dictionary.getText("lblIn"),
                    out: Personetics.dictionary.getText("lblOut")
                }
                if(this.isSeries){
                    var seriesNamesForDisplay = layoutInstructions.seriesNamesForDisplay;
                    var texts = this.texts;
                    if(typeof seriesNamesForDisplay === 'undefined' || seriesNamesForDisplay === null){
                        seriesNamesForDisplay = this.layoutInstructions.seriesLabels.map(function(label){
                            return texts[label.toLowerCase()];
                        })
                    }
                    this.seriesNamesForDisplay = seriesNamesForDisplay;
                }
        },

        setSelected: function setSelected(){
            var block = this;
            this.hasSelected = false;
            $.each(this.layoutInstructions.series,function(i, seriesArray){
                $.each(seriesArray, function(j, item){
                    if(item.selected == true){
                        block.hasSelected = true;
                        return false;
                    }
                });
            });
            if(this.hasSelected == false){
                $.each(this.layoutInstructions.series,function(i, seriesArray){
                    if(seriesArray.length > 0){
                        seriesArray[seriesArray.length - 1].selected = true;
                    }
                });
            }
        },

        render: function(el, layoutInstructions) {
                Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);

                var chartEl = this.frameEl.find(".pstory-bar-chart");
                if (chartEl.length > 0) {
                    this.renderBarChart(chartEl, layoutInstructions);
                }
        },
        afterRender: function(el){
            // only after render if render method didn't fail
            if(this.frameEl) {
                Personetics.story.Block.prototype.afterRender.call(this, el);
                $(this.chartEl).addClass(this.layoutInstructions.direction);
                this.renderAccessibilityData();
            }
        },
        renderAccessibilityData: function renderAccessibilityData(el){
            var id = this.frameEl.parents(".pstory-dialog-frame").attr("id") + this.frameEl.index();
            var titleContent;
            var parentNode = this.chartHelper.svg.node().parentNode;
            if(this.layoutInstructions.type == "pin-graph") {
                var dataString = this.createDataString();
                titleContent = this.getAccessibilityTitle() + '. ' + dataString;
            } else {
                titleContent = this.getAccessibilityTitle();
                d3.select(parentNode).attr("role", "application");
            }

            d3.select(parentNode).append("title").attr("id", id + "_title").text(titleContent);
            this.chartHelper.svg.attr('aria-labelledby', id + '_title');
            this.chartHelper.svg.selectAll("*").attr('aria-hidden', true);
        },

        getAccessibilityTitle: function getAccessibilityTitle(){
            return this.texts.accessibilityBarChartTitle;
        },

        createDataString: function createDataString(){
            var categories = this.layoutInstructions.categories;
            var series = this.layoutInstructions.series;
            var texts = this.texts;
            var seriesLabels = this.layoutInstructions.seriesLabels;
            var seriesNamesForDisplay = this.seriesNamesForDisplay;
            var dataElement = $("<span></span>");
            var hasMultiSeries = this.isSeries;
            if(hasMultiSeries){
                //series In, January, 10,000$, series Out, January, 5,000$","series In, February, 10,000$, series Out, February, 5,000$
                $.each(series[0], function (index, item){
                    dataElement.append(' ' + texts.series + ' ' + seriesNamesForDisplay[0] + ', ' + categories[index] + ', ' + item.label + ', ' +
                     texts.series + ' ' + seriesNamesForDisplay[1] + ', ' + categories[index] + ', ' + series[1][index].label + ',');
                });
            }
            else{
                $.each(series, function (index, item){
                    dataElement.prepend(' ' + Personetics.utils.date.nthDate(categories[index],Personetics.processor.PStoryConfig.getConfig("lang")) + ', ' + item.label + ',');
                });
            }
            return dataElement.text();
        },

        beforeRenderChart: function(el){
            // if layoutInstructions.series contains a single series array, use the child array as the real series array
            if(this.layoutInstructions.series.length == 1 && $.isArray(this.layoutInstructions.series[0]))
                this.layoutInstructions.series = this.layoutInstructions.series[0];
            
            this.chartTypeHelper = this.chartType + "Helper";
            this.initChartHelper(this.chartTypeHelper);

            this.initOptions();
            
        },
        initOptions: function(){
            if(this.chartType == "multiVertical"){
                this.options = this.story.uxCtrl.getColumnChartMultiSeriesOptions();
                this.options.palette = this.story.uxCtrl.getMultiVerticalPalette();
                this.options.paletteLabels = this.story.uxCtrl.getMultiVerticalLabelsPalette();
            }
            else if(this.chartType == "multiHorizontal"){
                this.options = this.story.uxCtrl.getBarChartOptions();
            }
            else{
                this.options = this.story.uxCtrl.getColumnChartOptions();
            }
        },
        barsDirection: function barsDirection(){
            if((this.chartType == "vertical" || this.chartType == "multiVertical") && Personetics.processor.PStoryConfig.isRtl()){
               this.barsDirectionRTL();
            }    
        },
        barsDirectionRTL: function barsDirectionRTL(){
             if($.isArray(this.layoutInstructions.categories)){
                    this.layoutInstructions.categories.reverse();
                }
                if($.isArray(this.layoutInstructions.series)){
                    $.each(this.layoutInstructions.series, function(i, series){
                        if($.isArray(series)){
                            series.reverse();
                        }
                    });
                }
        },

        renderBarChart: function(el) {
            this.options.desktopScreenWidth = this.story.uxCtrl.getDesktopScreenWidth();
            var handleClickBind= Personetics.bind(this, this.handleClick);
            if(this.chartType == "multiHorizontal"){
                this.chartHelper.prepareMultiHorizontalChart(this, el);
                this.chartHelper.renderMultiHorizontalChart(this, el, this.layoutInstructions);
            }
            else{
                if(typeof this.chartHelper.prepareChartData == "function"){
                    this.layoutInstructions = this.chartHelper.prepareChartData(this.layoutInstructions, this.options);
                }
                this.chartHelper.prepareChart(this.layoutInstructions, this.options, handleClickBind);
                this.chartHelper.renderChart(el);
            }
        },
        handleClick: function(obj, clickedItemIndex) {
            if(this.hasSelected == false){
                return;
            }
            if(obj.amount == 0)
                return;
             
            var svg;
            svg = this.frameEl.find('svg .perso-bar, svg .perso-chart-rect')[clickedItemIndex].className.animVal;
            if(svg.indexOf("selected") != -1){
                return;
            }

            /*jq not working*/
            var highlightedElements = this.frameEl.find('svg .perso-bar.selected, svg .perso-chart-rect.selected');
            $.each(highlightedElements,function (i,element) {
                element.className.baseVal= Personetics.utils.string.removeClass(element.className,'selected');
            });

            var highlightedLabels = this.frameEl.find('svg .perso-label');
            $.each(highlightedLabels,function (i,label) {
                label.className.baseVal= Personetics.utils.string.removeClass(label.className,'selected');
            });

            var highlightedxAxisLabels = this.frameEl.find('svg .perso-xAxis-label');
            $.each(highlightedxAxisLabels,function (i, xAxisLabel) {
                xAxisLabel.className.baseVal= Personetics.utils.string.removeClass(xAxisLabel.className,'selected');
            });


            //Check if the object has mode (series) or not
            if(obj.hasOwnProperty("mode")){
                //highlight selected elements
                var highlightSelectedInElements = this.frameEl.find('svg .perso-bar, svg .perso-chart-rect.In')[clickedItemIndex];
                var highlightSelectedOutElements = this.frameEl.find('svg .perso-bar, svg .perso-chart-rect.Out')[clickedItemIndex];
               
                //highlight selected labels
                var highlightSelectedInLabels = this.frameEl.find('svg .perso-label.In')[clickedItemIndex];
                var highlightSelectedOutLabels = this.frameEl.find('svg .perso-label.Out')[clickedItemIndex];

                var clickedBarxAxis = this.frameEl.find('svg .perso-xAxis-label')[clickedItemIndex];

                highlightSelectedInElements.className.baseVal= Personetics.utils.string.addClass(highlightSelectedInElements.className,'selected');
                highlightSelectedOutElements.className.baseVal= Personetics.utils.string.addClass(highlightSelectedOutElements.className,'selected');

                if(typeof highlightSelectedInLabels != 'undefined'){
                    highlightSelectedInLabels.className.baseVal= Personetics.utils.string.addClass(highlightSelectedInLabels.className,'selected'); 
                }
                if(typeof highlightSelectedOutLabels != 'undefined'){
                    highlightSelectedOutLabels.className.baseVal= Personetics.utils.string.addClass(highlightSelectedOutLabels.className,'selected');
                }

                if(clickedBarxAxis){
                    clickedBarxAxis.className.baseVal= Personetics.utils.string.addClass(clickedBarxAxis.className,'selected');
                }


            } else {
                //choose the clicked item
                var clickedBar = this.frameEl.find('svg .perso-bar, svg .perso-chart-rect')[clickedItemIndex];
                var clickedBarLabel = this.frameEl.find('svg .perso-label')[clickedItemIndex];
                var clickedBarxAxis = this.frameEl.find('svg .perso-xAxis-label')[clickedItemIndex];   
                
                //add 'selected' flag to the clicked item
                clickedBar.className.baseVal= Personetics.utils.string.addClass(clickedBar.className,'selected');
                if(typeof clickedBarLabel != 'undefined'){
                    clickedBarLabel.className.baseVal= Personetics.utils.string.addClass(clickedBarLabel.className,'selected');
                }
                if(clickedBarxAxis){
                    clickedBarxAxis.className.baseVal= Personetics.utils.string.addClass(clickedBarxAxis.className,'selected');
                }
                
            }
            this.parent.notifyEvent(this, "setSelectedValue", obj.category);
            var params = {
                value: obj.category,
                type: this.layoutInstructions.type
            }; 
            this.notifyReportEvent(params);
        },

        //utils
        getChartType: function(direction, hasMultiSeries){
            var type = null;
            if(direction =="vertical" && hasMultiSeries){
                type = "multiVertical";
            }else if(direction =="horizontal" && hasMultiSeries){
                type = "multiHorizontal";
            }else if (direction =="vertical"){
                type = "vertical";
            }
            else if(direction =="horizontal"){
                type = "horizontal";
            }
            return type;
        },

        initChartHelper: function(type){
            this.chartHelper = Personetics.story.BlockChartFactory.generateHelperClazz(type, this.story.cfg);
        },
        //build D3 data structure
        rebuildSeriesData: function (series) {
            var self = this;
            var data = [];
            if (self.isSeries && series.length) {
                $.each(self.layoutInstructions.seriesLabels, function (i, label) {
                    var tmpArray = [];
                    $.each(series, function (j, seriesItem) {
                        $.each(seriesItem, function (k, item) {
                            if (label == item.mode) {
                                tmpArray.push(item);
                            }
                        })
                    });
                    data.push(tmpArray);
                })
            } else {
                data = [series];
            }
            return data;
        },
        
        doScrollEvent: function (skipAnimation) {
            Personetics.story.Block.prototype.doScrollEvent.call(this, skipAnimation);
            if(this.isBlockPositionInViewport(this.frameEl)){
                if(typeof this.chartHelper.barAnimations == 'function'){
                    this.chartHelper.barAnimations();
                }
            }
        },
        getBlockPercentInViewportToStartAnimate: function(){
            var type = Personetics.story.Block.prototype.getBlockPercentInViewportToStartAnimate.call(this);
            return type[this.chartType];
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.BarChartBlock = Personetics.story.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "pure-bar-chart";
        },
        /**before render */
        beforeRender: function (el, layoutInstructions) {
            Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.isDesktopMode = this.story.cfg.widthMode === 'desktop';
            this.series = layoutInstructions.series;
            layoutInstructions.isSeries = this.isSeries = this.layoutInstructions.hasOwnProperty('seriesLabels')
                && this.layoutInstructions.seriesLabels.length > 0
                && this.layoutInstructions.seriesLabels[0].length > 0;
            this.chartType = (this.isSeries) ? 'multiVertical' : 'vertical';
            this.setSelected();
            this.texts = this.getTexts();
            
            this.prepereData();
            this.options = this.story.uxCtrl.getBarChartNewOptions(this.chartType);
            this.benchmarkConfig =  this.story.uxCtrl.getBarBenchmarkConfig();
        },
        prepereData: function prepereData(){
            var block = this;
            this.prepereAccessibilityCategories();
            this.setSeriesNamesForDisplay();
            if(this.isSeries){
                $.each(this.layoutInstructions.series, function (i, item) {
                    block.layoutInstructions.series[i].category = item[0].category;
                });
            }
            this.prepereBenchmarkData();
        },
        prepereBenchmarkData: function prepereBenchmarkData(){
            var block = this;
            this.benchmarkLines = this.layoutInstructions.benchmarkLines || [];
            //add 2 dots to the line in order to add edges for the lines
            this.benchmarkLines.forEach(function(item, i){
                item.benchmarks.unshift(item.benchmarks[0]);
                item.benchmarks.push(item.benchmarks[item.benchmarks.length - 1]);
            });
            this.benchmarkLinesData = this.benchmarkLines;
            this.seriesDataAndBenchmarkData = this.series;
            this.benchmarkLinesData.forEach(function(item, index){
                block.seriesDataAndBenchmarkData = block.seriesDataAndBenchmarkData.concat(item.benchmarks);
            });
        },

        getTexts: function getTexts() {
            return {
                accessibilityBarChartTitle: Personetics.dictionary.getText("accessibilityBarChartPureTitle"),
                series: Personetics.dictionary.getText("accessibilitySeries"),
                selected: Personetics.dictionary.getText("accessibilitySelected"),
                notSelected: Personetics.dictionary.getText("accessibilityNotSelected"),
                in: Personetics.dictionary.getText("lblIn"),
                out: Personetics.dictionary.getText("lblOut")
            };
        },
        prepereAccessibilityCategories: function renderAccessibilityCategories() {
            var block = this;
            var dateUtils = Personetics.processor.PUtils.getUtilsInstance("dateUtils");
            var lang = Personetics.processor.PStoryConfig.getConfig("lang");
            $.each(this.layoutInstructions.categories, function (i, category) {
                var monthNumber = dateUtils.getMonthNumber(lang + "-short", category);
                var fullMonthName = dateUtils.getMonthName(lang)[monthNumber];
                fullMonthName = fullMonthName || category;
                block.layoutInstructions.series[i].displayLabel = category
                block.layoutInstructions.series[i].accLabel = fullMonthName
            });
        },
        setSeriesNamesForDisplay: function setSeriesNamesForDisplay() {
            if (this.isSeries) {
                var seriesNamesForDisplay = this.layoutInstructions.seriesNamesForDisplay;
                var texts = this.texts;
                if (typeof seriesNamesForDisplay === 'undefined' || seriesNamesForDisplay === null) {
                    seriesNamesForDisplay = this.layoutInstructions.seriesLabels.map(function (label) {
                        return texts[label.toLowerCase()];
                    })
                }
                this.seriesNamesForDisplay = seriesNamesForDisplay;
            }
        },
        setSelected: function setSelected() {
            var block = this;
            var hasSelected = false;
            var series = block.layoutInstructions.series;
            $.each(series, function (i, item) {
                if (!block.isSeries) {
                    if (item.selected == true) {
                        hasSelected = true;
                        return false;
                    }
                } else {
                    $.each(item, function (j, obj) {
                        if (obj.selected == true) {
                            if (!item.selected) {
                                item.selected = true;
                            }
                            hasSelected = true;
                            return false;
                        }
                    });
                }
            });
            if (hasSelected == false) {
                if (series.length && block.isSeries) {
                    $.each(series[series.length - 1], function (i, item) {
                        if (typeof item !== 'undefined' && item !== null) {
                            item.selected = true;
                        }
                    });
                } else {
                    series[series.length - 1].selected = true;
                }          
            }
        },
        /**end before render */
        /**render */
        render: function (el, layoutInstructions) {
            Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);
            var chartEl = this.frameEl.find(".pstory-bar-chart .perso-bar-chart-container");
            if (chartEl.length > 0) {
                this.renderBars(chartEl);
            }
        },
        renderBars: function (el) {
            var block = this;
            if (this.isSeries) {
                var series = $(el).find('.perso-series-wrapper');
                block.setBarsWidth(series);
                block.setBarsSeriesHeight(series);
            } else {
                var bars = $(el).find('.perso-bar-wrapper');
                block.setBarsWidth(bars);
                block.setBarHeight(bars);
            }
        },
        setBarsWidth: function (elements) {
            var totalMargin = (this.layoutInstructions.categories.length - 1) * this.options.marginBetweenBars;
            $(elements).css('width', 100 / this.layoutInstructions.categories.length + '%');
        },
        /**calculate bars height */
        setBarHeight: function (barElements) {
            var maxValue = this.getMaxValue();
            var minValue = this.getMinValue();
            this.calculateBarsHeight(barElements, minValue, maxValue);
        },
        setBarsSeriesHeight: function (seriesElements) {
            var maxValue = this.getSeiresMaxValue();
            this.calculateSeriesBarsHeight(seriesElements, maxValue);

        },
        calculateBarsHeight: function (bars, minValue, maxValue) {
            var block = this;
            var negativeBar = false;
            var orignalMaxValue = maxValue;
            if (minValue < 0) {
                if (maxValue >= 0) {
                    maxValue = maxValue + Math.abs(minValue);
                } else {
                    negativeBar = true;
                }
            }

            var options = this.prepareCalculateBarHeightOptions(maxValue);
            var maxHeight = block.calculateBarHeightByValue(orignalMaxValue, options);
            $.each(bars, function (i, bar) {
                var x = block.series[i].value;
                var values = block.calculateBarHeightByValue(x, options);
                var normalValue = values.normalValue;
                $(bar).css('height', normalValue + 'px');
                var top = 0;
                if (values.y < 0) {
                    $(bar).addClass('negative-bar');
                    if(negativeBar == false){
                        top = maxHeight.normalValue;
                    }
                }
                else{
                    top = maxHeight.normalValue - normalValue;
                }
                
                $(bar).css('top', top + 'px');
            });
        },
        calculateSeriesBarsHeight: function ($series, maxValue) {
            var block = this;
            var options = this.prepareCalculateBarHeightOptions(maxValue);
            if ($series.length) {
                $.each($series, function (i, series) {
                    var $bars = $(series).find('.perso-bar-wrapper');
                    if ($bars.length) {
                        $.each($bars, function (j, bar) {
                            var absValue = Math.abs(block.series[i][j].value);
                            var mode = (block.series[i][j].mode) ? block.series[i][j].mode : '';
                            $(bar).addClass(mode.toLowerCase());
                            var height = block.calculateBarHeightByValue(absValue, options).normalValue;
                            $(bar).css('height', height + 'px');
                            $(bar).css('top', 'calc(100% - ' + height + 'px)');
                        })
                    }
                });
            }
        },
        prepareCalculateBarHeightOptions: function prepareCalculateBarHeightOptions(maxValue) {
            /**
             * m = (y1-y2)/(x1-x2)
             * Y-y1 = m(X - x1)
             * 
             * x1= 0
             * x2= maxValue
             * y1 = 0
             * y2 = containerHeight - minHeight//for normalize
             */
            var minHeight = this.options.minBarHeight * $(document).width(); /*minHeight = normalize value*/
            var containerHeight = this.options.height * $(document).height();
            var m = (containerHeight) / (Math.abs(maxValue));
            return {
                'm': m,
                'minHeight': minHeight,
                'containerHeight': containerHeight
            }
        },
        calculateBarHeightByValue: function calculateBarHeightByValue(x, options) {
            var y = options.m * (x);
            return {
                'normalValue': Math.abs(y + options.minHeight),
                'y': y
            };
        },
        getMaxValue: function () {
            var block = this;
            var maxValue = Math.max.apply(Math, block.seriesDataAndBenchmarkData.map(function (o) {
                return o.value;
            }));
            return maxValue;
        },
        getMinValue: function () {
            var block = this;
            var minValue = Math.min.apply(Math, block.seriesDataAndBenchmarkData.map(function (o) {
                return o.value;
            }));
            return minValue;
        },
        getSeiresMaxValue: function () {
            var block = this;
            var maxSeriesValue = 0;
            if (block.isSeries) {
                $.each(block.series, function (i, series) {
                    var tmp = Math.max.apply(Math, series.map(function (o) {
                        return o.value;
                    }));
                    if (maxSeriesValue < tmp) {
                        maxSeriesValue = tmp;
                    }
                })
            }
            return maxSeriesValue;
        },
        /**end calculate bars height */
        /**render benchmark */
        renderBenchmark: function renderBenchmark(params){
            this.renderLineSVG(params);
            this.renderBenchMarkLines();
            
            this.benchmarkLineAnimation();
        },
        beforeRenderBenchmark: function beforeRenderBenchmark(){/**called from do animation -afterRender */
            var maxBarValue = Math.max.apply(Math, this.series.map(function (o) {
                return o.value;
            }));
            var block = this;
            var el = this.frameEl.find('.pstory-bar-chart .perso-bar-chart-wrapper');
            var barsWrapperElm = this.frameEl.find('.perso-bars-wrapper');
            var height = $(barsWrapperElm).height();
            var width = $(barsWrapperElm).width() + ($(barsWrapperElm).width() / block.layoutInstructions.categories.length) * 2;
            this.xScale = d3.scale.ordinal().rangeRoundBands([0, width], 0);
            block.layoutInstructions.categories.unshift("edge1");
            block.layoutInstructions.categories.push("edge2");
            this.xScale.domain(block.layoutInstructions.categories.map(function (d) {
                return d;
            }));
            this.minValue = this.getMinValue() > 0 ? 0 : this.getMinValue();
            this.yScale = d3.scale.linear().range([height, 0]);
            this.yScale.domain([block.minValue, block.getMaxValue()]);
            this.svgWidth = this.xScale("edge2") - this.xScale("edge1");
            this.frameEl.find('.pstory-bar-chart .perso-bars-wrapper').css('margin-top', this.yScale(maxBarValue));
            return{
                el: el,
                height: height,
                width: width
            }
        },
        renderLineSVG: function (params) {
            this.svg = d3.select(params.el.get(0)).append("svg")
                .attr("class", "perso-svg-chart-container")
                .attr("width", this.svgWidth)
                .attr("height", params.height) 
                .style('margin-left', params.el.find('.perso-bar').outerWidth(true) / 2 * -1)
                .append("g")
                .attr('class','perso-svg-container-group');

        },         
        renderBenchMarkLines: function(){
            var self = this;
            this.benchmark = this.svg.append("g")
            .attr('class', 'benchmarkLines');

            this.benchmarkLinesData.forEach(function(benchmarkLine, index){
                self.renderLine(benchmarkLine.benchmarks);
                self.renderLabel(benchmarkLine); 
                self.renderClipPath(); 
            });
        },
        renderLabel: function renderLabel(benchmarkLine) {
            var barWrapper = this.frameEl.find('.perso-bar-chart-wrapper');
            var html = '<label class="perso-bar-budget-label">'+ benchmarkLine.label + '</label>';
            barWrapper.append(html);
            var label = barWrapper.find('.perso-bar-budget-label');
            var left = barWrapper.offset().left + (this.frameEl.find('.perso-bar-chart-wrapper').outerWidth(true)- label.outerWidth()) / 2 ;
            var center = Math.round(benchmarkLine.benchmarks.length / 2);
            var top = this.yScale(benchmarkLine.benchmarks[center].value) + label.height()/2;
            label.css({
                'position': 'absolute',
                'left': left,
                'top': top
            });
        },
        renderLine: function (benchmarkLine) {
            var block = this;
            this.line = d3.svg.line()
                .interpolate(block.benchmarkConfig.lineInterpolate)
                .x(function (d, index) {
                    return block.xScale(block.layoutInstructions.categories[index]);
                })
                .y(function (d) {
                    return block.yScale(d.value);
                });
            this.benchmark.append("g")
                .attr("name","line")
                .append("path")
                .datum(benchmarkLine)
                .attr("class", "perso-line")
                .attr("d", this.line)
                .style("clip-path", "url(#banchmarkClipPath)");
        },
        renderClipPath: function renderClipPath(){
            var labelWidth = this.benchmarkConfig.labelWidthPercent;
            var labelWidthSimpleValue = this.convertPercentToSimpleValue(labelWidth, this.svgWidth);
            var rects =[{
                x: (this.svgWidth / 2 - labelWidthSimpleValue / 2) + 'px',
                width: 0
            },{
                x: (this.svgWidth / 2 + labelWidthSimpleValue / 2) + 'px',
                width: 0
            }]
            var clipPath = this.svg.append("defs").append("clipPath")
                .attr("id", "banchmarkClipPath");
            this.clipRects = clipPath.selectAll('rect')
                .data(rects)
                .enter()
                .append("rect")
                .attr("x", function(d){
                    return d.x;
                })
                .attr("width", function(d){
                    return d.width;
                })
                .attr("height", "100%");
        },
        convertPercentToSimpleValue: function convertPercentToSimpleValue(percentValue, containerValue){
            return containerValue / 100 * percentValue;
        },
        /**end render */
        /**after render */
        afterRender: function (el) {
            // only after render if render method didn't fail
            if (this.frameEl) {
                this.frameEl.closest(".pstory-dialog-frame").addClass("pure-bar-chart-dialog")
                this.setMonthPickerTabWidth();
                this.setDefaultMonthPickerTab();
                this.setBarsWrapperHeight();
                this.setDefaultBar();
                this.setMonthAmount(this.series[this.getDefaultIndex()].label);
                if (this.isBlockPositionInViewport(this.frameEl)) {
                    this.doAnimations();
                }
            }
            this.renderAccessibility();
            Personetics.story.Block.prototype.afterRender.call(this, this, el);
        },
        renderAccessibility: function renderAccessibility() {
            Personetics.utils.accessibility.addAltTextToElement(this.frameEl, this.texts["accessibilityBarChartTitle"]);
        },
        setBarsWrapperHeight: function setBarsWrapperHeight() {
            var barsWrapperElm = this.frameEl.find('.perso-bars-wrapper');
            var calculatedHeight = this.options.height * $(document).height();
            if (barsWrapperElm.length) {
                $(barsWrapperElm).height(calculatedHeight);
            }
        },


        setDefaultBar: function setDefaultBar() {
            var selectedElm = this.frameEl.find(".perso-bar.selected");
            if (this.isSeries) {
                this.setTooltipPosition(selectedElm.attr('pstory-category'));
            }
            this.createDefaultBarTransElem(selectedElm);
        },
        getDefaultIndex: function () {
            var block = this;
            var selected = 0;
            $.each(block.layoutInstructions.series, function (i, item) {
                if (item.selected) {
                    selected = i;
                    return false;
                }
            });
            return selected;
        },
        getSelectedBarIndex: function () {
            return this.selectedBarIndex ? this.selectedBarIndex : 0;
        },
        updateSelectedAccText: function updateSelectedAccText() {
            var selectedTextEl = this.frameEl.find('.perso-accessibility-bar-selected-text');
            selectedTextEl.text(this.frameEl.find('.perso-month-picker-item.selected').attr('aria-label') + ',')
        },
        createDefaultBarTransElem: function (elem) {
            $(elem).each(function (i,bar) {
                $(bar).addClass('selected-animated');
                $(bar).append($("<div class='perso-animated-bar'></div>"));
            });
        },
        benchmarkLineAnimation: function benchmarkLineAnimation(){
            var labelWidth = this.benchmarkConfig.labelWidthPercent;
            labelWidthSimpleValue = this.convertPercentToSimpleValue(labelWidth, this.svgWidth);
            this.frameEl.find('.perso-bar-budget-label').css('opacity', 1);
            this.clipRects.transition()
                .duration(this.benchmarkConfig.lineTransitionDuration)
                .delay(this.benchmarkConfig.labelTransitionDuration)
                .attr("width", (this.svgWidth / 2 - labelWidthSimpleValue / 2) + "px") 
                .attr("x", function(d, i){
                    if(i == 1){
                        return d.x;
                    }
                    else return 0;
                });
        },
        /**bind events */
        bindEvents: function () {
            this.frameEl.find(".perso-month-picker-item").bind("click", Personetics.bind(this, this.monthPickerItemClick));
        },
        tabClickListener: function tabClickListener(category) {
            this.changeSelectedElm(category);
            if (!this.isSeries) {
                var selected = this.series.filter(function(item){
                    return item.category == category
                })[0];
                this.setMonthAmount(selected.label);
            } else {
                this.setTooltipPosition(category);
            }
            if(!this.frameEl.hasClass('perso-collapsed')){
                Personetics.utils.accessibility.putFocus(this.frameEl.find('.perso-bar-chart-wrapper'));
            }
        },
        changeSelectedElm: function (category) {
            var elm = this.frameEl.find('.perso-bar');
            elm.removeClass('selected selected-animated');
            elm.find('.perso-filler-bar').remove();
            elm.filter("[pstory-category='" + category + "']").addClass('selected').attr("aria-selected", "true");
            this.updateSelectedAccText();

        },
        setMonthAmount: function (label) {
            var $persoMonthAmount = $('.perso-month-amount');
            if ($persoMonthAmount.length) {
                $persoMonthAmount.html(label);
            }
        },
        setTooltipPosition: function (category) {
            var block = this;
            var selectedSeries = this.frameEl.find('.perso-series .perso-bar.selected').parents('.perso-series');
            var tooltip = this.frameEl.find('.perso-tooltip');
            block.setTooltipLabels(tooltip, category);
            var maxSelectedSeriesBarHeight = this.getSeriesHigherBar(selectedSeries);
            if (selectedSeries.length && tooltip.length) {
                var bottomVal = maxSelectedSeriesBarHeight + this.options.tooltipJMarginBottom;
                var leftVal = $(selectedSeries).offset().left + $(selectedSeries).width() / 2 - $(tooltip).outerWidth() / 2;
                tooltip.css({
                    bottom: bottomVal,
                    left: leftVal,
                })
            }
        },
        setTooltipLabels: function (tooltip, category) {
            var block = this;
            var seriesNamesForDisplay = this.seriesNamesForDisplay;
            var labelTextElm = '<span class="perso-tooltip-label"></span>';
            if (tooltip.length) {
                $(tooltip).empty();
                var seriesObj = this.series.filter(function(item){
                    return item.category == category;
                })[0];
                $.each(this.layoutInstructions.seriesLabels, function (i, label) {
                    if (label.toLowerCase() == seriesObj[i].mode.toLowerCase()) {
                        $(labelTextElm).appendTo(tooltip);
                        $('.perso-tooltip-label').last().html(seriesNamesForDisplay[i] + " " + seriesObj[i].label);
                    }
                })
            }
        },
        getSeriesHigherBar: function ($series) {
            if ($series) {
                var barsHeight = $($series).find('.perso-bar').map(function () {
                        return $(this).height();
                    }).get(),
                    maxHeight = Math.max.apply(null, barsHeight);
            }
            return (maxHeight ? maxHeight : 0);
        },

        getCollapsedFixedElement: function getCollapsedFixedElement(){
            return this.frameEl.find('.perso-month-picker-wrapper');
        },

        getCollapseParams: function getCollapseParams(){
            var params = Personetics.story.Block.prototype.getCollapseParams.call(this);
			return $.extend(params, {
                fixedContainer: this.getCollapsedFixedElement(),
                el: this.frameEl
            });
		},

        doScrollEvent: function (skipAnimation) {
            Personetics.story.Block.prototype.doScrollEvent.call(this, skipAnimation);
            if (this.isBlockPositionInViewport(this.frameEl)) {
                this.doAnimations();
            }

            if (this.supportBlockCollapse) {
                if (this.chartType == "vertical" || this.chartType == "multiVertical") {
                    var block = this;
                    var elementDisplayed = this.frameEl.find('.perso-month-picker-container');
                    block.collapseHelper.scrollEvent(block, elementDisplayed, skipAnimation);
                }
            }
        },
        
        getSupportBlockCollapse: function getSupportBlockCollapse(){
            return Personetics.projectConfiguration.getConfig("supportCollapse") == true && Personetics.projectConfiguration.getConfig("monthPickerCollapse") == true;
        },
        getBlockPercentInViewportToStartAnimate: function () {
            var type = Personetics.story.Block.prototype.getBlockPercentInViewportToStartAnimate.call(this);
            return type[this.chartType];
        },
        doAnimations: function () {
            var block = this;
            if (!block.isDraw) {
                var animationClass = (!block.isSeries && block.series[block.getDefaultIndex()].value < 0) ? 'perso-negative' : '';
                var animatedElm = this.frameEl.find('.perso-animated-bar');
                if (animatedElm.length) {
                    animatedElm.addClass('perso-filler-bar').addClass(animationClass);
                    block.amountAnimation($(block.frameEl.find('.perso-month-amount')));
                    block.isDraw = true;
                }
                if(this.benchmarkLines.length > 0){
                    var animationDuration = animatedElm.css('animation-duration');
                    var params = this.beforeRenderBenchmark();
                    setTimeout(function() {
                        block.renderBenchmark(params);
                    }, this.benchmarkConfig.benchmarkDrawDelay);
                }
            }
        },
        amountAnimation: function ($el) {
            var block = this;
            var amountElm = $el.find('.perso-int-num');
            var currencyElm = $el.find('.perso-currency');
            if (amountElm.length) {
                $(currencyElm).addClass('perso-fade-in');
                $(amountElm).addClass('perso-fade-in');
                $(amountElm).attr('Counter', 0).animate({
                    Counter: parseFloat($(amountElm).text().replace(/,/g, ''))
                }, {
                    duration: block.options.amountAnimationDuration,
                    easing: 'swing',
                    step: function (now) {
                        var amount = Math.ceil(now);
                        $(this).text(block.formatNumbers(amount));
                    }
                });
            }
        },
        formatNumbers: function (number) {
            var numberParts = number.toString().split('.');
            numberParts[0] = numberParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return numberParts.join(".");
        },

        setDefaultMonthPickerTab: function () {
            var defaultTabIndex = this.getDefaultIndex();
            this.changeSelectedTabAnimationMonthPicker(this.frameEl.find(".perso-month-picker-item")[defaultTabIndex]);
        },
        setMonthPickerTabWidth: function setMonthPickerTabWidth() {
            var monthPickerTabs = this.frameEl.find('.perso-month-picker-container .perso-month-picker-item');
            $(monthPickerTabs).css('width', 100 / this.layoutInstructions.categories.length + '%');
        },
        monthPickerItemClick: function monthPickerItemClick(e) {
            var target = e.currentTarget;
            var categoryNumber = $(target).attr("pstory-category");
            var otherButtons = this.frameEl.find('.perso-month-picker-item');
            otherButtons.removeClass('selected');
            this.changeSelectedTabAnimationMonthPicker(target);
            this.tabClickListener(categoryNumber);

            this.parent.notifyEvent(this, "setSelectedValue", categoryNumber);
            var params = {
                value: categoryNumber,
                type: this.layoutInstructions.type
            };
            this.notifyReportEvent(params);
        },
        changeSelectedTabAnimationMonthPicker: function changeSelectedTabAnimationMonthPicker(selected) {
            if (typeof selected === "undefined" || selected === null || selected.length == 0)
                return;
            var tabAnimatedBorder = this.frameEl.find(".pstory-month-picker-selected-tab");
            var left = $(selected).offset().left - parseInt(this.frameEl.find(".perso-month-picker-wrapper").css("padding-left"));
            var width = $(selected).innerWidth();
            $(selected).addClass('selected');
            $(selected).attr("aria-selected", "true");
            $(selected).siblings('.perso-month-picker-item').attr("aria-selected","false");
            this.updateSelectedAccText();
            tabAnimatedBorder.css({
                "left": left + 'px',
                width: width + 'px'
            });
        }

    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
	var d3 = Personetics.persoD3 || window.d3;
	Personetics.story = Personetics.story || {};
	Personetics.story.PinGraphChartBlock = Personetics.story.Block.extend({
        getHtmlTemplateId: function(clazz) {
            return "pure-pinGraph-chart";
        },
		beforeRender: function(el, layoutInstructions) {
            if(layoutInstructions) {
                Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
                this.series = layoutInstructions.series;
                this.categories = layoutInstructions.categories;
                this.chartType = layoutInstructions.type;
                this.maxValue = this.getMaxValue();
                this.options = this.story.uxCtrl.getHorizontalPinGraphChartOptions();
            }
		},
		render: function(el, layoutInstructions) {
            Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);
            var chartEl = this.frameEl.find(".pstory-pinGraph-chart");
            if (chartEl.length > 0) {
                this.renderPinChart(chartEl);
            }
		},
        renderPinChart: function(el){
            var self = this;
            var pinChartRaws = $(el).find('.perso-pinGraph-raw');
            var maxVal = Math.abs(self.maxValue);
            self.setContainerHeight(el);
            if(pinChartRaws.length){
                $.each(pinChartRaws, function (i, raw) {
                    $(raw).css('height','calc( 100% / '+ self.series.length+')');
                    self.setCategoryText(raw, i);
                    self.setBarWidthByValue(raw, i, maxVal);
                    self.setAmount(raw, i);
                })
            }
        },
        setCategoryText: function(el, index){
            var self = this;
            var categoryLabel = $(el).find('.perso-date-txt');
            if(categoryLabel.length){
                $(categoryLabel).text(self.categories[index]);
            }
        },
        setContainerHeight: function (el) {
            var self = this;
            if(el.length){
                var height = $(window).height() * this.options.pinChartHeight;//0.32 = 182 (sympli value) / 568 (window height)
                $(el).css('height',height);
            }
        },
        setBarWidthByValue: function(el, index, maxVal){
            var self = this;
            var pinchartBar = $(el).find('.perso-pinGraph-bar');
            var pinchartAmount = $(el).find('.perso-pinGraph-amount');
            var pinChartBarWrapper = $(el).find('.perso-bar-wrapper');
            if(pinchartBar.length){
                var calculatedWidth = Math.abs(self.series[index].value)/maxVal * this.options.maxWidthBarPercent;
                $(pinchartBar).css('width','calc( '+ calculatedWidth + '%)');
                $(pinchartBar).css('max-width','calc( '+ calculatedWidth + '%)');
                $(pinchartAmount).css('line-height',pinChartBarWrapper.height() + 'px')
            }
        },
        setAmount: function(el, index){
            var self = this;
            var amountLabel = $(el).find('.perso-pinGraph-amount');
            if(amountLabel.length){
                $(amountLabel).html(self.series[index].label);
            }
        },
        getMaxValue: function () {
            var self = this;
            var maxValue = Math.max.apply(Math, self.series.map(function (o) {
                return o.value;
            }));
            return maxValue;
        },
        afterRender: function (){
            if(this.isBlockPositionInViewport(this.frameEl)){
                this.doAnimations();
            }
            var pinGraphText = Personetics.dictionary.getText("accessibilityPinGraph");
            var highlightedText = Personetics.dictionary.getText("accessibilityHighlighted");
            Personetics.utils.accessibility.addAltTextToElement(this.frameEl, pinGraphText);
            this.frameEl.find('.perso-pinGraph-raw:last-child').append('<div class="perso-accessibility-read">. '+highlightedText+'</div>');
        },
        getBlockPercentInViewportToStartAnimate: function(){
            var type = Personetics.story.Block.prototype.getBlockPercentInViewportToStartAnimate.call(this);
            return type[this.chartType];
        },
        doAnimations: function () {
            var self = this;
            if(!self.isDraw){
                var raws = this.frameEl.find('.perso-pinGraph-container');
                if(raws.length){
                    raws.addClass('do-bar-animation');
                    raws.addClass('do-amount-animation');
                    self.isDraw = true;
                }
            }
        },
        doScrollEvent: function (skipAnimation) {
            Personetics.story.Block.prototype.doScrollEvent.call(this, skipAnimation);
            if(this.isBlockPositionInViewport(this.frameEl)){
               this.doAnimations();
            }
        },
	});
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.D3PinGraphChartBlock = Personetics.story.D3BarChartBlock.extend({
        beforeRender: function(el, layoutInstructions){
            Personetics.story.D3BarChartBlock.prototype.beforeRender.call(this, el, layoutInstructions);
            this.texts.accessibilityPinGraphTitle = Personetics.dictionary.getText("accessibilityPinGraphTitle");
        },
        getHtmlTemplateId: function(clazz) {
            return "pinGraph-chart";
        },
        render: function(el, layoutInstructions) {
            Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);

            var chartEl = this.frameEl.find(".pstory-pinGraph-chart");
            if (chartEl.length > 0) {
                this.renderBarChart(chartEl, layoutInstructions);
            }
        },
        renderBarChart: function(el,data) {
            if(typeof this.chartHelper.prepareChartData == "function"){
                this.layoutInstructions = this.chartHelper.prepareChartData(this.layoutInstructions, this.options);
            }
            this.chartHelper.prepareChart(this.layoutInstructions, this.options);
            this.chartHelper.renderChart(el);
        },
        beforeRenderChart: function(el, layoutInstructions){
            this.layoutInstructions.series = this.layoutInstructions.series[0];
            this.chartType = this.getChartType();
            this.chartTypeHelper = (this.chartType +"Helper");
            this.initChartHelper(this.chartTypeHelper);
            this.options = this.story.uxCtrl.getPinGraphChartOptions();
        },
        barsDirection: function barsDirection(){
            if(Personetics.processor.PStoryConfig.isRtl()){
               this.barsDirectionRTL();
            }    
        },

        getChartType: function(){
            var type = 'pinGraph';
            return type;
        },

        getAccessibilityTitle: function getAccessibilityTitle(){
            return this.texts.accessibilityPinGraphTitle;
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.DotsLineChartBlock = Personetics.story.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "line-chart";
        },

        beforeRender: function (el, layoutInstructions) {
            Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.texts = {
                accessibilityLineChartTitle: Personetics.dictionary.getText("accessibilityLineGraphTitle"),
                accessibilityLineGraphHighlightedDot: Personetics.dictionary.getText("accessibilityLineGraphHighlightedDot"),
            };
            this.beforeRenderChart();
        },

        beforeRenderChart: function () {
            this.chartType = 'lineChart';
            // if layoutInstructions.series contains a single series array, use the child array as the real series array
            if (this.layoutInstructions.series.length == 1 && $.isArray(this.layoutInstructions.series[0])) {
                this.layoutInstructions.series = this.layoutInstructions.series[0];
            }
            this.chartTypeHelper = this.chartType + "Helper";
            this.initChartHelper(this.chartTypeHelper);
        },

        render: function (el, layoutInstructions) {
            Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);
            var chartEl = this.frameEl.find('.pstory-line-chart');
            if (chartEl.length > 0) {
                var data = layoutInstructions;
                var el = chartEl;
                var options = this.initLineChartOptions();
                this.chartHelper.prepareChart(data, options);
                this.chartHelper.renderChart(el);
            }
        },
        afterRender: function (el) {
            Personetics.story.Block.prototype.afterRender.call(this, el);
            var $lineChartContainer = this.el.find('.pstory-line-chart');
            if($lineChartContainer.length) {
                this.chartHelper.renderAccessibilityData(this.frameEl,this.texts);
            }
            Personetics.utils.accessibility.trackFocus($lineChartContainer);
        },

        initLineChartOptions: function initLineChartOptions(){
            var ratio = 1.3;
            if($(window).width() > 470 && $(window).width() < 790) {
                this.el.find(".pstory-block-container").css("text-align","center");
                ratio = ratio + (($(window).width() / 414) - 1);
            }
            return this.story.uxCtrl.getDotsLineChartOptions(ratio);

        },

        initChartHelper: function(type){
            this.chartHelper = Personetics.story.BlockChartFactory.generateHelperClazz(type, this.story.cfg);
        },
        doScrollEvent: function (skipAnimation) {
            Personetics.story.Block.prototype.doScrollEvent.call(this, skipAnimation);
            if(this.isBlockPositionInViewport(this.frameEl)){
                if(typeof this.chartHelper.lineAnimations == 'function'){
                    this.chartHelper.lineAnimations();
                }
            }
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.PieChartBlock = Personetics.story.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "pie-chart";
        },
        beforeRender: function (el, layoutInstructions) {
            Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.options = this.story.uxCtrl.getPieOptions();
            this.setTotal(layoutInstructions);
            this.colors = d3.scale.ordinal().range(this.getGraphPalette());
            this.texts = {
                accessibilityPieTitle: Personetics.dictionary.getText("accessibilityPieTitle")
            };
            this.grayscaleId = "grayscale_" + +new Date();
            this.dropShadow = '';
            if (this.options.arcs.filter.dropShadow) {
                this.dropShadowId = "drop-shadow_" + +new Date();
                this.dropShadow = "url(#" + this.dropShadowId + ")";
            }
            this.isOldAndroidVersion = Personetics.utils.persoHelper.isOldAndroidVersion();
            this.layoutInstructions.slices = this.layoutInstructions.slices.sort(function (sliceA, sliceB) {
                return Math.abs(sliceB.value) - Math.abs(sliceA.value)
            });
        },
        /**pie beforeRender definations */
        setPieDefination: function () {
            var block = this;
            var normalizedValue = block.totalAmountInt * 0.05;
            var padAngle = 0.04;
            if (typeof block.options.arcs.padAngle != 'undefined') {
                padAngle = block.options.arcs.padAngle;
            }
            return d3.layout.pie()
                .padAngle(padAngle)
                .value(function (d) {
                    var value = Math.abs(d.value) + normalizedValue;
                    return value;
                });
        },
        sortPie: function (layoutInstructionsSlices) {
            layoutInstructionsSlices.sort(function (a, b) {
                return Math.abs(b.value) - Math.abs(a.value);
            });
            return layoutInstructionsSlices;
        },
        setTotal: function setTotal(layoutInstructions) {
            // get centerText from config, and split it by "<br>"
            var totalFromSrc = layoutInstructions.centerText;
            var totalFromSrcToArr = [];
            if (totalFromSrc) {
                totalFromSrcToArr = totalFromSrc.split(/<br>|<\/br>/);
            } else {
                Personetics.log("Center text is empty");
            }
            this.totalText = totalFromSrcToArr[0] ? totalFromSrcToArr[0] : '';
            this.totalAmount = totalFromSrcToArr[1] ? totalFromSrcToArr[1] : '';

            if (layoutInstructions.hasOwnProperty('slices') && layoutInstructions.slices.length > 0) {
                var totalAmountObj = layoutInstructions.slices.reduce(function (total, slice) {
                    return { value: Math.abs(total.value) + Math.abs(slice.value) };
                });
                this.totalAmountInt = totalAmountObj.value;
            }
            else {
                this.totalAmountInt = 0;
            }

        },
        getGraphPalette: function () {
            return this.story.uxCtrl.getPieGraphPalette();
        },

        /**render functions */
        render: function (el, layoutInstructions) {
            if (layoutInstructions.slices) {
                layoutInstructions.texts = this.texts;
                Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);
                this.frameEl = el.find('.pstory-block-frame').last();
                var chartEl = this.frameEl.find(".pstory-pie-chart");
                if (chartEl.length > 0) {
                    this.renderPieChart(chartEl, layoutInstructions);
                }
            }
            else {
                Personetics.log("PieChartBlock.render() Error: invalid slices property - not rendering");
            }
        },

        renderPieChart: function (el, layoutInstructions) {
            var block = this;
            layoutInstructions.slices = this.sortPie(layoutInstructions.slices);
            /** */
            d3.selection.prototype.moveToFront = function () {
                return this.each(function () {
                    var gparent = this.parentNode;
                    gparent.parentNode.appendChild(gparent);
                });
            };
            this.setPieSizeOnStart();
            this.defineArcs();
            this.renderPieBase(el);
            this.renderShadowFilter(block);//?? base or pie
            this.renderPie(el, layoutInstructions, block);
            if(!this.options.doAnimations){
                this.options.pieDelay = this.options.pieDelay = this.options.pieDuration = this.options.pieTextDelay = this.options.pieTextDuration = this.options.pieSelectedDelay = 0;
                this.pieAnimation();
            }

            this.renderAccessibilityData(el, layoutInstructions);

        },

        setPieSizeOnStart: function setPieSizeStart(){
            this.width = this.frameEl.find('.pstory-pie-chart').width();
            if(typeof this.maxWidth !== "undefined" && this.width > this.maxWidth){
                this.width = this.maxWidth;
            }
            this.height = this.width * 0.7;
            //set radius width depends on screen width
            this.innerRadius = 1;
            this.outerRadius = 1;
            this.innerRadiusOver = 1;
            this.outerRadiusOver = 1;
        },
        setPieSize: function setPieSize(width) {
            this.margin = { top: 0, right: 20, bottom: 0, left: 20 };
            this.width = width;
            this.height = this.width * 0.7;
            this.radius = this.width / 2.5;
            //set radius width depends on screen width
            this.innerRadius = this.radius - 26;
            this.outerRadius = this.radius - 36;
            this.innerRadiusOver = this.radius - 23;
            this.outerRadiusOver = this.radius - 43;
        },
        defineArcs: function defineArcs() {
            var block = this;
            this.arc = d3.svg.arc()
                .innerRadius(block.innerRadius)
                .outerRadius(block.outerRadius);

            this.arcOver = d3.svg.arc()
                .innerRadius(block.innerRadiusOver)
                .outerRadius(block.outerRadiusOver);
        },
        /**render svg base and base attributes */
        renderPieBase: function renderPieBase(el) {
            this.svg = this.renderPieSvgBase(el);
        },
        renderPieSvgBase: function (el) {
            var block = this;
            if (el) {
                return (d3.select(el.get(0)).append("svg")
                    .attr("width", block.width)
                    .attr("height", block.height)
                    .append("g")
                    .attr("transform", "translate(" + block.width / 2 + "," + block.height * 0.5+ ")"));

            }
        },
        /**render the pie */

        renderPie: function (el, layoutInstructions, block) {
            this.renderArcs(layoutInstructions);
            // this.renderTicks(block, layoutInstructions);
            // this.renderPieLabels(block, layoutInstructions);
            this.renderPieTitle(this.totalText);
            if (this.options.drawCenterLine == true) {
                this.renderLine();
            }
            this.renderPieAmount(this.totalAmount);

        },
        renderArcs: function (layoutInstructions) {
            var block = this;
            var arcs = block.svg.selectAll(".arc")
                .data(block.setPieDefination()(layoutInstructions.slices))
                .enter().append("g")
                .attr("class", "perso-arc")
                .attr("pstory-id", function (d) {
                    return d.data.category;
                });

            arcs.append("path")
                .attr("d", block.arc)
                .attr("class", function (d) {
                    var clazz = "";
                    if (d.data.highlight) {
                        clazz += "perso-selected";
                    }
                    return clazz;
                })
                .style("filter", function (d) {
                    if (d.data.highlight) {
                        if (block.options.arcs.filter.dropShadow) {
                            return "url(#" + block.options.arcs.filter.dropShadow.id + ")";
                        }
                        return "";
                    }
                })
                .style("fill", function (d, i) {
                    return block.colors(d.data.category);
                })
                .on("click", function (obj, clickedItemIndex) {
                    block.onPieItemClick(obj, clickedItemIndex, this);
                });
        },
        renderTicks: function (block, layoutInstructions) {
            if (block) {
                var ticks = block.svg.append('g')
                    .attr('class', 'perso-ticks')
                    .selectAll("line")
                    .data(block.setPieDefination()(layoutInstructions))
                    .enter().append("line");

                ticks.attr('class', 'perso-tick')
                    .attr("x1", 0)
                    .attr("x2", 0)
                    .attr("y1", -block.radius * .8)
                    .attr("y2", -block.radius * .9)
                    .attr("stroke", "gray")
                    .attr("transform", function (d) {
                        return "rotate(" + (d.startAngle + d.endAngle) / 2 * (180 / Math.PI) + ")";
                    });
            }
        },
        renderPieLabels: function (block, layoutInstructions) {
            if (block) {
                var labels = block.svg.append('g')
                    .attr('class', 'perso-pie-labels')
                    .attr("transform", "translate(8,0)")
                    .selectAll("text")
                    .data(block.setPieDefination()(layoutInstructions))
                    .enter().append("text");
                labels.attr("class", "perso-pie-label")
                    .attr("transform", function (d) {
                        var dist = block.radius + 20;
                        var angle = (d.startAngle + d.endAngle) / 2;
                        var x = dist * Math.sin(angle);
                        var y = -dist * Math.cos(angle);
                        return "translate(" + x + "," + y + ")";
                    })
                    .attr("dy", "-0.5em")
                    .attr("text-anchor", "middle")
                    .html(function (d) {
                        return d.data.category;
                    })
                    .call(block.wrapLabelText, $(window).width() * .28);
            }
        },
        renderPieTitle: function (totalText) {
            var block = this;
            var totaltxt_SpaceFromCenter = this.options.totaltxt_SpaceFromCenter || '-.3em';
            this.svg.append('text')
                .attr('class', 'perso-total-txt')
                //in order to enable animation for text and support also other elements that defined with "em"
                .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_total_font_size) + "px")
                .attr('dy', totaltxt_SpaceFromCenter)
                .html(totalText);
        },
        renderPieAmount: function (totalAmount) {
            var block = this;
            var totalAmount_SpaceFromCenter = this.options.totalAmount_SpaceFromCenter || '.9em';
            this.svg.append('text')
                .attr('class', 'perso-total-amount')
                //in order to enable animation for text and support also other elements that defined with "em"
                .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_anoumt_font_size) + "px")
                .attr('dy', totalAmount_SpaceFromCenter)
                .html(totalAmount);
        },

        renderLine: function () {
            var lineWidth = this.options.centerLineWidth || 0;
            this.svg.append('line')
                .attr('class', 'perso-centerLine')
                .attr('x1', lineWidth / 2 * -1)
                .attr('x2', lineWidth / 2)
        },
        pieAnimation: function pieAnimation(){
            if(!this.pieDrew){
                this.pieTransition();
                this.textTransition();
                this.pieDrew = true;
            }
        },
        pieTransition: function pieTransition(arcs){
            var block = this;
            this.setPieSize(this.frameEl.find('.pstory-pie-chart').width());
            this.defineArcs();
            this.svg.selectAll(".perso-arc path")
                .transition()
                .delay(block.options.pieDelay)
                .duration(block.options.pieDuration)
                .attr("d", block.arc)
        },
        textTransition: function textTransition(){
            var block = this;
            var pieTotalText = this.svg.select('.perso-total-txt');
            pieTotalText.style({"font-size": "0", "opacity": "1"})
            if(typeof pieTotalText!= 'undefined'){
                pieTotalText.transition()
                    .duration(this.options.pieTextDuration)
                    .delay(this.options.pieTextDelay)
                    .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_total_font_size) + "px")
            }
            var pieTotalAmount = this.svg.select('.perso-total-amount');
            pieTotalAmount.style({"font-size": "0", "opacity": "1"})
            if(typeof pieTotalAmount != 'undefined'){
                pieTotalAmount.transition()
                    .duration(this.options.pieTextDuration)
                    .delay(this.options.pieTextDelay)
                    .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_amount_font_size) + "px")
            }

        },
        renderAccessibilityData: function renderAccessibilityData(el) {
            var id = this.frameEl.parents(".pstory-dialog-frame").attr("id") + this.frameEl.index();
            var titleContent = this.texts.accessibilityPieTitle + '. ' + this.createDataString();
            var parentNode = this.svg.node().parentNode;
            d3.select(parentNode).append("title").attr("id", id + "_title").text(titleContent);
            d3.select(parentNode).attr("role", "presentation");
            this.svg.attr('aria-labelledby', id + '_title');
            this.svg.selectAll("*").attr('aria-hidden', true);
        },

        createDataString: function createDataString() {
            var dataElement = $("<span></span>");
            dataElement.append(this.totalText + ': ' + this.totalAmount + '.');
            return dataElement.text();
        },

        /**events functions */
        onPieItemClick: function (obj, clickedItemIndex, clickedItem) {
            var block = this;
            var prevIndex = this.getSelectedIndex();
            if(clickedItemIndex !== prevIndex){
                var prevPath = block.arcPaths[prevIndex];
                d3.select(prevIndex)
                    .attr("class", "perso-selected");
            }
            d3.select(clickedItem)
                .attr("class", "perso-selected");

            var pstoryLabels = this.frameEl.find('.pstory-pie-chart svg .perso-pie-label');
            if (typeof pstoryLabels != 'undefined' && pstoryLabels.length > clickedItemIndex) {
                var clickedArcLabel = pstoryLabels[clickedItemIndex];
                clickedArcLabel.className.baseVal = Personetics.utils.string.addClass(clickedArcLabel.className, 'selected');
            }
            this.handleClick(obj, clickedItemIndex);
        },

        renderShadowFilter: function (block) {
            var filter = block.options.arcs.filter.dropShadow;
            var svgWithFilters = block.svg;
            if (filter) {
                var defs = block.svg.append("defs");

                // create filter with id #drop-shadow
                // height=130% so that the shadow is not clipped
                var filterSvg = defs.append("filter")
                    .attr("id", this.dropShadowId)
                    .attr("height", "130%");

                // SourceAlpha refers to opacity of graphic that this filter will be applied to
                // convolve that with a Gaussian with standard deviation 3 and store result
                // in blur
                filterSvg.append("feGaussianBlur")
                    .attr("in", filter.in)//SourceAlpha
                    .attr("stdDeviation", filter.stdDeviation)
                    .attr("result", "blur");

                // translate output of Gaussian blur to the right and downwards with 2px
                // store result in offsetBlur
                filterSvg.append("feOffset")
                    .attr("in", "blur")
                    .attr("dx", filter.dxOffset)
                    .attr("dy", filter.dyOffset)
                    .attr("result", "offsetBlur");

                filterSvg.append("feFlood")
                    .attr("in", "offsetBlur")
                    .attr("flood-color", filter.color)//rgba(73, 73, 73, 0.35)
                    .attr("flood-opacity", "1")
                    .attr("result", "offsetColor");

                filterSvg.append("feComposite")
                    .attr("in", "offsetColor")
                    .attr("in2", "offsetBlur")
                    .attr("operator", "in")
                    .attr("result", "offsetBlur");


                // overlay original SourceGraphic over translated blurred opacity by using
                // feMerge filter. Order of specifying inputs is important!
                var feMerge = filterSvg.append("feMerge");

                feMerge.append("feMergeNode")
                    .attr("in", "offsetBlur")
                feMerge.append("feMergeNode")
                    .attr("in", filter.in);
            }
        },

        handleClick: function (obj, clickedItemIndex) {
            var dataObj = obj;
            if (dataObj.data) {
                dataObj = dataObj.data;
            }
            this.parent.notifyEvent(this, "setSelectedValue", dataObj.category);
            var params = {
                value: dataObj.category,
                type: this.layoutInstructions.type
            };
            this.notifyReportEvent(params);
            this.setSelectedIndex(clickedItemIndex);

        },

        // this function get svg path selected index
        getSelectedPathIndex: function (paths) {
            var selectedIndex = 0;
            var selectedCategory = this.frameEl.find('path.perso-selected').parent().attr('pstory-id');
            var selected = this.layoutInstructions.slices.filter(function (slice, i) {
                if (slice.category == selectedCategory) {
                    selectedIndex = i;
                    return true;
                }
            });
            return selectedIndex;
        },
        wrapLabelText: function (text, width) {
            text.each(function () {
                var text = d3.select(this),
                    words = text.text().split(/\s+/).reverse(),
                    word,
                    line = [],
                    lineNumber = 0,
                    lineHeight = .15, // ems the space between the lines.
                    y = text.attr("y"),
                    dy = parseFloat(text.attr("dy")),
                    tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
                while (word = words.pop()) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
                    }
                }
            });
        },
        doScrollEvent: function (skipAnimation) {
            Personetics.story.Block.prototype.doScrollEvent.call(this, skipAnimation);
            if(this.isBlockPositionInViewport(this.frameEl)){
                if(typeof this.pieAnimation == 'function'){
                    this.pieAnimation();
                }
            }
        },
        getSelectedIndex: function(){
            return this.index ? this.index : 0;
        },
        setSelectedIndex: function(indx){
            this.index = indx;
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.NewPieChartBlock = Personetics.story.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "pie-chart";
        },
        beforeRender: function (el, layoutInstructions) {
            Personetics.story.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.options = this.getPieOptions();
            this.setTotal(layoutInstructions);
            this.colors = d3.scale.ordinal().range(this.getGraphPalette());
            this.texts = {
                accessibilityPieTitle: Personetics.dictionary.getText("accessibilityPieTitle")
            };
            this.grayscaleId = "grayscale_" + +new Date();
            this.dropShadow = '';
            if (this.options.arcs.filter.dropShadow) {
                this.dropShadowId = "drop-shadow_" + +new Date();
                this.dropShadow = "url(#" + this.dropShadowId + ")";
            }
            this.isOldAndroidVersion = Personetics.utils.persoHelper.isOldAndroidVersion();
            this.layoutInstructions.slices = this.layoutInstructions.slices.sort(function (sliceA, sliceB) {
                return Math.abs(sliceB.value) - Math.abs(sliceA.value)
            });
        },
        getPieOptions: function(){
            return this.story.uxCtrl.getPieOptions();
        },
        /**pie beforeRender definations */
        setPieDefination: function () {
            var block = this;
            var normalizedValue = block.totalAmountInt * 0.05;
            var padAngle = 0.04;
            if (typeof block.options.arcs.padAngle != 'undefined') {
                padAngle = block.options.arcs.padAngle;
            }
            return d3.layout.pie()
                .padAngle(padAngle)
                .value(function (d) {
                    var value = Math.abs(d.value) + normalizedValue;
                    return value;
                });
        },
        sortPie: function (layoutInstructionsSlices) {
            layoutInstructionsSlices.sort(function (a, b) {
                return Math.abs(b.value) - Math.abs(a.value);
            });
            return layoutInstructionsSlices;
        },
        setTotal: function setTotal(layoutInstructions) {
            // get centerText from config, and split it by "<br>"
            var totalFromSrc = layoutInstructions.centerText;
            var totalFromSrcToArr = [];
            if (totalFromSrc) {
                totalFromSrcToArr = totalFromSrc.split(/<br>|<\/br>/);
            } else {
                Personetics.log("Center text is empty");
            }
            this.totalText = totalFromSrcToArr[0] ? totalFromSrcToArr[0] : '';
            this.totalAmount = totalFromSrcToArr[1] ? totalFromSrcToArr[1] : '';

            if (layoutInstructions.hasOwnProperty('slices') && layoutInstructions.slices.length > 0) {
                var totalAmountObj = layoutInstructions.slices.reduce(function (total, slice) {
                    return { value: Math.abs(total.value) + Math.abs(slice.value) };
                });
                this.totalAmountInt = totalAmountObj.value;
            }
            else {
                this.totalAmountInt = 0;
            }

        },
        getGraphPalette: function () {
            return this.story.uxCtrl.getPieGraphPalette();
        },

        /**render functions */
        render: function (el, layoutInstructions) {
            if (layoutInstructions.slices) {
                layoutInstructions.texts = this.texts;
                Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);
                this.frameEl = el.find('.pstory-block-frame').last();
                var chartEl = this.frameEl.find(".pstory-pie-chart");
                if (chartEl.length > 0) {
                    this.renderPieChart(chartEl, layoutInstructions);
                }
            }
            else {
                Personetics.log("PieChartBlock.render() Error: invalid slices property - not rendering");
            }
        },

        renderPieChart: function (el, layoutInstructions) {
            var block = this;
            layoutInstructions.slices = this.sortPie(layoutInstructions.slices);
            /** */
            d3.selection.prototype.moveToFront = function () {
                return this.each(function () {
                    var gparent = this.parentNode;
                    gparent.parentNode.appendChild(gparent);
                });
            };
            this.setPieSizeOnStart();
            this.defineArcs();
            this.renderPieBase(el);
            this.renderShadowFilter(block);//?? base or pie
            this.renderPie(el, layoutInstructions, block);
            if(!this.options.doAnimations){
                this.options.pieDelay = this.options.pieDelay = this.options.pieDuration = this.options.pieTextDelay = this.options.pieTextDuration = this.options.pieSelectedDelay = 0;
                this.pieAnimation();
            }

            this.renderAccessibilityData(el, layoutInstructions);

        },

        setPieSizeOnStart: function setPieSizeStart(){
            this.width = this.frameEl.find('.pstory-pie-chart').width();
            if(typeof this.maxWidth !== "undefined" && this.width > this.maxWidth){
                this.width = this.maxWidth;
            }
            this.height = this.width * 0.6;
            //set radius width depends on screen width
            this.innerRadius = 1;
            this.outerRadius = 1;
            this.innerRadiusOver = 1;
            this.outerRadiusOver = 1;
        },
        setPieSize: function setPieSize(width) {
            this.margin = { top: 0, right: 20, bottom: 0, left: 20 };
            this.width = width;
            this.height = this.width * 0.6;
            this.radius = this.width / 4.3;
            //set radius width depends on screen width
            this.innerRadius = this.radius;
            this.outerRadius = this.radius - 26;
            this.innerRadiusOver = this.radius + 2;
            this.outerRadiusOver = this.radius - 28;
        },
        defineArcs: function defineArcs() {
            var block = this;
            this.arc = d3.svg.arc()
                .innerRadius(block.innerRadius)
                .outerRadius(block.outerRadius);

            this.arcOver = d3.svg.arc()
                .innerRadius(block.innerRadiusOver)
                .outerRadius(block.outerRadiusOver);
        },
        /**render svg base and base attributes */
        renderPieBase: function renderPieBase(el) {
            this.svg = this.renderPieSvgBase(el);
        },
        renderPieSvgBase: function (el) {
            var block = this;
            if (el) {
                return (d3.select(el.get(0)).append("svg")
                    .attr("width", block.width)
                    .attr("height", block.height)
                    .append("g")
                    .attr("transform", "translate(" + block.width / 2 + "," + block.height * 0.5+ ")"));

            }
        },
        /**render the pie */

        renderPie: function (el, layoutInstructions, block) {
            this.renderArcs(layoutInstructions);
            // this.renderTicks(block, layoutInstructions);
            // this.renderPieLabels(block, layoutInstructions);
            this.renderPieTitle(this.totalText);
            if (this.options.drawCenterLine == true) {
                this.renderLine();
            }
            this.renderPieAmount(this.totalAmount);

        },
        renderArcs: function (layoutInstructions) {
            var block = this;
            // var radius = Math.min(block.width, block.height) / 2;
            // d3.svg.arc()
            //     .outerRadius(radius - 50)
            //     .innerRadius(50);
            var arcs = block.svg.selectAll(".arc")
                .data(block.setPieDefination()(layoutInstructions.slices))
                .enter().append("g")
                .attr("class", "perso-arc")
                .attr("pstory-id", function (d) {
                    return d.data.category;
                });

            arcs.append("path")
                .attr("d", block.arc)
                .attr("class", function (d) {
                    var clazz = "";
                    if (d.data.highlight) {
                        clazz += "perso-selected";
                    }
                    return clazz;
                })
                .style("filter", function (d) {
                    if (d.data.highlight) {
                        if (block.options.arcs.filter.dropShadow) {
                            return "url(#" + block.options.arcs.filter.dropShadow.id + ")";
                        }
                        return "";
                    }
                })
                .style("fill", function (d, i) {
                    return block.colors(d.data.category);
                })
                .on("click", function (obj, clickedItemIndex) {
                    block.onPieItemClick(obj, clickedItemIndex, this);
                });
        },
        renderTicks: function (block, layoutInstructions) {
            if (block) {
                var ticks = block.svg.append('g')
                    .attr('class', 'perso-ticks')
                    .selectAll("line")
                    .data(block.setPieDefination()(layoutInstructions))
                    .enter().append("line");

                ticks.attr('class', 'perso-tick')
                    .attr("x1", 0)
                    .attr("x2", 0)
                    .attr("y1", -block.radius * .8)
                    .attr("y2", -block.radius * .9)
                    .attr("stroke", "gray")
                    .attr("transform", function (d) {
                        return "rotate(" + (d.startAngle + d.endAngle) / 2 * (180 / Math.PI) + ")";
                    });
            }
        },
        renderPieLabels: function (block, layoutInstructions) {
            if (block) {
                var labels = block.svg.append('g')
                    .attr('class', 'perso-pie-labels')
                    .attr("transform", "translate(8,0)")
                    .selectAll("text")
                    .data(block.setPieDefination()(layoutInstructions))
                    .enter().append("text");
                labels.attr("class", "perso-pie-label")
                    .attr("transform", function (d) {
                        var dist = block.radius + 20;
                        var angle = (d.startAngle + d.endAngle) / 2;
                        var x = dist * Math.sin(angle);
                        var y = -dist * Math.cos(angle);
                        return "translate(" + x + "," + y + ")";
                    })
                    .attr("dy", "-0.5em")
                    .attr("text-anchor", "middle")
                    .html(function (d) {
                        return d.data.category;
                    })
                    .call(block.wrapLabelText, $(window).width() * .28);
            }
        },
        renderPieTitle: function (totalText) {
            var block = this;
            var totaltxt_SpaceFromCenter = this.options.totaltxt_SpaceFromCenter || '-.3em';
            this.svg.append('text')
                .attr('class', 'perso-total-txt')
                //in order to enable animation for text and support also other elements that defined with "em"
                .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_total_font_size) + "px")
                .attr('dy', totaltxt_SpaceFromCenter)
                .html(totalText);
        },
        renderPieAmount: function (totalAmount) {
            var block = this;
            var totalAmount_SpaceFromCenter = this.options.totalAmount_SpaceFromCenter || '.9em';
            this.svg.append('text')
                .attr('class', 'perso-total-amount')
                //in order to enable animation for text and support also other elements that defined with "em"
                .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_anoumt_font_size) + "px")
                .attr('dy', totalAmount_SpaceFromCenter)
                .html(totalAmount);
        },

        renderLine: function () {
            var lineWidth = this.options.centerLineWidth || 0;
            this.svg.append('line')
                .attr('class', 'perso-centerLine')
                .attr('x1', lineWidth / 2 * -1)
                .attr('x2', lineWidth / 2)
        },
        pieAnimation: function pieAnimation(){
            if(!this.pieDrew){
                this.pieTransition();
                this.textTransition();
                this.pieDrew = true;
            }
        },
        pieTransition: function pieTransition(arcs){
            var block = this;
            this.setPieSize(this.frameEl.find('.pstory-pie-chart').width());
            this.defineArcs();
            this.svg.selectAll(".perso-arc path")
                .transition()
                .delay(block.options.pieDelay)
                .duration(block.options.pieDuration)
                .attr("d", block.arc)
        },
        textTransition: function textTransition(){
            var block = this;
            var pieTotalText = this.svg.select('.perso-total-txt');
            pieTotalText.style({"font-size": "0", "opacity": "1"})
            if(typeof pieTotalText!= 'undefined'){
                pieTotalText.transition()
                    .duration(this.options.pieTextDuration)
                    .delay(this.options.pieTextDelay)
                    .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_total_font_size) + "px")
            }
            var pieTotalAmount = this.svg.select('.perso-total-amount');
            pieTotalAmount.style({"font-size": "0", "opacity": "1"})
            if(typeof pieTotalAmount != 'undefined'){
                pieTotalAmount.transition()
                    .duration(this.options.pieTextDuration)
                    .delay(this.options.pieTextDelay)
                    .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_amount_font_size) + "px")
            }

        },
        renderAccessibilityData: function renderAccessibilityData(el) {
            var id = this.frameEl.parents(".pstory-dialog-frame").attr("id") + this.frameEl.index();
            var titleContent = this.texts.accessibilityPieTitle + '. ' + this.createDataString();
            var parentNode = this.svg.node().parentNode;
            d3.select(parentNode).append("title").attr("id", id + "_title").text(titleContent);
            d3.select(parentNode).attr("role", "presentation");
            this.svg.attr('aria-labelledby', id + '_title');
            this.svg.selectAll("*").attr('aria-hidden', true);
        },

        createDataString: function createDataString() {
            var dataElement = $("<span></span>");
            dataElement.append(this.totalText + ': ' + this.totalAmount + '.');
            return dataElement.text();
        },

        /**events functions */
        onPieItemClick: function (obj, clickedItemIndex, clickedItem) {
            var block = this;
            var prevIndex = this.getSelectedIndex();
            if(clickedItemIndex !== prevIndex){
                var prevPath = block.arcPaths[prevIndex];
                d3.select(prevIndex)
                    .attr("class", "perso-selected");
            }
            d3.select(clickedItem)
                .attr("class", "perso-selected");

            var pstoryLabels = this.frameEl.find('.pstory-pie-chart svg .perso-pie-label');
            if (typeof pstoryLabels != 'undefined' && pstoryLabels.length > clickedItemIndex) {
                var clickedArcLabel = pstoryLabels[clickedItemIndex];
                clickedArcLabel.className.baseVal = Personetics.utils.string.addClass(clickedArcLabel.className, 'selected');
            }
            this.handleClick(obj, clickedItemIndex);
        },

        renderShadowFilter: function (block) {
            var filter = block.options.arcs.filter.dropShadow;
            var svgWithFilters = block.svg;
            if (filter) {
                var defs = block.svg.append("defs");

                // create filter with id #drop-shadow
                // height=130% so that the shadow is not clipped
                var filterSvg = defs.append("filter")
                    .attr("id", this.dropShadowId)
                    .attr("height", "130%");

                // SourceAlpha refers to opacity of graphic that this filter will be applied to
                // convolve that with a Gaussian with standard deviation 3 and store result
                // in blur
                filterSvg.append("feGaussianBlur")
                    .attr("in", filter.in)//SourceAlpha
                    .attr("stdDeviation", filter.stdDeviation)
                    .attr("result", "blur");

                // translate output of Gaussian blur to the right and downwards with 2px
                // store result in offsetBlur
                filterSvg.append("feOffset")
                    .attr("in", "blur")
                    .attr("dx", filter.dxOffset)
                    .attr("dy", filter.dyOffset)
                    .attr("result", "offsetBlur");

                filterSvg.append("feFlood")
                    .attr("in", "offsetBlur")
                    .attr("flood-color", filter.color)//rgba(73, 73, 73, 0.35)
                    .attr("flood-opacity", "1")
                    .attr("result", "offsetColor");

                filterSvg.append("feComposite")
                    .attr("in", "offsetColor")
                    .attr("in2", "offsetBlur")
                    .attr("operator", "in")
                    .attr("result", "offsetBlur");


                // overlay original SourceGraphic over translated blurred opacity by using
                // feMerge filter. Order of specifying inputs is important!
                var feMerge = filterSvg.append("feMerge");

                feMerge.append("feMergeNode")
                    .attr("in", "offsetBlur")
                feMerge.append("feMergeNode")
                    .attr("in", filter.in);
            }
        },

        handleClick: function (obj, clickedItemIndex) {
            var dataObj = obj;
            if (dataObj.data) {
                dataObj = dataObj.data;
            }
            this.parent.notifyEvent(this, "setSelectedValue", dataObj.category);
            var params = {
                value: dataObj.category,
                type: this.layoutInstructions.type
            };
            this.notifyReportEvent(params);
            this.setSelectedIndex(clickedItemIndex);

        },

        // this function get svg path selected index
        getSelectedPathIndex: function (paths) {
            var selectedIndex = 0;
            var selectedCategory = this.frameEl.find('path.perso-selected').parent().attr('pstory-id');
            var selected = this.layoutInstructions.slices.filter(function (slice, i) {
                if (slice.category == selectedCategory) {
                    selectedIndex = i;
                    return true;
                }
            });
            return selectedIndex;
        },
        wrapLabelText: function (text, width) {
            text.each(function () {
                var text = d3.select(this),
                    words = text.text().split(/\s+/).reverse(),
                    word,
                    line = [],
                    lineNumber = 0,
                    lineHeight = .15, // ems the space between the lines.
                    y = text.attr("y"),
                    dy = parseFloat(text.attr("dy")),
                    tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
                while (word = words.pop()) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
                    }
                }
            });
        },
        doScrollEvent: function (skipAnimation) {
            Personetics.story.Block.prototype.doScrollEvent.call(this, skipAnimation);
            if(this.isBlockPositionInViewport(this.frameEl)){
                if(typeof this.pieAnimation == 'function'){
                    this.pieAnimation();
                }
            }
        },
        getSelectedIndex: function(){
            return this.index ? this.index : 0;
        },
        setSelectedIndex: function(indx){
            this.index = indx;
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
	var d3 = Personetics.persoD3 || window.d3;
	Personetics.story = Personetics.story || {};
	Personetics.story.WidePieChartBlock = Personetics.story.Block.extend({
		getHtmlTemplateId: function(clazz) {
			return "pie-chart";
		},
		beforeRender: function(el) {
			var block = this;
			var cfg = block.config;

			block.margin = {
				top: 10,
				right: 10,
				bottom: 10,
				left: 10
			};
			block.width = (el.width() - block.margin.left - block.margin.right);
			block.height = block.width / 2;
			block.radius = block.width / 3;

			block.xFieldExp = new Personetics.processor.PExp(cfg.x);
			var yExp = block.yFieldExp = new Personetics.processor.PExp(cfg.y);

			block.xScale = d3.scale.ordinal().rangeRoundBands([0, block.width], .1);

			block.yScale = d3.scale.linear().range([block.height, 0]);

			block.xAxis = d3.svg.axis()
				.scale(block.xScale)
				.orient("bottom");

			var deg = (Math.PI/180);
			block.pie = d3.layout.pie()
				.sort(null)
				.startAngle(-90 * deg)
				.endAngle(90 * deg)
				.value(function(d) {
					return yExp.eval(d);
				});

			// this.legendRectSize = 18;
			// this.legendSpacing = 4;
			// this.legendNumColumns = 1;
		},
		render: function(el) {
			this.el = el;
			var data = this.story.model.fetchFromSrc(this,this.config.src);
			if (!data)
				return;

			if (data !== Personetics.processor.Future)
				data = data.getObjArray();

			var html = this.template(data);
			el.append(html);
			var chartEl = el.find(".pstory-pie-chart");
			if (chartEl.length > 0) {
				this.renderPieChart(chartEl,data);
			}
		},
		afterRenderPieChart: function(el, data) {
			var block = this;
			var cfg = block.config;

			var xScale = block.xScale;
			var yScale = block.yScale;

			var xExp = block.xFieldExp;
			var yExp = block.yFieldExp;

			xScale.domain(data.map(function(d) { return xExp.eval(d); }));
			yScale.domain([0, d3.max(data, function(d) { return yExp.eval(d); })]);

			// var ledgendHieght = xScale.domain().length * (block.legendRectSize + block.legendSpacing);
			// ledgendHieght /= block.legendNumColumns;
			// block.legendSpacing += block.legendSpacing;

			block.svg = d3.select(el.get(0)).append("svg")
				.attr("width", block.width + block.margin.left + block.margin.right)
				.attr("height", block.height + block.margin.top + block.margin.bottom)
				.append("g")
				.attr("transform", "translate(" + (block.width / 2 + block.margin.left) + "," + (block.height + block.margin.top) + ")");

			var colors = this.getGraphPalette();
			var color = xScale.range(colors);

			var arc = d3.svg.arc()
				.outerRadius(this.radius )
				.innerRadius(this.radius * 0.5);

			var deg = (Math.PI/180);
			var pie = d3.layout.pie()
				.sort(null)
				.value(function(d) { return yExp.eval(d); })
				.startAngle(-90 * deg)
				.endAngle(90 * deg);

			var svg = block.svg;

			var g = svg.selectAll(".arc")
				.data(pie(data))
				.enter().append("g")
				.attr("class", "arc");

			g.append("path")
				.attr("d", arc)
				.style("fill", function(d) { return color(xExp.eval(d.data)); });

			// this.appendLedgend();

			var labels = true;
			if (labels) {
				var labelRadius = 230;
				g.append("text")
					.attr("x", function (d, i) {
						var centroid = arc.centroid(d);
						var midAngle = Math.atan2(centroid[1], centroid[0]);
						var x = Math.cos(midAngle) * labelRadius;
						var sign = (x > 0) ? 1 : -1;
						var labelX = x + (5 * sign);
						return labelX;
					})
					.attr("y", function (d, i) {
						var centroid = arc.centroid(d);
						var midAngle = Math.atan2(centroid[1], centroid[0]);
						var y = Math.sin(midAngle) * labelRadius;
						return y;
					})
					.attr('text-anchor', function (d, i) {
						var centroid = arc.centroid(d);
						var midAngle = Math.atan2(centroid[1], centroid[0]);
						var x = Math.cos(midAngle) * labelRadius;
						return (x > 0) ? "start" : "end";
					})


				// .attr("transform", function(d) { return "translate(" + arc.centroid(d) + ")"; })
				// .attr("dy", "-5.35em")
				.text(function(d) {
					var txt = xExp.eval(d.data);
					return txt;
				});

				g.append("line").attr({
					stroke: "black",
					"stroke-width": 1,
					x1: function (d, i) {
						return arc.centroid(d)[0];
					},
					y1: function (d, i) {
						return arc.centroid(d)[1];
					},
					x2: function (d, i) {
						var centroid = arc.centroid(d);
						var midAngle = Math.atan2(centroid[1], centroid[0]);
						var x = Math.cos(midAngle) * labelRadius;
						return x;
					},
					y2: function (d, i) {
						var centroid = arc.centroid(d);
						var midAngle = Math.atan2(centroid[1], centroid[0]);
						var y = Math.sin(midAngle) * labelRadius;
						return y;
					},
					'class': "label-line"
				});
			}
		},
		getGraphPalette: function() {
			return this.story.uxCtrl.getPieGraphPalette();
		},
		handleClick: function(obj) {
			if (!this.config.var || !this.config.varSource)
				return;

			this.setValue(obj[this.config.varSource]);
			this.story.fireEvent(this);
		}
	});
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
	Personetics.story = Personetics.story || {};
	Personetics.story.MapBlock = Personetics.story.Block.extend({
		getHtmlTemplateId: function(clazz) {
			return "map"
		},
		render: function(el, layoutInstructions) {

			Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);

			this.mapEl = this.frameEl.find(".pstory-map-frame");

			var mapOptions = {
				scrollwheel: false,
				navigationControl: false,
				mapTypeControl: false,
				scaleControl: false,
				draggable: false,
				zoom: 15,
				center: new google.maps.LatLng(40.7097798, -73.9624878),
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};

			var mapCanvas = document.createElement("div");
			mapCanvas.id = "map-canvas";
			mapCanvas.style.width = "100%";
			mapCanvas.style.height = "100%";
			this.mapEl.append(mapCanvas);
			this.map = new google.maps.Map(mapCanvas, mapOptions);
		}
	});
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};

    Personetics.story.PBlockSessionManager = Base.extend({
        initialize: function(story){
            this.story = story;
            this.blockProcessorManager = PBlockProcessorManager.getInstance();

            var customizationOptions = story.options;

            var options  = {
                story: story.storyDef,
                texts: story.texts,
                externalParams: story.cfg.params,
                facts: story.cfg.data || story.cfg.insightFacts,
                expressions: story.expressions,
                customizationOptions: customizationOptions
            }

            this.blockProcessorManager.start(options);
            this.dialogsToBlocksMap = {};

            this.processedData = [];
        },

        reset: function(){
            this.processedData = [];
        },

        resetDialog: function(dlgId){
            if(this.dialogsToBlocksMap.hasOwnProperty(dlgId))
                this.dialogsToBlocksMap[dlgId] = [];
        },

        startBlock: function(dlgId, texts, config, index){
            if(!this.dialogsToBlocksMap.hasOwnProperty(dlgId))
                this.dialogsToBlocksMap[dlgId] = [];

            var layoutInstructions = this.blockProcessorManager.processBlockConfig(dlgId, index);
            var renderer = Personetics.story.PBlockFactory.createBlock(this, layoutInstructions, this.story);

            var block = {
                dlgId: dlgId,
                config: config,
                layoutInstructions: layoutInstructions,
                renderer: renderer
            };
            this.dialogsToBlocksMap[dlgId].push(block);

            renderer.initBlock();
        },

        renderBlocks: function(dlgId, el, isFirstDialogs){
            if(this.dialogsToBlocksMap.hasOwnProperty(dlgId)) {

                var me = this;
                var primaryButton = true;
                $.each(this.dialogsToBlocksMap[dlgId], function (index, block) {
                    if(block.config.type === "buttons") {
                        if (primaryButton) {
                            primaryButton = false;
                        }
                        else {
                            block.layoutInstructions.class = block.layoutInstructions.class + " perso-secondary";
                        }
                    }
                    var renderer = block.renderer;
                    var layoutInstructions = block.layoutInstructions;

                    if(isFirstDialogs && index == 0)
                        renderer.setIsFirstBlock(true);

                    me.processedData.push(layoutInstructions);

                    renderer.beforeRender(el, layoutInstructions);
                    renderer.render(el, layoutInstructions);
                    renderer.afterRender(el);
                    renderer.bindEvents();
                });
                if(!primaryButton){
                    var maxWidth = 0;
                    var buttons = el.find(".pstory-block-buttons-navigateTo");
                    buttons.each(function(){
                        maxWidth = Math.max(maxWidth, $(this).find("a").outerWidth());
                    });
                    buttons.each(function(){
                       $(this).find("a").width(maxWidth);
                    });
                }
                if (window.setProcessorData)
                    window.setProcessorData(this.processedData);
            }
            else {
                throw "Invalid dialog id '" + dlgId + "'"
            }
        },

        findBlock: function (options) {
            var rendererObj = options.rendererObj;
            // var processorObj = options.processorObj;
            // var objProp = rendererObj ? "renderer" : processorObj ? "processor" : null;
            // var obj = rendererObj || processorObj || null;
            var result = null;

            // if(obj && objProp) {

            $.each(this.dialogsToBlocksMap, function (dlgId, blocks) {
                $.each(blocks, function (index, block) {
                    var currObj = block.renderer;
                    if (rendererObj == currObj) {
                        result = block;
                        return false;
                    }
                });
                if (result)
                    return false;
            });
            // }

            return result;
        },

        notifyEvent: function (renderer, eventName, params) {
            switch (eventName) {
                case "doNavigateToPage":
                    this.doNavigateToPage(params);
                    break;
                case "setSelectedValue":
                    this.setSelectedValue(renderer, params);
                    break;
                case "actionEvent":
                    this.actionEvent(renderer, params);
            }
        },

        setSelectedValue: function (renderer, value) {
            var block = this.findBlock({ rendererObj: renderer });
            // var processor = block.processor;
            //
            // var realValue = processor.getRealValue(value);
            // this.setBlockVarValue(block.config, block.dlgId, realValue);
            // processor.setSelectedValue(realValue);

            this.blockProcessorManager.setBlockVarValue(block.config, value);

            this.story.fireEvent(block);
        },

        doNavigateToPage: function (params) {
            var bridge = personetics.getJSBridge();
            if (bridge && ($.isFunction(bridge.navigateToPage)))
                bridge.navigateToPage(params);
            else
                Personetics.log("Events Delegate not defined");
        },

        actionEvent: function actionEvent (renderer, params){
            var action = this.blockProcessorManager.getAction(params.actionId);
            delete action.actionId;
            this.widgetEvent(renderer, action);
        },

        widgetEvent: function widgetEvent(renderer, params){
            var bridge = personetics.getJSBridge();
            if (bridge && ($.isFunction(bridge.widgetEvent)))
                bridge.widgetEvent(renderer, params);
            else
                Personetics.log("Events Delegate not defined");
        },

        setVisible: function (dlgId, visible) {
            if (this.dialogsToBlocksMap.hasOwnProperty(dlgId)) {
                $.each(this.dialogsToBlocksMap[dlgId], function (index, block) {
                    block.renderer.setVisible(visible);
                });
            }
        },

        resetVariables: function (block) {
            this.blockProcessorManager.resetVariables(block)
        },

        getModel: function getModel() {
            return this.blockProcessorManager.getModel();
        },

        handleEvent: function handleEvent(eventType /*arguments*/) {
            var args = arguments;
            $.each(this.dialogsToBlocksMap, function (dialogId, dialog) {
                $.each(dialog, function (index, block) {
                    block.renderer.handleEvent(args);
                });
            });
        }
    });

})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
	Personetics.story = Personetics.story || {};
	Personetics.story.PSkinControler = Base.extend({
		initialize: function() {
		},
		setStory: function(story) {
			this.story = story;
		},

		registerWidgets: function(){
			this.registerDefaultWidgets();
		},

		registerBlocks: function() {
			this.registerDefaultBlocks();
			this.registerDefaultChartHeplers();
		},
		getTablesFormat: function(){
			return Personetics.story.getTablesFormat();
		},
		afterRender: function(dlg,callback) {
			if(dlg.shouldShow()) {
				dlg.el.css({opacity: 0.0, visibility: "visible"});
				dlg.el.fadeTo(0, 1);
			}

			//dlg.afterRender(null);
			if(callback)
				callback();
		},
		beforeRender:function(dlg,callback){
			callback();
		},
		registerBlock: function(type, config) {
			Personetics.story.PBlockFactory.registerBlock(type,config);
		},
		registerChartHelper: function (name, clazz){
			Personetics.story.BlockChartFactory.registerChartHelper(name, clazz);
		},
		getAccountSelectorPalette: function(){
			return ['darkBlue','turquoise','grey','red','lightBlue','orange'];
		},
		getGraphPalette: function() {
			return ['#5D68C2','#3B49B6','#1729AF','#111F88','#08176C'];
		},
		getColumnGraphPalette: function() {
			return ['#5D68C2','#3B49B6','#1729AF','#111F88','#08176C'];
		},
		getBarGraphPalette: function() {
			return ['#5D68C2','#3B49B6','#1729AF','#111F88','#08176C'];
		},
		getPieGraphPalette: function(){
			return ['#5D68C2','#3B49B6','#1729AF','#111F88','#08176C'];
		},
		getBarChartMultiSeriesLabels : function(labels){
			return function(){
				if(labels && labels.length > 0) {
					var label = labels[this.series.index];
					return ("<span class='" + this.series.name + "'>" + label + "</span>");
				}
				else{
					return "";
				}
			}
		},
		/**register blocks, chart helpers and widgets */
		registerDefaultBlocks: function(type) {
			this.registerBlock("txt", {
				blockClass: Personetics.story.TextBlock
			});
			this.registerBlock("text", {
				blockClass: Personetics.story.TextBlock
			});
			this.registerBlock("date-box", {
				blockClass: Personetics.story.DateBoxBlock
			});
			this.registerBlock("image", {
				blockClass: Personetics.story.ImageBlock
			});
			this.registerBlock("textboxes", {
				blockClass: Personetics.story.TextBoxes
			});
			this.registerBlock("compare-block", {
				blockClass: Personetics.story.CompareBlock
			});
			this.registerBlock("buttons", {
				blockClass: Personetics.story.ButtonsBlock
			});
			this.registerBlock("account-selector", {
				blockClass: Personetics.story.AccountSelectorBlock
			});
            this.registerBlock("entity-selector", {
                blockClass: Personetics.story.EntitySelectorBlock
            });
			this.registerBlock("tabs", {
				blockClass: Personetics.story.TabsBlock
			});
			this.registerBlock("selectOne", {
				blockClass: Personetics.story.SelectOneBlock
			});
			this.registerBlock("external-links", {
				blockClass: Personetics.story.ButtonsBlock
			});
			this.registerBlock("tranList", {
				blockClass: Personetics.story.TableBlock
			});
			this.registerBlock("table", {
				blockClass: Personetics.story.TableBlock
			});
			this.registerBlock("bar-chart",{
				blockClass: Personetics.story.D3BarChartBlock
			});
			this.registerBlock("line-chart",{
				blockClass: Personetics.story.DotsLineChartBlock
			});
			this.registerBlock("bar-chart",{
				blockClass: Personetics.story.BarChartBlock
			});
			this.registerBlock("bar-chart",{
				blockClass: Personetics.story.BarCharHighchartstBlock,
				class: "highcharts"
			});
			this.registerBlock("pie-chart", {
				blockClass: Personetics.story.PieChartBlock
			});
            this.registerBlock("arc-chart", {
                blockClass: Personetics.story.PieChartBlock
            });
			this.registerBlock("pie-chart", {
				blockClass: Personetics.story.PieChartBlock,
				widthMode: "small"
			});
			this.registerBlock("pie-chart",{
				blockClass: Personetics.story.WidePieChartBlock,
				widthMode: "wide"
			});
			this.registerBlock("pie-chart",{
				blockClass: Personetics.story.PieChartHighchartsBlock,
				class: "highcharts"
			});
			this.registerBlock("spline-chart",{
				blockClass: Personetics.story.SplineCharHighchartstBlock,
				class: "highcharts"
			});
		    this.registerBlock("pinGraph-chart",{
				blockClass: Personetics.story.PinGraphChartBlock
			});
			this.registerBlock("map",{
				blockClass: Personetics.story.MapBlock
			});
			this.registerBlock("pin-graph",{
				blockClass: Personetics.story.D3PinGraphChartBlock
			});
            this.registerBlock("pin-chart",{
                blockClass: Personetics.story.D3PinGraphChartBlock
            });
			this.registerBlock("h-box",{
				blockClass: Personetics.story.HBoxBlock
			});
		},
		registerDefaultChartHeplers: function () {
			this.registerChartHelper("verticalHelper", {
				helperClass:Personetics.utils.d3Helpers.VerticalChartHelper
			});
			this.registerChartHelper("horizontalHelper", {
				helperClass:Personetics.utils.d3Helpers.HorizontalChartHelper
			});
			this.registerChartHelper("multiVerticalHelper", {
				helperClass:Personetics.utils.d3Helpers.MultiVerticalChartHelper
			});
			this.registerChartHelper("multiHorizontalHelper", {
				helperClass:Personetics.utils.d3Helpers.MultiHorizontalChartHelper
			});
			this.registerChartHelper("pinGraphHelper", {
				helperClass:Personetics.utils.d3Helpers.PinGraphChartHelper
			});
			this.registerChartHelper("lineChartHelper", {
				helperClass:Personetics.utils.d3Helpers.LineChartHelper
			});
		},
		registerDefaultWidgets: function(){
			Personetics.UI.PWidgetFactory.registerWidget("app-ctrl", {
				widgetClass: Personetics.UI.PAppCtrl,
				widgetName: "Base app ctrl"
			});
			Personetics.UI.PWidgetFactory.registerWidget("master", {
                widgetClass: Personetics.UI.PAppCtrl,
                widgetName: "Base master"
            });
			Personetics.UI.PWidgetFactory.registerWidget("insights", {
                widgetClass: Personetics.story.PInsighsCtrl,
                widgetName: "Base insights"
            });

			Personetics.UI.PWidgetFactory.registerWidget("insights-overlay", {
                widgetClass: Personetics.story.PInsighsOverlayCtrl,
                widgetName: "Base insights overlay"
            });

			Personetics.UI.PWidgetFactory.registerWidget("inbox", {
                widgetClass: Personetics.story.PInboxCtrl,
                widgetName: "Base inbox"
            });

			Personetics.UI.PWidgetFactory.registerWidget("management", {
                widgetClass: Personetics.UI.PManagementCtrl,
                widgetName: "Base management"
            });

			Personetics.UI.PWidgetFactory.registerWidget("ratings", {
                widgetClass: Personetics.UI.PRatingCtrl,
                widgetName: "Base ratings"
            });

			Personetics.UI.PWidgetFactory.registerWidget("story-widget", {
                widgetClass: Personetics.UI.PStoryWidgetCtrl,
                widgetName: "Base story widget"
            });

			Personetics.UI.PWidgetFactory.registerWidget("loading-animation", {
                widgetClass: Personetics.UI.PLoadingAnimationCtrl,
                widgetName: "Base loading"
            });

			Personetics.UI.PWidgetFactory.registerWidget("teaser-widget", {
                widgetClass: Personetics.UI.PTeaserWidgetCtrl,
                widgetName: "Base teaser widget"
            });

			Personetics.UI.PWidgetFactory.registerWidget("teaser-insight-widget", {
                widgetClass: Personetics.UI.PInsightTeaserWidgetCtrl,
                widgetName: "Base teaser insight widget"
            });

		}

	});
	Personetics.story.skinController = Personetics.story.PSkinControler;
	/*Personetics.story.getFormats = function(){
		return {
			"dateFormat": "MM/DD/YY",
			"amountFormat": "",
			"currencySymbol": ""/*,
			"currencyName": "US dollar",
			"currencyNamePlural": "US dollars",
			"currencyNameDecimal": "cent",
			"currencyNameDecimalPlural": "cents",
			"accesibilityDateFormat": "The {{day}} of {{month}}, {{year}}",
			"accesibilityAmountFormat": "{{amountInt}} {{currencyName}}",
			"accesibilityAmountDecimalFormat": " and {{amountDecimal}} {{currencyNameDecimal}}"
		}
	};*/


})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.PDialog = Base.extend({
        initialize: function(story,config) {
            var dlg = this;
            this.story = story;
            this.config = config;
            this.lang = story.lang;
            this.id = story.getId() + "_" + this.config.id;
            this.txts = {};
            this.visible = false;
            this.class = this.config.class ? this.config.class : "";

            if (this.config.showIf)
                this.showCondExp = new Personetics.processor.PExp(this.config.showIf);

            this.isShouldShow = null;

            this.loadTexts(story.texts, story.lang, story.defaultLang);

            this.initializeBlocks();

        },
        loadTexts: function(config, lang, defaultLang) {
            var defaultConfig = this.config.txt || {};
            var langTexts = config && config.hasOwnProperty(this.config.id) ? config[this.config.id] : null;

            // merge lang text into default config
            if(langTexts) {
                var ar;
                if(langTexts.hasOwnProperty(lang))
                    ar = langTexts[lang];
                else
                    ar = langTexts[defaultLang];

                $.each(ar, function (textId, textTemplate) {
                    defaultConfig[textId] = textTemplate;
                });
            }

            var txts = {};
            var wf = this.story;
            var dlg = this;
            if(defaultConfig) {
                $.each(defaultConfig, function (key, txt) {
                    var langTxt = txt;
                    if (langTexts) {
                        langTxt = langTexts[lang] ? langTexts[lang][key] : null;
                        if (!langTxt)
                            langTxt = langTexts[defaultLang] ? langTexts[defaultLang][key] : txt;
                        if (!langTxt)
                            langTxt = txt;
                    }
                    dlg.txts[key] = langTxt;
                });
            }
            else{
                Personetics.log("Personetics.story.PDialog.loadTexts: dialog doesn't have any text configuration")
            }
        },
        
        getId: function() {
            return this.id;
        },
        getShortId: function() {
            return this.config.id;
        },
        getText: function(txtId) {
            var txt;
            if (this.txts) {
                var txts = this.txts;
                if (txts)
                    txt = txts[txtId];
            }
            return txt;
        },
        processText: function(txtId, context, parentContext) {
            var pTxt = this.getText(txtId);
            if (!pTxt)
                return "-";
            if(this.story.mode == "preview")
                return pTxt.getTextTemplate();
            else
                return pTxt.process(context, parentContext);
        },
        shouldShow: function() {

            if (!this.showCondExp)
                return true;

            if(this.isShouldShow == null){
                try{
                    this.isShouldShow = this.showCondExp.eval(this.story.model);
                }
                catch(e){
                    this.isShouldShow = null;
                }
            }

            return this.isShouldShow;
        },
        generateData: function(){
            var isFirstDialog = this.isFirstDialog;
            var data = {
                id: this.getId(),
                class: this.config.class
            };

            if(this.config.isSingleDialogMode){
                data.btn = [];
                data.btn.diaogBtn = [];
                data.btn.showBtn = [];

                if(this.config.next ){
                    data.btn.push({
                        diaogBtn: Personetics.dictionary.getText('continue'),
                        actionBtn: "continue",
                        showBtn: true
                    }); //TODO: move to dialog texts
                }
                else{
                    data.btn.push({
                        diaogBtn: Personetics.dictionary.getText('close'),
                        actionBtn: "close",
                        showBtn: true

                    }); //TODO: move to dialog texts
                }
                if(!isFirstDialog){
                    data.btn.push({
                        diaogBtn: Personetics.dictionary.getText('previous'),
                        actionBtn: "prev",
                        showBtn: true
                    }); //TODO: move to dialog texts
                }
                // el.find('.pstory-dialog-frame').hide();
            }
            return data;
        },
        render: function(el, isFirstDialog) {

            this.isFirstDialog = isFirstDialog;
            var shouldShow = this.shouldShow();
            var isSingleDialogMode = this.config.isSingleDialogMode;

            if (isSingleDialogMode && !shouldShow){
                this.story.renderDialog();
            }
            else{

                if(shouldShow) {
                    var template = this.story.getTemplate("#tmpl-pstory-dialog"); // why not this.getTemplate ?

                    if (isSingleDialogMode) {
                        template = this.story.getTemplate("#tmpl-pstory-dialog-continue-btn");
                        el.find('.pstory-dialog-frame').hide();
                    }

                    var data = this.generateData();
                    var html = template(data);
                    var dlgEl = $(html);
                    this.el = dlgEl;
                    el.append(dlgEl);
                }
                // AFTER RENDER
            }
        },
        afterRender: function(){
            var dlg = this;
            var story = this.story;
            var dlgEl = this.el;
            var shouldShow = this.shouldShow();
            var isSingleDialogMode = this.config.isSingleDialogMode;

            if(shouldShow) {
                var contentEl = this.el.find('.pstory-dialog-content');

                // if isSingleDialog mode, scroll to the top of the new dialog
                if (isSingleDialogMode) {
                    if (this.story.parent.scrollTo) {
                        this.story.parent.scrollTo(dlgEl.offset().top);
                    }
                    /*remove dialog buttons height from content*/

                    var dialogButtonsHeight = this.el.find('.pstory-dialog-buttons').height();
                    contentEl.height(contentEl.height() - dialogButtonsHeight);
                }

                if(contentEl.parents('.pstory-dialog-frame').hasClass('horizontal')){
                    this.config.dialogWidth = contentEl.width();
                }
                this.renderBlocks(contentEl);

                if(contentEl.parents('.pstory-dialog-frame').hasClass('horizontal')){
                    var blocks = contentEl.find('.pstory-block-frame');
                    var width = contentEl.width();
                    var height = 0;
                    width /= blocks.length;
                    $.each(blocks, function(i, item){
                        var margin = parseInt($(item).css('margin-left')) + parseInt($(item).css('margin-right'));
                        var itemWidth = width - margin;
                        $(item).width(itemWidth);
                        //var itemHeight = $(item).height();
                        var itemHeight = $(item).children().first().height();
                        height = itemHeight > height ? itemHeight : height;
                    });
                    contentEl.height(height);
                }

            }
        },
        bindEvents: function(){
            var story = this.story;
            var shouldShow = this.shouldShow();
            if(shouldShow) {
                var dlgEl = this.el;
                var contentEl = this.el.find('.pstory-dialog-content');
                var dlgClickHandler = story.cfg.dlgClickHandler;
                if (dlgClickHandler) {
                    contentEl.bind("click", function () {
                        dlgClickHandler(this);
                    });
                }

                var continueButtonEl = dlgEl.find(".pstory-dialog-btn");
                continueButtonEl.bind("click", function () {
                    var opts = {};
                    if ($(this).data('action') == 'prev') {
                        opts.renderPreviousDialog = true;
                    }
                    else if ($(this).data('action') == 'close') {
                        story.closeHandler();
                        return;
                    }
                    story.renderDialog(null, opts);
                });
            }
        },
        initializeBlocks: function(){
            var dlg = this;
            var story = this.story;

            story.blockSessionManager.resetDialog(this.getShortId());

            this.config.blocks.forEach(function(blockCfg, index) {
                var show = true;
                if (blockCfg.showIf) {
                    try{
                    	var showIfExp = new Personetics.processor.PExp(blockCfg.showIf);
	                show = showIfExp.eval(story.model);
                    }
                    catch(e){
                        show = true;
                    }
                }
                if (show) {
                    blockCfg.index = index;
                    story.blockSessionManager.startBlock(dlg.getShortId(), dlg.txts, blockCfg, index);
                }
            });
        },
        renderBlocks: function(contentEl){
            this.story.blockSessionManager.renderBlocks(this.getShortId(), contentEl, this.isFirstDialog);
        },
        setIsBlock: function(){
            if(this.shouldShow()) {
                this.el.addClass("perso-block");
                $(this.el).find("*").off();
            }
        },
        setVisible: function(visible) {
            if (this.visible == visible)
                return;
            this.visible = visible;
            var dlg = this;
            this.story.blockSessionManager.setVisible(this.getShortId, visible);
        },
        addBlock: function(block) {
            this.blocks.push(block);
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.PWorkflowCtx = Base.extend({
        initialize: function(wf,model) {
            this.wf = wf;
            this.dialogs = [];
            this.firstDialogId = null;
        },
        pushDlg: function(dlg) {
            this.dialogs.push(dlg);
            var isShouldShow = dlg.shouldShow();
            if(!this.firstDialogId && isShouldShow)
                this.firstDialogId = dlg.getShortId();
        },
        getFirstDialogId:function(){
            return this.firstDialogId;
        },
        hasDlg: function(dlgId) {
            this.dialogs.forEach(function(dlg,index) {
                if (dlg.getId() == dlgId)
                    return true;
            });
            return false;
        },
        getDlg: function(dlgId){
            var result = null;
            this.dialogs.forEach(function(dlg,index) {
                if (dlg.getShortId() == dlgId)
                    result = dlg;
                    return true;
            });
            return result;
        },
        removeDlgsAfter: function(pivotDlgId) {
            if (!pivotDlgId) {
                var after = this.dialogs;
                this.dialogs = [];
                return after;
            }

            var dlgsBefore = [];
            var dlgsAfter = [];
            var before = true;
            this.dialogs.forEach(function(dlg,index) {
                if (before)
                    dlgsBefore.push(dlg);
                else
                    dlgsAfter.push(dlg);

                var curDlgId = dlg.getId();
                if (curDlgId == pivotDlgId)
                    before = false;
            });
            this.dialogs = dlgsBefore;

            return dlgsAfter;
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
	Personetics.story = Personetics.story || {};

	Personetics.story.PStory = Personetics.story.PCtrlBase.extend({
		initialize: function (config) {
			this.cfg = config;
			this.super = Personetics.story.PCtrlBase.prototype;
			this.super.initialize.call(this, config.parent);

			this.cfg.chartsLibClass = typeof Highcharts !== 'undefined' ? "highcharts" : null;
			this.cfg.widthMode = "";

			this.storyDef = config.flowDef || config.storyDefinition;
			this.id = this.storyDef.storyId;
			this.insight = config.insight;
			this.pserver = config.pserver;
			if (!this.pserver) {
				if (typeof personetics !== 'undefined' && personetics !== null)
					this.pserver = personetics.pserverProxy;
				else
					this.pserver = null;
			}
			
			var insightFacts = config.data || config.insightFacts;
			var options = {};
			this.texts = config.texts || config.storyText;
			this.ctx = new Personetics.story.PWorkflowCtx(this);
			this.templates = {};
			this.closeHandler = config.closeHandler;
			// if no customer specific UX control was set, use default
			this.defaultLang = config.defaultLang || "en";
			options.lang = config.lang || this.defaultLang;
			var skinController = config.uxCtrl;
			if (!skinController)
				skinController = new Personetics.story.skinController();
			this.uxCtrl = skinController;
			this.desktopScreenWidth = this.uxCtrl.getDesktopScreenWidth();
            this.mobileMaxScreenWidth = this.uxCtrl.getMobileMaxScreenWidth();
			this.screenWidth = $(window).width();
			if (this.screenWidth >= this.desktopScreenWidth) {
				this.cfg.widthMode = "desktop";
			}else if(this.screenWidth > this.mobileMaxScreenWidth && this.screenWidth < this.desktopScreenWidth){
                this.cfg.widthMode = "tablet";
			}
			//this.uxCtrl.setStory(this);
			this.uxCtrl.registerBlocks();

			options.useProjectDefaultCurrency = Personetics.projectConfiguration.getConfig("useProjectDefaultCurrency");
			options.supportHtmlTagInProcessor = Personetics.projectConfiguration.getConfig("supportHtmlTagInProcessor");
			options.amountFormat = Personetics.projectConfiguration.getConfig("amountFormat");
			options.dateFormat = Personetics.projectConfiguration.getConfig("dateFormat");
			options.currencySymbol = Personetics.projectConfiguration.getConfig("currencySymbol");
            options.supportCollapse = Personetics.projectConfiguration.getConfig("supportCollapse");

			this.options = options;
            this.expressions = config.expressions;
			this.blockSessionManager = new Personetics.story.PBlockSessionManager(this);
			this.model = this.blockSessionManager.getModel();
			// this.model.setFormats(this.uxCtrl.getFormats());//?

			// initialize dialogs config
			var dlgCfgMap = {};
			this.storyDef.dialogs.forEach(function (cfg) {
				if (dlgCfgMap[cfg.id])
					Personetics.log("duplicate dlg found: " + cfg.id);
				else
					dlgCfgMap[cfg.id] = cfg
			});

			this.dlgCfgMap = dlgCfgMap;
		},
		getId: function () {
			return this.id;
		},
		fireEvent: function (block, e) {
			this.handleEvent(block, e);
		},
		start: function (parentEl) {
			this.parentEl = parentEl;

			var direction = Personetics.processor.PStoryConfig.isRtl() == true ? "rtl" : "ltr";
			// create html element
			var storyData = {
				storyId: this.getId(),
				langClass: "pstory-lang-" + this.lang,
				directionClass: "pstory-direction-" + direction,
				cssClass: this.cfg.cssClass
			};
			var html = this.getTemplateHtml("#pstory-frame", storyData);
			var newEl = $(html);
			newEl = parentEl.append(newEl);
			this.frameEl = newEl.find(".pstory-frame");
			this.el = this.frameEl.find(".pstory-container");

			var resizedEl = this.el;

			this.renderTitleText();
			this.setPlaceHolderForFixedTitle();

			// render dialogs
			this.renderDialogs();
			this.scrollHandler();

			var contentEl = parentEl;

		},
		renderDialogs: function () {
			if (this.cfg.isSingleDialogMode)
				this.renderDialog();
			else
				this.doNextLoop();
		},
		renderTitleText: function () {
			if (!this.cfg.showTitle)
				return;

			var title = this.getTitle();
			var subtitle = this.getSubtitle();
			var iconType = this.cfg.iconType;

			var pstory_title = this.parentEl.siblings().find('.pstory-title-text');
			if(pstory_title.length > 0) {
                this.parentEl.siblings().find('.pstory-subtitle-text').html(subtitle);
                this.parentEl.siblings().find('.pstory-title .perso-teaser-image').addClass("perso-" + iconType);
                this.parentEl.siblings().find('.pstory-title-text').html(title);
            }
            else {
                var html = this.getTemplateHtml("#tmpl-pstory-title-inside-story", {title: this.getTitle(),backButtonText:'back'});
                var newEl = $(html);
                this.el.append(newEl);
                this.el.find('.pstory-subtitle-text').html(subtitle);
                this.el.find('.pstory-title .perso-teaser-image').addClass("perso-" + iconType);
                this.el.find('.pstory-title-text').html(title);
			}
		},
		getTitle: function () {
			return this.getTitleHelper("title");
		},

		getSubtitle: function () {
			return this.getTitleHelper("subtitle");
		},

		//TODO: move to block processor manager
		getTitleHelper: function (type) {
			var lang = this.options.lang;
			var defaultLang = this.defaultLang;
			var titleCfg = this.storyDef[type];

			if (this.texts.hasOwnProperty(type) && this.texts[type]) {
				var textTitleCfg = this.texts[type];
				if (textTitleCfg.hasOwnProperty(lang))
					titleCfg = textTitleCfg[lang];
				else if (textTitleCfg.hasOwnProperty(defaultLang))
					titleCfg = textTitleCfg[defaultLang];
			}

			if (!titleCfg)
				return null;

			var titleExp = new Personetics.processor.PTextTemplate(titleCfg.txt, this);
			var title = titleExp.process(this.model);
			return title;
		},

		addTouchScroll: function(){
			this.frameEl.addClass("pstory-scrolling-touch");
            this.frameEl.css('-webkit-overflow-scrolling','touch');
		},

		renderDialog: function (startHeight, options) {
			var nextDlg;
			var flow = this;
			// first dialog already rendered
			if (this.current) {
				this.current.setIsBlock();
				var targetsCfg;
				if (options && options.hasOwnProperty("renderPreviousDialog")) {
					var renderPreviousDialog = options.renderPreviousDialog;
					if (renderPreviousDialog)
						targetsCfg = this.findPreviousDialog();
					else
						targetsCfg = this.current.config.next;
				}
				else {
					targetsCfg = this.current.config.next;
				}
				if (targetsCfg) {
					nextDlg = this.renderNextDlg(targetsCfg, null);
				}
			}
			// render first dialog
			else {
				nextDlg = this.pushDlg(this.storyDef.dialogs[0], null);
			}
			// set the dialog heigh after it was rendered
			if (!nextDlg) {
				var endHeight = flow.el.height();
				if (startHeight && startHeight != endHeight) {
					if (flow.cfg.resizeHandler)
						flow.cfg.resizeHandler(endHeight);
				}
			}
		},

		findPreviousDialog: function () {
			var currentDialog = this.current;
			var dialogsConfig = this.storyDef.dialogs;
			var res = null;
			$.each(dialogsConfig, function (index, dialogConfig) {
				var next = dialogConfig.next;
				if (next) {
					if ($.isArray(next)) {
						$.each(next, function (index, nextConfig) {
							if (nextConfig.target == currentDialog.config.id) {
								res = { "target": dialogConfig.id };
								return false;
							}
						});
					}
					else {
						if (next.target == currentDialog.config.id) {
							res = { "target": dialogConfig.id };
							return false;
						}
					}
				}
			});
			return res;
		},
		// can we make this non-recursive? seems overly complicated. Can use callbacks instead
		doNextLoop: function (startHeight) {
			var story = this;
			var firstNext = this.current;
			var nextStep = function () {
				var nextDlg = story.next(nextStep);

				// what is this?
				if (!nextDlg) {
					var endHeight = story.el.height();
					story.afterLastDialog(endHeight, startHeight);


				}
			};
			nextStep();
			if (firstNext) {
				var next = firstNext.config.next;
				if (next) {
					var target;
					if ($.isArray(next)) {
						target = next[0].target;
					}
					else {
						target = next.target;
					}

					var id = 'pdlg-' + story.id + '_' + target;
					var parent = this.el.parents('.perso-insights-container');
					this.scrollTo(parent, id);
					this.setFocus(id);
				}
			}
		},

		afterLastDialog: function (endHeight, startHeight) {
			var story = this;
			if (startHeight && startHeight != endHeight) {
				if (story.cfg.resizeHandler)
					story.cfg.resizeHandler(endHeight, story.el);
			}
			if (story.cfg.onEndHandleEvent) {
				story.cfg.onEndHandleEvent(story.el);
			}
		},
		setPlaceHolderForFixedTitle: function setPlaceForFixedTitle() {
			var titleEl = $('.pstory-title-wrapper');
			var height = titleEl.height();
			if (titleEl.length > 0 && titleEl.css('position') == 'fixed') {
				var titleParent = titleEl.parent('.pstory-title-outer-wrapper');
				titleParent.css('paddingBottom', height + 'px');
			}
			var storyFrame = this.el.parents('#story-frame-container');
			if (storyFrame.length == 0) {
				storyFrame = this.el.parents('.pstory-frame');
			}

			//for editor
			var editorFrame = this.el.parents('.pstory-frame');
			while (editorFrame.height() == 0) {
				editorFrame = editorFrame.parent();
			}


			var heightFrame = storyFrame.height() > 0 ? storyFrame.innerHeight() :  editorFrame.height();
            storyFrame.height(heightFrame - height);

		},
		pushDlg: function (cfg, callback) {
			cfg.isSingleDialogMode = this.cfg.isSingleDialogMode;
			cfg.widthMode = this.cfg.widthMode;
			cfg.chartsLibClass = this.cfg.chartsLibClass;

			var dlg = new Personetics.story.PDialog(this, cfg);
			this.ctx.pushDlg(dlg);
			var firstDialogId = this.ctx.getFirstDialogId();
			var isFirstDialog = firstDialogId == cfg.id;
			this.current = dlg;
			var story = this;
			this.uxCtrl.beforeRender(dlg, function () {
				dlg.render(story.el, isFirstDialog);
				dlg.afterRender();
				dlg.bindEvents();
				story.uxCtrl.afterRender(dlg, callback);
			});
			return dlg;
		},
		next: function (callback) {
			var nextDlg;
			// current displayed dialog?
			if (!this.current)
				nextDlg = this.pushDlg(this.storyDef.dialogs[0], callback);

			// transCfg == dialog.next
			var transCfg = this.current.config.next;

			// nextDlg will only be defined when returning from the pushDialog() call in the first next() iteration
			// condition won't happen if dialog doesn't have "next" property
			if (!nextDlg && transCfg) {
				nextDlg = this.renderNextDlg(transCfg, callback);
			}

			return nextDlg
		},

		renderNextDlg: function (transCfg, callback) {
			var trans = transCfg;
			var isQuiz = false;

			//Check if it's quiz block
			for(var i =0; i < this.current.config.blocks.length; i++){
                if(this.current.config.blocks[i].hasOwnProperty('buttonType') && this.current.config.blocks[i].hasOwnProperty('class') &&
                	this.current.config.blocks[i].buttonType === "button" && this.current.config.blocks[i].class === "perso-radio-buttons"){
                	isQuiz = true;
                	break;
                }
			}
			if (!Array.isArray(transCfg))
				trans = [transCfg];
			//If type of the block is quiz check if the selected answer obj is not null-> then render it
            if(!isQuiz || (isQuiz && this.model.getVarValue('selectedAnswer'))) {

                // if dialog has multiple targets, find the first one which fulfills its condition, or the first one without
                // condition
                for (var i = 0; i < trans.length; i++) {
                    var tr = trans[i];
                    var ok = true;
                    if (tr.cond) {
                        var condExp = new Personetics.processor.PExp(tr.cond);
                        try {
                            ok = condExp.eval(this.model);
                        }
                        catch (e) {
                            ok = false;
                        }

                    }
                    if (ok) {
                        // No circles
                        if (this.ctx.hasDlg(tr.target))
                            break;

                        var config = this.dlgCfgMap[tr.target];
                        if (!config) {
                            Personetics.utils.PLogger.error("could not find dialog definition for target: " + tr.target);
                        } else {
                            var nextDlg = this.pushDlg(config, callback);
                            break;
                        }
                    }
                }
            }
		},
		handleEvent: function (block) {
			this.el.prevObject.removeClass('pstory-scrolling-touch');
			var me = this;
			var startHeight = this.el.height();
			if (this.cfg.onStartHandleEvent) {
				this.cfg.onStartHandleEvent(startHeight, this.el);
			}
			this.current = null;
			var dlgId = null;
			if (block) {
				dlgId = block.dlgId;
				this.current = this.ctx.getDlg(block.dlgId);
			}
			var after = this.ctx.removeDlgsAfter(this.current.getId());
			var story = this;
			after.forEach(function (dlg) {
				if (dlg.el)
					dlg.el.remove();

				$.each(dlg.config.blocks, function (i, block) {
					me.blockSessionManager.resetVariables(block);
				});
			});

			this.blockSessionManager.reset();

			if (this.cfg.isSingleDialogMode)
				this.renderDialog(startHeight);
			else
				this.doNextLoop(startHeight);
			this.el.prevObject.addClass('pstory-scrolling-touch');
		},

		handleQueryData: function (data, block) {
			this.blockSessionManager.renderBlock(block.dlgId, block.index, data);
		},

		handleScroll: function (scrollTop, scrollBottom) {
			this.ctx.dialogs.forEach(function (dlg, index) {
				var dlgTop = dlg.el.position().top;
				var dlgBottom = dlgTop + dlg.el.height();
				var isVisible = true;
				if (dlgBottom <= scrollTop || dlgTop >= scrollBottom)
					isVisible = false;

				dlg.setVisible(isVisible);
			})
		},
		scrollTo: function scrollTo(el, toElementId) {
		},
		setFocus: function setFocus(elId) {

		},
		scrollHandler: function () {
			var story = this;
			var totalHeight = 0;
			$(this.frameEl).bind("scroll", function (event) {
				var scrollTop = $(this.frameEl).scrollTop();
				story.blockSessionManager.handleEvent("scroll", scrollTop);
			});

		}
	});
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
	Personetics.story = Personetics.story || {};

	Personetics.story.PStory = Personetics.story.PCtrlBase.extend({
		initialize: function (config) {
			this.cfg = config;
			this.super = Personetics.story.PCtrlBase.prototype;
			this.super.initialize.call(this, config.parent);

			this.cfg.chartsLibClass = typeof Highcharts !== 'undefined' ? "highcharts" : null;
			this.cfg.widthMode = "";

			this.storyDef = config.flowDef || config.storyDefinition;
			this.id = this.storyDef.storyId;
			this.insight = config.insight;
			this.pserver = config.pserver;
			if (!this.pserver) {
				if (typeof personetics !== 'undefined' && personetics !== null)
					this.pserver = personetics.pserverProxy;
				else
					this.pserver = null;
			}

			var insightFacts = config.data || config.insightFacts;
			var options = {};
			this.texts = config.texts || config.storyText;
			this.facts = insightFacts;
			this.ctx = new Personetics.story.PWorkflowCtx(this);
			this.templates = {};
			this.closeHandler = config.closeHandler;
			// if no customer specific UX control was set, use default
			this.defaultLang = config.defaultLang || "en";
			options.lang = config.lang || this.defaultLang;
			var skinController = config.uxCtrl;
			if (!skinController)
				skinController = new Personetics.story.skinController();
			this.uxCtrl = skinController;
			this.desktopScreenWidth = this.uxCtrl.getDesktopScreenWidth();
			this.mobileMaxScreenWidth = this.uxCtrl.getMobileMaxScreenWidth();
			this.screenWidth = $(window).width();
			if (this.screenWidth >= this.desktopScreenWidth) {
				this.cfg.widthMode = "desktop";
			} else if (this.screenWidth > this.mobileMaxScreenWidth && this.screenWidth < this.desktopScreenWidth) {
				this.cfg.widthMode = "tablet";
			}
			//this.uxCtrl.setStory(this);
			this.uxCtrl.registerBlocks();

			options.useProjectDefaultCurrency = Personetics.projectConfiguration.getConfig("useProjectDefaultCurrency");
			options.supportHtmlTagInProcessor = Personetics.projectConfiguration.getConfig("supportHtmlTagInProcessor");
			options.amountFormat = Personetics.projectConfiguration.getConfig("amountFormat");
			options.dateFormat = Personetics.projectConfiguration.getConfig("dateFormat");
			options.currencySymbol = Personetics.projectConfiguration.getConfig("currencySymbol");
			options.supportCollapse = Personetics.projectConfiguration.getConfig("supportCollapse");

			this.options = options;
			this.expressions = config.expressions;
			this.blockSessionManager = new Personetics.story.PBlockSessionManager(this);
			this.model = this.blockSessionManager.getModel();
			// this.model.setFormats(this.uxCtrl.getFormats());//?

			// initialize dialogs config
			var dlgCfgMap = {};
			this.storyDef.dialogs.forEach(function (cfg) {
				if (dlgCfgMap[cfg.id])
					Personetics.log("duplicate dlg found: " + cfg.id);
				else
					dlgCfgMap[cfg.id] = cfg
			});

			this.dlgCfgMap = dlgCfgMap;
		},
		getId: function () {
			return this.id;
		},
		fireEvent: function (block, e) {
			this.handleEvent(block, e);
		},
		start: function (parentEl) {
			this.parentEl = parentEl;

			var direction = Personetics.processor.PStoryConfig.isRtl() == true ? "rtl" : "ltr";
			// create html element
			var storyData = {
				storyId: this.getId(),
				langClass: "pstory-lang-" + this.lang,
				directionClass: "pstory-direction-" + direction,
				cssClass: this.cfg.cssClass
			};
			var html = this.getTemplateHtml("#pstory-frame", storyData);
			var newEl = $(html);
			newEl = parentEl.append(newEl);
			this.frameEl = newEl.find(".pstory-frame");
			this.el = this.frameEl.find(".pstory-container");

			var resizedEl = this.el;

			this.renderTitleText();
			this.setPlaceHolderForFixedTitle();

			// render dialogs
			this.renderDialogs();
			this.scrollHandler();

			var contentEl = parentEl;

		},
		renderDialogs: function () {
			if (this.cfg.isSingleDialogMode)
				this.renderDialog();
			else
				this.doNextLoop();
		},
		renderTitleText: function () {
			if (!this.cfg.showTitle)
				return;

			var title = this.getTitle();
			var subtitle = this.getSubtitle();
			var dateTitle = this.getDateTitle();
			var iconType = this.cfg.iconType;

			var pstory_title = this.parentEl.siblings().find('.pstory-title-text');
			if (pstory_title.length > 0) {
				this.parentEl.siblings().find('.pstory-subtitle-text').html(subtitle);
				this.parentEl.siblings().find('.pstory-title .perso-teaser-image').addClass("perso-" + iconType);
				this.parentEl.siblings().find('.pstory-title-text').html(title);
				if (this.cfg.widthMode == "desktop")
					this.parentEl.siblings().find('.pstory-title-date').html(dateTitle);
			}
			else {
				var html = this.getTemplateHtml("#tmpl-pstory-title", { title: this.getTitle(), backButtonText: 'back' });
				var newEl = $(html).find('.pstory-title-outer-wrapper');
				this.el.append(newEl);
				this.el.find('.pstory-subtitle-text').html(subtitle);
				this.el.find('.pstory-title .perso-teaser-image').addClass("perso-" + iconType);
				this.el.find('.pstory-title-text').html(title);
				if (this.cfg.widthMode == "desktop")
					this.el.find('.pstory-title-date').html(dateTitle);
			}
		},
		getDateTitle: function () {
			if (this.facts.hasOwnProperty("currentDate") && this.facts["currentDate"])
				return Personetics.processor.PUtils.getUtilsInstance('utils').formatDate(this.facts["currentDate"].rows[0][0], "d M");
		},
		getTitle: function () {
			return this.getTitleHelper("title");
		},

		getSubtitle: function () {
			return this.getTitleHelper("subtitle");
		},

		//TODO: move to block processor manager
		getTitleHelper: function (type) {
			var lang = this.options.lang;
			var defaultLang = this.defaultLang;
			var titleCfg = this.storyDef[type];
			if (this.texts.hasOwnProperty(type) && this.texts[type]) {
				var textTitleCfg = this.texts[type];
				if (textTitleCfg.hasOwnProperty(lang))
					titleCfg = textTitleCfg[lang];
				else if (textTitleCfg.hasOwnProperty(defaultLang))
					titleCfg = textTitleCfg[defaultLang];
			}

			if (!titleCfg)
				return null;

			var titleExp = new Personetics.processor.PTextTemplate(titleCfg.txt, this);
			var title = titleExp.process(this.model);
			return title;
		},

		addTouchScroll: function () {
			this.frameEl.addClass("pstory-scrolling-touch");
			this.frameEl.css('-webkit-overflow-scrolling', 'touch');
		},

		renderDialog: function (startHeight, options) {
			var nextDlg;
			var flow = this;
			// first dialog already rendered
			if (this.current) {
				this.current.setIsBlock();
				var targetsCfg;
				if (options && options.hasOwnProperty("renderPreviousDialog")) {
					var renderPreviousDialog = options.renderPreviousDialog;
					if (renderPreviousDialog)
						targetsCfg = this.findPreviousDialog();
					else
						targetsCfg = this.current.config.next;
				}
				else {
					targetsCfg = this.current.config.next;
				}
				if (targetsCfg) {
					nextDlg = this.renderNextDlg(targetsCfg, null);
				}
			}
			// render first dialog
			else {
				nextDlg = this.pushDlg(this.storyDef.dialogs[0], null);
			}
			// set the dialog heigh after it was rendered
			if (!nextDlg) {
				var endHeight = flow.el.height();
				if (startHeight && startHeight != endHeight) {
					if (flow.cfg.resizeHandler)
						flow.cfg.resizeHandler(endHeight);
				}
			}
		},

		findPreviousDialog: function () {
			var currentDialog = this.current;
			var dialogsConfig = this.storyDef.dialogs;
			var res = null;
			$.each(dialogsConfig, function (index, dialogConfig) {
				var next = dialogConfig.next;
				if (next) {
					if ($.isArray(next)) {
						$.each(next, function (index, nextConfig) {
							if (nextConfig.target == currentDialog.config.id) {
								res = { "target": dialogConfig.id };
								return false;
							}
						});
					}
					else {
						if (next.target == currentDialog.config.id) {
							res = { "target": dialogConfig.id };
							return false;
						}
					}
				}
			});
			return res;
		},
		// can we make this non-recursive? seems overly complicated. Can use callbacks instead
		doNextLoop: function (startHeight) {
			var story = this;
			var firstNext = this.current;
			var nextStep = function () {
				var nextDlg = story.next(nextStep);

				// what is this?
				if (!nextDlg) {
					var endHeight = story.el.height();
					story.afterLastDialog(endHeight, startHeight);


				}
			};
			nextStep();
			if (firstNext) {
				var next = firstNext.config.next;
				if (next) {
					var target;
					if ($.isArray(next)) {
						target = next[0].target;
					}
					else {
						target = next.target;
					}

					var id = 'pdlg-' + story.id + '_' + target;
					var parent = this.el.parents('.perso-insights-container');
					this.scrollTo(parent, id);
					this.setFocus(id);
				}
			}
		},

		afterLastDialog: function (endHeight, startHeight) {
			var story = this;
			if (startHeight && startHeight != endHeight) {
				if (story.cfg.resizeHandler)
					story.cfg.resizeHandler(endHeight, story.el);
			}
			if (story.cfg.onEndHandleEvent) {
				story.cfg.onEndHandleEvent(story.el);
			}
		},
		setPlaceHolderForFixedTitle: function setPlaceForFixedTitle() {
			var titleEl = $('.pstory-title-wrapper');
			var height = titleEl.height();
			titleEl.height(height);
			if (titleEl.length > 0 && titleEl.css('position') == 'fixed') {
				var titleParent = titleEl.parent('.pstory-title-outer-wrapper');
				titleParent.css('paddingBottom', height + 'px');
			}
			var storyFrame = this.el.parents('#story-frame-container');
			if (storyFrame.length == 0) {
				storyFrame = this.el.parents('.pstory-frame');
			}

			//for editor
			var editorFrame = this.el.parents('.pstory-frame');
			while (editorFrame.height() == 0) {
				editorFrame = editorFrame.parent();
			}
			if (typeof window.personetics.getDeviceType === 'function' && window.personetics.getDeviceType() !== "RJS") {
				var heightFrame = storyFrame.height() > 0 ? storyFrame.innerHeight() : editorFrame.height();
				storyFrame.height(heightFrame - height);
			}
		},
		pushDlg: function (cfg, callback) {
			cfg.isSingleDialogMode = this.cfg.isSingleDialogMode;
			cfg.widthMode = this.cfg.widthMode;
			cfg.chartsLibClass = this.cfg.chartsLibClass;

			var dlg = new Personetics.story.PDialog(this, cfg);
			this.ctx.pushDlg(dlg);
			var firstDialogId = this.ctx.getFirstDialogId();
			var isFirstDialog = firstDialogId == cfg.id;
			this.current = dlg;
			var story = this;
			this.uxCtrl.beforeRender(dlg, function () {
				dlg.render(story.el, isFirstDialog);
				dlg.afterRender();
				dlg.bindEvents();
				story.uxCtrl.afterRender(dlg, callback);
			});
			return dlg;
		},
		next: function (callback) {
			var nextDlg;
			// current displayed dialog?
			if (!this.current)
				nextDlg = this.pushDlg(this.storyDef.dialogs[0], callback);

			// transCfg == dialog.next
			var transCfg = this.current.config.next;

			// nextDlg will only be defined when returning from the pushDialog() call in the first next() iteration
			// condition won't happen if dialog doesn't have "next" property
			if (!nextDlg && transCfg) {
				nextDlg = this.renderNextDlg(transCfg, callback);
			}

			return nextDlg
		},

		renderNextDlg: function (transCfg, callback) {
			var trans = transCfg;
			var isQuiz = false;

			//Check if it's quiz block
			for (var i = 0; i < this.current.config.blocks.length; i++) {
				if (this.current.config.blocks[i].hasOwnProperty('buttonType') && this.current.config.blocks[i].hasOwnProperty('class') &&
					this.current.config.blocks[i].buttonType === "button" && this.current.config.blocks[i].class === "perso-radio-buttons") {
					isQuiz = true;
					break;
				}
			}
			if (!Array.isArray(transCfg))
				trans = [transCfg];
			//If type of the block is quiz check if the selected answer obj is not null-> then render it
			if (!isQuiz || (isQuiz && this.model.getVarValue('selectedAnswer'))) {

				// if dialog has multiple targets, find the first one which fulfills its condition, or the first one without
				// condition
				for (var i = 0; i < trans.length; i++) {
					var tr = trans[i];
					var ok = true;
					if (tr.cond) {
						var condExp = new Personetics.processor.PExp(tr.cond);
						try {
							ok = condExp.eval(this.model);
						}
						catch (e) {
							ok = false;
						}

					}
					if (ok) {
						// No circles
						if (this.ctx.hasDlg(tr.target))
							break;

						var config = this.dlgCfgMap[tr.target];
						if (!config) {
							Personetics.utils.PLogger.error("could not find dialog definition for target: " + tr.target);
						} else {
							var nextDlg = this.pushDlg(config, callback);
							break;
						}
					}
				}
			}
		},
		handleEvent: function (block) {
			this.el.prevObject.removeClass('pstory-scrolling-touch');
			var me = this;
			var startHeight = this.el.height();
			if (this.cfg.onStartHandleEvent) {
				this.cfg.onStartHandleEvent(startHeight, this.el);
			}
			this.current = null;
			var dlgId = null;
			if (block) {
				dlgId = block.dlgId;
				this.current = this.ctx.getDlg(block.dlgId);
			}
			var after = this.ctx.removeDlgsAfter(this.current.getId());
			var story = this;
			after.forEach(function (dlg) {
				if (dlg.el)
					dlg.el.remove();

				$.each(dlg.config.blocks, function (i, block) {
					me.blockSessionManager.resetVariables(block);
				});
			});

			this.blockSessionManager.reset();

			if (this.cfg.isSingleDialogMode)
				this.renderDialog(startHeight);
			else
				this.doNextLoop(startHeight);
			this.el.prevObject.addClass('pstory-scrolling-touch');
		},

		handleQueryData: function (data, block) {
			this.blockSessionManager.renderBlock(block.dlgId, block.index, data);
		},

		handleScroll: function (scrollTop, scrollBottom) {
			this.ctx.dialogs.forEach(function (dlg, index) {
				var dlgTop = dlg.el.position().top;
				var dlgBottom = dlgTop + dlg.el.height();
				var isVisible = true;
				if (dlgBottom <= scrollTop || dlgTop >= scrollBottom)
					isVisible = false;

				dlg.setVisible(isVisible);
			})
		},
		scrollTo: function scrollTo(el, toElementId) {
		},
		setFocus: function setFocus(elId) {

		},
		scrollHandler: function () {
			var story = this;
			var totalHeight = 0;
			if (typeof window.personetics.getDeviceType === 'function' && window.personetics.getDeviceType() === "RJS") {
                $(document).bind("scroll", function (event) {
                    var scrollTop = $(this.frameEl).scrollTop();
                    story.blockSessionManager.handleEvent("scroll", scrollTop);
                });
			}
			$(this.frameEl).bind("scroll", function (event) {
				var scrollTop = $(this.frameEl).scrollTop();
				story.blockSessionManager.handleEvent("scroll", scrollTop);
			});

		}
	});
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.accessibility = {};
    Personetics.utils.accessibility.isFocusable = function isFocusable(element) {

        //check if element is hidden from screen reader.
        if ($(element).is('[aria-hidden="true"], [aria-hidden="true"] *'))
            return false;
        //retrieve only text not nested in child tags.
        var hasText = $(element).contents().not($(element).children()).text().trim().length > 0;
        if ($(element).is(":input, [role], [aria-label], [aria-labelledby]") || hasText)
            return true;
        return false;

    };
    Personetics.utils.accessibility.firstChildFocusable = function firstChildFocusable(element) {

        if(typeof element == 'undefind' || element == null || element.length == 0){
            return false
        }
        var me = this;
        var elementChildren = element.find('*');
        var result = false;
        $.each(elementChildren, function(i, elem){
            result = me.isFocusable(elem);
            if(result == true){
                result = elem;
                return false;
            }
        });
        return result;

    };
    Personetics.utils.accessibility.formatAccessibleDate = function formatAccessibleDate (dateStr) {
        var lang = Personetics.processor.PStoryConfig.getConfig("lang");
        var formattedDate;
        if (lang === 'he' || lang === 'HE' || lang === 'He') {
            var day = Personetics.utils.date.dayName(dateStr, lang);
            var dayNumber = Personetics.utils.date.dayNumber(dateStr);
            var dateText = "";
            var month = Personetics.utils.date.monthName(dateStr, lang);
            var year = Personetics.utils.date.yearNumber(dateStr);

            (dayNumber > 10) ? dateText += "ה" + day + " " : dateText += day + " ";
            dateText += "ל" + month + " " + year;
            formattedDate = dateText;
        }
        return formattedDate;
    };

    Personetics.utils.accessibility.trackFocus = function trackFocus(element) {
        if (typeof element === "undefined" || element.length === 0) {
            return;
        }
        var usingMouse;
        var el = element.get(0);
        var preFocus = function (event) {
            usingMouse = (event.type === 'mousedown');
        };

        var addFocus = function (event) {
            if (usingMouse) {
                var className =  event.target.getAttribute("class");
                event.target.setAttribute("class",className +' personetics-mouse-focus');
            }
        };

        var removeFocus = function (event) {
            var className =  event.target.getAttribute("class");
            if(className !== null) {
                className = className.replace(/ personetics-mouse-focus/g, '');
                event.target.setAttribute("class", className);
            }
        };

        var bindEvents = function () {

            el.removeEventListener('keydown', preFocus);
            el.removeEventListener('mousedown', preFocus);
            el.removeEventListener('focusin', addFocus);
            el.removeEventListener('focusout', removeFocus);

            el.addEventListener('keydown', preFocus);
            el.addEventListener('mousedown', preFocus);
            el.addEventListener('focusin', addFocus);
            el.addEventListener('focusout', removeFocus);
        };
        bindEvents();
    };
    Personetics.utils.accessibility.addAltTextToElement = function addAltTextToElement(element, altText){
        var accessibilityElementWrapper = $('<div class="perso-accessibility-wrapper perso-accessibility-account-selector"></div>');
        var accessibilityElement = $('<span class="perso-accessibility-read"  role="text">'+ altText +'</span>');
        accessibilityElementWrapper.append(accessibilityElement);
        $(element).prepend(accessibilityElementWrapper);
        accessibilityElement.height($(element).outerHeight());
        accessibilityElement.width($(element).width());
    };

    Personetics.utils.accessibility.putFocus = function putFocus(elementForFocus) {
        var $element = $(elementForFocus);
        var focusInterval = 10; // ms, time between function calls
        var focusTotalRepetitions = 10; // number of repetitions

        $element.attr('tabindex', '0');
        $element.blur();

        var focusRepetitions = 0;
        var interval = window.setTimeout(function () {
            $element.focus();
        }, focusInterval);
    };

})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    var allAccountsAnimation = function allAccountsAnimation(){
        var animationMap = {};

        var isValidate = function isValidate(animationObj){
            var isValid = false;
            if(typeof animationObj.type === 'undefined' || animationObj.type === null){
                Personetics.error("Required property 'type' is missing");
            }
            else if(typeof animationObj.doAnimation === 'undefined' || animationObj.doAnimation === null){
                Personetics.error("Required property 'doAnimation' is missing");
            }
            else if(typeof animationObj.cancelAnimation === 'undefined' || animationObj.cancelAnimation === null){
                Personetics.error("Required property 'cancelAnimation' is missing");
            }
            else
                isValid = true;
            return isValid;
        }

        function addAnimation(animationObj){
            if(isValidate(animationObj)){
                animationMap[animationObj.type] = {
                    doAnimation: animationObj.doAnimation,
                    cancelAnimation: animationObj.cancelAnimation
                }
            }
        }

        var getAnimation = function getAnimation(type){
            if(animationMap.hasOwnProperty(type)){
                return animationMap[type];
            }
            else Personetics.error("All accounts animation doesn't support this type: " + type);
        } 

        function init(){
            addAnimation({
                type: 'heapCards',
                doAnimation: function allAccountsAnimation_heapCards(selectedCard, cards, params) {
                    /*set cards left,top and z-index css attr to be in the position of the selected card,
                      each one behind and a bit below the previous
                    */
                    var cardsLength = cards.length;
                    var totalHeight = params.cardsStackTotalHeight|| $(cards).height() / 5;
                    var maxSpaceBetweenCards = params.maxSpaceBetweenCards || 10;
                    var topSpacing = Math.min(maxSpaceBetweenCards, totalHeight / cardsLength);
                    var realTotalHeight = cardsLength * topSpacing;
                    var topValue = (totalHeight - realTotalHeight) / 2;
                    $(selectedCard).css('top', topValue + 'px');
                    $(selectedCard).css('zIndex',  cardsLength+ 1);
                    $.each(cards, function (index, card) {
                        var selectedCardLeft = $(selectedCard).offset().left;
                        var offsetLeft = $(card).offset().left;
                        var left = parseInt($(card).css('left'));
                        var setLeftValue = selectedCardLeft - offsetLeft + left;
                        if(params.isRTL){
                            setLeftValue *= -1;
                        }
                        $(card).css({ 'left': setLeftValue + 'px', 'top': ((index + 1) * topSpacing + topValue) + 'px', 'zIndex': cardsLength - index }); 
                    });  
                    if(params.showBoxShadowForLastCardOnly){
                        cards.last().addClass('pstory-boxshadow-card');
                    }
                    else cards.add(selectedCard).addClass('pstory-boxshadow-card');
                    if(params.scale){
                        $(selectedCard).css({'transform': 'scalex(1)'}) ; 
                        $.each(cards, function (index, card) {
                            var scaleX = 1 - (index + 1) * params.scale;
                            $(card).css({'transform': 'scalex(' + scaleX + ')'});  
                        });  
                    }
                },
                cancelAnimation: function (cards){
                    cards.css({'left': '', 'top': ''});   
                }
            });
            addAnimation({
                type: 'fadingSlidingOut',
                doAnimation: function allAccountsAnimation_fadingOut(selectedCard, cards, params){
                    var container = params.container || selectedCard.parents('.options-container');
                    $.each(cards.add(selectedCard), function(index, card){
                        var offsetLeft = $(card).offset().left - container.offset().left;
                        var left = parseInt($(card).css('left'));                 
                        var setLeftValue = $('.options-container').width() - offsetLeft + left;
                        $(card).css('left', setLeftValue + 'px') ;                   
                    }); 
                },
                cancelAnimation: function(cards){
                    cards.css({'left': ''});   
                }
            });
        }

        init(); 

        this.addAnimation = addAnimation;
        this.getAnimation = getAnimation;        
    };
    Personetics.utils.allAccountsAnimation = new allAccountsAnimation();

})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.buttonAnimation = {};
    /*
        bind touch events for create animation that add backround to the element that appear on touchstart and disappear on touchend gradually.
    */
    Personetics.utils.buttonAnimation. bindMaterialButtonEventsForAnimation = function bindMaterialButtonEventsForAnimation(elements){
        var rplObj,
            x,
            y,
            ink,
            color,
            rplDelTimer;

        //fix to the problem that when click on inner element of the element (we get to this func) it's not click
        $(elements).bind("click",function(e) {
            $('.ink').siblings().one("click", function(e){
                e.stopPropagation();
            });
             $(e.currentTarget).find('.ink').siblings().click();
         });

        //fade out ripple when unclicked
        $(elements).bind("touchend",function() {
            $('.ink').css({'opacity':'0'});
            delRipple();
        });

        //Delete ripple element 0.8 second after last click
        function delRipple() {
            rplDelTimer = setTimeout(function() {
                $('.ink').remove();
            }, 800)
        }

        $(elements).bind("touchstart", function(e){
            x = e.originalEvent.touches[0].pageX;
            y = e.originalEvent.touches[0].pageY;
            rplObj = $(this); //set $(this) variable for later use
            color = $(this).css('color'); //Set color to code defined in html
            rippleClosed(); //run ripple function
        })

        function rippleClosed() {
            rplObj.prepend('<span class="ink"></span>'); //create ripple		
            ink = rplObj.find('.ink'); //create variable for ink span
            ink.css('background',color); //set ripple color to color variable

            //set diameter of ripple
            if(!ink.height() && !ink.width()) {
                //set diameter to parents width/height (whichever is larger)
                d = Math.max(rplObj.outerWidth(), rplObj.outerHeight());
                ink.css({height: d, width: d});
            }

            //set coordinates of ripple using position of mouse defined earlier
            x = x - rplObj.offset().left - ink.width()/2;
            y = y - rplObj.offset().top - ink.height()/2;
            
            //set the position and animate the expansion
            ink.css({top: y+'px', left: x+'px'}).css({'transform':'scale(1.8)'});
            
            //reset ripple deletion timer
            clearTimeout(rplDelTimer);
        }

        function rippleOpen() {
            rplObj.prepend('<span class="ink"></span>'); //create ripple		
            ink = rplObj.find('.ink'); //create variable for ink span
            ink.css('background',color); //set ripple color to color variable

            //set diameter of ripple
            if(!ink.height() && !ink.width()) {
                //set diameter to parents width/height (whichever is larger)
                d = Math.max(rplObj.outerWidth(), rplObj.outerHeight());
                ink.css({height: d, width: d});
            }

            //set coordinates of ripple using position of mouse defined earlier
            x = rplObj.offset();
            y = rplObj.offset();
            
            //set the position and animate the expansion
            ink.css({top: y+'px', left: x+'px'}).css({'transform':'scale(1.8)'});
            
            //reset ripple deletion timer
            clearTimeout(rplDelTimer);
            }

        };  
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.carouselAnimation = Personetics.utils.carouselAnimation || {};
    /**
     * itemWidth is regular carouselItem width with padding and margin
     * selectedItemWidth is selected carouselItem width with padding and margin
     * numItemsDispaly is the num of items that they are shown every time.
     * 
     * 
     * the html should be:
     * <elementWrapper(div) class ="carousel-animate carousel-wrapper (optional:for disable :carousel-disable)" >
     *      <innerWrapper(div) class ="carousel-inner-wrapper">
     *          <carouselItem(div) class ="carousel-item"></> x num of items
     *      </>
     * </>
     */
    Personetics.utils.carouselAnimation.bindCarouselEventsForAnimation = function bindCarouselEventsForAnimation(elementWrapper, param){

        var innerWrapper;
        var carouselItems;        
        /**items without the clone */
        var carouselItemsBase;
        var config = {};
        var keyCode = {
            "Space": 32,
            "Enter": 13,
            "LeftArrow": 37,
            "RightArrow": 39,
            "UpArrow": 38,
            "DownArrow": 40
        };
        init();

        function init(){
             innerWrapper = $(elementWrapper).find('.carousel-inner-wrapper');
             carouselItemsBase = innerWrapper.find('.carousel-item');
             innerWrapper.attr('num-original-cards', carouselItemsBase.length);

             if(typeof param == 'undefined'){
                 param = {};
             }

             if(typeof param.itemWidth != 'undefined'){
                 config.itemWidth = param.itemWidth;
             }

             if(typeof param.selectedItemWidth != 'undefined'){
                 config.selectedItemWidth = param.selectedItemWidth;
             }

             if(typeof param.numItemsDispaly == 'undefined'){
                 param.numItemsDispaly = 3;//default display 3 items
             }
             
             /**clone cards for carousel*/
             if(carouselItemsBase.length > 1){
                    var copyData = carouselItemsBase.clone(true);
                    copyData.attr('clone', 'true');
                    var copyData2 = copyData.clone(true);
                    innerWrapper.prepend($(copyData));             
                    innerWrapper.append($(copyData2).slice(0, 2));
             }
             carouselItems = innerWrapper.find('.carousel-item');
             setConfig(config.itemWidth, config.selectedItemWidth);
             this.dotAnimation = new Personetics.utils.DotAnimation.bindDotEventsForAnimation(elementWrapper, carouselItemsBase, param);
             this.dotAnimation.setSelectedDot();
             setNumItemsToDispaly(param.numItemsDispaly);
             bindEvents();
             caruselAccessibility();
        };

        function setConfig(itemWidth, selectedItemWidth){
            /**set the width */
                if(typeof itemWidth == 'undefined'){
                    itemWidth =  carouselItemsBase.filter(':not(.selected)').outerWidth(true);
                }
                if(typeof selectedItemWidth == 'undefined'){
                    selectedItemWidth = carouselItemsBase.filter('.selected').outerWidth(true);
                }

                config.itemWidth = itemWidth;
                config.selectedItemWidth = selectedItemWidth;
            /**left */
                var left = 0;
                var left2 = 0;

                /**find the selected, if there isn't selected slect the first */
                    var selectedIndex = -1;
                    $.each(carouselItemsBase, function(index,item){
                        if($(item).hasClass('selected')){
                            selectedIndex = index;
                        }
                    });
                    if(selectedIndex == -1){
                        selectedIndex = 0;
                        var pstoryId = carouselItemsBase.first().attr("pstory-id");
                        //add selected to first item and its clone cards
                        carouselItems.filter("[pstory-id='" + pstoryId + "']").addClass('selected');
                    }

                /**set the left value*/
                    var carouselItemsBaseLength = carouselItemsBase.length;
                    if(carouselItemsBaseLength > 1){
                        left -= itemWidth * (carouselItemsBaseLength -1); /*all items width exclude selected clone*/
                        left -= selectedItemWidth;/*add selected clone width*/
                    }
                    left2 = (elementWrapper.width() - selectedItemWidth) /2; //the size of the part of card we see
                    left += left2;
                    var left3 = left - (itemWidth * selectedIndex);

                /**save the minLeft in the config */
                    config.minLeft = left;

                /**set the left css*/
                    innerWrapper.css({'transition-duration': '0s','-webkit-transition-duration': '0s'});
                    innerWrapper.css({'left': left3 + 'px'/*, '-webkit-transform': 'translateX(' + left3 + 'px)'*/});
                /**set selected index dot
                 * selected dot index has to be in the middle
                 */
        };
        function setNumItemsToDispaly(numItemsDispaly){
            if(typeof numItemsDispaly == 'number'){
                config.numItemsDispaly = numItemsDispaly;

                if(numItemsDispaly > carouselItemsBase.length){
                    carouselItems.filter("[clone='true']").addClass('carousel-hide-clone');
                }
                else{
                    carouselItems.removeClass('carousel-hide-clone');
                }
            }
        }

        function bindEvents(){
            if(param.onClick !== false){
                 carouselItems.bind('click', function(e){
                     if($(elementWrapper).hasClass('carousel-disable') == false){
                        startCarousel(e);
                     }
                 });

                $("#personetics-teaser-widget-carousel").bind('keydown', function(e){
                    if(e.target === document.activeElement) {
                        if ([keyCode.RightArrow].indexOf(e.which) !== -1) {
                            onSwipe('right');
                        }
                        if ([keyCode.LeftArrow].indexOf(e.which) !== -1) {
                            onSwipe('left');
                        }
                        if ([keyCode.Enter].indexOf(e.which) !== -1) {
                            $(this).find(".account-button.selected").click();
                        }
                    }
                });
             }
             if(param.onSwipe !== false){
                $(elementWrapper).swipe(function(e){
                    if($(elementWrapper).hasClass('carousel-disable') == false){
                        onSwipe(e);
                    }
                },{preventDefault: false});
            }
        };

        function startCarousel(e){
            if(typeof param.beforeCarouselStart == 'function'){
                param.beforeCarouselStart(e);
            }
            doAnimation(e, param.animateDuration);
            if(param.showIndexDots)
                this.dotAnimation.updateIndex(e);
        };

        function onSwipe(e){
            /**prevent swipe */
            if($(elementWrapper).hasClass('carousel-disable') || config.disableInputSelect){
                if(param && param.onAnimationEnd){
                    param.onAnimationEnd();
                }
                return;
            }
            /**do swipe only on swipe left or right */
            if(e =='left' || e =='right'){
                var carouselItemsLength = carouselItems.length;
                var indexSelected = carouselItemsBase.filter('.selected').index();
                var direction = e =='left'? 1 : -1;
                /**the selected is the next item to the swipe direction */
                indexSelected += direction;
                
                /**edge */
                if(indexSelected == carouselItemsLength){
                    indexSelected = 0;
                }
                if(indexSelected < 0){
                    indexSelected = carouselItemsLength -1;
                }

                if(carouselItemsBase.length < config.numItemsDispaly && $(carouselItems[indexSelected]).attr('clone') == 'true') {
                    config.swipeDirection = null;
                    if (param && param.onAnimationEnd) {
                        param.onAnimationEnd();
                    }
                    return;
                }
                config.swipeDirection = direction * -1;
                var event ={};
                event.swipeDirection = e;
                event.currentTarget = carouselItems[indexSelected];
                startCarousel(event);
            }
        };
        function caruselAccessibility(){
                var selectedShow = carouselItems.filter(".selected:not([clone='true'])");
                selectedShow.siblings().attr("aria-hidden",true);
                selectedShow.attr("aria-hidden",true);

                //selectedShow.prev().attr("aria-hidden",false);
                //selectedShow.next().attr("aria-hidden",false);
                //TODO
                selectedShow.prev().addClass("prev");
                selectedShow.next().addClass("next");

                
                //TODO
                 selectedShow.prev().addClass("prev");
                 selectedShow.next().addClass("next");

                carouselItems.removeAttr("aria-label");
                if (typeof param.text != "undefined" ){
                    if(typeof param.text.next != "undefined")
                        selectedShow.next().attr("aria-label",param.text.next);
                    if(typeof param.text.prev != "undefined")
                        selectedShow.prev().attr("aria-label",param.text.prev);
                }

        };
         function setAccessibilityFocus(waitTime) {
            var selectedShow = param && param.isDesktop ? null : $(".pstory-account-button.selected");
            if(selectedShow && selectedShow.length < 1) {
                carouselItems.filter(".selected:not([clone='true'])")
            }
            var focusInterval = 10 + waitTime; // ms, time between function calls
            var focusTotalRepetitions = 10; // number of repetitions

             if(selectedShow) {
                 selectedShow.attr('tabindex', '0');
                 selectedShow.blur();
             }

            var focusRepetitions = 0;
            var interval = window.setTimeout(function() {
                if (selectedShow) {
                    selectedShow.focus();
                }
                if (param && param.onAnimationEnd) {
                    param.onAnimationEnd();
                }
                //   focusRepetitions++;
                //   if (focusRepetitions >= focusTotalRepetitions) {
                //     window.clearInterval(interval);
                //   }
            }, focusInterval);
        };
        function doAnimation(e, animateDuration){
            var target = e.currentTarget;
            if($(target).hasClass('selected') || config.disableInputSelect ==true){
                return;
            }

             var direction = config.swipeDirection;
            if(direction == null){
               direction = $(target).hasClass("prev") ? 1 : -1;
            }

            config.disableInputSelect = true;
            carouselItems.removeClass('selected');
            carouselItems.removeClass('prev');
            carouselItems.removeClass('next');

            var targetId = $(target).attr('pstory-id');//item id
            carouselItems.filter('[pstory-id="'+ targetId +'"]').addClass('selected');//add selected to all clone of current card

            


            if(typeof animateDuration != 'number'){
                animateDuration = 300;
            }

            var carouselItemsBaseLength = carouselItemsBase.length;

            var minLeft = config.minLeft;
            var maxLeft = minLeft - (config.itemWidth * (carouselItemsBaseLength - 1) + config.selectedItemWidth);
            var oldLeft = 0;
            oldLeft = parseFloat(innerWrapper.css('left'));
               
            var newLeft =  config.itemWidth * direction + oldLeft;
            var diff = config.selectedItemWidth - config.itemWidth;

            /**if there is 2 selected buttons before the selected */
                var selectedIndex = $(target).index();
                var prev = innerWrapper.find('.carousel-item:lt(' + selectedIndex +')');
                var numSelect = prev.filter('.selected').length;
                if(numSelect > 1){
                    newLeft = newLeft - diff;
                }
            /**if there is no selected button before the selected */
                else if(/*numButtons > 2 &&*/ numSelect == 0){
                    newLeft = newLeft + diff;
                }


            /**animation and callback*/
                setTimeout( function() {
                    /**move without animation */
                    innerWrapper.css({'transition-duration': '0s','-webkit-transition-duration': '0s'});
                    /**if it arrive to clone button change the transform to the same button original */
                    if(Math.abs(newLeft) >= Math.abs(maxLeft) - diff){
                        innerWrapper.css({'left': minLeft + 'px'/*, '-webkit-transform': 'translateX(' + minLeft + 'px)'*/});
                    }
                    else if(Math.abs(newLeft) < Math.abs(minLeft) - diff){
                        maxLeft = maxLeft + config.itemWidth + diff;
                        innerWrapper.css({'left':  maxLeft + 'px'/*, '-webkit-transform': 'translateX(' + maxLeft + 'px)'*/});
                    }
                    config.disableInputSelect = false;
                    if(typeof param.afterCarouselEnd == 'function'){
                        param.afterCarouselEnd();

                    }
                },animateDuration);
                /**move with animation */
                    innerWrapper.css({'transition-duration': animateDuration + 'ms','-webkit-transition-duration': animateDuration + 'ms'});
                    innerWrapper.css({'left': newLeft + 'px'/*, '-webkit-transform': 'translateX(' + newLeft + 'px)'*/});
                config.swipeDirection = null; //to remove the swipe
                caruselAccessibility();
                setAccessibilityFocus(animateDuration);
        };
        this.startCarousel = startCarousel;
        this.setConfig = setConfig;
        this.setNumItemsToDispaly = setNumItemsToDispaly;
        this.onSwipe = onSwipe;
    };
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.carouselAnimation = Personetics.utils.carouselAnimation || {};
  /**
     * itemWidth: is regular carouselItem width with padding and margin
     * selectedItemWidth: is selected carouselItem width with padding and margin
     * numItemsDispaly is: the num of items that they are shown every time.
     * showArrows: show arrows
     * minItemsForDisplayingArrows: minimum items in the carousel for show the arrows
     * infiniteCarousel: enable infinite carousel
     * numItemsDispaly: number of items that display in viewport
     * showIndexDot: show the dots
     * afterCarouselEnd: function that invoke after the carousel end.
     * beforeCarouselStart: function that invoke before the carousel start
     * 
     * the html should be:
     * <elementWrapper(div) class ="carousel-animate carousel-wrapper (optional:for disable :carousel-disable)" >
     *      <outerWrapper(div) class ="carousel-outer-wrapper">
     *      <innerWrapper(div) class ="carousel-inner-wrapper">
     *          <carouselItem(div) class ="carousel-item"></> x num of items
     *      </>
     * </>
     */
    Personetics.utils.carouselAnimation.bindMultiCarouselEventsForAnimation = function bindMultiCarouselEventsForAnimation(elementWrapper, param) {

        var outerWrapper;
        var innerWrapper;
        var carouselItems;
        /**items without the clone */
        var carouselItemsBase;
        var config = {};
        init();

        function init() {
            outerWrapper = $(elementWrapper).find('.carousel-outer-wrapper');
            innerWrapper = $(elementWrapper).find('.carousel-inner-wrapper');
            carouselItemsBase = innerWrapper.find('.carousel-item');
            innerWrapper.attr('num-original-cards', carouselItemsBase.length);

            if (typeof param == 'undefined') {
                param = {};
            }

            setItemsWidth(param.itemWidth, param.selectedItemWidth);

            if (typeof param.numItemsDispaly == 'undefined') {
                param.numItemsDispaly = 3;//default display 3 items
            }

            /**clone cards for carousel*/
            if (carouselItemsBase.length > 1) {
                var copyData = carouselItemsBase.clone(true);
                copyData.attr('clone', 'true');
                if (param.infiniteCarousel === false) {
                    copyData.addClass('carousel-hide-clone');
                }
                var copyData2 = copyData.clone(true);
                innerWrapper.prepend($(copyData));
                var cloneOnEnd = param.numItemsDispaly - 1 < 2 ? 2 : param.numItemsDispaly - 1
                innerWrapper.append($(copyData2).slice(0, cloneOnEnd));
            }
            carouselItems = innerWrapper.find('.carousel-item');
            setConfig(config.itemWidth, config.selectedItemWidth);
            /**dot animation */
            this.dotAnimation = new Personetics.utils.DotAnimation.bindDotEventsForAnimation(elementWrapper, carouselItemsBase, param);
            this.dotAnimation.setSelectedDot();
            setNumItemsToDispaly(param.numItemsDispaly);
            bindEvents();
            carouselAccessibilityInit();
        };
        function setItemsWidth(itemWidth, selectedItemWidth) {
            /**set the width */
            if (typeof itemWidth == 'undefined') {
                itemWidth = carouselItemsBase.filter(':not(.selected)').outerWidth(true);
            }
            if (typeof selectedItemWidth == 'undefined') {
                selectedItemWidth = carouselItemsBase.filter('.selected').outerWidth(true);
            }

            config.itemWidth = itemWidth;
            config.selectedItemWidth = selectedItemWidth;
        };

        function setConfig(itemWidth, selectedItemWidth) {
            /**set the width */
            setItemsWidth(itemWidth, selectedItemWidth);
            /**left */
            var left = 0;
            var left2 = 0;

            /**find the selected, if there isn't selected slect the first */
            var selectedIndex = -1;
            $.each(carouselItemsBase, function (index, item) {
                if ($(item).hasClass('selected')) {
                    selectedIndex = index;
                }
            });
            if (selectedIndex == -1) {
                selectedIndex = 0;
                var pstoryId = carouselItemsBase.first().attr("pstory-id");
                //add selected to first item and its clone cards
                carouselItems.filter("[pstory-id='" + pstoryId + "']").addClass('selected');
            }

            /**set the left value*/
            var carouselItemsBaseLength = carouselItemsBase.length;
            if (carouselItemsBaseLength > 1) {
                left -= itemWidth * (carouselItemsBaseLength - 1); /*all items width exclude selected clone*/
                left -= selectedItemWidth;/*add selected clone width*/
            }
            left2 = (outerWrapper.width() - selectedItemWidth) / 2; //the size of the part of card we see
            left += left2;
            var left3 = left - (itemWidth * selectedIndex);

            /**save the minLeft in the config */
            config.minLeft = left;

            /**set the left css*/
            innerWrapper.css({ 'transition-duration': '0s', '-webkit-transition-duration': '0s' });
            innerWrapper.css({ 'left': left3 + 'px'/*, '-webkit-transform': 'translateX(' + left3 + 'px)'*/ });
            /**set selected index dot
             * selected dot index has to be in the middle
             */
            if(param.infiniteCarousel === false)
                disableArrows();
        };
        function setNumItemsToDispaly(numItemsDispaly) {
            if (typeof numItemsDispaly == 'number') {
                config.numItemsDispaly = numItemsDispaly;

                if (numItemsDispaly > carouselItemsBase.length || param.infiniteCarousel === false) {
                    carouselItems.filter("[clone='true']").addClass('carousel-hide-clone');
                }
                else {
                    carouselItems.removeClass('carousel-hide-clone');
                }
            }
        }

        function bindEvents() {
            if (param.onClick !== false) {
                carouselItems.bind('click', function (e) {
                    if ($(elementWrapper).hasClass('carousel-disable') == false) {
                        itemClicked(e);
                    }
                    else {
                        afterCarouselEnd();
                    }
                });
                $(elementWrapper).find('.pstory-carousel-arrow').bind('click', function (e) {
                    if ($(elementWrapper).hasClass('carousel-disable') == false) {
                        arrowClicked(e);
                    }
                    else {
                        afterCarouselEnd();
                    }
                });

                innerWrapper.bind('keydown', function (e) {
                    var keyCode = {
                        "LeftArrow": 37,
                        "RightArrow": 39
                    };
                    if (e.target === document.activeElement) {
                        if ([keyCode.RightArrow].indexOf(e.which) !== -1) {
                            onSwipe('right');
                        }
                        if ([keyCode.LeftArrow].indexOf(e.which) !== -1) {
                            onSwipe('left');
                        }
                    }
                });
            }
            if (param.onSwipe !== false) {
                $(elementWrapper).swipe(function (e) {
                    if ($(elementWrapper).hasClass('carousel-disable') == false) {
                        onSwipe(e);
                    }
                }, { preventDefault: false });
            }
        };

        function itemClicked(e) {
            var target = e.currentTarget;
            var selected = carouselItemsBase.filter('.selected');
            var selectedIndex = selected.index();
            config.swipeDirection = selectedIndex - $(target).index();
            if (!($(e.currentTarget).hasClass('selected') || config.disableInputSelect == true)) {
                startCarousel(e);
            }
        };
        function arrowClicked(e) {
            var target = e.currentTarget;
            var direction = $(target).hasClass('pstory-carousel-arrow-next') ? 'left' : 'right';
            onSwipe(direction);
        };
        function onSwipe(e) {
            /**prevent swipe */
            if ($(elementWrapper).hasClass('carousel-disable') || this.disableInputSelect) {
                afterCarouselEnd();
                return;
            }
            /**do swipe only on swipe left or right */
            if (e == 'left' || e == 'right') {
                var carouselItemsLength = carouselItems.length;
                var indexSelected = carouselItemsBase.filter('.selected').index();
                var direction = e == 'left' ? 1 : -1;
                /**the selected is the next item to the swipe direction */
                indexSelected += direction;

                /**edge */
                if (indexSelected == carouselItemsLength) {
                    indexSelected = 0;
                }
                if (indexSelected < 0) {
                    indexSelected = carouselItemsLength - 1;
                }

                if ((carouselItemsBase.length < config.numItemsDispaly || param.infiniteCarousel === false)
                    && $(carouselItems[indexSelected]).attr('clone') == 'true') {
                    config.swipeDirection = null;
                    afterCarouselEnd();
                    return;
                }
                config.swipeDirection = direction * -1;
                var event = {};
                event.swipeDirection = e;
                event.currentTarget = carouselItems[indexSelected];

                if (!($(e.currentTarget).hasClass('selected') || config.disableInputSelect == true)) {
                    startCarousel(event);
                }
            }
        };
        function disableArrows(){
            var indexSelected = carouselItemsBase.filter('.selected').index();
            var arrowBtns = elementWrapper.find('.pstory-carousel-arrow');
            var nextBtn = arrowBtns.filter('.pstory-carousel-arrow-next');
            var prevBtn = arrowBtns.filter('.pstory-carousel-arrow-prev');
            
            prevBtn.removeClass('arrow-disable');
            nextBtn.removeClass('arrow-disable');
            if($(carouselItems[indexSelected + 1]).attr('clone') == 'true'){
                nextBtn.addClass('arrow-disable');
            }
            if($(carouselItems[indexSelected - 1]).attr('clone') == 'true'){
                prevBtn.addClass('arrow-disable');
            }
        };
        function startCarousel(e) {
            if (typeof param.beforeCarouselStart == 'function') {
                param.beforeCarouselStart(e);
            }
            doAnimation(e, param.animateDuration);
            if(param.infiniteCarousel === false)
                disableArrows();
            if (param.showIndexDots)
                this.dotAnimation.updateIndex(e);
        };

        function doAnimation(e, animateDuration) {
            var target = e.currentTarget;

            var direction = config.swipeDirection;
            if (direction == null) {
                direction = 1;
            }

            config.disableInputSelect = true;
            carouselItems.removeClass('selected');

            var targetId = $(target).attr('pstory-id');//item id
            carouselItems.filter('[pstory-id="' + targetId + '"]').addClass('selected');//add selected to all clone of current card

            if (typeof animateDuration != 'number') {
                animateDuration = 300;
            }

            var carouselItemsBaseLength = carouselItemsBase.length;

            var minLeft = config.minLeft;
            var maxLeft = minLeft - (config.itemWidth * (carouselItemsBaseLength - 1) + config.selectedItemWidth);
            var oldLeft = 0;
            oldLeft = parseFloat(innerWrapper.css('left'));

            var newLeft = config.itemWidth * direction + oldLeft;
            var diff = config.selectedItemWidth - config.itemWidth;

            /**if there are 2 selected buttons before the selected */
            var selectedIndex = $(target).index();
            var prev = innerWrapper.find('.carousel-item:lt(' + selectedIndex + ')');
            var numSelect = prev.filter('.selected').length;
            if (numSelect > 1) {
                newLeft = newLeft - diff;
            }
            /**if there is no selected button before the selected */
            else if (/*numButtons > 2 &&*/ numSelect == 0) {
                newLeft = newLeft + diff;
            }


            /**animation and callback*/
            setTimeout(function () {
                /**move without animation */
                innerWrapper.css({ 'transition-duration': '0s', '-webkit-transition-duration': '0s' });
                /**if it arrive to clone button change the transform to the same button original */
                if (Math.abs(newLeft) >= Math.abs(maxLeft) - diff) {
                    var min = minLeft + (newLeft - maxLeft);
                    innerWrapper.css({ 'left': min + 'px' });
                }
                else if (Math.abs(newLeft) < Math.abs(minLeft) - diff) {
                    maxLeft = maxLeft + (Math.abs(minLeft) - Math.abs(newLeft));
                    innerWrapper.css({ 'left': maxLeft + 'px' });
                }
                config.disableInputSelect = false;
                carouselAccessibility();
                afterCarouselEnd();
            }, animateDuration);
            /**move with animation */
            innerWrapper.css({ 'transition-duration': animateDuration + 'ms', '-webkit-transition-duration': animateDuration + 'ms' });
            innerWrapper.css({ 'left': newLeft + 'px' });
            config.swipeDirection = null; //to remove the swipe
            setAccessibilityFocus(animateDuration);
        };
        function carouselAccessibilityInit() {
            var selectedShow = carouselItems.filter(".selected:not([clone='true'])");
            carouselItems.attr("aria-hidden", true);

            var arrowBtns = elementWrapper.find('.pstory-carousel-arrow');
            var nextBtn = arrowBtns.filter('.pstory-carousel-arrow-next');
            var prevBtn = arrowBtns.filter('.pstory-carousel-arrow-prev');
            var selectBtn = elementWrapper.find('.pstory-acc-carousel-selected');
            var selectedOffset = selectedShow.offset();
            var wrapperOffset = elementWrapper.offset();
            var selectPosition = {
                height: selectedShow.innerHeight(true),
                width: selectedShow.innerWidth(true),
                left: selectedOffset.left - wrapperOffset.left,
                top: selectedOffset.top - wrapperOffset.top,
                position: 'absolute',
                opacity: 0
            }
            selectBtn.css(selectPosition);
            if (param.showArrows == true) {
                arrowBtns.removeClass('pstory-carousel-arrow-hidden');
            }
            else{
                var prevShow = carouselItems.filter(".selected:not([clone='true'])").prev();
                if(prevShow.length > 0){
                    var prevShowWidth = prevShow[0].getBoundingClientRect().width;
                    var prevShowOffset = prevShow.offset();
                    var prevPosition = {
                        height: prevShow[0].getBoundingClientRect().height,
                        width: prevShowWidth + prevShowOffset.left,
                        left: 0,
                        top: prevShowOffset.top - wrapperOffset.top,
                        position: 'absolute'
                    }
                    prevBtn.css(prevPosition);
                } else{
                    prevBtn.hide();
                }
                var nextShow = carouselItems.filter(".selected:not([clone='true'])").next();
                if(nextShow.length > 0){
                    var nextShowOffset = nextShow.offset();
                    var nextPosition = {
                        height: nextShow[0].getBoundingClientRect().height,
                        width: nextShow.parent().width() - nextShowOffset.left,
                        right: 0,
                        top: nextShowOffset.top - wrapperOffset.top,
                        position: 'absolute'
                    }
                    nextBtn.css(nextPosition);
                } else{
                    prevBtn.hide();
                }
            }
            selectBtn.bind('click', function(e){
                carouselItemsBase.filter('.selected').click();
            });
            carouselAccessibility();
        };
        function carouselAccessibility() {
            var selectedShow = carouselItemsBase.filter('.selected');
            var prevShow = selectedShow.prev();
            var nextShow = selectedShow.next();
            var selectBtn = elementWrapper.find('.pstory-acc-carousel-selected');
            var arrowBtns = elementWrapper.find('.pstory-carousel-arrow');
            var nextBtn = arrowBtns.filter('.pstory-carousel-arrow-next');
            var prevBtn = arrowBtns.filter('.pstory-carousel-arrow-prev');
            if(param.infiniteCarousel === false){
                if (prevShow.css('visibility') == 'hidden') {
                    prevBtn.attr('aria-hidden', true);
                }
                else {
                    prevBtn.attr('aria-hidden', false);
                }
            } 
            else{
                prevBtn.attr('aria-hidden', 'true');
            }
            if (nextShow.css('visibility') == 'hidden') {
                nextBtn.attr('aria-hidden', true);
            }
            else {
                nextBtn.attr('aria-hidden', false);
            }
            selectBtn.attr("aria-label", selectedShow.attr('aria-label'));
        };
        function setAccessibilityFocus(waitTime) {
            var selectBtn = elementWrapper.find('.pstory-acc-carousel-selected');
            var focusInterval = 10 + waitTime; // ms, time between function calls
            var focusTotalRepetitions = 10; // number of repetitions

            if (selectBtn) {
                selectBtn.attr('tabindex', '0');
                selectBtn.blur();
            }

            var focusRepetitions = 0;
            var interval = window.setTimeout(function () {
                if (selectBtn) {
                    selectBtn.attr('aria-label', elementWrapper.find('.carousel-item.selected').attr('aria-label'));
                    selectBtn.focus();
                }
            }, focusInterval);
        };
        function afterCarouselEnd() {
            if (typeof param.afterCarouselEnd == 'function') {
                param.afterCarouselEnd();
            }
        }
        this.startCarousel = startCarousel;
        this.setConfig = setConfig;
        this.setNumItemsToDispaly = setNumItemsToDispaly;
        this.onSwipe = onSwipe;
    };
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.DotAnimation = {};

    Personetics.utils.DotAnimation.bindDotEventsForAnimation = function bindDotEventsForAnimation(elementWrapper, options, params) {
        this.elementWrapper = elementWrapper;
        this.params = params;
        this.setSelectedDot = function setSelectedDot() {
            var selectedIndex = 0;
            $.each(options, function (index, item) {
                if ($(item).hasClass('selected')) {
                    selectedIndex = index;
                }
            });
            if (params.showIndexDots) {
                var indexDots = this.elementWrapper.find('.carousel-index-wrapper .carousel-index-dot');
                if (params.firstDot) {
                    $(indexDots[0]).addClass('pstory-selected-index');
                    $.each(indexDots, function (index, item) {//set pstory-id for index dots
                        var temp = index;
                        $(item).attr('pstory-id', $(options[temp]).attr('pstory-id'));
                    })
                }
                else {
                    var itemsNum = options.length;
                    var middle = Math.ceil(itemsNum / 2) - 1;
                    var diff = middle - selectedIndex;
                    if (diff < 0)
                        diff = itemsNum + diff;
                    var index = 0;
                    for(var i = 0; i < options.length ; i++){
                        if($(options[i]).hasClass("selected")){
                            index = i;
                            break;
                        }
                    }
                    $(indexDots[index]).addClass('pstory-selected-index');
                    $.each(indexDots, function (index, item) {//set pstory-id for index dots
                        var temp = index;
                        $(item).attr('pstory-id', $(options[temp]).attr('pstory-id'));
                    })
                }
            }
        };
        this.updateIndex = function updateIndex(e) {
            var target = e.currentTarget;
            var id = $(target).attr('pstory-id');
            var dotsWrapper = this.elementWrapper.find('.carousel-index-wrapper');
            var indexDots = dotsWrapper.find('.carousel-index-dot');
            if(this.params && this.params.updateDotsForAccessibility){
                this.params.updateDotsForAccessibility(dotsWrapper, id);
            }
            indexDots.removeClass('pstory-selected-index');
            indexDots.filter('[pstory-id="' + id + '"]').addClass('pstory-selected-index');
        };
    };


})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, undefined){

	Personetics.utils = Personetics.utils ? Personetics.utils : {};
	Personetics.utils.assert = {};
	Personetics.utils.assert.isUndefined = function isUndefined(obj) {
		return typeof obj === 'undefined';
	};

	Personetics.utils.assert.isNullOrUndefined = function isNullOrUndefined(obj) {
		return typeof obj === 'undefined' || obj == null;
	};

	Personetics.utils.assert.isTrue = function isTrue(obj) {
		var result = !Personetics.utils.assert.isUndefined(obj);
		return result && obj == true;
	};

	Personetics.utils.assert.isDefined = function isDefined(obj, nullable) {
		var result = !Personetics.utils.assert.isUndefined(obj);
		if(result && !Personetics.utils.assert.isUndefined(nullable) && nullable != null) {
			if(!nullable)
				result = obj != null;
		}
		return result;
	};

	Personetics.utils.assert.AssertIsDefined = function AssertIsDefined(obj, errorMessage) {
		if(Personetics.utils.assert.isNullOrUndefined(obj))
		{
			if(errorMessage)
				Personetics.utils.PLogger.error(errorMessage, errorMessage);
			else
				Personetics.utils.PLogger.error("Object is undefined", "Object is undefined");
		}
	};

	Personetics.utils.assert.assignDefaultValue = function assignDefaultValue(variable, defaultValueToSet) {
		var result = null;
		if (Personetics.utils.assert.isUndefined(variable))
			result = defaultValueToSet;
		else
			result = variable;
		return result;
	};

	Personetics.utils.assert.isObject = function isObject(obj)
	{
		return typeof obj === 'object';
	};

	Personetics.utils.assert.isString = function isString(obj)
	{
		return typeof obj === 'string';
	};

	Personetics.utils.assert.isArray = function isArray(obj)
	{
		return Object.prototype.toString.call(obj) === '[object Array]';
	};

	Personetics.utils.assert.isFunction = function isFunction(obj)
	{
		return typeof obj === 'function';
	};

	Personetics.utils.assert.exists =  function (first, namespace) {
		var tokens = namespace.split('.');

		var obj = first;

		for (var i = 1; i < tokens.length; i++) {
			obj = (obj == "undefined") ? obj : obj[tokens[i]];
		}

		return obj;
	};

	Personetics.utils.assert.AssertIsNullOrUndefined = function(obj, message){
		
	};

})(window, window.Personetics = window.Personetics || {});
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils || {};
    Personetics.utils.d3Extensions = {};

    var persoHelper = Personetics.utils.persoHelper;

    Personetics.utils.d3Extensions.html = function (value) {
        if (typeof value != "string") {
            return;
        }

        else {
            var rootSpan = $('<span>').html(value).first().children()[0];
            if (typeof rootSpan == 'undefined') {
                this.text(value);
            }
            else {
                var tspan = this.append('tspan');
                var attrs = rootSpan.attributes;
                $.each(attrs, function (j, attr) {
                    tspan.attr(attr.name, attr.value);
                });
                var valueChildren = $(rootSpan).children();
                $.each(valueChildren, function (i, node) {
                    var innerTspan = tspan.append('tspan')
                        .text($(node).text());
                    var attrs = node.attributes;
                    $.each(attrs, function (j, attr) {
                        innerTspan.attr(attr.name, attr.value);
                    });
                });
            }
        }
    };
    d3.selection.prototype.html = Personetics.utils.d3Extensions.html;
    Personetics.utils.d3Extensions.text = function text(value) {
        return arguments.length ? this.each(typeof value === "function" ? function () {
            var v = value.apply(this, arguments);
            v = $(v).length > 0 ? $(v)[0].innerText : v;
            this.textContent = v == null ? "" : v;
        } : value == null ? function () {
            this.textContent = "";
        } : function () {
            this.textContent = $(value).length > 0 ? $(value)[0].innerText : value;
        }) : this.textContent;
    };
    Personetics.utils.d3Extensions.last = function () {
        var last = this.size() - 1;
        return d3.select(this[0][last]);
    }
    d3.selection.prototype.last = Personetics.utils.d3Extensions.last;

    if (typeof persoHelper !== 'undefined' && (persoHelper.isOldAndroidVersion())) {
        // In old android versions override d3 "text" function with d3-extension "text" function.
        d3.selection.prototype.text = Personetics.utils.d3Extensions.text;
    }
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, undefined) {

    var monthNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    var monthNames = Personetics.pstoryDictionary.monthNames;
    var daysName = Personetics.pstoryDictionary.weekDays;

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.date = {};
    Personetics.utils.date.dayName = function dayName(dateStr, lang){
        var dayNames = daysName[lang];
        var dayNumber = this.dayNumber(dateStr);
        var dayName;
        if(dayNumber <= 10){
            dayName = dayNames [dayNumber - 1];
        } else {
            dayName = dayNumber;
        }
        return dayName;
    };
    Personetics.utils.date.monthName = function monthName(dateStr, lang, short) {
        if (!(parseInt(dateStr) == dateStr)) {/**safari bug */
            var d = new Date(dateStr);
            var month = d.getMonth();
            if (month != undefined && month != null && !isNaN(month)) {
                month = d.getMonth();
            }
        }
        else {
            try {
                var dn = parseInt(dateStr);
                if (dn >= 1 && dn <= 12) {
                    month = dn - 1;
                }
                else {
                    return dateStr;
                }
            } catch (e) {
                return dateStr;
            }
        }
        if (short == true)
            lang = lang + "-short";
        var names = monthNames[lang];
        if (!names) {
            if (short == true)
                names = monthNames["en-short"];
            else
                names = monthNames["en"];
        }

        return names[month];
    };

    Personetics.utils.date.dayNumber = function dayNumber(dateStr, dayFormat) {
        var parsedDateStr = dateStr.split('.')[0].replace(/T/g, ' ');
        parsedDateStr = parsedDateStr.split('-').join('/');
        dateStr = (isNaN(Date.parse(parsedDateStr))) ? dateStr : parsedDateStr;
        var result = dateStr;
        var date = new Date(dateStr);
        var day = date.getDate();
        if (!isNaN(day))
            result = date.getDate();
        if (dayFormat && dayFormat == "DD") {
            if (result < 10)
                result = "0" + result;
        }
        return result;
    };

    Personetics.utils.date.monthNumber = function monthNumber(dateStr) {
        if (!(parseInt(dateStr) == dateStr)) {/**safari bug */
            var d = new Date(dateStr);
            var month = d.getMonth();
            if (month != undefined && month != null && !isNaN(month)) {
                month = d.getMonth();
            }
        }
        else {
            try {
                var dn = parseInt(dateStr);
                if (dn >= 1 && dn <= 12) {
                    month = dn - 1;
                }
                else {
                    return dateStr;
                }
            } catch (e) {
                return dateStr;
            }
        }
        var monthNum = monthNumbers[month];
        var result = monthNum;
        if (monthNum < 10)
            result = "0" + result;

        return result;
    };

    Personetics.utils.date.yearNumber = function yearNumber(dateStr, isShort) {
        var result = "";
        var d = new Date(dateStr);
        var fullYear = d.getFullYear().toString();
        if (isShort) {
            result = fullYear.substring(2);
        }
        else result = fullYear;
        return result;
    };
    Personetics.utils.date.nthDate = function nthDate(dateStr, lang) {
        dateStr = dateStr.toLowerCase();
        var shortKey =   lang +"-short";
        for(var i=0; i< monthNames[shortKey].length;i++){
            if(dateStr.indexOf(monthNames[shortKey][i].toLowerCase()) !== -1){
                break;
            }
        }
        var dayNumber = dateStr.replace(monthNames[shortKey][i].toLowerCase(),"");
        var month =  monthNames[lang][i];
        function nth(d) {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        }
        var isnum = /^\d+$/.test(dayNumber);
        if(!isnum){
            return month;
        }
        dayNumber = parseInt(dayNumber,10);
        var result = month + " " + dayNumber + nth(dayNumber);
        return result;
    }

})(window, window.Personetics = window.Personetics || {});
(function(window, Personetics, $, undefined){

	Personetics.utils = Personetics.utils ? Personetics.utils : {};
	Personetics.utils.dictionary = {};

	/**
	 * Overrides an object with key value pairs from another.
	 * By default it overrides all keys (including null values). If you want to keep defined values, overrideDefinedVals should be false.
	 * Returns a copy of original
	 */
	Personetics.utils.dictionary.overrideObjectProperties = function(original, override, overrideDefinedVals)
	{

		Personetics.utils.assert.assignDefaultValue(overrideDefinedVals, true);

		var originalCopy = $.extend({}, true, original);

		if(Personetics.utils.assert.isNullOrUndefined(override))
			return originalCopy;
		if(Personetics.utils.assert.isNullOrUndefined(originalCopy))
			return override;

		$.each(override, function(key, value) {
			if(!originalCopy.hasOwnProperty(key) || originalCopy[key] == null || overrideDefinedVals)
				originalCopy[key] = value;
		});

		return originalCopy;
	};

	Personetics.utils.dictionary.hasItem = function hasItem(obj, key, nullable)
	{
		var hasItem = Personetics.utils.assert.isObject(obj) && Personetics.utils.string.isValidString(key) && obj.hasOwnProperty(key);
		return nullable ? hasItem : hasItem && obj[key] != null;
	};
	
	Personetics.utils.dictionary.exists = function exists(obj)
	{
		var args = Array.prototype.slice.call(arguments, 1);

		for (var i = 0; i < args.length; i++) {
			if (!obj || !obj.hasOwnProperty(args[i])) {
				return false;
			}
			obj = obj[args[i]];
		}
		return true;
	};

	Personetics.utils.dictionary.removeInvalids = function removeInvalids(obj)
	{
		var result = {};
		if(typeof obj !== 'undefined' && obj)
		{
			$.each(obj, function(key, value) {
				if(value != null)
				{
					if(Personetics.utils.assert.isObject(value) && !Personetics.utils.assert.isArray(value))
						result[key] = Personetics.utils.dictionary.removeInvalids(value);
					else
						result[key] = value;
				}
			});
		}
		return result;
	};

})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.emojisHelper = {};
    Personetics.utils.emojisHelper.parseEmoji = function parseEmoji(text) {
        var emojisCodes = extractEmojis(text);
        for(var i = 0; i<emojisCodes.length;i++){
            var emojiSymbol = parseHexToEmoji(emojisCodes[i]);
            var emojiRegExp = new RegExp(emojisCodes[i], 'g');
            text = text.replace(emojiRegExp, '<span>' + emojiSymbol + '</span>')
        }
        text = text.replace(/Emoji/g, '').replace(/{{|}}/g, '');
        var parsedText = text;
        return parsedText;
    }

    /**
     * extractEmojis
     * Input: text - for example ("You may want to pay close attention {{Emoji 1F470 1F3FF}} to your spending this week.")
     * Output: text - emojis codes (1F470 1F3FF)
     * */
    var extractEmojis = function (str) {
        var emojisCodes = [];
        var emojiExp = extractEmojiExp(str);
        for(var i = 0; i<emojiExp.length; i++){
            if (emojiExp[i].length) {
                var emojiCode = emojiExp[i];
                emojiCode = emojiCode.replace('Emoji', '');
                emojiCode = emojiCode.replace(/{{|}}/g, '');
                emojiCode = emojiCode.trim();
                if(emojisCodes.indexOf(emojiCode) === -1) {
                    emojisCodes.push(emojiCode);
                }
            }
        }
        return emojisCodes;
    }

    /**
     * parseHexToEmoji
     * Input: emojis codes
     * Output: emoji symbol in hex (&#x1F470&#x1F3FF)
     * */
    var parseHexToEmoji = function (emojisCodes) {
        var emojisCodesArr = emojisCodes.split(' ');
        var emoji = '';
        if (emojisCodesArr.length) {
            for (var i = 0; i < emojisCodesArr.length; i++) {
                emoji += '&#x' + emojisCodesArr[i];
            }
        }
        return emoji;
    }
    /**
     * Input: text
     * Output: text - for example"{{Emoji 1F470 1F3FF}}"*/
    var extractEmojiExp = function (str) {
        var emojiExpArr = [];
        var emojiExpOccurrence = (str.match(/{{Emoji/g) || []).length;
        var emojiOpenBrace = '{{Emoji';
        var emojiCloseBrace = '}}';
        for(var i=0; i<emojiExpOccurrence; i++){
            var expressionStartIndex = str.indexOf(emojiOpenBrace);
            var expressionEndIndex = str.indexOf(emojiCloseBrace) + emojiCloseBrace.length;
            var emojiExp = str.slice(expressionStartIndex, expressionEndIndex);
            str = str.replace(emojiExp,'');
            emojiExpArr.push(emojiExp);
        }
        return emojiExpArr;
    }


})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.encodeDecode = {};
    Personetics.utils.encodeDecode.Base64 = {
        codex : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

        encode : function(input) {
            var output = new Personetics.utils.string.StringBuffer();

            var enumerator = new Personetics.utils.encodeDecode.Utf8EncodeEnumerator(input);
            while (enumerator.moveNext()) {
                var chr1 = enumerator.current;

                enumerator.moveNext();
                var chr2 = enumerator.current;

                enumerator.moveNext();
                var chr3 = enumerator.current;

                var enc1 = chr1 >> 2;
                var enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                var enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                var enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output.append(this.codex.charAt(enc1) + this.codex.charAt(enc2) + this.codex.charAt(enc3) + this.codex.charAt(enc4));
            }

            return output.toString();
        },

        decode : function(input) {
            var output = new Personetics.utils.string.StringBuffer();

            var enumerator = new Personetics.utils.encodeDecode.Base64DecodeEnumerator(input);
            while (enumerator.moveNext()) {
                var charCode = enumerator.current;

                if (charCode < 128)
                    output.append(String.fromCharCode(charCode));
                else if ((charCode > 191) && (charCode < 224)) {
                    enumerator.moveNext();
                    var charCode2 = enumerator.current;

                    output.append(String.fromCharCode(((charCode & 31) << 6) | (charCode2 & 63)));
                } else {
                    enumerator.moveNext();
                    var charCode2 = enumerator.current;

                    enumerator.moveNext();
                    var charCode3 = enumerator.current;

                    output.append(String.fromCharCode(((charCode & 15) << 12) | ((charCode2 & 63) << 6) | (charCode3 & 63)));
                }
            }

            return output.toString();
        }
    };

    Personetics.utils.encodeDecode.Utf8EncodeEnumerator = function Utf8EncodeEnumerator(input) {
        this._input = input;
        this._index = -1;
        this._buffer = [];

        this.current = Number.NaN;

        this.moveNext = function() {
            if (this._buffer.length > 0) {
                this.current = this._buffer.shift();
                return true;
            } else if (this._index >= (this._input.length - 1)) {
                this.current = Number.NaN;
                return false;
            } else {
                var charCode = this._input.charCodeAt(++this._index);

                // "\r\n" -> "\n"
                //
                if ((charCode == 13) && (this._input.charCodeAt(this._index + 1) == 10)) {
                    charCode = 10;
                    this._index += 2;
                }

                if (charCode < 128) {
                    this.current = charCode;
                } else if ((charCode > 127) && (charCode < 2048)) {
                    this.current = (charCode >> 6) | 192;
                    this._buffer.push((charCode & 63) | 128);
                } else {
                    this.current = (charCode >> 12) | 224;
                    this._buffer.push(((charCode >> 6) & 63) | 128);
                    this._buffer.push((charCode & 63) | 128);
                }

                return true;
            }
        }
    };

    Personetics.utils.encodeDecode.Base64DecodeEnumerator = function Base64DecodeEnumerator(input) {
        this._input = input;
        this._index = -1;
        this._buffer = [];

        this.current = 64;

        this.moveNext = function() {
            if (this._buffer.length > 0) {
                this.current = this._buffer.shift();
                return true;
            } else if (this._index >= (this._input.length - 1)) {
                this.current = 64;
                return false;
            } else {
                var enc1 = Personetics.utils.encodeDecode.Base64.codex.indexOf(this._input.charAt(++this._index));
                var enc2 = Personetics.utils.encodeDecode.Base64.codex.indexOf(this._input.charAt(++this._index));
                var enc3 = Personetics.utils.encodeDecode.Base64.codex.indexOf(this._input.charAt(++this._index));
                var enc4 = Personetics.utils.encodeDecode.Base64.codex.indexOf(this._input.charAt(++this._index));

                var chr1 = (enc1 << 2) | (enc2 >> 4);
                var chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                var chr3 = ((enc3 & 3) << 6) | enc4;

                this.current = chr1;

                if (enc3 != 64)
                    this._buffer.push(chr2);

                if (enc4 != 64)
                    this._buffer.push(chr3);

                return true;
            }
        }
    };
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};

    Personetics.utils.PEvent = Base.extend({
        initialize: function(){
            this.eventMessage = {
                "type" : "sendEvents",
                "eventInfo": {},
                "checkInPastEvent": true
            }
        },

        // eventMessage: {
        //     "type" : "notifyEvent",
        //     "eventInfo": {},
        //     "checkInPastEvent": true
        // },

        setParam: function(paramName, paramValue){
            this.eventMessage.eventInfo.params[paramName] = paramValue;
        },

        getJsonMessageEvent: function () {
            return JSON.stringify(this.eventMessage);
        },

        onSuccessCallback: function(){},

        onErrorCallback: function(){}
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.PEventsBuffer = function() {

        this.sendEventsTypesMapping = {
            "account-selector":"AccountSelector",
            "bar-chart":"BarChart",
            "pie-chart":"PieChart",
            "tabs":"Button",
            "buttons":"Button",
            "Navigation":"NavigateButton"
        }
        /* Event that were sent to PServer*/
        this.pastEvents = [];

        /* Event that are in Q and waiting to be sent to PServer*/
        this.eventToSend = [];

        /* Delay (seconds) between each time we send all events in "eventToSend" to PServer */
        this.eventDelayInterval = Personetics.projectConfiguration.getConfig("eventDelayInterval");

        this.start = function(){
            var me = this;
            this.intervalId = setInterval(function () {
                me.sendEvents();
            },
            this.eventDelayInterval);
        };

        this.stop = function(){
            if(this.intervalId)
                clearInterval(this.intervalId);
        };

        /* Adding events to the "eventToSend" Q */
        this.addEventToSend = function (event, success_callback, error_callback) {

            // Check if event already registered
            var shouldAddEvent = this.shouldSendEvent(event);
            if (shouldAddEvent == true) {
                this.eventToSend.push({
                    eventData: event,
                    onSuccessCallback: success_callback,
                    onErrorCallback: error_callback
                });
                if(event.eventMessage.eventInfo.type === "Navigation")
                {
                    this.sendEvents();
                }
            }
        };

        /* Send all events in buffer */
        this.sendEvents = function () {
            var me = this;
            var didSendEvents = false;
            var requestMsg ={};
            var eventsInfoList = [];
            if(this.eventToSend.length)
            {
                requestMsg.type = this.eventToSend[0].eventData.eventMessage.type;
                requestMsg.lang = Personetics.processor.PStoryConfig.getConfig("lang");
                requestMsg.protocolVersion = this.eventToSend[0].eventData.eventMessage.protocolVersion;
            }
            $.each(this.eventToSend, function(key, pevent) {
                if(typeof me.sendEventsTypesMapping[pevent.eventData.eventMessage.eventInfo.type] !== "undefined")
                {
                    pevent.eventData.eventMessage.eventInfo.type = me.sendEventsTypesMapping[pevent.eventData.eventMessage.eventInfo.type];
                }
                eventsInfoList.push(pevent.eventData.eventMessage.eventInfo);
                /* Add event to Q - pastEvents */
                me.pastEvents.push(pevent);
            });
            if(eventsInfoList.length) {
                didSendEvents = true;
                requestMsg.eventsInfoList = eventsInfoList;
                personetics.pserverProxy.notifyEvent(
                    requestMsg,
                    this.onSuccess,
                    this.onError);
            }
            /* Remove all event from Q - eventToSend */
            if (didSendEvents == true) {
                this.eventToSend = [];
            }

        };
        this.onSuccess = function()
        {

        };
        this.onError = function()
        {

        };
        /*
         Check if event should be added to the "sending Q"
         The function will check both Qs - "eventToSend" & "pastEvents"
         In case the current event exist - it wont send it
         */
        this.shouldSendEvent = function (pevent) {

            /*
             Go over all the events that were already been sent -
             if the current event is equal - Dont send it again.
             */

            var shouldSendEvent = true;
            var currentEventInfo = JSON.stringify(pevent.eventMessage.eventInfo);

            if(pevent.eventMessage.checkInPastEvent == true){
                $.each(this.pastEvents, function(key, aPastEvent) {
                    var pastEventInfo = aPastEvent.eventData.eventMessage.eventInfo;
                    if (JSON.stringify(pastEventInfo) === currentEventInfo) {
                        shouldSendEvent = false;
                        return false;
                    }
                });
            }

            /*
             In case the event was sent - stop the search and return - false = DONT SEND AGAIN
             else continue searching in the second Q
             */
            if (shouldSendEvent == false)
                return shouldSendEvent;


            /*
             Go over all the events that are in the Q and about to be send  -
             if the current event is equal - Dont add it again.
             */
            $.each(this.eventToSend, function(key, anEventToSend) {
                var pastEventInfo = anEventToSend.eventData.eventMessage.eventInfo;
                if (JSON.stringify(pastEventInfo) === JSON.stringify(currentEventInfo)) {
                    shouldSendEvent = false;
                    return false;
                }
            });

            return shouldSendEvent;
        };

        this.onEventSendSuccess = function () {
            //TODO: ?
        };

        this.onEventSendError = function () {
            Personetics.log("Error on sending events to PServer....");
        };
    };

})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.PEventOptInOut = Personetics.utils.PEvent.extend({
        initialize: function(){
            this.eventMessage = {
                "type" : "sendEvents",
                    "eventInfo": {
                    "type": "opt-in",
                        "params":{
                        // "isOptIn": true
                    }
                },
                "checkInPastEvent": false
            }
        },

        setOptInParam: function(isOptIn){
            var mode = "in";
            if(isOptIn == true)
                mode = "in";
            else
                mode = "out";

            this.eventMessage.eventInfo.params["isOptIn"] = mode;
        },

        setSentTime: function () {
            this.eventMessage.eventInfo.params["timestamp"] = new Date();
        },

        getJsonMessageEvent: function () {
            return JSON.stringify(this.eventMessage);
        },

        onSuccessCallback: function(){
        },

        onErrorCallback: function(){}
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    var pEventReporting = Personetics.utils.PEvent.extend({
        
        initialize: function(){
            this.params = {
                "eventType" : "sendEvents",
                "checkInPastEvent" : "false",
                "protocolVersion" : Personetics.projectConfiguration.getConfig("protocolVersion"),
                "userId" : "",
                "type": "",
                "value": "",
                "insightId":"",
                "instanceId":""
            }
        },

        setValue: function(parameters){
            var me = this;
            $.each(parameters, function (key, value) {
                if (me.params.hasOwnProperty(key) && value != 'undefined' && value != null) {
                    me.params[key] = value;
                }
            })
        },

        createMessage: function(){
            var params = this.params;
            var eventMessage = {
                "type" : params.eventType,
                "userId" : params.userId,
                "checkInPastEvent": params.checkInPastEvent,
                "protocolVersion": params.protocolVersion,
                "eventInfo": {
                    "type": params.type,
                    "eventDateTime": new Date(),
                    "params":{
                        "value" : params.value,
                        "insightId": params.insightId,
                        "instanceId": params.instanceId
                    }
                },
                
            }
            return eventMessage;
        },

        notifyEvent: function(){
            var pevent = {
                eventMessage: this.createMessage()
            }
            personetics.notifyEvent(pevent);
        },

        /*getJsonMessageEvent: function () {
            return JSON.stringify(this.eventMessage);
        },

        onSuccessCallback: function(){
        },

        onErrorCallback: function(){
        }*/
    });

    Personetics.utils.PEventReporting = new pEventReporting();

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.json = {};

    var JSON = window.JSON || {};
    window.JSON = JSON;

    JSON.stringify = JSON.stringify || function(obj) {
        var t = typeof (obj);
        if (t != "object" || obj === null) {
            // simple data type
            if (t == "string")
                obj = '"' + obj + '"';
            return String(obj);
        } else {
            // recurse array or object
            var n, v, json = [], arr = (obj && obj.constructor == Array);
            for (n in obj) {
                if(obj.hasOwnProperty(n)) {
                    v = obj[n];
                    t = typeof (v);
                    if (t == "string")
                        v = '"' + v + '"';
                    else if (t == "object" && v !== null)
                        v = JSON.stringify(v);
                    json.push((arr ? "" : '"' + n + '":') + String(v));
                }
            }
            return (arr ? "[" : "{") + String(json) + (arr ? "]" : "}");
        }
    };

    Personetics.utils.json.getJsonStringifyMethod = function getJsonStringifyMethod(){
        if($.toJSON){
            return $.toJSON;
        }
        else{
            return JSON.stringify;
        }
    };


    Personetics.utils.json.toJSON = function toJSON(value) {
        var _json_stringify = Personetics.utils.json.getJsonStringifyMethod();
        if(typeof Prototype !== 'undefined' && /*parseFloat(Prototype.Version.substr(0,3)) < 1.7 &&*/ typeof Array.prototype.toJSON !== 'undefined'){
            var _array_tojson = Array.prototype.toJSON;
            delete Array.prototype.toJSON;
            var r=_json_stringify(value);
            Array.prototype.toJSON = _array_tojson;
            return r;
        }
        else
            return _json_stringify(value);
    };

    Personetics.utils.json.replacer = function replacer(match, pIndent, pKey, pVal, pEnd) {
            var key = '<span class=json-key>';
            var val = '<span class=json-value>';
            var str = '<span class=json-string>';
            var r = pIndent || '';
            if (pKey)
                r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ';
            if (pVal)
                r = r + (pVal[0] == '"' ? str : val) + pVal + '</span>';
            return r + (pEnd || '');
    };

    Personetics.utils.json.prettyPrint = function prettyPrint(obj) {
            var jsonLine = /^( *)("[\w.+-]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg;
            return JSON.stringify(obj, null, 3)
                .replace(/&/g, '&amp;').replace(/\\"/g, '&quot;')
                .replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(jsonLine, Personetics.utils.json.replacer);
    };
     Personetics.utils.json.mergeString = function merge(firstjsonString,secondJsonString) {
        var json1 = JSON.parse(firstjsonString);
        var json2 = JSON.parse(secondJsonString);
        var result = Personetics.utils.json.mergeObject(json1,json2);
        var objectString = Personetics.utils.json.toJSON(result);
        return objectString;
     }
    Personetics.utils.json.mergeObject = function merge(firstjson,secondJson) {
        var mergedJson = $.extend({}, firstjson, secondJson);
        return mergedJson;
    };

    Personetics.utils.json.mergeDeepObject = function merge(firstjson,secondJson) {
        var mergedJson = $.extend(true, {}, firstjson, secondJson);
        return mergedJson;
    };
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, undefined){

    Personetics.utils = Personetics.utils || {};

    Personetics.PLoggerModes = {
        VERBOSE: {
            name: "VERBOSE",
            value: 1
        },
        DEBUG: {
            name: "DEBUG",
            value: 2
        },
        ALERT: {
            name: "ALERT",
            value: 3
        },
        ERROR: {
            name: "ERROR",
            value: 4
        },
        PRODUCTION: {
            name: "PRODUCTION",
            value: 5
        }
    };

    var logger = function logger(){
        this.mode = Personetics.PLoggerModes.ERROR.value;
    };

    logger.prototype.setDebugMode = function setDebugMode(mode){
        if(typeof mode !== 'undefined' && mode !== null && mode.hasOwnProperty("name") &&
            Personetics.PLoggerModes.hasOwnProperty(mode.name))
            this.mode = mode.value;
    };

    logger.prototype.verbose = function verbose(msg){
        if(this.mode <= Personetics.PLoggerModes.VERBOSE.value)
            console.log(msg);
    };

    logger.prototype.debug = function debug(msg){
        if(this.mode <= Personetics.PLoggerModes.DEBUG.value)
            console.log(msg);
    };

    logger.prototype.error = function(msg, exception,options) {
        if (this.mode <= Personetics.PLoggerModes.ERROR.value) {
            var shouldDisplayError = typeof options !== "undefined" && options.hasOwnProperty("shouldDisplayError") && typeof options.shouldDisplayError !== "undefined" ? options.shouldDisplayError : true;
            if (shouldDisplayError) {
                var context = Personetics.processor.PStoryConfig.getConfig("context");
                if (context) {
                    throwExceptionToServer(msg);
                } else {
                    console.error("<< ERROR >>: " + msg);
                }
            }
            if (Personetics.utils.assert.isDefined(exception, false))
                throw exception;
        }
    };

    logger.prototype.alert = function(msg){
        if(this.mode <= Personetics.PLoggerModes.ALERT.value)
            alert(msg);
    };

    var throwExceptionToServer = function(msg){
        var context = Personetics.processor.PStoryConfig.getConfig("context").toLowerCase();
        var func = this[Personetics.processor.PStoryConfig.getConfig("serverCallBack")];
        if(context === 'server'){
            if(typeof func === 'function'){
                func(msg);
            } else{
                throw msg;
            }
        } else {
            if(typeof func === 'function'){
                func('Error - invalid value for key "context", it should be "SERVER"'+ ' \nProcessor error - ' + msg);
            } else {
                throw ('Error - invalid value for key "context", it should be "SERVER"'+ ' \nProcessor error - ' + msg);
            }
        }
    };

    Personetics.utils.PLogger = new logger();

    Personetics.verbose = Personetics.utils.PLogger.verbose.bind(Personetics.utils.PLogger);
    Personetics.log = Personetics.utils.PLogger.debug.bind(Personetics.utils.PLogger);
    Personetics.debug = Personetics.utils.PLogger.debug.bind(Personetics.utils.PLogger);
    Personetics.error = Personetics.utils.PLogger.error.bind(Personetics.utils.PLogger);
    Personetics.alert = Personetics.utils.PLogger.alert.bind(Personetics.utils.PLogger);

})(window, window.Personetics = window.Personetics || {});
(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.messages = {};


    Personetics.utils.messages.errorMessage = function errorMessage(params) {
        var errorMsgTemplate = Personetics.UI.Handlebars.templates[ params ? params.templateId ? params.templateId : 'error-msg' : 'error-msg'];
        if(typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("getDeviceType")) {
            var deviceType = personetics.getDeviceType() || "web";
        }
        var html;
        if  (deviceType === 'web'){
             html = errorMsgTemplate(
                {
                    textLarge:params.textLarge,
                    textSmall:params.textSmall,
                    imgClass:params.imgClass
                })
        }
        else {
            html = errorMsgTemplate(
                {
                    textLarge:params.textLarge,
                    textSmall:params.textSmall,
                    imgClass:params.imgClass,
                    isMobileDevice:true//"mobile-err"
                })
        }


        return html;
    };
    Personetics.utils.messages.noInsightsMessage = function noInsightsMessage(params) {
        var errorMsgTemplate = Personetics.UI.Handlebars.templates[ params ? params.templateId ? params.templateId : 'no-insights-message' : 'no-insights-message'];
        if(typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("getDeviceType")) {
            var deviceType = personetics.getDeviceType() || "web";
        }
        var html;
        if  (deviceType === 'web'){
            html = errorMsgTemplate(
                {
                    textLarge:params.textLarge,
                    textSmall:params.textSmall,
                    imgClass:params.imgClass
                })
        }
        else {
            html = errorMsgTemplate(
                {
                    textLarge:params.textLarge,
                    textSmall:params.textSmall,
                    imgClass:params.imgClass,
                    isMobileDevice:true//"mobile-no-insights"
                })
        }
        return html;
    };

    Personetics.utils.messages.noFilteredInsightsMessage = function noFilteredInsightsMessage(params) {
        var noFileredMsgTemplate = Personetics.UI.Handlebars.templates[ params ? params.templateId ? params.templateId : 'no-filtered-insights-msg' : 'no-filtered-insights-msg'];
        if(typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("getDeviceType")) {
            var deviceType = personetics.getDeviceType() || "web";
        }
        var html;
        if  (deviceType === 'web'){
            html = noFileredMsgTemplate(
                {
                    text: params.text
                });
        }
        else {
            html = noFileredMsgTemplate(
                {
                    text: params.text,
                    isMobileDevice:true//"mobile-no-insights"
                })
        }
        return html;
    };

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){

	Personetics.utils = Personetics.utils ? Personetics.utils : {};
	Personetics.utils.network = {};
	
	Personetics.utils.network.consts = {
		
		base64EncodeResponse : false,
		requestTimeoutInMillis: 300000,
		dataType: "json",
		async: true,
		onComplete: function() {},
		onSuccess: function(data, textStatus, jqXHR) {
			Personetics.log("request success");
		},
		onFailure: function(jqXHR, textStatus, errorThrown) {
			Personetics.log("request failed: " + textStatus + ", " + errorThrown);
		}
	};


	Personetics.utils.network.doAjaxGet = function doAjaxGet(url, data, requestOptions) {

		var finalRequestOptions = Personetics.utils.dictionary.overrideObjectProperties(requestOptions, Personetics.utils.network.consts, false);

		Personetics.utils.assert.AssertIsDefined(url, "Personetics.utils.network.doAjaxGet: invalid request URL: " + url);

		var config = {
				type: "GET",
				url: url,
				dataType: finalRequestOptions.dataType,
				async: finalRequestOptions.async,
				timeout: finalRequestOptions.requestTimeoutInMillis,
				complete: finalRequestOptions.onComplete,
				success: onDoAjaxGetSuccess,
				error: onDoAjaxGetError
			};

		if(!Personetics.utils.assert.isNullOrUndefined(data))
			config.data = data;

		$.ajax(config);

		function onDoAjaxGetSuccess (response) {
			
			var processedResponse = response;
			if (finalRequestOptions.base64EncodeResponse == true ) {
				 processedResponse = Personetics.utils.network.decodeDataWithBase64(response);
				 processedResponse = $.parseJSON(processedResponse);
			}
			
			finalRequestOptions.onSuccess(processedResponse);
		}

		function onDoAjaxGetError (XMLHttpRequest, textStatus, errorThrown) {
			finalRequestOptions.onFailure (XMLHttpRequest, textStatus, errorThrown);
		}
	};

	Personetics.utils.network.doAjaxPost = function doAjaxPost(url, postData, requestOptions) {

		var finalRequestOptions = Personetics.utils.dictionary.overrideObjectProperties(requestOptions, Personetics.utils.network.consts, false);

		Personetics.utils.assert.AssertIsNullOrUndefined(url, "Personetics.utils.network.doAjaxPost: invalid request URL: " + url);

		$.ajax({
			type: "POST",
			url: url,
			data: postData,
			dataType: finalRequestOptions.dataType,
			async: finalRequestOptions.async,
			headers: finalRequestOptions.headers,
			timeout: finalRequestOptions.requestTimeoutInMillis,
			complete: finalRequestOptions.onComplete,
			success: onDoAjaxPostSuccess,
			error: onDoAjaxPostError
		});


		function onDoAjaxPostSuccess (response) {
			var processedResponse = response;
			if (finalRequestOptions.base64EncodeResponse == true ) {
				 processedResponse = Personetics.utils.network.decodeDataWithBase64(response);
				 processedResponse = $.parseJSON(processedResponse);
			}

			finalRequestOptions.onSuccess(processedResponse);
		}

		function onDoAjaxPostError (XMLHttpRequest, textStatus, errorThrown) {
			finalRequestOptions.onFailure (XMLHttpRequest, textStatus, errorThrown);
		}
	};

	Personetics.utils.network.queueAjaxPost = function queueAjaxPost(queueId, url, postData, requestOptions) {

		var finalRequestOptions = Personetics.utils.dictionary.overrideObjectProperties(requestOptions, Personetics.utils.network.consts, false);

		return $.ajaxq (queueId, {
			type: "POST",
			url: url,
			data:postData,
			dataType: finalRequestOptions.dataType,
			timeout: finalRequestOptions.requestTimeoutInMillis,
			success: onDoAjaxQueuePostSuccess,
			error: onDoAjaxQueuePostError
		});

		function onDoAjaxQueuePostSuccess (response) {
			var processedResponse = response;
			if (finalRequestOptions.base64EncodeResponse == true ) {
				processedResponse = Personetics.utils.network.decodeDataWithBase64(response);
				processedResponse = $.parseJSON(processedResponse);
			}
			
			finalRequestOptions.onSuccess(processedResponse);
		}

		function onDoAjaxQueuePostError (XMLHttpRequest, textStatus, errorThrown) {
			finalRequestOptions.onFailure (XMLHttpRequest, textStatus, errorThrown);
		}

	};

	Personetics.utils.network.removeAjaxPostQueue = function(queueId) {
		$.ajaxq(queueId);
	};

	Personetics.utils.network.wasUserAborted = function wasUserAborted(xhr, textStatus){
		return !xhr.getAllResponseHeaders() && textStatus != 'timeout';
	};

	Personetics.utils.network.createPostform = function createPostform(params, absoluteUrl, newDoc, win, pageInfo) {
		newDoc.charset = "utf-8";

		var formId = "hintForm";
		var form = newDoc.createElement("form");
		form.setAttribute("id", formId);
		form.setAttribute("method", "post");
		form.setAttribute("action", absoluteUrl);

		// form.acceptCharset='utf-8'
		for ( var i in params) {
			if (params.hasOwnProperty(i)) {
				var input = newDoc.createElement('input');
				input.type = 'hidden';
				input.name = i;
				input.value = params[i];
				form.appendChild(input);
			}
		}

		newDoc.body.appendChild(form);
		form.submit();
		newDoc.body.removeChild(form);

	}

	Personetics.utils.network.decodeDataWithBase64 = function (data) {

		data = data.replace(/(\r\n|\n|\r)/gm,"");
		data = data.replace(/"/g, ''); //  ""example"" ---> "example"
		var decodedData = Personetics.utils.encodeDecode.Base64.decode(data);
		return decodedData;
	};

})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, undefined) {
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.persoHelper = {};

    Personetics.utils.persoHelper.constants = {
        ANDROID_VERSIONS :{
            OLD_VERSION_MIN_TARGET: 4.4,
            OLD_VERSION_MAX_TARGET: 5.0
        }
    }
    Personetics.utils.persoHelper.getAndroidVersionNumber = function getAndroidVersionNumber(){
        var androidVersionNumber;
        var androidVersionString = getAndroidVersion();
        if(androidVersionString){
            androidVersionNumber = parseFloat(getAndroidVersion())
        }
        return androidVersionNumber;
    };

    Personetics.utils.persoHelper.isOldAndroidVersion = function isOldAndriodVersion (){
        var androidVersion = this.getAndroidVersionNumber();
        var isOldAndroidVersion = false;

        if(typeof androidVersion !== 'undefined' && androidVersion > 0){
            if(androidVersion < this.constants.ANDROID_VERSIONS.OLD_VERSION_MAX_TARGET && androidVersion >= this.constants.ANDROID_VERSIONS.OLD_VERSION_MIN_TARGET){
                isOldAndroidVersion = true;
            }
        }
        return isOldAndroidVersion;
    };

    var getAndroidVersion = function getAndroidVersion(){
        var userAgent = navigator.userAgent.toLowerCase();
        var match = userAgent.match(/android\s([0-9\.]*)/);
        return match ? match[1] : false;
    };
})(window, window.Personetics = window.Personetics || {});
(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.print = {};

    Personetics.utils.print.printHtmlToPdf = function printHtmlToPdf(config) {
        var pdf = new jsPDF('p', 'pt', 'a4');
        pdf.addFont('Roboto');
        pdf.setFont('Roboto');
        var element = config.parent;
        if(!config.page || !config.page.el){
            var children = config.parent.getElementsByTagName("*");
            config.beforeExportCallback && config.beforeExportCallback(children);
            pdf.internal.scaleFactor = config.internalScaleFactor;//3.75;
            addHtml(element, pdf, config);
        }else {
            var elemFromHtml = config.page.el;
            //config.parent.appendChild(elemFromHtml);
            var children = config.parent.getElementsByTagName("*");
            config.beforeExportCallback && config.beforeExportCallback(children);
            html2canvas(elemFromHtml, {
                allowTaint: false,
                useCORS: true,
            }).then(function (canvas) {
                pdf.internal.scaleFactor = config.page.internalScaleFactor;
                var newCanvas = copyCanvas(canvas, elemFromHtml.clientWidth, elemFromHtml.clientHeight);
                config.parent.appendChild(newCanvas);
                var x = config.x ? config.x : 0;
                var y = config.y ? config.y : 0;
                pdf.addHTML(newCanvas, x, y, {
                    pagesplit: true,
                    allowTaint: false,
                    useCORS: true
                }, function () {
                    if (newCanvas.parentElement) {
                        config.parent.removeChild(newCanvas);
                    }
                    elemFromHtml.parentNode.removeChild(elemFromHtml);
                    pdf.addPage();
                    pdf.internal.scaleFactor = config.internalScaleFactor;//3.75;
                    addHtml(element, pdf, config);
                });
            });
        }
    }

    function addHtml(element, pdf, config){
        var newCanvas = createCanvas({width:element.clientWidth,height:element.clientHeight,totalHeight:config.height});
        var x = config.x ? config.x : 0;
        var y = config.y ? config.y : 0;
        pdf.addHTML(element, x, y, {
                pagesplit: true,
                canvas: newCanvas
            },
            function () {
                if (newCanvas.parentElement) {
                    config.parent.removeChild(newCanvas);
                }
                // $.each(pdf.internal.pages, function (index, value) {
                //     if (value) {
                //         console.log(value);
                //     }
                // });
                pdf.save(config.fileName + config.format);
                config.callback && config.callback();
            });
    }
    Personetics.utils.print.printHtmlToPdfWithLoop = function printHtmlToPdf(config) {
        var pdf = new jsPDF('p', 'pt', 'a4');
        var element = config.parent;
        if(!config.page || !config.page.html){
            pdf.internal.scaleFactor = 3.75;
            var frame = config.parent.getElementsByClassName("pstory-dialog-content");
                var newCanvas = createCanvas({
                    width: element.clientWidth,
                    height: element.clientHeight,
                    totalHeight: config.height
                });
                pdf.addHTML(frame[0], {pagesplit: true, canvas: newCanvas}, function () {
                    if (newCanvas.parentElement) {
                        config.parent.removeChild(newCanvas);
                    }
                    loopElements(pdf, frame, 1, config);
                });
        }else {
            pdf.internal.scaleFactor = 2.5;
            var elemFromHtml = document.createElement("div");
            elemFromHtml.innerHTML = config.page.html;
            var newElement = elemFromHtml.firstChild;
            newElement.style.width = config.page.width;
            config.parent.appendChild(newElement);
            var children = newElement.getElementsByTagName("*");
            for (var i = 0; i < children.length; i++) {
                if (window.getComputedStyle(children[i], null).getPropertyValue("background-image") !== "none") {
                    children[i].style.backgroundImage = "none";
                }
            }
            html2canvas(newElement, {
                allowTaint: false,
                useCORS: true,
            }).then(function (canvas) {
                pdf.internal.scaleFactor = 1;
                var newCanvas = copyCanvas(canvas, newElement.clientWidth, newElement.clientHeight);
                config.parent.appendChild(newCanvas);
                pdf.addHTML(newCanvas, 0, 0, {
                    pagesplit: true, allowTaint: false,
                    useCORS: true
                }, function () {
                    if (newCanvas.parentElement) {
                        config.parent.removeChild(newCanvas);
                    }
                    newElement.parentNode.removeChild(newElement);
                    pdf.addPage();
                    pdf.internal.scaleFactor = 3.75;
                    var canvas = createCanvas({
                        width: element.clientWidth,
                        height: element.clientHeight,
                        totalHeight: config.height
                    });
                    pdf.addHTML(element, {pagesplit: true, canvas: canvas}, function () {

                        pdf.save(config.fileName + config.format);
                        config.callback && config.callback();
                    });
                });
            });
        }
    }


    function createCanvas(options){
        var canvas = document.createElement('canvas');
        canvas.width = options.width * 3;
        canvas.height = options.totalHeight * 3;
        canvas.style.width = options.width + 'px';
        canvas.style.height = options.height + 'px';
        var context = canvas.getContext('2d');
        context.scale(3, 3);
        context.fillStyle ="rgba(255, 255, 255, 1)";
        context.fillRect(0,0,canvas.width, canvas.height);
        return canvas;
    }

    function updateCanvas(canvas, options){
        //var canvas = document.createElement('canvas');
        canvas.width = options.width * 3;
        canvas.height = options.totalHeight * 3;
        canvas.style.width = options.width + 'px';
        canvas.style.height = options.height + 'px';
        var context = canvas.getContext('2d');
        context.scale(3, 3);
        context.fillStyle ="rgba(255, 255, 255, 1)";
        context.fillRect(0,0,canvas.width, canvas.height);
    }

    function copyCanvas(canvas, width, height){
        var newCanvas = document.createElement('canvas');
        newCanvas.width = width * 3;
        newCanvas.height = height * 3;
        newCanvas.style.width = width + 'px';
        newCanvas.style.height = height + 'px';
        var destCtx = newCanvas.getContext('2d');
        destCtx.scale(3, 3);
        destCtx.fillStyle = "rgba(255, 255, 255, 1)";
        destCtx.fillRect(0, 0, newCanvas.width, newCanvas.height);
        destCtx.drawImage(canvas, 0, 0);
        return newCanvas;
    }

    function loopElements(pdf, elemnts, index, config) {
        if (index == elemnts.length) {
            pdf.save(config.fileName + config.format);
            config.callback && config.callback();
            return;
        }
        pdf.addPage();
        html2canvas(elemnts[index], {
            allowTaint: false,
            useCORS: true,
        }).then(function (canvas) {
            pdf.internal.scaleFactor = 1;
            var newCanvas = copyCanvas(canvas, elemnts[index].clientWidth, elemnts[index].clientHeight);
            config.parent.appendChild(newCanvas);
            pdf.addHTML(newCanvas, 0, 0, {
                pagesplit: true, allowTaint: false,
                useCORS: true
            }, function () {
                if (newCanvas.parentElement) {
                    config.parent.removeChild(newCanvas);
                }
                loopElements(pdf, elemnts, index + 1, config);
            });
        });
    }
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){

	Personetics.utils = Personetics.utils ? Personetics.utils : {};
	Personetics.utils.scope = {};

	// Returns a wrapper that binds "this" inside "fn" to "scope"
	Personetics.utils.scope.bind = function bind(scope, fn) {
		return function() {
			return fn.apply(scope, arguments);
		};
	};

	Personetics.bind = Personetics.utils.scope.bind;

	Personetics.utils.scope.Callback = function Callback(f, parameters) {
		this.parameters=parameters;
		this.f=f;
		var me=this;
		this.invoke=function () {

			me.f.apply( me, me.parameters );
			// me.f(me.parameters);
		}
	};
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {

	Personetics.utils = Personetics.utils ? Personetics.utils : {};
	Personetics.utils.string = {};
	Personetics.utils.string.isString = function isString(str) {
		return typeof str === 'string';
	};

	Personetics.utils.string.isEmpty = function isString(str) {
		return Personetics.utils.string.isString(str) && str.length == 0;
	};

	Personetics.utils.string.isValidString = function isValidString(str) {
		return Personetics.utils.assert.isString(str) && str != null && str.length > 0;
	};

	Personetics.utils.string.truncateLongWords = function truncateLongWords(setnece, maxWordLength) {
		if (typeof setnece !== 'undefined' && setnece && setnece.length > 0 && setnece.replace(/ /g, '').length > 0) {
			var words = setnece.split(' ');
			var processedWords = [];
			$.each(words, function (i, word) {
				if (word.length > maxWordLength) {
					processedWords.push(word.substring(0, maxWordLength - 6) + '...');
				}
				else {
					processedWords.push(word);
				}
			});
			return processedWords.join(' ');
		}
		else {
			return "";
		}
	};

	Personetics.utils.string.stripTags = function stripTags(input) {
		var tagsToReplace = ["script"];

		var result = input;

		if (typeof input !== 'undefined' && input != null && input.length > 0) {
			$.each(tagsToReplace, function (i, tagToReplace) {
				var tagRegex = new RegExp("<" + tagsToReplace + ".*>.*</" + tagToReplace + ">", "ig");
				result = result.replace(tagRegex, "");
			});
		}
		return result;
	};

	Personetics.utils.string.replaceNewLine = function replaceNewLine(element) {
		if (!element)
			return element;

		var typeOf = typeof (element);

		if (typeOf == 'string') {

			var regex = new RegExp("^<([A-Z][A-Z0-9]*)[^>]*>(.*?)</\\1>$", "gim");
			var res = regex.exec(element.replace(/\n/g, ""));
			if (res) {
				element = element.replace(/\n/g, "");
			} //html code
			else { element = element.replace(/\n/g, "<br />"); }
		} else if (typeOf == 'object')
			$.each(element, function (key, value) {

				if (!value)
					return;

				if (typeof (key) == 'string' && key.toLowerCase().indexOf('speaking') != -1) // skip
					// speaking
					return;
				var typeOfValue = typeof (value);
				element[key] = Personetics.utils.string.replaceNewLine(value);
			});

		return element;
	};

	Personetics.utils.string.StringBuffer = function StringBuffer() {
		this.buffer = [];

		this.append = function append(string) {
			this.buffer.push(string);
			return this;
		};

		this.toString = function toString() {
			return this.buffer.join("");
		};
	};

	Personetics.utils.string.decodeHTMLSpecialCharecters = function decodeHTMLSpecialCharecters(input) {
		var decodedString = input.replace("&amp;", "&");
		/* add here any other replacments if needed in the future*/
		return decodedString;
	};

	Personetics.utils.string.stripSpecialChars = function stripSpecialChars(val) {
		return val.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');
	};

	Personetics.utils.string.removeClass = function removeClass(className, clazz) {
		var _classname = className;
		//support objects for svg
		if (typeof className === 'object')
			_classname = _classname.animVal;
		_classname = _classname.replace(new RegExp('(?:^|\\s)'+ clazz + '(?:\\s|$)'), ' ');
		return _classname;
	};

	Personetics.utils.string.addClass = function addClass(className, clazz) {
		className= Personetics.utils.string.removeClass(className,clazz);
		var _classname = className;
		//support objects for svg
		if (typeof className === 'object')
			_classname = _classname.animVal;
		_classname += " "+ clazz;
		return _classname;
	};


})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.url = {};

    /**
     * Returns value of specific request parameter identified by the name parameter
     */
    Personetics.utils.url.getParameterByName = function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results == null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    /**
     * Returns full address of given relative URL without the file name and query string
     */
    Personetics.utils.url.getAbsoluteUrl = function getAbsoluteUrl(localurl){
        
        if (/^(https?|file|ftps?|mailto|javascript|data:image\/[^;]{2,9};):/i.test(localurl))
            return localurl; // localurl is already absolute
            
            var href = window.location.href;
            var pathArray = href.split('/');
            var newPathname = "";
    
            //for ( var i = 0; i < 3/*pathArray.length - 1*/; i++) {
                for ( var i = 0; i < pathArray.length - 1; i++) {
                if (i != 0)
                    newPathname += "/";

                newPathname += pathArray[i];
            }
            return newPathname + '/' + localurl;
    };

    /**
     * Opens a new browser tab using post request
     */
    Personetics.utils.url.openTabWithPost = function openTabWithPost(localUrl, windowoption, params){
        var absoluteUrl = Personetics.utils.url.getAbsoluteUrl(localUrl);

        var newWin = window.open("","_blank");
        newWin.opener = null;
        newWin.focus();
        var newDoc = newWin.document;

        Personetics.utils.network.createPostform(name, params, absoluteUrl, newDoc);
    };

    /**
     * Creates a new iframe and loads it with a post request
     */
    Personetics.utils.url.iframeWithPost = function iframeWithPost(url, name, params){
        var form = document.createElement("form");
        form.setAttribute("method", "post");
        form.setAttribute("action", url);
        form.setAttribute("target", name);

        for (var i in params) {
            if (params.hasOwnProperty(i)) {
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = i;
                input.value = params[i];
                form.appendChild(input);
            }
        }

        document.body.appendChild(form);

        // note I am using a post.htm page since I did not want to make double
        // request to the page
        // it might have some Page_Load call which might screw things up.
        // window.open("post.htm", name, windowoption);

        form.submit();

        document.body.removeChild(form);
    };

    Personetics.utils.url.urlCheck = function urlCheck(s) {
        var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
        return regexp.test(s);
    };

    Personetics.utils.url.encodePostParams = function encodePostParams (parameterObject) {
        var postParamObject = {};
        /* if contains in key the string 64 - encode it and add it to the object */
        $.each(parameterObject, Personetics.bind(this, function(key, value){
            if (key.indexOf("64") >= 0){
                /*add base64 encoding*/
                var paramsJson = Personetics.utils.json.toJSON(parameterObject[key]);
                var str64 = Personetics.utils.encodeDecode.Base64.encode(paramsJson);
                parameterObject[key] = str64;
            } 
        }));

         return parameterObject;
    };
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.PWebAnalytics = Base.extend({
        reportWidgetActive: function(options){},
        reportWidgetLoaded: function(options){},
        reportOverlayLoaded: function(options){},
        reportRatingsSent: function(options){}
    });

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){

    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    var pEventReporting = Personetics.utils.PEvent.extend({
        
        initialize: function(){
            this.params = {
                "eventType" : "sendEvents",
                "checkInPastEvent" : "false",
                "protocolVersion" : Personetics.projectConfiguration.getConfig("protocolVersion"),
                "userId" : "",
                "type": "",
                "value": "",
                "insightId":"",
                "instanceId":""
            }
        },

        setValue: function(parameters){
            var me = this;
            $.each(parameters, function (key, value) {
                if (me.params.hasOwnProperty(key) && value != 'undefined' && value != null) {
                    me.params[key] = value;
                }
            })
        },

        createMessage: function(){
            var params = this.params;
            var eventMessage = {
                "type" : params.eventType,
                "userId" : params.userId,
                "checkInPastEvent": params.checkInPastEvent,
                "protocolVersion": params.protocolVersion,
                "eventInfo": {
                    "type": params.type,
                    "eventDateTime": this.getFormattedDate(),
                    "params":{
                        "value" : params.value,
                        "insightId": params.insightId,
                        "instanceId": params.instanceId
                    }
                },
                
            }
            return eventMessage;
        },

        notifyEvent: function(){
            var pevent = {
                eventMessage: this.createMessage()
            }
            personetics.notifyEvent(pevent);
        },
        getFormattedDate: function () {
            var currentDate = new Date();
            var currentDateString =
                currentDate.getUTCMonth() +
                1 +
                "/" +
                currentDate.getUTCDate() +
                "/" +
                currentDate.getUTCFullYear() +
                " " +
                currentDate.getUTCHours() +
                ":" +
                currentDate.getUTCMinutes() +
                ":" +
                currentDate.getUTCSeconds();
            return currentDateString;
        },
    });

    Personetics.utils.PEventReporting = new pEventReporting();

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};

    Personetics.story.PStoryPreview = Personetics.story.PStory.extend({
        initialize: function(config){
            this.super = Personetics.story.PStory.prototype;
            this.super.initialize.call(this,config);

            this.previewDialogId = config.dialogId;
            this.previewBlockIndex = config.blockIndex;
            this.mode = config.mode;
        },

        renderDialogs: function(){
            var me = this;
            var dialogsConfig = this.storyDef.dialogs;
            var previewDialogConfig = null;
            $.each(dialogsConfig, function(index, dialogConfig){
                if(dialogConfig.id == me.previewDialogId) {
                    previewDialogConfig = dialogConfig;
                    return false;
                }
            });

            if(previewDialogConfig){
                this.pushDlg(previewDialogConfig, Personetics.bind(this,this.highlightBlock));
            }
        },

        fireEvent: function(block,e) {
            // ignore click events
        },
        
        highlightBlock: function(){
            var dlgEl = this.frameEl.find(".pstory-dialog-frame");
            var blockEl = dlgEl.find('.pstory-block-frame').eq(this.previewBlockIndex);

            blockEl.addClass("pstory-preview-block");

            // var fontFamily = blockEl.css("font-family");
            // var fontSize = blockEl.css("font-size");
            // var color = blockEl.css("color");
            // var width = blockEl.width();
            // var offset = blockEl.offset();
            // var top = offset.top - 42; //TODO: fixed hardcoded 41 pixel offset
            // var left = offset.left - 1;
            //
            // var overviewBlockEl = blockEl.clone().appendTo("body").addClass("pstory-preview-block").css({
            //     top: top,
            //     left: left,
            //     width: width,
            //     "font-family": fontFamily,
            //     "font-size": fontSize,
            //     color: color
            // });
            // overviewBlockEl.show(1000);
            //
            // this.frameEl.addClass("pstory-preview-story");
        }
    });

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.NewAccountSelectorBlockProduct = Personetics.story.AccountSelectorBlock.extend({
        getHtmlTemplateId: function(clazz) {
            return "account-selector-new";
        },
        beforeRender: function (el, layoutInstructions) {
            Personetics.story.AccountSelectorBlock.prototype.beforeRender.call(this, el, layoutInstructions);
            var options = $.extend(true, [], layoutInstructions.options);
            var optAllIndex;
            var me = this;
            this.showHeaderTabs = false;
            this.defaultTab = 'choose-account';
            $.each(options, function (index, opt) {
                if (opt.id == 'all') {
                    optAllIndex = index;
                    me.showHeaderTabs = true;
                    me.all = $.extend(true, {}, (opt));
                    if(opt.selected)
                        me.defaultTab = 'all';
                    return false;
                }
            });
            if (typeof optAllIndex !== 'undefined') {
                options.splice(optAllIndex, 1);
            }
            options.cardsLength = options.length;
            this.options = options;
            if(this.story.cfg.widthMode === 'desktop'){
                this.config = this.story.uxCtrl.getAccountSelectorConfigDesktop();
                this.isDesktopMode = true;
            }
            else{
                this.config = this.story.uxCtrl.getAccountSelectorConfig();
                this.isDesktopMode = false;
            }
            this.showArrows = this.config.showArrows && this.options.cardsLength >= this.config.minAccountsForDisplayingArrows;
            this.isRightToLeft = this.config.isRightToLeft;
        },
        render: function (el, layoutInstructions) {
            this.el = el;
            var text = this.getAccountSelectorText();
            this.setImageValueForOptions();
            var param = {
                options: this.options,
                class: layoutInstructions.class,
                showHeaderTabs: this.showHeaderTabs,
                headersArray: this.getHeadersArray(),
                showIndexDots: this.config.showIndexDots,
                isDesktopMode: this.isDesktopMode,
                lblaccSelectAccounts: Personetics.dictionary.getText("lblaccSelectAccounts")
            };
            param = $.extend(param, text);
            var html = this.template(param);

            el.append(html);
            this.frameEl = el.find(".pstory-block-frame").last();
            if(this.isRightToLeft){
                this.frameEl.addClass('perso-RTL');
            }
        },
        getHeadersArray: function getHeadersArray() {
            var result = [{
                text: Personetics.dictionary.getText("lblaccSelectAll"),
                isAll: true
            },{
                text: Personetics.dictionary.getText("lblaccSelectChoose"),
                isAll: false
            }];
            return result;
        },
        getAccountSelectorText: function getAccountSelectorText() {
            var text = {
                allAccountsTxt: this.all ? this.all.text : "",
                allAccountsTxt2: this.all ? this.all.text2 : "",

                next: Personetics.dictionary.getText("lblaccSelectNextAcc"),
                prev: Personetics.dictionary.getText("lblaccSelectPreviousAcc"),
                allAccountsName: Personetics.dictionary.getText("lblaccSelectAll"), //"All accounts"
                numberPref: Personetics.dictionary.getText("lblaccSelectAccount"),
                numberPrefAccessibility: Personetics.dictionary.getText("lblaccSelectAccountAccessibility"),accountSelectorText: Personetics.dictionary.getText("lblAccessibiliotyAccountSelectorText"),
            }
            return text;
        },
        setImageValueForOptions: function setImageValueForOptions(){
            $.each(this.options, function (i, opt) {
                var urlObj = Personetics.imageMap.getImageClass(opt.image, "account_selector");
                opt.isAbsoluteURL = urlObj.isAbsoluteURL;
                opt.image  = urlObj.url;
            });
        },
        bindEvents: function bindEvents() {
            Personetics.story.OptionsBlock.prototype.bindEvents.call(this);
            var block = this;
            this.frameEl.find(".pstory-header-button").bind("click", Personetics.bind(this, this.optionHeaderClickEvent));
            this.frameEl.find('.pstory-prev-account-button').bind('click', function (e) {
                var selected = block.frameEl.find(".pstory-button.selected:not([clone='true'])");
                if (selected.parents('.carousel-disable').length > 0) {
                    return;
                }
                if(block.showArrows && block.config.nextArrowDir == "ltr")
                    selected.next().click();
                else selected.prev().click();
            });
            this.frameEl.find('.pstory-next-account-button').bind('click', function (e) {
                var selected = block.frameEl.find(".pstory-button.selected:not([clone='true'])");
                if (selected.parents('.carousel-disable').length > 0) {
                    return;
                }
                if(block.showArrows && block.config.nextArrowDir == "ltr" )
                    selected.prev().click();
                else selected.next().click();
            });
        },
        onInputSelect: function onInputSelect(e) {
            //for provide the parent function
        },
        optionClickEvent: function optionClickEvent(e) {
            //for provide the parent function
        },
        getReportValue: function (target) {
            return "Switch";
        },
        /*header click event and animation*/
        optionHeaderClickEvent: function optionHeaderClickEvent(e) {
            var target = $(e.currentTarget);
            var allAccounts = target.data('all');
            if (this.frameEl.find(".options-container").hasClass("allAccounts") == allAccounts){
                this.setFocusOnRelevantElement(allAccounts);
                return;
            }
            this.headerTabsAnimation(target);
            if (allAccounts) {
                this.onAllAccountsClick(true);
            }
            else {
                this.onChooseAccountClick(target);
            }
            this.updateAccessibilityButtons(allAccounts);
            this.setFocusOnRelevantElement(allAccounts);
            this.frameEl.find(".pstory-header-button").attr('aria-selected', 'false');//.removeClass("selected-header");
            target.attr('aria-selected', 'true');//.addClass("selected-header");

            this.notifyReportHeaderEvent(allAccounts);
        },
        setFocusOnRelevantElement: function setFocusOnRelevantElement(isAllAccountsState){
            var focusedElement;
            if(isAllAccountsState){
                focusedElement = this.frameEl.find(".pstory-all-accounts-txt");
            }
            else{
                focusedElement = this.frameEl.find(".pstory-account-button.selected");
            }
            this.putFocusAccessibility(focusedElement);

        },
        notifyReportHeaderEvent: function notifyReportHeaderEvent(allAccounts){
            var params = {};
            params.type = this.layoutInstructions.type;
            if (allAccounts) {
                params.value = "All";
            }
            else {
                params.value = "Specific";
            }
            this.notifyReportEvent(params);
        },
        /** Header tabs animation*/
        headerTabsAnimation: function headerTabsAnimation(selected) {
            if (typeof selected === "undefined" || selected === null || selected.length == 0)
                return;
            var tabAnimatedBorder = $(this.frameEl).find(".pstory-tab-animated-border-bottom");
            var left = selected.offset().left - this.frameEl.offset().left;
            var width = selected.innerWidth();
            if(this.isDesktopMode){
                tabAnimatedBorder.css({ "left": left + 'px', width: width + 'px' });
            }else{
                var tabList = this.frameEl.find(".tablist")
                tabAnimatedBorder.css({ "left": left > selected.width() ? (parseInt((tabList.width())) + parseInt(tabList.css("marginLeft")) - tabAnimatedBorder.width()) + "px" : left + "px"});
            }
        },
        onAllAccountsClick: function onAllAccountsClick(doAnimation) {
            this.frameEl.find('.pstory-block-content').removeClass('chooseAccount');
            this.frameEl.find('.pstory-block-content').addClass('allAccounts');
            this.frameEl.find('.carousel-outer-wrapper').addClass('allAccounts');
            this.frameEl.find('.options-container').addClass('allAccounts');
            this.frameEl.find('.options-container').addClass('carousel-disable');
            this.frameEl.find('.options-container').addClass('on-animation');
            this.carouselAnimation.setConfig();
            this.allAccountsSelectedAnimation(doAnimation);
            this.parent.notifyEvent(this, "setSelectedValue", this.all);

            /** Accessibility */
            this.frameEl.find('.pstory-all-accounts-txt').removeAttr("aria-hidden");
        },
        onChooseAccountClick: function onChooseAccountClick(target) {
            this.chooseAccountSelectedAnimation();
            this.frameEl.find('.pstory-block-content').addClass('chooseAccount');
            this.frameEl.find('.pstory-block-content').removeClass('allAccounts');
            this.frameEl.find('.carousel-outer-wrapper').removeClass('allAccounts');
            this.frameEl.find('.options-container').removeClass('allAccounts');
            this.frameEl.find('.options-container').removeClass('carousel-disable');
            this.carouselAnimation.setConfig();
            var selected = this.frameEl.find('.pstory-button.selected:not([clone="true"])');
            selected.prev().addClass("prev");
            selected.next().addClass("next");
            /*should do the fire event but dont need click event because the selected there is the class and we dont want the animation*/
            //selected.click();
            var selectedOpt = this.getOptionById(selected.attr('pstory-id'));
            this.parent.notifyEvent(this, "setSelectedValue", selectedOpt);

            /**accessibility */
            this.frameEl.find('.pstory-all-accounts-txt').attr("aria-hidden", true);
        },
        setAccessibility: function setAccessibility(isAllAccountsMode){
            if(this.options.cardsLength == 1){
                var prevNextAccountButtons = this.frameEl.find(".pstory-prev-account-button, .pstory-next-account-button");
                prevNextAccountButtons.css('display', 'none');
                prevNextAccountButtons.attr('aria-hidden', true);
                this.setAccSelectedButtonAriaLabel();
            }
            else this.updateAccessibilityButtons(isAllAccountsMode);
        },
        updateAccessibilityButtons: function updateAccessibilityButtons(isAllAccountsMode, selectedCard){
            var accountButtons = this.frameEl.find(".pstory-account-button");
            if(isAllAccountsMode)
                accountButtons.attr('aria-hidden', true);
            else{
                accountButtons.attr('aria-hidden', false);
                var accPrevAccount = accountButtons.filter('.pstory-prev-account-button');
                var accNextAccount = accountButtons.filter('.pstory-next-account-button');
                if(accNextAccount.hasClass('pstory-disable'))
                    accNextAccount.attr('aria-hidden', true);
                else accPrevAccount.attr('aria-hidden', true);
                this.setAccSelectedButtonAriaLabel(selectedCard);
            }
        },
        setAccSelectedButtonAriaLabel: function setAccSelectedButtonAriaLabel(selectedCard){
            if(typeof selectedCard === 'undefined' || selectedCard === null)
                selectedCard = this.frameEl.find('.pstory-button.selected:not([clone="true"])');
            var selectedOpt = this.getOptionById(selectedCard.attr('pstory-id'));
            var cards = this.frameEl.find('.pstory-button:not([clone="true"])')
            var index = cards.index(selectedCard) + 1;
            index = index == 0 ? 1 : index;
            var text = $('<span>' + selectedOpt.text + '</span>');
            if(text.find('br').length > 0){
                text.find('br').replaceWith(' ');
            }
            this.frameEl.find(".pstory-account-button.selected .perso-accessibility-read")
                .attr('aria-label',
                    '' +
                    selectedOpt.name +
                    '. '+
                    Personetics.dictionary.getText("lblaccSelectAccountAccessibility")+
                    ': ' +
                    selectedOpt.number +
                    '. ' +
                    text.text() +
                    '. ' +
                    index +
                    ' ' +
                    Personetics.dictionary.getText("accessibilityOutOfTxt") +
                    ' ' +
                    cards.length +
                    '. '+
                    Personetics.dictionary.getText("accessibilitySelected"))
                .attr("id","perso-accessibility-read-" + selectedOpt.id);
        },
        putFocusAccessibility: function putFocusAccessibility(elementForFocus) {
            var focusInterval = 10; // ms, time between function calls
            var focusTotalRepetitions = 10; // number of repetitions

            elementForFocus.attr('tabindex', '0');
            elementForFocus.blur();

            var focusRepetitions = 0;
            var interval = window.setTimeout(function () {
                elementForFocus.focus();
            }, focusInterval);
        },

        /*START Toggle choose account and allaccounts animation */
        allAccountsSelectedAnimation: function allAccountsSelectedAnimation(doAnimation) {
            var allTextEl = this.frameEl.find('.pstory-all-accounts-txt');
            var cardsForAnimation = this.getAllAccountsAnimationCards();
            var selectedCard = cardsForAnimation.filter('.selected');
            var notSelectedCards = cardsForAnimation.filter(':not(.selected)');
            var cardsLength = notSelectedCards.length;
            if (selectedCard.length == 0)
                return;
            if (doAnimation == true)
                cardsForAnimation.add(allTextEl).addClass("pstory-card-transition");
            else
                cardsForAnimation.add(allTextEl).removeClass("pstory-card-transition");
            cardsForAnimation.addClass('pstory-all-animated');
            this.frameEl.find('.options-container .pstory-button:not(.pstory-all-animated)').addClass('pstory-button-hidden');
            cardsForAnimation.removeClass('pstory-all-animated-last');
            notSelectedCards.last().addClass('pstory-all-animated-last');
            if(this.isRightToLeft){
                this.config.allAnimation.isRTL = this.isRightToLeft;
            }
            this.allAccountsAnimation.doAnimation(selectedCard, notSelectedCards, this.config.allAnimation);
        },

        chooseAccountSelectedAnimation: function chooseAccountSelectedAnimation() {
            var allTextEl = this.frameEl.find('.pstory-all-accounts-txt');
            this.frameEl.find(".pstory-button").add(allTextEl).addClass("pstory-card-transition");
            var cards = this.frameEl.find('.options-container .pstory-button');
            cards.removeClass("pstory-all-animated").removeClass('pstory-button-hidden');
            this.allAccountsAnimation.cancelAnimation(cards);
        },

        getAllAccountsAnimationCards: function getAllAccountsAnimationCards(){
            var cards = this.frameEl.find('.options-container .pstory-button:not(.carousel-hide-clone)');
            var startIndex, endIndex;
            var selectedItem = this.frameEl.find('.options-container .pstory-button.selected:not([clone="true"])')
            var selectedIndex = cards.index(selectedItem);
            startIndex = selectedIndex - Math.floor((this.options.cardsLength) / 2);
            endIndex = selectedIndex + Math.ceil((this.options.cardsLength) / 2);
            if(startIndex < 0){
                endIndex += Math.abs(startIndex);
                startIndex = 0;
            }
            else if(endIndex > cards.length){
                startIndex += endIndex - cards.length;
                endIndex = cards.length;
            }
            return cards.slice(startIndex, endIndex);
        },
        /*END Toggle choose account and allaccounts animation */
        /**after render functions */
        afterRender: function afterRender(el) {
            this.frameEl.parents('.pstory-dialog-frame').addClass('perso-account-selector');
            if(this.layoutInstructions.options.length == 1){
                this.frameEl.parents('.pstory-dialog-frame').addClass('perso-singel-account-selector');
            }
            this.setDefaultSelect();
            this.setAccountSelectorColors();
            this.bindCarousel();
            this.setDisableArrows();
            this.accSelectedAccountButtons();
            if(this.showArrows){
                this.frameEl.find('.pstory-account-button:not(.selected)').addClass('pstory-arrow');
            }
            else{
                this.accPrevNextAccountButtons();
            }
            if (this.showHeaderTabs){
                this.setCssForAllAnimation();
                this.allAccountsAnimation = Personetics.utils.allAccountsAnimation.getAnimation(this.config.allAnimation.type);
                var selecteTabAll = this.defaultTab === 'all';
                this.frameEl.find(".pstory-header-button[data-all='true']").attr('aria-selected', selecteTabAll);
                this.frameEl.find(".pstory-header-button[data-all='false']").attr('aria-selected', !selecteTabAll);
                this.frameEl.find(".cards-wrapper").attr("aria-hidden", selecteTabAll);
                var selectedHeader = this.frameEl.find("[aria-selected='true']");
                this.headerTabsAnimation(selectedHeader);
                if(selecteTabAll) {
                    this.onAllAccountsClick();
                }else{
                    this.onChooseAccountClick();
                    var me = this;
                    this.frameEl.find('.pstory-block-content').addClass('chooseAccount');
                    setTimeout(function()
                    {
                        me.onChooseAccountClick();
                        },300);
                }
            }
            Personetics.story.AccountSelectorBlock.prototype.afterRender.call(this, el);
            /**Accessibility */
            this.setAccessibility(this.defaultTab === 'all');
            var  frameEl = this.frameEl;
            this.el.find(".perso-accessibility-account-selector").css({
                'height': frameEl.outerHeight(),
                'width': frameEl.width()
            });
        },

        accSelectedAccountButtons: function accSelectedAccountButtons(){
            var relativeContainer = this.frameEl.find('.options-container');
            var selectedCardWrapper = this.frameEl.find('.pstory-button.selected:not([clone=true])');
            var selectedCard = selectedCardWrapper.find('.card');
            var accAccountButtonSelected = this.frameEl.find('.pstory-account-button.selected');
            accAccountButtonSelected.css({
                'top': selectedCard.offset().top - relativeContainer.offset().top,
                'height': selectedCard.outerHeight(true),
                'width': selectedCard.outerWidth(true),
                'left': selectedCard.offset().left - relativeContainer.offset().left
            });
        },
        accPrevNextAccountButtons: function accPrevNextAccountButton(){
            var relativeContainer = this.frameEl.find('.options-container');
            var selectedCardWrapper = this.frameEl.find('.pstory-button.selected:not([clone=true])');

            var prevNextCards = this.frameEl.find('.pstory-button.next .card, .pstory-button.prev .card');
            var accAccountButtons = this.frameEl.find('.pstory-account-button:not(.selected)');
            $.each(prevNextCards, function(i, card){
                var $card = $(card);
                //calculate the visible width of prev and next accounts
                var pstoryButtonPadding = $card.parent().outerWidth() - $card.parent().width();
                var accAccountButtonWidth = (relativeContainer.width() - selectedCardWrapper.outerWidth()) / 2 - pstoryButtonPadding / 2;
                $(accAccountButtons[i]).css({
                    'top': $card.offset().top - relativeContainer.offset().top,
                    'height': $card.outerHeight(),
                    'width': accAccountButtonWidth,
                    'left': Math.max($card.offset().left - relativeContainer.offset().left, 0)
                });
            });
        },
        setDefaultSelect: function (doAnimation) {
            var target = this.frameEl.find('.pstory-button.selected');
            if (target.length == 0) {
                $(this.frameEl.find('.pstory-button')[0]).addClass('selected');
            }
        },
        bindCarousel: function bindCarousel() {
            var param = this.prepareCarouselParam();
            this.carouselAnimation = new Personetics.utils.carouselAnimation.bindCarouselEventsForAnimation(this.frameEl.find(".options-container"), param);
        },
        prepareCarouselParam: function prepareCarouselParam() {
            var param = this.getOptionsWidth();
            param.showIndexDots = this.config.showIndexDots;
            param.beforeCarouselStart = Personetics.bind(this, this.beforeCarouselStart);
            return param;
        },
        beforeCarouselStart: function beforeCarouselStart(e) {
            //go to parent click function
            Personetics.story.AccountSelectorBlock.prototype.optionClickEvent.call(this, e);
            this.optionClickEvent(e);
            this.setDisableArrows(e.currentTarget);
            this.updateAccessibilityButtons(false, $(e.currentTarget));
        },
        setDisableArrows: function setDisableArrows(selectedItem){
            if(typeof selectedItem === 'undefined' || selectedItem === null)
                selectedItem = this.frameEl.find('.pstory-button.selected:not([clone="true"])');
            if(!this.config.enableInfiniteCarousel || this.options.cardsLength == 2){
                var prevArrow = this.el.find('.pstory-prev-account-button');
                var nextArrow = this.el.find('.pstory-next-account-button');
                if($(selectedItem).prev().attr('clone') == "true"){
                    if(this.config.nextArrowDir == "ltr" && this.showArrows){
                        nextArrow.addClass('pstory-disable');
                        prevArrow.removeClass('pstory-disable');
                    }
                    else{
                        prevArrow.addClass('pstory-disable');
                        nextArrow.removeClass('pstory-disable');
                    }
                }
                else if($(selectedItem).next().attr('clone') == "true"){
                    if(this.config.nextArrowDir == "ltr" && this.showArrows){
                        prevArrow.addClass('pstory-disable');
                        nextArrow.removeClass('pstory-disable');
                    }
                    else{
                        nextArrow.addClass('pstory-disable');
                        prevArrow.removeClass('pstory-disable');
                    }
                }
            }

        },
        getOptionsWidth: function getOptionsWidth() {
            var container = this.frameEl.find('.options-container');
            var allAccounts = container.hasClass("allAccounts");
            container.removeClass("allAccounts");

            var buttonWidth = container.find('.pstory-button:not(.selected)').outerWidth(true);
            if (typeof buttonWidth == 'undefined') {//support old jQuery
                buttonWidth = null;
            }
            var selectedWidth = container.find('.pstory-button.selected').outerWidth(true);//selected card width
            if (typeof selectedWidth == 'undefined') {//support old jQuery
                selectedWidth = null;
            }

            if (allAccounts == true) {
                container.addClass("allAccounts");
            }
            return { itemWidth: buttonWidth, selectedItemWidth: selectedWidth };
        },

        setAccountSelectorColors: function () {
            var listCards = this.frameEl.find(".pstory-button");
            var colors = this.story.uxCtrl.getAccountSelectorPalette();
            if(colors.length) {
                listCards.each(function (i, opt) {
                    $(opt).addClass(colors[i % colors.length]);
                });
            }
        },
        /**setting for all the animation */
        setCssForAllAnimation: function setCssForAllAnimation() {
            var container = this.frameEl.find('.options-container');
            container.addClass('pstory-all-animation-'+ this.config.allAnimation.type);
            //set height for options container to avoid jump on change from choose-account to all-accounts
            container.height(container.height());
        },
        /**collapse animation */
        doScrollEvent: function (skipAnimation) {
            if(this.supportBlockCollapse){
                var block = this;
                var elementDisplayed = this.frameEl.find('.carousel-outer-wrapper');
                this.collapseHelper.scrollEvent(block, elementDisplayed, skipAnimation);
            }
        },

        getSupportBlockCollapse: function getSupportBlockCollapse(){
			return Personetics.projectConfiguration.getConfig("supportCollapse") == true && Personetics.projectConfiguration.getConfig("accountSelectorCollapse") == true;
        },
        
        onCollapsed: function (elementDisplayed, heightForElementDisplayed, fixedContainer) {

        },
        onUnCollapsed: function (elementDisplayed) {

        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.AccountSelectorBlockProduct = Personetics.story.AccountSelectorBlock.extend({
        beforeRender: function (el, layoutInstructions) {
            Personetics.story.AccountSelectorBlock.prototype.beforeRender.call(this, el, layoutInstructions);
            var options = $.extend(true, [], layoutInstructions.options);
            var optAllIndex;
            var me = this;
            this.showHeaderTabs = false;
            this.defaultTab = 'choose-account';
            $.each(options, function (index, opt) {
                if (opt.id == 'all') {
                    optAllIndex = index;
                    me.showHeaderTabs = true;
                    me.all = $.extend(true, {}, (opt));
                    if(opt.selected)
                        me.defaultTab = 'all';
                    return false;
                }
            });
            if (typeof optAllIndex !== 'undefined') {
                options.splice(optAllIndex, 1);
            }
            options.cardsLength = options.length;
            this.options = options;
            if(this.story.cfg.widthMode === 'desktop'){
                this.config = this.story.uxCtrl.getAccountSelectorConfigDesktop();
                this.isDesktopMode = true;
            }
            else{
                this.config = this.story.uxCtrl.getAccountSelectorConfig();
                this.isDesktopMode = false;
            }
            this.showArrows = this.config.showArrows && this.options.cardsLength >= this.config.minAccountsForDisplayingArrows;
        },
        render: function (el, layoutInstructions) {
            this.el = el;
            var text = this.getAccountSelectorText();
            this.setImageValueForOptions();
            var param = {
                options: this.options,
                class: layoutInstructions.class,
                showHeaderTabs: this.showHeaderTabs,
                headersArray: this.getHeadersArray(),
                showIndexDots: this.config.showIndexDots,
                isDesktopMode: this.isDesktopMode
            };
            param = $.extend(param, text);
            var html = this.template(param);

            el.append(html);
            this.frameEl = el.find(".pstory-block-frame").last();
        },
        getHeadersArray: function getHeadersArray() {
            var result = [{
                text: Personetics.dictionary.getText("lblaccSelectAll"),
                isAll: true
            },{
                text: Personetics.dictionary.getText("lblaccSelectChoose"),
                isAll: false
            }];
            return result;
        },
        getAccountSelectorText: function getAccountSelectorText() {
            var text = {
                allAccountsTxt: this.all ? this.all.text : "",
                allAccountsTxt2: this.all ? this.all.text2 : "",

                next: Personetics.dictionary.getText("lblaccSelectNextAcc"),
                prev: Personetics.dictionary.getText("lblaccSelectPreviousAcc"),
                allAccountsName: Personetics.dictionary.getText("lblaccSelectAll"), //"All accounts"
                numberPref: Personetics.dictionary.getText("lblaccSelectAccount"),
                numberPrefAccessibility: Personetics.dictionary.getText("lblaccSelectAccountAccessibility"),accountSelectorText: Personetics.dictionary.getText("lblAccessibiliotyAccountSelectorText"),
            }
            return text;
        },
        setImageValueForOptions: function setImageValueForOptions(){
            $.each(this.options, function (i, opt) {
                var urlObj = Personetics.imageMap.getImageClass(opt.image, "account_selector");
                opt.isAbsoluteURL = urlObj.isAbsoluteURL;
                opt.image  = urlObj.url;
            });
        },
        bindEvents: function bindEvents() {
            Personetics.story.OptionsBlock.prototype.bindEvents.call(this);
            var block = this;
            this.frameEl.find(".pstory-header-button").bind("click", Personetics.bind(this, this.optionHeaderClickEvent));
            this.frameEl.find('.pstory-prev-account-button').bind('click', function (e) {
                var selected = block.frameEl.find(".pstory-button.selected:not([clone='true'])");
                if (selected.parents('.carousel-disable').length > 0) {
                    return;
                }
                if(block.showArrows && block.config.nextArrowDir == "ltr")
                    selected.next().click();
                else selected.prev().click();
            });
            this.frameEl.find('.pstory-next-account-button').bind('click', function (e) {
                var selected = block.frameEl.find(".pstory-button.selected:not([clone='true'])");
                if (selected.parents('.carousel-disable').length > 0) {
                    return;
                }
                if(block.showArrows && block.config.nextArrowDir == "ltr" )
                    selected.prev().click();
                else selected.next().click();
            });
        },
        onInputSelect: function onInputSelect(e) {
            //for provide the parent function
        },
        optionClickEvent: function optionClickEvent(e) {
            //for provide the parent function
        },
        getReportValue: function (target) {
            return "Switch";
        },
        /*header click event and animation*/
        optionHeaderClickEvent: function optionHeaderClickEvent(e) {
            var target = $(e.currentTarget);
            var allAccounts = target.data('all');
            if (this.frameEl.find(".options-container").hasClass("allAccounts") == allAccounts){
                this.setFocusOnRelevantElement(allAccounts);
                return;
            }
            this.headerTabsAnimation(target);
            if (allAccounts) {
                this.onAllAccountsClick(true);
            }
            else {
                this.onChooseAccountClick(target);
            }
            this.updateAccessibilityButtons(allAccounts);
            this.setFocusOnRelevantElement(allAccounts);
            this.frameEl.find(".pstory-header-button").attr('aria-selected', 'false');//.removeClass("selected-header");
            target.attr('aria-selected', 'true');//.addClass("selected-header");

            this.notifyReportHeaderEvent(allAccounts);
        },
        setFocusOnRelevantElement: function setFocusOnRelevantElement(isAllAccountsState){
            var focusedElement;
            if(isAllAccountsState){
                focusedElement = this.frameEl.find(".pstory-all-accounts-txt");
            }
            else{
                focusedElement = this.frameEl.find(".pstory-account-button.selected");
            }
            this.putFocusAccessibility(focusedElement);

        },
        notifyReportHeaderEvent: function notifyReportHeaderEvent(allAccounts){
            var params = {};
            params.type = this.layoutInstructions.type;
            if (allAccounts) {
                params.value = "All";
            }
            else {
                params.value = "Specific";
            }
            this.notifyReportEvent(params);
        },
        /** Header tabs animation*/
        headerTabsAnimation: function headerTabsAnimation(selected) {
            if (typeof selected === "undefined" || selected === null || selected.length == 0)
                return;
            var tabAnimatedBorder = $(this.frameEl).find(".pstory-tab-animated-border-bottom");
            var left = selected.offset().left - this.frameEl.offset().left;
            var width = selected.innerWidth();
            tabAnimatedBorder.css({ "left": left + 'px', width: width + 'px' });
        },
        onAllAccountsClick: function onAllAccountsClick(doAnimation) {
            this.frameEl.find('.options-container').addClass('allAccounts');
            this.frameEl.find('.options-container').addClass('carousel-disable');
            this.frameEl.find('.options-container').addClass('on-animation');
            this.carouselAnimation.setConfig();
            this.allAccountsSelectedAnimation(doAnimation);
            this.parent.notifyEvent(this, "setSelectedValue", this.all);

            /** Accessibility */
            this.frameEl.find('.pstory-all-accounts-txt').removeAttr("aria-hidden");
        },
        onChooseAccountClick: function onChooseAccountClick(target) {
            this.chooseAccountSelectedAnimation();
            this.frameEl.find('.options-container').removeClass('allAccounts');
            this.frameEl.find('.options-container').removeClass('carousel-disable');
            this.carouselAnimation.setConfig();
            var selected = this.frameEl.find('.pstory-button.selected:not([clone="true"])');
            selected.prev().addClass("prev");
            selected.next().addClass("next");
            /*should do the fire event but dont need click event because the selected there is the class and we dont want the animation*/
            //selected.click();
            var selectedOpt = this.getOptionById(selected.attr('pstory-id'));
            this.parent.notifyEvent(this, "setSelectedValue", selectedOpt);

            /**accessibility */
            this.frameEl.find('.pstory-all-accounts-txt').attr("aria-hidden", true);
        },
        setAccessibility: function setAccessibility(isAllAccountsMode){
            if(this.options.cardsLength == 1){
                var prevNextAccountButtons = this.frameEl.find(".pstory-prev-account-button, .pstory-next-account-button");
                prevNextAccountButtons.css('display', 'none');
                prevNextAccountButtons.attr('aria-hidden', true);
                this.setAccSelectedButtonAriaLabel();
            }
            else this.updateAccessibilityButtons(isAllAccountsMode);
        },
        updateAccessibilityButtons: function updateAccessibilityButtons(isAllAccountsMode, selectedCard){
            var accountButtons = this.frameEl.find(".pstory-account-button");
            if(isAllAccountsMode)
                accountButtons.attr('aria-hidden', true);
            else{
                accountButtons.attr('aria-hidden', false);
                var accPrevAccount = accountButtons.filter('.pstory-prev-account-button');
                var accNextAccount = accountButtons.filter('.pstory-next-account-button');
                if(accNextAccount.hasClass('pstory-disable'))
                    accNextAccount.attr('aria-hidden', true);
                else accPrevAccount.attr('aria-hidden', true);
                this.setAccSelectedButtonAriaLabel(selectedCard);
            }
        },
        setAccSelectedButtonAriaLabel: function setAccSelectedButtonAriaLabel(selectedCard){
            if(typeof selectedCard === 'undefined' || selectedCard === null)
                selectedCard = this.frameEl.find('.pstory-button.selected:not([clone="true"])');
            var selectedOpt = this.getOptionById(selectedCard.attr('pstory-id'));
            var cards = this.frameEl.find('.pstory-button:not([clone="true"])')
            var index = cards.index(selectedCard) + 1;
            index = index == 0 ? 1 : index;
            var text = $('<span>' + selectedOpt.text + '</span>');
            if(text.find('br').length > 0){
                text.find('br').replaceWith(' ');
            }
            this.frameEl.find(".pstory-account-button.selected .perso-accessibility-read")
                .attr('aria-label',
                    '' +
                    selectedOpt.name +
                    '. '+
                    Personetics.dictionary.getText("lblaccSelectAccountAccessibility")+
                    ': ' +
                    selectedOpt.number +
                    '. ' +
                    text.text() +
                    '. ' +
                    index +
                    ' ' +
                    Personetics.dictionary.getText("accessibilityOutOfTxt") +
                    ' ' +
                    cards.length +
                    '. '+
                    Personetics.dictionary.getText("accessibilitySelected"))
                .attr("id","perso-accessibility-read-" + selectedOpt.id);
        },
        putFocusAccessibility: function putFocusAccessibility(elementForFocus) {
            var focusInterval = 10; // ms, time between function calls
            var focusTotalRepetitions = 10; // number of repetitions

            elementForFocus.attr('tabindex', '0');
            elementForFocus.blur();

            var focusRepetitions = 0;
            var interval = window.setTimeout(function () {
                elementForFocus.focus();
            }, focusInterval);
        },

        /*START Toggle choose account and allaccounts animation */
        allAccountsSelectedAnimation: function allAccountsSelectedAnimation(doAnimation) {
            var allTextEl = this.frameEl.find('.pstory-all-accounts-txt');
            var cardsForAnimation = this.getAllAccountsAnimationCards();
            var selectedCard = cardsForAnimation.filter('.selected');
            var notSelectedCards = cardsForAnimation.filter(':not(.selected)');
            var cardsLength = notSelectedCards.length;
            if (selectedCard.length == 0)
                return;
            if (doAnimation == true)
                cardsForAnimation.add(allTextEl).addClass("pstory-card-transition");
            else
                cardsForAnimation.add(allTextEl).removeClass("pstory-card-transition");
            cardsForAnimation.addClass('pstory-all-animated');
            this.frameEl.find('.options-container .pstory-button:not(.pstory-all-animated)').addClass('pstory-button-hidden');
            cardsForAnimation.removeClass('pstory-all-animated-last');
            notSelectedCards.last().addClass('pstory-all-animated-last');
            this.allAccountsAnimation.doAnimation(selectedCard, notSelectedCards, this.config.allAnimation);
        },

        chooseAccountSelectedAnimation: function chooseAccountSelectedAnimation() {
            var allTextEl = this.frameEl.find('.pstory-all-accounts-txt');
            this.frameEl.find(".pstory-button").add(allTextEl).addClass("pstory-card-transition");
            var cards = this.frameEl.find('.options-container .pstory-button');
            cards.removeClass("pstory-all-animated").removeClass('pstory-button-hidden');
            this.allAccountsAnimation.cancelAnimation(cards);
        },

        getAllAccountsAnimationCards: function getAllAccountsAnimationCards(){
            var cards = this.frameEl.find('.options-container .pstory-button:not(.carousel-hide-clone)');
            var startIndex, endIndex;
            var selectedItem = this.frameEl.find('.options-container .pstory-button.selected:not([clone="true"])')
            var selectedIndex = cards.index(selectedItem);
            startIndex = selectedIndex - Math.floor((this.options.cardsLength) / 2);
            endIndex = selectedIndex + Math.ceil((this.options.cardsLength) / 2);
            if(startIndex < 0){
                endIndex += Math.abs(startIndex);
                startIndex = 0;
            }
            else if(endIndex > cards.length){
                startIndex += endIndex - cards.length;
                endIndex = cards.length;
            }
            return cards.slice(startIndex, endIndex);
        },
        /*END Toggle choose account and allaccounts animation */
        /**after render functions */
        afterRender: function afterRender(el) {
            this.frameEl.parents('.pstory-dialog-frame').addClass('perso-account-selector');
            this.setDefaultSelect();
            this.setAccountSelectorColors();
            this.bindCarousel();
            this.setDisableArrows();
            this.accSelectedAccountButtons();
            if(this.showArrows){
                this.frameEl.find('.pstory-account-button:not(.selected)').addClass('pstory-arrow');
            }
            else{
                this.accPrevNextAccountButtons();
            }
            if (this.showHeaderTabs){
                this.setCssForAllAnimation();
                this.allAccountsAnimation = Personetics.utils.allAccountsAnimation.getAnimation(this.config.allAnimation.type);
                var selecteTabAll = this.defaultTab === 'all';
                this.frameEl.find(".pstory-header-button[data-all='true']").attr('aria-selected', selecteTabAll);
                this.frameEl.find(".pstory-header-button[data-all='false']").attr('aria-selected', !selecteTabAll);
                this.frameEl.find(".cards-wrapper").attr("aria-hidden", selecteTabAll);
                var selectedHeader = this.frameEl.find("[aria-selected='true']");
                this.headerTabsAnimation(selectedHeader);
                if(selecteTabAll) {
                    this.onAllAccountsClick();
                }else{
                    this.onChooseAccountClick();
                    var me = this;
                    this.frameEl.find('.pstory-block-content').addClass('chooseAccount');
                    setTimeout(function()
                    {
                        me.onChooseAccountClick();
                    },300);
                }
            }
            Personetics.story.AccountSelectorBlock.prototype.afterRender.call(this, el);
            /**Accessibility */
            this.setAccessibility(this.defaultTab === 'all');
            var  frameEl = this.frameEl;
            this.el.find(".perso-accessibility-account-selector").css({
                'height': frameEl.outerHeight(),
                'width': frameEl.width()
            });
            if (Personetics.projectConfiguration.getConfig("supportCollapse") == true && Personetics.projectConfiguration.getConfig("accountSelectorCollapse") == true) {
                $(".pstory-all-accounts-txt").width($(".carousel-wrapper").width());
            }
        },
        updateCardsPadding: function(){
            var cards = $(".cards-wrapper").find(".carousel-item");
            var wrapper =$(".carousel-outer-wrapper");
            if(!this.story.uxCtrl.hasLayout($(window).width()) && cards.length > 1 && wrapper.find(".pstory-show-header-tabs").length){
                var wrapperWidth = wrapper.width();
                var padding = (wrapperWidth - 300) / 2;
                cards.each(function(){
                    $(this).css({"padding-left":padding + 15,"padding-right":padding + 15});
                });
            }
        },
        accSelectedAccountButtons: function accSelectedAccountButtons(){
            var relativeContainer = this.frameEl.find('.options-container');
            var selectedCardWrapper = this.frameEl.find('.pstory-button.selected:not([clone=true])');
            var selectedCard = selectedCardWrapper.find('.card');
            var accAccountButtonSelected = this.frameEl.find('.pstory-account-button.selected');
            accAccountButtonSelected.css({
                'top': selectedCard.offset().top - relativeContainer.offset().top,
                'height': selectedCard.outerHeight(true),
                'width': selectedCard.outerWidth(true),
                'left': selectedCard.offset().left - relativeContainer.offset().left
            });
        },
        accPrevNextAccountButtons: function accPrevNextAccountButton(){
            var relativeContainer = this.frameEl.find('.options-container');
            var selectedCardWrapper = this.frameEl.find('.pstory-button.selected:not([clone=true])');

            var prevNextCards = this.frameEl.find('.pstory-button.next .card, .pstory-button.prev .card');
            var accAccountButtons = this.frameEl.find('.pstory-account-button:not(.selected)');
            $.each(prevNextCards, function(i, card){
                var $card = $(card);
                //calculate the visible width of prev and next accounts
                var pstoryButtonPadding = $card.parent().outerWidth() - $card.parent().width();
                var accAccountButtonWidth = (relativeContainer.width() - selectedCardWrapper.outerWidth()) / 2 - pstoryButtonPadding / 2;
                $(accAccountButtons[i]).css({
                    'top': $card.offset().top - relativeContainer.offset().top,
                    'height': $card.outerHeight(),
                    'width': accAccountButtonWidth,
                    'left': Math.max($card.offset().left - relativeContainer.offset().left, 0)
                });
            });
        },
        setDefaultSelect: function (doAnimation) {
            var target = this.frameEl.find('.pstory-button.selected');
            if (target.length == 0) {
                $(this.frameEl.find('.pstory-button')[0]).addClass('selected');
            }
        },
        bindCarousel: function bindCarousel() {
            var param = this.prepareCarouselParam();
            this.carouselAnimation = new Personetics.utils.carouselAnimation.bindCarouselEventsForAnimation(this.frameEl.find(".options-container"), param);
        },
        prepareCarouselParam: function prepareCarouselParam() {
            var param = this.getOptionsWidth();
            param.showIndexDots = this.config.showIndexDots;
            param.beforeCarouselStart = Personetics.bind(this, this.beforeCarouselStart);
            return param;
        },
        beforeCarouselStart: function beforeCarouselStart(e) {
            //go to parent click function
            Personetics.story.AccountSelectorBlock.prototype.optionClickEvent.call(this, e);
            this.optionClickEvent(e);
            this.setDisableArrows(e.currentTarget);
            this.updateAccessibilityButtons(false, $(e.currentTarget));
        },
        setDisableArrows: function setDisableArrows(selectedItem){
            if(typeof selectedItem === 'undefined' || selectedItem === null)
                selectedItem = this.frameEl.find('.pstory-button.selected:not([clone="true"])');
            if(!this.config.enableInfiniteCarousel || this.options.cardsLength == 2){
                var prevArrow = this.el.find('.pstory-prev-account-button');
                var nextArrow = this.el.find('.pstory-next-account-button');
                if($(selectedItem).prev().attr('clone') == "true"){
                    if(this.config.nextArrowDir == "ltr" && this.showArrows){
                        nextArrow.addClass('pstory-disable');
                        prevArrow.removeClass('pstory-disable');
                    }
                    else{
                        prevArrow.addClass('pstory-disable');
                        nextArrow.removeClass('pstory-disable');
                    }
                }
                else if($(selectedItem).next().attr('clone') == "true"){
                    if(this.config.nextArrowDir == "ltr" && this.showArrows){
                        prevArrow.addClass('pstory-disable');
                        nextArrow.removeClass('pstory-disable');
                    }
                    else{
                        nextArrow.addClass('pstory-disable');
                        prevArrow.removeClass('pstory-disable');
                    }
                }
            }

        },
        getOptionsWidth: function getOptionsWidth() {
            var container = this.frameEl.find('.options-container');
            var allAccounts = container.hasClass("allAccounts");
            container.removeClass("allAccounts");

            var buttonWidth = container.find('.pstory-button:not(.selected)').outerWidth(true);
            if (typeof buttonWidth == 'undefined') {//support old jQuery
                buttonWidth = null;
            }
            var selectedWidth = container.find('.pstory-button.selected').outerWidth(true);//selected card width
            if (typeof selectedWidth == 'undefined') {//support old jQuery
                selectedWidth = null;
            }

            if (allAccounts == true)
                container.addClass("allAccounts");
            return { itemWidth: buttonWidth, selectedItemWidth: selectedWidth };
        },

        setAccountSelectorColors: function () {
            var listCards = this.frameEl.find(".pstory-button");
            var colors = this.story.uxCtrl.getAccountSelectorPalette();
            var sum = Math.ceil(listCards.length / colors.length);
            var newColors = [];
            for (var i = 0; i < sum; i++) {
                newColors = newColors.concat(colors);
            }

            listCards.each(function (i, opt) {
                $(opt).addClass(newColors[i]);
            });
        },
        /**setting for all the animation */
        setCssForAllAnimation: function setCssForAllAnimation() {
            var container = this.frameEl.find('.options-container');
            container.addClass('pstory-all-animation-'+ this.config.allAnimation.type);
            //set height for options container to avoid jump on change from choose-account to all-accounts
            container.height(container.height());
        },
        /**collapse animation */
        doScrollEvent: function (skipAnimation) {
            if(this.supportBlockCollapse){
                var block = this;
                var elementDisplayed = this.frameEl.find('.carousel-outer-wrapper');
                this.collapseHelper.scrollEvent(block, elementDisplayed, skipAnimation);
            }
        },

        getSupportBlockCollapse: function getSupportBlockCollapse(){
			return Personetics.projectConfiguration.getConfig("supportCollapse") == true && Personetics.projectConfiguration.getConfig("accountSelectorCollapse") == true;
        },
        
        onCollapsed: function (elementDisplayed, heightForElementDisplayed, fixedContainer) {

        },
        onUnCollapsed: function (elementDisplayed) {

        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.D3BarChartBlockProduct = Personetics.story.D3BarChartBlock.extend({
        beforeRender: function (el, layoutInstructions) {
            Personetics.story.D3BarChartBlock.prototype.beforeRender.call(this, el, layoutInstructions);
        },
        afterRender: function afterRender(el) {
            if (this.chartType == "vertical" || this.chartType == "multiVertical" || this.chartType == "pinGraph") {
                /**set the foreignObject height as xaxis height */
                this.xAxis = this.frameEl.find('.x.axis')[0];
            }
            Personetics.story.D3BarChartBlock.prototype.afterRender.call(this, el);
            var baseValWidth = el.find(".pstory-bar-chart svg, .pstory-pinGraph-chart svg").attr('width').baseVal;
            var widthSVG;
            if (typeof baseValWidth !== 'undefined' && baseValWidth !== null)
                widthSVG = baseValWidth.value;
            else
                widthSVG = el.find(".pstory-bar-chart svg, .pstory-pinGraph-chart svg").attr('width');
            var halfWidthSVG = widthSVG / 2 + 'px';
            el.find(".pstory-bar-chart, .pstory-pinGraph-chart svg").css('padding-left', "calc(50% - " + halfWidthSVG + ")");
            this.renderAccessibility(el, this.chartType);
        },
        //render buttons for accessibility
        renderAccessibility: function renderAccessibility(el, chartType) {
            var element = $("<div class='accessibility-chart-wrapper'></div>");
            var layoutInstructions = this.layoutInstructions;
            var block = this;
            var chartSvg = $(el).find("svg.perso-svg-chart-container");
            var chartSvgOffset = chartSvg.offset();
            var buttonHeight;
            var buttonTop;
            var buttonLeft;

            var button;
            if (chartType != "pinGraph") {
                el.find("svg .x.axis .tick").each(function (index, item) {
                    button = $("<input type='button' id='accessibility-chart-button_"+ layoutInstructions.categories[index]+ "' class='accessibility-chart-button'/>");
                    block.setUnclickableClass(button,chartType,index);
                    buttonHeight = $(item).get(0).getBBox().height;
                    button.css('width', $(item).get(0).getBBox().width + "px");
                    buttonTop = $(item).offset().top - chartSvgOffset.top;
                    buttonLeft = $(item).offset().left - chartSvgOffset.left;
                    button.css({ 'left': buttonLeft + "px", 'top': buttonTop + 'px' });
                    button.height(buttonHeight);
                    block.ariaLabelAccessibilityButtons(button, layoutInstructions, index, chartType);
                    block.ariaLabelSetSelected(el, item, button);
                    $(button).bind('click', function (e) {
                        block.handleClickAccessibilityButtons(layoutInstructions, index, chartType);
                        block.ariaLabelSetSelected(el, item, $(this));
                    });
                    element.prepend(button);
                });
                el.find(".pstory-bar-chart, .pstory-pinGraph-chart").append(element);

            }
        },

        getETransform: function getETransform(el) {
            var innerWrapper = el.find("svg .perso-bar, svg .perso-chart-rect").parent();
            var innerWrapperTransform = innerWrapper.css('transform');
            if (innerWrapperTransform != "none") {
                if (typeof innerWrapperTransform === undefined || innerWrapperTransform === null)
                    innerWrapperTransform = innerWrapper.css('-webkit-transform');
                if (typeof WebKitCSSMatrix !== 'undefined')
                    var oldTransition = new WebKitCSSMatrix(innerWrapperTransform)['e'];
                //explorer doesn't support WebKitCSSMatrix.
                else
                    var oldTransition = new MSCSSMatrix(innerWrapperTransform)['e'];
            }
            else {
                innerWrapperTransform = innerWrapper.attr('transform');
                if (typeof innerWrapperTransform.baseVal !== "undefined")
                    var oldTransition = innerWrapperTransform.baseVal.getItem(0).matrix.e;
            }
            return oldTransition;
        },

        ariaLabelSetSelected: function ariaLabelSetSelected(el, item, button) {
            var classSelected = $(item).find('.perso-xAxis-label.selected').length > 0 ? " selected" : "";
            // var classSelected = item.className.baseVal.indexOf('selected') > -1 ? " selected" : "";
            var selected = el.find(".accessibility-chart-button.selected");
            if (selected.length > 0) {
                var ariaLabel = selected.attr('aria-label').split('selected');
                selected.attr('aria-label', ariaLabel[0] + '');
                selected.removeClass("selected");
            }
            if (classSelected == " selected") {
                button.addClass("selected");
            }
            button.attr('aria-label', button.attr('aria-label') + classSelected);
        },
        ariaLabelAccessibilityButtons: function ariaLabelAccessibilityButtons(button, layoutInstructions, index, chartType) {
            var i = layoutInstructions.categories.length - index;
            var monthNumber = Personetics.processor.PUtils.getUtilsInstance("dateUtils").getMonthNumber(Personetics.processor.PStoryConfig.getConfig("lang")+"-short",layoutInstructions.categories[index])
            var fullMonthName = Personetics.processor.PUtils.getUtilsInstance("dateUtils").getMonthName(Personetics.processor.PStoryConfig.getConfig("lang"))[monthNumber]
            fullMonthName = fullMonthName || layoutInstructions.categories[index]
            var currencySymbol = Personetics.projectConfiguration.getConfig("currencySymbol");
            var seriesNamesForDisplay = this.seriesNamesForDisplay;
            if (chartType == "multiVertical") {
                button.attr("aria-label",
                    '' +
                    fullMonthName +
                    ', ' +
                    Personetics.dictionary.getText("accessibilitySeries") + " " + seriesNamesForDisplay[0] +
                    ': ' +
                    currencySymbol +
                    (layoutInstructions.series[0][index].value).toLocaleString("en") +
                    ', ' +
                    Personetics.dictionary.getText("accessibilitySeries") + " " + seriesNamesForDisplay[1] +
                    ': -' +
                    currencySymbol +
                   (layoutInstructions.series[1][index].value).toLocaleString("en") +
                    ', ' +
                    i +
                    " " +
                    Personetics.dictionary.getText("accessibilityOutOfTxt") +
                    " " +
                    layoutInstructions.categories.length + '');
            } else {
                button.attr("aria-label",
                    fullMonthName +
                    ', ' +
                    currencySymbol +
                    (layoutInstructions.series[index].value).toLocaleString("en") +
                    ', ' +
                    i +
                    " " +
                    Personetics.dictionary.getText("accessibilityOutOfTxt") +
                    " " +
                    layoutInstructions.categories.length + '');
            }
        },

        handleClickAccessibilityButtons: function handleClickAccessibilityButtons(layoutInstructions, index, chartType) {
            var seriesData = layoutInstructions.series;
            if (chartType == "multiVertical") {
                var clickedObj = layoutInstructions.series[0][index];
                if((seriesData[1][index].value !== 0 || seriesData[0][index].value !== 0)
                    && seriesData[1][index].category === clickedObj.category && seriesData[0][index].category === clickedObj.category) {
                    this.handleClick.call(this, clickedObj, index);
                }
            }
            else {
                var clickedObj = layoutInstructions.series[index];
                this.handleClick.call(this, clickedObj, index);
            }
            var nextElementForFocus;
            var blockElements = this.el.parents(".pstory-dialog-frame").next().find(".pstory-block-content, .pstory-block-content *");
            if(!this.frameEl.hasClass('perso-collapsed')){
                if(typeof Personetics.utils.accessibility !== 'undefined' && Personetics.utils.accessibility !== null){
                    $.each(blockElements, function(index, element){
                        if(Personetics.utils.accessibility.isFocusable(element)){
                            nextElementForFocus = $(element);
                            return false;
                        }
                    });
                    if(typeof nextElementForFocus !== "undefined" && nextElementForFocus.length > 0)
                        this.putFocusAccessibility(nextElementForFocus);
                }
            }
        },

        putFocusAccessibility: function putFocusAccessibility(elementForFocus) {
            var focusInterval = 10; // ms, time between function calls
            var focusTotalRepetitions = 10; // number of repetitions

            elementForFocus.attr('tabindex', '0');
            elementForFocus.blur();

            var focusRepetitions = 0;
            var interval = window.setTimeout(function () {
                elementForFocus.focus();
            }, focusInterval);
        },

        /**collapse animation */
        doScrollEvent: function (skipAnimation) {
            Personetics.story.D3BarChartBlock.prototype.doScrollEvent.call(this, skipAnimation);
            if(this.supportBlockCollapse){
                if (this.chartType == "vertical" || this.chartType == "multiVertical") {
                    var block = this;
                    var elementDisplayed = $(this.xAxis);
                    this.collapseHelper.scrollEvent(block, elementDisplayed, skipAnimation);
                }
            }
        },

        getSupportBlockCollapse: function getSupportBlockCollapse(){
			return Personetics.projectConfiguration.getConfig("supportCollapse") == true && Personetics.projectConfiguration.getConfig("monthPickerCollapse") == true;
		},

        onCollapsed: function (elementDisplayed, heightForElementDisplayed, fixedContainer) {

        },

        onUnCollapsed: function (elementDisplayed, heightForElementDisplayed, fixedContainer) {
            elementDisplayed[0].setAttribute("transform", elementDisplayed[0].getAttribute("transform"));
        },
        handleClick: function(obj, clickedItemIndex) {
            Personetics.story.D3BarChartBlock.prototype.handleClick.call(this, obj, clickedItemIndex);
        },
        setUnclickableClass: function(el, chartType, index){
            var block = this;
            var seriesData = block.layoutInstructions.series;
            if (chartType == "multiVertical") {
                if(seriesData[0][index].value === 0 && seriesData[1][index].value === 0){
                    el.addClass('perso-unclickable');
                }
            } else {
                if(seriesData[index].value === 0){
                    el.addClass('perso-unclickable');
                }
            }
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.ButtonsBlockProduct = Personetics.story.ButtonsBlock.extend({

        bindEvnetsForAnimation: function bindEvnetsForAnimation(){
            if(this.layoutInstructions.type.toLowerCase() !== "quiz") {
                if (Personetics.utils.buttonAnimation && $.isFunction(Personetics.utils.buttonAnimation.bindMaterialButtonEventsForAnimation)) {
                    Personetics.utils.buttonAnimation.bindMaterialButtonEventsForAnimation(this.frameEl.find(".pstory-button"));
                }
            }
        },
            
   });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.NewPieChartBlockProduct = Personetics.story.NewPieChartBlock.extend({

        beforeRender: function beforeRender(el, layoutInstructions) {
            Personetics.story.PieChartBlock.prototype.beforeRender.call(this, el, layoutInstructions);
            //get selected tab from previous dialogs for change pie colors in outflows case
            el.closest(".pstory-dialog-frame").addClass("pstory-dialog-frame-pie")
            var previousDialogs = el.parents('.pstory-dialog-frame').prev('.pstory-dialog-frame');
            var tabsBlock = previousDialogs.find('.pstory-block-tabs');
            var selectedTab = tabsBlock.find('.pstory-button.selected');
            var selectedTabId = selectedTab.attr("pstory-id");
            this.setCornerRadiusPie();
            this.colors = d3.scale.ordinal().range(this.getGraphPalette(selectedTabId));
            this.grayColors = d3.scale.ordinal().range(this.story.uxCtrl.getPieGrayColors());
            this.selectedTabId = selectedTabId;
            this.texts = $.extend(true, this.texts, {
                nextCategory: Personetics.dictionary.getText("accessibilityNextCategory"),
                previousCategory: Personetics.dictionary.getText("accessibilityPreviousCategory"),
                selectedCategoryTitle: Personetics.dictionary.getText("accessibilitySelectedCategoryTitle")
            });
        },
        setCornerRadiusPie: function(){
            if (typeof this.story.uxCtrl.getPieOptions == "function" &&
                typeof this.story.uxCtrl.getPieOptions().arcs != "undefined") {
                this.cornerRadiusPie = typeof this.story.uxCtrl.getPieOptions().arcs.cornerRadius != "undefined" ? this.story.uxCtrl.getPieOptions().arcs.cornerRadius.radiusCorner : 9;
            }
        },
        getPieOptions: function(){
            return this.story.uxCtrl.getPieOptions();
        },
        getGraphPalette: function (selectedTabId) {
            return this.story.uxCtrl.getPieGraphPalette(selectedTabId);
        },
        /**pie beforeRender definations */
        /**render svg base and base attributes */
        renderPieBase: function renderPieBase(el) {
            Personetics.story.PieChartBlock.prototype.renderPieBase.call(this, el);
        },
        renderGradient: function () {
            var gradients = this.options.arcs.gradients;
            var defWithGradients = this.svg.append("defs");
            if (gradients) {
                $.each(gradients, function (i, gradient) {
                    if (gradient) {
                        defWithGradients = defWithGradients.append("linearGradient")
                            .attr("id", gradient.id)
                            .attr("x1", "0")
                            .attr("x2", "0")
                            .attr("y1", "0")
                            .attr("y2", "1");

                        $.each(gradient.stopColors, function (i, stopColor) {
                            defWithGradients.append("stop")
                                .attr("offset", gradient.offset[i])
                                .attr("stop-color", stopColor);
                        })
                    }
                });
            }
        },
        /**render the pie */
        renderArcs: function (layoutInstructions) {
            var block = this;
            Personetics.story.PieChartBlock.prototype.renderArcs.call(this, layoutInstructions);
            if (this.options.arcs.filter.grayFilter == true) {
                var arcs = this.frameEl.find('.pstory-pie-chart svg .perso-arc path');
                $.each(arcs, function (i, arc) {
                    d3.select(arc).style("fill", function(d) { return block.grayColors(d.data.category); })
                });
            }
            this.arcs = arcs;
        },
        /**afterRender functions */
        afterRender: function (el) {
            var block = this;
            var defaultPath = block.frameEl.find('.pstory-pie-chart svg .perso-arc path.perso-selected')[0];

            //save path orders, to keep them the same
            block.arcPaths = block.frameEl.find('.pstory-pie-chart svg .perso-arc path');
            this.drawSelected();
            //move the arc path to front
            d3.select(defaultPath).moveToFront();
            //set default values in pie info container
            var selected = block.layoutInstructions.slices[block.getSelectedPathIndex(block.arcPaths)];
            block.initPieInfoValues(selected);
            if (block.layoutInstructions.slices.length > 1) {
                block.frameEl.find('.pstory-pie-data .pstory-arrow').show();
            }
            else {
                block.frameEl.find('.pstory-pie-data .pstory-arrow').hide();
            }
            Personetics.story.PieChartBlock.prototype.afterRender.call(block, el);
        },

        drawSelected: function drawSelected(){
            var block = this;
            //only do after render if render method doesn't fail
            if(this.pieDrew == true){
                if (block.frameEl) {
                    block.frameEl.addClass(block.selectedTabId);
                    var defaultPath = block.arcPaths[this.getSelectedIndex()];
                    //TODO
                    var radius = block.story.uxCtrl.getPieOptions().arcs.cornerRadius ? block.story.uxCtrl.getPieOptions().arcs.cornerRadius.radiusCorner : 9;
                    d3.select(defaultPath)
                        .transition()
                        .duration(0)
                        .delay(block.options.pieSelectedDelay)
                        .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                        .style("filter", block.dropShadow)
                        .style("fill", function (d, i) {
                            return block.colorArcs(d.data.category);
                        });
                    block.renderGradient();
                }
            }
        },

        /**events functions */
        bindEvents: function () {
            // only bind events if render method didn't fail
            if (this.frameEl) {
                var block = this;
                var $nextArrow = this.frameEl.find('.pstory-next-arrow');
                var $previousArrow = this.frameEl.find('.pstory-previous-arrow');
                var $paths = block.arcPaths;
                $nextArrow.bind('click', function (e) {
                    var currentItemIndex = block.getSelectedPathIndex($paths);
                    if (currentItemIndex == ($paths.length - 1)) {
                        block.moveArcs(0);
                        block.handleClick(block.layoutInstructions.slices[0], 0);
                    } else {
                        block.moveArcs(++currentItemIndex);
                        block.handleClick(block.layoutInstructions.slices[currentItemIndex], currentItemIndex);
                    }
                    if(document.activeElement == this) {
                        block.putFocusAccessibility($(this).closest(".pstory-block-content"));
                    }
                });

                $previousArrow.bind('click', function (e) {
                    var currentItemIndex = block.getSelectedPathIndex($paths);
                    if (currentItemIndex == 0) {
                        block.moveArcs($paths.length - 1);
                        block.handleClick(block.layoutInstructions.slices[$paths.length - 1], $paths.length - 1);
                    } else {
                        block.moveArcs(--currentItemIndex);
                        block.handleClick(block.layoutInstructions.slices[currentItemIndex], currentItemIndex);
                    }
                    if(document.activeElement == this) {
                        block.putFocusAccessibility($(this).closest(".pstory-block-content"));
                    }
                });
            }
        },

        putFocusAccessibility: function putFocusAccessibility(elementForFocus) {
            var focusInterval = 10; // ms, time between function calls
            var focusTotalRepetitions = 10; // number of repetitions

            elementForFocus.attr('tabindex', '0');
            elementForFocus.blur();

            var focusRepetitions = 0;
            var interval = window.setTimeout(function () {
                elementForFocus.focus();
            }, focusInterval);
        },

        onPieItemClick: function onPieItemClick(obj, clickedItemIndex, clickedItem) {
            var block = this;
            var oldSelectedArc = this.el.find('.perso-arc path.perso-selected');
            if (oldSelectedArc[0] != clickedItem) {//disable click on selected
                /**set the old selected path*/
                if (oldSelectedArc.length) {
                    oldSelectedArc[0].className.baseVal = Personetics.utils.string.removeClass(oldSelectedArc[0].className, 'perso-selected');
                    d3.select(oldSelectedArc[0])
                        .attr("d", block.arc)
                        .style("fill", function(d) { return block.grayColors(d.data.category); })
                }
                d3.select(clickedItem)
                    .attr("d", block.arcOver.cornerRadius(this.cornerRadiusPie))
                    .attr("class", "perso-selected")
                    .style("filter", this.dropShadow)
                    .style("fill", function(d) { return block.colors(d.data.category); })
                d3.select(clickedItem).moveToFront();
                this.handleClick(obj, clickedItemIndex);
                this.updatePieInfoValues(obj.data);
            }
        },

        updatePieInfoValues: function (obj) {
            var block = this;
            if (obj) {
                var amountDiv = '<div class="pstory-pie-amount perso-accessibility-no-read"><span>' + obj.label + '</span></div>';
                var categoryDiv = '<div class="pstory-pie-category perso-accessibility-no-read"><span>' + obj.category + '</span></div>';

                var $infoContainer = this.frameEl.find('.pstory-pie-info');
                $infoContainer.empty();
                $infoContainer.append(amountDiv);
                $infoContainer.append(categoryDiv);
                this.addInfoTextForAccessibility($infoContainer, obj);

                //set color from Palette
                this.setAmountColor(block.colors(obj.category));
            }
        },
        setAmountColor:function(color){
            if (this.options.arcs.filter.grayFilter == true) {
                $('.pstory-pie-amount').css('color', color)
            }
        },
        initPieInfoValues: function (obj) {
            this.updatePieInfoValues(obj);
        },

        addInfoTextForAccessibility: function addInfoTextForAccessibility($infoContainer, obj) {
            $infoContainer.prepend('<span class="perso-accessibility-read">' + obj.label + ', ' + obj.category + '</span>');
            $infoContainer.find(".perso-accessibility-no-read").attr('aria-hidden', true);
        },
        // this function move the selected arc to next/prev when click on arrows
        moveArcs: function (index) {
            var block = this;
            var path = block.arcPaths[index];
            var filter = '';
            var prevIndex = this.getSelectedIndex();
            var colors = this.options.arcs.filter.grayFilter ? block.grayColors : block.colors;
            if (path) {
                if(index !== prevIndex){
                    var prevPath = block.arcPaths[prevIndex];
                    d3.select(prevPath)
                        .attr("d", block.arc)
                        .style("fill", function(d) { return colors(d.data.category); })
                        .attr("class","")
                }
                d3.select(path)
                    .attr("d", block.arcOver.cornerRadius(this.cornerRadiusPie))
                    .attr("class", "perso-selected")
                    .style("filter", this.dropShadow)
                    .style("fill", function (d, i) {
                        return block.colors(d.data.category);
                    });
                d3.select(path).moveToFront();

                //set default values in pie info container
                block.updatePieInfoValues(block.layoutInstructions.slices[index]);
                this.setSelectedIndex(index);
            }
        },
        colorArcs: function (category) {
            var block = this;
            var color = block.colors(category);
            if (block.selectedTabId) {
                if (block.selectedTabId == "Out" && block.options.arcs.selectedOutflowPrimaryColor != null) {
                    color = block.options.arcs.selectedOutflowPrimaryColor;
                } else if (block.selectedTabId == "In" && block.options.arcs.selectedInflowPrimaryColor != null) {
                    color = block.options.arcs.selectedInflowPrimaryColor;
                }
            } else if (block.options.arcs.selctedPrimaryColor != null) {
                color = block.options.arcs.selctedPrimaryColor;
            }
            return color;
        },
        /**collapse animation */
        getIsDrawed: function(){
            return this.isDrawed ? this.isDrawed : false;
        },
        setIsDrawed: function(val){
            this.isDrawed = val;
        },
        doScrollEvent: function (skipAnimation) {
            Personetics.story.PieChartBlock.prototype.doScrollEvent.call(this, skipAnimation);
            if(this.isBlockPositionInViewport(this.frameEl) && !this.getIsDrawed()){
                this.setIsDrawed(true);
                this.drawSelected();
            }
            if (this.supportBlockCollapse) {
                var block = this;
                var elementDisplayed = this.frameEl.find('.pstory-pie-data');
                this.collapseHelper.scrollEvent(block, elementDisplayed, skipAnimation);
            }
        },
        
        getSupportBlockCollapse: function getSupportBlockCollapse(){
            return Personetics.projectConfiguration.getConfig("supportCollapse") == true && Personetics.projectConfiguration.getConfig("pieChartCollapse") == true;
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.PieChartBlockProduct = Personetics.story.PieChartBlock.extend({

        beforeRender: function beforeRender(el, layoutInstructions) {
            Personetics.story.PieChartBlock.prototype.beforeRender.call(this, el, layoutInstructions);
            //get selected tab from previous dialogs for change pie colors in outflows case
            var previousDialogs = el.parents('.pstory-dialog-frame').prev('.pstory-dialog-frame');
            var tabsBlock = previousDialogs.find('.pstory-block-tabs');
            var selectedTab = tabsBlock.find('.pstory-button.selected');
            var selectedTabId = selectedTab.attr("pstory-id");
            if (typeof this.story.uxCtrl.getPieOptions == "function")
                if (typeof this.story.uxCtrl.getPieOptions().arcs != "undefined")
                    this.cornerRadiusPie = typeof this.story.uxCtrl.getPieOptions().arcs.cornerRadius != "undefined" ? this.story.uxCtrl.getPieOptions().arcs.cornerRadius.radiusCorner : 9;
            this.colors = d3.scale.ordinal().range(this.getGraphPalette(selectedTabId));
            this.selectedTabId = selectedTabId;
            this.texts = $.extend(true, this.texts, {
                nextCategory: Personetics.dictionary.getText("accessibilityNextCategory"),
                previousCategory: Personetics.dictionary.getText("accessibilityPreviousCategory"),
                selectedCategoryTitle: Personetics.dictionary.getText("accessibilitySelectedCategoryTitle")
            });
        },
        getGraphPalette: function (selectedTabId) {
            return this.story.uxCtrl.getPieGraphPalette(selectedTabId);
        },
        /**pie beforeRender definations */
        /**render svg base and base attributes */
        renderPieBase: function renderPieBase(el) {
            Personetics.story.PieChartBlock.prototype.renderPieBase.call(this, el);
            if (this.options.arcs.filter.grayFilter == true) {
                this.renderGrayFilter();
            }
        },

        renderGrayFilter: function renderGrayFilter() {
            this.svg.append("filter")
                .attr("id", this.grayscaleId)
                .append("feColorMatrix")
                .attr("type", "matrix")
                .attr("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0")
        },
        renderGradient: function () {
            var gradients = this.options.arcs.gradients;
            var defWithGradients = this.svg.append("defs");
            if (gradients) {
                $.each(gradients, function (i, gradient) {
                    if (gradient) {
                        defWithGradients = defWithGradients.append("linearGradient")
                            .attr("id", gradient.id)
                            .attr("x1", "0")
                            .attr("x2", "0")
                            .attr("y1", "0")
                            .attr("y2", "1");

                        $.each(gradient.stopColors, function (i, stopColor) {
                            defWithGradients.append("stop")
                                .attr("offset", gradient.offset[i])
                                .attr("stop-color", stopColor);
                        })
                    }
                });
            }
        },
        /**render the pie */
        renderArcs: function (layoutInstructions) {
            Personetics.story.PieChartBlock.prototype.renderArcs.call(this, layoutInstructions);
            var grayscaleId = this.grayscaleId;
            if (this.options.arcs.filter.grayFilter == true) {
                var arcs = this.frameEl.find('.pstory-pie-chart svg .perso-arc path');
                $.each(arcs, function (i, arc) {
                    d3.select(arc).style("filter", "url(#" + grayscaleId + ")");
                });
            }
            this.arcs = arcs;
        },
        /**afterRender functions */
        afterRender: function (el) {
            var block = this;
            var defaultPath = block.frameEl.find('.pstory-pie-chart svg .perso-arc path.perso-selected')[0];

            //save path orders, to keep them the same
            block.arcPaths = block.frameEl.find('.pstory-pie-chart svg .perso-arc path');
            this.drawSelected();
            //move the arc path to front
            d3.select(defaultPath).moveToFront();
            //set default values in pie info container
            var selected = block.layoutInstructions.slices[block.getSelectedPathIndex(block.arcPaths)];
            block.initPieInfoValues(selected);
            if (block.layoutInstructions.slices.length > 1) {
                block.frameEl.find('.pstory-pie-data .pstory-arrow').show();
            }
            else {
                block.frameEl.find('.pstory-pie-data .pstory-arrow').hide();
            }
            Personetics.story.PieChartBlock.prototype.afterRender.call(block, el);
        },

        drawSelected: function drawSelected(){
            var block = this;
            //only do after render if render method doesn't fail
            if(this.pieDrew == true && !this.isFirstTime){
                this.isFirstTime = true;
                if (block.frameEl) {
                    block.frameEl.addClass(block.selectedTabId);
                    var defaultPath = block.frameEl.find('.pstory-pie-chart svg .perso-arc path.perso-selected')[0];
                    //TODO
                    var radius = block.story.uxCtrl.getPieOptions().arcs.cornerRadius ? block.story.uxCtrl.getPieOptions().arcs.cornerRadius.radiusCorner : 9;
                    d3.select(defaultPath)
                        .transition()
                        .duration(0)
                        .delay(block.options.pieSelectedDelay)
                        .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                        .style("filter", block.dropShadow)
                        .style("fill", function (d, i) {
                            return block.colorArcs(d.data.category);
                        });
                    block.renderGradient();
                }
            }
        },

        /**events functions */
        bindEvents: function () {
            // only bind events if render method didn't fail
            if (this.frameEl) {
                var block = this;
                var $nextArrow = this.frameEl.find('.pstory-next-arrow');
                var $previousArrow = this.frameEl.find('.pstory-previous-arrow');
                var $paths = block.arcPaths;
                $nextArrow.bind('click', function (e) {
                    var currentItemIndex = block.getSelectedPathIndex($paths);
                    if (currentItemIndex == ($paths.length - 1)) {
                        block.moveArcs(0);
                        block.handleClick(block.layoutInstructions.slices[0], 0);
                    } else {
                        block.moveArcs(++currentItemIndex);
                        block.handleClick(block.layoutInstructions.slices[currentItemIndex], currentItemIndex);
                    }
                    if(document.activeElement == this) {
                        block.putFocusAccessibility($(this).closest(".pstory-block-content"));
                    }
                });

                $previousArrow.bind('click', function (e) {
                    var currentItemIndex = block.getSelectedPathIndex($paths);
                    if (currentItemIndex == 0) {
                        block.moveArcs($paths.length - 1);
                        block.handleClick(block.layoutInstructions.slices[$paths.length - 1], $paths.length - 1);
                    } else {
                        block.moveArcs(--currentItemIndex);
                        block.handleClick(block.layoutInstructions.slices[currentItemIndex], currentItemIndex);
                    }
                    if(document.activeElement == this) {
                        block.putFocusAccessibility($(this).closest(".pstory-block-content"));
                    }
                });
            }
        },

        putFocusAccessibility: function putFocusAccessibility(elementForFocus) {
            var focusInterval = 10; // ms, time between function calls
            var focusTotalRepetitions = 10; // number of repetitions

            elementForFocus.attr('tabindex', '0');
            elementForFocus.blur();

            var focusRepetitions = 0;
            var interval = window.setTimeout(function () {
                elementForFocus.focus();
            }, focusInterval);
        },

        onPieItemClick: function onPieItemClick(obj, clickedItemIndex, clickedItem) {
            var block = this;
            var oldSelectedArc = this.el.find('.perso-arc path.perso-selected');
            var filter = '';
            if (this.options.arcs.filter.grayFilter == true) {
                filter = "url(#" + this.grayscaleId + ")";
            }
            if (oldSelectedArc[0] != clickedItem) {//disable click on selected
                /**set the old selected path*/
                if (oldSelectedArc.length) {
                    oldSelectedArc[0].className.baseVal = Personetics.utils.string.removeClass(oldSelectedArc[0].className, 'perso-selected');
                    d3.select(oldSelectedArc[0])
                        .attr("d", block.arc)
                        .style("filter", filter)
                }
                d3.select(clickedItem)
                    .attr("d", block.arcOver.cornerRadius(this.cornerRadiusPie))
                    .attr("class", "perso-selected")
                    .style("filter", this.dropShadow)
                    .style("fill", function (d, i) {
                        return block.colorArcs(d.data.category);
                    });
                d3.select(clickedItem).moveToFront();
                this.handleClick(obj, clickedItemIndex);
                this.updatePieInfoValues(obj.data);
            }
        },

        updatePieInfoValues: function (obj) {
            var block = this;
            if (obj) {
                var amountDiv = '<div class="pstory-pie-amount perso-accessibility-no-read"><span>' + obj.label + '</span></div>';
                var categoryDiv = '<div class="pstory-pie-category perso-accessibility-no-read"><span>' + obj.category + '</span></div>';

                var $infoContainer = this.frameEl.find('.pstory-pie-info');
                $infoContainer.empty();
                $infoContainer.append(amountDiv);
                $infoContainer.append(categoryDiv);
                this.addInfoTextForAccessibility($infoContainer, obj);

                //set color from Palette
                if (this.options.arcs.filter.grayFilter == true) {
                    $('.pstory-pie-amount').css('color', block.colors(obj.category))
                }
            }
        },
        initPieInfoValues: function (obj) {
            this.updatePieInfoValues(obj);
        },

        addInfoTextForAccessibility: function addInfoTextForAccessibility($infoContainer, obj) {
            $infoContainer.prepend('<span class="perso-accessibility-read">' + obj.label + ', ' + obj.category + '</span>');
            $infoContainer.find(".perso-accessibility-no-read").attr('aria-hidden', true);
        },

        // this function move the selected arc to next/prev when click on arrows
        moveArcs: function (index) {
            var block = this;
            var path = block.arcPaths[index];
            var filter = '';
            if (this.options.arcs.filter.grayFilter == true) {
                filter = "url(#" + this.grayscaleId + ")";
            }
            var oldSelectedArc = this.el.find('.perso-arc path.perso-selected');
            if (path) {
                d3.select('.pstory-frame .perso-arc path.perso-selected')
                    .attr("d", block.arc)
                    .style("filter", filter)
                oldSelectedArc[0].className.baseVal = Personetics.utils.string.removeClass(oldSelectedArc[0].className, 'perso-selected');
                d3.select(path)
                    .attr("d", block.arcOver.cornerRadius(this.cornerRadiusPie))
                    .attr("class", "perso-selected")
                    .style("filter", this.dropShadow)
                    .style("fill", function (d, i) {
                        return block.colorArcs(d.data.category);
                    });
                d3.select(path).moveToFront();

                //set default values in pie info container
                block.updatePieInfoValues(block.layoutInstructions.slices[index]);
            }
        },
        colorArcs: function (category) {
            var block = this;
            var color = block.colors(category);
            if (block.selectedTabId) {
                if (block.selectedTabId == "Out" && block.options.arcs.selectedOutflowPrimaryColor != null) {
                    color = block.options.arcs.selectedOutflowPrimaryColor;
                } else if (block.selectedTabId == "In" && block.options.arcs.selectedInflowPrimaryColor != null) {
                    color = block.options.arcs.selectedInflowPrimaryColor;
                }
            } else if (block.options.arcs.selctedPrimaryColor != null) {
                color = block.options.arcs.selctedPrimaryColor;
            }
            return color;
        },
        /**collapse animation */
        doScrollEvent: function (skipAnimation) {
            Personetics.story.PieChartBlock.prototype.doScrollEvent.call(this, skipAnimation);
            if(this.isBlockPositionInViewport(this.frameEl)){
                this.drawSelected();
            }
            if (this.supportBlockCollapse) {
                var block = this;
                var elementDisplayed = this.frameEl.find('.pstory-pie-data');
                this.collapseHelper.scrollEvent(block, elementDisplayed, skipAnimation);
            }
        },

        getSupportCollapse: function getSupportCollapse(){
			return Personetics.projectConfiguration.getConfig("supportCollapse") == true && Personetics.projectConfiguration.getConfig("pieChartCollapse") == true;
		},
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.D3PinGraphChartBlockProduct = Personetics.story.D3BarChartBlockProduct.extend({
        beforeRender: function(el, layoutInstructions){
            Personetics.story.D3BarChartBlockProduct.prototype.beforeRender.call(this, el, layoutInstructions);
            this.texts.accessibilityPinGraphTitle = Personetics.dictionary.getText("accessibilityPinGraphTitle");
        },
        getHtmlTemplateId: function(clazz) {
            return "pinGraph-chart";
        },
        render: function(el, layoutInstructions) {
            Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);

            var chartEl = this.frameEl.find(".pstory-pinGraph-chart");
            if (chartEl.length > 0) {
                this.renderBarChart(chartEl, layoutInstructions);
            }
        },
        renderBarChart: function(el) {
            if(typeof this.chartHelper.prepareChartData == "function"){
                this.layoutInstructions = this.chartHelper.prepareChartData(this.layoutInstructions, this.options);
            }
            this.chartHelper.prepareChart(this.layoutInstructions, this.options);
            this.chartHelper.renderChart(el);
        },
        beforeRenderChart: function(el, layoutInstructions){
            this.layoutInstructions.series = this.layoutInstructions.series[0];
            this.chartType = this.getChartType();
            this.chartTypeHelper = (this.chartType +"Helper");
            this.initChartHelper(this.chartTypeHelper);
            this.options = this.story.uxCtrl.getPinGraphChartOptions();
        },
        barsDirection: function barsDirection(){
            if(Personetics.processor.PStoryConfig.isRtl()){
               this.barsDirectionRTL();
            }    
        },

        getChartType: function(){
            var type = 'pinGraph';
            return type;
        },

        getAccessibilityTitle: function getAccessibilityTitle(){
            return this.texts.accessibilityPinGraphTitle;
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.NewTableBlockProduct = Personetics.story.TableBlock.extend({

        getHtmlTemplateId: function(clazz) {
            var template;
            var classStr;
            var classes = clazz ? clazz.split(" ") : [];
            $.each(classes, function (index, className){
                if (className.indexOf("perso-txlist") > -1) {
                    classStr = className.trim();
                    return false;
                }
            });
            this.classStr = classStr;
            if(typeof(this.classStr) == "undefined"){
                var numColumns = this.layoutInstructions.columns.length;
                switch(numColumns){
                    case 4:
                        this.classStr = "perso-txlist1";
                    default:
                        this.classStr = "perso-txlist1";
                }
            }
            template = "table-"+ (this.classStr.indexOf("perso-txlist1") != -1 ? this.classStr + "-new" : this.classStr);
            return template;
        },
        afterRender: function(el){
            Personetics.story.TableBlock.prototype.afterRender.call(this, el);
            if(this.supportBlockCollapse){
                var heightPrevFixedElements = this.collapseHelper.getHeightPrevFixedElements();

                /**change the scroll top of story in order to set the top of table after collapse element */
                var scrollTopDiff = heightPrevFixedElements - this.frameEl.offset().top;
                var pstoryFrame = this.frameEl.parents('.pstory-frame');
                var pstoryContainer = pstoryFrame.find('.pstory-container');
                var siblingsHeight = pstoryFrame[0].scrollHeight - pstoryContainer.height();
                if(scrollTopDiff > 0)
                    pstoryFrame.scrollTop(Math.ceil(pstoryFrame.scrollTop() - scrollTopDiff));
                pstoryContainer.css('min-height', pstoryFrame.height() + pstoryFrame.scrollTop() - siblingsHeight);
            }
        },
        getSupportBlockCollapse: function getSupportBlockCollapse(){
            return Personetics.projectConfiguration.getConfig("supportCollapse") == true;
        }

    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.TableBlockProduct = Personetics.story.TableBlock.extend({

        getHtmlTemplateId: function(clazz) {
            var template;
            var classStr;
            var classes = clazz ? clazz.split(" ") : [];
            $.each(classes, function (index, className){
                    if (className.indexOf("perso-txlist") > -1) {
                        classStr = className.trim();
                        return false;
                    }
            });
            this.classStr = classStr;
            if(typeof(this.classStr) == "undefined"){
                var numColumns = this.layoutInstructions.columns.length;
                switch(numColumns){
                    case 3:
                        this.classStr = "perso-txlist4";
                        break;
                    case 4:
                        this.classStr = "perso-txlist1";
                        break;
                    case 6:
                        this.classStr = "perso-txlist3";
                        break;
                    default:
                        this.classStr = "perso-txlist1";
                }
            }
            template = "table-"+ this.classStr;
            return template;
        },
        afterRender: function(el){
            Personetics.story.TableBlock.prototype.afterRender.call(this, el);
            if(this.supportBlockCollapse){
                var heightPrevFixedElements = this.collapseHelper.getHeightPrevFixedElements();

                /**change the scroll top of story in order to set the top of table after collapse element */
                var scrollTopDiff = heightPrevFixedElements - this.frameEl.offset().top;
                var pstoryFrame = this.frameEl.parents('.pstory-frame');
                var pstoryContainer = pstoryFrame.find('.pstory-container');
                var siblingsHeight = pstoryFrame[0].scrollHeight - pstoryContainer.height();
                if(scrollTopDiff > 0)
                    pstoryFrame.scrollTop(pstoryFrame.scrollTop() - scrollTopDiff);
                pstoryContainer.css('min-height', pstoryFrame.height() + pstoryFrame.scrollTop() - siblingsHeight);
            }
        },

        getSupportBlockCollapse: function getSupportBlockCollapse(){
            return Personetics.projectConfiguration.getConfig("supportCollapse") == true;
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.NewPieChartBlockOpenBank = Personetics.story.NewPieChartBlockProduct.extend({
        setCategoryId: function (id, selectedTabId) {
          var defaultId = 'CG0';
          if (selectedTabId && selectedTabId === 'In') {
              defaultId = 'CG10'
          }
          var definedCategories = ["CG4000", "CG200", "CG6000","CG700","CG100","CG2000","CG600","CG10","CG20","CG30","CG3000","CG0","CG800","CG1000"];
          if (definedCategories.indexOf(id) > -1) {
              return id;
          } else {
              return defaultId;
          }
        },
        beforeRender: function beforeRender(el, layoutInstructions) {
            Personetics.story.PieChartBlock.prototype.beforeRender.call(this, el, layoutInstructions);
            //get selected tab from previous dialogs for change pie colors in outflows case
            el.closest(".pstory-dialog-frame").addClass("pstory-dialog-frame-pie")
            var previousDialogs = el.parents('.pstory-dialog-frame').prev('.pstory-dialog-frame');
            var tabsBlock = previousDialogs.find('.pstory-block-tabs');
            tabsBlock.addClass('perso-pie-tabs');
            var selectedTab = tabsBlock.find('.pstory-button.selected');
            var selectedTabId = selectedTab.attr("pstory-id");
            this.setCornerRadiusPie();
            this.colors = d3.scale.ordinal()
              .domain(["CG4000", "CG200", "CG6000","CG700","CG100","CG2000","CG600","CG10","CG20","CG30","CG3000","CG0","CG800","CG1000"])
              .range(["#2e4256", "#04a9f4", "#f44336","#02bcd4","#673ab7","#dc2874","#9d27b0","#0ac8a1","#ff4d52","#546e7a","#3f51b5","#fbb800","#dc51ac","#ff8b4f"]);
            this.grayColors = d3.scale.ordinal().range(this.story.uxCtrl.getPieGrayColors());
            this.selectedTabId = selectedTabId;
            this.texts = $.extend(true, this.texts, {
                nextCategory: Personetics.dictionary.getText("accessibilityNextCategory"),
                previousCategory: Personetics.dictionary.getText("accessibilityPreviousCategory"),
                selectedCategoryTitle: Personetics.dictionary.getText("accessibilitySelectedCategoryTitle")
            });
        },
        getHtmlTemplateId: function (clazz) {
            return "pie-chart-open-bank";
        },
        setPieSize: function setPieSize(width) {
            this.margin = { top: 0, right: 20, bottom: 0, left: 20 };
            this.width = width;
            this.radius = this.width / 4.1;
            //set radius width depends on screen width
            this.innerRadius = this.story.uxCtrl.getValueByScreenWidth(90);
            this.outerRadius = this.innerRadius - this.story.uxCtrl.getValueByScreenWidth(35);
            this.innerRadiusOver = this.innerRadius;
            this.outerRadiusOver = this.outerRadius;
        },
        setPieSizeOnStart: function setPieSizeStart() {
            Personetics.story.NewPieChartBlockProduct.prototype.setPieSizeOnStart.call(this)
            this.height = this.width * 0.72916666;
        },
        setCircleSize: function setCircleSize() {
            var heightCircle = this.outerRadius * 2;
            var widthCircle = this.outerRadius * 2;
            this.frameEl.find('.pieCircle').css({ height: heightCircle, width: widthCircle, top: 'calc(50% - ' + heightCircle / 2 + 'px)', left: 'calc(50% - ' + widthCircle / 2 + 'px)' });
        },
        renderPieSvgBase: function (el) {
            var block = this;
            if (el) {
                return (d3.select(el.get(0)).append("svg")
                    .attr("width", block.width)
                    .attr("height", block.height)
                    .append("g")
                    .attr("class", 'arcs-wrapper')
                    .attr("transform", "translate(" + block.width / 2 + "," + block.height * 0.5 + ")"));

            }
        },
        pieTransition: function pieTransition(arcs) {
            var block = this;
            this.setPieSize(this.frameEl.find('.pstory-pie-chart').width());
            this.defineArcs();
            this.svg.selectAll(".perso-arc path")
                .transition()
                .delay(block.options.pieDelay)
                .duration(block.options.pieDuration)
                .attr("d", block.arc)
                .each("end", function () {
                    block.setCircleSize();
                });
        },
        updatePieInfoValues: function (obj) {
            var block = this;
            if (obj) {
                var iconDiv = '<div class="pstory-pie-icon '+ obj.categoryId+'"></div>'
                var amountDiv = '<div class="pstory-pie-amount perso-accessibility-no-read"><span>' + obj.label + '</span></div>';
                if (obj.category)
                    var categoryDiv = '<div class="pstory-pie-category perso-accessibility-no-read"><span>' + obj.category + '</span></div>';
                else
                    var noTransactionDiv = '<div class="pstory-pie-no-transaction perso-accessibility-no-read"><span>' + Personetics.dictionary.getText("lblNoTransaction") + '</span></div>';
                var $infoContainer = this.frameEl.find('.pstory-pie-info');
                $infoContainer.empty();
                $infoContainer.append(iconDiv);
                $infoContainer.append(amountDiv);
                categoryDiv ? $infoContainer.append(categoryDiv) : $infoContainer.append(noTransactionDiv);
                this.addInfoTextForAccessibility($infoContainer, obj);

                //set color from Palette
                this.setAmountColor(block.colors(block.setCategoryId(obj.categoryId,block.selectedTabId)));
            }
        },
        renderPieTitle: function (totalText) {
            var block = this;
            if (block.selectedTabId == "In")
                totalText = Personetics.dictionary.getText("lblInCenterText").split(" ");
            else
                totalText = Personetics.dictionary.getText("lblOutCenterText").split(" ");
            var totaltxt_SpaceFromCenter = block.story.uxCtrl.getValueByScreenWidth(this.options.totaltxt_SpaceFromCenter) || '-.3em';
            this.svg.append('text')
                .attr('class', 'perso-total-txt')
                //in order to enable animation for text and support also other elements that defined with "em"
                .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_total_font_size) + "px")
                .attr('y', totaltxt_SpaceFromCenter + "px")
                .selectAll('tspan').data(totalText)
                .enter().append('tspan')
                .text(function (d) {
                    return d;
                })
                .attr('dy', '1.25em').attr('x', '0');
        },
        renderPieAmount: function (totalAmount) {
            var block = this;
            var totalAmount_SpaceFromCenter = block.story.uxCtrl.getValueByScreenWidth(this.options.totalAmount_SpaceFromCenter) || '.9em';
            this.svg.append('text')
                .attr('class', 'perso-total-amount')
                //in order to enable animation for text and support also other elements that defined with "em"
                .style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_anoumt_font_size) + "px")
                .attr('dy', totalAmount_SpaceFromCenter + "px")
                .html(totalAmount);
        },
        setAmountColor: function (color) {
            if (this.options.arcs.filter.grayFilter == true) {
                $('.pstory-pie-amount').css('color', '#002b45')
            }
        },
        textTransition: function textTransition() {
            var block = this;
            var pieTotalText = this.svg.select('.perso-total-txt');
            pieTotalText.style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_total_font_size) + "px")
            if (typeof pieTotalText != 'undefined') {
                pieTotalText.transition()
                    .duration(this.options.pieTextDuration)
                    .delay(this.options.pieTextDelay)
                    .style({ "opacity": "1" })
            }
            var pieTotalAmount = this.svg.select('.perso-total-amount');
            pieTotalAmount.style("font-size", block.story.uxCtrl.getValueByScreenWidth(this.options.center_text_amount_font_size) + "px")
            if (typeof pieTotalAmount != 'undefined') {
                pieTotalAmount.transition()
                    .duration(this.options.pieTextDuration)
                    .delay(this.options.pieTextDelay)
                    .style({ "opacity": "1" })
            }
        },
        afterRender: function (el) {
            Personetics.story.NewPieChartBlockProduct.prototype.afterRender.call(this, el);
            var block = this;
            if (this.layoutInstructions.slices[0].class == 'perso_empty') {
                block.frameEl.addClass('perso-empty');
            }
        },
        renderPieChart: function (el, layoutInstructions) {
            if (layoutInstructions.slices == null || layoutInstructions.slices.length == 0 || (layoutInstructions.slices.length == 1 && layoutInstructions.slices[0].value == 0))
                layoutInstructions.slices = [{ "value": 1, "label": "", "category": "", "class": "perso_empty" }];
            layoutInstructions.slices = this.sortPie(layoutInstructions.slices);
            Personetics.story.NewPieChartBlockProduct.prototype.renderPieChart.call(this, el, layoutInstructions);
        },
        renderArcs: function (layoutInstructions) {
            var block = this;
            Personetics.story.PieChartBlock.prototype.renderArcs.call(this, layoutInstructions);
            if (this.options.arcs.filter.grayFilter == true) {
                var arcs = this.frameEl.find('.pstory-pie-chart svg .perso-arc path');
                $.each(arcs, function (i, arc) {
                    d3.select(arc).style("fill", function(d) { return block.grayColors(i); })
                });
            }
            this.arcs = arcs;
        },
        onPieItemClick: function onPieItemClick(obj, clickedItemIndex, clickedItem) {
            var block = this;
            var oldSelectedArc = this.el.find('.perso-arc path.perso-selected');
            if (oldSelectedArc[0] != clickedItem) {//disable click on selected
                /**set the old selected path*/
                if (oldSelectedArc.length) {
                    oldSelectedArc[0].className.baseVal = Personetics.utils.string.removeClass(oldSelectedArc[0].className, 'perso-selected');
                    var prevIndex = this.getSelectedIndex();
                    d3.select(oldSelectedArc[0])
                      .attr("d", block.arc)
                      .style("fill", function(d) { return block.grayColors(prevIndex); })
                }
                d3.select(clickedItem)
                  .attr("d", block.arcOver.cornerRadius(this.cornerRadiusPie))
                  .attr("class", "perso-selected")
                  .style("filter", this.dropShadow)
                  .style("fill", function(d) { return block.colors(block.setCategoryId(d.data.categoryId,block.selectedTabId)); })
                d3.select(clickedItem).moveToFront();
                this.handleClick(obj, clickedItemIndex);
                this.updatePieInfoValues(obj.data);
                if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                    var params = {
                        "eventId": "pie-chart-click"
                    }
                    personetics.createReportingEvent(this, params);
                }
            }

        },
        moveArcs: function (index) {
            var block = this;
            var path = block.arcPaths[index];
            var filter = '';
            var prevIndex = this.getSelectedIndex();
            var colors = this.options.arcs.filter.grayFilter ? block.grayColors : block.colors;
            if (path) {
                if(index !== prevIndex){
                    var prevPath = block.arcPaths[prevIndex];
                    d3.select(prevPath)
                      .attr("d", block.arc)
                      .style("fill", function(d) { return colors(prevIndex); })
                      .attr("class","")
                }
                d3.select(path)
                  .attr("d", block.arcOver.cornerRadius(this.cornerRadiusPie))
                  .attr("class", "perso-selected")
                  .style("filter", this.dropShadow)
                  .style("fill", function (d, i) {
                      return block.colors(block.setCategoryId(d.data.categoryId,block.selectedTabId));
                  });
                d3.select(path).moveToFront();

                //set default values in pie info container
                block.updatePieInfoValues(block.layoutInstructions.slices[index]);
                this.setSelectedIndex(index);
                if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                    var params = {
                        "eventId": "pie-chart-arrow-click"
                    }
                    personetics.createReportingEvent(this, params);
                }
            }
        },
        colorArcs: function (categoryId) {
            var block = this;
            var color = block.colors(block.setCategoryId(categoryId,block.selectedTabId));
            if (!categoryId) {
                if (block.selectedTabId) {
                    if (block.selectedTabId == "Out" && block.options.arcs.selectedOutflowPrimaryColor != null) {
                        color = block.options.arcs.selectedOutflowPrimaryColor;
                    } else if (block.selectedTabId == "In" && block.options.arcs.selectedInflowPrimaryColor != null) {
                        color = block.options.arcs.selectedInflowPrimaryColor;
                    }
                } else if (block.options.arcs.selctedPrimaryColor != null) {
                    color = block.options.arcs.selctedPrimaryColor;
                }
            }
            return color;
        },
        drawSelected: function drawSelected(){
            var block = this;
            //only do after render if render method doesn't fail
            if(this.pieDrew == true){
                if (block.frameEl) {
                    block.frameEl.addClass(block.selectedTabId);
                    var defaultPath = block.arcPaths[this.getSelectedIndex()];
                    //TODO
                    var radius = block.story.uxCtrl.getPieOptions().arcs.cornerRadius ? block.story.uxCtrl.getPieOptions().arcs.cornerRadius.radiusCorner : 9;
                    d3.select(defaultPath)
                      .transition()
                      .duration(0)
                      .delay(block.options.pieSelectedDelay)
                      .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                      .style("filter", block.dropShadow)
                      .style("fill", function (d, i) {
                          return block.colorArcs(block.setCategoryId(d.data.categoryId,block.selectedTabId));
                      });
                    block.renderGradient();
                }
            }
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.NewAccountSelectorBlockOpenBank = Personetics.story.NewAccountSelectorBlockProduct.extend({
        onCollapsed: function (elementDisplayed, heightForElementDisplayed, fixedContainer) {
            Personetics.story.NewAccountSelectorBlockProduct.prototype.onCollapsed.call(this, elementDisplayed, heightForElementDisplayed, fixedContainer);
            fixedContainer.height(fixedContainer.attr("collapsed-height"));
        },
        
        afterRender: function afterRender(el) {
            Personetics.story.NewAccountSelectorBlockProduct.prototype.afterRender.call(this, el);
            if(this.defaultTab != 'all') {
                this.frameEl.find('.options-container .pstory-button:not(.carousel-hide-clone)').addClass("pstory-card-transition");
            }
        },
        setImageValueForOptions: function setImageValueForOptions(){
            $.each(this.options, function (i, opt) {
                var urlObj = Personetics.imageMap.getImageClass(opt.image, "account_selector");
                opt.isAbsoluteURL = urlObj.isAbsoluteURL;
                opt.image  = urlObj.url === 'cardImage' ? null : urlObj.url;
            });
        },
        optionHeaderClickEvent: function optionHeaderClickEvent(e) {
            var target = $(e.currentTarget);
            var allAccounts = target.data('all');
            if (this.frameEl.find(".options-container").hasClass("allAccounts") == allAccounts){
                this.setFocusOnRelevantElement(allAccounts);
                return;
            }
            this.headerTabsAnimation(target);
            var params = {
                "eventId": "account-selector-tab-clicked",
                "additionalData": {
                    "tab-clicked": ""
                },
            }
            if (allAccounts) {
                this.onAllAccountsClick(true);
                params.additionalData["tab-clicked"] = "all accounts" 
            }
            else {
                this.onChooseAccountClick(target);
                params.additionalData["tab-clicked"] = "choose account" 
            }
            this.updateAccessibilityButtons(allAccounts);
            this.setFocusOnRelevantElement(allAccounts);
            this.frameEl.find(".pstory-header-button").attr('aria-selected', 'false');//.removeClass("selected-header");
            target.attr('aria-selected', 'true');//.addClass("selected-header");

            this.notifyReportHeaderEvent(allAccounts);

            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                personetics.createReportingEvent(this, params);
            }
        },
        optionClickEvent: function optionClickEvent(e) {
            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                var params = {
                    "eventId": "account-switch",
                }
                personetics.createReportingEvent(this, params);
            }
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.BarChartBlockOpenBank = Personetics.story.BarChartBlock.extend({
        setBarsWidth: function (elements, isSeries) {
            Personetics.story.BarChartBlock.prototype.setBarsWidth.call(this, elements, isSeries);
            if (this.isSeries) {
                var paddingRight = '13.1944%';
                var paddingLeft = '12.15277%';
                switch (this.layoutInstructions.categories.length) {
                    case 3:
                        paddingRight = '26.04166%';
                        paddingLeft = '26.38888%';
                        break;
                    case 4:                       
                        paddingRight = '21.875%';
                        paddingLeft = '21.18055%';
                        break;
                    default:
                        break;
                }
                this.el.find('.perso-bar-chart-container').css({ 'padding-right': paddingRight, 'padding-left': paddingLeft });

            }
            else {
                var paddingRight = '14.25%';
                var paddingLeft = '11.81%';
                switch (this.layoutInstructions.categories.length) {
                    case 3:
                        paddingRight = '27.430556%';
                        paddingLeft = '28.819445%';
                        break;
                    case 4:
                        paddingRight = '23.65%';
                        paddingLeft = '22.6%';
                        break;
                    case 5:
                        paddingRight = '14.25%';
                        paddingLeft = '14.25%';
                        break;
                    default:
                        break;
                }
                this.el.find('.perso-bars-wrapper').css({ 'padding-right': paddingRight, 'padding-left': paddingLeft });
            }
             $(elements).css('width', '');
        },
        changeSelectedTabAnimationMonthPicker: function changeSelectedTabAnimationMonthPicker(selected) {        
            if (typeof selected === "undefined" || selected === null || selected.length == 0)
                return;
            var tabAnimatedBorder = this.frameEl.find(".pstory-month-picker-selected-tab");
            var widthArray = [0, 0, 0, 31.52173, 28.01932, 22.65625, 17.96875];
            $(selected).addClass('selected');
            $(selected).attr("aria-selected", "true");
            $(selected).siblings('.perso-month-picker-item').attr("aria-selected","false");
            this.updateSelectedAccText();    
            this.setMonthPickerTabWidth();   
            var left = $(selected).offset().left - parseInt($(".perso-month-picker-container").offset().left)-2;   
            tabAnimatedBorder.css({
                "display":"block",
                "left": left + 'px',
                width: widthArray[this.layoutInstructions.categories.length]+"%"
            });                 
        },
        setDefaultBar: function () {
            Personetics.story.BarChartBlock.prototype.setDefaultBar.call(this);
            if (this.isSeries) {
                this.setMonthAmounts(this.frameEl.find(".perso-bar.selected").attr('pstory-category'));
            }
        },
        amountAnimation: function ($el) {
        },
        tabClickListener: function (category) {
            Personetics.story.BarChartBlock.prototype.tabClickListener.call(this, category);
            if (this.isSeries) {
                this.setMonthAmounts(category);
            }
            else{
                var fontSize = this.story.uxCtrl.getValueByScreenWidth(18) + "px";
                this.el.find(".perso-month-amount-wrapper").css({"text-align": "center", "padding-right": "5%", "padding-left": "5%","width":"100%"});
                this.el.find(".perso-month-amount .perso-amount").css({"font-size": fontSize,"margin-right":"0"});
            }
            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                var params = {
                    "eventId": this.chartType === "multiVertical"? "comparable-bar-chart-click" : "bar-chart-click" 
                }
                personetics.createReportingEvent(this, params);
            }
        },
        setMonthAmounts: function (category) {
            var monthAmount = this.frameEl.find('.perso-month-amount');
            if (monthAmount.length) {
                $(monthAmount).empty();
                var seriesObj = this.series.filter(function (item) {
                    return item.category == category;
                })[0];
                $.each(this.layoutInstructions.seriesLabels, function (i, label) {
                    if (label.toLowerCase() == seriesObj[i].mode.toLowerCase()) {
                        $(seriesObj[i].label).appendTo(monthAmount);
                    }
                })
            }     
        },
        monthPickerItemClick: function monthPickerItemClick(e) {
            this.el.find(".pstory-month-picker-selected-tab").css("display","block");           
            var target = e.currentTarget;
            var categoryNumber = $(target).attr("pstory-category");
            var otherButtons = this.frameEl.find('.perso-month-picker-item');
            this.frameEl.find('.perso-month-picker-item.selected').removeClass('end-animation');
            otherButtons.removeClass('selected');
            this.changeSelectedTabAnimationMonthPicker(target);
            this.tabClickListener(categoryNumber);

            this.parent.notifyEvent(this, "setSelectedValue", categoryNumber);
            var params = {
                value: categoryNumber,
                type: this.layoutInstructions.type
            };
            this.notifyReportEvent(params);
        },
        setMonthPickerTabWidth: function setMonthPickerTabWidth() {
            var monthPickerTabSelected = this.frameEl.find('.perso-month-picker-container .perso-month-picker-item.selected');
            var monthPickerTabs = this.frameEl.find('.perso-month-picker-container .perso-month-picker-item');
            var widthArray = [0, 0, 0, 31.52173, 28.01932, 22.65625, 17.96875];
            $(monthPickerTabs).css('width', (100 - widthArray[this.layoutInstructions.categories.length]) / (this.layoutInstructions.categories.length -1) + '%');  
            $(monthPickerTabSelected).css('width', widthArray[this.layoutInstructions.categories.length]+"%");          
            $(".pstory-month-picker-selected-tab").css('width', widthArray[this.layoutInstructions.categories.length]+"%"); 
        },
        render: function (el, layoutInstructions) {
            var texts = {
                lblMoneyIn: Personetics.dictionary.getText("lblMoneyIn"),
                lblMoneyOut: Personetics.dictionary.getText("lblMoneyOut")
            }
            layoutInstructions.texts = texts;
            Personetics.story.BarChartBlock.prototype.render.call(this, el, layoutInstructions);
        },
        setMonthAmount: function (label) {
            Personetics.story.BarChartBlock.prototype.setMonthAmount.call(this, label);
            if (!this.isSeries) {
                var category = this.frameEl.find(".perso-bar.selected").attr('pstory-category');
                var isBarMinus = false;
                var seriesObj = this.series.filter(function (item) {
                    if(item.value < 0)
                        isBarMinus = true;
                    return item.category == category;
                })[0];
                var amountSign = this.frameEl.find('.perso-month-amount .perso-amount .perso-minus-sign');
                if(isBarMinus){
                    if(seriesObj > 0)
                        amountSign.text('-')
                }
                else{
                    if (this.layoutInstructions.mode == "In") {
                        amountSign.text('+');
                    }
                    else if (seriesObj.value == 0) {
                        amountSign.text('');
                    }
                    else {
                        amountSign.text('-');
                    }
                }
             }
        },
        calculateBarsHeight: function (bars, minValue, maxValue) {
            Personetics.story.BarChartBlock.prototype.calculateBarsHeight.call(this, bars, minValue, maxValue);
            var orignalMaxValue = maxValue;
            if (minValue < 0) {
                if (maxValue >= 0) {
                    maxValue = maxValue + Math.abs(minValue);
                }
                var options = this.prepareCalculateBarHeightOptions(maxValue);
                var maxHeight = this.calculateBarHeightByValue(orignalMaxValue, options);
                var axis = this.frameEl.find('.x-axis');
                axis.css('top', maxHeight.normalValue + 'px');
            }
        },

        afterRender: function (el) {
            Personetics.story.BarChartBlock.prototype.afterRender.call(this, this, el);
            if(this.layoutInstructions.isSeries == false)
            {
                var amountLabel =this.frameEl.find(".perso-amount-label")
                if(this.layoutInstructions.mode == "In")
                    amountLabel.text(Personetics.dictionary.getText("lblMoneyIn"));
                else
                    amountLabel.text(Personetics.dictionary.getText("lblMoneyOut"));
                var fontSize = this.story.uxCtrl.getValueByScreenWidth(18) + "px";
                this.el.find(".perso-month-amount-wrapper").css({"text-align":"center", "padding-right":"5%","padding-left":"5%","width":"100%"});
                this.el.find(".perso-amount").css({"font-size":fontSize,"margin-right":"0"});
            }     
            var tabAnimatedBorder = this.frameEl.find(".pstory-month-picker-selected-tab");
            $(tabAnimatedBorder).bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(){
                $(".perso-month-picker-item.selected").addClass('end-animation');
                tabAnimatedBorder.css({"display":"none"});
            });
            this.setMonthPickerTabWidth();             
            this.el.find(".perso-bar-wrapper").each(function(){
                if($(this).height()==0){
                    $(this).css({"height":"3px","opacity":"0"});
                }
                else if($(this).height()<=1){
                    var barTop = $(this).parent().height() - 1;
                    $(this).css({"height":"1px","top":`${barTop}`});
                }
            });


        },
        setDefaultMonthPickerTab: function () {
            var defaultTabIndex = this.getDefaultIndex();
            this.changeSelectedTabAnimationMonthPicker(this.frameEl.find(".perso-month-picker-item")[defaultTabIndex]);
        },
        
        onBeforeCollapsed: function(){
                var monthPickerElWidth = this.frameEl.find(".perso-month-picker-wrapper .perso-month-picker-container").outerWidth();
                this.el.find(".perso-month-picker-wrapper .perso-month-picker-container").css("width", monthPickerElWidth);
                var widthArrayCollapsed = [0, 0, 0, 31.521739, 23.076923, 19.28572, 19.0972];
                var barLength = this.el.find(".perso-month-picker-item").length;
                this.el.find(".pstory-month-picker-selected-tab").css("width",widthArrayCollapsed[barLength] + "%");
                this.el.find(".perso-month-picker-item").css('width', (100 - widthArrayCollapsed[barLength]) / (barLength -1) + '%');
                this.el.find(".perso-month-picker-item.selected").css({"width":widthArrayCollapsed[barLength] + "%"});     
                this.el.find(".perso-month-picker-item.selected").addClass("end-animation");
                this.el.find(".pstory-month-picker-selected-tab").css("display","none");  
        },
        onCollapsed: function(){
            this.el.find(".perso-month-picker-wrapper.pstory-fixed .perso-month-picker-container").css({"width": ""});
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.NewButtonsBlockOpenBank = Personetics.story.NewButtonsBlock.extend({
        optionClickEvent: function(e){
            var target = $(e.target);

            var navigateToData = typeof target.data("navigateToPayload") == "undefined" ? target.children('a').data("navigateToPayload") : target.data("navigateToPayload");

            if(navigateToData){

                this.doNavigateToPage(navigateToData);
                var target = $(e.currentTarget);
                var action = target.attr('action-id');
                if(action){
                    this.parent.notifyEvent(this, "actionEvent", {actionId: action});
                }
                if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                    if (!target.closest('.perso-button1').hasClass('perso-secondary')) {
                        var params = {
                            "eventId": "primary-button-click",
                            "additionalData": {
                                "button-clicked": navigateToData.navigateTarget
                            },
                        }
                    } else {
                        var params = {
                            "eventId": "secondary-button-click",
                        }
                    }
                    personetics.createReportingEvent(this, params);
                }
            }
            else{
                if (this.layoutInstructions.type.toLowerCase() === "quiz" && !target.closest('.pstory-radio-button').hasClass('selected')) {
                    if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                        var quizParams = {
                            "eventId": "quiz-answer",
                            "additionalData": {
                                "quiz-answer": this.getQuizResult(this.layoutInstructions.options,target.closest('.pstory-radio-button')) === "Right" ? "1" : "0"
                            },
                        }
                        personetics.createReportingEvent(this, quizParams);
                    }
                }
                Personetics.story.OptionsBlock.prototype.optionClickEvent.call(this, e);
            }
        },
        getQuizResult:function(options,target)
        {
            for(var key in options)
            {
                if(options[key].id.toString() === $(target).attr("pstory-id"))
                {
                    if(options[key].answer === "true"){
                        return Personetics.dictionary.getText("right");
                    }
                    else{
                        return Personetics.dictionary.getText("wrong");
                    }
                }
            }
            return Personetics.dictionary.getText("wrong");
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.TabsBlockOpenBank = Personetics.story.TabsBlock.extend({
        changeSelectedTabAnimation: function changeSelectedTabAnimation(selected){
            if(typeof selected === "undefined" || selected === null || selected.length == 0)
                return;
            var tabAnimatedBorder = $(this.frameEl).find(".pstory-tab-animated-border-bottom");
            var left = selected.offset().left - this.el.find(".header-container").offset().left;
            var width = selected.innerWidth();
            if(this.isDesktopMode){
                tabAnimatedBorder.css({ "left": left + 'px', width: width + 'px' });
            }else{
                tabAnimatedBorder.css({ "left": left > selected.width() ? this.frameEl.width() - tabAnimatedBorder.width() : left});
            }
        },
        onInputSelect: function(e){
            Personetics.story.OptionsBlock.prototype.onInputSelect.call(this, e);
            var selected = $(e.currentTarget);
            selected.attr('aria-selected', true);
            selected.siblings('[role="tab"]').attr('aria-selected', false);

            this.changeSelectedTabAnimation(selected);
            var tabsBlock = $(selected).closest(".pstory-block-tabs");
            var selectedTab = tabsBlock.find('.pstory-button.selected');
            var selectedTabId = selectedTab.attr("pstory-id");

            if (tabsBlock.hasClass('perso-pie-tabs')) {
                if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                    var params = {
                        "eventId": "pie-chart-tab-click",
                        "additionalData": {
                            "tab-clicked": selectedTabId === "In" ? "inflows" : "outflows"
                        },
                    }
                    personetics.createReportingEvent(this, params);
                }
            }
        },

    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.NewTableBlockOpenBank = Personetics.story.NewTableBlockProduct.extend({
        beforeRender: function (el, layoutInstructions) {
            var helper = this;
            var row = helper.layoutInstructions.rows;
            var originalDate = this.layoutInstructions.cols.push("originalDate")
            var indexDate = helper.layoutInstructions.cols.indexOf("date")
            var indexProgramId = helper.layoutInstructions.cols.indexOf("programId");
            $(row).each(function (i) {
                helper.layoutInstructions.rows[i][originalDate - 1] = this[indexDate];
                var rowProgramIdTxt = helper.layoutInstructions.rows[i][indexProgramId];
                if (rowProgramIdTxt) {
                    helper.layoutInstructions.rows[i][indexProgramId] = rowProgramIdTxt.replace(/_/g, " ");
                }
            });
            Personetics.story.NewTableBlockProduct.prototype.beforeRender.call(this, el, layoutInstructions);
        },
        afterRender: function (el) {
            Personetics.story.NewTableBlockProduct.prototype.afterRender.call(this, el);
            var helper = this;
            var utils = Personetics.processor.PUtils.getUtilsInstance("utils", this.model);
            var table = el.find(".pstory-table.pstory-table-new-txlist1");
            table.children().each(function (i) {
                if (helper.layoutInstructions.rows[i].originalDate) {
                    var Originaldate = helper.layoutInstructions.rows[i].originalDate;
                    var date = new Date(Originaldate);
                    var currentDate = new Date()
                    if (currentDate.getFullYear() == date.getFullYear()) {
                        var newDate = utils.formatDate(date, "DD MMM", true, true);
                    }
                    else {
                        var newDate = utils.formatDate(date, "DD MMM YYYY", true, true);
                    }
                    var htmlDate = $(this).find(".perso-accessibility-wrapper")[0];
                    $(htmlDate).html(newDate);

                }
            });
        },

        formatTableHelper : function formatTableHelper(type, format, element){
            var result = element;
            var utils = Personetics.processor.PUtils.getUtilsInstance("utils", this.model);
            switch (format.type){
                case "date":
                    result = utils.formatDate(element, format.format, true, true);
                    break;
                case "amount":
                   result = utils.formatAmount(element, format.currencySymbol, format.format, true);
                    break;

            }
            return result;

        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, Handlebars, undefined){

this["Personetics"] = this["Personetics"] || {};
this["Personetics"]["UI"] = this["Personetics"]["UI"] || {};
this["Personetics"]["UI"]["Handlebars"] = this["Personetics"]["UI"]["Handlebars"] || {};
this["Personetics"]["UI"]["Handlebars"]["templates"] = this["Personetics"]["UI"]["Handlebars"]["templates"] || {};

this["Personetics"]["UI"]["Handlebars"]["templates"]["error-msg"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "class=\"mobile-err\"";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div id=\"personetics-error-container\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobileDevice : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n    <div class=\"personetics-error-img "
    + alias4(((helper = (helper = helpers.imgClass || (depth0 != null ? depth0.imgClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"imgClass","hash":{},"data":data}) : helper)))
    + "\"></div>\n    <div class=\"personetics-error-larg\">"
    + alias4(((helper = (helper = helpers.textLarge || (depth0 != null ? depth0.textLarge : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"textLarge","hash":{},"data":data}) : helper)))
    + "</div>\n    <div class=\"personetics-error-small\">"
    + alias4(((helper = (helper = helpers.textSmall || (depth0 != null ? depth0.textSmall : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"textSmall","hash":{},"data":data}) : helper)))
    + "</div>\n\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["flow-selector-tmpl"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "    <option value=\""
    + alias4(((helper = (helper = helpers.key || (data && data.key)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"key","hash":{},"data":data}) : helper)))
    + "\">"
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + "</option>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<select id=\"flow-selector\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</select>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["no-filtered-insights-msg"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "class=\"mobile-msg\"";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div id=\"personetics-no-insights-filter-container\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobileDevice : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n    <div class=\"personetics-nothing-toshow-msg\">"
    + container.escapeExpression(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper)))
    + "</div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["no-insights-message"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "class=\"mobile-err\"";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div id=\"personetics-no-insights-container\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobileDevice : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n    <div class=\"personetics-no-insights-img "
    + alias4(((helper = (helper = helpers.imgClass || (depth0 != null ? depth0.imgClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"imgClass","hash":{},"data":data}) : helper)))
    + "\"></div>\n    <div class=\"personetics-no-insights-small\">"
    + alias4(((helper = (helper = helpers.textSmall || (depth0 != null ? depth0.textSmall : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"textSmall","hash":{},"data":data}) : helper)))
    + "</div>\n    <div class=\"personetics-no-insights-larg\">"
    + alias4(((helper = (helper = helpers.textLarge || (depth0 != null ? depth0.textLarge : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"textLarge","hash":{},"data":data}) : helper)))
    + "</div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "			<div class=\"header-container\">\n				<input type=\"button\" value=\"All accounts\" class=\"pstory-header-button selected\" data-all=\"true\" pstory-id=\"all\" />\n				<input type=\"button\" value=\"Choose account\" class=\"pstory-header-button\" data-all=\"false\" />\n\n				<div class=\"pstory-header-button on-select no-select\" data-all=\"false\" pstory-id=\"all\"></div>\n				<!--pstory-id for first time-->\n				<div class=\"pstory-header-button on-select select\" data-all=\"true\"></div>\n			</div>\n			<div class=\"options-container show-all allAccounts\">\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "				<div class=\"options-container\">\n";
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return "						<div class=\"pstory-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\" role=\""
    + alias4(alias5((depths[1] != null ? depths[1].role : depths[1]), depth0))
    + "\">\n							<div class=\"card card_"
    + alias4(((helper = (helper = helpers.typeImage || (depth0 != null ? depth0.typeImage : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"typeImage","hash":{},"data":data}) : helper)))
    + " cards"
    + alias4(((helper = (helper = helpers.numCards || (depth0 != null ? depth0.numCards : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numCards","hash":{},"data":data}) : helper)))
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n								<div class=\"perso-card-img\"></div>\n								<span class=\"perso-account-name\">"
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + "</span>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "							</div>\n							<div id=\"pop-"
    + alias4(alias5(depth0, depth0))
    + "\" class=\"pstory-button-txt-wrapper\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.text2 : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "								<span class=\"pstory-button-txt\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n							</div>\n						</div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "selected";
},"8":function(container,depth0,helpers,partials,data) {
    var helper;

  return "								<span class=\"perso-account-number\">Account No. "
    + container.escapeExpression(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"number","hash":{},"data":data}) : helper)))
    + "</span>//TODO: dictionary\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "								<span class=\"pstory-button-txt perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.text2 || (depth0 != null ? depth0.text2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "						<span class=\"perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt2 || (depth0 != null ? depth0.allAccountsTxt2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"allAccountsTxt2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div id=\"pstory-block-account-selector\" class=\"pstory-block-frame pstory-block-account-selector "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\" data-show-header-tabs="
    + alias4(((helper = (helper = helpers.showHeaderTabs || (depth0 != null ? depth0.showHeaderTabs : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"showHeaderTabs","hash":{},"data":data}) : helper)))
    + ">\n	<div class=\"pstory-block-container\">\n		<div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaderTabs : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "					<div class=\"cards-wrapper\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "					</div>\n					<div class=\"pstory-all-accounts-txt\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.allAccountsTxt2 : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "						<span class=\"perso-amount-wrapper\">"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt || (depth0 != null ? depth0.allAccountsTxt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"allAccountsTxt","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n					</div>\n				</div>\n				<div class=\"pstory-comment\">"
    + ((stack1 = ((helper = (helper = helpers.comment || (depth0 != null ? depth0.comment : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"comment","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n			</div>\n		</div>\n	</div>";
},"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-bar-chart-collapse"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-bar-chart-collapse pstory-inner-"
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-contanier\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-button-collapse\">\n            	<div class=\"pstory-inner-title\">\n            		"
    + alias4(((helper = (helper = helpers.txt || (depth0 != null ? depth0.txt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"txt","hash":{},"data":data}) : helper)))
    + "\n        		</div>\n        		<div class=\"pstory-button-collapse-icon\"></div>\n        	</div>\n            <div class=\"pstory-bar-chart-collapse-content\">\n           		<div class=\"image\"></div>\n       		</div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-bar-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-bar-chart pstory-block-bar-chart "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.direction || (depth0 != null ? depth0.direction : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"direction","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-bar-chart\"></div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-buttons-new"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.navigateTarget : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                    <a href=\"#!\" id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-link-navigateTo button-animation pstory-button ripple-closed\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pnavigate-id=\""
    + alias4(((helper = (helper = helpers.navigateTarget || (depth0 != null ? depth0.navigateTarget : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"navigateTarget","hash":{},"data":data}) : helper)))
    + "\" >"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</a>\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.toggleState : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                        <input type=\"button\" class=\"pstory-button pstory-toggle-button "
    + alias4(((helper = (helper = helpers.toggleState || (depth0 != null ? depth0.toggleState : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"toggleState","hash":{},"data":data}) : helper)))
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" value=\""
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pstory-type-text=\"Toggle "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.toggleState || (depth0 != null ? depth0.toggleState : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"toggleState","hash":{},"data":data}) : helper)))
    + "\"/>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "selected";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? depths[1].typeRadio : depths[1]),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.program(12, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                            <div class=\"pstory-radio-button-wrapper\">\n                                <div class=\"pstory-button button-animation pstory-radio-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "  ripple-closed\" tabindex=\"0\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\">\n                                    <input id=\"pstory-radio-"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" name=\"radio-"
    + alias4(container.lambda((depths[1] != null ? depths[1].id : depths[1]), depth0))
    + "\" type=\"radio\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "/>\n                                    <label for=\"pstory-radio-"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"text\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</label>\n                                </div>\n                            </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "checked";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=helpers.helperMissing, alias4="function";

  return "                            <button id=\"pop-"
    + alias1(container.lambda(depth0, depth0))
    + "\" class=\"pstory-button pstory-regular-button "
    + ((stack1 = helpers["if"].call(alias2,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " ripple-closed\" action-id=\""
    + alias1(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pstory-type-text=\"Button "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" pstory-id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias1(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"event","hash":{},"data":data}) : helper)))
    + "\">\n                                "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                            </button>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div id=\"pstory-block-buttons_"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-block-frame pstory-block-buttons "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + " pstory-block-buttons-"
    + alias4(((helper = (helper = helpers.buttonType || (depth0 != null ? depth0.buttonType : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"buttonType","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n    </div>\n</div>";
},"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-buttons"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.navigateTarget : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                    <a href=\"#!\" id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-link-navigateTo pstory-button ripple-closed\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pnavigate-id=\""
    + alias4(((helper = (helper = helpers.navigateTarget || (depth0 != null ? depth0.navigateTarget : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"navigateTarget","hash":{},"data":data}) : helper)))
    + "\" >"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</a>\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.toggleState : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                        <input type=\"button\" class=\"pstory-button pstory-toggle-button "
    + alias4(((helper = (helper = helpers.toggleState || (depth0 != null ? depth0.toggleState : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"toggleState","hash":{},"data":data}) : helper)))
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" value=\""
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" pstory-type-text=\"Toggle "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.toggleState || (depth0 != null ? depth0.toggleState : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"toggleState","hash":{},"data":data}) : helper)))
    + "\"/>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "selected";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? depths[1].typeRadio : depths[1]),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.program(12, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                            <div class=\"pstory-button pstory-radio-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "  ripple-closed\"  tabindex=\"0\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"  pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\">\n                                <input id=\"pstory-radio-"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" name=\"radio-"
    + alias4(container.lambda((depths[1] != null ? depths[1].id : depths[1]), depth0))
    + "\" type=\"radio\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "/>\n                                <label for=\"pstory-radio-"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"text\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</label>\n                            </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "checked";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=helpers.helperMissing, alias4="function";

  return "                            <button id=\"pop-"
    + alias1(container.lambda(depth0, depth0))
    + "\" class=\"pstory-button pstory-regular-button "
    + ((stack1 = helpers["if"].call(alias2,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " ripple-closed\" action-id=\""
    + alias1(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pstory-type-text=\"Button "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" pstory-id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias1(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"event","hash":{},"data":data}) : helper)))
    + "\">\n                                "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                            </button>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div id=\"pstory-block-buttons_"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-block-frame pstory-block-buttons "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n    </div>\n</div>";
},"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-compare-block"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "                        <div class=\"perso-compare\" role=\"text\">\n                            <div class=\"perso-compare-text label\">"
    + ((stack1 = ((helper = (helper = helpers.label1 || (depth0 != null ? depth0.label1 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"label1","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n                            <div class=\"perso-compare-text value\">"
    + ((stack1 = ((helper = (helper = helpers.label2 || (depth0 != null ? depth0.label2 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"label2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n                        </div>\n                <div id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "_wrapper\" class=\"perso-compare-bar-wrapper\">\n                    <div id=\""
    + ((stack1 = ((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" class=\"perso-compare-bar\"></div>\n                </div>\n\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"pstory-block-frame pstory-block-compareBlock "
    + container.escapeExpression(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-contanier\">\n        <div class=\"pstory-block-content\">\n            <div class=\"perso-compareBlock-wrapper\" role=\"text\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            </div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-date-box"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-date-box "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-contanier\">\n        <div class=\"pstory-block-content\" tabindex=\"0\">\n            <div class=\"pstory-block-date-month\">"
    + alias4(((helper = (helper = helpers.month || (depth0 != null ? depth0.month : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"month","hash":{},"data":data}) : helper)))
    + "</div>\n            <div class=\"pstory-block-date-day\">"
    + alias4(((helper = (helper = helpers.day || (depth0 != null ? depth0.day : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"day","hash":{},"data":data}) : helper)))
    + "</div>\n        </div>\n    </div>\n</div>\n\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-entity-selector"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                        <div class=\"pstory-button carousel-item pstory-entity-selector-item "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " pstory-entity-"
    + alias4(((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"icon","hash":{},"data":data}) : helper)))
    + "\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\"\n                            pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n                            <div>\n                            </div>\n                        </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "selected";
},"4":function(container,depth0,helpers,partials,data) {
    return "                    <div class=\"carousel-index-dot\">\n                        <div class=\"carousel-index-dot-circle\"></div>\n                    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"pstory-block-frame pstory-block-entity-selector "
    + container.escapeExpression(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-contanier\">\n        <div class=\"pstory-block-content\">\n            <div class=\"options-container carousel-animate carousel-wrapper\">\n                <div class=\"carousel-outer-wrapper\">\n                    <div class=\"carousel-inner-wrapper\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                    </div>\n                </div>\n                <div class=\"pstory-entity-text\"></div>\n                <div class=\"carousel-index-wrapper\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                </div>\n                <div class=\"pstory-acc-carousel-selected\"></div>\n                <input type=\"button\" class=\"pstory-carousel-arrow pstory-carousel-arrow-prev\" aria-label=\"prev\" />\n                <input type=\"button\" class=\"pstory-carousel-arrow pstory-carousel-arrow-next\" aria-label=\"next\" />\n            </div>\n\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-hbox-columns"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "        <div class=\"pstory-hbox-column-frame "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\" data-v-align=\""
    + alias4(((helper = (helper = helpers["v-align"] || (depth0 != null ? depth0["v-align"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"v-align","hash":{},"data":data}) : helper)))
    + "\" data-width=\""
    + alias4(((helper = (helper = helpers.width || (depth0 != null ? depth0.width : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"width","hash":{},"data":data}) : helper)))
    + "\" >\n            <div class=\"pstory-hbox-blocks-container\"></div>\n        </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"pstory-block-hbox-columns-frame "
    + container.escapeExpression(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.columns : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-hbox"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pstory-block-frame pstory-block-hbox\">\n    <div class=\"pstory-block-contanier\">\n        <div class=\"pstory-block-content\">\n            <div class=\"hbox-block-content\"></div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-image"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <div class=\"pstory-block-content\" id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" style=\"background-image:url('"
    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
    + "')\"></div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <div class=\"pstory-block-content perso-image perso-"
    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
    + "\" id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"pstory-block-frame pstory-block-image "
    + container.escapeExpression(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-contanier\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isAbsoluteURL : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-layout"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"pstory-block-frame pstory-block-layout\">\n    <div class=\"pstory-block-contanier\">\n        <div class=\"pstory-block-content\">\n            <div class=\"layout-block-content\" id=\""
    + container.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data}) : helper)))
    + "\"></div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-line-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"pstory-block-frame pstory-block-line-chart pstory-block-line-chart "
    + container.escapeExpression(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-line-chart\"></div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-map"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pstory-block-frame pstory-block-map\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-map-frame\"></div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-month-picker"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <li class=\"perso-month-picker-item\" pstory-category=\""
    + alias4(((helper = (helper = helpers.category || (depth0 != null ? depth0.category : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"category","hash":{},"data":data}) : helper)))
    + "\" role=\"tab\" aria-label=\""
    + alias4(((helper = (helper = helpers.accLabel || (depth0 != null ? depth0.accLabel : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accLabel","hash":{},"data":data}) : helper)))
    + "\">"
    + alias4(((helper = (helper = helpers.displayLabel || (depth0 != null ? depth0.displayLabel : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"displayLabel","hash":{},"data":data}) : helper)))
    + "</li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"perso-month-picker-outer-wrapper\">\n    <div class=\"perso-month-picker-wrapper\">\n\n        <ul class=\"perso-month-picker-container\" role=\"tablist\">\n            <div class=\"pstory-month-picker-selected-tab\"></div>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pie-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pstory-block-frame pstory-block-pie-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-pie-chart\"></div>\n            <div class=\"pstory-pie-data\">\n                <div class=\"pstory-next-arrow\"></div>\n                <div class=\"pstory-pie-info\">\n                </div>\n                <div class=\"pstory-previous-arrow\"></div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pinGraph-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-pinGraph-chart_"
    + alias4(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + " pstory-block-pinGraph-chart "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-pinGraph-chart\">\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pure-bar-chart"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "perso-comparable-chart";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                    <div class=\"perso-series-wrapper\">\n                                        <div class=\"perso-series\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                                        </div>\n                                    </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                                                <div class=\"perso-bar-wrapper\">\n                                                    <div class=\"perso-bar"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" pstory-category=\""
    + container.escapeExpression(((helper = (helper = helpers.category || (depth0 != null ? depth0.category : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"category","hash":{},"data":data}) : helper)))
    + "\"></div>\n                                                </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return " selected";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                                    <div class=\"perso-bar-wrapper simple-bar\">                                                           \n                                        <div class=\"perso-bar "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(12, data, 0),"data":data})) != null ? stack1 : "")
    + " pstory-category=\""
    + container.escapeExpression(((helper = (helper = helpers.category || (depth0 != null ? depth0.category : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"category","hash":{},"data":data}) : helper)))
    + "\"></div>\n                                    </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "selected\" aria-selected=\"true\"";
},"12":function(container,depth0,helpers,partials,data) {
    return "\"";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-bar-chart pure-bar-chart "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.direction || (depth0 != null ? depth0.direction : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"direction","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-bar-chart\">\n"
    + ((stack1 = container.invokePartial(partials.monthPicker,depth0,{"name":"monthPicker","data":data,"indent":"                ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "                <div class=\"perso-bar-chart-wrapper perso-accessibility-wrapper "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSeries : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" role=\"text\" >\n                    <span class=\"perso-accessibility-read perso-accessibility-bar-seleced-text\"></span>\n                    <span class=\"perso-tooltip\"></span>\n                    <div class=\"perso-bar-chart-container\">\n                        <div class=\"perso-bars-wrapper\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSeries : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(8, data, 0),"data":data})) != null ? stack1 : "")
    + "                        </div>\n                        <div class=\"perso-month-amount\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pure-pinGraph-chart"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "                        <div class=\"perso-pinGraph-raw\" >\n                            <div class=\"perso-raw-wrapper\" role=\"text\">\n                                <span class=\"perso-raw-item perso-date-txt\"></span>\n                                <div class=\"perso-raw-item perso-bar-wrapper\">\n                                    <span class=\"perso-pinGraph-bar\"></span>\n                                    <span class=\"perso-raw-item perso-pinGraph-amount\"></span>\n                                </div>\n                            </div>\n                        </div>\n                        <div aria-hidden=\"true\"></div><!--it's required for accessibility-->\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-pinGraph-chart_"
    + alias4(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + " pstory-block-pinGraph-chart "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-pinGraph-chart\">\n                <div class=\"perso-pinGraph-container\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                </div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-selectOne"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "	            <div class=\"pstory-selectOne-wrapper\">\n		            <span class=\"pstory-selectOne\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"\n		                   pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\">"
    + alias4(((helper = (helper = helpers.txt || (depth0 != null ? depth0.txt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"txt","hash":{},"data":data}) : helper)))
    + "</span>\n                    <input type=\"button\" class=\"pstory-button pstory-selectOne-icon\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\"\n		                   pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\"/>\n	            </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-selectOne\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-spline-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pstory-block-frame pstory-block-spline-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-spline-chart\"></div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return "                    <tr>\n                        <td class=\"perso-loading-table\">"
    + container.escapeExpression(((helper = (helper = helpers.loadingText || (depth0 != null ? depth0.loadingText : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"loadingText","hash":{},"data":data}) : helper)))
    + "</td>\n                    </tr>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.twoCols : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.program(10, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaders : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                            <tr>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.displayedCols : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                            </tr>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                    <th role=\"cell\">"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "</th>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                            <tr>\n                                <td class=\"perso-td-first\" role=\"cell\">"
    + ((stack1 = alias1((depth0 != null ? depth0["0"] : depth0), depth0)) != null ? stack1 : "")
    + "</td>\n                                <td align=\"right\">\n                                    <span class=\"perso-td-second\" role=\"cell\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0["1"] : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                            </tr>\n";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaders : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                            <tr>\n                                <th role=\"cell\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.displayedCols : depth0)) != null ? stack1["1"] : stack1), depth0))
    + "</th>                           \n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.fourCols : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(14, data, 0),"data":data})) != null ? stack1 : "")
    + "                            </tr>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                <th align=\"right\" role=\"cell\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.displayedCols : depth0)) != null ? stack1["3"] : stack1), depth0))
    + "</th>\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                    <th align=\"right\" role=\"cell\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.displayedCols : depth0)) != null ? stack1["2"] : stack1), depth0))
    + "</th>\n";
},"16":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=depth0 != null ? depth0 : (container.nullContext || {});

  return "                            <tr>\n                                <td>\n                                    <span class=\"perso-td-date\" role=\"cell\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0["0"] : depth0), depth0)) != null ? stack1 : "")
    + "\n                                        </span>\n                                    <span class=\"perso-td-first\" role=\"cell\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0["1"] : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                                <td align=\"right\">\n                                    <span class=\"perso-td-second\" role=\"cell\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0["2"] : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n"
    + ((stack1 = helpers["if"].call(alias2,(depths[1] != null ? depths[1].fourCols : depths[1]),{"name":"if","hash":{},"fn":container.program(17, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                                </td>\n"
    + ((stack1 = helpers["if"].call(alias2,(depths[1] != null ? depths[1].fourCols : depths[1]),{"name":"if","hash":{},"fn":container.program(19, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                            </tr>\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                        <span class=\"perso-td-last\" role=\"cell\">\n                                            "
    + ((stack1 = container.lambda((depth0 != null ? depth0["3"] : depth0), depth0)) != null ? stack1 : "")
    + "\n                                        </span>\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                    <!--<td align=\"right\">\n                                        <span class=\"perso-td-last\" role=\"cell\">\n                                            "
    + ((stack1 = container.lambda((depth0 != null ? depth0["3"] : depth0), depth0)) != null ? stack1 : "")
    + "\n                                        </span>\n                                    </td>-->\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <table class=\"pstory-table\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </table>\n        </div>\n    </div>\n</div>";
},"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-tabs"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "            \n                <input type=\"button\" class=\"pstory-tab pstory-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" value=\""
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" pstory-id=\""
    + container.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" />\n            ";
},"2":function(container,depth0,helpers,partials,data) {
    return "selected";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                            <li  class=\"pstory-tab "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" aria-selected=\""
    + alias4(((helper = (helper = helpers.selected || (depth0 != null ? depth0.selected : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"selected","hash":{},"data":data}) : helper)))
    + "\" role=\"tab\" tabindex=\""
    + alias4(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</li>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "pstory-button";
},"7":function(container,depth0,helpers,partials,data) {
    return "pstory-button pstory-header-button";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div id=\"pstory-block-tabs_"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-block-frame pstory-block-tabs "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <!--"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "-->\n                <div class=\"header-container\">\n                    <div class=\"pstory-tab-animated-border-bottom\"></div>\n                    <ul class=\"tablist\" role=\"tablist\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                    </ul>\n                </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-textboxes"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "with-image";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.image : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "                       <div class=\"perso-textbox perso-textbox-with-image\" role=\"text\">\n                           <div class=\"perso-textbox-image "
    + ((stack1 = ((helper = (helper = helpers.image || (depth0 != null ? depth0.image : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"image","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"></div>\n                           <div class=\"perso-value\">"
    + ((stack1 = ((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"value","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n                           <div class=\"perso-label\">"
    + ((stack1 = ((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"label","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n                       </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "                       <div class=\"perso-textbox\" role=\"text\">\n                           <div class=\"perso-value\">"
    + ((stack1 = ((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"value","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n                           <div class=\"perso-label\">"
    + ((stack1 = ((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"label","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n                       </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"pstory-block-frame pstory-block-textboxes "
    + container.escapeExpression(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-contanier\">\n        <div class=\"pstory-block-content\">\n           <div class=\"perso-textboxes-wrapper "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hasImage : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" role=\"text\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "           </div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-txt-note"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"pstory-block-frame pstory-block-text "
    + container.escapeExpression(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-contanier\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-block-note-icon\"></div>\n            <div class=\"pstory-block-note-txt\" role=\"text\">\n                "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n            </div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-txt"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "        <div class=\"pstory-block-content\" aria-level=\"2\" role=\"heading\">\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "        <div class=\"pstory-block-content\" role=\"text\">\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"pstory-block-frame pstory-block-text "
    + container.escapeExpression(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-contanier\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.needAccessibility : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-frame"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-frame "
    + alias4(((helper = (helper = helpers.langClass || (depth0 != null ? depth0.langClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"langClass","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.directionClass || (depth0 != null ? depth0.directionClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"directionClass","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.cssClass || (depth0 != null ? depth0.cssClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"cssClass","hash":{},"data":data}) : helper)))
    + "\" data-id=\"pstory-frame_"
    + alias4(((helper = (helper = helpers.storyId || (depth0 != null ? depth0.storyId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"storyId","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-container\"></div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-post"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"post-frame\">\n    <div class=\"post-container\">\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-rating"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"perso-ratings-wrapper\">\n   <div class='perso-ratings-text'>"
    + container.escapeExpression(((helper = (helper = helpers.ratingTitle || (depth0 != null ? depth0.ratingTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ratingTitle","hash":{},"data":data}) : helper)))
    + "</div>\n   <div class='perso-ratings-icons' data-rating-max='5'></div>\n</div>\n\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-teasers"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return "<div class=\"perso-teaser\" id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data}) : helper)))
    + "\">"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.teaser : depth0)) != null ? stack1.title : stack1), depth0))
    + "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.posts : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-pfeed"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div>\n    <div class=\"perso-header\">\n        "
    + alias4(((helper = (helper = helpers.feedByText || (depth0 != null ? depth0.feedByText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feedByText","hash":{},"data":data}) : helper)))
    + " <!--<img src=\"resources/images/perso-logo.png\" class=\"perso-logo\">-->\n        <svg  xmlns:svg=\"http://www.w3.org/2000/svg\" xmlns=\"http://www.w3.org/2000/svg\" width=\"187\" height=\"37\" viewBox=\"0 0 187 37\">\n            <image width=\"187\" height=\"37\" preserveAspectRatio=\"none\" id=\"image10\" x=\"0\" y=\"0\"\n                    xlink:href=\"data:image/png;base64,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\"/>\n        </svg>\n    </div>\n    <div class=\"perso-main\">\n        <div class=\"nano perso-container\">\n            <div class=\"nano-content perso-scroll\">\n            </div>\n        </div>\n    </div>\n    <div class=\"perso-footer\">\n        <div class=\"footer-button\">"
    + alias4(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "</div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-pslide"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\""
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"perso-header\">\n        <sup><sup>"
    + alias4(((helper = (helper = helpers.feedByText || (depth0 != null ? depth0.feedByText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"feedByText","hash":{},"data":data}) : helper)))
    + " </sup><!--<img src=\"resources/images/perso-logo.png\" class=\"perso-logo\">-->\n            <svg  xmlns:svg=\"http://www.w3.org/2000/svg\" xmlns=\"http://www.w3.org/2000/svg\" width=\"187\" height=\"37\" viewBox=\"0 0 187 37\">\n                <image width=\"187\" height=\"37\" preserveAspectRatio=\"none\" id=\"image10\" x=\"0\" y=\"0\"\n                       xlink:href=\"data:image/png;base64,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\"/>\n            </svg>\n        </sup>\n    </div>\n    <div class=\"perso-main\">\n        <div class=\"nano perso-container\">\n            <div  class=\"nano-content perso-scroll\"></div>\n        </div>\n    </div>\n    <div class=\"perso-footer\"><div class=\"footer-button\">"
    + alias4(((helper = (helper = helpers.closeText || (depth0 != null ? depth0.closeText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"closeText","hash":{},"data":data}) : helper)))
    + "</div></div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-pstory-dialog-continue-btn"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "        		"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showBtn : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-dialog-btn\" data-action=\""
    + alias4(((helper = (helper = helpers.actionBtn || (depth0 != null ? depth0.actionBtn : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"actionBtn","hash":{},"data":data}) : helper)))
    + "\">"
    + alias4(((helper = (helper = helpers.diaogBtn || (depth0 != null ? depth0.diaogBtn : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"diaogBtn","hash":{},"data":data}) : helper)))
    + "</div>";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-dialog-frame perso-dialog-actions-btn "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\" id=\"pdlg-"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-dialog-container\">\n        <div class=\"pstory-dialog-content\" ></div>\n        <div class=\"pstory-dialog-buttons\" data-numOfDialogBtn=\""
    + alias4(container.lambda(((stack1 = (depth0 != null ? depth0.btn : depth0)) != null ? stack1.length : stack1), depth0))
    + "\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.btn : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		</div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-pstory-dialog"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-dialog-frame "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\" id=\"pdlg-"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-dialog-container\">\n        <div class=\"pstory-dialog-content\" />\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-pstory-title-inside-story"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"pstory-title-outer-wrapper\">\n    <div class=\"pstory-fixed pstory-title-wrapper\">\n        <div class=\"pstory-title\">\n            <div class=\"pstory-title-text pstory-title-inside-story\">"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-pstory-title"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div class=\"pstory-title-outer-wrapper\">\n    <div class=\"pstory-fixed pstory-title-wrapper\">\n        <div class=\"pstory-title\">\n            <div class=\"pstory-title-text\">"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n        </div>\n    </div>\n</div>\n<div id=\"story-frame-container\"></div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["block-bar-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-bar-chart pstory-block-bar-chart "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.direction || (depth0 != null ? depth0.direction : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"direction","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-bar-chart\"></div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["block-line-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"pstory-block-frame pstory-block-line-chart pstory-block-line-chart "
    + container.escapeExpression(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-line-chart\"></div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["block-pie-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pstory-block-frame pstory-block-pie-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-pie-chart\"></div>\n            <div class=\"pstory-pie-data\">\n                <div class=\"pstory-next-arrow\"></div>\n                <div class=\"pstory-pie-info\">\n                </div>\n                <div class=\"pstory-previous-arrow\"></div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["block-pinGraph-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"pstory-block-frame pstory-block-pinGraph-chart_"
    + container.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data}) : helper)))
    + " pstory-block-pinGraph-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-pinGraph-chart\"></div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["block-pure-bar-chart"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "perso-comparable-chart";
},"3":function(container,depth0,helpers,partials,data) {
    return "";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                                <div class=\"perso-bar-wrapper simple-bar\">\n                                <div class=\"perso-bar "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data})) != null ? stack1 : "")
    + " pstory-category=\""
    + container.escapeExpression(((helper = (helper = helpers.category || (depth0 != null ? depth0.category : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"category","hash":{},"data":data}) : helper)))
    + "\"></div>\n                            </div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "selected\" aria-selected=\"true\"";
},"9":function(container,depth0,helpers,partials,data) {
    return "\"";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-bar-chart pstory-block-bar-chart "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.direction || (depth0 != null ? depth0.direction : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"direction","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-bar-chart\">\n                <div class=\"perso-bar-chart-wrapper perso-accessibility-wrapper "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSeries : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" role=\"text\" >\n                    <span class=\"perso-accessibility-read perso-accessibility-bar-seleced-text\"></span>\n                    <span class=\"perso-tooltip\"></span>\n                    <div class=\"perso-bar-chart-container\">\n                    <div class=\"perso-bars-wrapper\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSeries : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "")
    + "                    </div>\n                    <div class=\"perso-month-amount\"></div>\n                </div>\n            </div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["block-pure-pinGraph-chart"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "                        <div class=\"perso-pinGraph-raw\" >\n                            <div class=\"perso-raw-wrapper\" role=\"text\">\n                                <span class=\"perso-raw-item perso-date-txt\"></span>\n                                <div class=\"perso-raw-item perso-bar-wrapper\">\n                                    <span class=\"perso-pinGraph-bar\"></span>\n                                </div>\n                            </div>\n                        </div>\n                        <div aria-hidden=\"true\"></div><!--it's required for accessibility-->\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-pinGraph-chart_"
    + alias4(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + " pstory-block-pinGraph-chart "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-pure-pinGraph-chart\">\n                <div class=\"perso-pinGraph-container\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                </div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["block-spline-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"pstory-block-frame pstory-block-spline-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-spline-chart\"></div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["block-tranList"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <div class=\"perso-table-row\">\n                        <div class=\"perso-loading-tbl\">\n                            <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</span>\n                        </div>\n                    </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                        <div class=\"perso-table-row\">\n                            <div class=\"perso-col left-col\">\n                                <div class=\"perso-row upper-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.accountNumber : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "                            </div>\n                            <div class=\"perso-col right-col\">\n                                <div class=\"perso-amount-container\"> "
    + ((stack1 = alias1((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                            </div>\n                        </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                                    <div class=\"perso-row lower-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + " <span class=\"perso-account-seperator\">|</span> "
    + ((stack1 = alias1((depth0 != null ? depth0.accountNumber : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                    <div class=\"perso-row lower-row\">"
    + ((stack1 = container.lambda((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-table pstory-table-new-txlist1\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-loading-animation"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "<div id='perso-loading-widget'>\n    <div class='perso-loading-text' >\n         "
    + ((stack1 = ((helper = (helper = helpers.loadingText || (depth0 != null ? depth0.loadingText : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"loadingText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n    </div>\n    <div class='perso-loading'></div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-widget-story-error"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "class=\"mobile-err\"";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div id=\"personetics-error-container\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobileDevice : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n    <div class=\"personetics-error-img "
    + container.escapeExpression(((helper = (helper = helpers.imgClass || (depth0 != null ? depth0.imgClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"imgClass","hash":{},"data":data}) : helper)))
    + "\"></div> \n    <div class=\"personetics-error-large\">"
    + ((stack1 = ((helper = (helper = helpers.textLarge || (depth0 != null ? depth0.textLarge : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"textLarge","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n    <div class=\"personetics-error-small\">"
    + ((stack1 = ((helper = (helper = helpers.textSmall || (depth0 != null ? depth0.textSmall : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"textSmall","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n   \n\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["filter-inbox-template"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "			<li role=\"tab\" class =\"perso-teaser-filter-tab\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" aria-selected=\"false\" aria-label=\""
    + alias2(alias1((depth0 != null ? depth0.text : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.text : depth0), depth0))
    + " ("
    + alias2(alias1((depth0 != null ? depth0.count : depth0), depth0))
    + ")</li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"perso-teaser-filter\">\n	<ul role=\"tablist\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.tabs : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</ul>\n	<div class=\"perso-filter-selected-tab\"></div>\n</div>\n\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["inbox-template"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-title perso-teaser-title\" aria-label=\""
    + alias4(((helper = (helper = helpers.inboxTitle || (depth0 != null ? depth0.inboxTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"inboxTitle","hash":{},"data":data}) : helper)))
    + "\">\n    <div aria-live=\"assertive\" role=\"text\" class=\"pstory-title-text\">"
    + alias4(((helper = (helper = helpers.inboxTitle || (depth0 != null ? depth0.inboxTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"inboxTitle","hash":{},"data":data}) : helper)))
    + "</div>\n    <input aria-label=\"close\" type=\"button\" class=\"pstory-title-close\"/>\n</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "        <div class='perso-teaser-filter-wrapper'></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.filter : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class='perso-multi-teaser-wrapper'>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.inboxTitle : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <div class='perso-multi-teaser-template'></div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-teaser-carousel-desktop"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class='perso-multi-teaser-wrapper'>\n    <div class=\"carousel-animate carousel-wrapper\">\n        <div class=\"carousel-outer-wrapper\">\n            <div class='perso-multi-teaser-template carousel-inner-wrapper'></div>\n        </div>\n        <div class=\"teaser-navigation\">\n            <input type=\"button\" class=\"pstory-carousel-arrow pstory-carousel-arrow-prev\" aria-label=\""
    + alias4(((helper = (helper = helpers.prev || (depth0 != null ? depth0.prev : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"prev","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"/>\n            <input type=\"button\" class=\"pstory-acc-carousel-selected\" aria-label=\""
    + alias4(((helper = (helper = helpers.selected || (depth0 != null ? depth0.selected : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"selected","hash":{},"data":data}) : helper)))
    + "\"/>\n            <div class=\"carousel-index-wrapper\" aria-labelledby=\"perso-accessibility-read-"
    + alias4(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.insights : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.id : stack1), depth0))
    + "\">\n                <div class=\"carousel-index-container\"></div>\n            </div>  \n            <input type=\"button\" class=\"pstory-carousel-arrow pstory-carousel-arrow-next\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\" tabindex=\"-1\"/>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-teaser-carousel"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class='perso-multi-teaser-wrapper'>\n    <div class=\"carousel-index-wrapper\">\n        <div class=\"carousel-index-container\">\n        </div>\n    </div>  \n    <div class=\"carousel-animate carousel-wrapper\">\n        <div class=\"carousel-outer-wrapper\">\n            <div class='perso-multi-teaser-template carousel-inner-wrapper'></div>\n        </div>\n        <input type=\"button\" class=\"pstory-carousel-arrow pstory-carousel-arrow-prev pstory-carousel-arrow-hidden\" aria-label=\""
    + alias4(((helper = (helper = helpers.prev || (depth0 != null ? depth0.prev : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"prev","hash":{},"data":data}) : helper)))
    + "\"/>\n        <input type=\"button\" class=\"pstory-acc-carousel-selected\" aria-label=\""
    + alias4(((helper = (helper = helpers.selected || (depth0 != null ? depth0.selected : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"selected","hash":{},"data":data}) : helper)))
    + "\"/>\n        <input type=\"button\" class=\"pstory-carousel-arrow pstory-carousel-arrow-next pstory-carousel-arrow-hidden\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\"/>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-feedback"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"perso-feedback-wrapper\">\n    <div class=\"textarea-wrapper\">\n        <div class=\"textarea-container\">\n            <textarea class=\"perso-feedback-text direction-text-left\" maxlength=\"500\" placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.lblfeedbackprompt || (depth0 != null ? depth0.lblfeedbackprompt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblfeedbackprompt","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"></textarea>\n            <div class=\"textarea-size\" ></div>\n        </div>\n        <input class=\"perso-feedback-submit\" type=\"button\" value=\""
    + ((stack1 = ((helper = (helper = helpers.btnsubmit || (depth0 != null ? depth0.btnsubmit : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnsubmit","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" disabled=\"disabled\"/>\n    </div>\n    <div class=\"perso-feedback-reaction\">"
    + ((stack1 = ((helper = (helper = helpers.lblreactionFeedback || (depth0 != null ? depth0.lblreactionFeedback : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblreactionFeedback","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-feedback"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"perso-feedback-wrapper\">\n    <div class=\"perso-feedback-inner-wrapper\">\n        <div class=\"perso-feedback-header\">"
    + ((stack1 = ((helper = (helper = helpers.lblfeedbackheader || (depth0 != null ? depth0.lblfeedbackheader : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblfeedbackheader","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n        <div class=\"textarea-wrapper\">\n            <div class=\"textarea-container\">\n                <textarea class=\"perso-feedback-text direction-text-left\" maxlength=\"500\"></textarea>\n            </div>\n            <input class=\"perso-feedback-submit\" type=\"button\" value=\""
    + ((stack1 = ((helper = (helper = helpers.btnsubmit || (depth0 != null ? depth0.btnsubmit : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnsubmit","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" disabled/>\n            <input class=\"perso-feedback-skip\" type=\"button\" value=\""
    + ((stack1 = ((helper = (helper = helpers.btnskip || (depth0 != null ? depth0.btnskip : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnskip","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" />\n        </div>   \n    </div>\n    <div class=\"perso-feedback-reaction\">"
    + ((stack1 = ((helper = (helper = helpers.lblreactionFeedback || (depth0 != null ? depth0.lblreactionFeedback : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblreactionFeedback","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-widget-teaser"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "                <input type=\"button\" class=\"perso-teaser-filter-tab"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" value=\""
    + alias2(alias1((depth0 != null ? depth0.text : depth0), depth0))
    + "\"/>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " perso-selected-tab";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"perso-teaser-widget-container\">\n    <div class=\"perso-teaser-header-wrapper\">\n        <div class=\"perso-teaser-header-top\"></div>\n        <div class=\"perso-teaser-header\">\n            <div class=\"perso-teaser-header-close\"></div>\n            <div class=\"perso-teaser-header-title\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.insightsTitle : stack1), depth0))
    + "</div>\n        </div>\n        <div class=\"perso-teaser-filter-tabs\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.tabs : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            <div class=\"pstory-tab-animated-border-bottom\"></div>\n        </div>\n   </div>\n    <div class=\"perso-insights-container\">\n        <div class=\"perso-loading-wrapper\">\n            <div class=\"perso-loading\"></div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["inboxContainer"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div id=\"personetics-inbox-container\">\n</div>\n<div id=\"personetics-story-inner-container\">\n    <div class=\"perso-story-inner-top\">\n        <div class=\"story-top-title\"></div>\n        <div class=\"story-top-buttons-wrapper\">\n            <div class=\"story-top-button story-top-button-inbox\">\n                <input id=\"story-button-inbox\" type=\"button\" class=\"story-top-button-circle\">\n                <div class=\"story-top-button-circle-img\"></div>\n                </input>\n                <div class=\"story-top-button-text\">"
    + container.escapeExpression(((helper = (helper = helpers.insightsInboxTitle || (depth0 != null ? depth0.insightsInboxTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"insightsInboxTitle","hash":{},"data":data}) : helper)))
    + "</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"perso-story-inner\">\n        <div id=\"personetics-story\"></div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector-accessibility"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return "			<div class=\"header-container\">\n				<div class=\"pstory-tab-animated-border-bottom\"></div>\n				<ul class=\"tablist\" role=\"tablist\">\n					<li class=\"pstory-header-button\" role=\"tab\" tabindex=\""
    + alias4(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-all=\"true\" pstory-id=\"all\">"
    + ((stack1 = alias5(((stack1 = (depth0 != null ? depth0.headerTexts : depth0)) != null ? stack1["0"] : stack1), depth0)) != null ? stack1 : "")
    + "</li>\n					<li class=\"pstory-header-button\" role=\"tab\" tabindex=\""
    + alias4(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" data-all=\"false\">"
    + ((stack1 = alias5(((stack1 = (depth0 != null ? depth0.headerTexts : depth0)) != null ? stack1["1"] : stack1), depth0)) != null ? stack1 : "")
    + "</li>\n				</ul>\n			</div>\n			<div class=\"carousel-animate carousel-wrapper options-container show-all\">\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "				<div class=\"carousel-animate carousel-wrapper options-container\">\n";
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return "						<div class=\"carousel-item pstory-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" aria-hidden=\"true\" pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\"\n						 role=\""
    + alias4(alias5((depths[1] != null ? depths[1].role : depths[1]), depth0))
    + "\">\n							<div class=\"card card_"
    + alias4(((helper = (helper = helpers.typeImage || (depth0 != null ? depth0.typeImage : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"typeImage","hash":{},"data":data}) : helper)))
    + " cards"
    + alias4(((helper = (helper = helpers.numCards || (depth0 != null ? depth0.numCards : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numCards","hash":{},"data":data}) : helper)))
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = container.invokePartial(partials.innerCard,depth0,{"name":"innerCard","hash":{"numberPrefAccessibility":(depths[1] != null ? depths[1].numberPrefAccessibility : depths[1]),"numberPref":(depths[1] != null ? depths[1].numberPref : depths[1])},"data":data,"indent":"\t\t\t\t\t\t\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "							</div>\n							<div id=\"pop-"
    + alias4(alias5(depth0, depth0))
    + "\" class=\"pstory-button-txt-wrapper\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.text2 : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " \n								<span class=\"pstory-button-txt\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n							</div>\n						</div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "selected";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "								<span class=\"pstory-button-txt  perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.text2 || (depth0 != null ? depth0.text2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "						<span class=\"perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt2 || (depth0 != null ? depth0.allAccountsTxt2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"allAccountsTxt2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span> ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"perso-accessibility-wrapper perso-accessibility-account-selector\" role=\"text\">\n	<span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountSelectorText || (depth0 != null ? depth0.accountSelectorText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountSelectorText","hash":{},"data":data}) : helper)))
    + "</span>\n</div>\n<div id=\"pstory-block-account-selector_"
    + alias4(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-block-frame pstory-block-account-selector "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\" data-showAll="
    + alias4(((helper = (helper = helpers.showAll || (depth0 != null ? depth0.showAll : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"showAll","hash":{},"data":data}) : helper)))
    + ">\n	<div class=\"pstory-block-container\">\n		<div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showAll : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "					<div class=\"carousel-inner-wrapper cards-wrapper\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "					</div>\n					<div class=\"perso-accessibility-wrapper account-button selected\" role=\"text\">\n						<span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountName || (depth0 != null ? depth0.accountName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountName","hash":{},"data":data}) : helper)))
    + ". "
    + alias4(((helper = (helper = helpers.numberPrefAccessibility || (depth0 != null ? depth0.numberPrefAccessibility : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberPrefAccessibility","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.accountNumber || (depth0 != null ? depth0.accountNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountNumber","hash":{},"data":data}) : helper)))
    + "</span>\n					</div>\n					<input class=\"account-button prev\" id=\"prev\" type=\"button\" value=\"\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\" />\n					<input class=\"account-button next\" id=\"next\" type=\"button\" value=\"\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\" />\n					<div class=\"pstory-all-accounts-txt\" role=\"text\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.allAccountsTxt2 : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n						<span class=\"perso-amount-wrapper\">"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt || (depth0 != null ? depth0.allAccountsTxt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"allAccountsTxt","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n					</div>\n				</div>\n				<div class=\"pstory-comment\">"
    + ((stack1 = ((helper = (helper = helpers.comment || (depth0 != null ? depth0.comment : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"comment","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n			</div>\n		</div>\n	</div>";
},"usePartial":true,"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector-inner-card"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "        <span class=\"perso-account-number\" aria-label=\""
    + alias4(((helper = (helper = helpers.numberPrefAccessibility || (depth0 != null ? depth0.numberPrefAccessibility : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberPrefAccessibility","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
    + ".\">*"
    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <span class=\"pstory-button-txt perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.text2 || (depth0 != null ? depth0.text2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"card card_"
    + alias4(((helper = (helper = helpers.typeImage || (depth0 != null ? depth0.typeImage : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"typeImage","hash":{},"data":data}) : helper)))
    + " cards"
    + alias4(((helper = (helper = helpers.numCards || (depth0 != null ? depth0.numCards : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numCards","hash":{},"data":data}) : helper)))
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"card-image\">\n        <div class=\"image\"></div>\n    </div>\n    <div class=\"card-container\">\n        <span class=\"perso-account-name\" aria-label=\""
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + ".\">"
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + "</span>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        <div id=\"pop-"
    + alias4(container.lambda(depth0, depth0))
    + "\" class=\"pstory-button-txt-wrapper\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.text2 : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            <span class=\"pstory-button-txt\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector-new"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "pstory-tabs";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "                <div class=\"overlay overlay-all\"></div>\n                <div class=\"overlay overlay-choose\"></div>\n                <div class=\"header-container\">\n                    <div class=\"pstory-tab-animated-border-bottom\"></div>\n                    <ul class=\"tablist\" role=\"tablist\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.headersArray : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                    </ul>\n                </div>\n            <div class=\"carousel-outer-wrapper collapse\">\n            <div class=\"carousel-animate options-container carousel-wrapper pstory-show-header-tabs\">\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "                            <li class=\"pstory-header-button\" "
    + ((stack1 = helpers["if"].call(alias1,(depths[1] != null ? depths[1].isDesktopMode : depths[1]),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " role=\"tab\" data-all=\""
    + container.escapeExpression(((helper = (helper = helpers.isAll || (depth0 != null ? depth0.isAll : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"isAll","hash":{},"data":data}) : helper)))
    + "\"\n                                "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isAll : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</li>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return " tabindex=\"0\" aria-label=\""
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" ";
},"7":function(container,depth0,helpers,partials,data) {
    return "pstory-id=\"all\" ";
},"9":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"carousel-outer-wrapper collapse\">\n            <div class=\"carousel-animate options-container carousel-wrapper\">\n";
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                    <div class=\"carousel-item pstory-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" aria-hidden=\"true\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\"\n                         role=\""
    + alias4(container.lambda((depths[1] != null ? depths[1].role : depths[1]), depth0))
    + "\">\n                        "
    + ((stack1 = helpers["if"].call(alias1,(depths[1] != null ? depths[1].isDesktopMode : depths[1]),{"name":"if","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.program(16, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n                    </div>\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "selected";
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return " "
    + ((stack1 = container.invokePartial(partials.innerCardDesktop,depth0,{"name":"innerCardDesktop","hash":{"numberPrefAccessibility":(depths[1] != null ? depths[1].numberPrefAccessibility : depths[1]),"numberPref":(depths[1] != null ? depths[1].numberPref : depths[1])},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n                        ";
},"16":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return " "
    + ((stack1 = container.invokePartial(partials.innerCard,depth0,{"name":"innerCard","hash":{"numberPrefAccessibility":(depths[1] != null ? depths[1].numberPrefAccessibility : depths[1]),"numberPref":(depths[1] != null ? depths[1].numberPref : depths[1])},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                <div class=\"carousel-index-wrapper\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n                    <div class=\"carousel-index-container\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                    </div>\n                </div>\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " role=\"application\" aria-labelledby=\"perso-accessibility-read-"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.id : stack1), depth0))
    + "\"\n                ";
},"21":function(container,depth0,helpers,partials,data) {
    return "                            <div class=\"carousel-index-dot\">\n                                <div class=\"carousel-index-dot-circle\"></div>\n                            </div>\n";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=helpers.helperMissing, alias4="function";

  return "                <div class=\"pstory-all-accounts-txt\" role=\"text\">\n                    <span class=\"perso-bold\">"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.length : stack1), depth0))
    + " "
    + alias1(((helper = (helper = helpers.lblaccSelectAccounts || (depth0 != null ? depth0.lblaccSelectAccounts : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"lblaccSelectAccounts","hash":{},"data":data}) : helper)))
    + "</span>\n                    <span class=\"perso-amount-wrapper\">"
    + ((stack1 = helpers["if"].call(alias2,(depth0 != null ? depth0.allAccountsTxt2 : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt || (depth0 != null ? depth0.allAccountsTxt : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"allAccountsTxt","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n                </div>\n";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return ((stack1 = ((helper = (helper = helpers.allAccountsTxt2 || (depth0 != null ? depth0.allAccountsTxt2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"allAccountsTxt2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + ": ";
},"26":function(container,depth0,helpers,partials,data) {
    return "\n                   tabindex=\"-1\" ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"perso-accessibility-wrapper perso-accessibility-account-selector\" role=\"text\">\n    <span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountSelectorText || (depth0 != null ? depth0.accountSelectorText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountSelectorText","hash":{},"data":data}) : helper)))
    + "</span>\n</div>\n<div id=\"pstory-block-account-selector_"
    + alias4(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-block-frame pstory-block-account-selector "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\" data-show-header-tabs="
    + alias4(((helper = (helper = helpers.showHeaderTabs || (depth0 != null ? depth0.showHeaderTabs : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"showHeaderTabs","hash":{},"data":data}) : helper)))
    + ">\n    <div class=\"pstory-block-container "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaderTabs : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n        <div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaderTabs : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.program(9, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            <div class=\"carousel-inner-wrapper cards-wrapper\" aria-hidden=\"true\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            </div>\n\n            <div class=\"perso-accessibility-wrapper pstory-account-button selected\" role=\"text\">\n                <span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountName || (depth0 != null ? depth0.accountName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountName","hash":{},"data":data}) : helper)))
    + ". "
    + alias4(((helper = (helper = helpers.numberPrefAccessibility || (depth0 != null ? depth0.numberPrefAccessibility : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberPrefAccessibility","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.accountNumber || (depth0 != null ? depth0.accountNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountNumber","hash":{},"data":data}) : helper)))
    + "</span>\n            </div>\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showIndexDots : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaderTabs : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n            <input type=\"button\" class=\"pstory-account-button pstory-prev-account-button\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " />\n            <input type=\"button\" class=\"pstory-account-button pstory-next-account-button\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "/>\n        </div>\n            <div class=\"pstory-comment\">"
    + ((stack1 = ((helper = (helper = helpers.comment || (depth0 != null ? depth0.comment : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"comment","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n        </div>\n        </div>\n        </div>";
},"usePartial":true,"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "                <div class=\"header-container\">\n                    <div class=\"pstory-tab-animated-border-bottom\"></div>\n                    <ul class=\"tablist\" role=\"tablist\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.headersArray : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                    </ul>\n                </div>\n            <div class=\"carousel-outer-wrapper\">\n            <div class=\"carousel-animate options-container carousel-wrapper pstory-show-header-tabs\">\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "                            <li class=\"pstory-header-button\" "
    + ((stack1 = helpers["if"].call(alias1,(depths[1] != null ? depths[1].isDesktopMode : depths[1]),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " role=\"tab\" data-all=\""
    + container.escapeExpression(((helper = (helper = helpers.isAll || (depth0 != null ? depth0.isAll : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"isAll","hash":{},"data":data}) : helper)))
    + "\"\n                                "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isAll : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</li>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return " tabindex=\"0\" aria-label=\""
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" ";
},"5":function(container,depth0,helpers,partials,data) {
    return "pstory-id=\"all\" ";
},"7":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"carousel-outer-wrapper\">\n            <div class=\"carousel-animate options-container carousel-wrapper\">\n";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                    <div class=\"carousel-item pstory-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" aria-hidden=\"true\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\"\n                         role=\""
    + alias4(container.lambda((depths[1] != null ? depths[1].role : depths[1]), depth0))
    + "\">\n                        "
    + ((stack1 = helpers["if"].call(alias1,(depths[1] != null ? depths[1].isDesktopMode : depths[1]),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.program(14, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n                    </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "selected";
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return " "
    + ((stack1 = container.invokePartial(partials.innerCardDesktop,depth0,{"name":"innerCardDesktop","hash":{"numberPrefAccessibility":(depths[1] != null ? depths[1].numberPrefAccessibility : depths[1]),"numberPref":(depths[1] != null ? depths[1].numberPref : depths[1])},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n                        ";
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return " "
    + ((stack1 = container.invokePartial(partials.innerCard,depth0,{"name":"innerCard","hash":{"numberPrefAccessibility":(depths[1] != null ? depths[1].numberPrefAccessibility : depths[1]),"numberPref":(depths[1] != null ? depths[1].numberPref : depths[1])},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                <div class=\"carousel-index-wrapper\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n                    <div class=\"carousel-index-container\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                    </div>\n                </div>\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " role=\"application\" aria-labelledby=\"perso-accessibility-read-"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.id : stack1), depth0))
    + "\"\n                ";
},"19":function(container,depth0,helpers,partials,data) {
    return "                            <div class=\"carousel-index-dot\">\n                                <div class=\"carousel-index-dot-circle\"></div>\n                            </div>\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "                    <span class=\"perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt2 || (depth0 != null ? depth0.allAccountsTxt2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"allAccountsTxt2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"23":function(container,depth0,helpers,partials,data) {
    return "\n                   tabindex=\"-1\" ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"perso-accessibility-wrapper perso-accessibility-account-selector\" role=\"text\">\n    <span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountSelectorText || (depth0 != null ? depth0.accountSelectorText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountSelectorText","hash":{},"data":data}) : helper)))
    + "</span>\n</div>\n<div id=\"pstory-block-account-selector_"
    + alias4(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-block-frame pstory-block-account-selector "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\" data-show-header-tabs="
    + alias4(((helper = (helper = helpers.showHeaderTabs || (depth0 != null ? depth0.showHeaderTabs : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"showHeaderTabs","hash":{},"data":data}) : helper)))
    + ">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaderTabs : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(7, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            <div class=\"carousel-inner-wrapper cards-wrapper\" aria-hidden=\"true\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            </div>\n\n            <div class=\"perso-accessibility-wrapper pstory-account-button selected\" role=\"text\">\n                <span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountName || (depth0 != null ? depth0.accountName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountName","hash":{},"data":data}) : helper)))
    + ". "
    + alias4(((helper = (helper = helpers.numberPrefAccessibility || (depth0 != null ? depth0.numberPrefAccessibility : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberPrefAccessibility","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.accountNumber || (depth0 != null ? depth0.accountNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountNumber","hash":{},"data":data}) : helper)))
    + "</span>\n            </div>\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showIndexDots : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            <div class=\"pstory-all-accounts-txt\" role=\"text\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.allAccountsTxt2 : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                <span>"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt || (depth0 != null ? depth0.allAccountsTxt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"allAccountsTxt","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n            </div>\n        </div>\n            <input type=\"button\" class=\"pstory-account-button pstory-prev-account-button\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " />\n            <input type=\"button\" class=\"pstory-account-button pstory-next-account-button\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "/>\n        </div>\n            <div class=\"pstory-comment\">"
    + ((stack1 = ((helper = (helper = helpers.comment || (depth0 != null ? depth0.comment : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"comment","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n        </div>\n        </div>\n        </div>";
},"usePartial":true,"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pie-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-pie-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-pie-chart\"></div>\n            <div class=\"pstory-pie-data\">\n                <input type=\"button\" class=\"pstory-arrow pstory-next-arrow\" aria-hidden=\"true\"/>\n                <div class=\"pstory-pie-info perso-accessibility-wrapper\" role=\"text\">\n                </div>\n                <input type=\"button\" class=\"pstory-arrow pstory-previous-arrow\" aria-label=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.nextCategory : stack1), depth0))
    + "\"/>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-minimal"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <tr>\n                        <td class=\"perso-loading-table\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</td>\n                    </tr>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda;

  return "                            <tr class=\""
    + container.escapeExpression(alias1((depths[1] != null ? depths[1]["class"] : depths[1]), depth0))
    + "\">\n                                <td role=\"cell\" class=\"perso-td-date\">"
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "</td>\n                                <td  align=\"right\" role=\"cell\" class=\"perso-td-amount-balance\">"
    + ((stack1 = alias1((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + " </td>                                \n                                <td  align=\"right\" class=\"perso-td-amount-balance  \" role=\"cell\"> "
    + ((stack1 = alias1((depth0 != null ? depth0.account : depth0), depth0)) != null ? stack1 : "")
    + "</td>\n\n                            </tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <table class=\"pstory-table\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </table>\n        </div>\n    </div>\n</div>";
},"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist1-new"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <div class=\"perso-table-row\">\n                        <div class=\"perso-loading-tbl\">\n                            <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</span>\n                        </div>\n                    </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                        <div class=\"perso-table-row\">\n                            <div class=\"perso-col left-col\">\n                                <div class=\"perso-row upper-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.accountNumber : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "                            </div>\n                            <div class=\"perso-col right-col\">\n                                <div class=\"perso-amount-container\"> "
    + ((stack1 = alias1((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                            </div>\n                        </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                                    <div class=\"perso-row lower-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + " <span class=\"perso-account-seperator\">|</span> "
    + ((stack1 = alias1((depth0 != null ? depth0.accountNumber : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                                    <div class=\"perso-row lower-row\">"
    + ((stack1 = container.lambda((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-table pstory-table-new-txlist1\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            </div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist1"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <tr>\n                        <td class=\"perso-loading-table\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</td>\n                    </tr>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                        <tr>\n                            <td>\n                                   <span class=\"perso-td-first-row perso-td-account-number\">\n                                       "
    + ((stack1 = alias1((depth0 != null ? depth0.accountNumber : depth0), depth0)) != null ? stack1 : "")
    + "\n                                   </span>\n                                <span class=\"perso-td-transaction\">\n                                    "
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "\n                                </span>\n                            </td>\n                            <td  class=\"rightAlign\" >\n                                     <span class=\"perso-td-first-row perso-td-date\">\n                                         "
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "\n                                     </span>\n                                <span class=\"perso-td-amount-balance perso-td-amount\">\n                                    "
    + ((stack1 = alias1((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + "\n                                </span>\n                            </td>\n                        </tr>\n\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <table class=\"pstory-table pstory-table-txlist1\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            </table>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist2"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <tr>\n                        <td class=\"perso-loading-table\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</td>\n                    </tr>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                            <tr>\n                                <td>\n                                    <span class=\"perso-td-first-row perso-td-transaction\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                                <td  class=\"rightAlign\" >\n                                    <span class=\"perso-td-first-row perso-td-date\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                    <span class=\"perso-td-amount-balance perso-td-amount\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                            </tr>\n\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <table class=\"pstory-table pstory-table-txlist2\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            </table>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist3"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <tr>\n                        <td class=\"perso-loading-table\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</td>\n                    </tr>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda;

  return "                            <tr >\n                                <td>\n                                    <span class=\"perso-td-first-row perso-td-date\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>                                    \n                                </td>\n                                <td> \n                                    <span class=\"perso-td-first-row perso-td-account-number\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.accountNumber : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                    <span class=\"perso-td-transaction\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>                           \n                                </td>\n                                <td class=\"rightAlign\" >\n                                     <span class=\"perso-td-first-row perso-td-balance-title perso-td-small\">\n                                        "
    + container.escapeExpression(alias1((depths[1] != null ? depths[1].balanceLabel : depths[1]), depth0))
    + "\n                                    </span>\n                                    <span class=\"perso-td-amount-balance perso-td-balance\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.balance : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>   \n                                \n                            </tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <table class=\"pstory-table pstory-table-txlist3\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </table>\n        </div>\n    </div>\n</div>";
},"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist4"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                <div id=\"perso-legend-wrapper\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.legendTexts : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "                        <div class=\"perso-legend-container\">\n                            <div class=\"perso-legend-dot "
    + ((stack1 = ((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "-dot\"></div>\n                            <span class=\"perso-legend-text\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n                        </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <div class=\"perso-table-row\">\n                        <div class=\"perso-loading-tbl\">\n                            <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</span>\n                        </div>\n                    </div>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                    <div class=\"perso-table-row scheduled-"
    + ((stack1 = alias1((depth0 != null ? depth0.isScheduled : depth0), depth0)) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isScheduled : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data})) != null ? stack1 : "")
    + "                        <div class=\"perso-table-cell perso-cell-1\">\n                            <div class=\"perso-transaction-title\">"
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                            <div class=\"perso-transaction-date\">"
    + ((stack1 = alias1((depth0 != null ? depth0.isAnticipated : depth0), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                        </div>\n                        <div class=\"perso-table-cell perso-cell-2\">\n                            <div class=\"perso-td-amount-balance perso-td-amount\">"
    + ((stack1 = alias1((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                        </div>\n                    </div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                            <div class=\"perso-large-legend-dot scheduled-dot "
    + ((stack1 = container.lambda((depth0 != null ? depth0.debitOrCredit : depth0), depth0)) != null ? stack1 : "")
    + "\"></div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                            <div class=\"perso-large-legend-dot estimated-dot "
    + ((stack1 = container.lambda((depth0 != null ? depth0.debitOrCredit : depth0), depth0)) != null ? stack1 : "")
    + "\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.legendTexts : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            <div class=\"pstory-table-type-2 pstory-table-txlist4\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist5"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <tr>\n                        <td class=\"perso-loading-table\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</td>\n                    </tr>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda;

  return "                            <tr >\n                                <td>\n                                    <span class=\"perso-td-first-row perso-td-date\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                                <td  class=\"leftAlign\">\n                                    <span class=\"perso-td-first-row perso-td-transaction perso-td-small\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                      <span class=\"perso-td-amount-balance perso-td-amount\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                                <td  class=\"leftAlign\" role=\"cell\">\n                                    <span class=\"perso-td-first-row perso-td-balance-title perso-td-small\">\n                                        "
    + container.escapeExpression(alias1((depths[1] != null ? depths[1].balanceLabel : depths[1]), depth0))
    + "\n                                    </span>\n                                      <span class=\"perso-td-amount-balance perso-td-balance\">\n                                          "
    + ((stack1 = alias1((depth0 != null ? depth0.balance : depth0), depth0)) != null ? stack1 : "")
    + "\n                                      </span>\n                                </td>\n                            </tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <table class=\"pstory-table pstory-table-txlist5\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </table>\n        </div>\n    </div>\n</div>";
},"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist6"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <tr>\n                        <td class=\"perso-loading-table\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</td>\n                    </tr>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                            <tr>\n                                <td>\n                                    <span class=\"perso-td-date\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                                <td >\n                                    <span class=\"perso-td-transaction\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                                <td  class=\"rightAlign\">\n                                       <span class=\"perso-td-amount-balance perso-td-amount\">\n                                           "
    + ((stack1 = alias1((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + "\n                                       </span>\n                                </td>\n                            </tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <table class=\"pstory-table pstory-table-txlist6\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            </table>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-pstory-title"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"pstory-title-outer-wrapper\">\n    <div class=\"pstory-title-wrapper pstory-fixed\">\n        <div class=\"pstory-title\">\n            <input aria-label=\""
    + container.escapeExpression(((helper = (helper = helpers.backButtonText || (depth0 != null ? depth0.backButtonText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"backButtonText","hash":{},"data":data}) : helper)))
    + "\" type=\"button\" class=\"pstory-title-close\"/>\n            <div role=\"heading\" aria-level=\"1\" class=\"pstory-title-text\">"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n        </div>\n    </div>\n</div>\n<div id=\"story-frame-container\"></div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector-inner-card"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return container.escapeExpression(((helper = (helper = helpers.image || (depth0 != null ? depth0.image : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    var helper;

  return container.escapeExpression(((helper = (helper = helpers.type || (depth0 != null ? depth0.type : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data}) : helper)));
},"5":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <span class=\"perso-account-number\" aria-label=\""
    + alias4(((helper = (helper = helpers.numberPrefAccessibility || (depth0 != null ? depth0.numberPrefAccessibility : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberPrefAccessibility","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
    + ".\">..."
    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <span class=\"pstory-button-txt perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.text2 || (depth0 != null ? depth0.text2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"card card_"
    + alias4(((helper = (helper = helpers.typeImage || (depth0 != null ? depth0.typeImage : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"typeImage","hash":{},"data":data}) : helper)))
    + " cards"
    + alias4(((helper = (helper = helpers.numCards || (depth0 != null ? depth0.numCards : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numCards","hash":{},"data":data}) : helper)))
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"card-container\">\n        <div class=\"card-image\">\n                <div class=\"image "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.image : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\"></div>\n        </div>\n        <div class=\"perso-account-txt-wrapper\">\n            <span class=\"perso-account-name\" aria-label=\""
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + ".\">"
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + "</span>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n        <div id=\"pop-"
    + alias4(container.lambda(depth0, depth0))
    + "\" class=\"pstory-button-txt-wrapper\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.text2 : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            <span class=\"pstory-button-txt\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector-new"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "pstory-tabs";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "                <div class=\"overlay overlay-all\"></div>\n                <div class=\"overlay overlay-choose\"></div>\n                <div class=\"header-container\">\n                    <div class=\"pstory-tab-animated-border-bottom\"></div>\n                    <ul class=\"tablist\" role=\"tablist\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.headersArray : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                    </ul>\n                </div>\n            <div class=\"carousel-outer-wrapper collapse\">\n            <div class=\"carousel-animate options-container carousel-wrapper pstory-show-header-tabs\">\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "                            <li class=\"pstory-header-button\" "
    + ((stack1 = helpers["if"].call(alias1,(depths[1] != null ? depths[1].isDesktopMode : depths[1]),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " role=\"tab\" data-all=\""
    + container.escapeExpression(((helper = (helper = helpers.isAll || (depth0 != null ? depth0.isAll : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"isAll","hash":{},"data":data}) : helper)))
    + "\"\n                                "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isAll : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</li>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return " tabindex=\"0\" aria-label=\""
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" ";
},"7":function(container,depth0,helpers,partials,data) {
    return "pstory-id=\"all\" ";
},"9":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"carousel-outer-wrapper collapse\">\n            <div class=\"carousel-animate options-container carousel-wrapper\">\n";
},"11":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                    <div class=\"carousel-item pstory-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" aria-hidden=\"true\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\"\n                         role=\""
    + alias4(container.lambda((depths[1] != null ? depths[1].role : depths[1]), depth0))
    + "\">\n                        "
    + ((stack1 = helpers["if"].call(alias1,(depths[1] != null ? depths[1].isDesktopMode : depths[1]),{"name":"if","hash":{},"fn":container.program(14, data, 0, blockParams, depths),"inverse":container.program(16, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "\n                    </div>\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "selected";
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return " "
    + ((stack1 = container.invokePartial(partials.innerCardDesktop,depth0,{"name":"innerCardDesktop","hash":{"numberPrefAccessibility":(depths[1] != null ? depths[1].numberPrefAccessibility : depths[1]),"numberPref":(depths[1] != null ? depths[1].numberPref : depths[1])},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n                        ";
},"16":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return " "
    + ((stack1 = container.invokePartial(partials.innerCard,depth0,{"name":"innerCard","hash":{"numberPrefAccessibility":(depths[1] != null ? depths[1].numberPrefAccessibility : depths[1]),"numberPref":(depths[1] != null ? depths[1].numberPref : depths[1])},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                <div class=\"carousel-index-wrapper\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n                    <div class=\"carousel-index-container\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                    </div>\n                </div>\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " role=\"application\" aria-labelledby=\"perso-accessibility-read-"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.id : stack1), depth0))
    + "\"\n                ";
},"21":function(container,depth0,helpers,partials,data) {
    return "                            <div class=\"carousel-index-dot\">\n                                <div class=\"carousel-index-dot-circle\"></div>\n                            </div>\n";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                   <div class=\"pstory-all-accounts-txt\" role=\"text\">\n                        <span class=\"perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt || (depth0 != null ? depth0.allAccountsTxt : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"allAccountsTxt","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.allAccountsTxt2 : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                    </div>\n";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "                        <span class=\"perso-amount-wrapper\">"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt2 || (depth0 != null ? depth0.allAccountsTxt2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"allAccountsTxt2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"26":function(container,depth0,helpers,partials,data) {
    return "\n                   tabindex=\"-1\" ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"perso-accessibility-wrapper perso-accessibility-account-selector\" role=\"text\">\n    <span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountSelectorText || (depth0 != null ? depth0.accountSelectorText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountSelectorText","hash":{},"data":data}) : helper)))
    + "</span>\n</div>\n<div id=\"pstory-block-account-selector_"
    + alias4(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-block-frame pstory-block-account-selector "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\" data-show-header-tabs="
    + alias4(((helper = (helper = helpers.showHeaderTabs || (depth0 != null ? depth0.showHeaderTabs : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"showHeaderTabs","hash":{},"data":data}) : helper)))
    + ">\n    <div class=\"pstory-block-container "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaderTabs : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n        <div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaderTabs : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.program(9, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            <div class=\"carousel-inner-wrapper cards-wrapper\" aria-hidden=\"true\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            </div>\n\n            <div class=\"perso-accessibility-wrapper pstory-account-button selected\" role=\"text\">\n                <span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountName || (depth0 != null ? depth0.accountName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountName","hash":{},"data":data}) : helper)))
    + ". "
    + alias4(((helper = (helper = helpers.numberPrefAccessibility || (depth0 != null ? depth0.numberPrefAccessibility : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberPrefAccessibility","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.accountNumber || (depth0 != null ? depth0.accountNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountNumber","hash":{},"data":data}) : helper)))
    + "</span>\n            </div>\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showIndexDots : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaderTabs : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n            <input type=\"button\" class=\"pstory-account-button pstory-prev-account-button\" aria-label=\""
    + alias4(((helper = (helper = helpers.prev || (depth0 != null ? depth0.prev : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"prev","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " />\n            <input type=\"button\" class=\"pstory-account-button pstory-next-account-button\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "/>\n        </div>\n            <div class=\"pstory-comment\">"
    + ((stack1 = ((helper = (helper = helpers.comment || (depth0 != null ? depth0.comment : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"comment","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n        </div>\n        </div>\n        </div>";
},"usePartial":true,"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-buttons-new"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.navigateTarget : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                    <a id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-link-navigateTo button-animation pstory-button ripple-closed\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pnavigate-id=\""
    + alias4(((helper = (helper = helpers.navigateTarget || (depth0 != null ? depth0.navigateTarget : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"navigateTarget","hash":{},"data":data}) : helper)))
    + "\" >"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</a>\n";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.toggleState : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.program(8, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                        <input type=\"button\" class=\"pstory-button pstory-toggle-button "
    + alias4(((helper = (helper = helpers.toggleState || (depth0 != null ? depth0.toggleState : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"toggleState","hash":{},"data":data}) : helper)))
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" value=\""
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pstory-type-text=\"Toggle "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.toggleState || (depth0 != null ? depth0.toggleState : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"toggleState","hash":{},"data":data}) : helper)))
    + "\"/>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "selected";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? depths[1].typeRadio : depths[1]),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.program(12, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                            <div class=\"pstory-radio-button-wrapper\">\n                                <div class=\"pstory-button button-animation pstory-radio-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "  ripple-closed\" tabindex=\"0\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" action-id=\""
    + alias4(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\">\n                                    <input id=\"pstory-radio-"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" name=\"radio-"
    + alias4(container.lambda((depths[1] != null ? depths[1].id : depths[1]), depth0))
    + "\" type=\"radio\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "/>\n                                    <label for=\"pstory-radio-"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" role=\"text\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</label>\n                                </div>\n                            </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "checked";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=helpers.helperMissing, alias4="function";

  return "                            <button id=\"pop-"
    + alias1(container.lambda(depth0, depth0))
    + "\" class=\"pstory-button pstory-regular-button "
    + ((stack1 = helpers["if"].call(alias2,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " ripple-closed\" action-id=\""
    + alias1(((helper = (helper = helpers.action || (depth0 != null ? depth0.action : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"action","hash":{},"data":data}) : helper)))
    + "\" pstory-type-text=\"Button "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" pstory-id=\""
    + alias1(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias1(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"event","hash":{},"data":data}) : helper)))
    + "\">\n                                "
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n                            </button>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div id=\"pstory-block-buttons_"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-block-frame pstory-block-buttons "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + " pstory-block-buttons-"
    + alias4(((helper = (helper = helpers.buttonType || (depth0 != null ? depth0.buttonType : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"buttonType","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n    </div>\n</div>";
},"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-month-picker"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <li class=\"perso-month-picker-item\" pstory-category=\""
    + alias4(((helper = (helper = helpers.category || (depth0 != null ? depth0.category : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"category","hash":{},"data":data}) : helper)))
    + "\" role=\"tab\" aria-label=\""
    + alias4(((helper = (helper = helpers.accLabel || (depth0 != null ? depth0.accLabel : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accLabel","hash":{},"data":data}) : helper)))
    + "\">"
    + alias4(((helper = (helper = helpers.displayLabel || (depth0 != null ? depth0.displayLabel : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"displayLabel","hash":{},"data":data}) : helper)))
    + "</li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"perso-month-picker-outer-wrapper\">\n    <div class=\"perso-month-picker-wrapper bars_"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.series : depth0)) != null ? stack1.length : stack1), depth0))
    + "\">\n\n        <ul class=\"perso-month-picker-container\" role=\"tablist\">\n            <div class=\"pstory-month-picker-selected-tab\"></div>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </ul>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pie-chart-open-bank"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-pie-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\" tabindex=\"0\">\n            <div class=\"pstory-pie-chart\">\n                <div class=\"pieCircle\"></div>\n            </div>\n            <div class=\"pstory-pie-data\">\n                <input type=\"button\" class=\"pstory-arrow pstory-next-arrow\" tabindex=\"-1\" aria-label=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.nextCategory : stack1), depth0))
    + "\" />\n                <div class=\"pstory-pie-info perso-accessibility-wrapper\" role=\"text\">\n                </div>\n                <input type=\"button\" class=\"pstory-arrow pstory-previous-arrow\" tabindex=\"-1\" aria-label=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.previousCategory : stack1), depth0))
    + "\" />\n                <div class=\"carousel-animate carousel-wrapper\">\n                    <div class=\"carousel-index-wrapper\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pure-bar-chart"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return container.escapeExpression(((helper = (helper = helpers.mode || (depth0 != null ? depth0.mode : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"mode","hash":{},"data":data}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    return "Out";
},"5":function(container,depth0,helpers,partials,data) {
    return "perso-comparable-chart";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " "
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " ";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\n                            <div class=\"perso-series-wrapper\">\n                                <div class=\"perso-series\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                                </div>\n                            </div>\n                            ";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                                    <div class=\"perso-bar-wrapper\">\n                                        <div class=\"perso-bar"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" pstory-category=\""
    + container.escapeExpression(((helper = (helper = helpers.category || (depth0 != null ? depth0.category : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"category","hash":{},"data":data}) : helper)))
    + "\"></div>\n                                    </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return " selected";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\n                            \n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " ";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                            <div class=\"perso-bar-wrapper simple-bar\">\n                                <div class=\"perso-bar "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.program(16, data, 0),"data":data})) != null ? stack1 : "")
    + " pstory-category=\""
    + container.escapeExpression(((helper = (helper = helpers.category || (depth0 != null ? depth0.category : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"category","hash":{},"data":data}) : helper)))
    + "\"></div>\n                            </div>\n                            ";
},"14":function(container,depth0,helpers,partials,data) {
    return "selected\" aria-selected=\"true\" ";
},"16":function(container,depth0,helpers,partials,data) {
    return " \"";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "                                <div class=\"perso-amount-labels-wrapper \">\n                                    <span class=\"perso-amount-label \">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.lblMoneyIn : stack1), depth0))
    + "</span>\n                                    <span class=\"perso-amount-label \">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.lblMoneyOut : stack1), depth0))
    + "</span>\n                                </div> \n                                <div class=\"perso-month-amount \"></div>\n";
},"20":function(container,depth0,helpers,partials,data) {
    return "                                <div class=\"perso-month-amount \"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-bar-chart pure-bar-chart "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.direction || (depth0 != null ? depth0.direction : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"direction","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-bar-chart "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.mode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = container.invokePartial(partials.monthPicker,depth0,{"name":"monthPicker","data":data,"indent":"                ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "                <div class=\"perso-bar-chart-wrapper perso-accessibility-wrapper "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSeries : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" role=\"text\">\n                    <span class=\"perso-accessibility-read perso-accessibility-bar-seleced-text\"></span>\n                    <span class=\"perso-tooltip\"></span>\n                    <div class=\"perso-bar-chart-container\">\n                        <div class=\"x-axis\"></div>\n                        <div class=\"perso-bars-wrapper\">\n                            "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSeries : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(12, data, 0),"data":data})) != null ? stack1 : "")
    + "\n                        </div>\n                    </div>\n                </div>\n                                        <div class=\"perso-month-amount-wrapper \">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSeries : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.program(20, data, 0),"data":data})) != null ? stack1 : "")
    + "                        </div>\n            </div>\n        </div>\n    </div>\n</div>";
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pure-pinGraph-chart"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return container.escapeExpression(((helper = (helper = helpers.mode || (depth0 != null ? depth0.mode : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"mode","hash":{},"data":data}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    return "Out";
},"5":function(container,depth0,helpers,partials,data) {
    return "                        <div class=\"perso-pinGraph-raw\" >\n                            <div class=\"perso-raw-wrapper\" role=\"text\">\n                                <span class=\"perso-raw-item perso-date-txt\"></span>\n                                <div class=\"perso-raw-item perso-bar-wrapper\">\n                                    <span class=\"perso-pinGraph-bar\"></span>\n                                    <span class=\"perso-raw-item perso-pinGraph-amount\"></span>\n                                </div>\n                            </div>\n                        </div>\n                        <div aria-hidden=\"true\"></div><!--it's required for accessibility-->\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-pinGraph-chart_"
    + alias4(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + " pstory-block-pinGraph-chart "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-pinGraph-chart "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.mode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\">\n                <div class=\"perso-pinGraph-container\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.series : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                </div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist1-new"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <div class=\"perso-table-row\">\n                        <div class=\"perso-loading-tbl\">\n                            <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</span>\n                        </div>\n                    </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda;

  return "                        <div class=\"perso-table-row\">\n                              <div class=\"perso-col perso-td-icon "
    + container.escapeExpression(((helper = (helper = helpers.category || (depth0 != null ? depth0.category : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"category","hash":{},"data":data}) : helper)))
    + " "
    + ((stack1 = alias2((depth0 != null ? depth0.mode : depth0), depth0)) != null ? stack1 : "")
    + "\">\n                        </div>\n                            <div class=\"perso-col left-col\">\n                                <div class=\"perso-row upper-row\">"
    + ((stack1 = alias2((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.card : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "                            </div>\n                            <div class=\"perso-col right-col\">\n                                <div class=\"perso-amount-container\"> "
    + ((stack1 = alias2((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                                 <div class=\"perso-row lower-row\">"
    + ((stack1 = alias2((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                            </div>\n                        </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                                <div class=\"perso-row lower-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.programId : depth0), depth0)) != null ? stack1 : "")
    + "..."
    + ((stack1 = alias1((depth0 != null ? depth0.card : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                                <div class=\"perso-row lower-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.programId : depth0), depth0)) != null ? stack1 : "")
    + "..."
    + ((stack1 = alias1((depth0 != null ? depth0.accountNumber : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table with-icons\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-table pstory-table-new-txlist1 with-icons\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            </div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist2"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    <div class=\"perso-table-row\">\n                        <div class=\"perso-loading-tbl\">\n                            <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.loading : stack1), depth0))
    + "</span>\n                        </div>\n                    </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                     <div class=\"perso-table-row\">\n                            <div class=\"perso-col left-col\">\n                                <div class=\"perso-row upper-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.card : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "")
    + "                            </div>\n                            <div class=\"perso-col right-col\">\n                                <div class=\"perso-amount-container\"> "
    + ((stack1 = alias1((depth0 != null ? depth0.amount : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                                 <div class=\"perso-row lower-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n                            </div>\n                        </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                                    <div class=\"perso-row lower-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.programId : depth0), depth0)) != null ? stack1 : "")
    + "..."
    + ((stack1 = alias1((depth0 != null ? depth0.card : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                                    <div class=\"perso-row lower-row\">"
    + ((stack1 = alias1((depth0 != null ? depth0.programId : depth0), depth0)) != null ? stack1 : "")
    + "..."
    + ((stack1 = alias1((depth0 != null ? depth0.accountNumber : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-table pstory-table-new-txlist1\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            </div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-rating"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"perso-ratings-wrapper\">\n   <div class='perso-ratings-text'>"
    + alias4(((helper = (helper = helpers.ratingTitle || (depth0 != null ? depth0.ratingTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ratingTitle","hash":{},"data":data}) : helper)))
    + "</div>\n    <div class=\"perso-ratings-yes-no\">\n        <div class=\"perso-ratings-box perso-ratings-box-yes\" data-val=\"4\">\n           <div class=\"perso-rating-yes-icon\">"
    + alias4(((helper = (helper = helpers.ratingYes || (depth0 != null ? depth0.ratingYes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ratingYes","hash":{},"data":data}) : helper)))
    + "</div>\n            <div class=\"perso-rating-yes-text\"></div>\n        </div><div class=\"perso-ratings-box perso-ratings-box-no\" data-val=\"2\">\n            <div class=\"perso-rating-no-icon\">"
    + alias4(((helper = (helper = helpers.ratingNo || (depth0 != null ? depth0.ratingNo : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ratingNo","hash":{},"data":data}) : helper)))
    + "</div>\n            <div class=\"perso-rating-no-text\"></div>\n        </div>\n    </div>\n</div>\n\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["doubleBox"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"pstory-block-hbox-columns-frame teaser-body\" aria-hidden=\"true\">\n        <div class=\"pstory-hbox-column-frame\" data-width=\"6\">\n\n            <div class=\"pstory-hbox-column-frame perso-double-box perso-double-box-left\" data-v-align=\"middle\" data-width=\"12\">\n                <div class=\"perso-double-box-container\">\n                    <div class=\"pstory-block-frame pstory-block-text\">\n                        <div class=\"pstory-block-content perso-double-box-value "
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0["box-value1"] : depth0)) != null ? stack1.isDate : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n                            "
    + ((stack1 = alias2(((stack1 = (depth0 != null ? depth0["box-value1"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                        </div>\n                    </div>\n                    <div class=\"pstory-block-frame pstory-block-text\">\n                        <div class=\"pstory-block-content perso-double-box-text\">\n                            "
    + ((stack1 = alias2(((stack1 = (depth0 != null ? depth0["box-label1"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n        <div class=\"pstory-hbox-column-frame\" data-width=\"6\">\n\n            <div class=\"pstory-hbox-column-frame perso-double-box perso-double-box-right\" data-v-align=\"middle\" data-width=\"12\">\n                <div class=\"perso-double-box-container\">\n                    <div class=\"pstory-block-frame pstory-block-text\">\n                        <div class=\"pstory-block-content perso-double-box-value "
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0["box-value2"] : depth0)) != null ? stack1.isDate : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n                            "
    + ((stack1 = alias2(((stack1 = (depth0 != null ? depth0["box-value2"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                        </div>\n                    </div>\n                    <div class=\"pstory-block-frame pstory-block-text\">\n                        <div class=\"pstory-block-content perso-double-box-text\">\n                            "
    + ((stack1 = alias2(((stack1 = (depth0 != null ? depth0["box-label2"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "perso-double-box-value-date";
},"4":function(container,depth0,helpers,partials,data) {
    return " perso-double-box-value-date ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["horizontalBar"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"pstory-block-hbox-columns-frame teaser-body\" aria-hidden=\"true\">\n        <div class=\"pstory-hbox-column-frame\" data-width=\"12\" id=\""
    + alias1(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.chart : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"></div>\n    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["horizontalBarAndBox"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"pstory-block-hbox-columns-frame teaser-body\" aria-hidden=\"true\">\n        <div class=\"pstory-hbox-column-frame\" data-width=\"8\">\n            <div id=\""
    + alias1(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.chart : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"></div>\n        </div>\n\n        <div class=\"pstory-hbox-column-frame left-separator\" data-width=\"4\" data-v-align=\"middle\">\n            <div class=\"pstory-block-hbox-columns-frame\">\n                <div class=\"pstory-block-frame pstory-block-text\">\n                    <div class=\"pstory-block-content\">\n                        "
    + ((stack1 = alias2(((stack1 = (depth0 != null ? depth0["box-label"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                    </div>\n                </div>\n                <div class=\"pstory-block-frame pstory-block-text perso-percent-small\">\n                    <div class=\"pstory-block-content\">\n                        <span class=\"pluse\">+</span>\n                            "
    + ((stack1 = alias2(((stack1 = (depth0 != null ? depth0["box-value"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["image"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"teaser-body\" aria-hidden=\"true\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0["main-image"] : depth0)) != null ? stack1.isAbsoluteURL : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "        <img src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0["main-image"] : depth0)) != null ? stack1.absUrl : stack1), depth0))
    + "\" alt=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0["main-image"] : depth0)) != null ? stack1.alt : stack1), depth0))
    + "\" title=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0["main-image"] : depth0)) != null ? stack1.alt : stack1), depth0))
    + "\" />\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "        <div class=\"image "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0["main-image"] : depth0)) != null ? stack1.absUrl : stack1), depth0))
    + "\" title=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0["main-image"] : depth0)) != null ? stack1.alt : stack1), depth0))
    + "\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["imageAndBox"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"pstory-block-hbox-columns-frame teaser-body\" aria-hidden=\"true\">\n        <div class=\"pstory-hbox-column-frame\" data-width=\"6\">\n            <img src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.image : depth0)) != null ? stack1.url : stack1), depth0))
    + "\" alt=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.image : depth0)) != null ? stack1.alt : stack1), depth0))
    + "\" title=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0["main-image"] : depth0)) != null ? stack1.alt : stack1), depth0))
    + "\" style=\"max-height: 100%; max-width: 100%\" />\n        </div>\n        <div class=\"pstory-hbox-column-frame\" data-v-align=\"middle\" data-width=\"6\">\n            \n            <div class=\"pstory-block-hbox-columns-frame\">\n\n                <div class=\"pstory-block-frame pstory-block-text\">\n                    <div class=\"pstory-block-content\">\n                        "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0["box-label"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                    </div>\n                </div>\n                <div class=\"pstory-block-frame pstory-block-text perso-percent-large\">\n                    <div class=\"pstory-block-content\">\n                        "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0["box-value"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                    </div>\n                </div>\n\n            </div>\n        </div>\n    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["lineChart"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"pstory-block-hbox-columns-frame teaser-body\" aria-hidden=\"true\">\n        <div class=\"pstory-hbox-column-frame\" data-width=\"12\" id=\""
    + alias1(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.chart : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"></div>\n    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pie"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"pstory-block-hbox-columns-frame teaser-body\" aria-hidden=\"true\">\n        <div class=\"pstory-hbox-column-frame\" data-width=\"4\">\n            <div id=\""
    + alias4(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.chart1 : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"></div>\n\n            <div class=\"pstory-block-frame pstory-block-text perso-pie-text block-title\">\n                <div class=\"pstory-block-content\">\n                    "
    + ((stack1 = alias5(((stack1 = (depth0 != null ? depth0.label1 : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                </div>\n            </div>\n\n        </div>\n        <div class=\"pstory-hbox-column-frame\" data-width=\"4\">\n            <div id=\""
    + alias4(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.chart2 : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"></div>\n\n            <div class=\"pstory-block-frame pstory-block-text perso-pie-text block-title\">\n                <div class=\"pstory-block-content\">\n                    "
    + ((stack1 = alias5(((stack1 = (depth0 != null ? depth0.label2 : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                </div>\n            </div>\n        </div>\n        <div class=\"pstory-hbox-column-frame\" data-width=\"4\">\n            <div id=\""
    + alias4(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.chart3 : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"></div>\n\n            <div class=\"pstory-block-frame pstory-block-text perso-pie-text block-title\">\n                <div class=\"pstory-block-content\">\n                    "
    + ((stack1 = alias5(((stack1 = (depth0 != null ? depth0.label3 : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                </div>\n            </div>\n        </div>\n    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pinChart"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"teaser-body\" id=\""
    + alias1(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.chart : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"  aria-hidden=\"true\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["simpleText"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["teaserHeader"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"teaser-header\" aria-hidden=\"true\">\n    <div class=\"teaser-top\">\n        <div class=\"pstory-block-frame pstory-block-date-box\">\n            <div class=\"pstory-block-content\">\n                <div class=\"perso-teaser-date pstory-block-date-month\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.date : depth0)) != null ? stack1.month : stack1), depth0))
    + "</div>\n                <div class=\"perso-teaser-date pstory-block-date-day\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.date : depth0)) != null ? stack1.day : stack1), depth0))
    + "</div>\n            </div>\n        </div>\n        <div class=\"pstory-block-frame pstory-block-text insight-title-text block-title\">\n            <div class=\"pstory-block-content\">\n                "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0.title : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n            </div>\n        </div>\n    </div>\n\n    <div class=\"pstory-block-frame pstory-block-text teaser-text\">\n        <div class=\"pstory-block-content\">\n           "
    + ((stack1 = alias1(((stack1 = (depth0 != null ? depth0["teaser-text"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["teaserWrapperPartial"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "perso-highlighted";
},"3":function(container,depth0,helpers,partials,data) {
    return "not ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;

  return "<div class=\"perso-teaser-template perso-teaser-template-bar-box perso-"
    + alias4(((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"status","hash":{},"data":data}) : helper)))
    + "  "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.highlighted : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" id=\"perso-teaser-template_"
    + alias4(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"insightId","hash":{},"data":data}) : helper)))
    + "\"\n role=\"button\" aria-label=\""
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.date : depth0)) != null ? stack1.month : stack1), depth0))
    + " "
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.date : depth0)) != null ? stack1.day : stack1), depth0))
    + ". "
    + alias4(alias5(((stack1 = (depth0 != null ? depth0.title : depth0)) != null ? stack1.text : stack1), depth0))
    + ". "
    + alias4(((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"status","hash":{},"data":data}) : helper)))
    + ". "
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.highlighted : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "highlighted. "
    + ((stack1 = alias5(((stack1 = (depth0 != null ? depth0["teaser-text"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\">\n    <div class=\"perso-teaser-template-inner\">\n"
    + ((stack1 = container.invokePartial(partials["@partial-block"],depth0,{"name":"@partial-block","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n</div>";
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["textAndButton"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"teaser-body\" aria-hidden=\"true\">\n        <div id=\"pstory-block-buttons_"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.buttons : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\" class=\"pstory-block-frame pstory-block-buttons\">\n            <div class=\"pstory-block-content\">\n                <a href=\"#!\" class=\"pstory-link-navigateTo pstory-button ripple-closed\" pnavigate-id=\""
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.buttons : depth0)) != null ? stack1.options : stack1)) != null ? stack1["0"] : stack1)) != null ? stack1.navigateTarget : stack1), depth0))
    + "\" >"
    + ((stack1 = alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? depth0.buttons : depth0)) != null ? stack1.options : stack1)) != null ? stack1["0"] : stack1)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "</a>\n            </div>\n        </div>\n    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["txList"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"teaser-body\" id=\""
    + alias1(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.txList : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"  aria-hidden=\"true\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["verticalBar"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"teaser-body\" id=\""
    + alias1(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.chart : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"  aria-hidden=\"true\"></div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["verticalBarAndBox"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;

  return ((stack1 = container.invokePartial(partials.teaserHeader,depth0,{"name":"teaserHeader","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <div class=\"pstory-block-hbox-columns-frame teaser-body\" aria-hidden=\"true\">\n        <div class=\"pstory-hbox-column-frame\" data-width=\"7.5\">\n            <div id=\""
    + alias1(((helper = (helper = helpers.insightId || (depth0 != null ? depth0.insightId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"insightId","hash":{},"data":data}) : helper)))
    + "_"
    + alias1(alias2(((stack1 = (depth0 != null ? depth0.chart : depth0)) != null ? stack1.blockId : stack1), depth0))
    + "\"></div>\n        </div>\n        <div class=\"pstory-hbox-column-frame\" data-width=\"4.5\">\n            <!--<div class=\"pstory-block-hbox-columns-frame\">-->\n\n            <div class=\"pstory-hbox-column-frame left-separator\" data-v-align=\"middle\" data-width=\"12\">\n                <div class=\"pstory-block-frame pstory-block-text\">\n                    <div class=\"pstory-block-content\">\n                        "
    + ((stack1 = alias2(((stack1 = (depth0 != null ? depth0["box-label"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                    </div>\n                </div>\n                <div class=\"pstory-block-frame pstory-block-text perso-percent-large\">\n                    <div class=\"pstory-block-content\">\n                        "
    + ((stack1 = alias2(((stack1 = (depth0 != null ? depth0["box-value"] : depth0)) != null ? stack1.text : stack1), depth0)) != null ? stack1 : "")
    + "\n                    </div>\n                </div>\n            </div>\n\n        </div>\n    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.teaserWrapperPartial,depth0,{"name":"teaserWrapperPartial","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});})(window, window.Personetics = window.Personetics || {}, jQuery, window.Personetics.UI.Handlebars);


(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.BlockChartFactory = new function (){
        this.chartHelperFactoryMap = {};

        this.registerChartHelper = function(type, config){
            if(config.hasOwnProperty('helperClass')) {
                if (config.helperClass) {
                    // from cache
                    var entry = this.chartHelperFactoryMap[type];
                    if (!entry) {
                        entry = {
                            type: type,	// helper type
                            class: {},	// additional helpers based on css class
                            widthModes: {} // additional helpers based on screen width
                        };
                        this.chartHelperFactoryMap[type] = entry;
                    }
                    // map helper by class or by more specific css class
                    if (config.class) {
                        entry.class[config.class] = config.helperClass;
                    }
                    // map helper by width mode
                    //TODO: what happens when both width mode and css class are specified?
                    else if (config.widthMode) {
                        entry.widthModes[config.widthMode] = config.helperClass;
                    }
                    // default helper mapping
                    else {
                        entry.helperClass = config.helperClass;
                    }
                }
            }
            // backwards compatibility
            else{
                 this.chartHelperFactoryMap[type] = config;
            }
        };

        this.generateHelperClazz = function (name, config) {          
            var generatedChartHelper = null;
            if(typeof (name) !== "undefined" && name != null && this.chartHelperFactoryMap.hasOwnProperty(name)){
                var chartHelperClass = this.chartHelperFactoryMap[name].helperClass;
                if (config.hasOwnProperty("widthMode") && typeof config.widthMode !== 'undefined' && config.widthMode !== null &&
					config.widthMode.length > 0 && this.chartHelperFactoryMap[name].widthModes[config.widthMode] != undefined){
                    var chartHelperClass = this.chartHelperFactoryMap[name].widthModes[config.widthMode];
                }
                generatedChartHelper = new chartHelperClass(config);
                    
            } else {
                Personetics.log('The helper' + name + 'is not valid');
            }
            return generatedChartHelper;
        };
    };
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.BlockHelperBase = Base.extend({
        prepareChart: function (data, options) {
            this.options = options;
            this.width = this.getValueByScreenWidth(this.options.svgWidth);
        },

        renderSVGBase: function(el, clazz){
            var helper = this;
            if(!clazz){
                clazz = '';
            }
            return(d3.select(el.get(0)).append("svg")
                .attr("class","perso-svg-chart-container " + clazz)
                .attr("width", helper.width)
                .attr("height", helper.getValueByScreenWidth(helper.options.svgHeight))
                .append("g")
                .attr("transform", "translate(0,0)"));
        },
        renderLabels: function(){
            var helper = this;
            if(this.options.labels.drawLabels) {
                this.svg.append("g")
                    .selectAll()
                    .data(helper.seriesData)
                    .enter()
                    .append("text")
                    .attr("class", "perso-label")
                    .attr("class", function(d){
                        var clazz = 'perso-label';
                        if(d.selected){
                            clazz +=" selected";
                        }
                        return clazz;
                    })
                    .attr("text-anchor", "middle")
                    .attr("x", function (d, i) {
                        return helper.xScale(helper.categoriesData[i]) + helper.xScale.rangeBand() / 2;
                    })
                    .attr("y", function (d) {
                        var margin = (this.options.labels.marginBottom > 0) ? this.options.labels.marginBottom : 0;
                        return helper.yScale(d.value) - margin;
                    })
                    .html(function (d) {
                        return d.label;
                    });
            }
        },
        renderXAxis: function(){
            var helper = this;
            if (this.xAxis) {
                this.svg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", function(d,i){
                        var x = 0 ;
                        var y = 0;                      
                        if(helper.options.axis.translation.x){
                            x = helper.options.axis.translation.x;
                        }
                        if(helper.options.axis.translation.y == "height"){
                            y += (helper.height + helper.margin.bottom);
                        }
                        return ("translate("+ x + "," + y + ")");
                    })
                    .call(helper.xAxis);
            }
        },
        wrapLabelText: function(text) {
            text.each(function() {
                var text = d3.select(this),
                    words = [],//text.text().split(/\s+/).reverse(),
                    word,
                    lineNumber = 0,
                    lineHeight = 0.8, // ems
                    y = text.attr("y"),
                    dy = parseFloat(text.attr("dy"));
                    if(text.text().match(/\d+/g) != null)
                        words[0] = text.text().match(/\d+/g)[0];
                    if(text.text().match(/[a-zA-Z]+/) != null)
                        words[1] = text.text().match(/[a-zA-Z]+/)[0];
                    text.text(null);
                    while (word = words.pop()) { 
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", (lineNumber * lineHeight * 1.5 + dy) + "em");
                        tspan.text(word);
                        lineNumber++;
                    }
            });
        },
        renderYAxis: function(isNegative){
            var helper = this;
            if (this.options.yAxisLineDisplay) {               
                this.svg.append("g")
                    .attr("class", "y axis perso-grid")
                    .attr("transform", function(d,i){
                        var y = typeof helper.options.yAxisTop != 'undefined'? helper.options.yAxisTop: 0;
                        if(typeof isNegative === 'boolean' && isNegative){
                            y = helper.negativeYAxisTop;
                        }
                        var x = typeof helper.options.horizontalLineLeft != 'undefined'? helper.options.horizontalLineLeft: 0;
                        return ("translate(" + helper.getValueByScreenWidth(x) + "," + helper.getValueByScreenWidth(y) + ")");
                    })
                    .call(helper.yAxis)
                    .selectAll(".tick line")
                    .attr('x2', function(d,i){
                        var x2 = typeof helper.options.horizontalLineWidth != 'undefined'? helper.options.horizontalLineWidth: (helper.options.svgWidth || 0);
                        return helper.getValueByScreenWidth(x2);
                    });
            }
            if(!this.options.yAxisTextDisplay){
                this.svg.selectAll(".y.perso-grid .tick text" ).remove();
                this.svg.selectAll(".y.perso-grid path" ).remove();
            }

        },
        renderHorizontalLines: function (y0Scale) {
            var helper = this;
            var lines = this.svg.append("g")
                .attr("transform","translate("+ helper.margin.left *-1 +"," + 0 + ")")
                .selectAll("g")
                .data(helper.seriesData)
                .enter()
                .append("g")
                .attr("class","perso-chart-line")
                .attr("transform", function (d, i) {
                    var y = y1Scale(i)*(i+1);
                    return "translate(0," + y + ")";
                })
                .selectAll('.line')
                .data(function (d) {
                    return d
                })
                .enter().append("line")
                .attr("class","perso-chart-line")
                .attr("x1","0")
                .attr("x2",helper.width )//TODO - add line width to configs
                .attr("y1",function(d,i){
                    //return y0Scale(i);
                    return y0Scale(i) + helper.options.rectangles.paddingBottom;
                })
                .attr("y2",function(d,i){
                    //return y0Scale(i);
                    return y0Scale(i) + helper.options.rectangles.paddingBottom;
                })
        },
        renderVerticalLines: function (x0Scale) {
            var helper = this;
            if(helper.options.drowVerticalLines){
                var lineMarginLeft = helper.options.lineMarginLeft  ? helper.options.lineMarginLeft :-30;
                var lines = this.svg.append("g")
                    .attr("transform","translate("+ helper.getValueByScreenWidth(lineMarginLeft) +"," + helper.getValueByScreenWidth(helper.options.verticalLineTop) + ")")
                    .selectAll("g")
                    .data(helper.seriesData)
                    .enter()
                    .append("g")
                    .attr("class","perso-chart-line")
                    .attr("transform", function (d, i) {
                        return "translate(0,0)";
                    })
                    .selectAll('.line')
                    .data(function (d) {
                        return d
                    })
                    .enter().append("line")
                    .attr("class","perso-chart-line")
                    .attr("y1","0")
                    .attr("y2", helper.getValueByScreenWidth(helper.options.lineHeight) )
                    .attr("x1",function(d,i){
                        return x0Scale(i) + helper.getValueByScreenWidth(helper.options.rectangles.paddingBottom);
                    })
                    .attr("x2",function(d,i){
                        return x0Scale(i) + helper.getValueByScreenWidth(helper.options.rectangles.paddingBottom);
                    })
            }
        },
        renderGradient: function(){
            var gradients = this.options.rectangles.gradients;
            var defWithGradients = this.svg.append("defs");
            if(gradients){
                $.each(gradients, function(i, gradient){
                    if(gradient){
                        defWithGradients = defWithGradients.append("linearGradient")
                            .attr("id",gradient.id)
                            .attr("x1","0")
                            .attr("x2","0")
                            .attr("y1","0")
                            .attr("y2","1");
                            
                        $.each(gradient.stopColors, function(i,stopColor){
                            defWithGradients.append("stop")
                            .attr("offset",gradient.offset[i])
                            .attr("stop-color", stopColor);
                        })


                    }
                });
            }
        },
        renderFilter: function(){
            var filters = this.options.rectangles.filter;
            var svgWithFilters = this.svg.selectAll("defs");
            if(filters){
                $.each(filters, function(i, filter){
                    if(filter){
                        var filterSvg = svgWithFilters.append("filter")
                            .attr("id", filter.id)

                        filterSvg.append("feGaussianBlur")
                            .attr("in", filter.in)
                            .attr("stdDeviation",filter.stdDeviation)

                        filterSvg.append("feOffset")
                            .attr("dx", filter.dxOffset)
                            .attr("dy", filter.dyOffset)
                        var feMerge = filterSvg.append("feMerge")

                        feMerge.append("feMergeNode")

                        feMerge.append("feMergeNode")
                            .attr("in", filter.in);
                    }
                })
            }
        },
        getValueByScreenWidth: function(value){
            var screenWidth = $(window).width();
            if(screenWidth >= this.options.desktopScreenWidth){
                return value;
            }
            else{
                if (screenWidth < 347) {
                    return value;
                } else if (screenWidth >= 414) {
                    return value * this.options.screen.ratio_large;
                } else {
                    return value * this.options.screen.ratio_medium;
                }   
            }                 
        }
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.MultiVerticalChartHelper = Personetics.utils.d3Helpers.BlockHelperBase.extend({
        MIN_BAR_HEIGHT: 20,
        prepareChart: function (data, options, handleClick) {
            Personetics.utils.d3Helpers.BlockHelperBase.prototype.prepareChart.call(this, data, options); 
            var helper = this;
            this.handleClick = handleClick;
            this.seriesData = data.series;
            this.categoriesData = data.categories;
            this.seriesLabelsData = data.seriesLabels;
            this.series = data.series;

            this.rWidth = this.getValueByScreenWidth(options.rectangles.width);
            this.rPadding = this.getValueByScreenWidth(options.rectangles.paddingRight);
            this.rSpace = this.getValueByScreenWidth(options.rectangles.space);
            this.width = this.getValueByScreenWidth(options.svgWidth);

            var maxCategories = (this.width + this.rSpace)/(this.rWidth + this.rPadding +this.rSpace);
            this.numOfBars = this.categoriesData.length > maxCategories? Math.floor(maxCategories): this.categoriesData.length;
            this.left = (this.width - (this.numOfBars * (this.rWidth + this.rPadding) + (this.numOfBars - 1) * this.rSpace)) / 2;
            this.contentWidth = this.numOfBars * (this.rWidth + this.rPadding +this.rSpace);
            this.leftForScale = ((this.width - (this.numOfBars) * (this.rWidth + this.rPadding) - (this.numOfBars - 1) * this.rSpace -this.rSpace)   / 2);


            this.colorScale = d3.scale.ordinal().rangeRoundBands([0, this.width], .1);
            this.colors = this.colorScale.range(helper.options.palette);
            this.colorsLabels = d3.scale.ordinal().rangeRoundBands([0, this.width], .1).range(helper.options.paletteLabels);

            //D3 dispatcher
            this.dispatch = d3.dispatch("clickOnMonth");

            var dataLength = 0;
            this.seriesData.map(function(a) {dataLength += a.length; return a;});
            this.dataLength = dataLength;

            //x scales
            this.xScale = d3.scale.ordinal().domain(data.categories).rangeBands([0, this.contentWidth]);
            this.xLineScale = d3.scale.ordinal().domain(d3.range(data.categories.length)).rangeBands([0, this.contentWidth], 0);
            this.xAxis = d3.svg.axis()
                .scale(this.xScale)
                .outerTickSize(0);

            //y scales
            this.yScale = d3.scale.linear().range([(this.getValueByScreenWidth(this.options.maxBarHeight) - this.MIN_BAR_HEIGHT), 0], .1);
            this.yAxisScale = d3.scale.linear().range([this.getValueByScreenWidth(this.options.yAxisHeight), 0]);
        },
        renderChart: function (el) {
            var helper = this;
            this.yScale.domain([0, d3.max(helper.seriesData, function (d) {
                return d3.max(d, function (k) {
                    return k.value;
                });
            })]);

            this.modifyData();

            this.svg = this.renderSVGBase(el, "multiVertical");
            this.renderGradient();
            this.renderFilter();
            this.renderMultiVerticalBars();
            this.renderLabels();
            if(!this.options.doAnimations){
                this.options.barDelay = this.options.barDuration = this.options.labelDelay = this.options.labelDuration = 0;
                this.barAnimations();
            } 
            this.renderHiddenRects(this.seriesData);
            this.renderXAxis();
            this.renderVerticalLines(helper.xLineScale);

        },
        renderMultiVerticalBars: function () {
            var helper = this;
            // merge data to one array to get max and min value
            var mergedData = [].concat.apply([], this.seriesData);

            this.minValue = d3.min(mergedData, function (d) {
                return d.value || Infinity;
            });
            this.maxValue = d3.max(mergedData, function (d) {
                return d.value;
            });
            helper.sortedData = helper.sortData();
            this.blockWithBars = this.svg.append("g")
                .attr("transform", function (data, i) {
                    return "translate(" + helper.left + "," + helper.getValueByScreenWidth(helper.options.barTop) + ")";
                })
                .selectAll("g")
                .data(helper.sortedData)
                .enter().append("g")
                .style("fill", function (d, i) {
                    return helper.colors(i);
                })
                .attr("transform", function (d, i) {
                    return "translate(" + helper.getSeriesTranslateValue(i) + ",0)";
                })
                .selectAll("rect")
                .data(function (d) {
                    return d
                });

            this.blockWithBars.enter().append("rect")
                .attr("class", function (d) {
                    var clazz = 'perso-chart-rect' + ' ' + d.mode ;
                    if (d.selected) {
                        clazz += " selected";
                    }
                    return clazz;
                })
                .attr("y", this.getValueByScreenWidth(this.options.maxBarHeight))
                .attr("height", 0)
                .attr("x", function (d, i) {
                    return i * (helper.rWidth + helper.rPadding + helper.rSpace);
                })
                .attr("width", function (d, i) {
                    return helper.rWidth;
                })
                .attr("rx", function (d) {
                    var rx = (helper.options.rectangles.borderRadius.rx) ? helper.options.rectangles.borderRadius.rx : "0";
                    return helper.getValueByScreenWidth(rx);
                })
                .attr("ry", function (d) {
                    var ry = (helper.options.rectangles.borderRadius.ry) ? helper.options.rectangles.borderRadius.ry : "0";
                    return helper.getValueByScreenWidth(ry);
                })
                .on("click", function (obj, clickedItemIndex) {
                    if (typeof helper.handleClick == 'function'){
                        helper.handleClick(obj, clickedItemIndex);
                    }
                });
        },
        MultiVerticalBarsTransition: function (blockWithBars) {
            var helper = this;
            blockWithBars.transition()
                .duration(helper.options.barDuration)
                .delay(helper.options.barDelay)
                .attr("y", function (d) {
                    return helper.getBarsY(d);
                })
                .attr("height", function (d) {
                    return helper.getBarsHeight(d);
                });
        },
        getBarsHeight: function (d) {
            var helper = this;
            var currentValue = Math.abs(d.value);
            var barHeight = d.value? helper.getValueByScreenWidth(this.options.maxBarHeight) - this.yScale(currentValue):0;
            d.barHeight = barHeight;
            return barHeight;
        },
        getBarsY: function (d) {
            var yValue;
            if(d.value < 0){
                yValue = this.getValueByScreenWidth(this.options.maxBarHeight);
            } else{
                yValue = this.yScale(d.value);
            }
            return yValue;
        },
        renderLabels: function renderLabels() {
            var helper = this;
            helper.sortedData = helper.sortData();
            if (this.options.labels.drawLabels) {
                var cssClass = 'perso-label perso-label-fadeIn';
                if (this.categoriesData.length >= 4) {
                    cssClass += " minimize-font";
                }
                var blockWithBars = this.svg.append("g")
                    .attr("transform", function (d, i) {
                        var transValue = helper.getValueByScreenWidth(helper.options.labelTop);
                        return "translate(" + helper.leftForScale + "," + transValue + ")";
                    })
                    .selectAll("g")
                    .data(helper.sortedData)
                    .enter().append("g")
                    .style("fill", function (d, i) {
                        return helper.colorsLabels(i);
                    })
                    .attr("transform", function (d, i) {
                        var transValue = helper.getValueByScreenWidth(helper.options.nextLabelTop) * (!i);
                        return "translate(" + 0 + "," + transValue + ")";
                    })
                    .selectAll("text")
                    .data(function (d) {
                        return d;
                    });
                    
                this.labels = blockWithBars.enter()
                    .append("text")
                    .attr("text-anchor", "middle")
                    .attr("class", function (d) {
                        var clazz = cssClass + ' ' + d.mode; ;
                        if (d.selected) {
                            clazz += " selected";
                        }
                        return clazz;
                    })
                    .attr("x", function (d, i) {
                        return helper.xScale(helper.categoriesData[i]) + (helper.contentWidth / helper.dataLength);                    
                    })
                    .attr("y", function (d, i, j) {
                        var maxBarHeightInMonth = helper.getMaxBarHeightInMonth(helper.categoriesData[i]);
                        var yValue = helper.yScale(0) - maxBarHeightInMonth;
                        return (yValue);
                    })
                    .attr("dy", "0.4em");
                    
                // support IE
               
                $.each(helper.seriesLabelsData, function (modeIndex, mode) {

                    var amounts = helper.svg.selectAll('.perso-label.'+ mode);
                    var tspans = amounts.append('tspan');

                    $.each(tspans[0], function (index, tspan) {
                            var attrs = $(helper.seriesData[modeIndex][index].label)[0].attributes;
                            $.each(attrs, function (j, attr) {
                                tspan.setAttribute(attr.name, attr.value);
                            });
                            $(tspan).attr("perso-index", index);
                            var totalAmountChildren = $($(helper.seriesData[modeIndex][index].label)[0]).children();
                            $.each(totalAmountChildren, function (i, node) {
                                                        
                                var svgTspan =  helper.svg.select('[perso-index="' + index + '"]');           
                                var innerTspan = svgTspan.append('tspan').text($(node).text());
                                var attrs = node.attributes;
                                $.each(attrs, function (j, attr) {
                                    innerTspan.attr(attr.name, attr.value);
                                });
                            });
                    });
                });            

            }
        },
        renderXAxis: function () {
            var helper = this;
            if (this.xAxis) {
                var axisTick = this.svg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", function (d, i) {
                        var y = helper.getValueByScreenWidth(helper.options.xAxiaTop);
                        return ("translate(" + helper.leftForScale + "," + y + ")");
                    })
                    .call(helper.xAxis)
                    .selectAll(".tick text")
                    .attr("y", "0")
                    .data(this.seriesData[0])
                    .attr("class", function(d,i){
                        var clazz = "perso-xAxis-label";
                        if(d.selected){
                            clazz +=" selected";
                        }

                        if (helper.seriesData[1][i].value === 0 && helper.seriesData[0][i].value === 0
                            && helper.seriesData[1][i].category === d.category && helper.seriesData[0][i].category === d.category) {
                            clazz += " perso-unclickable";
                        }

                        return clazz;
                    })
                     .on("click", function (obj, clickedItemIndex) {
                         if((helper.seriesData[1][clickedItemIndex].value !== 0 || helper.seriesData[0][clickedItemIndex].value !== 0)
                             && helper.seriesData[1][clickedItemIndex].category === obj.category && helper.seriesData[0][clickedItemIndex].category === obj.category) {
                             if (typeof helper.handleClick == 'function') {
                                 helper.handleClick(obj, clickedItemIndex);
                             }
                         }
                    });
            }
        },
        /**
         * Add hidden rectangles in order to hide selectable area of bars.
         */
        renderHiddenRects: function (seriesData) {
            var helper = this;
            var hiddenRectHeight = helper.getValueByScreenWidth(helper.options.maxBarHeight);
            helper.seriesData = seriesData;
            var hiddenRects = this.svg.append('g')
                .attr('class','perso-hidden-rects')
                .attr("transform", function (data, i) {
                    return "translate(" + helper.left + "," + helper.getValueByScreenWidth(helper.options.barTop) + ")";
                })
                .selectAll("g")
                .data(this.seriesData[0]);

            hiddenRects.enter()
                .append('rect')
                .attr("class", function (d, i) {
                    var clazz = 'hidden-rect';
                    if (helper.seriesData[1][i].value === 0 && helper.seriesData[0][i].value === 0
                    && helper.seriesData[1][i].category === d.category && helper.seriesData[0][i].category === d.category) {
                        clazz += " perso-unclickable";
                    }
                    return clazz;
                })
                .attr("height", function (d, i) {
                    return hiddenRectHeight;
                })
                .attr('width', helper.rWidth +  helper.rPadding)
                .attr("x", function (d, i) {
                    return i * ( helper.rWidth +  helper.rPadding +  helper.rSpace) ;
                })
                .attr('fill-opacity', 0)
                .on("click", function (obj, clickedItemIndex) {
                    if((helper.seriesData[1][clickedItemIndex].value !== 0 || helper.seriesData[0][clickedItemIndex].value !== 0)
                        && helper.seriesData[1][clickedItemIndex].category === obj.category && helper.seriesData[0][clickedItemIndex].category === obj.category) {
                        if (typeof helper.handleClick == 'function') {
                            helper.handleClick(obj, clickedItemIndex);
                        }
                    }
                });

        },
        getMaxBarHeightInMonth: function (category) {
            var helper = this;
            var maxValue = 0;
            if (this.series && this.series.length > 0) {

                //loop over merged data, and get max value of specific month
                $.each(helper.seriesData, function (i, series) {
                    $.each(series, function (j, item) {
                        var barHeight = Math.abs(helper.getBarsHeight(item));
                        if (helper.categoriesData[j] == category && barHeight > maxValue) {
                            maxValue = barHeight;
                        }
                    });
                });
            }
            return maxValue;
        },
        /**
         * This function reverse the data */
        sortData: function(){
            var helper = this;
            if(this.seriesData){
                var reversedLabels = this.seriesLabelsData.slice().reverse();
                var sortedData = [];
                reversedLabels.forEach(function(series, i){
                    sortedData[reversedLabels.indexOf(helper.seriesLabelsData[i])] = helper.seriesData[i];
                });
            }
            return sortedData;
        },

        //add Positive and Negative mode to each data series object
        modifyData: function(){
            var helper = this;
            if(this.seriesData){
                var series = this.seriesLabelsData;
                $.each(series, function(i){
                    $.each(helper.seriesData[i],function (k, seriesObj) {
                        seriesObj.mode = series[i];
                    })
                });
            }
        },

        getSeriesTranslateValue: function (index) {
            return this.rPadding * index;
        },
        barAnimations: function barAnimations(){
            if(!this.barsDraw){
                this.MultiVerticalBarsTransition(this.blockWithBars);
                this.labelsTransition(this.labels);
                this.barsDraw = true;
            }
        },
        labelsTransition: function labelsTransition(labels){
            if(typeof labels != 'undefined'){
                labels.transition()
                .duration(this.options.labelDuration)
                .delay(this.options.labelDelay)
                .style("opacity", 1)
            }
        }

    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.VerticalChartHelper = Personetics.utils.d3Helpers.BlockHelperBase.extend({

        MIN_BAR_HEIGHT: 20,

        prepareChartData: function(data, options){
            this.options = options;
            this.width = this.getValueByScreenWidth(options.svgWidth);
            var rect = options.rectangles;
            var maxCategories = (this.width + this.getValueByScreenWidth(rect.space))/this.getValueByScreenWidth(rect.width + rect.space);
            this.numOfBars = data.categories.length > maxCategories? Math.floor(maxCategories): data.categories.length;
            this.calcLeft = (this.width - (this.numOfBars + 1) * this.getValueByScreenWidth(rect.width + rect.space))/2;
            if(Personetics.processor.PStoryConfig.isRtl()){
                var slice = data.categories.length - (data.categories.length - this.numOfBars);
                data.categories = data.categories.slice(0, slice);
                data.series = data.series.slice(0, slice);
            }
            else{
                var categoriesDataLength = data.categories.length;
                data.categories = data.categories.slice(categoriesDataLength - this.numOfBars, categoriesDataLength);
                data.series = data.series.slice(categoriesDataLength - this.numOfBars, categoriesDataLength);
            }
            return data;
        },
        
        prepareChart: function (data, options, handleClick) {
            Personetics.utils.d3Helpers.BlockHelperBase.prototype.prepareChart.call(this, data, options); 
            this.benchmarkLinesData = data.benchmarkLines || [];
            var helper = this;
            this.handleClick = handleClick;   
            
            this.seriesData = data.series;
            this.categoriesData = data.categories;

            this.negativeBarTop = this.options.negativeBarTop || this.options.svgHeight;
            this.negativeYAxisTop = this.options.negativeYAxisTop || this.options.svgHeight;
            
            var rect = options.rectangles;
            this.xScale = d3.scale.ordinal().rangeRoundBands([0, (this.numOfBars + 1) * this.getValueByScreenWidth(rect.width + rect.space)], 1);
            this.yScale = d3.scale.linear().range([(this.getValueByScreenWidth(this.options.maxBarHeight) - this.MIN_BAR_HEIGHT), 0]);

            this.xAxis = d3.svg.axis().scale(this.xScale).outerTickSize(0)
            this.yAxisScale = d3.scale.linear().range([this.getValueByScreenWidth(this.options.yAxisHeight), 0]);
            this.yAxis = d3.svg.axis()
                .scale(this.yAxisScale)
                .orient("left")
                .innerTickSize(-this.width)
                .outerTickSize(0)
                .ticks(5);
        },
        renderChart: function (el) {
            var helper = this;
            //Setting values we need in more than one function
            var cfg = this.config;
            // Set max & min domain's value
            this.minVal = 0;
            this.seriesDataAndBenchmark = helper.seriesData;
            helper.benchmarkLinesData.forEach(function(item, index){
                helper.seriesDataAndBenchmark = helper.seriesDataAndBenchmark.concat(item.benchmarks);
            })
            this.maxVal = d3.max(helper.seriesDataAndBenchmark, function (d) {
                return Math.abs(parseFloat(d.value));
            });

            //set X and Y domian.
            this.xScale.domain(helper.categoriesData.map(function (d) {
                return d;
            }));
            this.yScale.domain([this.minVal, this.maxVal]);
            this.hasMinVals = false;
            this.seriesMinVal = d3.min(helper.seriesDataAndBenchmark, function (d) {
                return parseFloat(d.value);
            });
            if(this.seriesMinVal < 0){
                this.hasMinVals = true;
                this.maxPositiveVal = d3.max(helper.seriesDataAndBenchmark, function (d) {
                    return parseFloat(d.value);
                });
                this.maxNegativeBarHeight = this.options.maxBarHeight - this.yScale(Math.abs(this.seriesMinVal));
                this.maxPositiveBarHeight = this.options.maxBarHeight - this.yScale(this.maxPositiveVal);
            }
            this.svg = this.renderSVGBase(el);
            this.renderGradient();
            this.renderFilter();
            this.renderYAxis();
            if(this.hasMinVals)
                this.renderYAxis(true);
            if(this.options.hasOwnProperty('isDesktop') && this.options.isDesktop){
                this.renderAccessibilityHiddenRects();
            }
            this.renderVerticalBars();
            this.renderXAxis();
            this.renderLabels();
            if(!this.options.doAnimations){
                this.options.barDelay = this.options.barDuration = this.options.labelDelay = this.options.labelDuration = 0;
                this.barAnimations();
            }
            this.renderBenchMarkLines(); 
            this.renderBenchMarkOuterLabels();
        }, 
        renderBenchMarkLines: function(){
            var helper = this;
            this.benchmark = this.svg.append("g")
            .attr('class', 'benchmarkLines');

            this.benchmarkLinesData.forEach(function(benchmarkLine, index){
                helper.renderLine(benchmarkLine.benchmarks);
            })
            
        },
        renderLine: function (benchmarkLine) {
            var helper = this;
            this.line = d3.svg.line()
                .interpolate(helper.options.lineStyle_interpolate || "linear")
                .x(function (d, i) {
                    return helper.xScale(helper.categoriesData[i]);
                })
                .y(function (d) {
                    return helper.yScale(d.value);
                });
            this.benchmark.append("g")
                .attr("name","line")
                .attr("transform","translate(" + helper.calcLeft + "," + helper.getValueByScreenWidth(helper.options.barTop) +")")
                .append("path")
                .datum(benchmarkLine)
                .attr("class", "perso-line")
                .attr("d", this.line);
        },
        renderBenchMarkOuterLabels: function () {
            var helper = this;
            if (this.options.labels.drawBenchMarkOuterLabels) {
                this.svg.append("g")
                    .attr("transform", function () {
                        var y = helper.options.benchMarkOuterLabelsY ? helper.getValueByScreenWidth(helper.options.benchMarkOuterLabelsY) : 0;
                        var x = helper.options.benchMarkOuterLabelsX ? helper.getValueByScreenWidth(helper.options.benchMarkOuterLabelsX) : 0;
                        return ("translate(" + x + "," + y + ")");
                    })
                    .selectAll()
                    .data(this.benchmarkLinesData)
                    .enter()
                    .append("text")
                    .attr("text-anchor", "middle")
                    .attr("y", function (d) {
                        return helper.yScale(d.benchmarks[0].value);
                    })
                    .attr("dy", function (d) {
                        if (d.value < 0)
                            return "1em";
                        return 0;
                    })
                    .text(function (d) {
                        return d.label;
                    });
            }
        },
        renderSVGBase: function (el) {
            var helper = this;
            var height = helper.getValueByScreenWidth(helper.options.svgHeight);
            var y = 0;
            if(helper.hasMinVals){
                height = height + helper.getValueByScreenWidth(this.maxNegativeBarHeight + this.options.barTop);
                y = helper.getValueByScreenWidth(helper.maxPositiveBarHeight - helper.options.maxBarHeight);
            }
            return (d3.select(el.get(0)).append("svg")
                .attr("class", "perso-svg-chart-container")
                .attr("width", helper.width)
                .attr("height", height + y) 
                .append("g")
                .attr('class','perso-svg-container-group')
                .attr("transform", function(){
                    return "translate(0," + y + ")";
                }));

        },
        renderVerticalBars: function () {
            var helper = this;
            //get min abs value to set rectangle height
            helper.minAbsValue = d3.min(helper.seriesData, function(d) {
                return  Math.abs(d.value) || Infinity;
            });
            helper.maxValue = helper.maxVal;
            //get min value (include negative values) to set y position
            helper.minValue = helper.minVal;
             
            var rectSpace = helper.getValueByScreenWidth(helper.options.rectangles.space || 30);
            var rectWidth = helper.getValueByScreenWidth(helper.options.rectangles.width);
            var left = (helper.width - (helper.numOfBars * rectWidth + (helper.numOfBars - 1) * rectSpace))/2;
            this.bars = this.svg.append("g")
                .attr("transform", function () {
                    return ("translate(" + left + "," + helper.getValueByScreenWidth(helper.options.barTop) + ")");
                })
                .selectAll("rect")
                .data(helper.seriesData)
                .enter()
                .append("rect")
                .attr("class", function(d){
                    var clazz = "perso-bar";
                    if(d.selected){
                        clazz +=" selected";
                    }
                    return clazz;
                })
                .attr("x", function (d, i) { 
                    return i* (rectSpace +rectWidth);
                })
                .attr("width", function (d, i) {
                    return rectWidth;
                })
                .attr("y", function(d, i){
                    if(d.value < 0)
                        return helper.getValueByScreenWidth(helper.negativeBarTop - helper.options.barTop);
                    return helper.getValueByScreenWidth(helper.options.maxBarHeight);
                })
                .attr("height", 0)
                .attr("rx", function (d) {
                    var rx = (helper.options.rectangles.borderRadius.rx) ? helper.options.rectangles.borderRadius.rx : "0";
                    return helper.getValueByScreenWidth(rx);

                })
                .attr("ry", function (d) {
                    var ry = (helper.options.rectangles.borderRadius.ry) ? helper.options.rectangles.borderRadius.ry : "0";
                    return helper.getValueByScreenWidth(ry);

                })
                .on("click", function (obj, clickedItemIndex) {
                    if (typeof helper.handleClick == 'function'){
                        helper.handleClick(obj, clickedItemIndex);
                    }
                })     
        },
        getBarsHeight: function (d) {
            var currentValue = Math.abs(d.value);
            var barHeight = d.value? this.getValueByScreenWidth(this.options.maxBarHeight) - this.yScale(currentValue):0;
            d.barHeight = barHeight;
            return barHeight;
        },
        getBarsY: function (d) {
            var yValue;
            if(d.value < 0){
                yValue = this.getValueByScreenWidth(this.negativeBarTop - this.options.barTop);
            } else{
                yValue = this.yScale(d.value);
            }
            return yValue;
        },
        renderLabels: function () {
            // if there are 6 column, minimize the font size
            var cssClass = "perso-label perso-label-fadeIn";
            var helper = this;
            if(helper.seriesData.length >= 6){
                cssClass +=" minimize-font";
            }
            if (this.options.labels.drawLabels) {
                this.label = this.svg.append("g")
                    .attr("transform", function () {
                        var y = helper.options.labelTop? helper.getValueByScreenWidth(helper.options.labelTop): 0;
                        return ("translate(" + helper.calcLeft + "," + y + ")");
                    })
                    .selectAll()
                    .data(helper.seriesData)
                    .enter()
                    .append("text")
                    .attr("class", function(d){
                        var clazz = cssClass;
                        if(d.selected){
                            clazz +=" selected";
                        }
                        return clazz;
                    })
                    .attr("text-anchor", "middle")
                    .attr("x", function (d, i) {
                        return (helper.xScale(helper.categoriesData[i]) );
                    })
                    .attr("y", function (d) {
                        return helper.getLabelsY(d);
                    })
                    .attr("dy", function(d){
                        if(d.value < 0)
                            return "1em";
                        return 0;
                    });

                // support IE
                var amounts = this.svg.selectAll('.perso-label');
                var tspans = amounts.append('tspan');

                $.each(tspans[0], function (index, tspan) {
                    var attrs = $(helper.seriesData[index].label)[0].attributes;
                    $.each(attrs, function (j, attr) {
                        tspan.setAttribute(attr.name, attr.value);
                    });
                    $(tspan).attr("perso-index", index);
                    //tspan.classList.add('perso-tspan-' + index);
                    var totalAmountChildren = $($(helper.seriesData[index].label)[0]).children();
                    $.each(totalAmountChildren, function (i, node) {
                        var svgTspan =  helper.svg.select('[perso-index="' + index + '"]');           
                        var innerTspan = svgTspan.append('tspan').text($(node).text());
                        var attrs = node.attributes;
                        $.each(attrs, function (j, attr) {
                            innerTspan.attr(attr.name, attr.value);
                        });
                    });
                });
            
            
            }
        },
        getLabelsY:function(d){
            var helper = this;
            var y;
            if(d.value < 0){
                y = helper.getValueByScreenWidth(this.options.barTop - this.options.labelTop + this.negativeBarTop - this.options.labelTop) + this.getBarsHeight(d) ;
            }
            else y = this.yScale(0) - this.getBarsHeight(d) + this.MIN_BAR_HEIGHT ;
            /*if(d.value / helper.maxValue < helper.minHeightPercent){
                y = yScale(helper.minBarChartHeight);
            }*/
		    return y;
        },
        renderXAxis: function(){
            var helper = this;
            if (this.xAxis) {
                this.svg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", function(d,i){
                    return ("translate("+ helper.calcLeft + "," + helper.getValueByScreenWidth(helper.options.xAxisTop) + ")");
                })
                .call(helper.xAxis)
                .selectAll(".tick text")
                    .data(helper.seriesData)
                    .attr("y", "0")
                    .attr("class", function(d,i){
                        var clazz = "perso-xAxis-label";
                        if(d.selected){
                            clazz +=" selected";
                        }

                        if(d.value === 0){
                             clazz += " perso-unclickable";
                         }
                        return clazz;
                    });
            }
        },

        /**
         * Add hidden rectangles.
         */
        renderAccessibilityHiddenRects: function () {
            var helper = this;
            var hiddenRectWidth = helper.getValueByScreenWidth((helper.options.rectangles.width * 3) + (helper.options.rectangles.paddingRight || 0));
            var hiddenRectHeight = helper.getValueByScreenWidth(helper.options.svgHeight - (helper.options.labelTop || 0 ));
            var rectSpace = helper.getValueByScreenWidth(helper.options.rectangles.space || 30);
            var rectWidth = helper.getValueByScreenWidth(helper.options.rectangles.width);
            var left = (helper.width - (helper.numOfBars * rectWidth + (helper.numOfBars - 1) * rectSpace))/2;
            var reversedData = this.seriesData.slice().reverse();
            var hiddenRects = this.svg.append('g')
                .attr('class','perso-hidden-rects')
                .attr("transform", function (data, i) {
                    var marginLeft = helper.options.rectangles.marginLeft ? helper.options.rectangles.marginLeft : 0;
                    return "translate(" + left + "," + helper.getValueByScreenWidth(helper.options.barTop - helper.options.yAxisTop) + ")";
                })
                .selectAll("g")
                .data(reversedData);

            hiddenRects.enter()
                .append('rect')
                .attr("class", function (d) {
                    var clazz = 'access-hidden-rect';
                    if (d.value === 0) {
                        clazz += " perso-unclickable";
                    }
                    return clazz;
                })
                .attr("height", function (d, i) {
                    return hiddenRectHeight;
                })
                .attr('width',hiddenRectWidth)
                .attr("x", function (d, i) {
                    var lastItemIndex = helper.seriesData.length - 1;
                    return ((lastItemIndex - i) * (rectSpace +rectWidth) - hiddenRectWidth / 3);
                })
                .attr('fill-opacity', 0);
        },
        /**animations */
        barAnimations: function barAnimations(){
            if(!this.barsDraw){
                this.barsTransition(this.bars);
                this.labelTransition(this.label);
                this.barsDraw = true;
            }
            
        },
        barsTransition: function(bars){
            var helper = this;
            bars.transition()
                .duration(this.options.barDuration)
                .delay(this.options.barDelay)
                .attr("y", function(d) {
                    return helper.getBarsY(d);
                })
                .attr("height", function(d) {
                    return helper.getBarsHeight(d);
                });
        },
        labelTransition: function labelTransition(labels){
            if(typeof labels != 'undefined'){
                labels.transition()
                .duration(this.options.labelDuration)
                .delay(this.options.labelDelay)
                .style("opacity", 1)
            }
        },
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.PinGraphChartHelper = Personetics.utils.d3Helpers.VerticalChartHelper.extend({
        
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.LineChartHelper = Base.extend({

        prepareChart: function (data, options) {
            var helper = this;
            this.options = options;
            this.seriesData = data.series.reverse();
            this.categoriesData = data.categories;

            this.graphWidth = this.getValueByScreenWidth(this.options.line_width);
            this.graphHeight = this.getValueByScreenWidth(this.options.line_height);

            // set axes scales
            this.xScale = d3.time.scale().range([0, this.graphWidth]);
            this.yScale = d3.scale.linear().range([this.graphHeight, 0]);
            this.setXscaleAndYscaleDomain();

            this.initAxes();
        },
        setXscaleAndYscaleDomain: function(){
            var minValue = d3.min(this.seriesData, function (d) {
                return parseFloat(d.value);
            });
            var maxValue = d3.max(this.seriesData, function (d) {
                return parseFloat(d.value);
            });
            var oldestDate = d3.min(this.categoriesData, function (d) {
                return (new Date(d.value));
            });
            var newestDate = d3.max(this.categoriesData, function (d) {
                return (new Date(d.value));
            });

            this.xScale.domain([oldestDate, newestDate]);
            this.yScale.domain([minValue, maxValue]);
        },
        initAxes: function () {
            var helper = this;
            //set categories labels to x
            var xValues = this.categoriesData.map(function (d) {
                return (new Date(d.value));
            });
            //set axes
            this.xAxis = d3.svg.axis()
                .scale(this.xScale)
                .orient('bottom')
                .innerTickSize(this.getValueByScreenWidth(this.options.xAxis_line_height + this.options.xAxis_line_y))
                .tickValues(xValues)
                .tickFormat(function (d) {
                    var label = d3.time.format("%m-/%d-/%Y");
                    helper.categoriesData.forEach(function (category, index) {
                        var categoryDate = new Date(category.value);
                        if (categoryDate.getTime() == d.getTime()) {
                            label = category.label;
                        }
                    })
                    return label;
                });

            this.yAxis = d3.svg.axis()
                .scale(this.yScale)
                .ticks(5)
                .orient('left');
        },
        renderChart: function (el) {
            var helper = this;
            this.svg = this.renderSVGBase(el);
            this.renderXAxis();
            this.renderYAxis();
            this.renderArea();
            this.renderHorizonalLine();
            this.graph = this.renderGraph();
            this.renderLine();
            this.renderLabels();
            this.renderDots();
            if(!this.options.doAnimations){
                this.options.lineDelay = this.options.lineDuration = this.options.dotsDelay = this.options.dotsDuration = this.options.areaDelay = this.options.areaDuration = 0;
                this.lineAnimations();
            }
        },

        renderSVGBase: function (el) {
            var chartWidth = this.getValueByScreenWidth(this.options.svgWidth);
            var chartHeight = this.getValueByScreenWidth(this.options.svgHeight);

            return (d3.select(el.get(0)).append("svg")
                    .attr("class", "perso-svg-chart-container")
                    .attr("width", chartWidth)
                    .attr("height", chartHeight)
                    .append("g")
                    .attr("transform","translate(0,0)")
            );
        },

        renderXAxis: function () {
            var highlightedTickDate = this.getSelectedMonth();

            if(this.options.xAxis_display){
                var x_Axis = this.svg.append("g")
                    .attr("name", "x axis")
                    .attr("class", "perso-line-x axis")
                    .call(this.xAxis);

                x_Axis.selectAll('.perso-line-x.axis line')
                    .attr("x1",this.getValueByScreenWidth(this.options.xAxis_line_x))
                    .attr("x2",this.getValueByScreenWidth(this.options.xAxis_line_x))
                    .attr("y1",this.getValueByScreenWidth(this.options.xAxis_line_y));

                x_Axis.selectAll(".perso-line-x.axis text")
                    .attr("y",this.getValueByScreenWidth(this.options.xAxis_text_y))
                    .attr("x",this.getValueByScreenWidth(this.options.xAxis_text_x))
                    .attr("class", function (d) {
                        var _class = "tick";
                        if (d.getTime() == highlightedTickDate.getTime()) {
                            _class = "highlighted-text";
                        }
                        return _class;
                    });
            }
        },

        renderYAxis: function () {
            if(this.options.yAxis_display){
                this.svg.append("g")
                    .attr("name","y axis")
                    .attr("class", "perso-line-y axis")
                    .attr("transform", "translate(" +
                        this.getValueByScreenWidth(this.options.yAxis_x) + "," +
                        this.getValueByScreenWidth(this.options.yAxis_y) + ")")
                    .call(this.yAxis)
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("x","0");
            }
        },

        renderGraph: function() {
            return (this.svg.append("g")
                .attr("name","graph")
                .attr("transform", "translate(" +
                    this.getValueByScreenWidth(this.options.line_left) + "," +
                    this.getValueByScreenWidth(this.options.line_top) + ")")
                .attr("width", this.graphWidth)
                .attr("height", this.graphHeight));
        },

        renderLine: function () {
            var helper = this;
            this.line = d3.svg.line()
                .interpolate(this.setInterpolate(this.options.lineStyle_interpolate))
                .x(function (d) {
                    return helper.xScale(new Date(d.category));
                })
                .y(function (d) {
                    return helper.yScale(d.value);
                });
            var strokeWidth = this.getValueByScreenWidth(this.options.lineStyle_thickness);
            strokeWidth = strokeWidth > 4 ? 4 : strokeWidth;
            this.graph.append("g")
                .attr("name","line")
                .append("path")
                .datum(this.seriesData)
                .attr("class", "perso-line")
                .attr("stroke-width",strokeWidth)
                .attr("d", this.line);
        },

        renderDots: function () {
            var helper= this;
            this.graph.append("g")
                .attr("name","dots")
                .selectAll("dot")
                .data(this.seriesData)
                .enter().append("circle")
                .filter(function (d) {
                    return helper.isDateInCategories(d.category)
                })
                .attr("cx", function (d) {
                    return helper.xScale(new Date(d.category));
                })
                .attr("cy", function (d) {
                    return helper.yScale(d.value);
                })
                .attr("class", function (d) {
                    var _class = "perso-dot";
                    if (d.highlight) {
                        _class = "perso-dot-selected";
                    }
                    return _class;
                })
                .attr("r",0);

            this.graph.select("circle.perso-dot-selected")
                .attr("r",0);
        },

        renderLabels: function(){
            var helper = this;
            var highlightedTickDate = this.getSelectedMonth();
            var filterdData = [];
            if(this.options.labels_display) {
                this.svg.append("g")
                    .attr("name","labels")
                    .attr("transform", "translate(" +
                        this.getValueByScreenWidth(this.options.labels_x) + "," +
                        this.getValueByScreenWidth(this.options.line_top - (this.options.labels_y + this.options.dots_radius)) + ")")
                    .selectAll()
                    .data(helper.seriesData)
                    .enter().append("text")
                    .filter(function (d) {
                        if(helper.isDateInCategories(d.category)){
                            filterdData.push(d);
                        }
                        return helper.isDateInCategories(d.category)
                    })
                    .attr("class", function (d) {
                        var _class = "perso-label";
                        if (new Date(d.category).getTime() == highlightedTickDate.getTime()) {
                            _class += " perso-label-selected";
                        }
                        return _class;
                    })
                    .attr("text-anchor", "middle")
                    .attr("x", function (d, i) {
                        return helper.xScale(new Date(d.category));
                    })
                    .attr("y", function (d) {
                        return helper.yScale(d.value);
                    })
                    .attr("dy", function(d){
                        if(d.value < 0)
                            return "1em";
                        return 0;
                    })
                    /*   .html(function (d) {
                           var text = d.label;
                           return text;
                       })*/
                    .attr("opacity",0)
                    .transition()
                    .delay(this.options.duration)
                    .attr("opacity",1);

                // support IE
                var amounts = this.svg.selectAll('.perso-label');
                var tspans = amounts.append('tspan');

                $.each(tspans[0], function (index, tspan) {
                    var attrs = $(filterdData[index].label)[0].attributes;
                    $.each(attrs, function (j, attr) {
                        tspan.setAttribute(attr.name, attr.value);
                    });
                    $(tspan).attr("perso-index", index);
                    //tspan.classList.add('perso-tspan-' + index);
                    var totalAmountChildren = $($(filterdData[index].label)[0]).children();
                    $.each(totalAmountChildren, function (i, node) {
                        var svgTspan =  helper.svg.select('[perso-index="' + index + '"]');
                        var innerTspan = svgTspan.append('tspan').text($(node).text());
                        var attrs = node.attributes;
                        $.each(attrs, function (j, attr) {
                            innerTspan.attr(attr.name, attr.value);
                        });
                    });
                });
            }
        },

        renderArea: function(){
            var helper = this;
            if(this.options.area_display){
                var linearScale = d3.scale.linear()
                    .rangeRound([this.graphHeight, 0]);
                this.area = d3.svg.area()
                    .interpolate(this.setInterpolate(this.options.lineStyle_interpolate))
                    .x(function (d) {
                        return helper.xScale(new Date(d.category));
                    })
                    .y1(function (d) {
                        return helper.yScale(d.value);
                    })
                    .y0(linearScale(0));

                this.svg.append("path")
                    .attr("transform", "translate(" +
                        this.getValueByScreenWidth(this.options.line_left) + "," +
                        this.getValueByScreenWidth(this.options.line_top) + ")")
                    .datum(this.seriesData)
                    .attr("d", this.area)
                    .attr("class","perso-line-area")
                    .attr("opacity", 0);

            }
        },

        renderHorizonalLine: function renderHorizonalLine(){
            if(this.options.horizonalLine_display){
                this.svg.append("line")
                    .attr("name","horizonal-line")
                    .attr("class","perso-horizonal-line")
                    .attr("x1",this.getValueByScreenWidth(this.options.horizonalLine_x))
                    .attr("x2",this.getValueByScreenWidth(this.options.horizonalLine_x + this.options.horizonalLine_length))
                    .attr("y1",this.getValueByScreenWidth(this.options.horizonalLine_y))
                    .attr("y2",this.getValueByScreenWidth(this.options.horizonalLine_y))
            }
        },
        //animations
        lineAnimations: function lineAnimations(){
            if(!this.lineDraw){
                this.lineTransition();
                this.dotsTransition();
                this.areaAnimation();
                this.lineDraw = true;
            }
        },
        lineTransition: function lineTransition(){
            this.svg.select(".perso-line")
                .style("stroke-opacity", 1)
                .transition()
                .duration(this.options.lineDuration)
                .attrTween("stroke-dasharray", function () {
                    var len = this.getTotalLength();
                    return function (t) {
                        return (d3.interpolateString("0," + len, len + ",0"))(t)
                    };
                });
        },
        dotsTransition: function dotsTransition(){
            this.graph.selectAll(".perso-dot")
                .transition()
                .delay(this.options.dotsDelay)
                .duration(this.options.dotsDuration)
                .attr("r", this.getValueByScreenWidth(this.options.dots_radius));

            this.graph.select("circle.perso-dot-selected")
                .transition()
                .delay(this.options.dotsDelay)
                .duration(this.options.dotsDuration)
                .attr("r", this.getValueByScreenWidth(this.options.dots_radius_selected));
        },
        areaAnimation: function areaAnimation(){
            this.svg.select(".perso-line-area")
                .transition()
                .delay(this.options.areaDelay)
                .duration(this.options.areaDuration)
                .attr('opacity', 1);
        },

        getSelectedMonth: function(){
            var helper = this;
            var highlightedTickDate = new Date();
            var highlightedDotIndex = helper.setHighlightDot();
            if(typeof highlightedDotIndex != 'undefined'){
                if(typeof this.seriesData[highlightedDotIndex] != 'undefined' && this.seriesData[highlightedDotIndex] !== null){
                    highlightedTickDate = new Date(this.seriesData[highlightedDotIndex].category);
                }
            }
            return highlightedTickDate;
        },

        isDateInCategories: function (date) {
            var categoriesArr = this.categoriesData;
            var isDateExist = false;
            if (typeof  date != 'undefined' && date !== null) {
                categoriesArr.forEach(function (category, index) {
                    if (category.value == date) {
                        isDateExist = true;
                    }
                })
            }
            return isDateExist;
        },

        setHighlightDot: function(){
            var helper = this;
            /**
             * This function set the highlighted dot and return the index */
            var highlightKeys = {
                MAX: 'max',
                MIN: 'min',
                LAST: 'last',
                FIRST: 'first'
            };

            var maxValueInCategories = d3.max(this.seriesData, function (d) {
                if(helper.isDateInCategories(d.category))
                    return parseFloat(d.value);
            });
            var minValueInCategories = d3.min(this.seriesData, function (d) {
                if(helper.isDateInCategories(d.category))
                    return parseFloat(d.value);
            });

            var highlightKey = helper.options.highlightBy;
            var index = helper.seriesData.length - 1;

            switch (highlightKey){
                case highlightKeys.MAX:
                    var maxObjIndex = helper.getObjIndexByValue(helper.seriesData, maxValueInCategories);
                    helper.seriesData[maxObjIndex].highlight = true;
                    index = maxObjIndex;
                    break;

                case highlightKeys.MIN:
                    var minObjIndex = helper.getObjIndexByValue(helper.seriesData, minValueInCategories);
                    helper.seriesData[minObjIndex].highlight = true;
                    index = minObjIndex;
                    break;

                case highlightKeys.FIRST:
                    helper.seriesData[0].highlight = true;
                    index = 0;
                    break;

                default:
                    var lastIndex = helper.seriesData.length - 1;
                    helper.seriesData[lastIndex].highlight = true;
            }
            return index;
        },

        getObjIndexByValue: function(data, value){
            var index = $.map(data, function(obj, index) {
                if(obj.value == value) {
                    return index;
                }
            })
            return index[0];
        },

        setInterpolate: function(interpolate){
            var interpolateKeys = {
                Default: 'cardinal',
                Linear: 'linear',
                Monotone: 'monotone'
            }
            var _interpolate = interpolateKeys.Default;

            switch (interpolate){
                case interpolateKeys.Monotone:
                    _interpolate = interpolateKeys.Monotone;
                    break;

                case interpolateKeys.Linear:
                    _interpolate = interpolateKeys.Linear;
                    break;

                default:
                    _interpolate;
            }
            return _interpolate;
        },

        getValueByScreenWidth: function (value) {
            var screenWidth = $(window).width();
            if (screenWidth >= 790) {
                return value;
            }
            else {
                if (screenWidth < 347) {
                    return value;
                } else if (screenWidth >= 414) {
                    return value * this.options.screen.ratio_large;
                } else {
                    return value * this.options.screen.ratio_medium;
                }
            }
        },

        renderAccessibilityData: function (frameEl, texts) {
            this.texts = texts;
            var id = frameEl.parents(".pstory-dialog-frame").attr("id") + frameEl.index();
            var content = this.getAccessibilityTitle() + '. ' + this.prepareAccessibilityText();
            var parentNode = frameEl.find(".perso-svg-chart-container")[0];

            d3.select(parentNode).append("title").attr("id", id + "_title").text(content);
            d3.select(parentNode).attr("role", "presentation");
            this.svg.attr('aria-labelledby', id + '_title');
            this.svg.selectAll("*").attr('aria-hidden', true);
        },

        filterSeriesByCategories: function (){
            var categories = this.categoriesData;
            var series = this.seriesData;
            var filterdSeries =[];

            for(var i = 0; i < categories.length; i++){
                for(var j = 0; j < series.length; j++){
                    if(series[j].category === categories[i].value){
                        var matchedItem = {
                            label:categories[i].label,
                            value: series[j].value
                        };
                        if(series[j].highlight){
                            matchedItem.highlight = true;
                        }
                        filterdSeries.push(matchedItem);
                        break;
                    };
                }
            }
            return filterdSeries;
        },

        prepareAccessibilityText: function(){
            var block = this;
            var content='';
            var filteredData = this.filterSeriesByCategories();
            var reversedFilterdData = filteredData.slice().reverse();
            // first add the highlighted dot
            $.each(reversedFilterdData, function(i,item){
                if(item.highlight) {
                    content = block.getAccessibilityHighlightedDotlbl()+ ', ' + item.label + ', ' + Math.round(item.value) + ',';
                }
            });
            // add the rest
            $.each(reversedFilterdData, function(i,item){
                if(!item.highlight) {
                    content += ' ' + item.label + ', ' + Math.round(item.value) + ',';
                }
            });
            return content;
        },

        getAccessibilityTitle: function getAccessibilityTitle(){
            return this.texts.accessibilityLineChartTitle;
        },

        getAccessibilityHighlightedDotlbl: function (){
            return this.texts.accessibilityLineGraphHighlightedDot;
        },
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.NewLineChartHelper = Base.extend({

        prepareChart: function (data, options) {
            var helper = this;
            this.options = options;
            this.seriesData = data.series;
            this.categoriesData = data.categories;
            this.highlightedCategory = (typeof (data.highlightedCategories) !== 'undefined') ? data.highlightedCategories[0] : null;
            this.setHighlightedCategory();

            this.graphWidth = this.getValueByScreenWidth(this.options.line_width);
            this.graphHeight = this.getValueByScreenWidth(this.options.line_height);

            // set axes scales
            this.xScale = d3.time.scale().range([0, this.graphWidth]);
            this.yScale = d3.scale.linear().range([this.graphHeight, 0]);
            this.setXscaleAndYscaleDomain();

            this.initAxes();
        },
        normalizeSeries: function normalizeSeries(series, categories) {
            var normalizedSeries = [];
            var prevSeries = null;
            var values = 0;
            series.forEach(function (s) {
                if (prevSeries == null) {
                    prevSeries = s;
                } else {
                    values += Math.abs(s.value - prevSeries.value);
                    prevSeries = s;
                }
            });
            values = values / series.length;
            prevSeries = null;
            series.forEach(function (s) {
                if (prevSeries == null) {
                    prevSeries = s;
                    normalizedSeries.push(s);
                } else {
                    var category = categories.filter(function (c) {
                        return new Date(s.category).getTime() == new Date(c.value).getTime();
                    })
                    if (Math.abs(s.value - prevSeries.value) > values || category.length) {
                        prevSeries = s;
                        normalizedSeries.push(s);
                    }
                }
            });
            return normalizedSeries;
        },
        setXscaleAndYscaleDomain: function () {
            var minValue = d3.min(this.seriesData, function (d) {
                return parseFloat(d.value);
            });
            var maxValue = d3.max(this.seriesData, function (d) {
                return parseFloat(d.value);
            });
            var firstDate = new Date(this.seriesData[0].category);
            var lastDate = new Date(this.seriesData[this.seriesData.length - 1].category);

            this.xScale.domain([firstDate, lastDate]);
            this.yScale.domain([minValue, maxValue]);
        },
        initAxes: function () {
            var helper = this;
            //set categories labels to x
            var xValues = this.categoriesData.map(function (d) {
                return new Date(d.value);
            });
            //set axes
            this.xAxis = d3.svg.axis()
                .scale(this.xScale)
                .orient('bottom')
                .innerTickSize(this.getValueByScreenWidth(this.options.xAxis_line_height + this.options.xAxis_line_y))
                .tickValues(xValues)
                .tickFormat(function (d) {
                    //var label = d3.time.format("%m-/%d-/%Y");
                    var label = '';
                    helper.categoriesData.forEach(function (category, index) {
                        if (new Date(category.value).toDateString() == d.toDateString()) {
                            label = category.label;
                        }
                    });
                    return label;
                });

            this.yAxis = d3.svg.axis()
                .scale(this.yScale)
                .ticks(5)
                .orient('left');
        },
        renderChart: function (el) {
            this.el = el;
            var helper = this;
            this.svg = this.renderSVGBase(el);
            this.renderXAxis();
            this.renderYAxis();
            this.renderArea();
            this.renderHorizonalLine();
            this.graph = this.renderGraph();
            this.renderLine();
            this.renderLabels();
            this.renderDots();
            this.renderDotsLabel();
            if (!this.options.doAnimations) {
                this.options.lineDelay = this.options.lineDuration = this.options.dotsDelay = this.options.dotsDuration = this.options.areaDelay = this.options.areaDuration = 0;
                this.lineAnimations();
            }
        },

        renderSVGBase: function (el) {
            var chartWidth = this.getValueByScreenWidth(this.options.svgWidth);
            var chartHeight = this.getValueByScreenWidth(this.options.svgHeight);

            return (d3.select(el.get(0)).append("svg")
                    .attr("class", "perso-svg-chart-container")
                    .attr("width", chartWidth)
                    .attr("height", chartHeight)
                    .append("g")
                    .attr("transform", "translate(" + this.getValueByScreenWidth(this.options.line_left) + ",0)")
            );
        },

        renderXAxis: function () {
            var helper = this;
            var highlightedTickDate = this.getSelectedMonth();

            if (this.options.xAxis_display) {
                var x_Axis = this.svg.append("g")
                    .attr("name", "x axis")
                    .attr("class", "perso-line-x axis")
                    .data(this.seriesData)
                    .call(this.xAxis);

                x_Axis.selectAll('.perso-line-x.axis line')
                //.data(helper.categoriesData)
                    .attr("x1", 0)
                    .attr("x2", 0)
                    .attr("y1", function (d, i) {
                        /**bisect func must get sort data */
                        var seriesDataCopy = [];
                        $.extend(true, seriesDataCopy, helper.seriesData);
                        var seriesDataSort = seriesDataCopy.map(function (h) {
                            h.category = new Date(h.category);
                            return h;
                        });
                        seriesDataSort = seriesDataSort.sort(function (a, b) {
                            return a.category - b.category
                        });
                        //var bisect = d3.bisector(function(d) { return new Date(d.category)}).right;
                        var bisect = d3.bisector(function (d) {
                            return d.category
                        }).right;
                        var indexData = bisect(seriesDataSort, d);
                        var d0, d1, value = 0;
                        if (indexData > 0) {
                            d0 = seriesDataSort[indexData - 1];
                            value = helper.yScale(d0.value);
                        }
                        if (indexData < seriesDataSort.length) {
                            d1 = seriesDataSort[indexData];
                            value = helper.yScale(d1.value);
                        }

                        if (typeof d1 != 'undefined' && typeof d0 != 'undefined') {
                            /**
                             *m = (y1-y2)/(x1-x2)
                             * Y-y1 = m(X - x1)
                             **/
                            var m = (helper.yScale(d0.value) - helper.yScale(d1.value)) / (helper.xScale(new Date(d0.category)) - helper.xScale(new Date(d1.category)));
                            var y = m * (helper.xScale(d) - helper.xScale(new Date(d0.category))) + helper.yScale(d0.value);
                            value = y;
                        }
                        return value + helper.getValueByScreenWidth(helper.options.line_top);
                    });

                x_Axis.selectAll(".perso-line-x.axis text")
                    .attr("y", this.getValueByScreenWidth(this.options.xAxis_text_y))
                    .attr("x", 0)
                    .attr("class", function (d) {
                        var _class = "tick";
                        if (d.getTime() == highlightedTickDate.getTime()) {
                            _class = "highlighted-text";
                        }
                        return _class;
                    });
            }
        },

        renderYAxis: function () {
            if (this.options.yAxis_display) {
                this.svg.append("g")
                    .attr("name", "y axis")
                    .attr("class", "perso-line-y axis")
                    .attr("transform", "translate(" +
                        this.getValueByScreenWidth(this.options.yAxis_x) + "," +
                        this.getValueByScreenWidth(this.options.yAxis_y) + ")")
                    .call(this.yAxis)
                    .selectAll("text")
                    .style("text-anchor", "end")
                    .attr("x", "0");
            }
        },

        renderGraph: function () {
            return (this.svg.append("g")
                .attr("name", "graph")
                .attr("transform", "translate(0," +
                    this.getValueByScreenWidth(this.options.line_top) + ")")
                .attr("width", this.graphWidth)
                .attr("height", this.graphHeight));
        },

        renderLine: function () {
            var helper = this;
            this.line = d3.svg.line()
                .interpolate(this.setInterpolate(this.options.lineStyle_interpolate))
                .x(function (d) {
                    return helper.xScale(new Date(d.category));
                })
                .y(function (d) {
                    return helper.yScale(d.value);
                });
            var strokeWidth = this.getValueByScreenWidth(this.options.lineStyle_thickness);
            strokeWidth = strokeWidth > 4 ? 4 : strokeWidth;
            this.graph.append("g")
                .attr("name", "line")
                .append("path")
                .datum(this.seriesData)
                .attr("class", "perso-line")
                .attr("stroke-width", strokeWidth)
                .attr("d", this.line);
        },

        renderDots: function () {
            var helper = this;
            this.graph.append("g")
                .attr("name", "dots")
                .selectAll("dot")
                .data(this.seriesData)
                .enter().append("circle")
                .filter(function (d) {
                    return (d.highlight)
                })
                .attr("cx", function (d) {
                    return helper.xScale(new Date(d.category));
                })
                .attr("cy", function (d) {
                    return helper.yScale(d.value);
                })
                .attr("class", function (d) {
                    var _class = "perso-dot";
                    return _class;
                })
                .attr("r", 0);
        },
        renderDotsLabel: function renderDotsLabel() {
            var helper = this;
            var dotText = [];
            var dotText2 = [];
            var dotRectX;
            var categoryIndex;
            dotRectX = this.renderDotsLabelRect();

            var textG = this.graph.append("g")
                .attr("name", "dots-text");

            textG.selectAll("dot-text")
                .data(this.seriesData.filter(function (d) {
                    if (d.highlight && typeof d.label != 'undefined') {
                        return true;
                    }
                    return false;
                }))
                .enter()
                .append("text")
                .attr("x", function (d) {
                    dotText.push(this);
                    return helper.xScale(new Date(d.category));
                })
                .attr("y", function (d) {
                    return helper.yScale(d.value) - helper.options.dotText.yOffset;
                })
                .attr("opacity", 0)
                // .text(function(d){
                //     return d.value;
                // })
                .attr("class", function (d) {
                    var _class = "perso-dot-label-text";
                    return _class;
                });

            // support IE
            if (dotText.length > 0) {
                var amounts = dotText[0];
                var tspans = d3.select(amounts).append('tspan');

                $.each(tspans[0], function (index, tspan) {
                    var highlightObj = helper.seriesData.filter(function (item) {
                        return item.highlight;
                    })
                    if (typeof highlightObj[index].label != 'undefined') {
                        var attrs = $(highlightObj[index].label)[0].attributes;
                        $.each(attrs, function (j, attr) {
                            tspan.setAttribute(attr.name, attr.value);
                        });
                        $(tspan).attr("perso-index", index);
                        var totalAmountChildren = $($(highlightObj[index].label)[0]).children();
                        $.each(totalAmountChildren, function (i, node) {
                            var svgTspan = helper.svg.select('[perso-index="' + index + '"]');
                            var innerTspan = svgTspan.append('tspan').text($(node).text());
                            var attrs = node.attributes;
                            $.each(attrs, function (j, attr) {
                                innerTspan.attr(attr.name, attr.value);
                            });
                        });
                    }
                });
            }
            /**label2 */
            textG.selectAll("dot-text")
                .data(this.seriesData.filter(function (d) {
                    if (d.highlight && typeof d.label2 != 'undefined') {
                        return true;
                    }
                    return false;
                }))
                .enter()
                .append("text")
                .attr("x", function (d) {
                    dotText2.push(this);
                    return helper.xScale(new Date(d.category));
                })
                .attr("y", function (d) {
                    return helper.yScale(d.value) - helper.options.dotText.yOffset + helper.options.dotText.lineHeight;
                })
                .attr("opacity", 0)
                .text(function (d) {
                    return d.label2;
                })
                .attr("class", function (d) {
                    var _class = "perso-dot-label2-text";
                    return _class;
                });

            if (dotText.length > 0) {
                this.setDotsLabelRectWidth(dotText, dotText2, dotRectX);
                this.renderDotsLabelPolygon();
            }

        },
        renderDotsLabelRect: function renderDotsLabelRect() {
            var dotRectX;
            var helper = this;
            this.graph.append("g")
                .attr("name", "dots-rect")
                .selectAll("dot-rect")
                .data(this.seriesData.filter(function (d) {
                    if (d.highlight) {
                        categoryIndex = helper.getHighlightedCategory();
                        return true;
                    }
                    return false;
                }))
                .enter()
                .append("rect")
                .attr("x", function (d) {
                    dotRectX = helper.xScale(new Date(d.category));
                    return dotRectX;
                })
                .attr("y", function (d) {
                    return helper.yScale(d.value) - helper.options.dotRect.yOffset;
                })
                .attr("height", helper.options.dotRect.height)
                .attr("rx", helper.options.dotRect.radiusX)
                .attr("ry", helper.options.dotRect.radiusY)
                .attr("opacity", 0)
                .attr("class", function (d) {
                    var _class = "perso-dot-label";
                    return _class;
                });
            return dotRectX;
        },
        setDotsLabelRectWidth: function setDotsLabelRectWidth(dotText, dotText2, dotRectX) {
            var helper = this;
            var width = dotText[0].getBBox().width;
            if (dotText2.length > 0) {
                var width2 = dotText2[0].getBBox().width;
                width = Math.max(width, width2);
            }
            this.graph.selectAll("rect")
                .attr("width", width + helper.options.dotText.paddingLeft + helper.options.dotText.paddingRight)
                .attr("x", function (d) {
                    return dotRectX - ((width + helper.options.dotText.paddingLeft + helper.options.dotText.paddingRight) / 2);
                });

        },
        renderDotsLabelPolygon: function renderDotsLabelPolygon() {
            var helper = this;
            this.graph.append("g")
                .attr("name", "dots-polygon")
                .selectAll("dot-polygon")
                .data(this.seriesData)
                .enter()
                .append("polygon")
                .filter(function (d) {
                    return (d.highlight)
                })
                .attr("points", helper.options.dotPolygon.points)
                .attr("transform", function (d) {
                    return "translate(" +
                        (helper.xScale(new Date(d.category)) - helper.options.dotText.paddingLeft - helper.options.dotText.paddingRight) + "," +
                        (helper.yScale(d.value) - helper.options.dotPolygon.yOffset) + ")"
                })
                .attr("opacity", 0)
                .attr("class", function (d) {
                    var _class = "perso-dot-label-polygon";
                    return _class;
                });
        },

        renderLabels: function () {
            var helper = this;
            var highlightedTickDate = this.getSelectedMonth();
            var filterdData = [];
            if (this.options.labels_display) {
                this.svg.append("g")
                    .attr("name", "labels")
                    .attr("transform", "translate(" +
                        this.getValueByScreenWidth(this.options.labels_x) + "," +
                        this.getValueByScreenWidth(this.options.line_top - (this.options.labels_y + this.options.dots_radius)) + ")")
                    .selectAll()
                    .data(helper.seriesData)
                    .enter().append("text")
                    .filter(function (d) {
                        if (helper.isDateInCategories(d.category)) {
                            filterdData.push(d);
                        }
                        return helper.isDateInCategories(d.category)
                    })
                    .attr("class", function (d) {
                        var _class = "perso-label";
                        if (new Date(d.category).getTime() == highlightedTickDate.getTime()) {
                            _class += " perso-label-selected";
                        }
                        return _class;
                    })
                    .attr("text-anchor", "middle")
                    .attr("x", function (d, i) {
                        return helper.xScale(new Date(d.category));
                    })
                    .attr("y", function (d) {
                        return helper.yScale(d.value);
                    })
                    .attr("dy", function (d) {
                        if (d.value < 0)
                            return "1em";
                        return 0;
                    })
                    /*   .html(function (d) {
                           var text = d.label;
                           return text;
                       })*/
                    .attr("opacity", 0)
                    .transition()
                    .delay(this.options.duration)
                    .attr("opacity", 1);

                // support IE
                var amounts = this.svg.selectAll('.perso-label');
                var tspans = amounts.append('tspan');

                $.each(tspans[0], function (index, tspan) {
                    var attrs = $(filterdData[index].label)[0].attributes;
                    $.each(attrs, function (j, attr) {
                        tspan.setAttribute(attr.name, attr.value);
                    });
                    $(tspan).attr("perso-index", index);
                    //tspan.classList.add('perso-tspan-' + index);
                    var totalAmountChildren = $($(filterdData[index].label)[0]).children();
                    $.each(totalAmountChildren, function (i, node) {
                        var svgTspan = helper.svg.select('[perso-index="' + index + '"]');
                        var innerTspan = svgTspan.append('tspan').text($(node).text());
                        var attrs = node.attributes;
                        $.each(attrs, function (j, attr) {
                            innerTspan.attr(attr.name, attr.value);
                        });
                    });
                });
            }
        },

        renderArea: function () {
            var helper = this;
            if (this.options.area_display) {
                var linearScale = d3.scale.linear()
                    .rangeRound([this.graphHeight, 0]);
                this.area = d3.svg.area()
                    .interpolate(this.setInterpolate(this.options.lineStyle_interpolate))
                    .x(function (d) {
                        return helper.xScale(new Date(d.category));
                    })
                    .y1(function (d) {
                        return helper.yScale(d.value);
                    })
                    .y0(linearScale(0));

                this.svg.append("path")
                    .attr("transform", "translate(0," +
                        this.getValueByScreenWidth(this.options.line_top) + ")")
                    .datum(this.seriesData)
                    .attr("d", this.area)
                    .attr("class", "perso-line-area")
                    .attr("opacity", 0);

            }
        },

        renderHorizonalLine: function renderHorizonalLine() {
            if (this.options.horizonalLine_display) {
                this.svg.append("line")
                    .attr("name", "horizonal-line")
                    .attr("class", "perso-horizonal-line")
                    .attr("x1", this.getValueByScreenWidth(this.options.horizonalLine_x))
                    .attr("x2", this.getValueByScreenWidth(this.options.horizonalLine_x + this.options.horizonalLine_length))
                    .attr("y1", this.getValueByScreenWidth(this.options.horizonalLine_y))
                    .attr("y2", this.getValueByScreenWidth(this.options.horizonalLine_y))
            }
        },
        //animations
        lineAnimations: function lineAnimations() {
            if (!this.lineDraw) {
                this.lineTransition();
                this.dotsTransition();
                this.dotsLabelTransition();
                this.areaAnimation();
                this.lineDraw = true;
            }
        },
        lineTransition: function lineTransition() {
            this.svg.select(".perso-line")
                .style("stroke-opacity", 1)
                .transition()
                .duration(this.options.lineDuration)
                .attrTween("stroke-dasharray", function () {
                    var len = this.getTotalLength();
                    return function (t) {
                        return (d3.interpolateString("0," + len, len + ",0"))(t)
                    };
                });
        },
        dotsTransition: function dotsTransition() {
            this.graph.selectAll(".perso-dot")
                .transition()
                .delay(this.options.dotsDelay)
                .duration(this.options.dotsDuration)
                .attr("r", this.getValueByScreenWidth(this.options.dots_radius));

            this.graph.select("circle.perso-dot-selected")
                .transition()
                .delay(this.options.dotsDelay)
                .duration(this.options.dotsDuration)
                .attr("r", this.getValueByScreenWidth(this.options.dots_radius_selected));
        },
        dotsLabelTransition: function dotsLabelTransition() {
            this.graph.select("rect.perso-dot-label")
                .transition()
                .delay(this.options.dotsLabelDelay)
                .duration(this.options.dotsDuration)
                .attr("rx", this.getValueByScreenWidth(this.options.dotRect.dot_label_radius))
                .attr("ry", this.getValueByScreenWidth(this.options.dotRect.dot_label_radius))
                .attr("opacity", 1)
            this.graph.select("polygon.perso-dot-label-polygon")
                .transition()
                .delay(this.options.dotsLabelDelay)
                .duration(this.options.dotsDuration)
                .attr("opacity", 1);
            this.graph.select("text.perso-dot-label-text")
                .transition()
                .delay(this.options.dotsLabelDelay)
                .duration(this.options.dotsDuration)
                .attr("opacity", 1);
            this.graph.select("text.perso-dot-label2-text")
                .transition()
                .delay(this.options.dotsLabelDelay)
                .duration(this.options.dotsDuration)
                .attr("opacity", 1);
        },
        areaAnimation: function areaAnimation() {
            this.svg.select(".perso-line-area")
                .transition()
                .delay(this.options.areaDelay)
                .duration(this.options.areaDuration)
                .attr('opacity', 1);
        },

        getSelectedMonth: function () {
            var helper = this;
            var highlightedTickDate = new Date();
            var highlightedDotIndex = (helper.highlightedCategory) ? helper.getHighlightedCategory() : helper.setHighlightDot();
            if (typeof highlightedDotIndex != 'undefined') {
                if (typeof this.seriesData[highlightedDotIndex] != 'undefined' && this.seriesData[highlightedDotIndex] !== null) {
                    highlightedTickDate = new Date(this.seriesData[highlightedDotIndex].category);
                }
            }
            return highlightedTickDate;
        },

        getDataFilter: function () {
            var helper = this;
            var dates = [];
            this.seriesData.forEach(function (item) {
                if (helper.isDateInCategories(item.category)) {
                    dates.push(item);
                }
            })
            return dates;
        },

        isDateInCategories: function (date) {
            var categoriesArr = this.categoriesData;
            var isDateExist = false;
            if (typeof  date != 'undefined' && date !== null) {
                categoriesArr.forEach(function (category, index) {
                    if (category.value == date) {
                        isDateExist = true;
                    }
                })
            }
            return isDateExist;
        },

        setHighlightDot: function () {
            var helper = this;
            /**
             * This function set the highlighted dot and return the index */
            var highlightKeys = {
                MAX: 'max',
                MIN: 'min',
                LAST: 'last',
                FIRST: 'first'
            };

            var maxValueInCategories = d3.max(this.seriesData, function (d) {
                if (helper.isDateInCategories(d.category))
                    return parseFloat(d.value);
            });
            var minValueInCategories = d3.min(this.seriesData, function (d) {
                if (helper.isDateInCategories(d.category))
                    return parseFloat(d.value);
            });

            var highlightKey = helper.options.highlightBy;
            var index = helper.seriesData.length - 1;

            switch (highlightKey) {
                case highlightKeys.MAX:
                    var maxObjIndex = helper.getObjIndexByValue(helper.seriesData, maxValueInCategories);
                    helper.seriesData[maxObjIndex].highlight = true;
                    index = maxObjIndex;
                    break;

                case highlightKeys.MIN:
                    var minObjIndex = helper.getObjIndexByValue(helper.seriesData, minValueInCategories);
                    helper.seriesData[minObjIndex].highlight = true;
                    index = minObjIndex;
                    break;

                case highlightKeys.FIRST:
                    helper.seriesData[0].highlight = true;
                    index = 0;
                    break;

                default:
                    var lastIndex = helper.seriesData.length - 1;
                    helper.seriesData[lastIndex].highlight = true;
            }
            return index;
        },
        getHighlightedCategory: function () {
            var helper = this;
            var index = helper.seriesData.length - 1; // default index!
            if (helper.highlightedCategory) {
                $.each(helper.seriesData, function (i, categoryData) {
                    if (categoryData.category == helper.highlightedCategory) {
                        index = i;
                        return false;
                    }
                });
            }
            return index;
        },
        setHighlightedCategory: function () {
            var helper = this;
            var highlightedCategoryIndex = helper.getHighlightedCategory();
            if (highlightedCategoryIndex) {
                helper.seriesData[highlightedCategoryIndex].highlight = true;
            }
        },
        getObjIndexByValue: function (data, value) {
            var index = $.map(data, function (obj, index) {
                if (obj.value == value) {
                    return index;
                }
            })
            return index[0];
        },

        setInterpolate: function (interpolate) {
            var interpolateKeys = {
                Default: 'cardinal',
                Linear: 'linear',
                Monotone: 'monotone'
            }
            var _interpolate = interpolateKeys.Default;

            switch (interpolate) {
                case interpolateKeys.Monotone:
                    _interpolate = interpolateKeys.Monotone;
                    break;

                case interpolateKeys.Linear:
                    _interpolate = interpolateKeys.Linear;
                    break;

                default:
                    _interpolate;
            }
            return _interpolate;
        },

        getValueByScreenWidth: function (value) {
            var screenWidth = $(window).width();
            if (screenWidth >= 790) {
                return value;
            }
            else {
                if (screenWidth < 347) {
                    return value;
                } else if (screenWidth >= 414) {
                    return value * this.options.screen.ratio_large;
                } else {
                    return value * this.options.screen.ratio_medium;
                }
            }
        },

        renderAccessibilityData: function (frameEl, texts) {
            this.texts = texts;
            var id = frameEl.parents(".pstory-dialog-frame").attr("id") + frameEl.index();
            var content = this.getAccessibilityTitle() + '. ' + this.prepareAccessibilityText();
            var parentNode = frameEl.find(".perso-svg-chart-container")[0];

            d3.select(parentNode).append("title").attr("id", id + "_title").text(content);
            d3.select(parentNode).attr("role", "presentation");
            this.svg.attr('aria-labelledby', id + '_title');
            this.svg.selectAll("*").attr('aria-hidden', true);
        },

        filterSeriesByCategories: function () {
            var categories = this.categoriesData;
            var series = this.seriesData;
            var filterdSeries = [];

            for (var i = 0; i < categories.length; i++) {
                for (var j = 0; j < series.length; j++) {
                    if (series[j].category === categories[i].value) {
                        var matchedItem = {
                            label: categories[i].label,
                            value: series[j].value
                        };
                        if (series[j].highlight) {
                            matchedItem.highlight = true;
                        }
                        filterdSeries.push(matchedItem);
                        break;
                    }
                    ;
                }
            }
            return filterdSeries;
        },

        prepareAccessibilityText: function () {
            var block = this;
            var content = '';
            var filteredData = this.filterSeriesByCategories();
            var reversedFilterdData = filteredData.slice().reverse();
            // first add the highlighted dot
            $.each(reversedFilterdData, function (i, item) {
                if (item.highlight) {
                    content = block.getAccessibilityHighlightedDotlbl() + ', ' + item.label + ', ' + Math.round(item.value) + ',';
                }
            });
            // add the rest
            $.each(reversedFilterdData, function (i, item) {
                if (!item.highlight) {
                    content += ' ' + item.label + ', ' + Math.round(item.value) + ',';
                }
            });
            return content;
        },

        getAccessibilityTitle: function getAccessibilityTitle() {
            return this.texts.accessibilityLineChartTitle;
        },

        getAccessibilityHighlightedDotlbl: function () {
            return this.texts.accessibilityLineGraphHighlightedDot;
        },
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.HorizontalChartHelper = Personetics.utils.d3Helpers.BlockHelperBase.extend({
        prepareChart: function(el){},
        renderChart: function (){},
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.MultiHorizontalChartHelper = Base.extend({
        localConfigs:{
            barFillPercent: 0.55
        },
        prepareMultiHorizontalChart: function (block, el) {
            this.prepareChart(block ,el);
            this.maxDataArraLength = this.getMaxDataArray(block.layoutInstructions.series);        
            //this.margin = {top: this.getValueByScreenWidth(this.options.margin.top), right: 0, bottom: 0, left: 19};
            this.height = block.options.chartHeight || (this.maxDataArraLength * block.layoutInstructions.series.length *
                        (this.getValueByScreenWidth(block.options.rectangles.height) + 
                        this.getValueByScreenWidth(this.options.rectangles.paddingBottom) * 2)+ 
                        block.layoutInstructions.seriesLabels.length * this.options.rectangles.seriesPadding / 2);
            this.localConfigs.barFillPercent = this.options.rectangles.barFillPercent ? this.options.rectangles.barFillPercent :this.localConfigs.barFillPercent;

            this.xScale = d3.scale.linear().range([0, this.width * this.localConfigs.barFillPercent]);// TODO - 0.27 should be added to configs in RBC skin
            this.colorScale = d3.scale.ordinal().rangeRoundBands([0, this.width], .1);
            var palette = block.layoutInstructions.seriesLabels[0] === 'In'? block.defaultConfig.barGraphPalette : block.defaultConfig.barGraphPalette.reverse();
            var paletteLabels = block.defaultConfig.barGraphLabelsPalette;
            this.colors = this.colorScale.range(palette);
            this.colorsLabels = d3.scale.ordinal().rangeRoundBands([0, this.width], .1).range(paletteLabels);

            this.y0Scale = d3.scale.ordinal().domain(d3.range(block.layoutInstructions.categories.length)).rangeBands([this.height, 0], 0.05);//???
            this.y1Scale = d3.scale.ordinal().domain(d3.range(block.layoutInstructions.series.length)).rangeBands([this.y0Scale.rangeBand(), 0], 0.05); //TODO - 0.25 should be added to configs in RBC skin
            this.y2Scale = d3.scale.ordinal().domain(block.layoutInstructions.categories).rangeBands([0, this.height]);

            this.xAxis = d3.svg.axis()
                .scale(this.xScale)
                .orient("bottom");
            this.yAxis = d3.svg.axis()
                .scale(this.y2Scale)
                .orient("right")
        },
        renderMultiHorizontalChart: function (block ,el, data) {
            this.seriesData = data.series;
            this.seriesLabelsData = data.seriesLabels;
            var cfg = block.config;

            var xScale = this.xScale;
            var y0Scale = this.y0Scale;
            var y1Scale = this.y1Scale;
            var y2Scale = this.y2Scale;

            xScale.domain([0, d3.max(data.series, function (d) {
                return d3.max(d, function (k) {
                    return k.value;
                });
            })]);

            this.modifyData();
            this.svg = this.renderSVGBase(el, "multiHorizontal");
            this.renderGradient();
            this.renderFilter();
            this.renderMultiHorizontalBars(block, data, xScale, y1Scale, y0Scale);
            this.renderHorizontalLines(data, xScale, y0Scale, y1Scale);
            this.renderLabels(data, xScale, y0Scale, y1Scale);
            this.renderYAxis();
        },
        renderSVGBase: function(el, clazz){
            var helper = this;
            if(!clazz){
                clazz = '';
            }
            return(d3.select(el.get(0)).append("svg")
                .attr("focusable", false)
                .attr("class","perso-svg-chart-container " + clazz)
                .attr("width", helper.width)
                .attr("height", helper.height)
                .append("g")
                .attr("transform", "translate(" + helper.getValueByScreenWidth(helper.margin.left) + "," + helper.getValueByScreenWidth(helper.margin.top) + ")"));

        },
        renderMultiHorizontalBars: function (block, data, xScale, y1Scale, y0Scale) {
            var helper = this
            helper.sortedData = helper.sortData();
            // merge data to one array to get max and min value
            var mergedData = [].concat.apply([], data.series);
            helper.minValue = d3.min(mergedData, function(d) {
                return d.value || Infinity;
            });
            helper.maxValue = d3.max(mergedData, function(d) {
                return d.value;
            });
            var blockWithBars = this.svg.append("g")
                .attr("transform", function (d, i) {
                    var yValue = helper.getValueByScreenWidth(helper.options.rectangles.paddingTop);
                    var xValue = helper.getValueByScreenWidth(helper.options.rectangles.paddingLeft);
                    return "translate(" + xValue + "," + yValue + ")";
                })
                .attr("width", helper.width)
                .selectAll("g")
                .data(helper.sortedData)
                .enter().append("g")
                .style("fill", function (d, i) {
                    return helper.colors(i);
                })
                .attr("transform", function (d, i) {
                    var screenWidth = screen.width;
                    var y = helper.options.rectangles.paddingBottom;
                    y = y1Scale(i) * (i + 1) + helper.getValueByScreenWidth(y) * (i + 1);
                    return "translate(0," + y + ")";
                })
                .selectAll("rect")
                .data(function (d) {
                    return d
                });

            blockWithBars.enter().append("rect")
                .attr("class", function(d){
                    var clazz = 'perso-chart-rect'+ ' ' + d.mode;
                    if(d.selected){
                        clazz +=" selected";
                    }
                    return clazz;
                })
                .attr("height", function (d, i) {
                    var rectHeight = helper.options.rectangles.height;
                    return helper.getValueByScreenWidth(rectHeight);
                })
                .attr("y", function (d, i) {
                    return y0Scale(i);
                })
                .attr("width", 1)
                .attr("rx", function (d) {
                    var rx = (helper.options.rectangles.borderRadius.rx) ? helper.options.rectangles.borderRadius.rx : "0";
                    return helper.getValueByScreenWidth(rx);
                })
                .attr("ry", function (d) {
                    var ry = (helper.options.rectangles.borderRadius.ry) ? helper.options.rectangles.borderRadius.ry : "0";
                    return helper.getValueByScreenWidth(ry);
                })
                .on("click", function (obj, clickedItemIndex) {
                if (block)
                    block.handleClick(obj, clickedItemIndex);
            });

            blockWithBars.transition()
                .duration(1000)
                .delay(500)
                .attr("width", function (d) {
                var maxBarWidth = helper.width * 0.4;
                var minBarWidth = maxBarWidth * .166;
                var minValueInArray = helper.minValue;
                var maxValueInData = helper.maxValue
                var currentValue = d.value;
                var currentBarWidth = xScale(currentValue);

                var rectWidth = minBarWidth;;
                if( (currentValue / maxValueInData) > 0.166 || currentValue > minValueInArray){
                    rectWidth += currentBarWidth;
                } else if(currentValue == 0){
                    rectWidth = currentBarWidth;
                }
                return rectWidth;//todo set this value on Skin-Ctrl
            })


        },
        renderLabels: function (data, xScale, y0Scale, y1Scale) {
            var helper = this;
            if (this.options.drawLabels) {
                var blockWithdata = this.svg.append("g")
                    .attr("transform", function (d, i) {
                        var yValue = helper.getValueByScreenWidth(helper.options.rectangles.paddingTop);
                        var xValue = helper.getValueByScreenWidth(helper.options.rectangles.paddingLeft);
                        return "translate(" + xValue + "," + yValue + ")";
                    })
                    .attr("width", helper.width)
                    .selectAll("g")
                    .data(data.series)
                    .enter().append("g")
                    .attr("transform", function (d, i) {
                        var y = helper.options.rectangles.paddingBottom;
                        y = y1Scale(i) * (i + 1) + helper.getValueByScreenWidth(y) * (i + 1);
                        return "translate(-7," + y + ")";
                    })
                    .selectAll("text")
                    .data(function (d) {
                        return d
                    });

                blockWithdata.enter()
                    .append("text")
                    .attr("class", function(d){
                        var clazz = 'perso-label perso-label-fadeIn';
                        if(d.selected){
                            clazz +=" selected";
                        }
                        return clazz;
                    })
                    .attr("text-anchor", "start")
                    .style("fill", function (d, i, j) {
                        return helper.colorsLabels(j);
                    })
                    .attr("x", function (d) {
                        var paddingLeft = (helper.options.labels.paddingLeft) ? helper.options.labels.paddingLeft : "0";
                        var xValue = xScale(d.value) + helper.getValueByScreenWidth(paddingLeft);
                        // var chartWidth = helper.width * 0.4;
                        return xValue;
                    })
                    .attr("y", function (d, i) {
                        return y0Scale(i) + helper.options.rectangles.height / 2;
                    })
                    .attr("dy", "0.4em")
                    .html(function (d) {
                        return d.label;
                    });
            }
        },
        renderYAxis: function () {
            var helper = this;
            if (this.yAxis) {
                var transValue = helper.getValueByScreenWidth(this.options.axis.yAxis.transValue);
                this.svg.append("g")
                    .attr("transform", "translate(" + helper.options.axis.yAxis.paddingRight * -1 + "," + transValue + ")")
                    .attr("class", "y axis")
                    .call(helper.yAxis)
                    .selectAll(".tick text")
                    .call(helper.wrapLabelText, screen.width * .23);
            }
            if (this.options.axis.yAxis.hide) {
                this.svg.selectAll(".y .tick text").remove();
                this.svg.selectAll(".y path").remove();
            }

        },
        getMaxDataArray:function (data){
            var maxLength = 0;
            if(data.length){
                $.each(data, function (i,array) {
                    if(array.length > maxLength){
                        maxLength = array.length;
                    }
                })
            }
            return maxLength;
        },
        wrapLabelText: function(text, width) {
            text.each(function() {
                var text = d3.select(this);
                var yValue = 0;
                var lines = 1;
                if(this.getComputedTextLength() > width){
                    lines = 2;
                    yValue = -5;
                }

                var words = text.text().split(/\s+/).reverse(),
                    word,
                    line = [],
                    lineNumber = 0,
                    lineHeight = .95, // ems
                    y = text.attr("y"),
                    dy = parseFloat(text.attr("dy")),
                    tspan = text.text(null).append("tspan").attr("x", 9).attr("y", yValue * lines).attr("dy", dy + "em");
                while (word = words.pop()) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan").attr("x", 9).attr("y", yValue * lines).attr("dy", (++lineNumber * lineHeight * 1.5) + dy + "em").text(word);
                    }
                }

            });
        },
        /**from helper base */
        prepareChart: function (block ,el) {
            this.options = block.options;
            this.totalWidth = el.width();
            this.margin = {top: this.getValueByScreenWidth(this.options.margin.top), 
                            right: this.getValueByScreenWidth(this.options.margin.right), 
                            bottom: this.getValueByScreenWidth(this.options.margin.bottom), 
                            left: this.getValueByScreenWidth(this.options.margin.left)};
            this.width = el.width() - this.margin.left - this.margin.right;
        },
        
        renderHorizontalLines: function (data, xScale, y0Scale,y1Scale) {
            var helper = this;
            if (this.options.drawLine){
                var lines = this.svg.append("g")
                    .attr("transform", "translate(" + helper.margin.left * -1 + "," + 0 + ")")
                    .selectAll("g")
                    .data(data.series)
                    .enter()
                    .append("g")
                    .attr("class", "perso-chart-line")
                    .attr("transform", function (d, i) {
                        var y = y1Scale(i) * (i + 1);
                        return "translate(0," + y + ")";
                    })
                    .selectAll('.line')
                    .data(function (d) {
                        return d
                    })
                    .enter().append("line")
                    .attr("class", "perso-chart-line")
                    .attr("x1", "0")
                    .attr("x2", helper.totalWidth)//TODO - add line width to configs
                    .attr("y1", function (d, i) {
                        //return y0Scale(i);
                        return y0Scale(i);
                    })
                    .attr("y2", function (d, i) {
                        //return y0Scale(i);
                        return y0Scale(i);
                    })
            }
        },
        renderGradient: function(){
            var gradients = this.options.rectangles.gradients;
            var defWithGradients = this.svg.append("defs");
            if(gradients){
                $.each(gradients, function(i, gradient){
                    if(gradient){
                        defWithGradients = defWithGradients.append("linearGradient")
                            .attr("id",gradient.id)
                            .attr("x1","0")
                            .attr("x2","0")
                            .attr("y1","0")
                            .attr("y2","1");
                //TODO refactoring!! replace to each
                        defWithGradients.append("stop")
                            .attr("offset",gradient.offset1)
                            .attr("stop-color", gradient.stopColor1);

                        defWithGradients.append("stop")
                            .attr("offset",gradient.offset2)
                            .attr("stop-color", gradient.stopColor2)

                    }
                });
            }
        },
        renderFilter: function(){
            var filters = this.options.rectangles.filter;
            var svgWithFilters = this.svg.selectAll("defs");
            if(filters){
                $.each(filters, function(i, filter){
                    if(filter){
                        var filterSvg = svgWithFilters.append("filter")
                            .attr("id", filter.id)

                        filterSvg.append("feGaussianBlur")
                            .attr("in", filter.in)
                            .attr("stdDeviation",filter.stdDeviation)

                        filterSvg.append("feOffset")
                            .attr("dx", filter.dxOffset)
                            .attr("dy", filter.dyOffset)
                        var feMerge = filterSvg.append("feMerge")

                        feMerge.append("feMergeNode")

                        feMerge.append("feMergeNode")
                            .attr("in", filter.in);
                    }
                })
            }
        },
        getValueByScreenWidth: function(value){
            var screenWidth = $(window).width();
            if(screenWidth >= 790){
                return value;
            }
            else{
                if (screenWidth < 347) {
                    return value;
                } else if (screenWidth >= 414) {
                    return value * this.options.screen.ratio_large;
                } else {
                    return value * this.options.screen.ratio_medium;
                }   
            }                  
        },
        modifyData: function(){
            var helper = this;
            if(this.seriesData){
                var series = this.seriesLabelsData;
                $.each(series, function(i){
                    $.each(helper.seriesData[i],function (k, seriesObj) {
                        seriesObj.mode = series[i];
                    })
                });
            }
        },
        sortData: function(){
            var helper = this;
            if(this.seriesData){
                var reversedLabels = this.seriesLabelsData.slice().reverse();
                var sortedData = [];
                reversedLabels.forEach(function(series, i){
                    sortedData[reversedLabels.indexOf(helper.seriesLabelsData[i])] = helper.seriesData[i];
                });
            }
            return sortedData;
        }

    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.VerticalChartHelperProduct = Personetics.utils.d3Helpers.VerticalChartHelper.extend({
        renderXAxis: function(){
            var helper = this;
            if (this.xAxis) {
                this.svg.append("g")
                    .attr("class", "x axis")
                    .attr("transform", function(d,i){
                        var y = helper.getValueByScreenWidth(helper.options.xAxisTop);//helper.yScale(0);
                    
                    return ("translate("+ helper.calcLeft + "," + y + ")");
                })
                .call(helper.xAxis)
                .selectAll(".tick text")
                    .data(helper.seriesData)
                    .attr("y", "0")
                    .attr("class", function(d){
                        var clazz = "perso-xAxis-label";
                        if(d.selected){
                            clazz +=" selected";
                        }
                        return clazz;
                    })
                    .on("click", function (obj, clickedItemIndex) {
                        if (typeof helper.handleClick == 'function')
                            helper.handleClick(obj, clickedItemIndex);
                    });
            }
        }
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.PinGraphChartHelperProduct = Personetics.utils.d3Helpers.VerticalChartHelperProduct.extend({
        
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.LineChartHelperOpenBank = Personetics.utils.d3Helpers.NewLineChartHelper.extend({
        
        getValueByScreenWidth: function (value) {
            var screenWidth = $(window).width();
            if (screenWidth >= 790) {
                return value;
            }
            else
                return value * (screenWidth / 320);
        },

        getHighlightedCategory: function () {
            var helper = this;
            var index = - 1;
            if (helper.highlightedCategory) {
                $.each(helper.seriesData, function (i, categoryData) {
                    helper.seriesData.highlight = false;
                    if (new Date(categoryData.category).toDateString() == new Date(helper.highlightedCategory).toDateString()) {
                        index = i;
                        return false;
                    }
                });
            }
            if (index == -1) {
                index = this.setHighlightDot();
            }
            helper.seriesData[index].highlight = true;
            return index;
        },

        isDateInCategories: function (date) {
            var categoriesArr = this.categoriesData;
            var isDateExist = false;
            if (typeof date != 'undefined' && date !== null) {
                categoriesArr.forEach(function (category, index) {
                    if (new Date(category.value).toDateString() == new Date(date).toDateString()) {
                        isDateExist = true;
                    }
                })
            }
            return isDateExist;
        },

        renderXAxis: function () {
            var highlightedTickDate = this.getSelectedMonth();

            if(this.options.xAxis_display){
                var x_Axis = this.svg.append("g")
                    .attr("name", "x axis")
                    .attr("class", "perso-line-x axis")
                    .call(this.xAxis);

                x_Axis.selectAll('.perso-line-x.axis line')
                    .attr("x1",this.getValueByScreenWidth(this.options.xAxis_line_x))
                    .attr("x2",this.getValueByScreenWidth(this.options.xAxis_line_x))
                    .attr("y1",this.getValueByScreenWidth(this.options.xAxis_line_y));

                x_Axis.selectAll(".perso-line-x.axis text")
                    .attr("y",this.getValueByScreenWidth(this.options.xAxis_text_y))
                    .attr("x",this.getValueByScreenWidth(this.options.xAxis_text_x))
                    .attr("class", function (d) {
                        var _class = "tick";
                        if (d.getTime() == highlightedTickDate.getTime()) {
                            _class = "highlighted-text";
                        }
                        return _class;
                    });
            }
        },

        renderDotsLabel: function renderDotsLabel() {
            var helper = this;
            var dotText = [];
            var dotText2 = [];
            var dotRectX;
            var categoryIndex;

            var textG = this.graph.append("g")
                .attr("name", "dots-text");

            textG.selectAll("dot-text")
                .data(this.seriesData.filter(function (d) {
                    if (d.highlight && typeof d.label != 'undefined') {
                        return true;
                    }
                    return false;
                }))
                .enter()
                .append("text")
                .attr("x", function (d) {
                    dotText.push(this);
                    return helper.getValueByScreenWidth(helper.options.dotText.xOffset)
                })
                .attr("y", function (d) {
                    return helper.getValueByScreenWidth(helper.options.dotText.yOffset)
                })
                .attr("opacity", 0)
                .attr("class", function (d) {
                    var _class = "perso-dot-label-text";
                    return _class;
                });

            // support IE
            if (dotText.length > 0) {
                var amounts = dotText[0];
                var tspans = d3.select(amounts).append('tspan');

                $.each(tspans[0], function (index, tspan) {
                    var highlightObj = helper.seriesData.filter(function (item) {
                        return item.highlight;
                    })
                    if (typeof highlightObj[index].label != 'undefined') {
                        var attrs = $(highlightObj[index].label)[0].attributes;
                        $.each(attrs, function (j, attr) {
                            tspan.setAttribute(attr.name, attr.value);
                        });
                        $(tspan).attr("perso-index", index);
                        var totalAmountChildren = $($(highlightObj[index].label)[0]).children();
                        $.each(totalAmountChildren, function (i, node) {
                            var svgTspan = helper.svg.select('[perso-index="' + index + '"]');
                            var innerTspan = svgTspan.append('tspan').text($(node).text());
                            var attrs = node.attributes;
                            $.each(attrs, function (j, attr) {
                                innerTspan.attr(attr.name, attr.value);
                            });
                        });
                    }
                });
            }

            if (dotText.length > 0) {
                textG.append("circle")
                    .attr("cx",helper.getValueByScreenWidth(helper.options.dotCircle.xOffset))
                    .attr("cy",helper.getValueByScreenWidth(helper.options.dotCircle.yOffset))
                    .attr("opacity", 0)
                    .attr("r", helper.getValueByScreenWidth(helper.options.dotCircle.radius))
                    .attr("class", function (d) {
                        var _class = "perso-dot-label-circle";
                        return _class;
                    });
            }
        },

        dotsLabelTransition: function dotsLabelTransition() {
            Personetics.utils.d3Helpers.NewLineChartHelper.prototype.dotsLabelTransition.call(this);
            this.graph.select("circle.perso-dot-label-circle")
                .transition()
                .delay(this.options.dotsLabelDelay)
                .duration(this.options.dotsDuration)
                .attr("opacity", 1);
        },
        areaAnimation: function areaAnimation() {
            this.svg.select(".perso-line-area")
                .transition()
                .delay(this.options.areaDelay)
                .duration(this.options.areaDuration)
                .attr('opacity', 0.2);
        },

        renderArea: function () {
            var helper = this;
            if (this.options.area_display) {
                var linearScale = d3.scale.linear()
                    .rangeRound([helper.getValueByScreenWidth(helper.options.xAxis_line_height+(helper.options.xAxis_line_y-helper.options.line_top)), 0]);
                this.area = d3.svg.area()
                    .interpolate(this.setInterpolate(this.options.lineStyle_interpolate))
                    .x(function (d) {
                        return helper.xScale(new Date(d.category));
                    })
                    .y1(function (d) {
                        return helper.yScale(d.value);
                    })
                    .y0(linearScale(0));

                this.svg.append("path")
                    .attr("transform", "translate(0," +
                        this.getValueByScreenWidth(this.options.line_top) + ")")
                    .datum(this.seriesData)
                    .attr("d", this.area)
                    .attr("class", "perso-line-area")
                    .attr("opacity", 0);

                var areaGradient = this.svg.append('defs')
                    .append('linearGradient')
                    .attr('id', 'areaGradient')
                    .attr('y1','0')
                    .attr('y2','1');
                areaGradient.append('stop')
                    .attr('class', 'stop-up')
                    .attr('offset', '0');
                areaGradient.append('stop')
                    .attr('class', 'stop-down')
                    .attr('offset', '1');
            }
        },

        renderDots: function () {
            Personetics.utils.d3Helpers.NewLineChartHelper.prototype.renderDots.call(this);
            var selectedDot = this.graph.select("circle.perso-dot")
            .attr("id","b")
           
            var filter = this.graph.append("defs")
            .append("filter")
            .attr("x","-50%")
            .attr("y","-28.9%")
            .attr("width","200%")
            .attr("height","200%")
            .attr("filterUnits","objectBoundingBox")
            .attr("id","a")

            filter.append("feOffset")
            .attr("dy",this.options.dots_shadow)
            .attr("in","SourceAlpha")
            .attr("result","shadowOffsetOuter1")

            filter.append("feGaussianBlur")
            .attr("stdDeviation","2.5")
            .attr("in","shadowOffsetOuter1")
            .attr("result","shadowBlurOuter1")

            filter.append("feComposite")
            .attr("in","shadowBlurOuter1")
            .attr("in2","SourceAlpha")
            .attr("operator","out")
            .attr("result","shadowBlurOuter1")
            
            filter.append("feColorMatrix")
            .attr("values","0 0 0 0 0.984 0 0 0 0 0.722 0 0 0 0 0 0 0 0 1 0")
            .attr("in","shadowBlurOuter1")

            var g = this.graph.select("[name=dots]")
            .append("g")

            g.append("circle")
            .attr("cx",selectedDot.attr("cx"))
            .attr("cy",selectedDot.attr("cy"))
            .attr("r",this.options.dots_radius_shadow)
            .attr("fill","#FFF")
            .attr("fill-opacity",".74")

            var group = g.append("g")
            
            group.append("use")
            .attr("filter","url(#a)")
            .attr("xlink:href","#b")
            
            group.append("use")
            .attr("xlink:href","#b")

            
        },
        renderLine: function () {
            Personetics.utils.d3Helpers.NewLineChartHelper.prototype.renderLine.call(this);
            var filter = this.graph.select("g")
            .append("defs")
            .append("filter")
            .attr("id","shadow")
            .attr("x","0")
            .attr("width","100%")
            .attr("height","200%")

            filter.append("feOffset")
            .attr("result","offOut")
            .attr("in","SourceGraphic")
            .attr("dy","5")
            .attr("dx","0")

            filter.append("feGaussianBlur")
            .attr("result","blurOut")
            .attr("in","offOut")
            .attr("stdDeviation","2")

            filter.append("feBlend")
            .attr("mode","normal")
            .attr("in","SourceGraphic")
            .attr("in2","blurOut")
        }
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.MultiHorizontalChartHelperOpenBank = Personetics.utils.d3Helpers.MultiHorizontalChartHelper.extend({

        renderSVGBase: function renderSVGBase(el, clazz) {
            var helper = this;
            var screenWidth = $(window).width();
            if (screenWidth >= 790) {
                helper.height = helper.options.MultiHorizontalChartHeightDesktop;
                helper.margin.left = 30;
                helper.margin.top = 32;
            } else {
                helper.height = helper.getValueByScreenWidth(helper.options.svgHeight);
            }

            if (!clazz) {
                clazz = '';
            }

            return d3.select(el.get(0)).append("svg").attr("focusable", false).attr("class", "perso-svg-chart-container " + clazz).attr("width", helper.width).attr("height", helper.height).append("g").attr("transform", "translate(" + helper.getValueByScreenWidth(helper.margin.left) + "," + helper.getValueByScreenWidth(helper.margin.top) + ")");
        },
        renderGradient: function(){
            var gradients = this.options.rectangles.gradients;
            var defWithGradients = this.svg.append("defs");
            var linearGradient;
            if(gradients){
                $.each(gradients, function(i, gradient){
                    if(gradient){
                        linearGradient = defWithGradients.append("linearGradient")
                            .attr("id",gradient.id)
                            .attr("x1","0")
                            .attr("x2","0")
                            .attr("y1","0")
                            .attr("y2","1");

                        $.each(gradient.stopColors, function(i,stopColor){
                            linearGradient.append("stop")
                            .attr("offset",gradient.offset[i])
                            .attr("stop-color", stopColor);
                        })
                    }
                });
            }
        },
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.CollapseHelper = Base.extend({
        initialize: function initialize(params){
            this.fixedContainer = params.fixedContainer ? params.fixedContainer : params.el.find('.pstory-block-container');
            this.fixedWrapper = this.fixedContainer.parent();
            params.el.parents('.pstory-dialog-frame').removeClass('perso-collapsed-animation');
            params.el.addClass('perso-collapsed');
            this.fixedContainer.addClass('pstory-fixed');
            this.collapsedHeight = this.fixedContainer.outerHeight();
            params.el.removeClass('perso-collapsed');
            this.fixedContainer.removeClass('pstory-fixed');
            this.diffHeight = this.fixedContainer.outerHeight() - this.collapsedHeight;
            this.heightForElementDisplayed = params.uxCtrl.getCollapseOptions(params).displayedHeight;            
        },
        scrollEvent: function(block, elementDisplayed, skipAnimation){           
            this.elementDisplayed = elementDisplayed;
            this.heightPrevFixedElements = this.getHeightPrevFixedElements();
            var displayElementTop = this.fixedWrapper.offset().top + this.fixedWrapper.height() - this.heightForElementDisplayed + this.diffHeight;//block.frameEl.offset().top + block.frameEl.height() - this.heightForElementDisplayed;
            var topOffset = this.fixedWrapper.offset().top;
            if(typeof this.isCollapsed  != 'undefined'
                && this.isCollapsed == true
                && topOffset >= this.topFixedContainer){
                    this.isCollapsed = false;
                    this.doUnCollapse(block);
            }
            else if(displayElementTop <= this.heightPrevFixedElements ){
                if(typeof this.isCollapsed  == 'undefined' || this.isCollapsed == false){
                    this.isCollapsed = true;
                    if(typeof block.story.options !== 'undefined' && (typeof block.story.options.enableCollapse == 'undefined' || block.story.options.enableCollapse == true)){
                        this.doCollapse(block, skipAnimation);
                    }
                }
            }
        },
        getHeightPrevFixedElements: function getHeightPrevFixedElements(){
            this.prevCollapsed = $('.pstory-fixed').last();//$('.perso-collapsed').last().find('.pstory-block-container');
            if(this.prevCollapsed.length > 0){
                var prevCollapsedTop = this.prevCollapsed.offset().top;
                var prevCollapsedHeight = parseFloat(this.prevCollapsed.attr('collapsed-height') || this.prevCollapsed.outerHeight());
                return prevCollapsedTop + prevCollapsedHeight;
            }
            return 0;

        },

        doCollapse: function(block, skipAnimation){

            
                      
            /**the fixed element */
            if($.isFunction(block.onBeforeCollapsed)) {
                block.onBeforeCollapsed(this.fixedContainer);
            }
            if(block.frameEl.is(':last-child'))
                block.frameEl.parents('.pstory-dialog-frame').next().addClass('pstory-dialog-collapsed');
            
            /**save the wrapper height */
            this.fixedWrapper.height(this.fixedWrapper.outerHeight());

            this.fixedContainer.attr('collapsed-height', this.collapsedHeight);

            /**the fixedContainer top */
            this.topFixedContainer = Math.min(0,this.heightForElementDisplayed - this.fixedContainer.outerHeight()) + this.heightPrevFixedElements + this.diffHeight;
            this.fixedContainer.css({'top': this.topFixedContainer + 'px'});

            /**z-index */
            var zIndex = 999;
            if(this.prevCollapsed.length > 0)
            zIndex = this.prevCollapsed.css('z-index') -1;
            this.fixedContainer.css({'z-index': zIndex});

            /**change margin to padding for background */
            /*var marginRight = block.frameEl.css('margin-right');
            var marginLeft = block.frameEl.css('margin-left');
            this.fixedContainer.css({'padding-right': marginRight, 'padding-left': marginLeft});*/
            
            if(skipAnimation == true)
                block.frameEl.parents('.pstory-dialog-frame').removeClass('perso-collapsed-animation');
            else
                block.frameEl.parents('.pstory-dialog-frame').addClass('perso-collapsed-animation');

            block.frameEl.removeClass('perso-unCollapsed');
            block.frameEl.addClass('perso-collapsed');
            this.fixedContainer.addClass('pstory-fixed');
            this.bindEvents(block);
            if($.isFunction(block.onCollapsed)) {
                block.onCollapsed(this.elementDisplayed, this.heightForElementDisplayed, this.fixedContainer);
            }
        },
        doUnCollapse: function(block){
            this.unBindEvents();
            block.frameEl.parents('.pstory-dialog-frame').next().removeClass('pstory-dialog-collapsed');//.height(block.frameEl.parents('.pstory-dialog-frame').height());

            block.frameEl.removeClass('perso-collapsed');
            this.fixedContainer.removeClass('pstory-fixed');

            if($.isFunction(block.onUnCollapsed))
                block.onUnCollapsed(this.elementDisplayed);
        },
        bindEvents : function(block){
            var mousedown = false;
            if(!jQuery._data(this.fixedContainer.get(0), 'events') || !jQuery._data(this.fixedContainer.get(0), 'events').mousewheel) {
                this.fixedContainer.bind('mousewheel', this.scrollOnFixedElemment);
                var mousedownPageY;
                this.fixedContainer.bind({
                    'touchmove': function(e) {
                        mousedown &&  removeScroll(block);
                    },
                    'touchstart': function(e) {
                        mousedown = true;
                        mousedownPageY = e.originalEvent.touches[0].pageY;
                    },
                    'touchend': function() {
                        updateScroll(block);
                        mousedown = false;
                    },
                    'mousemove': function(e) {
                        mousedown && removeScroll(block);
                    },
                    'mousedown': function(e) {
                        mousedown = true;
                        mousedownPageY = e.pageY;
                    },
                    'mouseup': function() {
                        mousedown = false;
                    }
                });

                var removeScroll = function(block)
                {
                    var scrollElem = block.frameEl.parents(".pstory-frame");
                    scrollElem .css("overflow","hidden");
                }

                var updateScroll = function(block)
                {
                    var scrollElem = block.frameEl.parents(".pstory-frame");
                    scrollElem .css("overflow","scroll");
                }
            }
        },
        unBindEvents: function () {
            this.fixedContainer.unbind("mousewheel");
            this.fixedContainer.unbind("touchmove");
            this.fixedContainer.unbind("touchstart");
            this.fixedContainer.unbind("touchend");
            this.fixedContainer.unbind("mousemove");
            this.fixedContainer.unbind("mousedown");
            this.fixedContainer.unbind("mouseup");
        },
        scrollOnFixedElemment: function(event){
            var scrollElem = $(".pstory-frame");
            if (event.originalEvent.wheelDelta / 120 > 0) {
                scrollElem.animate({scrollTop: scrollElem.scrollTop() - 50}, 0, "swing");
            }
            else {
                scrollElem.animate({scrollTop: scrollElem.scrollTop() + 50}, 0, "swing");
            }
        }
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    var allAccountsAnimation = function allAccountsAnimation(){
        var animationMap = {};

        var isValidate = function isValidate(animationObj){
            var isValid = false;
            if(typeof animationObj.type === 'undefined' || animationObj.type === null){
                Personetics.error("Required property 'type' is missing");
            }
            else if(typeof animationObj.doAnimation === 'undefined' || animationObj.doAnimation === null){
                Personetics.error("Required property 'doAnimation' is missing");
            }
            else if(typeof animationObj.cancelAnimation === 'undefined' || animationObj.cancelAnimation === null){
                Personetics.error("Required property 'cancelAnimation' is missing");
            }
            else
                isValid = true;
            return isValid;
        }

        function addAnimation(animationObj){
            if(isValidate(animationObj)){
                animationMap[animationObj.type] = {
                    doAnimation: animationObj.doAnimation,
                    cancelAnimation: animationObj.cancelAnimation
                }
            }
        }

        var getAnimation = function getAnimation(type){
            if(animationMap.hasOwnProperty(type)){
                return animationMap[type];
            }
            else Personetics.error("All accounts animation doesn't support this type: " + type);
        } 

        function init(){
            addAnimation({
                type: 'heapCards',
                doAnimation: function allAccountsAnimation_heapCards(selectedCard, cards, params) {
                    /*set cards left,top and z-index css attr to be in the position of the selected card,
                      each one behind and a bit below the previous
                    */
                    var cardsLength = cards.length;
                    var totalHeight = params.cardsStackTotalHeight|| $(cards).height() / 5;
                    var maxSpaceBetweenCards = params.maxSpaceBetweenCards || 10;
                    var topSpacing = Math.min(maxSpaceBetweenCards, totalHeight / cardsLength);
                    var realTotalHeight = cardsLength * topSpacing;
                    var topValue = (totalHeight - realTotalHeight) / 2;
                    $(selectedCard).css('top', topValue + 'px');
                    $(selectedCard).css('zIndex',  cardsLength+ 1);
                    $.each(cards, function (index, card) {
                        var selectedCardLeft = $(selectedCard).offset().left;
                        var offsetLeft = $(card).offset().left;
                        var left = parseInt($(card).css('left'));
                        var setLeftValue = selectedCardLeft - offsetLeft + left;
                        if(params.isRTL){
                            setLeftValue *= -1;
                        }
                        $(card).css({ 'left': setLeftValue + 'px', 'top': ((index + 1) * topSpacing + topValue) + 'px', 'zIndex': cardsLength - index }); 
                    });  
                    if(params.showBoxShadowForLastCardOnly){
                        cards.last().addClass('pstory-boxshadow-card');
                    }
                    else cards.add(selectedCard).addClass('pstory-boxshadow-card');
                    if(params.scale){
                        $(selectedCard).css({'transform': 'scalex(1)'}) ; 
                        $.each(cards, function (index, card) {
                            var scaleX = 1 - (index + 1) * params.scale;
                            $(card).css({'transform': 'scalex(' + scaleX + ')'});  
                        });  
                    }
                },
                cancelAnimation: function (cards){
                    cards.css({'left': '', 'top': ''});   
                }
            });
            addAnimation({
                type: 'fadingSlidingOut',
                doAnimation: function allAccountsAnimation_fadingOut(selectedCard, cards, params){
                    var container = params.container || selectedCard.parents('.options-container');
                    $.each(cards.add(selectedCard), function(index, card){
                        var offsetLeft = $(card).offset().left - container.offset().left;
                        var left = parseInt($(card).css('left'));                 
                        var setLeftValue = $('.options-container').width() - offsetLeft + left;
                        $(card).css('left', setLeftValue + 'px') ;                   
                    }); 
                },
                cancelAnimation: function(cards){
                    $.each(cards, function(index, card){
                        card.style.left = "";                  
                    }); 
                }
            });
        }

        init(); 

        this.addAnimation = addAnimation;
        this.getAnimation = getAnimation;        
    };
    Personetics.utils.allAccountsAnimation = new allAccountsAnimation();

})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.carouselAnimation = Personetics.utils.carouselAnimation || {};
    /**
     * itemWidth is regular carouselItem width with padding and margin
     * selectedItemWidth is selected carouselItem width with padding and margin
     * numItemsDispaly is the num of items that they are shown every time.
     * 
     * 
     * the html should be:
     * <elementWrapper(div) class ="carousel-animate carousel-wrapper (optional:for disable :carousel-disable)" >
     *      <innerWrapper(div) class ="carousel-inner-wrapper">
     *          <carouselItem(div) class ="carousel-item"></> x num of items
     *      </>
     * </>
     */
    Personetics.utils.carouselAnimation.bindCarouselEventsForAnimation = function bindCarouselEventsForAnimation(elementWrapper, param) {

        var innerWrapper;
        var carouselItems;
        /**items without the clone */
        var carouselItemsBase;
        var config = {};
        var keyCode = {
            "Space": 32,
            "Enter": 13,
            "LeftArrow": 37,
            "RightArrow": 39,
            "UpArrow": 38,
            "DownArrow": 40
        };
        init();

        function init() {
            innerWrapper = $(elementWrapper).find('.carousel-inner-wrapper');
            carouselItemsBase = innerWrapper.find('.carousel-item');
            innerWrapper.attr('num-original-cards', carouselItemsBase.length);

            if (typeof param == 'undefined') {
                param = {};
            }

            if (typeof param.itemWidth != 'undefined') {
                config.itemWidth = param.itemWidth;
            }

            if (typeof param.selectedItemWidth != 'undefined') {
                config.selectedItemWidth = param.selectedItemWidth;
            }

            if (typeof param.numItemsDispaly == 'undefined') {
                param.numItemsDispaly = 3;//default display 3 items
            }

            /**clone cards for carousel*/
            if (carouselItemsBase.length > 1) {
                var copyData = carouselItemsBase.clone(true);
                copyData.attr('clone', 'true');
                var copyData2 = copyData.clone(true);
                innerWrapper.prepend($(copyData));
                innerWrapper.append($(copyData2).slice(0, 2));
            }
            carouselItems = innerWrapper.find('.carousel-item');
            setConfig(config.itemWidth, config.selectedItemWidth);
            this.dotAnimation = new Personetics.utils.DotAnimation.bindDotEventsForAnimation(elementWrapper, carouselItemsBase, param);
            this.dotAnimation.setSelectedDot();
            setNumItemsToDispaly(param.numItemsDispaly);
            bindEvents();
            caruselAccessibility();
        };

        function setConfig(itemWidth, selectedItemWidth) {
            /**set the width */
            if (typeof itemWidth == 'undefined') {
                itemWidth = carouselItemsBase.filter(':not(.selected)').outerWidth(true);
            }
            if (typeof selectedItemWidth == 'undefined') {
                selectedItemWidth = carouselItemsBase.filter('.selected').outerWidth(true);
            }

            config.itemWidth = itemWidth;
            config.selectedItemWidth = selectedItemWidth;

            /**find the selected, if there isn't selected slect the first */
            var selectedIndex = -1;
            $.each(carouselItemsBase, function (index, item) {
                if ($(item).hasClass('selected')) {
                    selectedIndex = index;
                }
            });
            if (selectedIndex == -1) {
                selectedIndex = 0;
                var pstoryId = carouselItemsBase.first().attr("pstory-id");
                //add selected to first item and its clone cards
                carouselItems.filter("[pstory-id='" + pstoryId + "']").addClass('selected');
            }

        };
        function setNumItemsToDispaly(numItemsDispaly) {
            if (typeof numItemsDispaly == 'number') {
                config.numItemsDispaly = numItemsDispaly;

                if (numItemsDispaly > carouselItemsBase.length) {
                    carouselItems.filter("[clone='true']").addClass('carousel-hide-clone');
                }
                else {
                    carouselItems.removeClass('carousel-hide-clone');
                }
            }
        }

        function bindEvents() {
            if (param.onClick !== false) {
                carouselItems.bind('click', function (e) {
                    if ($(elementWrapper).hasClass('carousel-disable') == false) {
                        startCarousel(e);
                    }
                });

                $("#personetics-teaser-widget-carousel").bind('keydown', function (e) {
                    if (e.target === document.activeElement) {
                        if ([keyCode.RightArrow].indexOf(e.which) !== -1) {
                            onSwipe('right');
                        }
                        if ([keyCode.LeftArrow].indexOf(e.which) !== -1) {
                            onSwipe('left');
                        }
                        if ([keyCode.Enter].indexOf(e.which) !== -1) {
                            $(this).find(".account-button.selected").click();
                        }
                    }
                });
            }
            if (param.onSwipe !== false) {
                $(elementWrapper).swipe(function (e) {
                    if ($(elementWrapper).hasClass('carousel-disable') == false) {
                        onSwipe(e);
                    }
                }, { preventDefault: false });
            }
        };

        function startCarousel(e) {
            if (typeof param.beforeCarouselStart == 'function') {
                param.beforeCarouselStart(e);
            }
            doAnimation(e, param.animateDuration);
            if (param.showIndexDots)
                this.dotAnimation.updateIndex(e);
        };

        function onSwipe(e) {
            /**prevent swipe */
            if ($(elementWrapper).hasClass('carousel-disable') || config.disableInputSelect) {
                if (param && param.onAnimationEnd) {
                    param.onAnimationEnd();
                }
                return;
            }
            /**do swipe only on swipe left or right */
            if (e == 'left' || e == 'right') {
                var carouselItemsLength = carouselItems.length;
                var indexSelected = carouselItemsBase.filter('.selected').index();
                var direction = e == 'left' ? 1 : -1;
                /**the selected is the next item to the swipe direction */
                indexSelected += direction;

                /**edge */
                if (indexSelected == carouselItemsLength) {
                    indexSelected = 0;
                }
                if (indexSelected < 0) {
                    indexSelected = carouselItemsLength - 1;
                }

                if (carouselItemsBase.length < config.numItemsDispaly && $(carouselItems[indexSelected]).attr('clone') == 'true') {
                    config.swipeDirection = null;
                    if (param && param.onAnimationEnd) {
                        param.onAnimationEnd();
                    }
                    return;
                }
                config.swipeDirection = direction * -1;
                var event = {};
                event.swipeDirection = e;
                event.currentTarget = carouselItems[indexSelected];
                startCarousel(event);
            }
        };
        function caruselAccessibility() {
            var selectedShow = carouselItems.filter(".selected:not([clone='true'])");
            selectedShow.siblings().attr("aria-hidden", true);
            selectedShow.attr("aria-hidden", true);
            selectedShow.prev().addClass("prev");
            selectedShow.next().addClass("next");
            selectedShow.prev().addClass("prev");
            selectedShow.next().addClass("next");

            carouselItems.removeAttr("aria-label");
            if (typeof param.text != "undefined") {
                if (typeof param.text.next != "undefined")
                    selectedShow.next().attr("aria-label", param.text.next);
                if (typeof param.text.prev != "undefined")
                    selectedShow.prev().attr("aria-label", param.text.prev);
            }

        };
        function setAccessibilityFocus(waitTime) {
            var selectedShow = param && param.isDesktop ? null : $(".pstory-account-button.selected");
            if (selectedShow && selectedShow.length < 1) {
                carouselItems.filter(".selected:not([clone='true'])")
            }
            var focusInterval = 10 + waitTime; // ms, time between function calls
            var focusTotalRepetitions = 10; // number of repetitions

            if (selectedShow) {
                selectedShow.attr('tabindex', '0');
                selectedShow.blur();
            }

            var focusRepetitions = 0;
            var interval = window.setTimeout(function () {
                if (selectedShow) {
                    selectedShow.focus();
                }
                if (param && param.onAnimationEnd) {
                    param.onAnimationEnd();
                }
            }, focusInterval);
        };
        function doAnimation(e, animateDuration) {
            var target = e.currentTarget;
            if ($(target).hasClass('selected') || config.disableInputSelect == true) {
                return;
            }

            var direction = config.swipeDirection;
            if (direction == null) {
                direction = $(target).hasClass("prev") ? 1 : -1;
            }

            config.disableInputSelect = true;
            var selected = carouselItems.filter(".selected");
            var leftDiff = 24.5;
            var newLeft = selected.filter(":not([clone='true'])").offset().left - innerWrapper.offset().left + getValueByScreenWidth(leftDiff) * direction;
            selected.css('transition', '0s')
            var targetId = $(target).attr('pstory-id');//item id
            var targetItem = carouselItems.filter('[pstory-id="' + targetId + '"]');
            if (targetItem.filter(":not([clone='true'])").hasClass('next')) {
                var left = targetItem.filter('.next').offset().left - innerWrapper.offset().left - (selected.width() - targetItem.width());
                targetItem.css('transition', '0s');
                targetItem.css('left', left)
                targetItem.find('.card').css('width', selected.width())
            }
            selected.animate({ 'left': newLeft },
                'slow', function () {
                    $.each(selected, function (index, selectedCard) {
                        selectedCard.style.left = "";
                        selectedCard.style.transition = "";
                    });

                    selected.removeClass('selected');
                    carouselItems.removeClass('prev');
                    carouselItems.removeClass('next');
                    targetItem.addClass('selected');//add selected to all clone of current card
                    $.each(targetItem, function (index, target) {
                        target.style.left = "";
                        target.style.transition = "";
                    });


                    targetItem.find('.card').css('width', '')


                    if (typeof animateDuration != 'number') {
                        animateDuration = 300;
                    }
                    var carouselItemsBaseLength = carouselItemsBase.length;

                    var selectedIndex = $(target).index();
                    var prev = innerWrapper.find('.carousel-item:lt(' + selectedIndex + ')');

                    setTimeout(function () {
                        innerWrapper.css({ 'transition-duration': '0s', '-webkit-transition-duration': '0s' });

                        config.disableInputSelect = false;
                        if (typeof param.afterCarouselEnd == 'function') {
                            param.afterCarouselEnd();

                        }
                    }, animateDuration);
                    innerWrapper.css({ 'transition-duration': animateDuration + 'ms', '-webkit-transition-duration': animateDuration + 'ms' });
                    config.swipeDirection = null; //to remove the swipe
                    caruselAccessibility();
                    setAccessibilityFocus(animateDuration);
                });
        };
        function getValueByScreenWidth(value) {
            var screenWidth = $(window).width();
            var screenOptions = {
                ratio_medium: 1.17,
                ratio_large: 1.3
            };
            var returnValue = value;
            if (screenWidth >= 414 && screenWidth < 790) {
                returnValue = value * screenOptions.ratio_large;
            } else if (screenWidth >= 347){
                returnValue = value * screenOptions.ratio_medium;
            }
            return returnValue;
        };
        this.startCarousel = startCarousel;
        this.setConfig = setConfig;
        this.setNumItemsToDispaly = setNumItemsToDispaly;
        this.onSwipe = onSwipe;
    };
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){

    Personetics.story = Personetics.story || {};

    Personetics.story.PBlockRenderer = Personetics.story.PCtrlBase.extend({
        initialize: function(parent, skinCtrl) {
            Personetics.story.PCtrlBase.prototype.initialize.call(this);

            this.parent = parent;

            if(typeof skinCtrl !== 'undefined' && skinCtrl !== null)
                this.uxCtrl = skinCtrl;
            else
                this.uxCtrl = new Personetics.story.skinController();//new Personetics.story.PSkinControler();

            this.uxCtrl.setStory(this);

            this.uxCtrl.registerBlocks();

            this.templates = {};
        },

        renderBlocks: function (el, layoutInstructions) {
            this.layoutInstructions = layoutInstructions;

            var me = this;
            $(el).empty();
            $.each(this.layoutInstructions, function (index, layoutInstructions) {
                var type = layoutInstructions.type;

                //TODO: replace 'story' param with 'parent'
                var blockRenderer = Personetics.story.PBlockFactory.createBlock(me, layoutInstructions, me);

                if(blockRenderer) {
                    blockRenderer.beforeRender(el, layoutInstructions);
                    blockRenderer.render(el, layoutInstructions);
                    blockRenderer.afterRender(el);
                    blockRenderer.bindEvents();
                }
            });
        },

        notifyEvent: function(blockRenderer, eventame, params){
            this.parent.notifyEvent(blockRenderer, eventame, params);
        }
    });

})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.story.CollapseHelperOpenBank = Personetics.story.CollapseHelper.extend({
        doCollapse: function(block, skipAnimation){
            /**the fixed element */
            if($.isFunction(block.onBeforeCollapsed)) {
                block.onBeforeCollapsed(this.fixedContainer);
            }
            if(block.frameEl.is(':last-child'))
                block.frameEl.parents('.pstory-dialog-frame').next().addClass('pstory-dialog-collapsed');

            /**save the wrapper height */
            this.fixedWrapper.height(this.fixedWrapper.outerHeight());

            this.fixedContainer.attr('collapsed-height', this.collapsedHeight);

            /**the fixedContainer top */
            this.topFixedContainer = Math.min(0,this.heightForElementDisplayed - this.fixedContainer.outerHeight()) + this.heightPrevFixedElements + this.diffHeight -1;
            this.fixedContainer.css({'top': this.topFixedContainer + 'px'});

            /**z-index */
            var zIndex = 999;
            if(this.prevCollapsed.length > 0)
                zIndex = this.prevCollapsed.css('z-index') -1;
            this.fixedContainer.css({'z-index': zIndex});

            /**change margin to padding for background */
            /*var marginRight = block.frameEl.css('margin-right');
            var marginLeft = block.frameEl.css('margin-left');
            this.fixedContainer.css({'padding-right': marginRight, 'padding-left': marginLeft});*/

            if(skipAnimation == true)
                block.frameEl.parents('.pstory-dialog-frame').removeClass('perso-collapsed-animation');
            else
                block.frameEl.parents('.pstory-dialog-frame').addClass('perso-collapsed-animation');

            block.frameEl.removeClass('perso-unCollapsed');
            block.frameEl.addClass('perso-collapsed');
            this.fixedContainer.addClass('pstory-fixed');
            this.bindEvents(block);
            if($.isFunction(block.onCollapsed)) {
                block.onCollapsed(this.elementDisplayed, this.heightForElementDisplayed, this.fixedContainer);
            }
        },
        doUnCollapse: function(block){
            this.unBindEvents();
            block.frameEl.parents('.pstory-dialog-frame').next().removeClass('pstory-dialog-collapsed');//.height(block.frameEl.parents('.pstory-dialog-frame').height());

            block.frameEl.removeClass('perso-collapsed');
            this.fixedContainer.removeClass('pstory-fixed');

            if($.isFunction(block.onUnCollapsed))
                block.onUnCollapsed(this.elementDisplayed);
        },
        bindEvents : function(block){
            var mousedown = false;
            if(!jQuery._data(this.fixedContainer.get(0), 'events') || !jQuery._data(this.fixedContainer.get(0), 'events').mousewheel) {
                this.fixedContainer.bind('mousewheel', this.scrollOnFixedElemment);
                var mousedownPageY;
                this.fixedContainer.bind({
                    'touchmove': function(e) {
                        mousedown &&  removeScroll(block);
                    },
                    'touchstart': function(e) {
                        mousedown = true;
                        mousedownPageY = e.originalEvent.touches[0].pageY;
                    },
                    'touchend': function() {
                        updateScroll(block);
                        mousedown = false;
                    },
                    'mousemove': function(e) {
                        mousedown && removeScroll(block);
                    },
                    'mousedown': function(e) {
                        mousedown = true;
                        mousedownPageY = e.pageY;
                    },
                    'mouseup': function() {
                        updateScroll(block);
                        mousedown = false;
                    }
                });

                var removeScroll = function(block)
                {
                    var scrollElem = block.frameEl.parents(".pstory-frame");
                    scrollElem .css("overflow","hidden");
                }

                var updateScroll = function(block)
                {
                    var scrollElem = block.frameEl.parents(".pstory-frame");
                    scrollElem .css("overflow","scroll");
                }
            }
        },
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    var keyCode ={
        "Space":32,
        "Enter":13,
        "LeftArrow":37,
        "RightArrow":39,
        "UpArrow":38,
        "DownArrow":40
    };
    Personetics.story.AccountSelectorBlockProductDesktop = Personetics.story.AccountSelectorBlockProduct.extend({
        // getHtmlTemplateId: function(clazz) {
        //     return "account-selector-desktop";
        // }
        beforeRender: function (el, layoutInstructions) {
            this.animationEnd = true;
            Personetics.story.AccountSelectorBlockProduct.prototype.beforeRender.call(this, el, layoutInstructions);
        },
        prepareCarouselParam: function prepareCarouselParam(){
            var me = this;
            var params = Personetics.story.AccountSelectorBlockProduct.prototype.prepareCarouselParam.call(this);
            params.updateDotsForAccessibility = this.updateDotsForAccessibility;
            params.isDesktop = true;
            params.onAnimationEnd = function()
            {
                me.animationEnd = true;
            };
            return params;
        },

        updateDotsForAccessibility: function(dotsWrapper,id){
            dotsWrapper.attr("aria-labelledby","perso-accessibility-read-" + id);
            if(!!window.MSInputMethodContext && !!document.documentMode) { //for JAWS on IE 11
                dotsWrapper.blur();
                dotsWrapper.focus();
            }
        },
        putFocusAccessibility: function putFocusAccessibility(elementForFocus) {
        },
       
        onChooseAccountClick: function onChooseAccountClick(target){
            Personetics.story.AccountSelectorBlockProduct.prototype.onChooseAccountClick.call(this,target);
        },
        optionHeaderKeydownEvent: function optionHeaderClickEvent(e) {
            if([keyCode.Space,keyCode.Enter].indexOf(e.which) !== -1)
            {
                this.optionHeaderClickEvent(e);
                var elem;
                var target = $(e.target);
                if(target.attr("data-all") === "true" || target.parent().attr("data-all") === "true") {
                    elem = $("#allAccountHelper");
                }else{
                    elem = $("#chooseAccountHelper");
                    elem.attr("aria-labelledby", $(".carousel-index-wrapper").attr("aria-labelledby"));
                }
                elem.addClass("pstory-header-button");
                elem.attr("tabindex", "0");
                elem.focus();
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        },
        optionCarouselDotKeydownEvent: function optionHeaderClickEvent(e) {
            if(this.animationEnd) {
                if ([keyCode.RightArrow, keyCode.DownArrow].indexOf(e.which) !== -1) {
                    this.animationEnd = false;
                    this.carouselAnimation.onSwipe("left");
                    return false;
                } else if ([keyCode.LeftArrow, keyCode.UpArrow].indexOf(e.which) !== -1) {
                    this.animationEnd = false;
                    this.carouselAnimation.onSwipe("right");
                    return false;
                }
            }else{
                return false;
            }
            if([keyCode.Space].indexOf(e.which) !== -1)
            {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        },
        bindEvents: function bindEvents() {
            Personetics.story.AccountSelectorBlockProduct.prototype.bindEvents.call(this);
            Personetics.utils.accessibility.trackFocus(this.frameEl);
            this.frameEl.find(".pstory-header-button").bind("keypress", Personetics.bind(this, this.optionHeaderKeydownEvent));
            this.frameEl.find(".carousel-index-wrapper").bind("keydown", Personetics.bind(this, this.optionCarouselDotKeydownEvent));
        },
        afterRender: function afterRender(el) {
            Personetics.story.AccountSelectorBlockProduct.prototype.afterRender.call(this, el);
            var carouselItem = el.find(".carousel-inner-wrapper .carousel-item");
            if(carouselItem.length > 1) {
                this.frameEl.find(".carousel-index-wrapper").attr("tabindex", "0");
            }else{
                this.frameEl.find(".carousel-index-wrapper").removeAttr("tabindex");
            }
            if(this.showHeaderTabs) {
                this.addAccessibilityTabsHelper();
            }

            carouselItem.each(function()
            {
                var element =  $(this);
                element.find(".perso-bold").attr("id","perso-bold" + element.attr("pstory-id"));
                element.find(".perso-amount").attr("id","perso-amount" + element.attr("pstory-id"));
            });
            el.find(".pstory-all-accounts-txt").find(".perso-bold").attr("id","perso-bold-all");
            el.find(".pstory-all-accounts-txt").find(".perso-amount").attr("id","perso-amount-all");
        },

        addAccessibilityTabsHelper: function addAccessibilityTabsHelper(){
            var allAccountTab = this.frameEl.find(".pstory-header-button[data-all='true']");
            var chooseAccountTab = this.frameEl.find(".pstory-header-button[data-all='false']");
            allAccountTab.append("<div id='allAccountHelper' style='position: absolute;top:0;left:0' aria-labelledby='perso-bold-all perso-amount-all'></div>");
            chooseAccountTab.append("<div id='chooseAccountHelper' style='position: absolute;top:0;left:0' aria-labelledby='" + $(".carousel-index-wrapper").attr("aria-labelledby") + "'></div>");
            $("#allAccountHelper,#chooseAccountHelper").focusout(function () {
                var elem = $(this);
                elem.removeAttr("tabindex");
                elem.removeClass("pstory-header-button");
                if (elem.attr("id") === "chooseAccountHelper") {
                    elem.removeAttr("aria-labelledby");
                }
            });
            if(!!window.MSInputMethodContext && !!document.documentMode) { //for JAWS on IE 11
                var ofLabel = Personetics.dictionary.getText("accessibilityOfLbl");
                allAccountTab.attr("aria-label",allAccountTab.text() + " " + "1 " + ofLabel + " 2");
                chooseAccountTab.attr("aria-label",chooseAccountTab.text() + " " + "2 " + ofLabel + " 2");
            }
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    var keyCode = {
        'Enter': 13
    };
    Personetics.story.D3BarChartBlockProductDesktop = Personetics.story.D3BarChartBlockProduct.extend({
        initOptions: function () {
            if (this.chartType == "multiVertical") {
                this.options = this.story.uxCtrl.getColumnChartMultiSeriesOptionsDesktop();
                this.options.palette = this.story.uxCtrl.getMultiVerticalPaletteDesktop();
                this.options.paletteLabels = this.story.uxCtrl.getMultiVerticalLabelsPaletteDesktop();
            }
            else if (this.chartType == "multiHorizontal")
                this.options = this.story.uxCtrl.getBarChartOptionsDesktop();
            else

                this.options = this.story.uxCtrl.getColumnChartOptionsDesktop();


        },
        renderAccessibility: function renderAccessibility(el, chartType) {
            Personetics.story.D3BarChartBlockProduct.prototype.renderAccessibility.call(this, el, chartType);
            this.frameEl.find(".accessibility-chart-wrapper .accessibility-chart-button").attr('tabindex', '-1');
        },
        afterRender: function (el) {
            var $barChartContainer = this.el.find(".perso-svg-chart-container");
            Personetics.story.D3BarChartBlockProduct.prototype.afterRender.call(this, el);
            $barChartContainer.attr("aria-labelledby", $barChartContainer.find("title").attr("id"));
            Personetics.utils.accessibility.trackFocus($barChartContainer);
            if(this.chartType !== 'pinGraph') {
                this.addAccessDataToHiddenRects();
                this.updateSelectedHiddenRect();
            }
            //Listen to keypress on chart wrapper
            if (this.layoutInstructions.hasOwnProperty('var') && typeof this.layoutInstructions.var !== 'undefined') {
                this.listenToKeypress();
            }
        },
        putFocusAccessibility: function putFocusAccessibility(elementForFocus) {
        },
        listenToKeypress: function () {
            var block = this;
            if (block.chartHelper.svg) {
                this.el.find(".perso-svg-chart-container")
                    .bind("keypress", function (e) {
                        if (e.target.className.animVal.indexOf('access-hidden-rect') !== -1) {
                            if ([keyCode.Enter].indexOf(e.which) !== -1) {
                                var data = (block.layoutInstructions.seriesLabels.length >= 2) ? block.layoutInstructions.series[0] : block.layoutInstructions.series;
                                var lastBarIndex = data.length - 1;
                                var targetBarIndex = $(e.target).index();
                                block.handleClick(data[lastBarIndex - targetBarIndex], lastBarIndex - targetBarIndex);
                            }
                        }
                    })
            }
        },
        getSelectedBarIndex: function (svgEl, isSeries) {
            var index;
            if (svgEl) {
                if (isSeries) {
                    index = $(svgEl[0]).find('.perso-chart-rect.In.selected').index()
                } else {
                    index = $(svgEl[0]).find('.perso-bar.selected').index()
                }
                ;
            }
            return index;
        },
        renderAccessibilityData: function renderAccessibilityData(el) {
            Personetics.story.D3BarChartBlock.prototype.renderAccessibilityData.call(this, el);
            if (this.chartType !== 'pinGraph') {
                if (!!window.MSInputMethodContext && !!document.documentMode) { //for JAWS on IE 11
                    this.el.find(".perso-svg-chart-container").attr('focusable', false);
                    this.el.find(".perso-svg-container-group").attr({'focusable':true, "aria-hidden":"false"});
                    this.chartHelper.svg.selectAll(".perso-bar").attr('focusable', false);
                    this.chartHelper.svg.selectAll(".access-hidden-rect").attr({'focusable':true,"class":"access-hidden-rect-IE", "aria-hidden":"false"});
                }
                this.el.find(".perso-svg-chart-container").attr('tabindex', '-1');
                this.chartHelper.svg.selectAll(".perso-bar").attr('tabindex', '-1');
                this.chartHelper.svg.selectAll(".access-hidden-rect").attr('tabindex', '0');
                this.chartHelper.svg.selectAll(".perso-hidden-rects, .access-hidden-rect").attr('aria-hidden', false);
            }
        },
        handleClick: function (obj, clickedItemIndex) {
            var block = this;
            var seriesData = block.layoutInstructions.series;
            if (obj.hasOwnProperty('mode') && obj.mode) {
                if((seriesData[1][clickedItemIndex].value !== 0 || seriesData[0][clickedItemIndex].value !== 0)
                    && seriesData[1][clickedItemIndex].category === obj.category && seriesData[0][clickedItemIndex].category === obj.category) {
                    Personetics.story.D3BarChartBlockProduct.prototype.handleClick.call(this, obj, clickedItemIndex);
                    this.handleMultiChartClick();
                }
            } else {
                if(seriesData[clickedItemIndex].value !== 0) {
                    Personetics.story.D3BarChartBlockProduct.prototype.handleClick.call(this, obj, clickedItemIndex);
                    this.handleSingleChartClick();
                }
            }
            this.updateSelectedHiddenRect();
        },
        handleSingleChartClick: function () {
            var persoBarsNum = this.el.find('.perso-bar').length - 1;
            this.el.find('.accessibility-chart-button.selected').removeClass('selected');
            $(this.el.find('.accessibility-chart-button')[persoBarsNum - (this.el.find('.perso-bar.selected').index())]).addClass('selected');
        },
        handleMultiChartClick: function () {
            var persoBarsNum = this.el.find('.perso-chart-rect.Out').length - 1;
            this.el.find('.accessibility-chart-button.selected').removeClass('selected');
            $(this.el.find('.accessibility-chart-button')[persoBarsNum - (this.el.find('.perso-chart-rect.Out.selected').index())]).addClass('selected');
        },

        addAccessDataToHiddenRects: function () {
            var accessChartButtons = $(this.el.find('.accessibility-chart-button'));
            var hiddenRects = $(this.el.find('.access-hidden-rect, .access-hidden-rect-IE'));
            if (accessChartButtons.length && hiddenRects.length) {
                for (var i = 0; i < hiddenRects.length; i++) {
                    var itemData = accessChartButtons.eq(i).attr('aria-label');
                    hiddenRects.eq(i).attr('aria-label', itemData);
                }
            }
        },

        updateSelectedHiddenRect: function () {
            var block = this;
            var classSelected = block.el.find('.perso-xAxis-label.selected').length > 0 ? " " + block.texts.selected : "";
            var hiddenRects = block.el.find('.access-hidden-rect, .access-hidden-rect-IE');
            var selectedIndex = block.el.find(".accessibility-chart-button.selected").index();
            $.each(hiddenRects, function (i, rect) {
                var $rect = $(rect);
                var ariaLabel = ($rect.attr('aria-label').indexOf('not selected') !== -1 ) ? $rect.attr('aria-label').split('not selected') : $rect.attr('aria-label').split('selected');
                if (selectedIndex !== -1) {
                    if (selectedIndex == i) {
                            $rect.attr('aria-label', ariaLabel[0] + classSelected);
                    } else {
                        if($rect.attr('aria-label').indexOf('not selected') == -1) {
                            $rect.attr('aria-label', ariaLabel[0] + ' ' + block.texts.notSelected);
                        }
                    }
                }
            });
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.DotsLineChartBlockDesktop = Personetics.story.DotsLineChartBlock.extend({
        initLineChartOptions: function initLineChartOptions(){
            return this.story.uxCtrl.getDotsLineChartOptionsDesktop();
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.D3PinGraphChartBlockProductDesktop = Personetics.story.D3BarChartBlockProductDesktop.extend({
        beforeRender: function(el, layoutInstructions){
            Personetics.story.D3BarChartBlockProduct.prototype.beforeRender.call(this, el, layoutInstructions);
            this.texts.accessibilityPinGraphTitle = Personetics.dictionary.getText("accessibilityPinGraphTitle");
        },
        getHtmlTemplateId: function(clazz) {
            return "pinGraph-chart";
        },
        render: function(el, layoutInstructions) {
            Personetics.story.Block.prototype.render.call(this, el, layoutInstructions);
            this.options.desktopScreenWidth = this.story.uxCtrl.getDesktopScreenWidth();
                        
            var chartEl = this.frameEl.find(".pstory-pinGraph-chart");
            if (chartEl.length > 0) {
                this.renderBarChart(chartEl, layoutInstructions);
            }
        },
        renderBarChart: function(el) {
            if(typeof this.chartHelper.prepareChartData == "function"){
                this.layoutInstructions = this.chartHelper.prepareChartData(this.layoutInstructions, this.options);
            }
            this.chartHelper.prepareChart(this.layoutInstructions, this.options);
            this.chartHelper.renderChart(el);
        },
        beforeRenderChart: function(el, layoutInstructions){
            this.layoutInstructions.series = this.layoutInstructions.series[0];
            this.chartType = this.getChartType();
            this.chartTypeHelper = (this.chartType +"Helper");
            this.initChartHelper(this.chartTypeHelper);
            this.options = this.story.uxCtrl.getPinGraphChartOptionsDesktop();
        },
        afterRender: function (el) {
            var $barChartContainer = this.el.find(".perso-svg-chart-container");
            Personetics.story.D3BarChartBlockProductDesktop.prototype.afterRender.call(this, el);
            $barChartContainer.attr('tabindex','-1');
        },
        barsDirection: function barsDirection(){
            if(Personetics.processor.PStoryConfig.isRtl()){
               this.barsDirectionRTL();
            }    
        },

        getChartType: function(){
            var type = 'pinGraph';
            return type;
        },

        getAccessibilityTitle: function getAccessibilityTitle(){
            return this.texts.accessibilityPinGraphTitle;
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    var keyCode = {
        "Space": 32,
        "Enter": 13,
        "LeftArrow": 37,
        "RightArrow": 39,
        "UpArrow": 38,
        "DownArrow": 40
    };
    Personetics.story = Personetics.story || {};
    Personetics.story.PieChartBlockProductDesktop = Personetics.story.PieChartBlockProduct.extend({
        renderPieChart: function (el, layoutInstructions) {
            this.maxWidth = 460;
            Personetics.story.PieChartBlockProduct.prototype.renderPieChart.call(this, el, layoutInstructions);
            this.renderDots(el, layoutInstructions);
        },
        renderDots: function (el, layoutInstructions) {
            var arcs = layoutInstructions.slices;
            var html = this.frameEl.find('.carousel-index-wrapper');
            var dot = '<span class="carousel-index-dot"></span>';
            $.each(arcs, function (arc, index) {
                html.append(dot);
            });
        },
        bindDots: function bindDots() {
            this.param = this.prepareDots();
            this.elementWrapper = this.frameEl;
            this.arcOptions = this.frameEl.find('.perso-arc');
            this.dotAnimation = new Personetics.utils.DotAnimation.bindDotEventsForAnimation(this.elementWrapper, this.arcOptions, this.param);
            this.dotAnimation.setSelectedDot();
        },
        afterRender: function (el) {
            Personetics.story.PieChartBlockProduct.prototype.afterRender.call(this, el);
            this.renderAccessibilityTextWrapper();
            var pstoryBlockContent = this.el.find(".pstory-block-pie-chart .pstory-block-content");
            var pieSvg = pstoryBlockContent.find('svg');
            pstoryBlockContent.attr("role", "application");
            pieSvg.attr('focusable', false);
            this.updateElementAriaLabelledByIds(pstoryBlockContent, [pstoryBlockContent.find("title").attr("id"), pstoryBlockContent.find('.perso-accessibility-read.selected').attr('id')]);
            pstoryBlockContent.bind("keydown", Personetics.bind(this, this.optionHeaderKeydownEvent));
            Personetics.utils.accessibility.trackFocus(pstoryBlockContent);
            this.bindDots();
        },
        beforeRender: function (el, layoutInstructions) {
            Personetics.story.PieChartBlockProduct.prototype.beforeRender.call(this, el, layoutInstructions);
            var previousDialogs = el.parents('.pstory-dialog-frame').prev('.pstory-dialog-frame');
            var tabsBlock = previousDialogs.find('.pstory-block-tabs');
            tabsBlock.find('.pstory-tab').attr('tabindex', '0');
        },
        setCornerRadiusPie: function(){
            if (typeof this.story.uxCtrl.getPieOptionsDesktop == "function" &&
                typeof this.story.uxCtrl.getPieOptionsDesktop().arcs != "undefined") {
                this.cornerRadiusPie = typeof this.story.uxCtrl.getPieOptionsDesktop().arcs.cornerRadius != "undefined" ? this.story.uxCtrl.getPieOptionsDesktop().arcs.cornerRadius.radiusCorner : 9;
            }
        },
        getPieOptions: function(){
            return this.story.uxCtrl.getPieOptionsDesktop();
        },
        getGraphPalette: function (selectedTabId) {
            return this.story.uxCtrl.getPieGraphPaletteDesktop(selectedTabId);
        },
        prepareDots: function prepareDots() {
            var param = {};
            param.showIndexDots = true;
            param.firstDot = true;
            return param;
        },
        onPieItemClick: function (obj, clickedItemIndex, clickedItem) {
            Personetics.story.PieChartBlockProduct.prototype.onPieItemClick.call(this, obj, clickedItemIndex, clickedItem);
            //var indexSelected = this.arcOptions.filter('.perso-selected').index();
            var event = {};
            event.currentTarget = this.arcOptions[clickedItemIndex];
            this.dotAnimation.updateIndex(event);
        },
        moveArcs: function (index) {
            var block = this;
            var event = {};
            var nextIndex = (index == block.layoutInstructions.slices.length -1)? 0 :index +1;
            event.currentTarget = this.arcOptions.filter("[pstory-id = '" + block.layoutInstructions.slices[nextIndex].category + "']")[0];
            this.dotAnimation.updateIndex(event);
            var path = block.arcPaths[index];
            var filter = '';
            var prevIndex = this.getSelectedIndex();
            if (this.options.arcs.filter.grayFilter == true) {
                filter = "url(#" + this.grayscaleId + ")";
            }
            if (path) {
                if(index !== prevIndex){
                    var prevPath = block.arcPaths[prevIndex];
                    d3.select(prevPath)
                        .attr("d", block.arc)
                        .style("filter", filter)
                        .attr("class","")
                }
                d3.select(path)
                    .attr("d", block.arcOver.cornerRadius(this.cornerRadiusPie))
                    .attr("class", "perso-selected")
                    .style("filter", this.dropShadow)
                    .style("fill", function (d, i) {
                        return block.colorArcs(d.data.category);
                    });
                d3.select(path).moveToFront();

                //set default values in pie info container
                block.updatePieInfoValues(block.layoutInstructions.slices[index]);
                this.setSelectedIndex(index);
            }
        },
        optionHeaderKeydownEvent: function (e) {
            if ($(e.target).hasClass("pstory-block-content")) {
                if ([keyCode.RightArrow, keyCode.DownArrow].indexOf(e.which) !== -1) {
                    this.el.find('.pstory-previous-arrow').click();
                    return false;
                } else if ([keyCode.LeftArrow, keyCode.UpArrow].indexOf(e.which) !== -1) {
                    this.el.find('.pstory-next-arrow').click();
                    return false;
                }
            }
        },
        tabsKeyPressEvent: function (e) {
            if ([keyCode.Space, keyCode.Enter].indexOf(e.which) !== -1) {
                $(e.currentTarget).click();
                return false;
            }
        },
        putFocusAccessibility: function putFocusAccessibility(elementForFocus) {
            elementForFocus.focus();
        },
        renderAccessibilityTextWrapper: function () {
            var block = this;
            var slices = block.layoutInstructions.slices;
            var $accessibilityWrapper = $('<div class="accessibility-pie-wrapper"></div>');
            block.numberOfSlices = block.layoutInstructions.slices.length;
            var sliceLabel = Personetics.dictionary.getText("accessibilitySliceLbl");
            var ofLabel = Personetics.dictionary.getText("accessibilityOfLbl");

            //remove text from arrows
            block.el.find('.pstory-arrow').attr('aria-hidden', true);
            //set aria-hidden
            block.el.find(".perso-accessibility-no-read").attr('aria-hidden', true);
            //Add access. texts for each slice.
            $.each(slices, function (i, slice) {
                var id = "perso-readable-slice_" + (slice.category ? slice.category.replace(" ", "_") : "");
                var clazz = (slice.highlight) ? 'perso-accessibility-read selected' : 'perso-accessibility-read';
                $($accessibilityWrapper).prepend('<span id="' + id + '" class="' + clazz + '"' + 'role="text">' + sliceLabel + ' ' + slice.index + ' ' + ofLabel + ' ' + block.numberOfSlices + ', ' + slice.label + ', ' + slice.category + '</span>');
            })

            this.el.find('.pstory-block-pie-chart .pstory-block-content').append($accessibilityWrapper);
        },
        updatePieInfoValues: function (obj) {
            var block = this;
            if (obj) {
                var amountDiv = '<div class="pstory-pie-amount perso-accessibility-no-read"><span>' + obj.label + '</span></div>';
                var categoryDiv = '<div class="pstory-pie-category perso-accessibility-no-read"><span>' + obj.category + '</span></div>';

                var $infoContainer = this.frameEl.find('.pstory-pie-info');
                $infoContainer.empty();
                $infoContainer.append(amountDiv);
                $infoContainer.append(categoryDiv);

                //set color from Palette
                this.setAmountColor(obj);

                //update accessibility text
                var accessibilityWrapper = this.el.find('.accessibility-pie-wrapper');
                if (accessibilityWrapper.length) {
                    this.updateSelectedAccessbilityText(accessibilityWrapper);
                    this.updateElementAriaLabelledByIds(this.el.find('.pstory-block-pie-chart .pstory-block-content'), this.el.find('.perso-accessibility-read.selected').attr('id'), true);
                }
            }
        },
        setAmountColor:function(obj){
            if (this.options.arcs.filter.grayFilter == true) {
                $('.pstory-pie-amount').css('color', this.colors(obj.category))
            }
        },
        updateSelectedAccessbilityText: function (el) {
            if (el.length) {
                var selectedArcIndex = this.getSelectedPathIndex(this.arcPaths) + 1;
                var newSelectedIndex = this.numberOfSlices - selectedArcIndex;
                $(el).find('.perso-accessibility-read.selected').removeClass('selected');
                $($(el).find('.perso-accessibility-read')[newSelectedIndex]).addClass('selected');
            }
        },
        updateElementAriaLabelledByIds: function (el, ids, refocus) {
            if (el.length > 0) {
                if (Array.isArray(ids)) {
                    el.attr("aria-labelledby", ids[0] + " " + ids[1]);
                } else {
                    el.attr("aria-labelledby", ids);
                }
                if(refocus == true && !!window.MSInputMethodContext && !!document.documentMode) {//for JAWS on IE 11
                    el.eq(0).blur();
                    el.eq(0).focus();
                }

            }
        },
        bindEvents: function () {
            Personetics.story.PieChartBlockProduct.prototype.bindEvents.call(this);
            var pstoryBlockContent = this.el.find(".pstory-block-pie-chart");
            Personetics.utils.accessibility.trackFocus(this.el.parents().find(".pstory-block-tabs.perso-tabs"));
            var tabsBlock = this.el.parents().find(".pstory-tab.pstory-button");
            pstoryBlockContent.bind("keydown", Personetics.bind(this, this.optionHeaderKeydownEvent));
            tabsBlock.bind("keypress", Personetics.bind(this, this.tabsKeyPressEvent));

        },
        setPieSizeOnStart: function setPieSizeStart(){
            this.width = this.frameEl.find('.pstory-pie-chart').width();
            if(typeof this.maxWidth !== "undefined" && this.width > this.maxWidth){
                this.width = this.maxWidth;
            }
            this.height = this.width * 0.7;
            //set radius width depends on screen width
            this.innerRadius = 1;
            this.outerRadius = 1;
            this.innerRadiusOver = 1;
            this.outerRadiusOver = 1;
        },
        setPieSize: function setPieSize(width) {
            this.margin = { top: 0, right: 20, bottom: 0, left: 20 };
            this.width = width;
            this.height = this.width * 0.7;
            this.radius = this.width / 2.5;
            //set radius width depends on screen width
            this.innerRadius = this.radius - 26;
            this.outerRadius = this.radius - 36;
            this.innerRadiusOver = this.radius - 23;
            this.outerRadiusOver = this.radius - 43;
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.MultiVerticalChartHelperDesktop = Personetics.utils.d3Helpers.MultiVerticalChartHelper.extend({
        prepareChart: function (data, options, handleClick) {
            Personetics.utils.d3Helpers.MultiVerticalChartHelper.prototype.prepareChart.call(this, data, options, handleClick);

            this.yAxis = d3.svg.axis()
                .scale(this.yAxisScale)
                .orient("left")
                .innerTickSize(-this.width)
                .outerTickSize(0)
                .ticks(5);
        },
        renderChart: function (el) {
            var helper = this;
            this.yScale.domain([0, d3.max(helper.seriesData, function (d) {
                return d3.max(d, function (k) {
                    return k.value;
                });
            })]);

            this.modifyData();

            this.svg = this.renderSVGBase(el, "multiVertical");
            this.renderGradient();
            this.renderFilter();
            this.renderYAxis();
            this.renderAccessibilityHiddenRects();
            this.renderMultiVerticalBars();
            this.renderHiddenRects(this.seriesData);
            this.renderLabels();
            if(!this.options.doAnimations){
                this.options.barDelay = this.options.barDuration = this.options.labelDelay = this.options.labelDuration = 0;
                this.barAnimations();
            } 
            this.renderXAxis();
            this.renderVerticalLines(helper.xLineScale);
        },

        renderAccessibilityHiddenRects: function () {
            var helper = this;
            var hiddenRectWidth = helper.getValueByScreenWidth((helper.options.rectangles.width * 3) + (helper.options.rectangles.paddingRight || 0));
            var hiddenRectHeight = helper.getValueByScreenWidth(helper.options.svgHeight - (helper.options.labelTop || 0 ));
            
            //reversing the data to handle tabindex position
            var reversedData = this.seriesData[0].slice().reverse();
            var hiddenRects = this.svg.append('g')
                .attr('class','perso-hidden-rects')
                .attr("transform", function (data, i) {
                    return "translate(" + helper.left + "," + helper.getValueByScreenWidth(helper.options.accessHiddenRectMarginTop) + ")";
                })
                .selectAll("g")
                .data(reversedData);

            hiddenRects.enter()
                .append('rect')
                .attr('class','access-hidden-rect')
                .attr("height", function (d, i) {
                    return hiddenRectHeight;
                })
                .attr('width',hiddenRectWidth)
                .attr("x", function (d, i) {
                    //reversing the data to handle tabindex position
                    var lastItemIndex = helper.series[0].length - 1
                    return (helper.xScale(helper.categoriesData[lastItemIndex - i])) - (hiddenRectWidth - (helper.rWidth  + helper.rPadding))/2;
                })
                .attr('fill-opacity', 0);
            },
        
        renderSVGBase: function(el, clazz){
            var helper = this;
            if(!clazz){
                clazz = '';
            }
            return(d3.select(el.get(0)).append("svg")
                .attr("class","perso-svg-chart-container " + clazz)
                .attr("width", helper.options.svgWidth)
                .attr("height", helper.options.svgHeight)
                .append("g")
                .attr("transform", "translate(0," + helper.getValueByScreenWidth(this.options.chart.transY) + ")"));
        },
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.AccountSelectorBlockOpenBankDesktop = Personetics.story.AccountSelectorBlockProductDesktop.extend({
        onAllAccountsClick: function onAllAccountsClick(doAnimation) {
            this.frameEl.find(".pstory-card-transition").addClass('pstory-transition-change-to-all');
            this.frameEl.find('.options-container').addClass('allAccounts');
            this.frameEl.find('.options-container').addClass('carousel-disable');
            this.frameEl.find('.options-container').addClass('on-animation');
            this.carouselAnimation.setConfig();
            this.allAccountsSelectedAnimation(doAnimation);
            this.parent.notifyEvent(this, "setSelectedValue", this.all);

            /** Accessibility */
            this.frameEl.find('.pstory-all-accounts-txt').removeAttr("aria-hidden");
            this.frameEl.find('.pstory-block-content').removeClass('chooseAccount');
            this.frameEl.find('.pstory-block-content').addClass('allAccounts');
            this.frameEl.find('.carousel-outer-wrapper').addClass('allAccounts');
        },
        onChooseAccountClick: function onChooseAccountClick(target) {
            this.frameEl.find(".pstory-card-transition").removeClass('pstory-transition-change-to-all');
            this.chooseAccountSelectedAnimation();
            this.frameEl.find('.options-container').removeClass('allAccounts');
            this.frameEl.find('.options-container').removeClass('carousel-disable');
            this.carouselAnimation.setConfig();
            var selected = this.frameEl.find('.pstory-button.selected:not([clone="true"])');
            selected.prev().addClass("prev");
            selected.next().addClass("next");
            /*should do the fire event but dont need click event because the selected there is the class and we dont want the animation*/
            //selected.click();
            var selectedOpt = this.getOptionById(selected.attr('pstory-id'));
            this.parent.notifyEvent(this, "setSelectedValue", selectedOpt);

            /**accessibility */
            this.frameEl.find('.pstory-all-accounts-txt').attr("aria-hidden", true);
            this.frameEl.find('.pstory-block-content').addClass('chooseAccount');
            this.frameEl.find('.pstory-block-content').removeClass('allAccounts');
            this.frameEl.find('.carousel-outer-wrapper').removeClass('allAccounts');
        },
        afterRender: function afterRender(el) {
            Personetics.story.AccountSelectorBlockProductDesktop.prototype.afterRender.call(this, el);
            if(this.layoutInstructions.options.length == 1){
                this.frameEl.parents('.pstory-dialog-frame').addClass('perso-singel-account-selector');
            }
            this.frameEl.find('.options-container .pstory-button:not(.carousel-hide-clone)').addClass("pstory-card-transition");
        },
        setImageValueForOptions: function setImageValueForOptions(){
            $.each(this.options, function (i, opt) {
                var urlObj = Personetics.imageMap.getImageClass(opt.image, "account_selector");
                opt.isAbsoluteURL = urlObj.isAbsoluteURL;
                opt.image  = urlObj.url === 'cardImage' ? null : urlObj.url;
            });
        },
        optionHeaderClickEvent: function optionHeaderClickEvent(e) {
            var target = $(e.currentTarget);
            var allAccounts = target.data('all');
            if (this.frameEl.find(".options-container").hasClass("allAccounts") == allAccounts){
                this.setFocusOnRelevantElement(allAccounts);
                return;
            }
            this.headerTabsAnimation(target);
            var params = {
                "eventId": "account-selector-tab-clicked",
                "additionalData": {
                    "tab-clicked": ""
                },
            }
            if (allAccounts) {
                this.onAllAccountsClick(true);
                params.additionalData["tab-clicked"] = "all accounts"
            }
            else {
                this.onChooseAccountClick(target);
                params.additionalData["tab-clicked"] = "choose account"
            }
            this.updateAccessibilityButtons(allAccounts);
            this.setFocusOnRelevantElement(allAccounts);
            this.frameEl.find(".pstory-header-button").attr('aria-selected', 'false');//.removeClass("selected-header");
            target.attr('aria-selected', 'true');//.addClass("selected-header");

            this.notifyReportHeaderEvent(allAccounts);
            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                personetics.createReportingEvent(this, params);
            }
        },
        beforeCarouselStart: function beforeCarouselStart(e) {
            //go to parent click function
            Personetics.story.AccountSelectorBlock.prototype.optionClickEvent.call(this, e);
            this.optionClickEvent(e);
            this.setDisableArrows(e.currentTarget);
            this.updateAccessibilityButtons(false, $(e.currentTarget));
            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                var params = {
                    "eventId": "account-switch",
                }
                personetics.createReportingEvent(this, params);
            }
        },
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.D3BarChartBlockDesktopOpenBank = Personetics.story.D3BarChartBlockProductDesktop.extend({
    
        afterRender: function (el) {
            Personetics.story.D3BarChartBlockProductDesktop.prototype.afterRender.call(this, el);
            if(this.chartType == 'multiVertical')
            {
                var signElements= this.frameEl.find("text.perso-label.In .perso-minus-sign");
                $.each(signElements, function (index, el) {
                        $(el).text("+");
                })
            }
        },
        handleSingleChartClick: function () {
            var persoBarsNum = this.el.find('.perso-bar').length - 1;
            this.el.find('.accessibility-chart-button.selected').removeClass('selected');
            $(this.el.find('.accessibility-chart-button')[persoBarsNum - (this.el.find('.perso-bar.selected').index())]).addClass('selected');
            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                var params = {
                    "eventId": "bar-chart-click"
                }
                personetics.createReportingEvent(this, params);
            }

        },
        handleMultiChartClick: function () {
            var persoBarsNum = this.el.find('.perso-chart-rect.Out').length - 1;
            this.el.find('.accessibility-chart-button.selected').removeClass('selected');
            $(this.el.find('.accessibility-chart-button')[persoBarsNum - (this.el.find('.perso-chart-rect.Out.selected').index())]).addClass('selected');
            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                var params = {
                    "eventId": "comparable-bar-chart-click"
                }
                personetics.createReportingEvent(this, params);
            }},

    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    var keyCode = {
        "Space": 32,
        "Enter": 13,
        "LeftArrow": 37,
        "RightArrow": 39,
        "UpArrow": 38,
        "DownArrow": 40
    };
    Personetics.story = Personetics.story || {};
    Personetics.story.PieChartBlockOpenBankDesktop = Personetics.story.PieChartBlockProductDesktop.extend({
        setCategoryId: function (id, selectedTabId) {
            var defaultId = 'CG0';
            if (selectedTabId && selectedTabId === 'In') {
                defaultId = 'CG10'
            }
            var definedCategories = ["CG4000", "CG200", "CG6000","CG700","CG100","CG2000","CG600","CG10","CG20","CG30","CG3000","CG0","CG800","CG1000"];
            if (definedCategories.indexOf(id) > -1) {
                return id;
            } else {
                return defaultId;
            }
        },
        beforeRender: function (el, layoutInstructions) {
            Personetics.story.PieChartBlockProductDesktop.prototype.beforeRender.call(this, el, layoutInstructions);
            var previousDialogs = el.parents('.pstory-dialog-frame').prev('.pstory-dialog-frame');
            var tabsBlock = previousDialogs.find('.pstory-block-tabs');
            tabsBlock.addClass('perso-pie-tabs');
            this.options = this.story.uxCtrl.getPieOptionsDesktop();
            this.grayColors = d3.scale.ordinal().range(this.story.uxCtrl.getPieGrayColors());
            this.colors = d3.scale.ordinal()
              .domain(["CG4000", "CG200", "CG6000","CG700","CG100","CG2000","CG600","CG10","CG20","CG30","CG3000","CG0","CG800","CG1000"])
              .range(["#2e4256", "#04a9f4", "#f44336","#02bcd4","#673ab7","#dc2874","#9d27b0","#0ac8a1","#ff4d52","#546e7a","#3f51b5","#fbb800","#dc51ac","#ff8b4f"]);
        },
        renderArcs: function (layoutInstructions) {
            Personetics.story.PieChartBlockProductDesktop.prototype.renderArcs.call(this, layoutInstructions);
            var block= this;
                var arcs = this.frameEl.find('.pstory-pie-chart svg .perso-arc path');
                $.each(arcs, function (i, arc) {
                    d3.select(arc).style("fill", function() { return block.grayColors(i); });
                });
            this.arcs = arcs;
        },
        renderDots: function (el, layoutInstructions) {},
        //bindDots: function bindDots() {},
        setPieSize: function setPieSize(width) {
            this.margin = { top: 0, right: 20, bottom: 0, left: 20 };
            this.width = width;
            this.height = this.width * 0.6;
            this.radius = this.width / 2.98;
            //set radius width depends on screen width
            this.innerRadius = this.radius;
            this.outerRadius = this.radius - 33.7;
            this.innerRadiusOver = this.radius;
            this.outerRadiusOver = this.radius - 33.7;
        },
        setCircleSize: function setCircleSize(){
            var heightCircle = this.outerRadius * 2;
            var widthCircle = this.outerRadius * 2;
            var topCircle = parseInt(this.frameEl.find('.pstory-pie-chart').css('padding-top')) + 33.7 + 3;
            var leftCircle = this.frameEl.find('.arcs-wrapper').offset().left - this.frameEl.find('.pstory-pie-chart').offset().left + 33.7;
            this.frameEl.find('.pieCircle').css({ height: heightCircle, width: widthCircle, top: topCircle +'px', left: leftCircle });
            this.frameEl.find('.perso-pie-total-text').css({ 'width': widthCircle - 4, 'left': leftCircle + 2 }); //2 and 4 for padding-right and left
            this.frameEl.find('.perso-pie-total-amount').css({ 'width': widthCircle - 4, 'left': leftCircle + 2 }); //2 and 4 for padding-right and left
        },
        pieTransition: function pieTransition(arcs){
            var block = this;
            this.setPieSize(this.frameEl.find('.pstory-pie-chart').width());
            this.defineArcs();
            this.svg.selectAll(".perso-arc path")
                .transition()
                .delay(block.options.pieDelay)
                .duration(block.options.pieDuration)
                .attr("d", block.arc)
                .each("end", function () {
                    block.setCircleSize();
                });
        },
        renderPieSvgBase: function (el) {
            var block = this;
            if (el) {
                return (d3.select(el.get(0)).append("svg")
                    .attr("width", block.width)
                    .attr("height", block.height)
                    .append("g")
                    .attr("class", 'arcs-wrapper')
                    .attr("transform", "translate(" + block.width / 2 + "," + block.height * 0.5+ ")"));
            }
        },
        renderPieTitle: function (totalText) {
            var block = this;
            if (block.selectedTabId == "In")
            totalText = Personetics.dictionary.getText("lblInCenterText").split(" ");
        else
            totalText = Personetics.dictionary.getText("lblOutCenterText").split(" ");

            block.frameEl.find('.perso-pie-total-text.perso-pie-total').html(totalText[0]);
            block.frameEl.find('.perso-pie-total-text.perso-pie-type').html(totalText[1]);
        },
        renderPieAmount: function (totalAmount) {
            var block = this;
            block.frameEl.find('.perso-pie-total-amount').html(totalAmount);
        },
        setAmountColor:function(obj){
            if (this.options.arcs.filter.grayFilter == true) {
                $('.pstory-pie-amount').css('color', '#002b45')
            }
        },
        updatePieInfoValues: function (obj) {
            var block = this;
            if (obj) {
                var iconDiv = '<div class="pstory-pie-icon '+ obj.categoryId+'"></div>'
                var amountDiv = '<div class="pstory-pie-amount perso-accessibility-no-read"><span>' + obj.label + '</span></div>';

                if (obj.category)
                    var categoryDiv = '<div class="pstory-pie-category perso-accessibility-no-read"><span>' + obj.category + '</span></div>';
                else
                    var noTransactionDiv = '<div class="pstory-pie-no-transaction perso-accessibility-no-read"><span>' + Personetics.dictionary.getText("lblNoTransaction") + '</span></div>';

                var $infoContainer = this.frameEl.find('.pstory-pie-info');
                $infoContainer.empty();
                $infoContainer.append(amountDiv);
                if(categoryDiv){
                    $infoContainer.append(iconDiv);
                    $infoContainer.append(categoryDiv)
                }
                else
                {
                    $infoContainer.append(noTransactionDiv);
                }

                //set color from Palette
                this.setAmountColor(block.colors(block.setCategoryId(obj.categoryId,block.selectedTabId)));

                //update accessibility text
                var accessibilityWrapper = this.el.find('.accessibility-pie-wrapper');
                if (accessibilityWrapper.length) {
                    this.updateSelectedAccessbilityText(accessibilityWrapper);
                    this.updateElementAriaLabelledByIds(this.el.find('.pstory-block-pie-chart .pstory-block-content'), this.el.find('.perso-accessibility-read.selected').attr('id'), true);
                }
            }
        },
        onPieItemClick: function onPieItemClick(obj, clickedItemIndex, clickedItem) {
            var block = this;
            var oldSelectedArc = this.el.find('.perso-arc path.perso-selected');
            if (oldSelectedArc[0] != clickedItem) {//disable click on selected
                /**set the old selected path*/
                if (oldSelectedArc.length) {
                    oldSelectedArc[0].className.baseVal = Personetics.utils.string.removeClass(oldSelectedArc[0].className, 'perso-selected');
                    var prevIndex = this.getSelectedIndex();     
                    d3.select(oldSelectedArc[0])
                        .attr("d", block.arc)
                        .style("fill", function (d) {
                            var caregories = block.layoutInstructions.slices;
                            if (caregories[0].category == d.data.category) {
                                var color = block.grayColors(d.data.category);
                                var prevColor = block.grayColors(caregories[caregories.length - 1].category);
                                var nextColor = block.grayColors(caregories[1].category);
                                var index = 2;
                                while (color == prevColor || color == nextColor) {
                                    color = block.grayColors(caregories[index++].category)
                                }
                                return color;
                            }
                            return block.grayColors(prevIndex);
                        })
                }
                d3.select(clickedItem)
                    .attr("d", block.arcOver.cornerRadius(this.cornerRadiusPie))
                    .attr("class", "perso-selected")
                    .style("filter","")
                    .style("fill", function (d, i) {
                        return block.colorArcs(block.setCategoryId(d.data.categoryId, block.selectedTabId));
                    });
                d3.select(clickedItem).moveToFront();
                this.handleClick(obj, clickedItemIndex);
                this.updatePieInfoValues(obj.data);
                if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                    var params = {
                        "eventId": "pie-chart-click"
                    }
                    personetics.createReportingEvent(this, params);
                }
            }

        },
        moveArcs: function (index) {
            var block = this;
            var event = {};
            var nextIndex = (index == block.layoutInstructions.slices.length -1)? 0 :index +1;
            event.currentTarget = this.arcOptions.filter("[pstory-id = '" + block.layoutInstructions.slices[nextIndex].category + "']")[0];
            this.dotAnimation.updateIndex(event);
            var path = block.arcPaths[index];
            var prevIndex = this.getSelectedIndex();
            if (path) {
                if(index !== prevIndex){
                    var prevPath = block.arcPaths[prevIndex];
                    d3.select(prevPath)
                        .attr("d", block.arc)
                        .attr("class","")
                        .style("fill", function (d) {
                            var caregories = block.layoutInstructions.slices;
                            if (caregories[0].category == d.data.category) {
                                var color = block.grayColors(d.data.category);
                                var prevColor = block.grayColors(caregories[caregories.length - 1].category);
                                var nextColor = block.grayColors(caregories[1].category);
                                var index = 2;
                                while (color == prevColor || color == nextColor) {
                                    color = block.grayColors(caregories[index++].category)
                                }
                                return color;
                            }
                            return block.grayColors(d.data.category);
                        })
                }
                d3.select(path)
                    .attr("d", block.arcOver.cornerRadius(this.cornerRadiusPie))
                    .attr("class", "perso-selected")
                    .style("filter","")
                    .style("fill", function (d, i) {
                        return block.colorArcs(block.setCategoryId(d.data.categoryId, block.selectedTabId));
                    });
                d3.select(path).moveToFront();

                //set default values in pie info container
                block.updatePieInfoValues(block.layoutInstructions.slices[index]);
                this.setSelectedIndex(index);
                if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                    var params = {
                        "eventId": "pie-chart-arrow-click"
                    }
                    personetics.createReportingEvent(this, params);
                }
            }
        },
        afterRender: function (el) {
            Personetics.story.PieChartBlockProductDesktop.prototype.afterRender.call(this, el);
            var block = this;
            if (this.layoutInstructions.slices[0].class == 'perso_empty') {
                block.frameEl.addClass('perso-empty');
            }
        },
        renderPieChart: function (el, layoutInstructions) {
            if (layoutInstructions.slices == null || layoutInstructions.slices.length == 0 || (layoutInstructions.slices.length == 1 && layoutInstructions.slices[0].value == 0))
                layoutInstructions.slices = [{ "value": 1, "label": "", "category": "", "class": "perso_empty" }];
            layoutInstructions.slices = this.sortPie(layoutInstructions.slices);
            Personetics.story.PieChartBlockProductDesktop.prototype.renderPieChart.call(this, el, layoutInstructions);
        },
        colorArcs: function (categoryId) {
            var block = this;
            var color = block.colors(block.setCategoryId(categoryId, block.selectedTabId));
            if (!categoryId) {
                if (block.selectedTabId) {
                    if (block.selectedTabId == "Out" && block.options.arcs.selectedOutflowPrimaryColor != null) {
                        color = block.options.arcs.selectedOutflowPrimaryColor;
                    } else if (block.selectedTabId == "In" && block.options.arcs.selectedInflowPrimaryColor != null) {
                        color = block.options.arcs.selectedInflowPrimaryColor;
                    }
                } else if (block.options.arcs.selctedPrimaryColor != null) {
                    color = block.options.arcs.selctedPrimaryColor;
                }
            }
            return color;
        },
        drawSelected: function drawSelected(){
            var block = this;
            //only do after render if render method doesn't fail
            if(this.pieDrew == true){
                if (block.frameEl) {
                    block.frameEl.addClass(block.selectedTabId);
                    var defaultPath = block.arcPaths[this.getSelectedIndex()];
                    //TODO
                    var radius = block.story.uxCtrl.getPieOptions().arcs.cornerRadius ? block.story.uxCtrl.getPieOptions().arcs.cornerRadius.radiusCorner : 9;
                    d3.select(defaultPath)
                      .transition()
                      .duration(0)
                      .delay(block.options.pieSelectedDelay)
                      .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                      .style("filter", block.dropShadow)
                      .style("fill", function (d, i) {
                          return block.colorArcs(block.setCategoryId(d.data.categoryId, block.selectedTabId));
                      });
                    block.renderGradient();
                }
            }
        }

    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.story = Personetics.story || {};
    Personetics.story.D3PinGraphChartBlockOpenBankDesktop = Personetics.story.D3PinGraphChartBlockProductDesktop.extend({
       
        afterRender: function (el) {
            Personetics.story.D3PinGraphChartBlockProductDesktop.prototype.afterRender.call(this, el);
            el.find(".pstory-bar-chart, .pstory-pinGraph-chart svg").css('padding-left', "0");
        },
       
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.MultiVerticalChartHelperDesktopOpenBank = Personetics.utils.d3Helpers.MultiVerticalChartHelperDesktop.extend({
        MIN_BAR_HEIGHT: 0,

        renderChart: function (el) {
            var helper = this;
            this.yScale.domain([0, d3.max(helper.seriesData, function (d) {
                return d3.max(d, function (k) {
                    return k.value;
                });
            })]);

            this.modifyData();

            this.svg = this.renderSVGBase(el, "multiVertical");
            this.renderGradient();
            this.renderFilter();
            this.renderYAxis();
            this.renderAccessibilityHiddenRects();
            this.renderMultiVerticalBars();
            this.renderHiddenRects(this.seriesData);
            this.renderLabels();
            this.renderInOutLabels()
            if(!this.options.doAnimations){
                this.options.barDelay = this.options.barDuration = this.options.labelDelay = this.options.labelDuration = 0;
                this.barAnimations();
            } 
            this.renderXAxis();
            this.renderVerticalLines(helper.xLineScale);
        },

        prepareChart: function (data, options, handleClick) {
            Personetics.utils.d3Helpers.MultiVerticalChartHelperDesktop.prototype.prepareChart.call(this, data, options, handleClick);

            this.yAxis = d3.svg.axis()
                .scale(this.yAxisScale)
                .orient("left")
                .innerTickSize(-this.width)
                .outerTickSize(0)
                .ticks(1);
        },

        renderYAxis: function(isNegative){
            var helper = this;
            if (this.options.yAxisDisplayOneLine) {
                this.svg.append("g")
                    .attr("class", "y axis perso-grid")
                    .attr("transform", function (d, i) {
                        var y = helper.yScale(0) + helper.getValueByScreenWidth(helper.options.barTop/*yAxisTopNegState*/) + helper.MIN_BAR_HEIGHT;
                        var x = typeof helper.options.horizontalLineLeft != 'undefined'? helper.options.horizontalLineLeft : 0;
                        return ("translate(" + helper.getValueByScreenWidth(x) + "," + y + ")");
                    })
                    .call(helper.yAxis)
                    .selectAll(".tick line")
                    .attr('x2', function (d, i) {
                        var x2 = typeof helper.options.horizontalLineWidth != 'undefined' ? helper.options.horizontalLineWidth : (helper.options.svgWidth || 0);
                        return helper.getValueByScreenWidth(x2);
                    });
            }
            Personetics.utils.d3Helpers.MultiVerticalChartHelperDesktop.prototype.renderYAxis.call(this, isNegative);            
        },  

        getSeriesTranslateValue: function (index) { 
            return this.rPadding * (!index);
        },

        renderInOutLabels: function renderInOutLabels(){
            var helper = this;
            if(this.options.inOut.drawInOut){
                var texts=[
                    [Personetics.dictionary.getText("Inflow")],
                    [Personetics.dictionary.getText("Outflow")],
                ]
                var block = this.svg.append("g")
                .attr("transform", function (d, i) {
                    var y = helper.getValueByScreenWidth(helper.options.inOut.paddingTop);
                    var x = helper.getValueByScreenWidth(helper.options.inOut.paddingLeft);
                    return "translate(" + x + "," + y + ")";
                })
                .attr("class", function (d) {
                    var clazz = "perso-in-out-wrapper";
                    return clazz;
                })
                .selectAll("g")
                    .data(texts)
                    .enter().append("g")
                    .attr("transform", function (d, i) {
                        var transValue = helper.getValueByScreenWidth(helper.options.inOut.nextLeft) * (i);
                        return "translate(" + transValue + "," + 0 + ")";
                    })
                    .attr("class", function (d) {
                        var clazz = "perso-in-out" ;
                        return clazz;
                    })
                    .selectAll("text")
                    .data(function (d) {
                        return d;
                    });
                    var inOutText = block.enter().append("text")
                    .attr("class", function (d) {
                        var clazz = "perso-in-out-label" ;
                        return clazz;
                    })
                    .attr("x", function (d, i) {  
                        return helper.getValueByScreenWidth(helper.options.inOut.label.x);                
                    })
                    .attr("y", function (d, i) {
                        return helper.getValueByScreenWidth(helper.options.inOut.label.y);                  
                    })
                    .text(function (d, i){
                        return d;
                    });
                    var inOutRect = block.enter().append("rect")
                    .attr("class", function (d) {
                        var clazz = "perso-in-out-rect";
                        return clazz;
                    })
                    .attr("height", function (d, i) {
                        return helper.getValueByScreenWidth(helper.options.inOut.rectangle.height);
                    })
                    .attr("width", function (d, i) {
                        return helper.getValueByScreenWidth(helper.options.inOut.rectangle.width);                   
                    })
                    .attr("rx", function (d, i) {
                        return helper.getValueByScreenWidth(helper.options.inOut.rectangle.borderRadius.rx);            
                    })
                    .attr("ry", function (d, i) { 
                        return helper.getValueByScreenWidth(helper.options.inOut.rectangle.borderRadius.ry);         
                    })
                    .attr("y", function (d, i) {
                        return helper.getValueByScreenWidth(helper.options.inOut.rectangle.paddingTop);                  
                    });
            }
        },

        renderLabels: function renderLabels() {
            var helper = this;
            helper.sortedData = helper.sortData();
            if (this.options.labels.drawLabels) {
                var cssClass = 'perso-label perso-label-fadeIn';
                if (this.categoriesData.length >= 4) {
                    cssClass += " minimize-font";
                }
                var blockWithBars = this.svg.append("g")
                    .attr("transform", function (d, i) {
                        var transValue = helper.getValueByScreenWidth(helper.options.labelTop);
                        return "translate(" + helper.leftForScale + "," + transValue + ")";
                    })
                    .selectAll("g")
                    .data(helper.sortedData)
                    .enter().append("g")
                    .style("fill", function (d, i) {
                        return helper.colorsLabels(i);
                    })
                    .attr("transform", function (d, i) {
                        var transValue = helper.getValueByScreenWidth(helper.options.nextLabelTop) * (i);
                        return "translate(" + 0 + "," + transValue + ")";
                    })
                    .selectAll("text")
                    .data(function (d) {
                        return d;
                    });
                    
                this.labels = blockWithBars.enter()
                    .append("text")
                    .attr("text-anchor", "middle")
                    .attr("class", function (d) {
                        var clazz = cssClass + ' ' + d.mode; ;
                        if (d.selected) {
                            clazz += " selected";
                        }
                        return clazz;
                    })
                    .attr("x", function (d, i) {
                        return helper.xScale(helper.categoriesData[i]) + (helper.contentWidth / helper.dataLength);                    
                    })
                    .attr("y", function (d, i, j) {
                        var yValue = 0;
                        return (yValue);
                    })
                    .attr("dy", "0.4em");
                    
                // support IE
               
                $.each(helper.seriesLabelsData, function (modeIndex, mode) {

                    var amounts = helper.svg.selectAll('.perso-label.'+ mode);
                    var tspans = amounts.append('tspan');

                    $.each(tspans[0], function (index, tspan) {
                            var attrs = $(helper.seriesData[modeIndex][index].label)[0].attributes;
                            $.each(attrs, function (j, attr) {
                                tspan.setAttribute(attr.name, attr.value);
                            });
                            $(tspan).attr("perso-index", index);
                            var totalAmountChildren = $($(helper.seriesData[modeIndex][index].label)[0]).children();
                            $.each(totalAmountChildren, function (i, node) {
                                                        
                                var svgTspan =  helper.svg.select('[perso-index="' + index + '"]');           
                                var innerTspan = svgTspan.append('tspan').text($(node).text());
                                var attrs = node.attributes;
                                $.each(attrs, function (j, attr) {
                                    innerTspan.attr(attr.name, attr.value);
                                });
                            });
                    });
                });            

            }
        },

        renderGradient: function (){
            var gradients = this.options.rectangles.gradients;
            var defWithGradients = this.svg.append("defs");
            var linearGradient;
            if(gradients){
                $.each(gradients, function(i, gradient){
                    if(gradient){
                        linearGradient = defWithGradients.append("linearGradient")
                            .attr("id",gradient.id)
                            .attr("x1","0")
                            .attr("x2","0")
                            .attr("y1","0")
                            .attr("y2","1");
                            
                        $.each(gradient.stopColors, function(i,stopColor){
                            linearGradient.append("stop")
                            .attr("offset",gradient.offset[i])
                            .attr("stop-color", stopColor);
                        })


                    }
                });
            }
        },
    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.PinGraphChartHelperOpenBank = Personetics.utils.d3Helpers.PinGraphChartHelperProduct.extend({
            MIN_BAR_HEIGHT: 0,
    
            prepareChart: function (data, options, handleClick) {
                Personetics.utils.d3Helpers.VerticalChartHelperProduct.prototype.prepareChart.call(this, data, options, handleClick); 
                this.yAxis = d3.svg.axis()
                    .scale(this.yAxisScale)
                    .orient("left")
                    .innerTickSize(-this.width)
                    .outerTickSize(0)
                    .ticks(1);
            },
    
            getLabelsY:function(d){
                var helper = this;
                var y =0;
                if (helper.minValue < 0) {
                    if (d.value < 0) {
                        y= helper.getValueByScreenWidth(helper.options.labelSpaceBarNegBar);
                    }
                }
                return y;
            },
    
            renderYAxis: function(isNegative){
                var helper = this;
                if (this.options.yAxisDisplayOneLine) {
                    this.svg.append("g")
                        .attr("class", "y axis perso-grid")
                        .attr("transform", function (d, i) {
                            var y = helper.yScale(0) + helper.getValueByScreenWidth(helper.options.yAxisTopNegState) + helper.MIN_BAR_HEIGHT;
                            var x = typeof helper.options.horizontalLineLeft != 'undefined'? helper.options.horizontalLineLeft : 0;
                            return ("translate(" + helper.getValueByScreenWidth(x) + "," + y + ")");
                        })
                        .call(helper.yAxis)
                        .selectAll(".tick line")
                        .attr('x2', function (d, i) {
                            var x2 = typeof helper.options.horizontalLineWidth != 'undefined' ? helper.options.horizontalLineWidth : (helper.options.svgWidth || 0);
                            return helper.getValueByScreenWidth(x2);
                        });
                }
                Personetics.utils.d3Helpers.VerticalChartHelperProduct.prototype.renderYAxis.call(this, isNegative);            
            },  
            
            renderChart: function (el) {
                var helper = this;
                //Setting values we need in more than one function
                var cfg = this.config;
                // Set max & min domain's value
                this.minVal = 0;
                this.maxVal = d3.max(helper.seriesData, function (d) {
                    return Math.abs(parseFloat(d.value));
                });
    
                //set X and Y domian.
                this.xScale.domain(helper.categoriesData.map(function (d) {
                    return d;
                }));
                this.yScale.domain([this.minVal, this.maxVal]);
    
                this.minVal = d3.min(helper.seriesData, function (d) {
                    return parseFloat(d.value);
                });
    
                if(this.minVal<0){
                    this.yScale.domain([this.minVal, this.maxVal]);
                }
                this.svg = this.renderSVGBase(el);
                this.renderGradient();
                this.renderFilter();
                this.renderYAxis();
    
                if (this.options.hasOwnProperty('isDesktop') && this.options.isDesktop) {
                    this.renderAccessibilityHiddenRects();
                }
                this.renderVerticalBars();
                this.renderXAxis();
                this.renderLabels();
                if (!this.options.doAnimations) {
                    this.options.barDelay = this.options.barDuration = this.options.labelDelay = this.options.labelDuration = 0;
                    this.barAnimations();
                }
            },
    
            renderSVGBase: function (el) {
                var helper = this;
                var y = 0;
                var screenWidth = $(window).width();
                if (screenWidth >= 790) {
                    y = 12;
                }
                helper.height = helper.getValueByScreenWidth(helper.options.svgHeight);
                return (d3.select(el.get(0)).append("svg")
                    .attr("class", "perso-svg-chart-container")
                    .attr("width", helper.width)
                    .attr("height", helper.height)
                    .append("g")
                    .attr('class','perso-svg-container-group')
                    .attr("transform", function(){
                        return "translate(0," + y + ")";
                    }));
            },
    
            renderVerticalBars: function () {
                var helper = this;
                //get min abs value to set rectangle height
                helper.minAbsValue = d3.min(helper.seriesData, function (d) {
                    return Math.abs(d.value) || Infinity;
                });
                helper.maxValue = helper.maxVal;
                //get min value (include negative values) to set y position
                helper.minValue = helper.minVal;
    
                var rectSpace = helper.getValueByScreenWidth(helper.options.rectangles.space || 30);
                var rectWidth = helper.getValueByScreenWidth(helper.options.rectangles.width);
                var left = (helper.width - (helper.numOfBars * rectWidth + (helper.numOfBars - 1) * rectSpace)) / 2;
                this.bars = this.svg.append("g")
                    .attr("transform", function () {
                        var y = helper.getValueByScreenWidth(helper.options.barTop);
                        if (helper.minValue < 0) {
                            y = helper.getValueByScreenWidth(helper.options.barTopNegState);
                        }
                        return "translate(" + left + "," + y + ")";
                    })
                    .selectAll("rect")
                    .data(helper.seriesData)
                    .enter()
                    .append("rect")
                    .attr("class", function (d) {
                        var clazz = "perso-bar";
                        if (d.selected) {
                            clazz += " selected";
                        }
                        if(d.value < 0){
                            clazz +=" perso-negative"
                        }
                        return clazz;
                    })
                    .attr("x", function (d, i) {
                        return i * (rectSpace + rectWidth);
                    })
                    .attr("width", function (d, i) {
                        return rectWidth;
                    })
                    .attr("y", function (d, i) {
                        return helper.getValueByScreenWidth(helper.options.maxBarHeight);
                    })
                    .attr("height", 0)
                    .attr("rx", function (d) {
                        var rx = (helper.options.rectangles.borderRadius.rx) ? helper.options.rectangles.borderRadius.rx : "0";
                        return helper.getValueByScreenWidth(rx);
    
                    })
                    .attr("ry", function (d) {
                        var ry = (helper.options.rectangles.borderRadius.ry) ? helper.options.rectangles.borderRadius.ry : "0";
                        return helper.getValueByScreenWidth(ry);
    
                    })
                    .on("click", function (obj, clickedItemIndex) {
                        if (typeof helper.handleClick == 'function') {
                            helper.handleClick(obj, clickedItemIndex);
                        }
                    })
            },
    
            getBarsHeight: function (d) {
                var currentValue = Math.abs(d.value);
                var barHeight = d.value ? this.getValueByScreenWidth(this.options.maxBarHeight) - this.yScale(currentValue) : 0;
                if (this.minValue < 0) {
                    barHeight = d.value ? this.yScale(0) - this.yScale(currentValue) + this.MIN_BAR_HEIGHT : 0;
                }
    
                d.barHeight = barHeight;
                return barHeight;
            },
    
            getBarsY: function (d) {
                var yValue;
                if (d.value < 0) {
                    yValue = this.yScale(0) + this.MIN_BAR_HEIGHT;
                } else {
                    yValue = this.yScale(d.value);
                }
                return yValue;
            },
    
            renderLabels: function () {
                // if there are 6 column, minimize the font size
                var cssClass = "perso-label perso-label-fadeIn";
                var helper = this;
                if (helper.seriesData.length >= 6) {
                    cssClass += " minimize-font";
                }
                if (this.options.labels.drawLabels) {
                    this.label = this.svg.append("g")
                        .attr("transform", function () {
                            var y = helper.options.labelTop ? helper.getValueByScreenWidth(helper.options.labelTop) : 0;
                            return ("translate(" + helper.calcLeft + "," + y + ")");
                        })
                        .selectAll()
                        .data(helper.seriesData)
                        .enter()
                        .append("text")
                        .attr("class", function (d) {
                            var clazz = cssClass;
                            if (d.selected) {
                                clazz += " selected";
                            }
                            return clazz;
                        })
                        .attr("text-anchor", "middle")
                        .attr("x", function (d, i) {
                            return (helper.xScale(helper.categoriesData[i]));
                        })
                        .attr("y", function (d) {
                            return helper.getLabelsY(d);
                        })
                        .attr("dy", function (d) {
                            if (d.value < 0)
                                return "1em";
                            return 0;
                        });
    
                    // support IE
                    var amounts = this.svg.selectAll('.perso-label');
                    var tspans = amounts.append('tspan');
    
                    $.each(tspans[0], function (index, tspan) {
                        var attrs = $(helper.seriesData[index].label)[0].attributes;
                        $.each(attrs, function (j, attr) {
                            tspan.setAttribute(attr.name, attr.value);
                        });
                        $(tspan).attr("perso-index", index);
                        var totalAmountChildren = $($(helper.seriesData[index].label)[0]).children();
                        $.each(totalAmountChildren, function (i, node) {
                            var svgTspan = helper.svg.select('[perso-index="' + index + '"]');
                            var innerTspan = svgTspan.append('tspan').text($(node).text());
                            var attrs = node.attributes;
                            $.each(attrs, function (j, attr) {
                                innerTspan.attr(attr.name, attr.value);
                            });
                        });
                    });
                }
            },

            renderGradient: function(){
                var gradients = this.options.rectangles.gradients;
                var defWithGradients = this.svg.append("defs");
                var linearGradient;
                if(gradients){
                    $.each(gradients, function(i, gradient){
                        if(gradient){
                            linearGradient = defWithGradients.append("linearGradient")
                                .attr("id",gradient.id)
                                .attr("x1","0")
                                .attr("x2","1")
                                .attr("y1","0")
                                .attr("y2","0");
                                
                            $.each(gradient.stopColors, function(i,stopColor){
                                linearGradient.append("stop")
                                .attr("offset",gradient.offset[i])
                                .attr("stop-color", stopColor);
                            })
                        }
                    });
                }
            },
    
        })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.utils = Personetics.utils ? Personetics.utils : {};
    Personetics.utils.d3Helpers = Personetics.utils.d3Helpers ? Personetics.utils.d3Helpers : {};
    Personetics.utils.d3Helpers.VerticalChartHelperOpenBank = Personetics.utils.d3Helpers.VerticalChartHelperProduct.extend({
        MIN_BAR_HEIGHT: 0,

        prepareChart: function (data, options, handleClick) {
            Personetics.utils.d3Helpers.VerticalChartHelperProduct.prototype.prepareChart.call(this, data, options, handleClick); 
            this.yAxis = d3.svg.axis()
                .scale(this.yAxisScale)
                .orient("left")
                .innerTickSize(-this.width)
                .outerTickSize(0)
                .ticks(1);
        },

        getLabelsY:function(d){
            var helper = this;
            var y =0;
            if (helper.minValue < 0) {
                if (d.value < 0) {
                    y= helper.getValueByScreenWidth(helper.options.labelSpaceBarNegBar);
                }
            }
		    return y;
        },

        renderYAxis: function(isNegative){
            var helper = this;
            if (this.options.yAxisDisplayOneLine) {
                this.svg.append("g")
                    .attr("class", "y axis perso-grid")
                    .attr("transform", function (d, i) {
                        var y = helper.yScale(0) + helper.getValueByScreenWidth(helper.options.yAxisTopNegState) + helper.MIN_BAR_HEIGHT;
                        var x = typeof helper.options.horizontalLineLeft != 'undefined'? helper.options.horizontalLineLeft : 0;
                        return ("translate(" + helper.getValueByScreenWidth(x) + "," + y + ")");
                    })
                    .call(helper.yAxis)
                    .selectAll(".tick line")
                    .attr('x2', function (d, i) {
                        var x2 = typeof helper.options.horizontalLineWidth != 'undefined' ? helper.options.horizontalLineWidth : (helper.options.svgWidth || 0);
                        return helper.getValueByScreenWidth(x2);
                    });
            }
            Personetics.utils.d3Helpers.VerticalChartHelperProduct.prototype.renderYAxis.call(this, isNegative);            
        },  
        
        renderChart: function (el) {
            var helper = this;
            //Setting values we need in more than one function
            var cfg = this.config;
            // Set max & min domain's value
            this.minVal = 0;
            this.maxVal = d3.max(helper.seriesData, function (d) {
                return Math.abs(parseFloat(d.value));
            });

            //set X and Y domian.
            this.xScale.domain(helper.categoriesData.map(function (d) {
                return d;
            }));
            this.yScale.domain([this.minVal, this.maxVal]);

            this.minVal = d3.min(helper.seriesData, function (d) {
                return parseFloat(d.value);
            });

            if(this.minVal<0){
                this.yScale.domain([this.minVal, this.maxVal]);
            }
            this.svg = this.renderSVGBase(el);
            this.renderGradient();
            this.renderFilter();
            this.renderYAxis();

            if (this.options.hasOwnProperty('isDesktop') && this.options.isDesktop) {
                this.renderAccessibilityHiddenRects();
            }
            this.renderVerticalBars();
            this.renderXAxis();
            this.renderLabels();
            if ((!this.options.doAnimations) || this.minValue < 0) {
                this.options.barDelay = this.options.barDuration = this.options.labelDelay = this.options.labelDuration = 0;
                this.barAnimations();
            }
        },
        renderGradient: function(){
            var gradients = this.options.rectangles.gradients;
            var defWithGradients = this.svg.append("defs");
            var linearGradient;
            if(gradients){
                $.each(gradients, function(i, gradient){
                    if(gradient){
                        linearGradient = defWithGradients.append("linearGradient")
                            .attr("id",gradient.id)
                            .attr("x1","0")
                            .attr("x2","0")
                            .attr("y1","0")
                            .attr("y2","1");
                            
                        $.each(gradient.stopColors, function(i,stopColor){
                            linearGradient.append("stop")
                            .attr("offset",gradient.offset[i])
                            .attr("stop-color", stopColor);
                        })


                    }
                });
            }
        },
        renderSVGBase: function (el) {
            var helper = this;
            var y = 0;
            var screenWidth = $(window).width();
            if (screenWidth >= 790) {
                y = 10;
            }
            helper.height = helper.getValueByScreenWidth(helper.options.svgHeight);
            return (d3.select(el.get(0)).append("svg")
                .attr("class", "perso-svg-chart-container")
                .attr("width", helper.width)
                .attr("height", helper.height)
                .append("g")
                .attr('class','perso-svg-container-group')
                .attr("transform", function(){
                    return "translate(0," + y + ")";
                }));
        },

        renderVerticalBars: function () {
            var helper = this;
            //get min abs value to set rectangle height
            helper.minAbsValue = d3.min(helper.seriesData, function (d) {
                return Math.abs(d.value) || Infinity;
            });
            helper.maxValue = helper.maxVal;
            //get min value (include negative values) to set y position
            helper.minValue = helper.minVal;

            var rectSpace = helper.getValueByScreenWidth(helper.options.rectangles.space || 30);
            var rectWidth = helper.getValueByScreenWidth(helper.options.rectangles.width);
            var left = (helper.width - (helper.numOfBars * rectWidth + (helper.numOfBars - 1) * rectSpace)) / 2;
            this.bars = this.svg.append("g")
                .attr("transform", function () {
                    var y = helper.getValueByScreenWidth(helper.options.barTop);
                    if (helper.minValue < 0) {
                        y = helper.getValueByScreenWidth(helper.options.barTopNegState);
                    }
                    return "translate(" + left + "," + y + ")";
                })
                .selectAll("rect")
                .data(helper.seriesData)
                .enter()
                .append("rect")
                .attr("class", function (d) {
                    var clazz = "perso-bar";
                    if (d.selected) {
                        clazz += " selected";
                    }
                    if(d.value < 0){
                        clazz +=" perso-negative"
                    }
                    return clazz;
                })
                .attr("x", function (d, i) {
                    return i * (rectSpace + rectWidth);
                })
                .attr("width", function (d, i) {
                    return rectWidth;
                })
                .attr("y", function (d, i) {
                    return helper.getValueByScreenWidth(helper.options.maxBarHeight);
                })
                .attr("height", 0)
                .attr("rx", function (d) {
                    var rx = (helper.options.rectangles.borderRadius.rx) ? helper.options.rectangles.borderRadius.rx : "0";
                    return helper.getValueByScreenWidth(rx);

                })
                .attr("ry", function (d) {
                    var ry = (helper.options.rectangles.borderRadius.ry) ? helper.options.rectangles.borderRadius.ry : "0";
                    return helper.getValueByScreenWidth(ry);

                })
                .on("click", function (obj, clickedItemIndex) {
                    if (typeof helper.handleClick == 'function') {
                        helper.handleClick(obj, clickedItemIndex);
                    }
                })
        },

        getBarsHeight: function (d) {
            var currentValue = Math.abs(d.value);
            var barHeight = d.value ? this.getValueByScreenWidth(this.options.maxBarHeight) - this.yScale(currentValue) : 0;
            if (this.minValue < 0) {
                barHeight = d.value ? this.yScale(0) - this.yScale(currentValue) + this.MIN_BAR_HEIGHT : 0;
            }

            d.barHeight = barHeight;
            return barHeight;
        },

        getBarsY: function (d) {
            var yValue;
            if (d.value < 0) {
                yValue = this.yScale(0) + this.MIN_BAR_HEIGHT;
            } else {
                yValue = this.yScale(d.value);
            }
            return yValue;
        },

        renderLabels: function () {
            // if there are 6 column, minimize the font size
            var cssClass = "perso-label perso-label-fadeIn";
            var helper = this;
            if (helper.seriesData.length >= 6) {
                cssClass += " minimize-font";
            }
            if (this.options.labels.drawLabels) {
                this.label = this.svg.append("g")
                    .attr("transform", function () {
                        var y = helper.options.labelTop ? helper.getValueByScreenWidth(helper.options.labelTop) : 0;
                        return ("translate(" + helper.calcLeft + "," + y + ")");
                    })
                    .selectAll()
                    .data(helper.seriesData)
                    .enter()
                    .append("text")
                    .attr("class", function (d) {
                        var clazz = cssClass;
                        if (d.selected) {
                            clazz += " selected";
                        }
                        return clazz;
                    })
                    .attr("text-anchor", "middle")
                    .attr("x", function (d, i) {
                        return (helper.xScale(helper.categoriesData[i]));
                    })
                    .attr("y", function (d) {
                        return helper.getLabelsY(d);
                    })
                    .attr("dy", function (d) {
                        if (d.value < 0)
                            return "1em";
                        return 0;
                    });

                // support IE
                var amounts = this.svg.selectAll('.perso-label');
                var tspans = amounts.append('tspan');

                $.each(tspans[0], function (index, tspan) {
                    var attrs = $(helper.seriesData[index].label)[0].attributes;
                    $.each(attrs, function (j, attr) {
                        tspan.setAttribute(attr.name, attr.value);
                    });
                    $(tspan).attr("perso-index", index);
                    var totalAmountChildren = $($(helper.seriesData[index].label)[0]).children();
                    $.each(totalAmountChildren, function (i, node) {
                        var svgTspan = helper.svg.select('[perso-index="' + index + '"]');
                        var innerTspan = svgTspan.append('tspan').text($(node).text());
                        var attrs = node.attributes;
                        $.each(attrs, function (j, attr) {
                            innerTspan.attr(attr.name, attr.value);
                        });
                    });
                });
            }
        },

    })
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, Handlebars, undefined){

this["Personetics"] = this["Personetics"] || {};
this["Personetics"]["UI"] = this["Personetics"]["UI"] || {};
this["Personetics"]["UI"]["Handlebars"] = this["Personetics"]["UI"]["Handlebars"] || {};
this["Personetics"]["UI"]["Handlebars"]["templates"] = this["Personetics"]["UI"]["Handlebars"]["templates"] || {};

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector-inner-card-desktop"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "	<span class=\"perso-account-number\" aria-label=\""
    + alias4(((helper = (helper = helpers.numberPrefAccessibility || (depth0 != null ? depth0.numberPrefAccessibility : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberPrefAccessibility","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
    + ".\">"
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "		<span class=\"pstory-button-txt perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.text2 || (depth0 != null ? depth0.text2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"card card_"
    + alias4(((helper = (helper = helpers.typeImage || (depth0 != null ? depth0.typeImage : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"typeImage","hash":{},"data":data}) : helper)))
    + " cards"
    + alias4(((helper = (helper = helpers.numCards || (depth0 != null ? depth0.numCards : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numCards","hash":{},"data":data}) : helper)))
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.id : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	<span class=\"perso-account-name\" aria-label=\""
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + ".\">"
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + "</span>\n	<div class=\"perso-account-selector-card-line\"></div>\n	<div id=\"pop-"
    + alias4(container.lambda(depth0, depth0))
    + "\" class=\"pstory-button-txt-wrapper\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.text2 : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		<span class=\"pstory-button-txt\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n	</div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pie-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-pie-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\" tabindex=\"0\">\n            <div class=\"pstory-pie-chart\"></div>\n            <div class=\"pstory-pie-data\">\n                <input type=\"button\" class=\"pstory-arrow pstory-next-arrow\" tabindex=\"-1\" aria-label=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.nextCategory : stack1), depth0))
    + "\"/>\n                <div class=\"pstory-pie-info perso-accessibility-wrapper\" role=\"text\">\n                </div>\n                <input type=\"button\" class=\"pstory-arrow pstory-previous-arrow\" tabindex=\"-1\" aria-label=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.previousCategory : stack1), depth0))
    + "\"/>\n                <div class=\"carousel-animate carousel-wrapper\">\n                    <div class=\"carousel-index-wrapper\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist3-desktop"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "                    <tr>\n                        <td class=\"perso-loading-table\">Loading...</td>\n                    </tr>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda;

  return "                            <tr >\n                                <td>\n                                    <span class=\"perso-td-first-row perso-td-date\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                                <td  class=\"leftAlign\"> \n                                    <span class=\"perso-td-first-row perso-td-account-number\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.accountNumber : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                    <span class=\"perso-td-transaction\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                                <td class=\"leftAlign\" >\n                                    <span class=\"perso-td-first-row\">\n                                        "
    + container.escapeExpression(alias1((depths[1] != null ? depths[1].balanceLabel : depths[1]), depth0))
    + "\n                                    </span>\n                                    <span class=\"perso-td-amount-balance\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.balance : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>   \n                            </tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <table class=\"pstory-table pstory-table-txlist3\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "            </table>\n        </div>\n    </div>\n</div>\n";
},"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-table-perso-txlist4-desktop"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "                    <tr>\n                        <td class=\"perso-loading-table\">Loading...</td>\n                    </tr>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda;

  return "                            <tr >\n                                <td>\n                                    <span class=\"perso-td-first-row perso-td-date\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.date : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                    <span class=\"perso-td-transaction\">\n                                        "
    + ((stack1 = alias1((depth0 != null ? depth0.transaction : depth0), depth0)) != null ? stack1 : "")
    + "\n                                    </span>\n                                </td>\n                                <td  class=\"leftAlign\">\n                                      <span class=\"perso-td-first-row perso-td-amount-balance\">\n                                          "
    + ((stack1 = alias1((depth0 != null ? depth0.balance : depth0), depth0)) != null ? stack1 : "")
    + "\n                                      </span>\n                                </td>\n                            </tr>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"pstory-block-frame pstory-block-table\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <table class=\"pstory-table pstory-table-txlist4\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.future : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "            </table>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-rating-desktop"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"perso-ratings-wrapper perso-rating-close-state\">\n   <div class='perso-ratings-text'>"
    + container.escapeExpression(((helper = (helper = helpers.ratingTitle || (depth0 != null ? depth0.ratingTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ratingTitle","hash":{},"data":data}) : helper)))
    + "</div>\n   <div class='perso-ratings-icons' data-rating-max='5' role=\"application\"></div>\n</div>\n\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-feedback-desktop"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"perso-feedback-wrapper perso-rating-close-state\">\n    <div class=\"textarea-wrapper\">\n        <div class=\"textarea-container\">\n            <textarea class=\"perso-feedback-text direction-text-center\" aria-label=\""
    + ((stack1 = ((helper = (helper = helpers.lblfeedbackprompt || (depth0 != null ? depth0.lblfeedbackprompt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblfeedbackprompt","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" maxlength=\"500\" placeholder=\""
    + ((stack1 = ((helper = (helper = helpers.lblfeedbackprompt || (depth0 != null ? depth0.lblfeedbackprompt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblfeedbackprompt","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"></textarea>\n            <div class=\"textarea-size\" ></div>\n        </div>\n        <input class=\"perso-feedback-submit\" type=\"button\" value=\""
    + ((stack1 = ((helper = (helper = helpers.btnsubmit || (depth0 != null ? depth0.btnsubmit : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnsubmit","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" disabled=\"disabled\"/>\n        <input class=\"perso-feedback-submit-arrow\" type=\"button\" disabled=\"disabled\"/>\n    </div>\n    <div class=\"perso-feedback-reaction\">"
    + ((stack1 = ((helper = (helper = helpers.lblreactionFeedback || (depth0 != null ? depth0.lblreactionFeedback : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblreactionFeedback","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector-inner-card-desktop"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return container.escapeExpression(((helper = (helper = helpers.image || (depth0 != null ? depth0.image : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    var helper;

  return container.escapeExpression(((helper = (helper = helpers.type || (depth0 != null ? depth0.type : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"type","hash":{},"data":data}) : helper)));
},"5":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "            <span class=\"perso-account-number\" aria-label=\""
    + alias4(((helper = (helper = helpers.numberPrefAccessibility || (depth0 != null ? depth0.numberPrefAccessibility : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberPrefAccessibility","hash":{},"data":data}) : helper)))
    + " "
    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
    + ".\">..."
    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "            <span class=\"pstory-button-txt perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.text2 || (depth0 != null ? depth0.text2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"card card_"
    + alias4(((helper = (helper = helpers.typeImage || (depth0 != null ? depth0.typeImage : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"typeImage","hash":{},"data":data}) : helper)))
    + " cards"
    + alias4(((helper = (helper = helpers.numCards || (depth0 != null ? depth0.numCards : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numCards","hash":{},"data":data}) : helper)))
    + "\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"card-container\">\n        <div class=\"card-image\">\n            <div class=\"image "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.image : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\"></div>\n        </div>\n        <div class=\"perso-account-txt-wrapper\">\n            <span class=\"perso-account-name\" aria-label=\""
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + ".\">"
    + alias4(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
    + "</span>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.number : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "        </div>\n        <div id=\"pop-"
    + alias4(container.lambda(depth0, depth0))
    + "\" class=\"pstory-button-txt-wrapper\" pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.text2 : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "            <span class=\"pstory-button-txt\">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n        </div>\n    </div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-account-selector"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return "            <div class=\"header-container\">\n                <div class=\"pstory-tab-animated-border-bottom\"></div>\n                <ul class=\"tablist\" role=\"tablist\">\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.headersArray : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                </ul>\n            </div>\n            <div class=\"carousel-outer-wrapper\">\n                <div class=\"carousel-animate options-container carousel-wrapper pstory-show-header-tabs\">\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "                    <li class=\"pstory-header-button\" "
    + ((stack1 = helpers["if"].call(alias1,(depths[1] != null ? depths[1].isDesktopMode : depths[1]),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " role=\"tab\" data-all=\""
    + container.escapeExpression(((helper = (helper = helpers.isAll || (depth0 != null ? depth0.isAll : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"isAll","hash":{},"data":data}) : helper)))
    + "\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isAll : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">"
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</li>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return " tabindex=\"0\" aria-label=\""
    + ((stack1 = ((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"text","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\"\n                        ";
},"5":function(container,depth0,helpers,partials,data) {
    return " pstory-id=\"all\" ";
},"7":function(container,depth0,helpers,partials,data) {
    return "                    <div class=\"carousel-outer-wrapper\">\n                        <div class=\"carousel-animate options-container carousel-wrapper\">\n";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "                                <div class=\"carousel-item pstory-button "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.selected : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" aria-hidden=\"true\"\n                                    pstory-id=\""
    + alias4(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
    + "\" pstory-event=\""
    + alias4(((helper = (helper = helpers.event || (depth0 != null ? depth0.event : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"event","hash":{},"data":data}) : helper)))
    + "\" role=\""
    + alias4(container.lambda((depths[1] != null ? depths[1].role : depths[1]), depth0))
    + "\">\n                                    "
    + ((stack1 = helpers["if"].call(alias1,(depths[1] != null ? depths[1].isDesktopMode : depths[1]),{"name":"if","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.program(14, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "                                </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "selected";
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return " "
    + ((stack1 = container.invokePartial(partials.innerCardDesktop,depth0,{"name":"innerCardDesktop","hash":{"numberPrefAccessibility":(depths[1] != null ? depths[1].numberPrefAccessibility : depths[1]),"numberPref":(depths[1] != null ? depths[1].numberPref : depths[1])},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n                                    ";
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1;

  return " "
    + ((stack1 = container.invokePartial(partials.innerCard,depth0,{"name":"innerCard","hash":{"numberPrefAccessibility":(depths[1] != null ? depths[1].numberPrefAccessibility : depths[1]),"numberPref":(depths[1] != null ? depths[1].numberPref : depths[1])},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "                            <div class=\"carousel-index-wrapper\" "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ">\n                                <div class=\"carousel-index-container\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                                </div>\n                            </div>\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " role=\"application\"\n                                aria-labelledby=\"perso-accessibility-read-"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1["0"] : stack1)) != null ? stack1.id : stack1), depth0))
    + "\" ";
},"19":function(container,depth0,helpers,partials,data) {
    return "                                    <div class=\"carousel-index-dot\">\n                                        <div class=\"carousel-index-dot-circle\"></div>\n                                    </div>\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "                                <span class=\"perso-bold\">"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt2 || (depth0 != null ? depth0.allAccountsTxt2 : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"allAccountsTxt2","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n";
},"23":function(container,depth0,helpers,partials,data) {
    return " tabindex=\"-1\" ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"perso-accessibility-wrapper perso-accessibility-account-selector\" role=\"text\">\n    <span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountSelectorText || (depth0 != null ? depth0.accountSelectorText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountSelectorText","hash":{},"data":data}) : helper)))
    + "</span>\n</div>\n<div id=\"pstory-block-account-selector_"
    + alias4(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"pstory-block-frame pstory-block-account-selector "
    + alias4(((helper = (helper = helpers["class"] || (depth0 != null ? depth0["class"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"class","hash":{},"data":data}) : helper)))
    + "\"\n    data-show-header-tabs="
    + alias4(((helper = (helper = helpers.showHeaderTabs || (depth0 != null ? depth0.showHeaderTabs : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"showHeaderTabs","hash":{},"data":data}) : helper)))
    + ">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeaderTabs : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(7, data, 0, blockParams, depths),"data":data})) != null ? stack1 : "")
    + "                            <div class=\"carousel-inner-wrapper cards-wrapper\" aria-hidden=\"true\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.options : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                            </div>\n\n                            <div class=\"perso-accessibility-wrapper pstory-account-button selected\" role=\"text\">\n                                <span class=\"perso-accessibility-read\">"
    + alias4(((helper = (helper = helpers.accountName || (depth0 != null ? depth0.accountName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountName","hash":{},"data":data}) : helper)))
    + ". "
    + alias4(((helper = (helper = helpers.numberPrefAccessibility || (depth0 != null ? depth0.numberPrefAccessibility : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberPrefAccessibility","hash":{},"data":data}) : helper)))
    + "\n                                    "
    + alias4(((helper = (helper = helpers.accountNumber || (depth0 != null ? depth0.accountNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"accountNumber","hash":{},"data":data}) : helper)))
    + "</span>\n                            </div>\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showIndexDots : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                            <div class=\"pstory-all-accounts-txt\" role=\"text\">\n                                <span>"
    + ((stack1 = ((helper = (helper = helpers.allAccountsTxt || (depth0 != null ? depth0.allAccountsTxt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"allAccountsTxt","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</span>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.allAccountsTxt2 : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "                            </div>\n                        </div>\n                        <input type=\"button\" class=\"pstory-account-button pstory-prev-account-button\" aria-label=\""
    + alias4(((helper = (helper = helpers.prev || (depth0 != null ? depth0.prev : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"prev","hash":{},"data":data}) : helper)))
    + "\"\n                            "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " />\n                        <input type=\"button\" class=\"pstory-account-button pstory-next-account-button\" aria-label=\""
    + alias4(((helper = (helper = helpers.next || (depth0 != null ? depth0.next : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"next","hash":{},"data":data}) : helper)))
    + "\"\n                            "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDesktopMode : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0, blockParams, depths),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " />\n                    </div>\n                    <div class=\"pstory-comment\">"
    + ((stack1 = ((helper = (helper = helpers.comment || (depth0 != null ? depth0.comment : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"comment","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n                </div>\n            </div>\n        </div>";
},"usePartial":true,"useData":true,"useDepths":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pie-chart"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"pstory-block-frame pstory-block-pie-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\" tabindex=\"0\">\n            <div class=\"pstory-pie-chart\">\n                <div class=\"pieCircle\"></div>\n                <div class=\"perso-pie-total-text perso-pie-total\"></div>\n                <div class=\"perso-pie-total-text perso-pie-type\"></div>\n                <div class=\"perso-pie-total-amount\"></div>\n            </div>\n\n            <div class=\"pstory-pie-data\">\n                <div class=\"pstory-data-wrapper\">\n                    <input type=\"button\" class=\"pstory-arrow pstory-next-arrow\" tabindex=\"-1\" aria-label=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.nextCategory : stack1), depth0))
    + "\" />\n                    <div class=\"pstory-pie-info perso-accessibility-wrapper\" role=\"text\">\n                    </div>\n                    <input type=\"button\" class=\"pstory-arrow pstory-previous-arrow\" tabindex=\"-1\" aria-label=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.texts : depth0)) != null ? stack1.previousCategory : stack1), depth0))
    + "\" />\n                </div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["pstory-block-pinGraph-chart"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return container.escapeExpression(((helper = (helper = helpers.mode || (depth0 != null ? depth0.mode : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"mode","hash":{},"data":data}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    return "Out";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"pstory-block-frame pstory-block-pinGraph-chart_"
    + container.escapeExpression(((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"index","hash":{},"data":data}) : helper)))
    + " pstory-block-pinGraph-chart\">\n    <div class=\"pstory-block-container\">\n        <div class=\"pstory-block-content\">\n            <div class=\"pstory-pinGraph-chart "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.mode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\"></div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-pstory-title"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div id=\"story-frame-container\">\n    <div class=\"pstory-title-outer-wrapper\">\n        <div class=\"pstory-title-wrapper\">\n            <div class=\"pstory-title\">\n                <input aria-label=\""
    + container.escapeExpression(((helper = (helper = helpers.backButtonText || (depth0 != null ? depth0.backButtonText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"backButtonText","hash":{},"data":data}) : helper)))
    + "\" type=\"button\" class=\"pstory-title-close\"/>\n                <div role=\"heading\" aria-level=\"1\" class=\"pstory-title-text\">"
    + ((stack1 = ((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n                <div class=\"pstory-title-date\">"
    + ((stack1 = ((helper = (helper = helpers.dateTitle || (depth0 != null ? depth0.dateTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dateTitle","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n            </div>\n        </div>\n    </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-feedback-desktop"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"perso-feedback-wrapper\">\n    <div class=\"perso-feedback-inner-wrapper\">\n        <div class=\"perso-feedback-header\">"
    + ((stack1 = ((helper = (helper = helpers.lblfeedbackheader || (depth0 != null ? depth0.lblfeedbackheader : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblfeedbackheader","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n        <div class=\"textarea-wrapper\">\n            <div class=\"textarea-container\">\n                <textarea class=\"perso-feedback-text direction-text-left\" maxlength=\"500\"></textarea>\n            </div>\n            <input class=\"perso-feedback-submit\" type=\"button\" value=\""
    + ((stack1 = ((helper = (helper = helpers.btnsubmit || (depth0 != null ? depth0.btnsubmit : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnsubmit","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" disabled/>\n            <input class=\"perso-feedback-skip\" type=\"button\" value=\""
    + ((stack1 = ((helper = (helper = helpers.btnskip || (depth0 != null ? depth0.btnskip : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"btnskip","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\" />\n        </div>   \n    </div>\n    <div class=\"perso-feedback-reaction\">"
    + ((stack1 = ((helper = (helper = helpers.lblreactionFeedback || (depth0 != null ? depth0.lblreactionFeedback : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lblreactionFeedback","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-rating-desktop"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;

  return "<div class=\"perso-ratings-outer-wrapper\">\n   <div class=\"perso-ratings-wrapper\">\n      <div class='perso-ratings-text'>"
    + alias4(((helper = (helper = helpers.ratingTitle || (depth0 != null ? depth0.ratingTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ratingTitle","hash":{},"data":data}) : helper)))
    + "</div>\n      <div class=\"perso-ratings-yes-no\">\n         <div class=\"perso-ratings-box perso-ratings-box-yes\" data-val=\"4\">\n            <div class=\"perso-rating-yes-icon\">"
    + alias4(((helper = (helper = helpers.ratingYes || (depth0 != null ? depth0.ratingYes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ratingYes","hash":{},"data":data}) : helper)))
    + "</div>\n            <div class=\"perso-rating-yes-text\"></div>\n         </div>\n         <div class=\"perso-ratings-box perso-ratings-box-no\" data-val=\"2\">\n            <div class=\"perso-rating-no-icon\">"
    + alias4(((helper = (helper = helpers.ratingNo || (depth0 != null ? depth0.ratingNo : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ratingNo","hash":{},"data":data}) : helper)))
    + "</div>\n            <div class=\"perso-rating-no-text\"></div>\n         </div>\n      </div>\n   </div>\n</div>";
},"useData":true});

this["Personetics"]["UI"]["Handlebars"]["templates"]["tmpl-perso-widget-story-error-desktop"] = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "\n\n\n<div id=\"personetics-error-container\" >\n    <div class=\"personetics-error-content-desktop\"> \n        <div class=\"personetics-error-wrapper\"> \n            <div class=\"personetics-error-img "
    + container.escapeExpression(((helper = (helper = helpers.imgClass || (depth0 != null ? depth0.imgClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"imgClass","hash":{},"data":data}) : helper)))
    + "\"></div> \n           <div class=\"personetics-error-text\">"
    + ((stack1 = ((helper = (helper = helpers.textSmall || (depth0 != null ? depth0.textSmall : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"textSmall","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>\n        </div>\n     </div>\n</div>";
},"useData":true});})(window, window.Personetics = window.Personetics || {}, jQuery, window.Personetics.UI.Handlebars);


(function(window, Personetics, $, undefined){
    Personetics.UI = Personetics.UI || {};
    var factory = Base.extend({

        widgetsTextsMap: {	
        },
        defaultLang: "en",
        getText: function(textId, lang, fallbackText) {
            var fallbackTextValue = fallbackText || "";
            var text = fallbackTextValue;
            if(this.widgetsTextsMap.hasOwnProperty(textId)){
                var textObj = this.widgetsTextsMap[textId];
                text = textObj[lang] || textObj[this.defaultLang] || fallbackTextValue;
            }     
            return text;
        },
        registerText: function(textId, text, lang)

        {
           var lang = lang || this.defaultLang;
           if(!this.widgetsTextsMap.hasOwnProperty(textId))
                this.widgetsTextsMap[textId] = {};
           this.widgetsTextsMap[textId][lang] = text;
        }
    });

    Personetics.UI.PWidgetsTextsFactory = new factory();

})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.UI = Personetics.UI || {};

    Personetics.UI.PAppCtrl = Personetics.UI.PWidgetCtrl.extend({
        initialize: function(config){
            this.super = Personetics.UI.PWidgetCtrl.prototype;
            this.super.initialize.call(this, config);

            this.config.parentCtrl = this;
            this.config.widthMode = "";

            this.widgets = {};
            var skinController = config.uxCtrl;
			if (!skinController)
				    skinController = new Personetics.story.skinController();
			this.uxCtrl = skinController;
			this.desktopScreenWidth = this.uxCtrl.getDesktopScreenWidth();
			this.screenWidth = $( window ).width();
			if(this.screenWidth >= this.desktopScreenWidth){
				this.config.widthMode = "desktop";
			}
            this.setFirstWidgetType(config.widgetType);
            this.registerTexts();
        },

        setFirstWidgetType: function(widgetType){
            this.firstWidgetType = widgetType || "insights";
        },

        addConfigurationClasses: function(){
            var deviceType = personetics.getDeviceType();
            this.el.addClass("personetics-device-" + deviceType);;
        },

        getWidgetEl: function(widgetType){
            var widgetEl = this.el.find("#personetics-" + widgetType);
            if(widgetEl.length == 0){
                widgetEl = $("<div id='personetics-" + widgetType + "'></div>");
                this.el.append(widgetEl);
            }
            return widgetEl;
        },

        start: function(el){
            el.empty();
            var containerEl = $("<div class='personetics-widgets-wrapper'></div>");
            el.append(containerEl);
            this.el = containerEl;
            this.addConfigurationClasses();            
            var widget = Personetics.UI.PWidgetFactory.createWidget(this.firstWidgetType, this.config);
            this.widgets[this.firstWidgetType] = widget;
            var firstWidgetEl = this.getWidgetEl(this.firstWidgetType);
            widget.start(firstWidgetEl);
        },

        sendMessage: function(messageObj){
            var widgetType = messageObj.targetWidget;
            var message = messageObj.message;
            var args = messageObj.arguments;

            var widget = this.widgets[widgetType];
            if(widget && widget.hasOwnProperty(message)){
                return widget[message].apply(widget, args);
            }
        },

        startWidget: function(widgetType, options){
            options.parentCtrl = options.parentCtrl || this;
            options.widthMode = this.config.widthMode;
            var widget = Personetics.UI.PWidgetFactory.createWidget(widgetType, options);

            widget.start(options.el);

            if(widget)
                this.widgets[widgetType] = widget;
        },
        
        closeLoading: function closeLoading(){
            this.sendMessage({targetWidget: "loading-animation", message: "removeLoading"});
        },

        startManagement: function(options){
            var el = options.el;
            var managementCtrl = new Personetics.UI.PManagementCtrl(options, this);
            managementCtrl.start(el);
            return managementCtrl;
        },

        startRatings: function(options){
            var el = $(".pstory-frame");
            this.currentRatingsEl = el;
            var ratingCtrl = new Personetics.UI.PRatingCtrl(options, this);
            ratingCtrl.start(el);
            return ratingCtrl;
        },
        startInbox: function(options){
            var el = options.el;
            var inboxCtrl = new Personetics.story.PInboxCtrl(options, this);
            inboxCtrl.start(el);
            return inboxCtrl;
        },
        registerTexts: function registerTexts(){
            Personetics.dictionary.setLanguage(this.config.lang);
        }

    });

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.UI = Personetics.UI || {};

    Personetics.UI.PAppCtrlProduct = Personetics.UI.PAppCtrl.extend({
        setFirstWidgetType: function(widgetType){
            this.firstWidgetType = widgetType || "teaser-widget";
        },
        registerTexts: function registerTexts() {
            Personetics.UI.PAppCtrl.prototype.registerTexts.call(this);
        }
    });

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    Personetics.UI = Personetics.UI || {};

    Personetics.UI.PRatingCtrl = Personetics.UI.PWidgetCtrl.extend({
        initialize : function (config) {
            this.super = Personetics.UI.PWidgetCtrl.prototype;
            this.super.initialize.call(this, config);
            this.insight = this.config.insight;
            this.lang = this.config.lang;
            this.texts = {
                accessibilityRatingLevelTitle: Personetics.dictionary.getText("accessibilityRatingLevelTitle")
            };
            this.ratingTemplate = "#tmpl-perso-rating";
            this.feedbackTemplate = "#tmpl-perso-feedback";
        },

        start: function (el) {
            this.el = el;
            if($(window).width() < this.config.parentCtrl.desktopScreenWidth && !!window.MSInputMethodContext && !!document.documentMode) { //IE 11
                el.addClass("ie-11")
            }
            var ratingTmpl = this.getRatingTemplate();
            el.append(ratingTmpl);
            this.fixRatingElToBottom();
            this.sendGetRatings();
        },

        getRatingTemplate: function getRatingTemplate() {
            var ratingTitle = Personetics.dictionary.getText("lblstoryRating");
            var ratingTmpl = this.getTemplateHtml(this.ratingTemplate,{
                ratingTitle: ratingTitle
            });
            return ratingTmpl;
        },

        fixRatingElToBottom: function fixRatingElToBottom(){
            var ratingEl = this.el.find('.perso-ratings-wrapper');
            var ratingHeight = ratingEl.height() + 1;
            ratingEl.height(ratingHeight);
            //calculate el height : 100% - rating el height - rating el's height/margin
            var ratingOuterHeight = ratingEl.outerHeight(true);

            //min height gets 2px more than nessesary for forcing small scroll in order to solve missing account bug.
            this.el.find('.pstory-container').css('minHeight','calc(100% - '+(ratingOuterHeight - 2)+'px)');
        },

        sendGetRatings : function () {
            var testData = window.testData ? window.testData.ratings : null;
            var me = this;
            if (testData) {
                setTimeout(function () {
                    me.onGetRatigsResponse((testData));
                }, 500);
            } else {
                var data = {
                    id : this.insight.id
                };
                personetics.getInsightRating(
                    data,
                    Personetics.bind(this, this.onGetRatigsResponse),
                    Personetics.bind(this, this.onGetRatingsError));
            }
        },

        onGetRatigsResponse : function (json) {
            var rating = json ? json.rating : 0;
            var el = this.el.find(".perso-ratings-icons");
            this.id = json.id;
            this.starRating(el, rating);
            this.afterRender();
        },

        onGetRatingsError: function onGetRatingsError(){
            this.onError();
            //create default response object for error case
            //in error case - rating should be created as onsuccess with rating = 0
            var json = {
                id: this.insight.id,
                rating: 0
            }
            this.onGetRatigsResponse(json);
        },

        starRating : function (el, prevRating) {
            var me = this;
            var ratingId = this.insight.id + '_' + this.el.index() + '_rating_';
            var $ratingElement = el;
            var ratingMax = $ratingElement.data("rating-max");
            return el.each(function () {
                for (var x = 0; x < ratingMax; x++) {
                    var starElement = me.createRatingStarElement(x, prevRating, ratingId + x, ratingMax);
                    $ratingElement.append(starElement);
                }
                var $ratingItems = $ratingElement.children("input");
                var rating = 0;
                $ratingItems.bind("click", {
                    id : me.id,
                    me : me
                }, Personetics.bind(me, me.rateClick));
                if (typeof prevRating !== 'undefined' && prevRating !== null) {
                    rating = prevRating;
                    $ratingElement.attr("data-val", rating);   
                    $($ratingItems[rating-1]).attr("checked",true);
                }

            });                 
        },

        createRatingStarElement : function createRatingStarElement(index, prevRating, ratingElementId){
            var label = this.texts.accessibilityRatingLevelTitle + ' ' + (index+1);
            var element = $("<input type='radio' id='" + ratingElementId + "' name='rating' aria-label='" + label + "'/><label for='" + ratingElementId + "'/>");
            return element;
        },

        afterRender : function(){
        },

        rateClick: function rateClick(e) {
            this.onRateClick(e);
            this.feedbackStart();
        },

        onRateClick: function onRateClick(e) {
            var target = e.currentTarget;
            var rating = $(target).index(".perso-ratings-icons input[type='radio']") + 1;
            $("li:lt(" + rating + ")", $(target).parent("ul")).addClass("perso-hover");
            $("li:gt(" + ($(target).index()) + ")", $(target).parent("ul")).removeClass("perso-hover");
            $(target).closest("[data-val]").attr("data-val", rating);
            this.eventObj = {
                id : e.data.id,
                rating : rating
            };
            var testData = window.testData ? window.testData.ratingsResponse : null;
            if (testData) {
                var widget = this;
                setTimeout(function () {
                    e.data.me.onSuccesRate((testData));
                }, 500);
            } else {
                personetics.updateInsightRating(this.eventObj, e.data.me.onSuccesRate, e.data.me.onError);   
            }
        },
        feedbackStart: function feedbackStart() {
            if (Personetics.projectConfiguration.getConfig("showFeedback") == true) {
                if (!this.disableFeedBack) {

                    this.showFeedback();
                }
                else{
                    if(this.el.find('.perso-feedback-text').length > 0 && this.el.find(".perso-feedback-text").val() == ""){
                        var lblfeedbackprompt = Personetics.dictionary.getText("lblfeedbackprompt" + this.eventObj.rating);
                        var feedbackText =this.el.find('.perso-feedback-text');
                        feedbackText.attr({placeholder :lblfeedbackprompt,"aria-label":lblfeedbackprompt});
                    }
                }
            }
        },

        onSuccesRate: function (data) {
            Personetics.log("rating succes");
        },

        onError : function () {
            Personetics.log("rating error");
        },
        
        showFeedback:function showFeedback(){
            var widget = this;

            this.el.find('.perso-feedback-wrapper').remove();
            this.disableFeedBack = true;
            var lblfeedbackprompt = Personetics.dictionary.getText("lblfeedbackprompt" + this.eventObj.rating);
            var lblreactionFeedback = Personetics.dictionary.getText("lblreactionFeedback");
            var btnsubmit = Personetics.dictionary.getText("btnsubmit");

            var ratingTmpl = this.getTemplateHtml(this.feedbackTemplate,{
                lblfeedbackprompt: lblfeedbackprompt,
                lblreactionFeedback: lblreactionFeedback,
                btnsubmit: btnsubmit
            });    
            this.el.append(ratingTmpl);
            var submit = this.el.find('.perso-feedback-submit');
            submit.css('margin-left','calc(100% - '+ submit.outerWidth() +'px)');
            submit.bind("click",{
                id : widget.insight.id,
                widget : widget
            },Personetics.bind(widget, widget.sendFeedback));
            
            submit.hide();//hide submit
            this.el.find('.perso-feedback-reaction').hide();//hide perso-feedback-reaction
            
            var element = this.el.find('.perso-feedback-wrapper'); 
            this.scrollToEnd(this.el,element);

            this.feedbackText = this.el.find('.perso-feedback-text');
            this.textareaSize = this.el.find('.textarea-size');
            var feedbackTextFocusBind = Personetics.bind(this, this.feedbackTextFocus);
            $(this.feedbackText).bind('focus',feedbackTextFocusBind);
            var feedbackTextBlurBind = Personetics.bind(this, this.feedbackTextBlur);
            $(this.feedbackText).bind('blur',feedbackTextBlurBind);
            widget.textareaSize.text(this.feedbackText.value + '\n');
            var feedbackTextInputBind = Personetics.bind(this, this.feedbackTextInput);
            $(this.feedbackText).bind('input', feedbackTextInputBind);
        },

        feedbackTextBlur: function feedbackTextBlur(e){
            var widget =this;
            var lblfeedbackprompt = Personetics.dictionary.getText("lblfeedbackprompt" + this.eventObj.rating);
                if(this.value == 0){
                    widget.el.find('.perso-feedback-submit').hide();
                    widget.feedbackText.removeClass('direction-text');
                    widget.feedbackText.addClass('direction-text-center');
                    widget.feedbackText.attr("placeholder",lblfeedbackprompt);
                }
                setTimeout(function(){
                    widget.parentCtrl.enableCollapse = true;
                }, 800);
               
            },
        feedbackTextInput: function feedbackTextInput(e) {
            if(e.target.value == ""){
                this.el.find('.perso-feedback-submit').attr('disabled','disabled')
            }
            else{
                this.el.find('.perso-feedback-submit').removeAttr('disabled');
            }
            var element = this.el.find('.perso-feedback-wrapper');
            var feedbackelement = this.el.find('.perso-feedback-text');
            feedbackelement.css('padding-top','0.538em');
            this.textareaSize.text(e.target.value + '\n');
            //scrollToEnd
            this.el.scrollTop(this.el[0].scrollHeight)
        },
        feedbackTextFocus: function feedbackTextFocus(e){
            var isIE = /*@cc_on!@*/false || !!document.documentMode;
            var element = this.el.find('.perso-feedback-wrapper');
            var feedbackelement = this.el.find('.perso-feedback-text');
            feedbackelement.css('padding-top','0px');
            this.feedbackText.removeClass('direction-text-center');
            this.feedbackText.addClass('direction-text');
            if(isIE && this.feedbackText.attr('placeholder') == this.feedbackText.val()){
                this.feedbackText.val('');
            }
            this.el.find('.perso-feedback-submit').show();
            //scrollToEnd
            this.el.scrollTop(this.el[0].scrollHeight)
            this.parentCtrl.enableCollapse = false;
        },

        scrollToEnd: function scrollTo(el, toElement){
			if(toElement.length > 0){
				$(el).animate({
					scrollTop: toElement.offset().top - el.offset().top + el.scrollTop()
				}, 500);
			}				
		},
        sendFeedback: function sendFeedback(e){
            var widget = this;
            var feedback = this.el.find('.perso-feedback-text').val();
            if(typeof feedback != "undefined" && feedback.length > 0){
                this.eventObj = {
                    id : e.data.id,
                    feedback : feedback
                };         
                personetics.updateInsightFeedback(this.eventObj, e.data.widget.onSuccesFeedback, e.data.widget.onErrorFeedback);
            }
			widget.showFeedbackReaction();

        },
        onSuccesFeedback : function (data) {
            Personetics.utils.PLogger.debug("feedback succes");
        },
        onErrorFeedback : function () {
            Personetics.utils.PLogger.debug("feedback error");
        },
        showFeedbackReaction : function showFeedbackReaction(){
            var widget = this;
            var height = this.el.find('.perso-feedback-wrapper').height();
            this.el.find('.perso-feedback-wrapper').height(height); 
            var element = this.el.find('.perso-feedback-reaction');
            element.show();   
            this.el.find(".perso-feedback-wrapper").css('overflow','auto');
            var heightreaction = this.el.find('.perso-feedback-reaction').outerHeight();
            
            this.el.find('.perso-feedback-wrapper').animate(
                {'scrollTop':150, 'height': heightreaction},
                400, function() {
                    widget.disableFeedBack = false;
                    widget.el.find(".textarea-wrapper").hide();
            });
        }  
        


    });

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    Personetics.UI = Personetics.UI || {};

    Personetics.UI.OpenBankRatingCtrl = Personetics.UI.PRatingCtrl.extend({

        getRatingTemplate: function getRatingTemplate() {
            var ratingTitle = Personetics.dictionary.getText("lblstoryRating");
            var ratingYes =Personetics.dictionary.getText("lblYes");
            var ratingNo =Personetics.dictionary.getText("lblNo");
            var ratingTmpl = this.getTemplateHtml(this.ratingTemplate,{
                ratingTitle: ratingTitle,
                ratingYes: ratingYes,
                ratingNo: ratingNo
            });
            return ratingTmpl;
        },
        onGetRatigsResponse : function (json) {
            var rating = json ? json.rating : 0;
            var el = this.el.find(".perso-ratings-icons");
            this.id = json.id;
            // if there was no feedback yet
            if (!(typeof rating !== 'undefined' && rating !== null && rating>0)) {
                this.showRating();
                this.starRating(el, rating);
                this.afterRender(); 
            }
           
        },
        starRating : function (el, prevRating) {
            var me = this;
            var ratingId = this.insight.id + '_' + this.el.index() + '_rating_';
            var $ratingElement = el;
            var ratingMax = $ratingElement.data("rating-max");
            var likeItem =this.el.find('.perso-rating-yes-icon');
            likeItem.bind("click", {
                id : me.id,
                me : me
            }, Personetics.bind(me, me.likeClick));

            var dislikeItem =this.el.find('.perso-rating-no-icon');
            dislikeItem.bind("click", {
                id : me.id,
                me : me
            }, Personetics.bind(me, me.dislikeClick));
        },
        showRating:function(){
            this.el.find(".perso-ratings-wrapper").css("opacity","1");
        },

        likeClick: function rateClick(e) {
            this.el.find(".perso-ratings-box-yes").addClass("selected");
            this.el.find(".perso-ratings-box-no").removeClass("selected");
            el=this;
            setTimeout(function () {
                el.rateClick(e);;
            }, 100);
        },

        dislikeClick: function rateClick(e) {
            this.el.find(".perso-ratings-box-no").addClass("selected");
            this.el.find(".perso-ratings-box-yes").removeClass("selected");
            el=this;
            setTimeout(function () {
                el.rateClick(e);;
            }, 100);
        },

        rateClick: function rateClick(e) {
            this.onRateClick(e);
            this.showThanksForFeedback()
        },

        onRateClick: function onRateClick(e) {
            var target = e.currentTarget;
            var rating = $(target).closest("[data-val]").attr("data-val");
            this.eventObj = {
                id : e.data.id,
                rating : rating
            };
            var testData = window.testData ? window.testData.ratingsResponse : null;
            if (testData) {
                var widget = this;
                setTimeout(function () {
                    e.data.me.onSuccesRate((testData));
                }, 500);
            } else {
                personetics.updateInsightRating(this.eventObj, e.data.me.onSuccesRate, e.data.me.onError);
            }


            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                var params = {
                    "eventId": "rating-click",
                    "additionalData": {
                        "value": this.eventObj.rating
                    },
                }
                personetics.createReportingEvent(this, params);
            }
        },

        showThanksForFeedback: function showThanksForFeedback(){
            var widget = this;
            var animDelay = 400;
            if(this.el.find('.perso-feedback-wrapper').length ==0 ){
                var lblreactionFeedback = Personetics.dictionary.getText("lblreactionFeedback");
                var feedbackTmpl = this.getTemplateHtml(this.feedbackTemplate,{
                    lblreactionFeedback: lblreactionFeedback,
                });
                this.el.find('.perso-ratings-wrapper').after(feedbackTmpl);
                this.el.find('.perso-feedback-inner-wrapper').hide();
                animDelay = 200;
            }
            this.el.find('.perso-ratings-wrapper').next('.perso-feedback-wrapper').andSelf().wrapAll('<div class="perso-rating-feedback-wrapper" />');

            this.el.find(".perso-feedback-wrapper").css('overflow','auto');
            var heightreaction = this.el.find('.perso-feedback-reaction').outerHeight();

            this.el.find('.perso-ratings-text, .perso-feedback-header').animate({'opacity': 0}, animDelay / 2);
            this.el.find('.perso-feedback-reaction').fadeOut(0);
            widget.el.find('.perso-ratings-wrapper, .perso-feedback-inner-wrapper').hide();
            widget.el.find('.perso-feedback-reaction').show();
            widget.fixFeedbackElToBottom();
        },

        fixFeedbackElToBottom: function fixRatingElToBottom() {
            var feedbackEl = this.el.find('.perso-feedback-wrapper');
            var feedbackHeight = feedbackEl.height() + 1;
            feedbackEl.height(feedbackHeight);
            //calculate el height : 100% - feedback el height - feedback el's height/margin
            var feedbackOuterHeight = feedbackEl.outerHeight(true);

            //min height gets 2px more than nessesary for forcing small scroll in order to solve missing account bug.
            this.el.find('.pstory-container').css('minHeight', 'calc(100% - ' + (feedbackOuterHeight - 2) + 'px)');
            
            $(feedbackEl).scrollTop(753);
        },

        feedbackStart: function feedbackStart() {
            if (Personetics.projectConfiguration.getConfig("showFeedback") == true && (!this.disableFeedBack)) {
                this.showFeedback();
            }
        },

        onSuccesRate: function (data) {
            Personetics.log("rating succes");
        },

        onError : function () {
            Personetics.log("rating error");
        },

        showFeedback:function showFeedback(){
            var widget = this;

            this.el.find('.perso-feedback-wrapper').remove();
            this.disableFeedBack = true;
            var lblfeedbackheader = "lblfeedbackheader";
            var lblreactionFeedback = "lblreactionFeedback";
            var btnsubmit ="btnsubmit";
            var btnskip ="btnskip";

            var ratingTmpl = this.getTemplateHtml(this.feedbackTemplate,{
                lblreactionFeedback: lblreactionFeedback,
                btnsubmit: btnsubmit,
                btnskip: btnskip,
                lblfeedbackheader: lblfeedbackheader
            });
            this.el.append(ratingTmpl);
            var submit = this.el.find('.perso-feedback-submit');
            submit.bind("click",{
                id : widget.insight.id,
                widget : widget
            },Personetics.bind(widget, widget.sendFeedback));
            var skip = this.el.find('.perso-feedback-skip');
            skip.bind("click", Personetics.bind(widget, widget.showThanksForFeedback));

            this.el.find('.perso-feedback-reaction').hide();//hide perso-feedback-reaction

            var element = this.el.find('.perso-feedback-wrapper');
            this.scrollToEnd(this.el,element);

            this.feedbackText = this.el.find('.perso-feedback-text');
            var feedbackTextInputBind = Personetics.bind(this, this.feedbackTextInput);
            $(this.feedbackText).bind('input', feedbackTextInputBind);
        },


        feedbackTextInput: function feedbackTextInput(e) {
            if(e.target.value == ""){
                this.el.find('.perso-feedback-submit').attr('disabled','disabled')
            }
            else{
                this.el.find('.perso-feedback-submit').removeAttr('disabled');
            }
        },

        sendFeedback: function sendFeedback(e){
            var widget = this;
            var feedback = this.el.find('.perso-feedback-text').val();
            if(typeof feedback != "undefined" && feedback.length > 0){
                this.eventObj = {
                    id : e.data.id,
                    feedback : feedback
                };
                personetics.updateInsightFeedback(this.eventObj, e.data.widget.onSuccesFeedback, e.data.widget.onErrorFeedback);
            }
            widget.showThanksForFeedback();
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.UI = Personetics.UI || {};

    Personetics.UI.PLoadingAnimationCtrl = Personetics.UI.PWidgetCtrl.extend({
        initialize : function (config) {
            this.super = Personetics.UI.PWidgetCtrl.prototype;
            this.super.initialize.call(this, config);
            this.loadingText = this.getLoadingTxt(config);
        },

        getLoadingTxt: function getLoadingTxt(config){
            return config.loadingText;
        },
        
        start : function (el) {

            this.el = el;
            this.el.empty();
            var loadingText = this.loadingText;
            var loadingTmpl = this.getTemplateHtml("#tmpl-perso-loading-animation",{
                loadingText: loadingText
            });
            
            el.append(loadingTmpl);
            this.afterRender();
        },

        afterRender: function afterRender(){
            //if(config.fillParentSpace)
            this.setHeightToParentSpace();
        },

        setHeightToParentSpace:function setHeightToParentSpace(){
            var parentEl = this.el.parent();
            var parentHeight = parentEl.height();
            var totalSiblingsHeight = 0;
            var siblings = this.el.siblings();
            $.each(siblings, function(index, item){
                if($(item).css("position") == "static")
                    totalSiblingsHeight += $(item).height();
            })
            var loadingHeight = parentHeight - totalSiblingsHeight;
            this.el.find("#perso-loading-widget").height(loadingHeight);
        },

        removeLoading : function renderLoading(){
            var loadingEl = this.el.children("#perso-loading-widget");
            loadingEl.remove();
        }

    });

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
	Personetics.UI = Personetics.UI || {};
    var keyCode ={
        "UpArrow":38,
        "DownArrow":40
    };
	Personetics.UI.PStoryWidgetCtrl = Personetics.UI.PWidgetCtrl.extend({

		initialize: function (config) {
			this.super = Personetics.UI.PWidgetCtrl.prototype;
			this.super.initialize.call(this, config);
			if (typeof config !== undefined) {
				Personetics.utils.PEventReporting.setValue(
					{
						"instanceId": config.insightId,
						"insightId": config.instanceId,
						"userId": config.userId
					});
			}
			this.tmplInnerErrorName = "#tmpl-perso-widget-story-error";
			this.texts = {
				imgClass: "errorImage",
				textSmall: Personetics.dictionary.getText("inboxTechnicalIssues"),
				textLarge: Personetics.dictionary.getText("OhNo"),
				errorText: Personetics.dictionary.getText("storyErrorText"),
				backButtonText: Personetics.dictionary.getText("accessibilityStoryBackButtonText")
			};
			this.showTitle = Personetics.projectConfiguration.getConfig("showTitle");
			this.loadingAnimation = Personetics.projectConfiguration.getConfig("showLoadingAnimation");
			if(Personetics.utils.PResizeUIEventManager) {
                this.pEventUI = Personetics.utils.PResizeUIEventManager.getInstance();
                if(this.pEventUI) {
                    this.pEventUI.setSupportCollapse(Personetics.projectConfiguration.getConfig("supportCollapse"));
                	if(this.config.widthMode === "desktop"){
                        Personetics.projectConfiguration.setConfig({"supportCollapse":false});
					}
                    var pEventUI = this.pEventUI;
                        this.pEventUI.setCallBack(function (data) {
                        Personetics.projectConfiguration.setConfig({"supportCollapse":pEventUI.getSupportCollapse()});
                        personetics.startWidget.call(personetics, data)
                    });
                    this.pEventUI.setParams(config);
                }
            }
		},

		start: function (parentEl) {
			this.parentEl = parentEl;
			this.el = this.parentEl;
			this.lang = this.config.lang;
			this.el.empty();
			if(this.config.widthMode === "desktop"){
				var me = this;
				this.el.attr("tabindex","0");
                Personetics.utils.accessibility.trackFocus(this.el);
                this.el.keydown(function(e){
                	if(e.currentTarget === e.target) {
                        if (e.keyCode === keyCode.DownArrow || e.keyCode === keyCode.UpArrow) {
                            var direction = e.keyCode === keyCode.DownArrow ? 50 : -50;
                            me.el.find(".pstory-frame").animate({scrollTop: me.el.find(".pstory-frame").scrollTop() + direction}, 0, 'swing');
                        }
                    }
                });
			}
			this.renderTitle();
			this.sendGetStory();
		},
		renderTitle: function () {
			if (!this.showTitle)
				return;

			var html = this.getTemplateHtml("#tmpl-pstory-title", this.texts);
			var newEl = $(html);

			this.el.append(newEl);

			// refactor: close button hardcoded in title
			var closeEl = newEl.find(".pstory-title-close");

			var widget = this;
			closeEl.bind("click", function () {
				if(this.pEventUI) {
                    this.pEventUI.setCallBack(null);
                }
				widget.closeHandler()
			});

			var openTeasersEl = newEl.find(".pstory-open-teasers-button");
			openTeasersEl.bind("click", function () {
				widget.onShowTeasersButtonClick();
			});
		},

		sendGetStory: function () {
			var me = this;
			var testData = window.testData && window.testData.stories ? window.testData.stories[this.config.insightId] : null;
			if (this.loadingAnimation) {
				this.parentCtrl.startWidget('loading-animation', { el: this.el.find('#story-frame-container') });
			}
			if (testData) {
				setTimeout(function () {
					me.onGetStoryResponse(testData);
				}, 500);
			}
			else {
				if (typeof storyData !== "undefined") {
					this.config.payload = storyData;
				}
				if (typeof this.config.payload != 'undefined' && this.config.payload != null) {
					var payload = this.config.payload;
					if (typeof this.config.isPayloadEncoded != 'undefined' &&
						(this.config.isPayloadEncoded == true || this.config.isPayloadEncoded == "true")) {
						try {
							payload = Personetics.utils.encodeDecode.Base64.decode(payload);
							payload = $.parseJSON(payload);
						}
						catch (payload) {
							this.onError();
							return;
						}
					}
					me.onGetStoryResponse(payload);
				}
				else {
					var data = {
						widgetId: this.widgetId,
						insightId: this.config.insightId
					};
					personetics.getInsightDetails(data,
						Personetics.bind(this, this.onGetStoryResponse),
						Personetics.bind(this, this.onError));
				}
			}

		},

		onGetStoryResponse: function (json) {
			// var story = json.story;
			if (this.loadingAnimation)
				this.parentCtrl.closeLoading();
			this.context = "story";
            if(this.pEventUI) {
            	this.pEventUI.setPayload(json);
            }
			this.openStory(json);
			this.bindEvents();
		},

		openStory: function (storyCfg) {
			var me = this;
			if (storyCfg) {
				var el = this.parentEl.find("#story-frame-container");
				if (el.length == 0) {
					el = this.parentEl;
				}
				this.startStory(storyCfg, el);
				var titleElement = this.el.find(".pstory-title-text");
				if (titleElement.length > 0) {
					this.setVoiceOverFocus(titleElement[0]);
				}
				else {
					var element = Personetics.utils.accessibility.firstChildFocusable($('.pstory-frame'));
					if (typeof element != 'undefind') {
						this.setVoiceOverFocus(element);
					}
				}
			}
		},

		startStory: function (storyCfg, el) {
			var story = new Personetics.story.PStory({
				parent: this,
				lang: this.lang,				// lang
				defaultLang: this.defaultLang,  // default lang
				texts: storyCfg.text,		// texts
				flowDef: storyCfg.story,
				params: this.config.params,//widget params
				userId: this.config.userId,
				expressions: storyCfg.expressions,
				insight: { id: this.config.insightId },
				data: storyCfg.facts,
				uxCtrl: this.uxCtrl,
				showTitle: this.showTitle,
				widthMode: this.widthMode,
				iconType: this.iconType,
				resizeHandler: function (newHeight) {
				},
				//closeHandler: this.closeHandler,
				onStartHandleEvent: function (oldHeight, el) {
					$(el).css('height', $(el).height());
				},
				onEndHandleEvent: function (el) {
					$(el).css('height', 'auto');
				},
				openTeasersHandler: Personetics.bind(this, function () {
					this.onShowTeasersButtonClick();
				})
			});
			story.start(el);
			var ratingsOptions = {
				el: el.find(".pstory-frame"),
				insight: story.insight,
				lang: this.lang
			};

			this.parentCtrl.startWidget("ratings", ratingsOptions);

			//touch scroll is added only after story and ratings elements were rendered for avoiding missing account bug.
			story.addTouchScroll();
			return story;
		},

		onError: function (err) {
			if (this.loadingAnimation)
				this.parentCtrl.closeLoading();
			Personetics.utils.PLogger.error(err);
			var data = {
				textSmall: this.texts.textSmall,
				textLarge: this.texts.textLarge,
				imgClass: this.texts.imgClass,
			};
			var el = this.parentEl.find("#story-frame-container");
			if (el.length == 0) {
				el = this.parentEl;
			}

			var html = this.getTemplateHtml(this.tmplInnerErrorName, data);
			el.append(html);

			this.bindEvents();


			// refactor: close button hardcoded in title
			var closeEl = this.el.find(".pstory-title-close");
			var me = this;
			closeEl.bind("click", function () {
				if (typeof me.closeHandler == 'function')
					me.closeHandler()
			});
		},

		bindEvents: function () {
		},
		closeHandler: function () {

            if(this.pEventUI) {
                this.pEventUI.endResize();
            }
            var deviceType = personetics.getDeviceType();
			Personetics.API.personetics.eventBuffer && Personetics.API.personetics.eventBuffer.sendEvents();
			if (deviceType === 'web') {
				this.el.parent().empty();
				var regexResult = new RegExp('[\?&]' + 'teasersView' + '=([^&#]*)').exec(window.location.href);
				var widgetIndicator = 0;
				if (typeof regexResult !== 'undefined' && regexResult !== null)
					widgetIndicator = regexResult[1] || 0;
				var widgetType = widgetIndicator === "Carousel" ? "teaser-widget-carousel" : "teaser-widget"
				if (widgetIndicator === "Carousel") this.parentCtrl.config.filter = false;
				var config = $.extend(true, {}, this.parentCtrl.config);
				config.el = this.parentCtrl.getWidgetEl(widgetType);
				this.parentCtrl.startWidget(widgetType, config);//widgetType:teaser-widget
			}
			else {
				var bridge = personetics.getJSBridge();
				if (bridge && ($.isFunction(bridge.sessionEnded))) {
					var params = {
						type: "ExitInsight",
						value: "1"
					}
					Personetics.utils.PEventReporting.setValue(params);
					Personetics.utils.PEventReporting.notifyEvent();

					var config = $.extend(true, {}, this.parentCtrl.config);
					delete config.eventType;
					bridge.sessionEnded(config);
				}
				else
					Personetics.log("Events Delegate not defined");
			}
		},

		onShowTeasersButtonClick: function onShowTeasersButtonClick() {
			var teasersWidgetEl = this.parentCtrl.getWidgetEl("teaser-widget");
			var config = $.extend(true, this.parentCtrl.config, { el: teasersWidgetEl });
			this.parentCtrl.startWidget("teaser-widget", config);
		},

		setVoiceOverFocus: function setVoiceOverFocus(element) {
			var focusInterval = 10; // ms, time between function calls
			var focusTotalRepetitions = 10; // number of repetitions
			if (this.config.widthMode !== 'desktop') {
				element.setAttribute('tabindex', '0');
			}

			var focusRepetitions = 0;
			var interval = window.setInterval(function () {
				element.focus();
				focusRepetitions++;
				if (focusRepetitions >= focusTotalRepetitions) {
					window.clearInterval(interval);
				}
			}, focusInterval);
		}

	});
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    var HandlebarsTeaserHelpers = function HandlebarsTeaserHelpers(parent){
        this.parent = parent;
    };

    HandlebarsTeaserHelpers.prototype.registerHelpers = function createView(){

        Handlebars.registerHelper("renderBarChart", function(layoutInstructions){
            this.renderBarChart(layoutInstructions);
        }.bind(this))

    };

    HandlebarsTeaserHelpers.prototype.renderBlock = function renderBlock(parentEl, layoutInstructions, insightId){
        var el = parentEl.find("#" + insightId + "_" + layoutInstructions.blockId);

        if(el.length > 0) {
            var isSeries = layoutInstructions
                && layoutInstructions.hasOwnProperty('seriesLabels')
                && layoutInstructions.seriesLabels.length > 0
                && layoutInstructions.seriesLabels[0].length > 0;


            var block = Personetics.teaser.PBlockFactory.createBlock(this.parent, layoutInstructions);
            block.beforeRender(el, layoutInstructions, insightId);
            block.render(el, layoutInstructions);
            block.afterRender();
            block.bindEvents();
        }
    };

    window.HandlebarsTeaserHelpers = HandlebarsTeaserHelpers;

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    var Widget = function Widget(config){
        this.config = config;
    };

    Widget.prototype.start = function start(element){
        this.element = element;
    };

    Widget.prototype.stop = function stop(){

    };

    Personetics.Widget = Widget;

})(window, window.Personetics = window.Personetics || {}, jQuery);
var WidgetEventHandler = function WidgetDelegate(){
};

WidgetEventHandler.prototype.sendToPServer = function sendToPServer(widget, data, onReceive){
    Personetics.utils.PLogger.debug(widget.getName() + " sending data to PServer: " + JSON.stringify(data));
};

WidgetEventHandler.prototype.navigateToPage = function navigateToPage(widget, params){
    Personetics.utils.PLogger.debug(widget.getName() + " navigating to page " + json.stringify(params));
};

WidgetEventHandler.prototype.widgetError = function widgetError(widget, errorParams){
    Personetics.utils.PLogger.debug(widget.getName() + " has encoutered an error: " + JSON.stringify(errorParams));
};

WidgetEventHandler.prototype.widgetStopped = function widgetStopped(widget){
    Personetics.utils.PLogger.debug(widget.getName() + " has stopped");
};

WidgetEventHandler.prototype.handleWidgetEvent = function handleWidgetEvent(widget, event){

};

/*
 o	On indicator click
 	Start teaser widget
 o	On teaser clicked
 	Start story widget
 o	On navigat to
 	Show message

 */
(function(window, Personetics, undefined){
    var Handlebars = Personetics.UI.Handlebars;
    var horizontalBarChartsTemplates = ["horizontalBar", "horizontalBarAndBox", "columnHorizontalBoxTeaser"];

    var imageFileExtensions = ["png", "jpg", "svg", "bmp"];

    var HandlebarsTeaserWidget = function HandlebarsTeaserWidget(config) {
        Personetics.Widget.call(this, config);

        this.helpers = new HandlebarsTeaserHelpers(this);
    };

    HandlebarsTeaserWidget.prototype = Object.create(Personetics.Widget.prototype);

    HandlebarsTeaserWidget.prototype.start = function start(parentEl) {
        Personetics.Widget.prototype.start.call(this, parentEl);

        var me = this;

        var insightId = this.config.insight.id;
        this.lang = this.config.lang;
        Personetics.processor.PStoryConfig.setConfig("lang", this.lang);

        this.teaserId = "perso-teaser-template_" + insightId;

        var teaserBlocks;
        var templateId;
        var isTextTeasers = false;
        if (!this.config.insight.hasOwnProperty("teaserTemplate") || this.config.insight.teaserTemplate === null || this.config.insight.teaserTemplate.length == 0)
            isTextTeasers = true;

        if (!this.config.insight.hasOwnProperty("teaserBlocks") || this.config.insight.teaserBlocks === null)
            isTextTeasers = true;

        if (isTextTeasers) {
            templateId = "simpleText";
            teaserBlocks = [{
                "blockId": "date",
                "type": "date-box",
                "date": ""
            }, {
                "blockId": "title",
                "type": "text",
                "text": ""
            }, {
                "blockId": "teaser-text",
                "type": "text",
                "text": this.config.insight.text
            }];
        }
        else {
            templateId = this.config.insight.teaserTemplate;
            teaserBlocks = this.config.insight.teaserBlocks;
        }

        var template = Handlebars.templates[templateId];

        if (template) {

            var newTeaserBlocks = {
                insightId: insightId,
                status: this.config.insight.status,
                highlighted: this.config.insight.highlighted
            };

            teaserBlocks.forEach(function (layoutInstructions, index) {

                if (layoutInstructions.hasOwnProperty("date")) {
                    var dateStr = layoutInstructions.date.trim();
                    var month = Personetics.utils.date.monthName(dateStr, me.lang, true);

                    if (typeof window.skinSetup.getDateFormat == "function") {
                       if (window.skinSetup.getDateFormat() == "dd/mm/yy") {
                            month = Personetics.utils.date.monthNumber(dateStr);
                            var year = Personetics.utils.date.yearNumber(dateStr, true);
                            layoutInstructions.year = year;
                       }
                    }
                    layoutInstructions.month = month;
                    var day = Personetics.utils.date.dayNumber(dateStr ,"DD");
                    layoutInstructions.day = day;
                }

                var urlObj = {};
                if (layoutInstructions.type == "image") {
                    urlObj = Personetics.imageMap.getImageClass(layoutInstructions.url, "teaser_images");
                    layoutInstructions.isAbsoluteURL = urlObj.isAbsoluteURL;
                    layoutInstructions.absUrl = urlObj.url;
                }
                if (layoutInstructions.blockId == "icon") {
                    urlObj = Personetics.imageMap.getImageClass(layoutInstructions.url, "icons");
                    layoutInstructions.isAbsoluteURL = urlObj.isAbsoluteURL;
                    layoutInstructions.absUrl = urlObj.url;
                }
                if(!(isNaN(new Date(layoutInstructions.text)))) {
                    layoutInstructions.isDate = true;
                }
                if(layoutInstructions.type == "txt" || layoutInstructions == "text"){
                    if(layoutInstructions.text.indexOf('{{Emoji') != -1){
                        var text = Personetics.utils.emojisHelper.parseEmoji(layoutInstructions.text);
                        layoutInstructions.text = text;
                    }
                }
                newTeaserBlocks[layoutInstructions.blockId] = layoutInstructions;
            });

            var html = template(newTeaserBlocks);
            parentEl.append(html);

            this.afterRender(parentEl, newTeaserBlocks);
        }
        else {
            Personetics.utils.PLogger.error("HandlebarsTeaserWidget.start() - Couldn't find template: '" + templateId + "'");
        }
    };

    HandlebarsTeaserWidget.prototype.afterRender = function (parentEl, teaserBlocks) {
        // set hbox column width
        $(".pstory-hbox-column-frame").each(function () {

            var parentWidth = $(this).parent().width();

            var weight = $(this).data("width");
            var width = Math.floor(weight / 12 * parentWidth);
            width = width;// - 2; // to compensate for inline-block width
            $(this).css("width", width);

            var parentHeight = $(this).parent().height();
            $(this).css("height", parentHeight);
        });

        // render blocks
        for (var blockId in teaserBlocks) {
            if (teaserBlocks.hasOwnProperty(blockId)) {
                var layoutInstructions = teaserBlocks[blockId];

                if (layoutInstructions) {
                    // add direction to horizontal bar charts
                    if (layoutInstructions.type == "bar-chart" && horizontalBarChartsTemplates.indexOf(this.config.insight.teaserTemplate) >= 0)
                        layoutInstructions.direction = "horizontal";

                    this.helpers.renderBlock(parentEl, layoutInstructions, teaserBlocks.insightId);
                }
            }
        }

        // bind teaser click event
        var enterKeyCode = 13;
        var spaceKeyCode = 32;
        var me = this;
        me.teaserClickBind = me.config.widgetType === "inbox-story-widget"? Personetics.bind(this, this.teaserInboxClick) : Personetics.bind(this, this.teaserClick);
        parentEl.find("#" + me.teaserId).bind("click", {
            userId: me.config.userId,
            insightId: me.config.insight.id,
            instanceId: me.config.insight.insightId,
            lang: me.lang
        }, me.teaserClickBind);

        parentEl.find("#" + me.teaserId).bind("keydown", {
            userId: me.config.userId,
            insightId: me.config.insight.id,
            instanceId: me.config.insight.insightId,
            lang: me.lang
        }, function(e){
            if([enterKeyCode,spaceKeyCode].indexOf(e.which) !== -1 ){
                me.teaserClickBind(e);
            }
        });

        parentEl.find('#'+me.teaserId).attr('tabindex',0);
    };

    HandlebarsTeaserWidget.prototype.teaserClick = function teaserClick(event){
        var params = {
            userId: event.data.userId,
            insightId: event.data.insightId,
            instanceId: event.data.instanceId,
            eventType: "teaserClick",
            lang: event.data.lang,
            clickedTeaser:$(event.currentTarget),
            teaserId:this.teaserId
        };
        if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("sendWidgetEvent"))
            personetics.sendWidgetEvent(this, params);
        else
            Personetics.utils.PLogger.debug("personetics JS API is not available");
    },

        HandlebarsTeaserWidget.prototype.teaserInboxClick = function teaserInboxClick(event) {
            var params = {
                userId: event.data.userId,
                insightId: event.data.insightId,
                instanceId: event.data.instanceId,
                lang: event.data.lang,
                clickedTeaser: $(event.currentTarget),
                teaserId: this.teaserId,
                widget:this.config.widget
            };
            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("sendWidgetEvent"))
                personetics.sendWidgetEvent(this, params);
            else
                Personetics.utils.PLogger.debug("personetics JS API is not available");

            this.config.widget.startStory(params);
        },

    HandlebarsTeaserWidget.prototype.notifyEvent = function (block, eventName, params) {
        Personetics.utils.PLogger.debug("Block: '" + block.layoutInstructions.type + "':'" + block.layoutInstructions.blockId + "' event:'" + event + "' params: " + params);
    };

    window.HandlebarsTeaserWidget = HandlebarsTeaserWidget;

})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){
    var Handlebars = Personetics.UI.Handlebars;
    var filterInbox = function filterInbox(widget){
    	this.parentEl = widget.element;
    	this.widget = widget;
    	this.renderer = Personetics.bind(widget, widget.__proto__.renderTeasers);
    	this.afterRenderer = Personetics.bind(widget, widget.__proto__.afterRender);

        this.tabs = this.getTabs();
        this.createFilteredMap(this.tabs);
        this.updateCountTabs(this.tabs);
    	var tmpl = Handlebars.templates['filter-inbox-template'];
    	var html = tmpl({
    	    "tabs": this.tabs
    	});
    	this.el = this.parentEl.find(".perso-teaser-filter-wrapper");
        this.el.append(html);
        this.afterRender();
        
        if(typeof localStorage["teaserTabSelected"] == 'undefined'){
            localStorage["teaserTabSelected"] = 'all';
        }
        var selectedTab = this.el.find("[data-id=" + localStorage["teaserTabSelected"] + "]");
        selectedTab.addClass('selected');
        selectedTab.attr('aria-selected', 'true');
        this.tabChangeAnimtaion(selectedTab);
    };

    filterInbox.prototype.tabChangeAnimtaion = function(selected){
        if(typeof selected === "undefined" || selected === null || selected.length == 0)
            return;
        var tabAnimatedBorder = this.el.find(".perso-filter-selected-tab");
        var left = selected.offset().left - tabAnimatedBorder.parent().offset().left;
        var width = selected.innerWidth();
        tabAnimatedBorder.css({ "left": left + 'px', width: width + 'px' });
    };
    
    filterInbox.prototype.bindEvents = function(){
    	var helper = this;
    	this.el.find(".perso-teaser-filter-tab").bind("click", function(e){
            helper.onSelectTab($(e.target))
        });
    };

    filterInbox.prototype.onSelectTab = function(selected){
        var selectedTabId = selected.data("id");
        localStorage["teaserTabSelected"] = selectedTabId;
        this.el.find(".perso-teaser-filter-tab").removeClass('selected');
        selected.addClass('selected');
        this.tabChangeAnimtaion(selected);
        this.filteredInsights = this.getFilteredInsights(selectedTabId);
        this.parentEl.find(".perso-multi-teaser-template").empty();
        if(typeof this.renderer == 'function'){
        	this.renderer(this.filteredInsights);
        }
        if(typeof this.afterRenderer == 'function'){
        	this.afterRenderer(this.parentEl, this.filteredInsights, selectedTabId);
        }
        if(this.widget.config.hasOwnProperty("callbackOnSuccess") && typeof this.widget.config.callbackOnSuccess !== "undefined")
        {
            this.widget.config.callbackOnSuccess(this.widget.config);
        }
    };

    filterInbox.prototype.createFilteredMap = function createFilteredMap(tabs){
        var filterHelper = this;
        var filteredMap = {};
        tabs.forEach(function(tab){
            filteredMap[tab.id] = filterHelper.filterInsights(tab.id)
        });
        this.filteredMap = filteredMap;
    };

    filterInbox.prototype.getFilteredInsights = function getFilteredInsights(selectedId){
        var array = [];
        if(this.filteredMap.hasOwnProperty(selectedId)){
            array = this.filteredMap[selectedId];
        }
        return array;
    };

    filterInbox.prototype.updateCountTabs = function updateCountTabs(tabs){
        var filterHelper = this;
        tabs.forEach(function(tab){
            tab.count = filterHelper.getFilteredInsights(tab.id).length;
        });
    };

    filterInbox.prototype.getTabs = function(){
        var tabs = [{
            text: Personetics.dictionary.getText("ttlinboxAllInsights"),
            id: "all"
        },{
            text: Personetics.dictionary.getText("ttlinboxUnreadInsights"),
            id: "unread"
        }];
        return tabs;
    };

    filterInbox.prototype.filterInsights = function filterInsights(selectedId){
        var filteredInsights;
        var insights = this.widget.insights;
        if( typeof insights === "undefined" || insights === null)
            return [];
        switch (selectedId){
            case "all":
                filteredInsights = insights;
                break;
            case "flagged": 
                filteredInsights = insights.filter(function(item){
                    return item.highlighted;
                });
                break;
            case "unread":
            case "new":
            filteredInsights = insights.filter(function(item){
                return item.status == "unread" || item.status == "new";
            });
                break;
            default:
                filteredInsights = insights;
        }

        return filteredInsights;
    };

    filterInbox.prototype.afterRender = function(){
    	this.bindEvents();
    };

    filterInbox.prototype.onGetInsights = function(insights){
    	this.insights = insights;
    };

    window.filterInbox = filterInbox;
})(window, window.Personetics = window.Personetics || {});
(function(window, Personetics, undefined){
    var Handlebars = Personetics.UI.Handlebars;
    var HandlebarsMultiTeaserWidget = function HandlebarsMultiTeaserWidget(config){
        Personetics.Widget.call(this, config);
    };

    HandlebarsMultiTeaserWidget.prototype = Object.create(Personetics.Widget.prototype);

    HandlebarsMultiTeaserWidget.prototype.start = function start(el) {
        Personetics.Widget.prototype.start.call(this, el);
        this.parentEl = el;
        el.empty(); 
        this.loadingAnimation = Personetics.projectConfiguration.getConfig("showLoadingAnimation");
        this.render();
        this.bindEvents();

        if (this.config.hasOwnProperty('payload') && typeof (this.config.payload) !== 'undefined' && this.config.payload !== null) {
            this.handlePayload();
        } else {
            this.sendGetInsights();
        }

    };
    HandlebarsMultiTeaserWidget.prototype.render = function render(){
        var tmpl = Handlebars.templates['inbox-template'];
        var inboxTitle = Personetics.dictionary.getText("ttlinbox");
    	var html = tmpl({
            "filter": this.config.filter,
            "inboxTitle": inboxTitle
    	});
        this.parentEl.append(html);
        this.el = this.parentEl.find(".perso-multi-teaser-wrapper").last();
    };

    HandlebarsMultiTeaserWidget.prototype.handlePayload = function handlePayload(){
        if (this.config.hasOwnProperty('isPayloadEncoded') && typeof this.config.isPayloadEncoded !== 'undefined' &&
            (this.config.isPayloadEncoded == true || this.config.isPayloadEncoded == "true"  )) {
            var decodedPayload = JSON.parse(Personetics.utils.encodeDecode.Base64.decode(this.config.payload));
            this.insights = decodedPayload.insights;
        } else {
            this.insights = this.config.payload.insights;
        }
        this.onGetInsightsResponse({insights: this.insights});
    };

    HandlebarsMultiTeaserWidget.prototype.sendGetInsights = function sendGetInsights(){
        if(typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("getInboxInsights")){
            var bankInfo = this.config.bankInfo;
            if(this.loadingAnimation)
                this.showLoading();
            personetics.getInboxInsights(bankInfo,
                Personetics.bind(this, this.onGetInsightsResponse),
                Personetics.bind(this, this.onError));
        }
    };

    HandlebarsMultiTeaserWidget.prototype.bindEvents = function bindEvents(){
        var closeEl = this.parentEl.find(".pstory-title-close");
        var widget = this;
        closeEl.bind("click", function () {
            widget.closeHandler()
        });
    };

    HandlebarsMultiTeaserWidget.prototype.onGetInsightsResponse = function onGetInsightsResponse(json){
        this.insights = json.insights || json;
        this.hideLoading();
        if(this.insights){
            var insights = this.insights;
            if(this.insights.length > 0){
                if (this.config.filter == true) {
                    this.filter = new window.filterInbox(this);
                    insights = this.filter.getFilteredInsights(localStorage["teaserTabSelected"]);
                }
                this.renderTeasers(insights);
                this.afterRender(this.parentEl, insights);
            }
            else{
                this.onEmptyInsights(null, Personetics.dictionary.getText("teasersWidgetNoInsightsText"));
            } 
            
        }
        else{
            this.onError(null, Personetics.dictionary.getText("teasersWidgetErrorText"));
        }
    };

    HandlebarsMultiTeaserWidget.prototype.onEmptyInsights = function onEmptyInsights(){
        if (this.loadingAnimation)
			this.config.parentCtrl.closeLoading();
        this.updateHeight();
        this.el.empty();
        var params = {
            textLarge: Personetics.dictionary.getText("noInsigthsTextSecondMsg"),
            textSmall: Personetics.dictionary.getText("noInsigthsTextFirstMsg"),
            imgClass: "noInsights"
        };
        var html = Personetics.utils.messages.noInsightsMessage(params);
        this.el.append(html);
    };

    HandlebarsMultiTeaserWidget.prototype.onError = function onError(serverError, errorMessage){
        if (this.loadingAnimation)
			this.config.parentCtrl.closeLoading();
        this.updateHeight();
        this.el.empty();
        var params = {
            textLarge:Personetics.dictionary.getText("OhNo"),
            textSmall:Personetics.dictionary.getText("inboxTechnicalIssues"),
            imgClass:"errorImage"
        };
        var html = Personetics.utils.messages.errorMessage(params);
        this.el.append(html);
        
    };


    HandlebarsMultiTeaserWidget.prototype.renderTeasers = function renderTeasers(insights) {
        var config = this.config;
        var el = this.el.find('.perso-multi-teaser-template');
        var insightIdToDisplay = null;
        if (config.hasOwnProperty("insightIdToDisplay")) {
            insightIdToDisplay = config.insightIdToDisplay;
        }

        if (typeof insights !== "undefined" && insights !== null) {
            if (insightIdToDisplay !== null) {
                insights.forEach(function (insight, index) {
                    if (insight.id == insightIdToDisplay) {
                        config.insight = insight;
                        var widget = Personetics.UI.PWidgetFactory.createWidget('teaser-widget-single', config);
                        widget.start(el);
                    }
                });
            }
            else {
                insights.forEach(function (insight, index) {
                    config.insight = insight;
                    var widget = Personetics.UI.PWidgetFactory.createWidget('teaser-widget-single', config);
                    widget.start(el);
                });
            }
        }
    };

    HandlebarsMultiTeaserWidget.prototype.afterRender = function afterRender(el, insights, selectedTabId) {
        this.updateHeight();
        if(typeof insights !== 'undefined' && insights.length == 0){
            if(selectedTabId === "all"){
                this.sendGetInsights();
            }else {
                var params = {
                    text: Personetics.dictionary.getText("nothingToShowHere")
                };
                var html = Personetics.utils.messages.noFilteredInsightsMessage(params);
                this.el.find('.perso-multi-teaser-template').append(html);
            }
        }
    };

    HandlebarsMultiTeaserWidget.prototype.updateHeight = function updateHeight() {
        var totalSiblingsHeight = 0;
        var siblings = this.el.siblings();
        $.each(siblings, function(i, sibling){
            if($(sibling).is(":visible")){
                totalSiblingsHeight += $(sibling).outerHeight(true);
            }
        });
        this.el.height(this.parentEl.height() - totalSiblingsHeight);
    }

    HandlebarsMultiTeaserWidget.prototype.showLoading = function showLoading(){
        var loadingContainer = $('<div class="perso-loading-container"></div>')
        this.parentEl.append(loadingContainer);
        this.config.parentCtrl.startWidget('loading-animation', { el: this.el.parent().find('.perso-loading-container') });
    };

    HandlebarsMultiTeaserWidget.prototype.hideLoading = function hideLoading(){
        this.parentEl.find(".perso-loading-container").remove();
    };

    HandlebarsMultiTeaserWidget.prototype.closeHandler = function closeHandler(){
        if(typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("getDeviceType")) {
            var deviceType = personetics.getDeviceType();
        }
        if  (deviceType === 'web'){
           //currently it's do nothing
        }
        else {
            if (typeof personetics !== 'undefined' && personetics !== null) {
                var bridge = personetics.getJSBridge();
                if (bridge && ($.isFunction(bridge.sessionEnded))) {
                    Personetics.utils.PEventReporting.setValue("1");
                    bridge.sessionEnded();
                }
                else
                    Personetics.log("Events Delegate not defined");
            }
        }
    };

    window.HandlebarsMultiTeaserWidget = HandlebarsMultiTeaserWidget;

})(window, window.Personetics = window.Personetics || {});

(function (window, Personetics, undefined) {
    var Handlebars = Personetics.UI.Handlebars;
    var HandlebarsMultiTeaserWidgetCarousel = function HandlebarsMultiTeaserWidgetCarousel(config) {
        window.HandlebarsMultiTeaserWidget.call(this, config);
    };

    HandlebarsMultiTeaserWidgetCarousel.prototype = Object.create(window.HandlebarsMultiTeaserWidget.prototype);

    HandlebarsMultiTeaserWidgetCarousel.prototype.render = function render() {
        if (this.config.widthMode == 'desktop') {
            var tmpl = Handlebars.templates['tmpl-perso-teaser-carousel-desktop'];
        }
        else {
            var tmpl = Handlebars.templates['tmpl-perso-teaser-carousel'];
        }
        var html = tmpl({
            'prev': Personetics.dictionary.getText("accessibilityPrevTeaser"),
            'next': Personetics.dictionary.getText("accessibilityNextTeaser")
        });
        this.parentEl.append(html);
        this.el = this.parentEl.find(".perso-multi-teaser-wrapper").last();
    };

    HandlebarsMultiTeaserWidgetCarousel.prototype.sendGetInsights = function sendGetInsights() {
        if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("getInsights")) {
            var bankInfo = this.config.bankInfo;
            if (this.loadingAnimation)
                this.showLoading();
            personetics.getInsights(bankInfo,
                Personetics.bind(this, this.onGetInsightsResponse),
                Personetics.bind(this, this.onError));
        }
    };

    HandlebarsMultiTeaserWidgetCarousel.prototype.afterRender = function afterRender(el) {
        addCarouselClasses(el);
        this.bindCarousel(el);
        window.HandlebarsMultiTeaserWidget.prototype.afterRender.call(this, el);
    };

    var bindEventsForAccButton = function bindEventsForAccButton(el, nextAccButton) {
        nextAccButton.bind('click', function () {
            var nextTeaser = el.find('.carousel-item.selected:not([clone="true"])').next();
            if (nextTeaser.length == 0)
                nextTeaser = el.find('.carousel-item.selected:not([clone="true"])').prev();
            nextTeaser.click();
        })
    };

    HandlebarsMultiTeaserWidgetCarousel.prototype.setSelectedAccButtonLabel = function setSelectedAccButtonLabel() {
        el = this.parentEl
        var selectedTeaser = el.find('.carousel-item.selected:not([clone="true"])');
        var selectedTeaserId = selectedTeaser.attr('pstory-id');
        el.find('#perso-teaser-acc-button').attr('aria-labelledby', selectedTeaserId);
    };

    var addCarouselClasses = function addCarouselClasses(el) {
        var $teaserTemplateElms = el.find('.perso-teaser-template');
        $teaserTemplateElms.each(function () {
            $(this).addClass("carousel-item");
            $(this).attr("role", "button");
            //add pstory id for carousel
            var pstoryId = $(this).attr('id');
            $(this).attr('pstory-id', pstoryId);
        })
    };

    HandlebarsMultiTeaserWidgetCarousel.prototype.bindCarousel = function bindCarousel(el) {
        if(this.insights && this.insights.length > 1) {
            var param = getOptionsWidth(el);
            param.afterCarouselEnd = Personetics.bind(this, this.setSelectedAccButtonLabel);
            var isDesktopMode = this.config.widthMode == 'desktop';
            if (isDesktopMode) {
                param = $.extend(param, window.skinSetup.getTeasersConfigDesktop());
            } else {
                param = $.extend(param, window.skinSetup.getTeasersConfig());
            }
            this.carouselAnimation = new Personetics.utils.carouselAnimation.bindMultiCarouselEventsForAnimation(el, param);
        } else {
            var $singleItem = el.find('.perso-teaser-template2');
            $singleItem.addClass('single-carousel-item');
        }
    };

    var getOptionsWidth = function getOptionsWidth(el) {
        var container = el.find('.perso-multi-teaser-template');
        var teaserWidth = container.find('.carousel-item:not(.selected)').outerWidth(true);
        var selectedItemWidth = container.find('.carousel-item.selected').outerWidth(true);
        return { itemWidth: teaserWidth, selectedItemWidth: selectedItemWidth };
    };

    HandlebarsMultiTeaserWidgetCarousel.prototype.renderTeasers = function renderTeasers(insights) {
        window.HandlebarsMultiTeaserWidget.prototype.renderTeasers.call(this, insights);
        this.el.find('.perso-teaser-template').first().addClass('selected');
        this.renderDots(insights);
    };
    HandlebarsMultiTeaserWidgetCarousel.prototype.renderDots = function renderDots(insights) {
        var dotsContainer = this.el.find('.carousel-index-container');
        insights.forEach(function (insight, index) {
            dotsContainer.append('<div class="carousel-index-dot"><div class="carousel-index-dot-circle"></div></div>');
        });
    };

    window.HandlebarsMultiTeaserWidgetCarousel = HandlebarsMultiTeaserWidgetCarousel;
})(window, window.Personetics = window.Personetics || {});

(function(window, Personetics, undefined){
    var Handlebars = Personetics.UI.Handlebars;
    var filterInboxStory = function filterInboxStory(widget){
    	this.parentEl = widget.element;
    	this.widget = widget;
    	this.renderer = Personetics.bind(widget, widget.__proto__.renderTeasers);
    	this.afterRenderer = Personetics.bind(widget, widget.__proto__.afterRender);

    	this.texts = {
            "ttlinboxAll": Personetics.dictionary.getText("ttlinboxAll"),
            "ttlinboxHighlighted": Personetics.dictionary.getText("ttlinboxHighlighted"),
            "ttlinboxUnread": Personetics.dictionary.getText("ttlinboxUnread")
        };

    	var tmpl = Handlebars.templates['filter-inbox-template'];
    	var html = tmpl({
    	    "texts": this.texts
    	});
    	this.el = this.parentEl.find(".perso-teaser-filter-wrapper");
        this.el.append(html);
        this.afterRender();
        
        if(typeof localStorage["teaserTabSelected"] == 'undefined'){
            localStorage["teaserTabSelected"] = 'all';
        }
        var selectedTab = this.el.find("[data-id=" + localStorage["teaserTabSelected"] + "]");
        selectedTab.addClass('selected');
        selectedTab.attr('aria-selected', 'true');
    };

    filterInboxStory.prototype.bindEvents = function(){
        var enterKeyCode = 13;
        var spaceKeyCode = 32;
    	var helper = this;
    	this.el.find(".perso-teaser-filter-tab").bind("click", function(e){
            helper.onSelectTab($(e.target))
        });

        this.el.find(".perso-teaser-filter-tab").bind("keydown", function(e){
            if(([enterKeyCode,spaceKeyCode].indexOf(e.which) !== -1)){
                helper.onSelectTab($(e.target));
            }
        });
    };

    filterInboxStory.prototype.onSelectTab = function(selected) {
        if(selected.hasClass("selected"))
        {
            return;
        }
        var selectedTabId = selected.data("id");
        localStorage["teaserTabSelected"] = selectedTabId;
        var $previousSelectedTab = this.el.find(".perso-teaser-filter-tab");
        $previousSelectedTab.removeClass('selected');
        $previousSelectedTab.attr('aria-selected',false);
        selected.addClass('selected');
        selected.attr('aria-selected',true);
        var filteredInsights = this.filterInsights(selectedTabId);
        this.parentEl.find(".perso-multi-teaser-template").empty();
        if (typeof this.renderer == 'function') {
            this.renderer(filteredInsights);
        }
        if (typeof this.afterRenderer == 'function') {
            this.afterRenderer(this.parentEl,selectedTabId);
        }
    };

    filterInboxStory.prototype.filterInsights = function filterInsights(selectedId){
        var filteredInsights;
        var insights = this.widget.insights;
        if( typeof insights === "undefined" || insights === null)
            return [];
        switch (selectedId){
            case "all":
                filteredInsights = insights;
                break;
            case "flagged": 
                filteredInsights = insights.filter(function(item){
                    return item.highlighted;
                });
                break;
            case "unread":
            case "new":
            filteredInsights = insights.filter(function(item){
                return item.status == "unread" || item.status == "new";
            });
                break;
            default:
                filteredInsights = insights;
        }

        return filteredInsights;
    };

    filterInboxStory.prototype.afterRender = function(){
        //Add tabindex to each tab, Accessibility
        this.parentEl.find('.perso-teaser-filter-wrapper ul').children().each(function(i){
            $(this).attr('tabindex',0);
        });
    	this.bindEvents();
    };

    filterInboxStory.prototype.onGetInsights = function(insights){
    	this.insights = insights;
    };

    filterInboxStory.prototype.updateInsight = function(insightId){
        if(typeof this.widget.insights !== "undefined" && this.widget.insights.length) {
            var insight;
            if (insightId) {
                insight = this.widget.insights.filter(function (ins) {
                    return ins.id === insightId
                });
            }
            insight = (insight && insight.length > 0) ? insight[0] : this.widget.insights[0];
            insight.status = "read";
            return insight.id;
        }
    };
    window.filterInboxStory = filterInboxStory;
})(window, window.Personetics = window.Personetics || {});
(function(window, Personetics,Handlebars, undefined){
    var HandlebarsTeaserInboxAndStoryWidget = function HandlebarsTeaserInboxAndStoryWidget(config){
        Personetics.Widget.call(this, config);
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype = Object.create(window.Personetics.Widget.prototype);

    HandlebarsTeaserInboxAndStoryWidget.prototype.start = function start(el) {
        var inboxTmpl = Handlebars.templates[this.config.templateId ? this.config.templateId : 'inboxContainer'];
        var texts = {
            insightsInboxTitle: Personetics.dictionary.getText("ttlinboxstory").toUpperCase()
        }
    	var inboxContent = inboxTmpl(texts);

        el.append(inboxContent);
        inboxContainerEl = el.find("#personetics-inbox-container");
        this.config.story.el = el.find("#personetics-story");
        Personetics.Widget.prototype.start.call(this, inboxContainerEl);
        inboxContainerEl.empty();
        if(typeof teaserData !== "undefined") {
            this.config.payload = teaserData;
        }
        this.renderTitle(inboxContainerEl);
        Personetics.utils.accessibility.trackFocus(inboxContainerEl.find(".perso-teaser-filter-wrapper"));
        this.renderWrapper(inboxContainerEl);
        if (this.config.hasOwnProperty('payload') && typeof (this.config.payload) !== 'undefined' && this.config.payload !== null) {
            this.handlePayload();
        } else {
            this.sendGetInsights();
        }
        this.updateHeight();
    };
    HandlebarsTeaserInboxAndStoryWidget.prototype.handlePayload = function handlePayload() {
        if (this.config.hasOwnProperty('isPayloadEncoded') && typeof this.config.isPayloadEncoded !== 'undefined' &&
            (this.config.isPayloadEncoded == true || this.config.isPayloadEncoded == "true"  )) {
            var decodedPayload = JSON.parse(Personetics.utils.encodeDecode.Base64.decode(this.config.payload));
            this.insights = decodedPayload.insights;
        } else {
            this.insights = this.config.payload.insights;
        }
        this.onGetInsightsResponse({insights: this.insights});
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.sendGetInsights = function sendGetInsights(){
        if(typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("getInboxInsights")){
            var bankInfo = this.config.bankInfo;
            this.showLoading();
            var me = this;
            personetics.getInboxInsights(bankInfo,
                Personetics.bind(this, me.onGetInsightsResponse),
                Personetics.bind(this, me.onError));
        }
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.renderTitle = function renderTitle(el){
        if (this.config.filter == true) {
            var inboxTitle = Personetics.dictionary.getText("ttlinboxstory");
            var closeText = Personetics.dictionary.getText("close");
            var titleHtml = '<div class="pstory-title perso-teaser-title">' +
                '<div aria-live="assertive" role="text" class="pstory-title-text">' + inboxTitle + '</div>' +
                '<input aria-label="'+ closeText +'" type="button" class="pstory-title-close" tabindex="0">' +
                '</div>';
            el.append(titleHtml);
            el.append("<div class='perso-teaser-filter-wrapper'></div>");

            this.filter = new window.filterInboxStory(this);

            //Close Rich teasers
            var newEl = $(titleHtml);
            var closeEl = $(".pstory-title-close");
            var widget = this;
            closeEl.bind("click", function () {
                widget.closeHandler()
            });
            el.attr('aria-label', inboxTitle);
        }
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.renderWrapper = function renderWrapper(el){
        el.closest(".personetics-widgets-wrapper").addClass("personetics-widgets-insights-inbox-wrapper");
        el.append("<div class='perso-multi-teaser-template'></div>");
        this.parentEl = el;
        this.el = el.find(".perso-multi-teaser-template").last();
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.onGetInsightsResponse = function onGetInsightsResponse(json){
        this.insights = json.insights || json;
        this.hideLoading();
        if(this.insights){
            if(this.insights.length > 0){
                var insights = this.insights;
                if(typeof this.filter != 'undefined'){
                    insights = this.filter.filterInsights(localStorage["teaserTabSelected"]);
                }
                this.renderTeasers(insights);
                this.afterRender(this.parentEl);
            }
            else{
                this.onEmptyInsights();
            }
        }
        else{
            this.onError(null, Personetics.dictionary.getText("inboxTechnicalIssues"));
        }
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.onEmptyInsights = function(){
        this.el.empty();
        var params = {
            textLarge: Personetics.dictionary.getText("noInsigthsTextSecondMsg"),
            textSmall: Personetics.dictionary.getText("noInsigthsTextFirstMsg"),
            imgClass: "errorImage"
        };
        var html = Personetics.utils.messages.noInsightsMessage(params);
        this.el.append(html);
    }

    HandlebarsTeaserInboxAndStoryWidget.prototype.onError = function onError(serverError, errorMessage) {
        this.updateHeight();

        this.el.empty();
        var params = {
            textLarge: Personetics.dictionary.getText("OhNo"),
            textSmall: Personetics.dictionary.getText("inboxTechnicalIssues"),
            imgClass: "errorImage"
        };
        var html = Personetics.utils.messages.errorMessage(params);
        this.el.append(html);

    };


    HandlebarsTeaserInboxAndStoryWidget.prototype.renderTeasers = function renderTeasers(insights) {
        var config = this.config;
        var el = this.el;
        var me = this;
        var insightIdToDisplay = null;
        if (config.hasOwnProperty("insightIdToDisplay")) {
            insightIdToDisplay = config.insightIdToDisplay;
        }

        if (typeof insights !== "undefined" && insights !== null) {
            if (insightIdToDisplay !== null) {
                insights.forEach(function (insight, index) {
                    if (insight.id == insightIdToDisplay) {
                        config.insight = insight;
                        config.widget = me;
                        var widget = Personetics.UI.PWidgetFactory.createWidget('teaser-widget-single', config);
                        widget.start(el);
                    }
                });
            }
            else {
                insights.forEach(function (insight, index) {
                    config.insight = insight;
                    config.widget = me;
                    var widget = Personetics.UI.PWidgetFactory.createWidget('teaser-widget-single', config);
                    widget.start(el);
                });
            }
        }
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.afterRender = function afterRender(el,selectedTabId) {
        Personetics.utils.accessibility.trackFocus(this.el);
        this.updateHeight();
        if(this.el.children().length) {
            if(typeof selectedTabId !== "undefined")
            {
                this.startStory();
            }
            else {
                this.setSelected(this.config.story.teaserId);
                this.startStory(this.config.story);
            }
        }
        else
        {
            if(selectedTabId === "all"){
                if (this.config.hasOwnProperty('payload') && typeof (this.config.payload) !== 'undefined' && this.config.payload !== null) {
                    this.handlePayload();
                } else {
                    this.sendGetInsights();
                }
            }
            else {

                var params = {
                    text: Personetics.dictionary.getText("nothingToShowHere")
                };
                var html = Personetics.utils.messages.noFilteredInsightsMessage(params);
                this.el.append(html);
                this.config.story.el.empty();
            }
        }
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.updateHeight = function updateHeight() {
        var totalSiblingsHeight = 0;
        var siblings = this.el.siblings();
        $.each(siblings, function(i, sibling){
            if($(sibling).is(":visible")){
                totalSiblingsHeight += $(sibling).outerHeight(true);
            }
        });
        this.el.find(".perso-teaser-template").each(function(){
            var elem = $(this);
            elem.prepend("<div class='perso-teaser-overlay'></div>");
        });
        this.el.height(this.config.el.height() - totalSiblingsHeight - parseInt(this.el.css('margin-top'),10) - 7);
    }

    HandlebarsTeaserInboxAndStoryWidget.prototype.startStory = function startStory(params) {

        if(!params)
        {
            this.loadFirstTeaserStory();
        }
        else {
            if(this.config.filter) {
                params.insightId = this.filter.updateInsight(params.insightId);
                if(!params.instanceId){
                    for(var i =0; i< this.insights.length;i++){
                        if(this.insights[i].id === params.insightId){
                            params.instanceId = this.insights[i].insightId;
                        }
                    }
                }
                params.teaserId = params.teaserId || "perso-teaser-template_" + params.insightId;
                this.updateSelectTeasers(params.teaserId);
                for (key in params) {
                    if (typeof params[key] !== "undefined") {
                        this.config.story[key] = params[key];
                    }
                }
            }
            personetics.startWidget(this.config.story);
        }
    };
    HandlebarsTeaserInboxAndStoryWidget.prototype.updateSelectTeasers = function updateSelectTeasers(insightId)
    {
        className = "selected";
        var teaserObj = this.el.find("#" + insightId);
        if(teaserObj.length) {
            if (!teaserObj.hasClass(className)) {
                var teasers = this.el.find(".perso-teaser-template.selected");
                $.each(teasers, function (i, teaser) {
                    $(teaser).removeClass(className)
                });
                teaserObj.addClass(className)
            }
            this.scrollIntoView(teaserObj.get(0));
        }
        else
        {
            this.loadFirstTeaserStory();
        }
    };
    HandlebarsTeaserInboxAndStoryWidget.prototype.setSelected = function setSelected( teaserId)
    {
        if(teaserId === null){
            var teaserObj = el.find(".perso-teaser-template").eq(0);
            if(teaserObj.length)
            {
                teaserObj.click();
            }
            else {
                $("#personetics-story").empty();
            }
        }
        else {
            var teaserObj = this.el.find("#" + teaserId);
            if(teaserObj.length) {
                teaserObj.addClass("selected")
                this.scrollIntoView(teaserObj.get(0));
            }
            else {
                this.config.story.el.empty();
            }
        }
    };
    HandlebarsTeaserInboxAndStoryWidget.prototype.loadFirstTeaserStory = function loadFirstTeaserStory()
    {
        var teaserObj = this.el.find(".perso-teaser-template").eq(0);
        if(teaserObj.length)
        {
            teaserObj.click();
        }
        else {
            $("#personetics-story").empty();
        }
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.scrollIntoView = function scrollIntoView(e) {
        if(this.isInViewport(e))
        {
            return;
        }
        $('.perso-multi-teaser-template').animate({
            scrollTop: $(e).offset().top
        }, 1000);
    }

    HandlebarsTeaserInboxAndStoryWidget.prototype.isInViewport = function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
            rect.top >= 40 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    }
    HandlebarsTeaserInboxAndStoryWidget.prototype.showLoading = function showLoading(){
        this.el.append("<div class='perso-loading-wrapper'><div>" + Personetics.dictionary.getText("insightsLoadInsights") + "</div><div class='perso-loading'></div></div>");
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.hideLoading = function hideLoading(){
        this.el.find(".perso-loading-wrapper").remove();
    };

    HandlebarsTeaserInboxAndStoryWidget.prototype.closeHandler = function closeHandler(){
        this.config.story && this.config.story.el.empty()
        if(typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("getDeviceType")) {
            var deviceType = personetics.getDeviceType();
        }
        if  (deviceType === 'web'){
           //currently it's do nothing
        }
        else {
            if (typeof personetics !== 'undefined' && personetics !== null) {
                var bridge = personetics.getJSBridge();
                if (bridge && ($.isFunction(bridge.sessionEnded))) {
                    bridge.sessionEnded();
                }
                else
                    Personetics.log("Events Delegate not defined");
            }
        }
    };
    HandlebarsTeaserInboxAndStoryWidget.prototype.teaserClick = function teaserClick(event){
        var eventType = this.config !== "undefined" && this.config.hasOwnProperty("eventType") && typeof this.config.eventType !== "undefined"?this.config.eventType:"teaserClick";

        var params = {
            userId: event.data.userId,
            insightId: event.data.insightId,
            instanceId: event.data.instanceId,
            eventType: eventType,
            lang: event.data.lang,
            clickedTeaser:$(event.currentTarget),
            teaserId:this.teaserId
        };
        Personetics.utils.PEventReporting.setValue({ "instanceId": params.insightId, "insightId": params.instanceId, "userId": event.data.userId });//initiailze for report events
        if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("sendWidgetEvent"))
            personetics.sendWidgetEvent(this, params);
        else
            console.log("personetics JS API is not available");
    };

    window.HandlebarsTeaserInboxAndStoryWidget = HandlebarsTeaserInboxAndStoryWidget;

})(window, window.Personetics = window.Personetics || {},Personetics.UI.Handlebars);

(function(window, Personetics, $, undefined){
    Personetics.story = Personetics.story || {};
    Personetics.UI.PStoryWidgetCtrlProduct = Personetics.UI.PStoryWidgetCtrl.extend({

        initialize: function(config) {
            this.super = Personetics.UI.PStoryWidgetCtrl.prototype;
            this.super.initialize.call(this, config);

            this.uxCtrl = new Personetics.story.skinController();
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    Personetics.UI = Personetics.UI || {};
    var keyCode ={
        "Space":32,
        "Enter":13
    };
    Personetics.UI.PRatingCtrlDesktop = Personetics.UI.PRatingCtrl.extend({

        initialize: function (config) {
            Personetics.UI.PRatingCtrl.prototype.initialize.call(this, config);
            this.ratingTemplate = "#tmpl-perso-rating-desktop";
            this.feedbackTemplate = "#tmpl-perso-feedback-desktop";
        },
        start: function (el) {
            var me = this;
            Personetics.UI.PRatingCtrl.prototype.start.call(this, el);
            Personetics.utils.accessibility.trackFocus(this.el.find(".perso-ratings-wrapper"));
        },
        starRating: function (el, prevRating) {
            Personetics.UI.PRatingCtrl.prototype.starRating.call(this, el, prevRating);
            var rateKeypressBind = Personetics.bind(this, this.rateKeypress);
            var onRatingLblElemMousedownBind = Personetics.bind(this, this.onRatingLblElemMousedown);
            this.el.find(".perso-ratings-wrapper").bind("keypress", "input[type=radio]", rateKeypressBind);
            var ratingElem = this.el.find(".perso-ratings-wrapper .perso-ratings-icons input");
            ratingElem.focusin(this.onRatingElemFocusIn);
            ratingElem.focusout(this.onRatingElemFocusOut);
            this.el.find(".perso-ratings-wrapper .perso-ratings-icons label").mousedown(onRatingLblElemMousedownBind);
        },
        onRatingLblElemMousedown: function (e) {
            this.el.find(".perso-ratings-wrapper .perso-ratings-icons label").removeClass("ratingOnFocus");
            $(e.target).attr("isClicked", "true");
        },
        onRatingElemFocusIn: function () {
            var elem = $(this);
            var label = $("label[for='" + elem.attr("id") + "']");
            if (label.attr("isClicked")) {
                label.removeClass("ratingOnFocus")
            } else {
                label.addClass("ratingOnFocus");
            }
            label.removeAttr("isClicked");
        },
        onRatingElemFocusOut: function () {
            $("label[for='" + $(this).attr("id") + "']").removeClass("ratingOnFocus");
        },
        showFeedback: function () {
            Personetics.UI.PRatingCtrl.prototype.showFeedback.call(this);
            $(".perso-feedback-reaction").focusout(function () {
                $(this).removeAttr("tabindex");
            });
            $(this.el.find('.perso-ratings-text')).show();
            $(this.el.find('.perso-ratings-text')).addClass('direction-text-left');
            $(this.el.find('.perso-ratings-icons')).addClass('direction-text-left');
            var widget = this;
            var submit = $(this.el.find('.perso-feedback-submit'));
            submit.css('margin-left', '');
            var submitArrow = $(this.el.find('.perso-feedback-submit-arrow'));
            submitArrow.bind("click", {
                id: widget.insight.id,
                widget: widget
            }, Personetics.bind(widget, widget.sendFeedback));
            submitArrow.hide();
            Personetics.utils.accessibility.trackFocus(this.el.find(".perso-feedback-wrapper"));
        },
        sendFeedback: function sendFeedback(e) {
            Personetics.UI.PRatingCtrl.prototype.sendFeedback.call(this, e);
            this.el.find(".perso-ratings-wrapper").removeAttr("rating-started");
            var feedbackReaction = $(".perso-feedback-reaction").eq(0);
            feedbackReaction.attr("tabindex", "0");
            feedbackReaction.eq(0).focus();
        },
        feedbackTextInput: function feedbackTextInput(e) {
            Personetics.UI.PRatingCtrl.prototype.feedbackTextInput.call(this, e);
            if(e.target.value == ""){
                this.el.find('.perso-feedback-submit-arrow').attr('disabled','disabled')
            }
            else{
                this.el.find('.perso-feedback-submit-arrow').removeAttr('disabled');
            }
        },
        feedbackTextBlur: function (e) {
            Personetics.UI.PRatingCtrl.prototype.feedbackTextBlur.call(this);
        },

        feedbackTextFocus: function (e) {
            Personetics.UI.PRatingCtrl.prototype.feedbackTextFocus.call(this);
            $(this.el.find('.perso-feedback-submit-arrow')).show();
        },
        rateClick: function (e) {
            Personetics.UI.PRatingCtrl.prototype.rateClick.call(this, e);
            var ratingsWrapper = $('.perso-ratings-wrapper');
            var feedbackText = $(this.el.find('.perso-feedback-text'));
            ratingsWrapper.attr("rating-started", true);
            ratingsWrapper.css('height', '40px');
            ratingsWrapper.removeClass('perso-rating-close-state');
            feedbackText.addClass('direction-text-left');
            feedbackText.removeClass('direction-text-center');
            $(this.el.find('.perso-ratings-text')).hide();
        },
        rateKeypress: function (e) {
            if ([keyCode.Enter, keyCode.Space].indexOf(e.which) !== -1) {
                var target = $(e.target);
                if (target.closest(".perso-ratings-wrapper").attr("rating-started")) {
                    this.el.find(".perso-feedback-text").focus()
                } else {
                    target.click();
                    target.closest(".perso-ratings-icons").attr("rating-started", true);
                }
            }
        },
        createRatingStarElement: function createRatingStarElement(index, prevRating, ratingElementId, ratingMax) {
            var levelOf = "";
            if(!!window.MSInputMethodContext && !!document.documentMode) { //for JAWS on IE 11
                levelOf = " " + Personetics.dictionary.getText("accessibilityOfLbl") + " " + ratingMax;
            }
            var label = this.texts.accessibilityRatingLevelTitle + ' ' + (index + 1) + levelOf;
            var element = $("<input type='radio' id='" + ratingElementId + "' name='rating' role='radio' tabindex='0' aria-label='" + label + "'/><label for='" + ratingElementId + "'/>");
            return element;
        },
        showFeedbackReaction: function showFeedbackReaction() {
            Personetics.UI.PRatingCtrl.prototype.showFeedbackReaction.call(this);
            $(this.el.find('.perso-ratings-text')).removeClass('direction-text-left');
            $(this.el.find('.perso-ratings-icons')).removeClass('direction-text-left');
            $(this.el.find('.perso-ratings-icons')).addClass('direction-text-center');
            $(this.el.find('.perso-ratings-wrapper')).addClass('perso-rating-close-state');
            $('.perso-rating-close-state').css('height', '22px');
        }
    });

})(window, window.Personetics = window.Personetics || {}, jQuery);




 
(function (window, Personetics, $, undefined) {
    Personetics.UI = Personetics.UI || {};

    Personetics.UI.PRatingCtrlDesktopOpenBank = Personetics.UI.PRatingCtrlDesktop.extend({

        start: function (el) {
            this.el = el;
            if ($(window).width() < this.config.parentCtrl.desktopScreenWidth && !!window.MSInputMethodContext && !!document.documentMode) { //IE 11
                el.addClass("ie-11")
            }
            this.sendGetRatings();
        },

        getRatingTemplate: function getRatingTemplate() {
            var ratingTitle = Personetics.dictionary.getText("lblstoryRating");
            var ratingYes = Personetics.dictionary.getText("lblYes");
            var ratingNo = Personetics.dictionary.getText("lblNo");
            var ratingTmpl = this.getTemplateHtml(this.ratingTemplate, {
                ratingTitle: ratingTitle,
                ratingYes: ratingYes,
                ratingNo: ratingNo
            });
            return ratingTmpl;
        },

        onGetRatigsResponse: function (json) {
            var rating = json ? json.rating : 0;
            var el = this.el;
            // var el = this.el.find(".perso-ratings-icons");
            this.id = json.id;
            if (typeof rating !== 'undefined' && rating !== null && rating > 0) {
                this.hideRating();
            } else {
                this.starRating(el, rating);
                this.afterRender();
            }

        },
        starRating: function (el, prevRating) {
            var ratingTmpl = this.getRatingTemplate();
            el.append(ratingTmpl);
            this.fixRatingElToBottom();
            var iconsEl = this.el.find(".perso-ratings-icons");
            var me = this;
            var ratingId = this.insight.id + '_' + this.el.index() + '_rating_';
            var $ratingElement = iconsEl;
            var ratingMax = $ratingElement.data("rating-max");
            var likeItem = this.el.find('.perso-rating-yes-icon');
            likeItem.bind("click", {
                id: me.id,
                me: me
            }, Personetics.bind(me, me.likeClick));

            var dislikeItem = this.el.find('.perso-rating-no-icon');
            dislikeItem.bind("click", {
                id: me.id,
                me: me
            }, Personetics.bind(me, me.dislikeClick));
        },
        hideRating: function () {
            this.el.find(".perso-ratings-wrapper").hide();
        },

        likeClick: function rateClick(e) {
            this.el.find(".perso-ratings-box-yes").addClass("selected");
            this.el.find(".perso-ratings-box-no").removeClass("selected");
            this.rateClick(e);
        },

        dislikeClick: function rateClick(e) {
            this.el.find(".perso-ratings-box-no").addClass("selected");
            this.el.find(".perso-ratings-box-yes").removeClass("selected");
            this.rateClick(e);
        },

        rateClick: function rateClick(e) {
            this.onRateClick(e);
            this.showThanksForFeedback()
        },

        onRateClick: function onRateClick(e) {
            var target = e.currentTarget;
            var rating = $(target).closest("[data-val]").attr("data-val");
            this.eventObj = {
                id: e.data.id,
                rating: rating
            };
            var testData = window.testData ? window.testData.ratingsResponse : null;
            if (testData) {
                var widget = this;
                setTimeout(function () {
                    e.data.me.onSuccesRate((testData));
                }, 500);
            } else {
                personetics.updateInsightRating(this.eventObj, e.data.me.onSuccesRate, e.data.me.onError);
            }
            if (typeof personetics !== 'undefined' && personetics !== null && personetics.hasOwnProperty("createReportingEvent")){
                var params = {
                    "eventId": "rating-click",
                    "additionalData": {
                        "value": this.eventObj.rating
                    },
                }
                personetics.createReportingEvent(this, params);
            }
        },

        showThanksForFeedback: function showThanksForFeedback() {
            var widget = this;
            var animDelay = 400;
            if (this.el.find('.perso-feedback-wrapper').length == 0) {
                var lblreactionFeedback = Personetics.dictionary.getText("lblreactionFeedback");
                var feedbackTmpl = this.getTemplateHtml(this.feedbackTemplate, {
                    lblreactionFeedback: lblreactionFeedback,
                });
                this.el.find('.perso-ratings-wrapper').after(feedbackTmpl);
                this.el.find('.perso-feedback-inner-wrapper').hide();
                animDelay = 200;
            }

            this.el.find('.perso-ratings-wrapper').next('.perso-feedback-wrapper').addBack().wrapAll('<div class="perso-rating-feedback-wrapper" />');
            this.el.find(".perso-feedback-wrapper").css('overflow', 'auto');
            var heightreaction = this.el.find('.perso-feedback-reaction').outerHeight();

            this.el.find('.perso-ratings-text, .perso-feedback-header').animate({
                'opacity': 0
            }, animDelay / 2);
            widget.el.find('.perso-ratings-wrapper, .perso-feedback-inner-wrapper').hide();
            widget.el.find('.perso-feedback-reaction').show();
            widget.fixFeedbackElToBottom();
        },

        fixFeedbackElToBottom: function fixRatingElToBottom() {
            var feedbackEl = this.el.find('.perso-feedback-wrapper');
            var feedbackHeight = feedbackEl.height() + 1;
            feedbackEl.height(feedbackHeight);
            //calculate el height : 100% - feedback el height - feedback el's height/margin
            var feedbackOuterHeight = feedbackEl.outerHeight(true);

            //min height gets 2px more than nessesary for forcing small scroll in order to solve missing account bug.
            this.el.find('.pstory-container').css('minHeight', 'calc(100% - ' + (feedbackOuterHeight - 2) + 'px)');

            $(feedbackEl).scrollTop(753);
        },

        feedbackStart: function feedbackStart() {
            if (Personetics.projectConfiguration.getConfig("showFeedback") == true && (!this.disableFeedBack)) {
                this.showFeedback();
            }
        },

        onSuccesRate: function (data) {
            Personetics.log("rating succes");
        },

        onError: function () {
            Personetics.log("rating error");
        },

        showFeedback: function showFeedback() {
            var widget = this;

            this.el.find('.perso-feedback-wrapper').remove();
            this.disableFeedBack = true;
            var lblfeedbackheader = "lblfeedbackheader";
            var lblreactionFeedback = "lblreactionFeedback";
            var btnsubmit = "btnsubmit";
            var btnskip = "btnskip";

            var ratingTmpl = this.getTemplateHtml(this.feedbackTemplate, {
                lblreactionFeedback: lblreactionFeedback,
                btnsubmit: btnsubmit,
                btnskip: btnskip,
                lblfeedbackheader: lblfeedbackheader
            });
            this.el.append(ratingTmpl).fadeIn(500);
            var submit = this.el.find('.perso-feedback-submit');
            submit.bind("click", {
                id: widget.insight.id,
                widget: widget
            }, Personetics.bind(widget, widget.sendFeedback));
            var skip = this.el.find('.perso-feedback-skip');
            skip.bind("click", Personetics.bind(widget, widget.showThanksForFeedback));

            this.el.find('.perso-feedback-reaction').hide(); //hide perso-feedback-reaction

            var element = this.el.find('.perso-feedback-wrapper');
            this.scrollToEnd(this.el, element);

            this.feedbackText = this.el.find('.perso-feedback-text');
            var feedbackTextInputBind = Personetics.bind(this, this.feedbackTextInput);
            $(this.feedbackText).bind('input', feedbackTextInputBind);
        },


        feedbackTextInput: function feedbackTextInput(e) {
            if (e.target.value == "") {
                this.el.find('.perso-feedback-submit').attr('disabled', 'disabled')
            } else {
                this.el.find('.perso-feedback-submit').removeAttr('disabled');
            }
        },

        sendFeedback: function sendFeedback(e) {
            var widget = this;
            var feedback = this.el.find('.perso-feedback-text').val();
            if (typeof feedback != "undefined" && feedback.length > 0) {
                this.eventObj = {
                    id: e.data.id,
                    feedback: feedback
                };
                personetics.updateInsightFeedback(this.eventObj, e.data.widget.onSuccesFeedback, e.data.widget.onErrorFeedback);
            }
            widget.showThanksForFeedback();
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
	Personetics.UI = Personetics.UI || {};
    var keyCode ={
        "UpArrow":38,
        "DownArrow":40
	};
	Personetics.UI.PStoryWidgetCtrlOpenBankDesktop = Personetics.UI.PStoryWidgetCtrlProduct.extend({
		
		onGetStoryResponse: function (json) {
			// var story = json.story;

			if (this.loadingAnimation)
				this.parentCtrl.closeLoading();
			this.el.find(".pstory-title-outer-wrapper").css("display","block");
			this.context = "story";
            if(this.pEventUI) {
            	this.pEventUI.setPayload(json);
            }
			this.openStory(json);
			this.bindEvents();
		},
		onError: function (err) {
			if (this.loadingAnimation)
				this.parentCtrl.closeLoading();
			Personetics.utils.PLogger.error(err);
			var data = {
				textSmall: this.texts.textSmall,
				textLarge: this.texts.textLarge,
				imgClass: this.texts.imgClass,
			};
			var el = this.parentEl.find("#story-frame-container");
			if (el.length == 0) {
				el = this.parentEl;
			}

			var html = this.getTemplateHtml("#tmpl-perso-widget-story-error-desktop", data);
			el.append(html);
			
			var errorEl=el.find(".personetics-error-content-desktop");
			$(errorEl).parents("#story-frame-container").css({"align-items":"center","display":"flex"});
			this.bindEvents();


			// refactor: close button hardcoded in title
			var closeEl = this.el.find(".pstory-title-close");
			var me = this;
			closeEl.bind("click", function () {
				if (typeof me.closeHandler == 'function')
					me.closeHandler()
			});
		},

	});
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.story = Personetics.story || {};
    Personetics.story.ProductSkinControler = Personetics.story.PSkinControler.extend({
        registerWidgets: function () {
            this.registerDefaultWidgets();

            Personetics.UI.PWidgetFactory.registerWidget("app-ctrl", {
                widgetClass: Personetics.UI.PAppCtrlProduct,
                widgetName: "Product app ctrl"
            });
            Personetics.UI.PWidgetFactory.registerWidget("master", {
                widgetClass: Personetics.UI.PAppCtrlProduct,
                widgetName: "Product master"
            });

            Personetics.UI.PWidgetFactory.registerWidget("master-teaser", {
                widgetClass: Personetics.UI.PAppTeaserCtrl,
                widgetName: "Product master teaser"
            });

            Personetics.UI.PWidgetFactory.registerWidget("story-widget", {
                widgetClass: Personetics.UI.PStoryWidgetCtrlProduct,
                widgetName: "Product story widget"
            });

            Personetics.UI.PWidgetFactory.registerWidget("inbox-story-widget", {
                widgetClass: window.HandlebarsTeaserInboxAndStoryWidget,
                widgetName: "Product inbox and story widget"
            });

            Personetics.UI.PWidgetFactory.registerWidget("teaser-widget-single", {
                widgetClass: window.HandlebarsTeaserWidget,
                widgetName: "Product single teaser widget"
            });

            Personetics.UI.PWidgetFactory.registerWidget("teaser-widget", {
                widgetClass: window.HandlebarsMultiTeaserWidget,
                widgetName: "Product teaser widget"
            });

            Personetics.UI.PWidgetFactory.registerWidget("teaser-widget-carousel", {
                widgetClass: window.HandlebarsMultiTeaserWidgetCarousel,
                widgetName: "Product teaser widget"
            });


            Personetics.UI.PWidgetFactory.registerWidget("ratings", {
                widgetClass: Personetics.UI.PRatingCtrlDesktop,
                widgetName: "Desktop ratings",
                widthMode: "desktop"
            });
        },
        registerBlocks: function () {
            Personetics.story.PSkinControler.prototype.registerBlocks.call(this);
            this.registerBlock("account-selector", {
                blockClass: Personetics.story.NewAccountSelectorBlockProduct
            });
            this.registerBlock("account-selector", {
                widthMode: "desktop",
                blockClass: Personetics.story.AccountSelectorBlockProductDesktop
            });
            this.registerBlock("account-selector", {
                widthMode: "tablet",
                blockClass: Personetics.story.AccountSelectorBlockProductTablet
            });
            this.registerBlock("buttons", {
                blockClass: Personetics.story.NewButtonsBlock
            });
            this.registerBlock("pie-chart", {
                blockClass: Personetics.story.NewPieChartBlockProduct
            });
            this.registerBlock("arc-chart", {
                blockClass: Personetics.story.PieChartBlockProduct
            });
            this.registerBlock("pie-chart", {
                widthMode: "desktop",
                blockClass: Personetics.story.PieChartBlockProductDesktop
            });
            this.registerBlock("bar-chart", {
                blockClass: Personetics.story.BarChartBlock
            });
            this.registerBlock("bar-chart", {
                widthMode: "desktop",
                blockClass: Personetics.story.D3BarChartBlockProductDesktop
            });
            this.registerBlock("bar-chart", {
                widthMode: "tablet",
                blockClass: Personetics.story.BarChartBlock
            });
            this.registerBlock("pin-graph", {
                blockClass: Personetics.story.PinGraphChartBlock
            });
            this.registerBlock("pin-graph", {
                widthMode: "desktop",
                blockClass: Personetics.story.D3PinGraphChartBlock
            });
            this.registerBlock("pin-graph", {
                widthMode: "tablet",
                blockClass: Personetics.story.PinGraphChartBlock
            });
            this.registerBlock("line-chart", {
                blockClass: Personetics.story.DotsLineChartBlock
            });
            this.registerBlock("line-chart", {
                widthMode: "desktop",
                blockClass: Personetics.story.DotsLineChartBlockDesktop
            });
            this.registerBlock("table", {
                blockClass: Personetics.story.TableBlockProduct
            });
            this.registerBlock("tranList", {
                blockClass: Personetics.story.NewTableBlockProduct
            });

            this.registerChartHelper("verticalHelper", {
                helperClass: Personetics.utils.d3Helpers.VerticalChartHelperProduct
            });

            this.registerChartHelper("multiVerticalHelper", {
                helperClass: Personetics.utils.d3Helpers.MultiVerticalChartHelperDesktop,
                widthMode: "desktop"
            });

            this.registerChartHelper("pinGraphHelper", {
                helperClass: Personetics.utils.d3Helpers.PinGraphChartHelperProduct
            });
            this.registerChartHelper("collapseHelper", {
                helperClass: Personetics.story.CollapseHelper
            });
            this.registerChartHelper("lineChartHelper", {
                helperClass: Personetics.utils.d3Helpers.NewLineChartHelper
            });
        },

        getScreenOptions: function () {
            return {
                ratio_medium: 1.17,
                ratio_large: 1.3
            };
        },
        getValueByScreenWidth: function(value){
            var screenWidth = $(window).width();
            var screenOptions = this.getScreenOptions();
            var returnValue = value;
            if (screenWidth >= 414 && screenWidth < 790) {
                returnValue = value * screenOptions.ratio_large;
            } else if (screenWidth >= 347){
                returnValue = value * screenOptions.ratio_medium;
            }
            return returnValue;
        },
        getDesktopScreenWidth: function () {
            return 790;
        },
        getMobileMaxScreenWidth: function () {
            return 598;
        },
        hasLayout: function (screenWidth) {
            return screenWidth <= 375 || screenWidth > 789;
        },

        getCollapseOptions: function (params) {
            var blockDisplayedHeight;
            var blockType = params.type;
            switch(blockType){
            	case "account-selector":
                   blockDisplayedHeight = 86;
                   break;
                case "pie-chart":
                   blockDisplayedHeight = 63;
                   break;
                default:blockDisplayedHeight = 50;
            }
            var screenWidth = $(window).width();
            var screenOptions = this.getScreenOptions();
            var displayedHeight;
            if (screenWidth < 347) {
                displayedHeight = blockDisplayedHeight;
            } else if (screenWidth >= 414) {
                displayedHeight = blockDisplayedHeight * screenOptions.ratio_large;
            } else {
                displayedHeight = blockDisplayedHeight * screenOptions.ratio_medium;
            }
            return { "displayedHeight": displayedHeight };
        },
        //vertical bar
        getColumnChartOptions: function (ratio) {
            var ratioLarge = 1.3;
            if(typeof ratio !== "undefined"){
                ratioLarge = ratio;
            }
            var options = {
                maxBarHeight: 99,
                svgHeight: 200,
                svgWidth: 320,
                labelTop: 27,
                barTop: 41,
                xAxisTop: 170,
                yAxisHeight: 128,
                yAxisTop: 20,
                yAxisLineDisplay: true,
                yAxisTextDisplay: false,
                negativeYAxisTop: 181,
                negativeBarTop: 190,

                //lines
                horizontalLineWidth:281,
                horizontalLineLeft: 20,
                //animations
                doAnimations: true,
                barDelay:0,
                barDuration:350,
                labelDelay:400,
                labelDuration:350,
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: ratioLarge
                },
                margin: {
                    top: 43,
                    bottom: 40
                },
                height: 180,
                chart: {
                    transX: 0,//spacing variable
                    transY: 10
                },
                labels: {
                    drawLabels: true,
                    marginBottom: 18,
                    marginTop: -10
                },
                rectangles: {
                    width: 16,
                    space: 33,
                    minHeightPercent: 0.15,
                    borderRadius: {
                        rx: 9,
                        ry: 9
                    },
                    marginFromBottom: 15,
                    marginFromLeft: 0,
                    gradients: [{
                        id: "selectedGradient",
                        offset: ["0%", "100%"],
                        stopColors: ["#6888d2", "#536fb1"]
                    }],
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    }
                },
                selected: {},
                axis: {
                    translation: {
                        x: 0,
                        y: "height"
                    },
                    xAxis: {
                        hide: false,
                        collapsedPadding: {
                            top: 22,
                            bottom: 15
                        }
                    },
                    yAxis: {
                        x: 0,
                        y: 0,
                        hide: true
                    }
                }
            };

            return options;
        },
        //pin chart
        getPinGraphChartOptions: function (ratio) {
            var ratioLarge = 1.3;
            if(typeof ratio !== "undefined"){
                ratioLarge = ratio;
            }
            var options = {
                svgHeight: 200,
                svgWidth: 281,
                maxBarHeight: 112,
                labelTop: 12,
                barTop: 27,
                xAxisTop: 170,
                yAxisHeight: 128,
                yAxisTop: 20,
                yAxisLineDisplay: true,
                yAxisTextDisplay:false,
                //animations
                doAnimations: true,
                barDelay:0,
                barDuration:350,
                labelDelay:400,
                labelDuration:350,
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: ratioLarge
                },
                margin: {
                    top: 43,
                    bottom: 40
                },
                height: 180,
                chart: {
                    transX: 0,
                    transY: 10
                },
                totalHeight: 220,
                labels: {
                    drawLabels: true,
                    marginBottom: 18,
                    marginTop: 4.5
                },
                rectangles: {
                    minHeightPercent: 0.15,
                    width: 9,
                    space: 40,
                    borderRadius: {
                        rx: 4,
                        ry: 4
                    },
                    marginFromBottom: 15,
                    gradients: {
                        selectedGradient: {
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }
                    },
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    },
                    transition: {
                        duration: 1000,
                        delay: 500
                    }
                },
                selected: {},
                axis: {
                    translation: {
                        x: 0,
                        y: "height"
                    },
                    xAxis: {
                        hide: false,
                        tickPadding: 10,
                        collapsedPadding: {
                            top: 22,
                            bottom: 15
                        }
                    },
                    yAxis: {
                        x: 0,
                        y: 0,
                        hide: true
                    }
                }
            };

            return options;
        },
        //pin chart new
        getHorizontalPinGraphChartOptions: function () {
            var options = {
                maxWidthBarPercent: 61,
                pinChartHeight: 0.32 //0.32 = 182 (sympli value) / 568 (window height)
            };
            return options;
        },
        //multi vertical
        getColumnChartMultiSeriesOptions: function (ratio) {
            var ratioLarge = 1.3;
            if(typeof ratio !== "undefined"){
                ratioLarge = ratio;
            }
            var options = {
                svgHeight: 200,
                svgWidth: 313,
                maxBarHeight: 93,
                labelTop: 45,
                nextLabelTop: 14,
                barTop: 56,
                xAxiaTop: 170,
                verticalLineTop: 20,
                lineHeight: 130,
                drowVerticalLines: true,
                yAxisDisplay: false,

                //animations
                doAnimations: true,
                barDelay:0,
                barDuration:350,
                labelDelay:400,
                labelDuration:350,
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: ratioLarge
                },
                margin: {
                    top: 34,
                    right: 24,
                    bottom: 72,
                    left: 24
                },
                totalHeight: 220,
                labels: {
                    drawLabels: true,
                    marginTop: -16,
                    marginBottom: 4,
                    right:2
                },
                rectangles: {
                    width: 9,
                    space: 41,
                    paddingTop: 30,
                    paddingLeft: -19,
                    paddingRight: 22,
                    paddingBottom: 33,
                    seriesPadding: 12.5,
                    transX: 4,
                    minHeight: 0.25,
                    borderRadius: {
                        rx: 4,
                        ry: 4
                    },
                    marginFromBottom: 5,
                    gradients: {
                        selectedInGradient: {
                            id: "selectedInGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#7193e2", "#485f96"]
                        },
                        selectedOutGradient: {
                            id: "selectedOutGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#ffcc00", "#ffb80a"]
                        }
                    },
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    },
                    transition: {
                        duration: 1000,
                        delay: 500
                    }
                },
                selected: {},
                axis: {
                    translation: {
                        x: 2.5,
                        y: "height"
                    },
                    xAxis: {
                        hide: false,
                        tickPadding: 10,
                        minimizedPadding: {
                            top: 22,
                            bottom: 15
                        }
                    }
                }
            };

            return options;
        },
        //line chart
        getDotsLineChartOptions: function (ratio) {
            var ratioLarg = ratio ? ratio : 1.3;
            var options = {
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: ratioLarg
                },
                //general
                svgHeight: 200,
                svgWidth:290,
                //line
                line_left: 36,//59,
                line_top: 60,
                line_width:218,
                line_height:82,//130,
                //line area
                area_display: false,
                //line style
                lineStyle_interpolate:'basis',//cardinal/linear/monotone/basis
                lineStyle_thickness: 2,
                //x axis
                xAxis_line_y: 20,
                xAxis_line_height: 130,
                xAxis_text_y: 171,
                xAxis_display: true,
                //y axis
                yAxis_x:0,
                yAxis_y:0,
                yAxis_display: false,

                //dots
                dots_radius:5.5,
                dots_radius_selected:5.5,
                //labels
                labels_x: 0,
                labels_y:14.3,
                labels_display: true,
                //horizonalLine
                horizonalLine_x:0,
                horizonalLine_length:308,
                horizonalLine_y:100,
                horizonalLine_display:false,

                highlightBy: 'last',	// defines the criteria for style dots as selected dot, there are 4 options - max/min/first/last(default).

                //transition
                doAnimations: true,
                lineDuration: 1000,
                lineDelay: 200,
                dotsDelay: 700,
                dotsLabelDelay: 800,
                dotsDuration: 500,
                areaDelay:1200,
                areaDuration: 500,
                dotRect:{
                    height: 40,
                    yOffset: 55,
                    radiusX: 20,
                    radiusY: 10,
                    dot_label_radius:10, 
                },
                dotText:{
                    yOffset: 41,
                    paddingLeft: 6,
                    paddingRight: 6,
                    lineHeight: 20
                },
                dotPolygon:{
                    yOffset: 27,
                    points: "10,10 15.5,15.5 21,10"
                }


            }
            return options;
        },//line chart - desktop
        getDotsLineChartOptionsDesktop: function () {
            var options = {
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: 1.3
                },
                //general
                svgHeight: 404,
                svgWidth:790,
                //line
                line_left: 89,
                line_top: 105,
                line_width:611,
                line_height:162,
                //line area
                area_display: false,
                //line style
                lineStyle_interpolate:'basis',//cardinal/linear/monotone/basis
                lineStyle_thickness: 4,
                //x axis
                xAxis_line_y: 47,
                xAxis_line_x: 89,
                xAxis_line_height: 257,
                xAxis_text_y: 339,
                xAxis_text_x: 93,
                xAxis_display: true,
                //y axis
                yAxis_x:47,
                yAxis_y:20,
                yAxis_display: false,
                //transition
                duration: 2000,
                //dots
                dots_radius:5,
                dots_radius_selected:9,
                //labels
                labels_x:91,
                labels_y:24.31,
                labels_display: true,
                //horizonalLine,
                horizonalLine_display:false,

                highlightBy: 'last',	// defines the criteria for style dots as selected dot, there are 4 options - max/min/first/last(default).
                //animation
                doAnimations: true,
                lineDuration: 1000,
                lineDelay: 200,
                dotsDelay: 700,
                dotsDuration: 500,
                dotsLabelDelay: 800,
                areaDelay:1200,
                areaDuration: 500,
                dotRect:{
                    height: 20,
                    yOffset: 35,
                    radiusX: 20,
                    radiusY: 10
                },
                dotText:{
                    yOffset: 21,
                    paddingLeft: 7.5,
                    paddingRight: 7.5
                },
                dotPolygon:{
                    yOffset: 30,
                    points: "20,10 10,10 15,20"
                }


            }
            return options;
        },
        getBarChartOptions: function (ratio) {
            var ratioLarge = 1.3;
            if(typeof ration !== "undefined"){
                ratioLarge = ration;
            }
            var options = {
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: ratioLarge
                },
                margin: {
                    top: 22,
                    bottom: 0
                },
                drawLabels: true,
                rectangles: {
                    height: 13,//height for iphone 5 screen TODO - remove this height from configs
                    width:281,
                    color: "rgba(169, 167, 167, 1)",
                    paddingTop: -28,
                    paddingBottom: 10,
                    seriesPadding: 3,
                    borderRadius: {
                        rx: 6,
                        ry: 6
                    },
                    gradients: {
                        selectedGradient: {
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }
                    },
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    }
                },
                labels: {
                    minWidth: 100,
                },
                selected: {},
                axis: {
                    xAxis: {
                        hide: true
                    },
                    yAxis: {
                        hide: false,
                        transValue: -20
                    }
                }
            };
            return options;
        },
        getBarGraphPalette: function () {
            return ['rgba(169, 167, 167, 1)', 'url(#selectedGradient)'];
        },
        getBarGraphLabelsPalette: function () {
            return ['rgba(40, 36, 37, 1)', 'rgba(84, 113, 180, 1)'];
        },
        getMultiVerticalPalette: function () {
            return ['rgba(183, 183, 183, 1)', 'rgba(215, 215, 215, 1)'];
        },
        getMultiVerticalLabelsPalette: function () {
            return ['rgba(147, 145, 149, 1)', 'rgba(40, 36, 37, 1)'];
        },
        getPieGrayColors : function(){
            return ["#ededed", "#d5d6d7", "#dfe0e2", "#ededed", "#dfe0e2", "#d5d6d7", "#dfe0e2"];
        },
        getPieGraphPalette: function (selectedTabId) {
            var outFlowsPalette = ['#d8277e'];
            var inFlowsPalette = ['#2c375f'];
            if (selectedTabId == "Out")
                return outFlowsPalette;
            return inFlowsPalette;
        },
        getPieGraphPaletteDesktop:function(selectedTabId){
            var outFlowsPalette = ['#ffce40', '#ffb608', '#ff9819', '#fe7d3f', '#f9652b', '#df4c3a', '#c72735'];
            var inFlowsPalette = ['#6787d1', '#027ac4', '#7390c5', '#3095bd', '#45a5d3', '#5acafa', '#95dafb'];
            if (selectedTabId == "Out")
                return outFlowsPalette;
            return inFlowsPalette;
        },
        //pie
        getPieOptions: function () {
            var options = {
                doAnimations: true,
                pieDelay: 0,
                pieDuration: 300,
                pieSelectedDelay: 300 * 1.5,
                pieTextDelay: 300 * 2,
                pieTextDuration: 300,
                center_text_total_font_size: 10,
                center_text_amount_font_size: 10,
                center_text_total_font_weight: 800,
                arcs: {
                    /**
                     * selected primary colors (include inflow/outflow primary colors)
                     * are optional, in case the selected pie's arc should be always the same color
                     * add the relevant values, else it should be null.
                     * */
                    selctedPrimaryColor: null,// used of there is no tabs (inflow / outflow)
                    selectedInflowPrimaryColor: null,// used once there is an inflow tab
                    selectedOutflowPrimaryColor: null,// used once there is an outflow tab
                    filter: {//for drop shadow
                        /*dropShadow: {
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 5,
                            dyOffset: 1,
                            color: "rgba(73, 73, 73, 0.35)"
                        },*/
                        grayFilter: true
                    },
                    cornerRadius: {
                        radiusCorner: 0
                    },
                    padAngle: 0
                }
            }
            return options;
        },
        //pie - desktop
        getPieOptionsDesktop: function () {
            var options = {
                doAnimations: true,
                pieDelay: 0,
                pieDuration: 300,
                pieSelectedDelay: 300 * 1.5,
                pieTextDelay: 300 * 2,
                pieTextDuration: 300,
                center_text_total_font_size: 20,
                center_text_amount_font_size: 20,
                center_text_total_font_weight: 300,
                arcs: {
                    /**
                     * selected primary colors (include inflow/outflow primary colors)
                     * are optional, in case the selected pie's arc should be always the same color
                     * add the relevant values, else it should be null.
                     * */
                    selctedPrimaryColor: null,// used of there is no tabs (inflow / outflow)
                    selectedInflowPrimaryColor: null,// used once there is an inflow tab
                    selectedOutflowPrimaryColor: null,// used once there is an outflow tab
                    filter: {//for drop shadow
                        /*dropShadow: {
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 5,
                            dyOffset: 1,
                            color: "rgba(73, 73, 73, 0.35)"
                        },*/
                        grayFilter: true
                    },
                    cornerRadius: {
                        radiusCorner: 9
                    },
                    padAngle: 0.04
                }
            }
            return options;
        },
        //pin chart - desktop
        getPinGraphChartOptionsDesktop: function () {
            var options = {
                isDesktop:true,
                maxBarHeight: 177,
                svgHeight: 404,
                svgWidth: 730,
                labelTop: 90,
                barTop: 114,
                xAxisTop: 340,
                yAxisHeight: 255,
                yAxisTop: 47,
                yAxisLineDisplay: true,
                yAxisTextDisplay: false,
                //animations
                doAnimations: true,
                barDelay:0,
                barDuration:350,
                labelDelay:400,
                labelDuration:350,
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: 1.3
                },
                margin: {
                    top: 120,
                    bottom: 117
                },
                chart: {
                    transX: 0,//spacing variable
                    transY: 10 // pedding top (g from svg)
                },
                labels: {
                    drawLabels: true
                },
                rectangles: {
                    width: 14,
                    space: 89,
                    borderRadius: {
                        rx: 6,
                        ry: 6
                    },
                    gradients: [{
                        id: "selectedGradient",
                        offset: ["0%", "100%"],
                        stopColors: ["#6888d2", "#536fb1"]
                    }],
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    },
                    transition: {
                        duration: 1000,
                        delay: 500
                    }
                },
                selected: {},
                axis: {
                    translation: {
                        x: 0,
                        y: "height"
                    },
                    xAxis: {
                        hide: false,
                        collapsedPadding:{
                            top: 22,
                            bottom: 15
                        }
                    }
                }
            };

            return options;
        },
        //bar chart - desktop
        getColumnChartOptionsDesktop: function () {
            var options = {
                isDesktop:true,
                maxBarHeight: 150,
                svgHeight: 404,
                svgWidth: 730,
                labelTop: 118,
                barTop: 137,
                xAxisTop: 340,
                yAxisHeight: 253,
                yAxisTop: 49,
                yAxisLineDisplay: true,
                yAxisTextDisplay: false,
                //animations
                doAnimations: true,
                barDelay:0,
                barDuration:350,
                labelDelay:400,
                labelDuration:350,

                benchMarkOuterLabelsY: 137, //barTop
                benchMarkOuterLabelsX: 0,

                screen: {
                    ratio_medium: 1.17,
                    ratio_large: 1.3
                },
                chart: {
                    transX: 0,//spacing variable
                    transY: 10
                },
                labels: {
                    drawLabels: true,
                    drawBenchMarkOuterLabels: true
                },
                rectangles: {
                    width: 18,
                    space: 87,
                    borderRadius: {
                        rx: 9,
                        ry: 9
                    },
                    gradients: [{
                        id: "selectedGradient",
                        offset: ["0%", "100%"],
                        stopColors: ["#6888d2", "#536fb1"]
                    }],
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    },
                    transition: {
                        duration: 1000,
                        delay: 500
                    }
                },
                selected: {},
                axis: {
                    translation: {
                        x: 0,
                        y: "height"
                    },
                    xAxis: {
                        hide: false,
                        collapsedPadding:{
                            top: 22,
                            bottom: 15
                        }
                    },
                    yAxis: {
                        x: 0,
                        y: 0,
                        hide: true
                    }
                }
            };

            return options;
        },
        //multi vertical - desktop
        getColumnChartMultiSeriesOptionsDesktop: function () {
            var options = {
                svgHeight: 404,
                svgWidth: 730,
                maxBarHeight: 180,
                labelTop: 80,
                nextLabelTop: 21,
                barTop: 107,
                xAxiaTop: 340,
                yAxisTop: 49,
                yAxisHeight: 253,
                spaceLeft: 30,
                yAxisLineDisplay: true,
                yAxisTextDisplay: false,
                drowVerticalLines: false,
                accessHiddenRectMarginLeft:0,
                accessHiddenRectMarginTop:43,
                //animations
                doAnimations: true,
                barDelay:0,
                barDuration:350,
                labelDelay:400,
                labelDuration:350,

                screen: {
                    ratio_medium: 1.17,
                    ratio_large: 1.3
                },
                chart: {
                    transX: 0,	//spacing variable
                    transY: 0  // pedding top (g from svg)
                },
                labels: {
                    drawLabels: true,
                    right: 6
                },
                rectangles: {
                    width: 18,
                    space: 57,
                    seriesPadding: 12.5,
                    paddingRight: 30,
                    transX: 4,
                    borderRadius: {
                        rx: 9,
                        ry: 9
                    },
                    gradients: {
                        selectedInGradient: {
                            id: "selectedInGradient",
                            offset: ["100%"],
                            stopColors: ["rgba(84, 113, 180, 1)"]
                        },
                        selectedOutGradient: {
                            id: "selectedOutGradient",
                            offset: ["100%"],
                            stopColors: ["rgba(255, 185, 10, 1)"]
                        }
                    },
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    },
                    transition: {
                        duration: 1000,
                        delay: 500
                    }
                },
                selected: {},
                axis: {
                    translation: {
                        x: 8,
                        y: "height"
                    },
                    xAxis: {
                        hide: false,
                        tickPadding: 10,
                        minimizedPadding: {
                            top: 22,
                            bottom: 15
                        }
                    },
                    yAxis: {
                        hide: true,
                        x: 0,
                        y: 30
                    }
                }
            };

            return options;
        },
        getBarChartOptionsDesktop: function () {//?
            var options = {
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: 1.3
                },
                margin: {
                    top: 22,
                    bottom: 0
                },
                drawLabels: true,
                rectangles: {
                    height: 13,//height for iphone 5 screen TODO - remove this height from configs
                    width:730,
                    color: "rgba(169, 167, 167, 1)",
                    paddingTop: -28,
                    paddingBottom: 10,
                    seriesPadding: 3,
                    borderRadius: {
                        rx: 6,
                        ry: 6
                    },
                    gradients: {
                        selectedGradient: {
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }
                    },
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    }
                },
                labels: {
                    minWidth: 100,
                },
                selected: {},
                axis: {
                    xAxis: {
                        hide: true
                    },
                    yAxis: {
                        hide: false,
                        paddingRight: 27,
                        transValue: -20
                    }
                }
            };
            return options;
        },
        getBarBenchmarkConfig: function getBarBenchmarkConfig(){
            return {
                "lineInterpolate": "linear",
                "labelWidthPercent": 36.508,
                "benchmarkDrawDelay": 1500,
                "labelTransitionDuration": 500,
                "lineTransitionDuration": 500

            };
        },
        getMultiVerticalPaletteDesktop: function () {
            return ['rgba(215, 215, 215, 1)', 'rgba(183, 183, 183, 1)'];
        },
        getMultiVerticalLabelsPaletteDesktop: function () {
            return ['rgba(0, 0, 0, 1)', 'rgba(115, 114, 114, 1)'];
        },
        getDotsLineGraphPalette: function () {
            return ['rgba(46, 115, 255, 1)'];
        },
        getAccountSelectorPalette: function(){
            return ['image1','image2','image3'];
        },
        getAccountSelectorConfig: function getAccountSelectorConfig(){
            var config = {
                showArrows: true,
                minAccountsForDisplayingArrows: 2,
                enableInfiniteCarousel: true,
                showIndexDots: true,
                nextArrowDir: "rtl",
                allAnimation: {
                    type: "fadingSlidingOut",
                },
                isRightToLeft: false
            }
            return config;
        },
        getAccountSelectorConfigDesktop: function getAccountSelectorConfigDesktop(){
            var config = {
                showArrows: true,
                minAccountsForDisplayingArrows: 4,
                enableInfiniteCarousel: true,
                showIndexDots: true,
                nextArrowDir: "rtl",
                allAnimation: {
                    type: "heapCards",
                    cardsStackTotalHeight: 43,
                    maxSpaceBetweenCards: 14,
                    showBoxShadowForLastCardOnly: false,
                },
                isRightToLeft: false
            }
            return config;
        },
        getCollapseBlockHeight: function getCollapseBlockHeight(blockType){
            switch(blockType) {
                case "account-selector":
                    return 120;
                    break;
                case "bar-chart":
                case "pin-graph":
                case "pie-chart":
                    return 70;
                    break;
                case "pure-bar-chart":
                    return 40;
                    break;
                default:
                    return 70;
            }
        },

        getBlockPercentInViewportToStartAnimate: function getBlockPercentInViewportToStartAnimate(blockType){
            var percents = 1;
            var blocksPercents = {
                "bar-chart": {
                    "multiVertical":0.7,
                    "vertical": 0.7,
                    "horizontal": 0.8
                },
                "pin-graph": {
                    "pinGraph":0.7,
                    "pin-graph":0.7
                },
                "line-chart": 0.5,
                "pie-chart": 0.2,
                "pure-bar-chart":{
                    "pure-bar-chart": 0.5
                }
            }
            if(blocksPercents[blockType] != 'undefined'){
                percents = blocksPercents[blockType];
            }
            return percents;
        },
        getBlockPercentInViewportToStartAnimateDesktop: function getBlockPercentInViewportToStartAnimateDesktop(blockType){
            var percents = 1;
            var blocksPercents = {
                "bar-chart": {
                    "multiVertical":0.6,
                    "vertical": 0.6,
                    "horizontal": 0.6
                },
                "pin-graph": {
                    "pin-graph":0.6
                },
                "line-chart": 0.6,
                "pie-chart": 0.5
            }
            if(blocksPercents[blockType] != 'undefined'){
                percents = blocksPercents[blockType];
            }
            return percents;
        },

        getBarChartNewOptions: function getBarChartNewOptions(type){/**type= vertical/multiVertical/horizontal/multiHorizontal */
            var options = {
                'vertical':{
                    'height': 0.0792,//via simply 45 /568
                    'marginBetweenBars':4.6,// in percent
                    'amountAnimationDuration': 1500,
                    'minBarHeight': 0.0125//4
                },
                'multiVertical':{
                    'height': 0.0968,//via simply 55 /568
                    'marginBetweenBars':4.8,// in percent
                    'tooltipJMarginBottom': 15,
                    'amountAnimationDuration': 1500,
                    'minBarHeight': 0.0125//4
                }
            }
            return options[type];
        }
    });

    // register this skin controller as application skin controller
    Personetics.story.skinController = Personetics.story.ProductSkinControler;
    Personetics.story.getTablesFormat = function () {
        return {
            "table-perso-txlist1": {
                "columns": ["accountNumber", "transaction", "date", "amount"],
                "displayColumns": {
                    "date": {
                        "format": "MM/DD/YY",
                        "type": "date"
                    },
                    "amount": {
                        "format": "###,###.00",
                        "type": "amount"
                    }
                }
            },
            "table-perso-txlist1-new": {
                "columns": ["accountNumber", "transaction", "date", "amount"],
                "displayColumns": {
                    "date": {
                        "format": "MM/DD/YY",
                        "type": "date"
                    },
                    "amount": {
                        "format": "###,###.00",
                        "type": "amount"
                    }
                }
            },
            "table-perso-txlist2": {
                "columns": ["transaction", "date", "amount"],
                "displayColumns": {
                    "date": {
                        "format": "MM/DD/YY",
                        "type": "date"
                    },
                    "amount": {
                        "format": "###,###.00",
                        "type": "amount"
                    }
                }
            },
            "table-perso-txlist3": {
                "columns": ["accountNumber", "transaction", "date", "amount", "date", "balance"],
                "displayColumns": {
                    "date": {
                        "format": "MM/DD/YY",
                        "type": "date"
                    },
                    "amount": {
                        "format": "###,###.00",
                        "type": "amount"
                    },
                    "balance": {
                        "format": "###,###.00",
                        "type": "amount"
                    }
                }
            },
            "table-perso-txlist4": {
                "columns": ["date", "transaction", "amount"],
                "displayColumns": {
                    "date": {
                        "format": "MM/DD/YY",
                        "type": "date"
                    },
                    "amount": {
                        "format": "###,###.00",
                        "type": "amount"
                    }
                }
            },
            "table-perso-txlist5": {
                "columns": ["date", "transaction", "amount", "balance"],
                "displayColumns": {
                    "date": {
                        "format": "MM/DD/YY",
                        "type": "date"
                    },
                    "amount": {
                        "format": "###,###.00",
                        "type": "amount"
                    },
                    "balance": {
                        "format": "###,###.00",
                        "type": "amount"
                    }
                }
            },
            "table-perso-txlist6": {
                "columns": ["date", "transaction", "amount"],
                "displayColumns": {
                    "date": {
                        "format": "MM/DD/YY",
                        "type": "date"
                    },
                    "amount": {
                        "format": "###,###.00",
                        "type": "amount"
                    }
                }
            },
            "table-default": {
                "displayColumns": {
                    "date": {
                        "format": "MM/DD/YY",
                        "type": "date"
                    },
                    "amount": {
                        "format": "###,###.00",
                        "type": "amount"
                    }
                }
            },

            /*"dateFormat": "MM/DD/YY",
            "amountFormat": "###,###,###",
            "currencySymbol": "$"/*,
             "currencyName": "US dollar",
             "currencyNamePlural": "US dollars",
             "currencyNameDecimal": "cent",
             "currencyNameDecimalPlural": "cents",
             "accesibilityDateFormat": "The {{day}} of {{month}}, {{year}}",
             "accesibilityAmountFormat": "{{amountInt}} {{currencyName}}",
             "accesibilityAmountDecimalFormat": " and {{amountDecimal}} {{currencyNameDecimal}}"*/
        }
    };

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
	Personetics.story = Personetics.story || {};
	Personetics.story.openBankSkinControler = Personetics.story.ProductSkinControler.extend({
        registerBlocks: function () {
            Personetics.story.ProductSkinControler.prototype.registerBlocks.call(this);
            this.registerChartHelper("lineChartHelper", {
                helperClass: Personetics.utils.d3Helpers.LineChartHelperOpenBank
            });
            this.registerChartHelper("verticalHelper", {
                helperClass: Personetics.utils.d3Helpers.VerticalChartHelperOpenBank
            });
            this.registerChartHelper("pinGraphHelper", {
				helperClass:Personetics.utils.d3Helpers.PinGraphChartHelperOpenBank
			}); 
            this.registerBlock("bar-chart", {
                blockClass: Personetics.story.BarChartBlockOpenBank
            });
            this.registerBlock("bar-chart", {
                widthMode: "desktop",
                blockClass: Personetics.story.D3BarChartBlockDesktopOpenBank
            });
            this.registerBlock("pie-chart", {
                blockClass: Personetics.story.NewPieChartBlockOpenBank
            });
            this.registerBlock("tranList", {
                blockClass: Personetics.story.NewTableBlockOpenBank
            });
            this.registerBlock("tabs", {
                blockClass: Personetics.story.TabsBlockOpenBank
            });
            this.registerBlock("account-selector", {
                blockClass: Personetics.story.NewAccountSelectorBlockOpenBank
            });
            this.registerBlock("buttons", {
                blockClass: Personetics.story.NewButtonsBlockOpenBank
            });
            this.registerBlock("pie-chart", {
                blockClass: Personetics.story.PieChartBlockOpenBankDesktop,
                widthMode: "desktop"
            });
            this.registerBlock("pin-graph", {
                widthMode: "desktop",
                blockClass: Personetics.story.D3PinGraphChartBlockOpenBankDesktop
            });
            this.registerBlock("pinGraph", {
                widthMode: "desktop",
                blockClass: Personetics.story.D3PinGraphChartBlockOpenBankDesktop
            });
            this.registerBlock("account-selector", {
                widthMode: "desktop",
                blockClass: Personetics.story.AccountSelectorBlockOpenBankDesktop
            });
            this.registerChartHelper("multiVerticalHelper", {
                    helperClass: Personetics.utils.d3Helpers.MultiVerticalChartHelperDesktopOpenBank,
                    widthMode: "desktop"
            });
            this.registerChartHelper("collapseHelper", {
                helperClass: Personetics.story.CollapseHelperOpenBank
            });
        },
        registerWidgets: function () {
            Personetics.story.ProductSkinControler.prototype.registerWidgets.call(this);
            Personetics.UI.PWidgetFactory.registerWidget("ratings", {
                widgetClass: Personetics.UI.OpenBankRatingCtrl,
                widgetName: "Base ratings",
            });
            Personetics.UI.PWidgetFactory.registerWidget("ratings", {
                widgetClass: Personetics.UI.PRatingCtrlDesktopOpenBank,
                widgetName: "Desktop ratings",
                widthMode: "desktop"
            });
            Personetics.UI.PWidgetFactory.registerWidget("story-widget", {
                widgetClass: Personetics.UI.PStoryWidgetCtrlOpenBankDesktop,
                widgetName: "Product story widget",
                widthMode: "desktop"
            });
        },

        getHorizontalPinGraphChartOptions: function () {
            var options = {
                maxWidthBarPercent: 51,
                pinChartHeight: 0.338 //0.32 = 182 (sympli value) / 568 (window height)
            };
            return options;
        },
        //line chart
        getDotsLineChartOptions: function (ratio) {
            var ratioLarg = ratio ? ratio : 1.3;
            var options = {
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: ratioLarg
                },
                //general
                svgHeight: 192,
                svgWidth:288,
                //line
                line_left: 42,
                line_top: 49,
                line_width: 208,
                line_height:52,
                //line area
                area_display: true,
                areaPaddingBottom:49,
                //line style
                lineStyle_interpolate:'basis',//cardinal/linear/monotone/basis
                lineStyle_thickness: 3,
                //x axis
                xAxis_line_y: 50,
                xAxis_line_height: 100,
                xAxis_text_y: 163,
                xAxis_display: true,
                //y axis
                yAxis_x:0,
                yAxis_y:0,
                yAxis_display: false,

                //dots
                dots_radius:8,
                dots_radius_shadow: 23,
                dots_shadow: 4,
                dots_radius_selected:5.5,
                //labels
                labels_x: 0,
                labels_y:14.3,
                labels_display: true,
                //horizonalLine
                horizonalLine_x:0,
                horizonalLine_length:308,
                horizonalLine_y:100,
                horizonalLine_display:false,

                highlightBy: 'min',	// defines the criteria for style dots as selected dot, there are 4 options - max/min/first/last(default).

                //transition
                doAnimations: true,
                lineDuration: 1000,
                lineDelay: 200,
                dotsDelay: 700,
                dotsLabelDelay: 800,
                dotsDuration: 500,
                areaDelay:1200,
                areaDuration: 500,
                dotRect:{
                    height: 40,
                    yOffset: 55,
                    radiusX: 20,
                    radiusY: 10,
                    dot_label_radius:10, 
                },
                dotText:{
                    yOffset: -15,
                    xOffset:10,
                    paddingLeft: 6,
                    paddingRight: 6,
                    lineHeight: 20
                },
                dotPolygon:{
                    yOffset: 27,
                    points: "10,10 15.5,15.5 21,10"
                },
                dotCircle:{
                    yOffset: -21,
                    xOffset: 3,
                    radius:2.5,
                }
            }
            return options;
        },
        //line chart - desktop
        getDotsLineChartOptionsDesktop: function () {
            var options = {
                screen: {
                    ratio_medium: 1.17,
                    ratio_large: 1.3
                },
                //general
                svgHeight: 292,
                svgWidth:690,
                //line
                line_left: 85,
                line_top: 75,
                line_width: 517,
                line_height:74,
                //line area
                area_display: true,
                //line style
                lineStyle_interpolate:'basis',//cardinal/linear/monotone/basis
                lineStyle_thickness: 3,
                //x axis
                xAxis_line_y:78,
                xAxis_line_height: 152,
                xAxis_text_y: 252,
                xAxis_display: true,
                //y axis
                yAxis_x:47,
                yAxis_y:20,
                yAxis_display: false,
                //transition
                duration: 2000,
                //dots
                dots_radius:10,
                dots_radius_shadow:30.5,
                dots_shadow: 7,
                dots_radius_selected:5.5,
                //labels
                labels_x:91,
                labels_y:24.31,
                labels_display: true,
                //horizonalLine,
                horizonalLine_display:false,

                highlightBy: 'last',	// defines the criteria for style dots as selected dot, there are 4 options - max/min/first/last(default).
                //animation
                doAnimations: true,
                lineDuration: 1000,
                lineDelay: 200,
                dotsDelay: 700,
                dotsDuration: 500,
                dotsLabelDelay: 800,
                areaDelay:1200,
                areaDuration: 500,
                dotRect:{
                    height: 20,
                    yOffset: 35,
                    radiusX: 20,
                    radiusY: 10,
                    dot_label_radius:10,
                },
                dotText:{
                    yOffset: -15,
                    xOffset:60,
                    paddingLeft: 7.5,
                    paddingRight: 7.5,
                    lineHeight: 20
                },
                dotPolygon:{
                    yOffset: 30,
                    points: "20,10 10,10 15,20"
                },
                dotCircle:{
                    yOffset: -19,
                    xOffset: -1,
                    radius: 3.5,
                }

            }
            return options;
        },
        getPieGraphPalette: function (selectedTabId) {
            var outFlowsPalette = ['#fbb800'];
            var inFlowsPalette = ['#0ac8a1'];
            if (selectedTabId == "In")
                return inFlowsPalette;
            return outFlowsPalette; 
        }, 
        getPieGrayColors : function () {
             return ['#f1f4f4', '#e3e9e9', '#ccd5da'];
        },    
        //pie
        getPieOptions: function () {
            var options = {
                doAnimations: true,
                pieDelay: 0,
                pieDuration: 300,
                pieSelectedDelay: 300 * 1.5,
                pieTextDelay: 300,
                pieTextDuration: 300,
                center_text_total_font_size: 12,
                center_text_amount_font_size: 14,
                center_text_total_font_weight: 400, 
                totaltxt_SpaceFromCenter: -29,
                totalAmount_SpaceFromCenter: 23,
                arcs: {
                    selctedPrimaryColor: null, // used of there is no tabs (inflow / outflow)
                    selectedInflowPrimaryColor: null, // used once there is an inflow tab
                    selectedOutflowPrimaryColor: null, // used once there is an outflow tab
                    filter: {
                        grayFilter: true
                    },
                    cornerRadius: {
                        radiusCorner: 0
                    },
                    padAngle: 0
                }
            }
            return options;
        }, 
        //pie - desktop
        getPieOptionsDesktop: function () {
            var options = {
                doAnimations: true,
                pieDelay: 0,
                pieDuration: 300,
                pieSelectedDelay: 300 * 1.5,
                pieTextDelay: 300 * 2,
                pieTextDuration: 300,
                arcs: {
                    selctedPrimaryColor: '#fbb800', //default is OUT
                    selectedInflowPrimaryColor: '#0ac8a1',
                    selectedOutflowPrimaryColor: '#fbb800',
                    filter: {
                        grayFilter: false
                    },
                    cornerRadius: {
                        radiusCorner: 0
                    },
                    padAngle: 0
                }
            }
            return options;
        },
        getAccountSelectorConfig: function getAccountSelectorConfig(){
            var config = {
                showArrows: false,
                minAccountsForDisplayingArrows: 2,
                enableInfiniteCarousel: true,
                showIndexDots: true,
                nextArrowDir: "rtl",
                allAnimation: {
                    type: "fadingSlidingOut",
                },
                isRightToLeft: false
            }
            return config;
        },
        getBarChartNewOptions: function getBarChartNewOptions(type){/**type= vertical/multiVertical/horizontal/multiHorizontal */
            var options = {
                'vertical':{
                    'height': 0.123239,//via simply 45 /568
                    'marginBetweenBars':4.6,// in percent
                    'amountAnimationDuration': 1500,
                    'minBarHeight': 0//4
                },
                'multiVertical':{
                    'height': 0.09683,//via simply 55 /568
                    'marginBetweenBars':4.8,// in percent
                    'tooltipJMarginBottom': 15,
                    'amountAnimationDuration': 1500,
                    'minBarHeight': 0//4
                }
            }
            return options[type];
        },
        //bar chart - desktop
        getColumnChartOptionsDesktop: function () {
            var options = {
                isDesktop:true,
                maxBarHeight: 100,
                svgHeight: 237,
                svgWidth: 688,
                labelTop: 201,
                barTop: 29,
                xAxisTop: 150,
                yAxisHeight: 253,
                yAxisTop: 49,
                yAxisLineDisplay: false,
                yAxisTextDisplay: false,
                //animations
                doAnimations: true,
                barDelay:0,
                barDuration:350,
                labelDelay:400,
                labelDuration:350,

                //lines
				horizontalLineWidth: 591,
                horizontalLineLeft: 48,

				barTopNegState: 30,
				labelSpaceBarNegBar: -14,
				yAxisTopNegState: 30,
				yAxisDisplayOneLine: true,

                benchMarkOuterLabelsY: 29,
                benchMarkOuterLabelsX: 0,

                screen: {
                    ratio_medium: 1.17,
                    ratio_large: 1.3
                },
                chart: {
                    transX: 0,//spacing variable
                    transY: 10
                },
                labels: {
                    drawLabels: true,
                    drawBenchMarkOuterLabels: true
                },
                rectangles: {
                    width: 25,
                    space: 75,
                    borderRadius: {
                        rx: 0,
                        ry: 0,
                    },
                    gradients: [{
                        id: "rectGradient",
                        offset: ["0%", "100%"],
                        stopColors: ["#ffd303", "#fbb800"]
                    },
                    {
                        id: "negativeGradient",
                        offset: ["0%", "100%"],
                        stopColors: ["#fbb800", "#ffd303"]
                    }
                ],
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    },
                    transition: {
                        duration: 1000,
                        delay: 500
                    }
                },
                selected: {},
                axis: {
                    translation: {
                        x: 0,
                        y: "height"
                    },
                    xAxis: {
                        hide: false,
                        collapsedPadding:{
                            top: 22,
                            bottom: 15
                        }
                    },
                    yAxis: {
                        x: 0,
                        y: 0,
                        hide: true
                    }
                }
            };

            return options;
        },
        //pin-chart - desktop
        getPinGraphChartOptionsDesktop: function () {
            var options = {
                isDesktop:true,
                desktopScreenWidth: 790,
                maxBarHeight: 100,
                svgHeight: 237,
                svgWidth: 688,
                labelTop: 201,
                barTop: 29,
                xAxisTop: 150,
                yAxisHeight: 253,
                yAxisTop: 49,
                yAxisLineDisplay: false,
                yAxisTextDisplay: false,

				//lines
				horizontalLineWidth: 589,
                horizontalLineLeft: 49,

				barTopNegState: 30,
				labelSpaceBarNegBar: -14,
				yAxisTopNegState: 30,
				yAxisDisplayOneLine: true,

                //animations
                doAnimations: true,
                barDelay:0,
                barDuration:350,
                labelDelay:400,
                labelDuration:350,

                screen: {
                    ratio_medium: 1.17,
                    ratio_large: 1.3
                },
                margin: {
                    top: 120,
                    bottom: 117
                },
                chart: {
                    transX: 0,//spacing variable
                    transY: 10 // pedding top (g from svg)
                },
                labels: {
                    drawLabels: true
                },
                rectangles: {
                    width: 25,
                    space: 75,
                    borderRadius: {
                        rx: 0,
                        ry: 0
                    },
                    gradients: [{
                        id: "rectGradientIn",
                        offset: ["0%", "100%"],
                        stopColors: ["#16aa8b", "#0bc9a2"]
                    },
                    {
                        id: "rectGradientOut",
                        offset: ["0%", "100%"],
                        stopColors: ["#fbb800", "#ffd303"]
                    }],
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    },
                    transition: {
                        duration: 1000,
                        delay: 500
                    }
                },
                selected: {},
                axis: {
                    translation: {
                        x: 0,
                        y: "height"
                    },
                    xAxis: {
                        hide: false,
                        collapsedPadding:{
                            top: 22,
                            bottom: 15
                        }
                    }
                }
            };

            return options;
        },
        //multi vertical - desktop
        getColumnChartMultiSeriesOptionsDesktop: function () {
            var options = {
                svgHeight: 237,
                svgWidth: 688,
                maxBarHeight: 69,
                labelTop: 185,
                nextLabelTop: 18,
                barTop: 60,
                xAxiaTop: 150,
                yAxisTop: 49,
                yAxisHeight: 253,
                spaceLeft: 30,
                yAxisLineDisplay: false,
                yAxisTextDisplay: false,
                drowVerticalLines: false,                
                accessHiddenRectMarginLeft:0,
                accessHiddenRectMarginTop:43,
                
                //lines
                horizontalLineWidth: 589,
                horizontalLineLeft: 49,
                yAxisDisplayOneLine: true,
                
                //animations
                doAnimations: true,
                barDelay:0,
                barDuration:350,
                labelDelay:400,
                labelDuration:350,

                screen: {
                    ratio_medium: 1.17,
                    ratio_large: 1.3
                },
                chart: {
                    transX: 0,    //spacing variable
                    transY: 0  // pedding top (g from svg)
                },
                labels: {
                    drawLabels: true,
                    right: 6
                },
                rectangles: {
                    width: 26,
                    space: 75,
                    seriesPadding: 7,
                    paddingRight: 30,
                    transX: 4,
                    borderRadius: {
                        rx: 0,
                        ry: 0,
                    },
                    gradients: {
                        InGradient: {
                            id: "InGradient",
                            offset: ["0%","100%"],
                            stopColors: ["#0bc9a2","#16aa8b"]
                        },
                        OutGradient: {
                            id: "OutGradient",
                            offset: ["0%","100%"],
                            stopColors: ["#ffd303","#fbb800"]
                        }
                    },
                    filter: {
                        dropShadow: {
                            id: "dropShadow",
                            in: "SourceGraphic",
                            stdDeviation: 3,
                            dxOffset: 1,
                            dyOffset: 2
                        }
                    },
                    transition: {
                        duration: 1000,
                        delay: 500
                    }
                },
                selected: {},
                axis: {
                    translation: {
                        x: 8,
                        y: "height"
                    },
                    xAxis: {
                        hide: false,
                        tickPadding: 10,
                        minimizedPadding: {
                            top: 22,
                            bottom: 15
                        }
                    },
                    yAxis: {
                        hide: true,
                        x: 0,
                        y: 30
                    }
                },
                inOut:{
                    drawInOut: true,
                    paddingTop: 34,
                    paddingLeft: 266,
                    nextLeft:89,
                    rectangle:{
                        height: 5,
                        width: 9,
                        paddingTop: 2,
                        borderRadius: {
                            rx: 2.5,
                            ry: 2.5,
                        },
                    },
                    label:{
                        x: 17,
                        y: 9,
                    },
                }
            };

            return options;
        },
        getCollapseOptions: function (params) {
            var blockDisplayedHeight;
            var blockType = params.type;
            switch(blockType){
                case "account-selector":
                    blockDisplayedHeight = 130;
                   break;
                case "pie-chart":
                   blockDisplayedHeight = 65;
                   break;
                default:blockDisplayedHeight = 64;
            }
            var screenWidth = $(window).width();
            var screenOptions = this.getScreenOptions();
            var displayedHeight;
            if (screenWidth < 347) {
                displayedHeight = blockDisplayedHeight;
            } else if (screenWidth >= 414) {
                displayedHeight = blockDisplayedHeight * screenOptions.ratio_large;
            } else {
                displayedHeight = blockDisplayedHeight * screenOptions.ratio_medium;
            }
            return { "displayedHeight": displayedHeight };
        },
        getBlockPercentInViewportToStartAnimateDesktop: function getBlockPercentInViewportToStartAnimateDesktop(blockType){
            var percents = 1;
            var blocksPercents = {
                "bar-chart": {
                    "multiVertical":0.6,
                    "vertical": 0.6,
                    "horizontal": 0.6
                },
                "pin-graph": {
                    "pinGraph":0.6,
                    "pin-graph":0.6
                },
                "line-chart": 0.6,
                "pie-chart": 0.5
            }
            if(blocksPercents[blockType] != 'undefined'){
                percents = blocksPercents[blockType];
            }
            return percents;
        },
        getAccountSelectorConfigDesktop: function getAccountSelectorConfigDesktop(){
            var config = {
                showArrows: true,
                minAccountsForDisplayingArrows: 2,
                enableInfiniteCarousel: true,
                showIndexDots: true,
                nextArrowDir: "rtl",
                allAnimation: {
                    type: "fadingSlidingOut",
                    cardsStackTotalHeight: 43,
                    maxSpaceBetweenCards: 14,
                    showBoxShadowForLastCardOnly: false,
                },
                isRightToLeft: false
            }
            return config;
        },
    });

    // register this skin controller as application skin controller
    Personetics.story.skinController = Personetics.story.openBankSkinControler;
        Personetics.story.getTablesFormat = function () {
            return {
                "table-perso-txlist1": {
                    "columns": ["accountNumber", "transaction", "date", "amount"],
                    "displayColumns": {
                        "date": {
                            "format": "DD MMM",
                            "type": "date"
                        },
                        "amount": {
                            "format": Personetics.processor.PStoryConfig.getConfig("lang") == "es" ? "-##.###.###,00@" : "-##,###,###.00@",
                            "type": "amount"
                        }
                    }
                },
                "table-perso-txlist1-new": {
                    "columns": ["accountNumber", "transaction", "date", "amount"],
                    "displayColumns": {
                        "date": {
                            "format":  "DD MMM",
                            "type": "date"
                        },
                        "amount": {
                            "format": Personetics.processor.PStoryConfig.getConfig("lang") == "es" ? "-##.###.###,00@" : "-##,###,###.00@",
                            "type": "amount"
                        }
                    }
                },
                "table-perso-txlist2": {
                    "columns": ["transaction", "date", "amount"],
                    "displayColumns": {
                        "date": {
                            "format": "DD MMM",
                            "type": "date"
                        },
                        "amount": {
                            "format": Personetics.processor.PStoryConfig.getConfig("lang") == "es" ? "-##.###.###,00@" : "-##,###,###.00@",
                            "type": "amount"
                        }
                    }
                },
                "table-default": {
                    "displayColumns": {
                        "date": {
                            "format":  "DD MMM",
                            "type": "date"
                        },
                        "amount": {
                            "format": Personetics.processor.PStoryConfig.getConfig("lang") == "es" ? "-##.###.###,00@" : "-##,###,###.00@",
                            "type": "amount"
                        }
                    }
                },
    
                /*"dateFormat": "MM/DD/YY",
                "amountFormat": "###,###,###",
                "currencySymbol": "$"/*,
                 "currencyName": "US dollar",
                 "currencyNamePlural": "US dollars",
                 "currencyNameDecimal": "cent",
                 "currencyNameDecimalPlural": "cents",
                 "accesibilityDateFormat": "The {{day}} of {{month}}, {{year}}",
                 "accesibilityAmountFormat": "{{amountInt}} {{currencyName}}",
                 "accesibilityAmountDecimalFormat": " and {{amountDecimal}} {{currencyNameDecimal}}"*/
            }
        };
        
})(window, window.Personetics = window.Personetics || {}, jQuery);
// an abstract block class. All other blocks should extend it
(function(window, Personetics, $, undefined){
    var Handlebars = Personetics.UI.Handlebars;
	Personetics.teaser = Personetics.teaser || {};

	Personetics.teaser.Block = Base.extend({
		initialize: function(parent, layoutInstructions, defaultConfig) {
			this.parent = parent;
			this.layoutInstructions = layoutInstructions;

			// setup block's template
			var tmplId = this.getHtmlTemplateId(layoutInstructions.class);
			if (tmplId)
				this.template = Handlebars.templates["block-" + tmplId];

			// Add defaultConfig to block
			if(typeof defaultConfig !== "undefined" && defaultConfig !== null){
				this.defaultConfig = defaultConfig;
			}
		},

		getHtmlTemplateId: function(clazz) {
			throw "No template id defined for block"
		},

		initBlock: function() {
		},

		handleQueryData: function(data){
			this.renderData(data);
			this.bindEvents();
		},

		setVisible: function(visible) {},

		beforeRender: function(el, layoutInstructions) {
			this.layoutInstructions = layoutInstructions;
		},

		render: function(el, layoutInstructions) {
			// don't override if saved in beforeRender
			this.layoutInstructions = this.layoutInstructions || layoutInstructions;
			this.el = el;
			var html = this.template(layoutInstructions);
			el.append(html);
			this.frameEl = el.find(".pstory-block-frame").last();
		},

		renderAgain: function(data){
			var html = this.template(data);
			$(this.frameEl).replaceWith(html);
		},

		renderData: function(data){},

		afterRender: function(el) {},

		bindEvents: function() {}
	});
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.TextBlock = Personetics.teaser.Block.extend({
        getHtmlTemplateId: function(clazz) {
            switch(clazz){
                case "note":
                case "perso-note":
                    return "txt-note";
                default:
                    return "txt";
                }
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.DateBoxBlock = Personetics.teaser.Block.extend({
        getHtmlTemplateId: function(clazz) {
            return "date-box";
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.D3BarChartBlock = Personetics.teaser.Block.extend({
        CHART_TYPES:{
            MultiVertical : "multiVertical",
            MultiHorizontal: "multiHorizontal",
            SingleVertical: "vertical",
            SingleHorizontal: "horizontal"

        },
        getHtmlTemplateId: function(clazz) {
            return "bar-chart";
        },
        beforeRender: function(el, layoutInstructions, templateId){
            Personetics.teaser.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.layoutInstructions.series = this.rebuildSeriesData(this.layoutInstructions.series);
            if(this.layoutInstructions.direction == this.CHART_TYPES.SingleHorizontal) {
                this.layoutInstructions.series = [this.rebuildHorizontalSeriesData(this.layoutInstructions.series[0])];
            }
            this.setSelected();
            this.barsDirection();
            this.beforeRenderChart(el, templateId);
        },
        setSelected: function setSelected(){
            var block = this;
            this.hasSelected = false;
            $.each(this.layoutInstructions.series,function(i, seriesArray){
                $.each(seriesArray, function(j, item){
                    if(item.selected == true){
                        block.hasSelected = true;
                        return false;
                    }
                });
            });
            if(this.hasSelected == false){
                $.each(this.layoutInstructions.series,function(i, seriesArray){
                    if(seriesArray.length > 0){
                        seriesArray[seriesArray.length - 1].selected = true;
                    }
                });
            }
        },
        render: function(el, layoutInstructions) {
            this.renderSelectedBar(layoutInstructions);
            this.renderBlock(el, layoutInstructions);
        },
        renderBlock: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.render.call(this, el, layoutInstructions);

            var chartEl = this.frameEl.find(".pstory-bar-chart");
            if (chartEl.length > 0) {
                this.renderBarChart(chartEl, layoutInstructions);
            }
        },
        renderSelectedBar: function(layoutInstructions){
           
        },
        afterRender: function(){
            $(this.chartEl).addClass(this.layoutInstructions.direction);
            if(this.chartType == this.CHART_TYPES.MultiHorizontal){
                this.reverseData();                
            }
        },

        barsDirection: function barsDirection(){
            if(this.layoutInstructions.direction == "vertical" && Personetics.processor.PStoryConfig.isRtl()){
               this.barsDirectionRTL();
            }    
        },
        barsDirectionRTL: function barsDirectionRTL(){
             if($.isArray(this.layoutInstructions.categories)){
                    this.layoutInstructions.categories.reverse();
                }
                if($.isArray(this.layoutInstructions.series)){
                    $.each(this.layoutInstructions.series, function(i, series){
                        if($.isArray(series)){
                            series.reverse();
                        }
                    });
                }
        },
        beforeRenderChart: function(el, templateId){

            var direction = this.layoutInstructions.direction || "vertical";

            // if layoutInstructions.series contains a single series array, use the child array as the real series array
            if(this.layoutInstructions.series.length == 1 && $.isArray(this.layoutInstructions.series[0]))
                this.layoutInstructions.series = this.layoutInstructions.series[0];

            this.isSeries = this.layoutInstructions.hasOwnProperty('seriesLabels')
                && this.layoutInstructions.seriesLabels.length > 0
                && this.layoutInstructions.seriesLabels[0].length > 0;
            this.chartType = this.getChartType(direction, this.isSeries);
            this.chartTypeHelper = this.chartType + "Helper";
            this.initChartHelper(this.chartTypeHelper);

            if(this.chartType == this.CHART_TYPES.MultiVertical)
                this.options = this.defaultConfig.columnChartMultiSeriesOptions;
            else if(this.chartType == this.CHART_TYPES.MultiHorizontal){
                this.options = this.defaultConfig.barChartOptions;
                //this.reverseData();
            }
            else if(this.chartType == this.CHART_TYPES.SingleHorizontal)
                this.options = this.defaultConfig.singleHorizontalChartOptions;
            else
                if(templateId == "verticalBarAndBoxTeaser"){
                    this.options = this.defaultConfig.columnChartAndBoxOptions;
                }
                else{
                    this.options = this.defaultConfig.columnChartOptions;
                }

            if(this.defaultConfig.hasOwnProperty('desktopScreenWidth') && this.defaultConfig.desktopScreenWidth !== 'undefined' && this.defaultConfig.desktopScreenWidth !== null){
                    this.options.desktopScreenWidth = this.defaultConfig.desktopScreenWidth;
            }
        },
        renderBarChart: function(el) {
            var handleClickBind = Personetics.bind(this, this.handleClick);
            if(this.chartType == "multiHorizontal"){
                this.options.palette = this.defaultConfig.barGraphPalette;
                this.options.paletteLabels = this.defaultConfig.barGraphLabelsPalette;
                this.chartHelper.prepareMultiHorizontalChart(this, el);
                this.chartHelper.renderMultiHorizontalChart(this, el, this.layoutInstructions);
            }
            else{
                if(typeof this.chartHelper.prepareChartData == "function"){
                    this.layoutInstructions = this.chartHelper.prepareChartData(this.layoutInstructions, this.options);
                }
                this.chartHelper.prepareChart(this.layoutInstructions, this.options, handleClickBind);
                this.chartHelper.renderChart(el);
            }
        },
        /**d3 render bars from bottom to top - for displaying bars in order from top to bottom data has to be reversed */
        reverseData: function reverseData(){
            this.layoutInstructions.series.reverse();
            $.each(this.layoutInstructions.series, function(index, item){
                item.reverse();
            });
        },

        rebuildSeriesData: function (series) {
            var self = this;
            var data = [];
            if (self.isSeries && series.length) {
                $.each(self.layoutInstructions.seriesLabels, function (i, label) {
                    var tmpArray = [];
                    $.each(series, function (j, seriesItem) {
                        $.each(seriesItem, function (k, item) {
                            if (label == item.mode) {
                                tmpArray.push(item);
                            }
                        })
                    });
                    data.push(tmpArray);
                })
            } else {
                data = [series];
            }
            return data;
        },
        rebuildHorizontalSeriesData: function (series){
            var newSeries = [];
            var ina = [];
            var out = [];
            var i=0;
            for(i=0;i<series.length;i++){
                for(j =0; j < series[i].length;j++){
                    if(series[i][j].mode == 'In')
                        ina.unshift(series[i][j]);
                    else
                        out.unshift(series[i][j]);
                }
            }

            newSeries.push(ina, out);
            return newSeries;
        },

        handleClick: function(obj, clickedItemIndex) {
            if(this.hasSelected == false){
                return;
            }
            if(obj.amount == 0)
                return;
            var svg = this.frameEl.find('svg .perso-bar, svg .perso-chart-rect')[clickedItemIndex].className.animVal;
            if(svg.indexOf("selected") != -1){
                return;
            }

            /*jq not working*/
            var highlightedElements = this.frameEl.find('svg .perso-bar.selected, svg .perso-chart-rect.selected');
            $.each(highlightedElements,function (i,element) {
                element.className.baseVal= Personetics.utils.string.removeClass(element.className,'selected');
            });

            var highlightedLabels = this.frameEl.find('svg .perso-label');
            $.each(highlightedLabels,function (i,label) {
                label.className.baseVal= Personetics.utils.string.removeClass(label.className,'selected');
            });

            var highlightedxAxisLabels = this.frameEl.find('svg .perso-xAxis-label');
            $.each(highlightedxAxisLabels,function (i, xAxisLabel) {
                xAxisLabel.className.baseVal= Personetics.utils.string.removeClass(xAxisLabel.className,'selected');
            });


            //Check if the object has mode (series) or not
            if(obj.hasOwnProperty("mode")){
                //highlight selected elements
                var highlightSelectedInElements = this.frameEl.find('svg .perso-bar, svg .perso-chart-rect.In')[clickedItemIndex];
                var highlightSelectedOutElements = this.frameEl.find('svg .perso-bar, svg .perso-chart-rect.Out')[clickedItemIndex];
               
                //highlight selected labels
                var highlightSelectedInLabels = this.frameEl.find('svg .perso-label.In')[clickedItemIndex];
                var highlightSelectedOutLabels = this.frameEl.find('svg .perso-label.Out')[clickedItemIndex];

                highlightSelectedInElements.className.baseVal= Personetics.utils.string.addClass(highlightSelectedInElements.className,'selected');
                highlightSelectedOutElements.className.baseVal= Personetics.utils.string.addClass(highlightSelectedOutElements.className,'selected');

                highlightSelectedInLabels.className.baseVal= Personetics.utils.string.addClass(highlightSelectedInLabels.className,'selected'); 
                highlightSelectedOutLabels.className.baseVal= Personetics.utils.string.addClass(highlightSelectedOutLabels.className,'selected');


            } else {
                //choose the clicked item
                var clickedBar = this.frameEl.find('svg .perso-bar, svg .perso-chart-rect')[clickedItemIndex];
                var clickedBarLabel = this.frameEl.find('svg .perso-label')[clickedItemIndex];
                var clickedBarxAxis = this.frameEl.find('svg .perso-xAxis-label')[clickedItemIndex];   
                
                //add 'selected' flag to the clicked item
                clickedBar.className.baseVal= Personetics.utils.string.addClass(clickedBar.className,'selected');
                clickedBarLabel.className.baseVal= Personetics.utils.string.addClass(clickedBarLabel.className,'selected');
                if(clickedBarxAxis){
                    clickedBarxAxis.className.baseVal= Personetics.utils.string.addClass(clickedBarxAxis.className,'selected');
                }
                
            }
            this.parent.notifyEvent(this, "setSelectedValue", obj.category); 
            this.notifyReportEvent(obj.category);
        },

        //utils
        getChartType: function(direction, hasMultiSeries){
            var type = null;
            if(direction =="vertical" && hasMultiSeries){
                type = "multiVertical";
            }else if(direction =="horizontal" && hasMultiSeries){
                type = "multiHorizontal";
            }else if (direction =="vertical"){
                type = "vertical";
            }
            else if(direction =="horizontal"){
                type = "horizontal";
            }
            return type;
        },

        initChartHelper: function(type){
            this.chartHelper = Personetics.story.BlockChartFactory.generateHelperClazz(type, {}/*, this.story.cfg*/);
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.BarChartBlock = Personetics.teaser.Block.extend({

        getHtmlTemplateId: function(clazz) {
            return "pure-bar-chart";
        },
        beforeRender: function(el, layoutInstructions, templateId){
            Personetics.teaser.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.series = layoutInstructions.series;
            layoutInstructions.isSeries = this.isSeries = this.layoutInstructions.hasOwnProperty('seriesLabels')
                && this.layoutInstructions.seriesLabels.length > 0
                && this.layoutInstructions.seriesLabels[0].length > 0;
            this.chartType = (this.isSeries) ? 'multiVertical' : 'vertical';
            this.setSelected();
            this.texts = this.getTexts();

            this.prepereData();
            this.options = this.defaultConfig[this.chartType];
        },
        prepereData: function prepereData(){
            var block = this;
            this.prepereAccessibilityCategories();
            this.setSeriesNamesForDisplay();
            if(this.isSeries){
                $.each(this.layoutInstructions.series, function (i, item) {
                    block.layoutInstructions.series[i].category = item[0].category;
                });
            }
        },
        getTexts: function getTexts() {
            return {
                accessibilityBarChartTitle: Personetics.dictionary.getText("accessibilityBarChartPureTitle"),
                series: Personetics.dictionary.getText("accessibilitySeries"),
                selected: Personetics.dictionary.getText("accessibilitySelected"),
                notSelected: Personetics.dictionary.getText("accessibilityNotSelected"),
                in: Personetics.dictionary.getText("lblIn"),
                out: Personetics.dictionary.getText("lblOut")
            };
        },
        prepereAccessibilityCategories: function renderAccessibilityCategories() {
            var block = this;
            var dateUtils = Personetics.processor.PUtils.getUtilsInstance("dateUtils");
            var lang = Personetics.processor.PStoryConfig.getConfig("lang");
            $.each(this.layoutInstructions.categories, function (i, category) {
                var monthNumber = dateUtils.getMonthNumber(lang + "-short", category);
                var fullMonthName = dateUtils.getMonthName(lang)[monthNumber];
                fullMonthName = fullMonthName || category;
                block.layoutInstructions.series[i].displayLabel = category
                block.layoutInstructions.series[i].accLabel = fullMonthName
            });
        },
        setSeriesNamesForDisplay: function setSeriesNamesForDisplay() {
            if (this.isSeries) {
                var seriesNamesForDisplay = this.layoutInstructions.seriesNamesForDisplay;
                var texts = this.texts;
                if (typeof seriesNamesForDisplay === 'undefined' || seriesNamesForDisplay === null) {
                    seriesNamesForDisplay = this.layoutInstructions.seriesLabels.map(function (label) {
                        return texts[label.toLowerCase()];
                    })
                }
                this.seriesNamesForDisplay = seriesNamesForDisplay;
            }
        },
        setSelected: function setSelected() {
            var block = this;
            var hasSelected = false;
            var series = block.layoutInstructions.series;
            $.each(series, function (i, item) {
                if (!block.isSeries) {
                    if (item.selected == true) {
                        hasSelected = true;
                        return false;
                    }
                } else {
                    $.each(item, function (j, obj) {
                        if (obj.selected == true) {
                            if (!item.selected) {
                                item.selected = true;
                            }
                            hasSelected = true;
                            return false;
                        }
                    });
                }
            });
            if (hasSelected == false) {
                if (series.length && block.isSeries) {
                    $.each(series[series.length - 1], function (i, item) {
                        if (typeof item !== 'undefined' && item !== null) {
                            item.selected = true;
                        }
                    });
                } else {
                    series[series.length - 1].selected = true;
                }
            }
        },
        /**end before render */
        /**render */
        render: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.render.call(this, el, layoutInstructions);
            var chartEl = this.frameEl.find(".pstory-bar-chart");
            if (chartEl.length > 0) {
                this.renderBars(chartEl);
            }
        },
        renderBars: function (el) {
            var block = this;
            if (this.isSeries) {
                var series = $(el).find('.perso-series-wrapper');
                block.setBarsWidth(series);
                block.setBarsSeriesHeight(series);
            } else {
                var bars = $(el).find('.perso-bar-wrapper');
                block.setBarsWidth(bars);
                block.setBarHeight(bars);
            }
        },
        setBarsWidth: function (elements) {
            var totalMargin = (this.layoutInstructions.categories.length - 1) * this.options.marginBetweenBars;
            $(elements).css('width', 100 / this.layoutInstructions.categories.length + '%');
        },
        /**calculate bars height */
        setBarHeight: function (barElements) {
            var maxValue = this.getMaxValue();
            var minValue = this.getMinValue();
            this.calculateBarsHeight(barElements, minValue, maxValue);
        },
        setBarsSeriesHeight: function (seriesElements) {
            var maxValue = this.getSeiresMaxValue();
            this.calculateSeriesBarsHeight(seriesElements, maxValue);

        },
        calculateBarsHeight: function (bars, minValue, maxValue) {
            var block = this;
            var negativeBar = false;
            var orignalMaxValue = maxValue;
            if (minValue < 0) {
                if (maxValue >= 0) {
                    maxValue = maxValue + Math.abs(minValue);
                } else {
                    negativeBar = true;
                }
            }

            var options = this.prepareCalculateBarHeightOptions(maxValue);
            var maxHeight = block.calculateBarHeightByValue(orignalMaxValue, options);
            $.each(bars, function (i, bar) {
                var x = block.series[i].value;
                var values = block.calculateBarHeightByValue(x, options);
                var normalValue = values.normalValue;
                $(bar).css('height', normalValue + 'px');
                var top = 0;
                if (values.y < 0) {
                    $(bar).addClass('negative-bar');
                    if(negativeBar == false){
                        top = maxHeight.normalValue;
                    }
                }
                else{
                    top = maxHeight.normalValue - normalValue;
                }

                $(bar).css('top', top + 'px');
            });
        },
        calculateSeriesBarsHeight: function ($series, maxValue) {
            var block = this;
            var options = this.prepareCalculateBarHeightOptions(maxValue);
            if ($series.length) {
                $.each($series, function (i, series) {
                    var $bars = $(series).find('.perso-bar-wrapper');
                    if ($bars.length) {
                        $.each($bars, function (j, bar) {
                            var absValue = Math.abs(block.series[i][j].value);
                            var mode = (block.series[i][j].mode) ? block.series[i][j].mode : '';
                            $(bar).addClass(mode.toLowerCase());
                            var height = block.calculateBarHeightByValue(absValue, options).normalValue;
                            $(bar).css('height', height + 'px');
                            $(bar).css('top', 'calc(100% - ' + height + 'px)');
                        })
                    }
                });
            }
        },
        prepareCalculateBarHeightOptions: function prepareCalculateBarHeightOptions(maxValue) {
            var minHeight = this.options.minBarHeight * (window.innerWidth); /*minHeight = normalize value*/
            var containerHeight = this.options.height * (window.innerHeight);
            var m = (containerHeight) / (Math.abs(maxValue));
            return {
                'm': m,
                'minHeight': minHeight,
                'containerHeight': containerHeight
            }
        },
        calculateBarHeightByValue: function calculateBarHeightByValue(x, options) {
            var y = options.m * (x);
            return {
                'normalValue': Math.abs(y + options.minHeight),
                'y': y
            };
        },
        getMaxValue: function () {
            var block = this;
            var maxValue = Math.max.apply(Math, block.series.map(function (o) {
                return o.value;
            }));
            return maxValue;
        },
        getMinValue: function () {
            var block = this;
            var minValue = Math.min.apply(Math, block.series.map(function (o) {
                return o.value;
            }));
            return minValue;
        },
        getSeiresMaxValue: function () {
            var block = this;
            var maxSeriesValue = 0;
            if (block.isSeries) {
                $.each(block.series, function (i, series) {
                    var tmp = Math.max.apply(Math, series.map(function (o) {
                        return o.value;
                    }));
                    if (maxSeriesValue < tmp) {
                        maxSeriesValue = tmp;
                    }
                })
            }
            return maxSeriesValue;
        },
        /**end calculate bars height */
        convertPercentToSimpleValue: function convertPercentToSimpleValue(percentValue, containerValue){
            return containerValue / 100 * percentValue;
        },
        /**end render */
        /**after render */
        afterRender: function (el) {
            // only after render if render method didn't fail
            if (this.frameEl) {
                this.frameEl.closest(".pstory-dialog-frame").addClass("pure-bar-chart-dialog")
                this.setBarsWrapperHeight();
                this.setDefaultBar();
                this.setMonthAmount(this.series[this.getDefaultIndex()].value);
            }
            this.renderAccessibility();
        },
        renderAccessibility: function renderAccessibility() {
            Personetics.utils.accessibility.addAltTextToElement(this.frameEl, this.texts["accessibilityBarChartTitle"]);
        },
        setBarsWrapperHeight: function setBarsWrapperHeight() {
            var barsWrapperElm = this.frameEl.find('.perso-bars-wrapper');
            var calculatedHeight = this.options.height * (window.innerHeight);
            if (barsWrapperElm.length) {
                $(barsWrapperElm).height(calculatedHeight);
            }
        },


        setDefaultBar: function setDefaultBar() {
            var selectedElm = this.frameEl.find(".perso-bar.selected");
            if (this.isSeries) {
                this.setTooltipPosition(selectedElm.attr('pstory-category'));
            }
            this.createDefaultBarTransElem(selectedElm);
        },
        getDefaultIndex: function () {
            var block = this;
            var selected = 0;
            $.each(block.layoutInstructions.series, function (i, item) {
                if (item.selected) {
                    selected = i;
                    return false;
                }
            });
            return selected;
        },
        getSelectedBarIndex: function () {
            return this.selectedBarIndex ? this.selectedBarIndex : 0;
        },
        createDefaultBarTransElem: function (elem) {
            $(elem).each(function (i,bar) {
                //$(bar).addClass('selected-animated');
                $(bar).append($("<div class='perso-animated-bar'></div>"));
            });
        },
        /**bind events */
        bindEvents: function () {
            //this.frameEl.find(".perso-month-picker-item").bind("click", Personetics.bind(this, this.monthPickerItemClick));
        },
        // tabClickListener: function tabClickListener(category) {
        //     this.changeSelectedElm(category);
        //     if (!this.isSeries) {
        //         var selected = this.series.filter(function(item){
        //             return item.category == category
        //         })[0];
        //         this.setMonthAmount(selected.label);
        //     } else {
        //         this.setTooltipPosition(category);
        //     }
        //     if(!this.frameEl.hasClass('perso-collapsed')){
        //         Personetics.utils.accessibility.putFocus(this.frameEl.find('.perso-bar-chart-wrapper'));
        //     }
        // },
        changeSelectedElm: function (category) {
            var elm = this.frameEl.find('.perso-bar');
            elm.removeClass('selected selected-animated');
            elm.find('.perso-filler-bar').remove();
            elm.filter("[pstory-category='" + category + "']").addClass('selected').attr("aria-selected", "true");
            this.updateSelectedAccText();

        },
        setMonthAmount: function (label) {
            var $persoMonthAmount = $('.perso-month-amount');
            if ($persoMonthAmount.length) {
                $persoMonthAmount.html(label);
            }
        },
        setTooltipPosition: function (category) {
            var block = this;
            var selectedSeries = this.frameEl.find('.perso-series .perso-bar.selected').parents('.perso-series');
            var tooltip = this.frameEl.find('.perso-tooltip');
            block.setTooltipLabels(tooltip, category);
            var maxSelectedSeriesBarHeight = this.getSeriesHigherBar(selectedSeries);
            if (selectedSeries.length && tooltip.length) {
                var bottomVal = maxSelectedSeriesBarHeight + this.options.tooltipJMarginBottom;
                var leftVal = $(selectedSeries).offset().left + $(selectedSeries).width() / 2 - $(tooltip).outerWidth() / 2;
                tooltip.css({
                    bottom: bottomVal,
                    left: leftVal,
                })
            }
        },
        setTooltipLabels: function (tooltip, category) {
            var block = this;
            var seriesNamesForDisplay = this.seriesNamesForDisplay;
            var labelTextElm = '<span class="perso-tooltip-label"></span>';
            if (tooltip.length) {
                $(tooltip).empty();
                var seriesObj = this.series.filter(function(item){
                    return item.category == category;
                })[0];
                $.each(this.layoutInstructions.seriesLabels, function (i, label) {
                    if (label.toLowerCase() == seriesObj[i].mode.toLowerCase()) {
                        $(labelTextElm).appendTo(tooltip);
                        $('.perso-tooltip-label').last().html(seriesNamesForDisplay[i] + " " + seriesObj[i].label);
                    }
                })
            }
        },
        getSeriesHigherBar: function ($series) {
            if ($series) {
                var barsHeight = $($series).find('.perso-bar').map(function () {
                        return $(this).height();
                    }).get(),
                    maxHeight = Math.max.apply(null, barsHeight);
            }
            return (maxHeight ? maxHeight : 0);
        },

        doAnimations: function () {
            var block = this;
            if (!block.isDraw) {
                var animationClass = (!block.isSeries && block.series[block.getDefaultIndex()].value < 0) ? 'perso-negative' : '';
                var animatedElm = this.frameEl.find('.perso-animated-bar');
                if (animatedElm.length) {
                    animatedElm.addClass('perso-filler-bar').addClass(animationClass);
                    block.amountAnimation($(block.frameEl.find('.perso-month-amount')));
                    block.isDraw = true;
                }
                if(this.benchmarkLines.length > 0){
                    var animationDuration = animatedElm.css('animation-duration');
                    var params = this.beforeRenderBenchmark();
                    setTimeout(function() {
                        block.renderBenchmark(params);
                    }, this.benchmarkConfig.benchmarkDrawDelay);
                }
            }
        },
        amountAnimation: function ($el) {
            var block = this;
            var amountElm = $el.find('.perso-int-num');
            var currencyElm = $el.find('.perso-currency');
            if (amountElm.length) {
                $(currencyElm).addClass('perso-fade-in');
                $(amountElm).addClass('perso-fade-in');
                $(amountElm).attr('Counter', 0).animate({
                    Counter: parseFloat($(amountElm).text().replace(/,/g, ''))
                }, {
                    duration: block.options.amountAnimationDuration,
                    easing: 'swing',
                    step: function (now) {
                        var amount = Math.ceil(now);
                        $(this).text(block.formatNumbers(amount));
                    }
                });
            }
        },
        formatNumbers: function (number) {
            var numberParts = number.toString().split('.');
            numberParts[0] = numberParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return numberParts.join(".");
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.PinGraphChartBlock = Personetics.teaser.Block.extend({
        getHtmlTemplateId: function(clazz) {
            return "pure-pinGraph-chart";
        },
        beforeRender: function(el, layoutInstructions) {
            if(layoutInstructions) {
                Personetics.teaser.Block.prototype.beforeRender.call(this, el, layoutInstructions);
                //make sure we work with only 3 values
                this.limitPinChartData(3, layoutInstructions);
                this.series = layoutInstructions.series.reverse();
                this.categories = layoutInstructions.categories.reverse();
                this.chartType = layoutInstructions.type;
                this.maxValue = this.getMaxValue();
                this.options = this.defaultConfig.pinGraphChartOptions;
            }
        },
        render: function(el, layoutInstructions) {
            this.limitPinChartData(3, layoutInstructions);
            Personetics.teaser.Block.prototype.render.call(this, el, layoutInstructions);
            var chartEl = this.frameEl.find(".pstory-pure-pinGraph-chart");
            if (chartEl.length > 0) {
                this.renderPinChart(chartEl);
            }
        },
        renderPinChart: function(el){
            var self = this;
            var pinChartRaws = $(el).find('.perso-pinGraph-raw');
            var maxVal = Math.abs(self.maxValue);
            self.setContainerHeight(el);
            if(pinChartRaws.length){
                $.each(pinChartRaws, function (i, raw) {
                    $(raw).css('height','calc( 100% / '+ self.series.length+')');
                    self.setCategoryText(raw, i);
                    self.setBarWidthByValue(raw, i, maxVal);
                    //self.setAmount(raw, i);
                })
            }
        },
        setCategoryText: function(el, index){
            var self = this;
            var categoryLabel = $(el).find('.perso-date-txt');
            if(categoryLabel.length){
                $(categoryLabel).text(self.categories[index]);
            }
        },
        setContainerHeight: function (el) {
            var self = this;
            if(el.length){
                var height = $(window).height() * this.options.pinChartHeight;//0.32 = 182 (sympli value) / 568 (window height)
                $(el).css('height',height);
            }
        },
        setBarWidthByValue: function(el, index, maxVal){
            var self = this;
            var pinchartBar = $(el).find('.perso-pinGraph-bar');
            var pinchartAmount = $(el).find('.perso-pinGraph-amount');
            var pinChartBarWrapper = $(el).find('.perso-bar-wrapper');
            if(pinchartBar.length){
                var calculatedWidth = Math.abs(self.series[index].value)/maxVal * this.options.maxWidthBarPercent;
                $(pinchartBar).css('width','calc( '+ calculatedWidth + '%)');
                $(pinchartBar).css('max-width','calc( '+ calculatedWidth + '%)');
                $(pinchartAmount).css('line-height',pinChartBarWrapper.height() + 'px')
            }
        },
        setAmount: function(el, index){
            var self = this;
            var amountLabel = $(el).find('.perso-pinGraph-amount');
            if(amountLabel.length){
                $(amountLabel).html(self.series[index].label);
            }
        },
        getMaxValue: function () {
            var self = this;
            var maxValue = Math.max.apply(Math, self.series.map(function (o) {
                return o.value;
            }));
            return maxValue;
        },
        afterRender: function (){
            var pinGraphText = Personetics.dictionary.getText("accessibilityPinGraph");
            var highlightedText = Personetics.dictionary.getText("accessibilityHighlighted");
            Personetics.utils.accessibility.addAltTextToElement(this.frameEl, pinGraphText);
            this.frameEl.find('.perso-pinGraph-raw:last-child').append('<div class="perso-accessibility-read">. '+highlightedText+'</div>');
        },
        limitPinChartData: function(num, layoutInstructions){
            if(layoutInstructions){
                layoutInstructions.series = layoutInstructions.series.slice(Math.max(layoutInstructions.series.length - num));// get the last 3 value
                layoutInstructions.categories = layoutInstructions.categories.slice(Math.max(layoutInstructions.categories.length - num));// get the last 3 values
            }
        }


    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.PieChartBlock = Personetics.teaser.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "pie-chart";
        },
        beforeRender: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.options = this.defaultConfig.pieOptions;
            this.cornerRadiusPie = (typeof this.options.arcs.cornerRadius != "undefined") && (typeof this.options.arcs.cornerRadius.radiusCorner != "undefined") ? this.options.arcs.cornerRadius.radiusCorner: 9;
            this.setTotal(layoutInstructions);
            this.colors = d3.scale.ordinal().range(this.defaultConfig.pieGraphPalette());
            this.grayscaleId = "grayscale_" + +new Date();
        },
        /**pie beforeRender definations */
        pie/*setPieDefination*/: function () {
            var block = this;
            var totalAmount = block.totalAmountInt || 0;
            var normalizedValue = totalAmount * 0.05;
            return d3.layout.pie()
                .padAngle(-0.015)
                .value(function (d) {
                    var value = d.value + normalizedValue;
                    return value;
                });
        },
        setTotal: function setTotal(layoutInstructions){
            // get centerText from config, and split it by "<br>"
            var totalFromSrc = layoutInstructions.centerText;
            this.totalText = totalFromSrc;
            if(layoutInstructions.hasOwnProperty('slices') && layoutInstructions.slices.length > 0){
                var totalAmountObj = layoutInstructions.slices.reduce(function(total, slice){
                    return {value: total.value + slice.value};
                });
                this.totalAmountInt = totalAmountObj.value;
            }
            else{
                this.totalAmountInt = 0;
            }
        },
        getGraphPalette: function () {
            return this.defaultConfig.pieGraphPalette;
        },

        /**render functions */
        render: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.render.call(this, el, layoutInstructions);
            this.frameEl = el.find('.pstory-block-frame').last();
            var chartEl = this.frameEl.find(".pstory-pie-chart");
            if (chartEl.length > 0) {
                this.renderPieChart(chartEl, layoutInstructions);
            }
        },

        renderPieChart: function (el, layoutInstructions) {
            var block = this;
            this.setPieSize();
            /** */
            d3.selection.prototype.moveToFront = function() {
                return this.each(function(){
                    var gparent = this.parentNode;
                    gparent.parentNode.appendChild(gparent);
                });
            };

            block.arc = d3.svg.arc()
                .innerRadius(block.innerRadius)
                .outerRadius(block.outerRadius);

            block.arcOver = d3.svg.arc()
                .innerRadius(block.innerRadiusOver)
                .outerRadius(block.outerRadiusOver);

            this.renderPieBase(el);
            this.renderShadowFilter(block);//?? base or pie
            this.renderPie(el, layoutInstructions);
        },
        setPieSize: function setPieSize(percents){
            if (percents)
                var percents = percents;
            else
                var percents = {
                    heightPercent: 0.7,
                    innerRadiusPercent: 0.17,
                    outerRadiusPercent: 0.2,
                    innerRadiusOverPercent: 0.165,
                    outerRadiusOverPercent: 0.22
                }
            this.margin = {top: 0, right: 19, bottom: 0, left: 19};
            this.width = this.frameEl.find('.pstory-pie-chart').width();
            this.height = this.width * percents.heightPercent;
            this.radius = this.width / 2.3;

            var calculatedInnerRadiusRatio = percents.innerRadiusPercent * this.width;
            var calculatedOuterRadiusRatio = percents.outerRadiusPercent * this.width;
            var calculatedInnerRadiusOverRatio = percents.innerRadiusOverPercent * this.width;
            var calculatedOuterRadiusOverRatio = percents.outerRadiusOverPercent * this.width;

            this.innerRadius = this.radius - calculatedInnerRadiusRatio;
            this.outerRadius = this.radius - calculatedOuterRadiusRatio;
            this.innerRadiusOver = this.radius - calculatedInnerRadiusOverRatio;
            this.outerRadiusOver = this.radius - calculatedOuterRadiusOverRatio;

        },
        /**render svg base and base attributes */
        renderPieBase: function renderPieBase(el){
            this.svg = this.renderPieSvgBase(el);
        },
        renderPieSvgBase: function (el) {
            var block = this;
            if (el) {
                return ( d3.select(el.get(0)).append("svg")
                    .attr("focusable", false)
                    .attr("width", block.width)
                    .attr("height", block.height)
                    .append("g")
                    .attr("transform", "translate(" + block.width / 2 + "," + block.height / 2 + ")"));
            }
        },
        /**render the pie */

        renderPie: function(el, layoutInstructions){
            this.renderArcs(layoutInstructions);
            // this.renderTicks(block, layoutInstructions);
            // this.renderPieLabels(block, layoutInstructions);
            this.renderPieTitle(this.totalText);
        },
        renderArcs: function (layoutInstructions) {
            var block = this;
            var arcs = block.svg.selectAll(".arc")
                .data(block.pie()(layoutInstructions.slices))
                .enter().append("g")
                .attr("class", "perso-arc");

            arcs.append("path")
                .attr("d", block.arc)
                .attr("class", function(d){
                    var clazz = "";
                    if(d.data.highlight){
                        clazz += "perso-selected";
                    }
                    return clazz;
                })
                .style("fill", function (d, i) {
                    return block.colors(i);
                })
                .on("click", function (obj, clickedItemIndex) {
                    if(!obj.data.hasOwnProperty("highlight")){
                        block.onPieItemClick(obj, clickedItemIndex, this);
                    }
                });
        },
        renderTicks: function (block, layoutInstructions) {
            if (block) {
                var ticks = block.svg.append('g')
                    .attr('class','perso-ticks')
                    .selectAll("line")
                    .data(block.pie()(layoutInstructions))
                    .enter().append("line");

                ticks.attr('class','perso-tick')
                    .attr("x1", 0)
                    .attr("x2", 0)
                    .attr("y1", -block.radius *.8)
                    .attr("y2", -block.radius * .9)
                    .attr("stroke", "gray")
                    .attr("transform", function (d) {
                        return "rotate(" + (d.startAngle + d.endAngle) / 2 * (180 / Math.PI) + ")";
                    });
            }
        },
        renderPieLabels: function (block, layoutInstructions) {
            if (block) {
                var labels = block.svg.append('g')
                    .attr('class','perso-pie-labels')
                    .attr("transform","translate(8,0)")
                    .selectAll("text")
                    .data(block.pie()(layoutInstructions))
                    .enter().append("text");
                labels.attr("class", "perso-pie-label")
                    .attr("transform", function (d) {
                        var dist = block.radius + 20;
                        var angle = (d.startAngle + d.endAngle) / 2;
                        var x = dist * Math.sin(angle);
                        var y = -dist * Math.cos(angle);
                        return "translate(" + x + "," + y + ")";
                    })
                    .attr("dy", "-0.5em")
                    .attr("text-anchor", "middle")
                    .text(function (d) {
                        return d.data.category;
                    })
                    .call(block.wrapLabelText, screen.width * .28);
            }
        },
        renderPieTitle: function(totalText){
            this.svg.append('text')
                .attr('class', 'perso-total-txt')
                .attr('text-anchor','middle')
                .attr('dy','.25em' )
                .style('font-size',this.options.centerText.fontSize)
                .style('font-weight',this.options.centerText.fontWeight)
                .text(totalText);
        },
        renderPieAmount: function(totalAmount){
            this.svg.append('text')
                .attr('class', 'perso-total-amount')
                .attr('dy','.9em' )
                .text(totalAmount);
        },

        /**events functions */
        onPieItemClick: function(obj, clickedItemIndex, clickedItem){
            var block = this;
            var oldSelectedArc = $('.perso-arc path.perso-selected');
            if (oldSelectedArc.length) {
                oldSelectedArc[0].className.baseVal= Personetics.utils.string.removeClass(oldSelectedArc[0].className,'perso-selected');
            }
            var oldSelectedArcLabel = this.frameEl.find('.pstory-pie-chart svg .perso-pie-label.selected');
            if (oldSelectedArcLabel.length) {
                oldSelectedArcLabel[0].className.baseVal= Personetics.utils.string.removeClass(oldSelectedArcLabel[0].className,'selected');
            }

            d3.select(clickedItem)
                .attr("class", "perso-selected");

            var pstoryLabels = this.frameEl.find('.pstory-pie-chart svg .perso-pie-label');
            if(typeof pstoryLabels != 'undefined' && pstoryLabels.length > clickedItemIndex){
                var clickedArcLabel = pstoryLabels[clickedItemIndex];
                clickedArcLabel.className.baseVal= Personetics.utils.string.addClass(clickedArcLabel.className,'selected');

            }
            this.handleClick(obj, clickedItemIndex);
        },

        renderShadowFilter: function (block) {
            var filters = block.options.arcs.filter;
            var svgWithFilters = block.svg;
            if (filters) {
                $.each(filters, function (i, filter) {
                    if (filter) {
                        var filterSvg = svgWithFilters.append("filter")
                            .attr("id", filter.id);

                        filterSvg.append("feGaussianBlur")
                            .attr("in", filter.in)
                            .attr("stdDeviation", filter.stdDeviation);

                        filterSvg.append("feOffset")
                            .attr("dx", filter.dxOffset)
                            .attr("dy", filter.dyOffset);
                        var feMerge = filterSvg.append("feMerge");

                        feMerge.append("feMergeNode");

                        feMerge.append("feMergeNode")
                            .attr("in", filter.in);
                    }
                })
            }
        },

        handleClick: function (obj,clickedItemIndex) {
            var dataObj = obj;
            if(dataObj.data){
                dataObj = dataObj.data;
            }
            this.parent.notifyEvent(this, "setSelectedValue", dataObj.category);
        },

        // this function get svg path selected index
        getSelectedPathIndex: function(paths){
            var pathIndex = 0;
            if(paths.length){
                $.each(paths, function(i, path){
                    if(path.className.baseVal == 'perso-selected'){/*jq not work*/
                        pathIndex = i;
                        return false;
                    }
                })
            }
            return pathIndex;
        },
        wrapLabelText: function(text, width) {
            text.each(function() {
                var text = d3.select(this),
                    words = text.text().split(/\s+/).reverse(),
                    word,
                    line = [],
                    lineNumber = 0,
                    lineHeight = .95, // ems
                    y = text.attr("y"),
                    dy = parseFloat(text.attr("dy")),
                    tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
                while (word = words.pop()) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", (++lineNumber * lineHeight * 1.5) + dy + "em").text(word);
                    }
                }
                if(lineNumber == 1){

                }
            });
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.NewPieChartBlock = Personetics.teaser.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "pie-chart";
        },
        beforeRender: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.options = this.defaultConfig.pieOptions;
            this.cornerRadiusPie = (typeof this.options.arcs.cornerRadius != "undefined") && (typeof this.options.arcs.cornerRadius.radiusCorner != "undefined") ? this.options.arcs.cornerRadius.radiusCorner: 9;
            this.setTotal(layoutInstructions);
            this.colors = d3.scale.ordinal().range(this.defaultConfig.pieGraphPalette());
            this.grayscaleId = "grayscale_" + +new Date();
        },
        /**pie beforeRender definations */
        pie/*setPieDefination*/: function () {
            var block = this;
            var totalAmount = block.totalAmountInt || 0;
            var normalizedValue = totalAmount * 0.05;
            return d3.layout.pie()
                .padAngle(-0.015)
                .value(function (d) {
                    var value = d.value + normalizedValue;
                    return value;
                });
        },
        setTotal: function setTotal(layoutInstructions){
            // get centerText from config, and split it by "<br>"
            var totalFromSrc = layoutInstructions.centerText;
            this.totalText = totalFromSrc;
            if(layoutInstructions.hasOwnProperty('slices') && layoutInstructions.slices.length > 0){
                var totalAmountObj = layoutInstructions.slices.reduce(function(total, slice){
                    return {value: total.value + slice.value};
                });
                this.totalAmountInt = totalAmountObj.value;
            }
            else{
                this.totalAmountInt = 0;
            }
        },
        getGraphPalette: function () {
            return this.defaultConfig.pieGraphPalette;
        },

        /**render functions */
        render: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.render.call(this, el, layoutInstructions);
            this.frameEl = el.find('.pstory-block-frame').last();
            var chartEl = this.frameEl.find(".pstory-pie-chart");
            if (chartEl.length > 0) {
                this.renderPieChart(chartEl, layoutInstructions);
            }
        },

        renderPieChart: function (el, layoutInstructions) {
            var block = this;
            this.setPieSize();
            /** */
            d3.selection.prototype.moveToFront = function() {
                return this.each(function(){
                    var gparent = this.parentNode;
                    gparent.parentNode.appendChild(gparent);
                });
            };

            block.arc = d3.svg.arc()
                .innerRadius(block.innerRadius)
                .outerRadius(block.outerRadius);

            block.arcOver = d3.svg.arc()
                .innerRadius(block.innerRadiusOver)
                .outerRadius(block.outerRadiusOver);

            this.renderPieBase(el);
            this.renderShadowFilter(block);//?? base or pie
            this.renderPie(el, layoutInstructions);
        },
        setPieSize: function setPieSize(percents){
            if (percents)
                var percents = percents;
            else
                var percents = {
                    heightPercent: 0.7,
                    innerRadiusPercent: 0.17,
                    outerRadiusPercent: 0.23,
                    innerRadiusOverPercent: 0.145,
                    outerRadiusOverPercent: 0.24
                }
            this.margin = {top: 0, right: 19, bottom: 0, left: 19};
            this.width = this.frameEl.find('.pstory-pie-chart').width();
            this.height = this.width * percents.heightPercent;
            this.radius = this.width / 2.3;

            var calculatedInnerRadiusRatio = percents.innerRadiusPercent * this.width;
            var calculatedOuterRadiusRatio = percents.outerRadiusPercent * this.width;
            var calculatedInnerRadiusOverRatio = percents.innerRadiusOverPercent * this.width;
            var calculatedOuterRadiusOverRatio = percents.outerRadiusOverPercent * this.width;

            this.innerRadius = this.radius - calculatedInnerRadiusRatio;
            this.outerRadius = this.radius - calculatedOuterRadiusRatio;
            this.innerRadiusOver = this.radius - calculatedInnerRadiusOverRatio;
            this.outerRadiusOver = this.radius - calculatedOuterRadiusOverRatio;

        },
        /**render svg base and base attributes */
        renderPieBase: function renderPieBase(el){
            this.svg = this.renderPieSvgBase(el);
        },
        renderPieSvgBase: function (el) {
            var block = this;
            if (el) {
                return ( d3.select(el.get(0)).append("svg")
                    .attr("focusable", false)
                    .attr("width", block.width)
                    .attr("height", block.height)
                    .append("g")
                    .attr("transform", "translate(" + block.width / 2 + "," + block.height / 2 + ")"));
            }
        },
        /**render the pie */

        renderPie: function(el, layoutInstructions){
            this.renderArcs(layoutInstructions);
            // this.renderTicks(block, layoutInstructions);
            // this.renderPieLabels(block, layoutInstructions);
            this.renderPieTitle(this.totalText);
        },
        renderArcs: function (layoutInstructions) {
            var block = this;
            var arcs = block.svg.selectAll(".arc")
                .data(block.pie()(layoutInstructions.slices))
                .enter().append("g")
                .attr("class", "perso-arc");

            arcs.append("path")
                .attr("d", block.arc)
                .attr("class", function(d){
                    var clazz = "";
                    if(d.data.highlight){
                        clazz += "perso-selected";
                    }
                    return clazz;
                })
                .style("fill", function (d, i) {
                    return block.colors(i);
                })
                .on("click", function (obj, clickedItemIndex) {
                    if(!obj.data.hasOwnProperty("highlight")){
                        block.onPieItemClick(obj, clickedItemIndex, this);
                    }
                });
        },
        renderTicks: function (block, layoutInstructions) {
            if (block) {
                var ticks = block.svg.append('g')
                    .attr('class','perso-ticks')
                    .selectAll("line")
                    .data(block.pie()(layoutInstructions))
                    .enter().append("line");

                ticks.attr('class','perso-tick')
                    .attr("x1", 0)
                    .attr("x2", 0)
                    .attr("y1", -block.radius *.8)
                    .attr("y2", -block.radius * .9)
                    .attr("stroke", "gray")
                    .attr("transform", function (d) {
                        return "rotate(" + (d.startAngle + d.endAngle) / 2 * (180 / Math.PI) + ")";
                    });
            }
        },
        renderPieLabels: function (block, layoutInstructions) {
            if (block) {
                var labels = block.svg.append('g')
                    .attr('class','perso-pie-labels')
                    .attr("transform","translate(8,0)")
                    .selectAll("text")
                    .data(block.pie()(layoutInstructions))
                    .enter().append("text");
                labels.attr("class", "perso-pie-label")
                    .attr("transform", function (d) {
                        var dist = block.radius + 20;
                        var angle = (d.startAngle + d.endAngle) / 2;
                        var x = dist * Math.sin(angle);
                        var y = -dist * Math.cos(angle);
                        return "translate(" + x + "," + y + ")";
                    })
                    .attr("dy", "-0.5em")
                    .attr("text-anchor", "middle")
                    .text(function (d) {
                        return d.data.category;
                    })
                    .call(block.wrapLabelText, screen.width * .28);
            }
        },
        renderPieTitle: function(totalText){
            this.svg.append('text')
                .attr('class', 'perso-total-txt')
                .attr('text-anchor','middle')
                .attr('dy','.25em' )
                .style('font-size',this.options.centerText.fontSize)
                .style('font-weight',this.options.centerText.fontWeight)
                .text(totalText);
        },
        renderPieAmount: function(totalAmount){
            this.svg.append('text')
                .attr('class', 'perso-total-amount')
                .attr('dy','.9em' )
                .text(totalAmount);
        },

        /**events functions */
        onPieItemClick: function(obj, clickedItemIndex, clickedItem){
            var block = this;
            var oldSelectedArc = $('.perso-arc path.perso-selected');
            if (oldSelectedArc.length) {
                oldSelectedArc[0].className.baseVal= Personetics.utils.string.removeClass(oldSelectedArc[0].className,'perso-selected');
            }
            var oldSelectedArcLabel = this.frameEl.find('.pstory-pie-chart svg .perso-pie-label.selected');
            if (oldSelectedArcLabel.length) {
                oldSelectedArcLabel[0].className.baseVal= Personetics.utils.string.removeClass(oldSelectedArcLabel[0].className,'selected');
            }

            d3.select(clickedItem)
                .attr("class", "perso-selected");

            var pstoryLabels = this.frameEl.find('.pstory-pie-chart svg .perso-pie-label');
            if(typeof pstoryLabels != 'undefined' && pstoryLabels.length > clickedItemIndex){
                var clickedArcLabel = pstoryLabels[clickedItemIndex];
                clickedArcLabel.className.baseVal= Personetics.utils.string.addClass(clickedArcLabel.className,'selected');

            }
            this.handleClick(obj, clickedItemIndex);
        },

        renderShadowFilter: function (block) {
            var filters = block.options.arcs.filter;
            var svgWithFilters = block.svg;
            if (filters) {
                $.each(filters, function (i, filter) {
                    if (filter) {
                        var filterSvg = svgWithFilters.append("filter")
                            .attr("id", filter.id);

                        filterSvg.append("feGaussianBlur")
                            .attr("in", filter.in)
                            .attr("stdDeviation", filter.stdDeviation);

                        filterSvg.append("feOffset")
                            .attr("dx", filter.dxOffset)
                            .attr("dy", filter.dyOffset);
                        var feMerge = filterSvg.append("feMerge");

                        feMerge.append("feMergeNode");

                        feMerge.append("feMergeNode")
                            .attr("in", filter.in);
                    }
                })
            }
        },

        handleClick: function (obj,clickedItemIndex) {
            var dataObj = obj;
            if(dataObj.data){
                dataObj = dataObj.data;
            }
            this.parent.notifyEvent(this, "setSelectedValue", dataObj.category);
        },

        // this function get svg path selected index
        getSelectedPathIndex: function(paths){
            var pathIndex = 0;
            if(paths.length){
                $.each(paths, function(i, path){
                    if(path.className.baseVal == 'perso-selected'){/*jq not work*/
                        pathIndex = i;
                        return false;
                    }
                })
            }
            return pathIndex;
        },
        wrapLabelText: function(text, width) {
            text.each(function() {
                var text = d3.select(this),
                    words = text.text().split(/\s+/).reverse(),
                    word,
                    line = [],
                    lineNumber = 0,
                    lineHeight = .95, // ems
                    y = text.attr("y"),
                    dy = parseFloat(text.attr("dy")),
                    tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
                while (word = words.pop()) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", (++lineNumber * lineHeight * 1.5) + dy + "em").text(word);
                    }
                }
                if(lineNumber == 1){

                }
            });
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function(window, Personetics, $, undefined){
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.D3PinGraphChartBlock = Personetics.teaser.D3BarChartBlock.extend({
        getHtmlTemplateId: function(clazz) {
            return "pinGraph-chart";
        },
        render: function(el, layoutInstructions) {
            Personetics.teaser.D3BarChartBlock.prototype.renderSelectedBar.call(this, layoutInstructions);
            this.renderBlock(el, layoutInstructions);
        },
        renderBlock: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.render.call(this, el, layoutInstructions);

            var chartEl = this.frameEl.find(".pstory-pinGraph-chart");
            if (chartEl.length > 0) {
                this.renderBarChart(chartEl, layoutInstructions);
            }
        },
        renderBarChart: function(el,data) {
            if(typeof this.chartHelper.prepareChartData == "function"){
                this.layoutInstructions = this.chartHelper.prepareChartData(this.layoutInstructions, this.options);
            }
            this.chartHelper.prepareChart(this.layoutInstructions, this.options);
            this.chartHelper.renderChart(el);
        },
        beforeRenderChart: function(el, layoutInstructions){
            // if layoutInstructions.series contains a single series array, use the child array as the real series array
            if(this.layoutInstructions.series.length == 1 && $.isArray(this.layoutInstructions.series[0]))
                this.layoutInstructions.series = this.layoutInstructions.series[0];
            this.chartType = this.getChartType();
            this.chartTypeHelper = (this.chartType +"Helper");
            this.initChartHelper(this.chartTypeHelper);
            this.options = this.defaultConfig.pinGraphChartOptions;
            if(this.defaultConfig.hasOwnProperty('desktopScreenWidth') && this.defaultConfig.desktopScreenWidth !== 'undefined' && this.defaultConfig.desktopScreenWidth !== null){
                this.options.desktopScreenWidth = this.defaultConfig.desktopScreenWidth;
            }
        },

        getChartType: function(){
            var type = 'pinGraph';
            return type;
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.lineChartBlock = Personetics.teaser.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "line-chart";
        },

        beforeRender: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.texts = {
                // add texts
            };
            this.beforeRenderChart();
        },

        getGraphPalette: function () {
            return this.defaultConfig.lineChartPalette;
        },

        beforeRenderChart: function () {
            this.chartType = 'lineChart';
            // if layoutInstructions.series contains a single series array, use the child array as the real series array
            if (this.layoutInstructions.series.length == 1 && $.isArray(this.layoutInstructions.series[0])) {
                this.layoutInstructions.series = this.layoutInstructions.series[0];
            }
            this.chartTypeHelper = this.chartType + "Helper";
            this.initChartHelper(this.chartTypeHelper);
            this.options = this.defaultConfig.lineChartOptions;
        },

        render: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.render.call(this, el, layoutInstructions);
            var chartEl = this.frameEl.find('.pstory-line-chart');
            if (chartEl.length > 0) {
                var data = layoutInstructions;
                var el = chartEl;
                var options = this.options;
                this.chartHelper.prepareChart(data, options);
                this.chartHelper.renderChart(el);
            }
        },
        initChartHelper: function(type){
            this.chartHelper = Personetics.story.BlockChartFactory.generateHelperClazz(type, {}/*, this.story.cfg*/);

        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.NewlineChartBlock = Personetics.teaser.Block.extend({
        getHtmlTemplateId: function (clazz) {
            return "line-chart";
        },

        beforeRender: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.beforeRender.call(this, el, layoutInstructions);
            this.texts = {
                // add texts
            };
            this.beforeRenderChart();
        },

        getGraphPalette: function () {
            return this.defaultConfig.lineChartPalette;
        },

        beforeRenderChart: function () {
            this.chartType = 'lineChart';
            // if layoutInstructions.series contains a single series array, use the child array as the real series array
            if (this.layoutInstructions.series.length == 1 && $.isArray(this.layoutInstructions.series[0])) {
                this.layoutInstructions.series = this.layoutInstructions.series[0];
            }
            this.chartTypeHelper = this.chartType + "Helper";
            this.initChartHelper(this.chartTypeHelper);
            this.options = this.defaultConfig.lineChartOptions;
        },

        render: function (el, layoutInstructions) {
            Personetics.teaser.Block.prototype.render.call(this, el, layoutInstructions);
            var chartEl = this.frameEl.find('.pstory-line-chart');
            if (chartEl.length > 0) {
                var data = layoutInstructions;
                var el = chartEl;
                var options = this.options;
                this.chartHelper.prepareChart(data, options);
                this.chartHelper.renderChart(el);
            }
        },
        afterRender: function (el) {
            /* S-38852 Teaser line chart - still uses the old design
            Personetics.teaser.Block.prototype.afterRender.call(this, el);
            this.cloneD3Elm('.perso-dot');
            var dots = d3.selectAll('.perso-dot');
            var last = dots.last();
            last.attr('class','perso-inner-dot')
            last.attr('class','perso-inner-dot')*/
        },
        
        initChartHelper: function (type) {
            this.chartHelper = Personetics.story.BlockChartFactory.generateHelperClazz(type, {}/*, this.story.cfg*/);

        },

        cloneD3Elm: function (selector) {
            if (selector.length) {
                var node = d3.select(selector).node();
                return d3.select(node.parentNode.insertBefore(node.cloneNode(true), node.nextSibling));
            }
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function(window, Personetics, $, undefined){
	Personetics.teaser = Personetics.teaser || {};
	Personetics.teaser.PBlockFactory = new function() {

		this.types = {
			"TYPE_CONTAINER": "layout"
		};

		this.blockFactoryMap = {};

		this.index = "0";

		this.registerBlock = function(type, config) {
			var entry = this.blockFactoryMap[type];
			if(config.blockClass) {
				// from cache
				if (!entry) {
					entry = {
						type: type,	// block type
						class: {},	// additional blocks based on css class
						widthModes: {}
					};
					this.blockFactoryMap[type] = entry;
				}
				// map block by class or by more specific css class
				if (config.class) {
					entry.class[config.class] = config.blockClass;
				}
				// map block by width mode
				else if(config.widthMode) {
					entry.widthModes[config.widthMode] = config.blockClass;
				}
				// default block mapping
				else{
					entry.blockClass = config.blockClass;
				}
			}
			if(config.hasOwnProperty("defaultConfig")){
				entry.defaultConfig = config.defaultConfig;
			}
		};

		this.createBlock = function(parent, layoutInstructions, story) {
			var block;
			var blockClass;
			var storyCfg = story ? story.cfg : null;
			var type = layoutInstructions.type;
            if(layoutInstructions.direction=="horizontal" && layoutInstructions.hasOwnProperty('seriesLabels')){
                type="multiVertical-bar-chart";
            }
			if(type == this.types.TYPE_CONTAINER){
				blockClass = Personetics.teaser.LayoutBlock;
				layoutInstructions.layoutId = "layout-" + this.index;
				this.index++;
			}
			else {
				var cClass = storyCfg ? layoutInstructions.class || storyCfg.chartsLibClass : null;
				var widthMode = storyCfg ? storyCfg.widthMode : null;
				var entry = this.blockFactoryMap[type];
				if (entry) {
					if (widthMode) {
						blockClass = entry.widthModes[widthMode];
					}
					if (cClass) {
						blockClass = entry.class[cClass];
					}

					if (!blockClass)
						blockClass = entry.blockClass;
				}
				if (!blockClass) {
					blockClass = Personetics.teaser.Block;
					Personetics.log("Invalid block type '" + type + "'");
				}
			}
			block = new blockClass(parent, layoutInstructions, entry.defaultConfig);
			return block;
		};
	};
})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    var Handlebars = Personetics.UI.Handlebars;
    var SkinSetup = function SkinSetup() {
    };


    SkinSetup.prototype.init = function registerBlocks() {
        this.registerDefaultBlocks();
        this.registerDefaultChartHeplers();
        this.registerPartialTemplates();
    };

    SkinSetup.prototype.registerBlock = function (type, config) {
        Personetics.teaser.PBlockFactory.registerBlock(type, config);
    };

    SkinSetup.prototype.registerChartHelper = function (name, clazz) {
        Personetics.story.BlockChartFactory.registerChartHelper(name, clazz);
    };

    SkinSetup.prototype.registerPartialTemplates = function registerPartialTemplates() {
        var me = this;
        var partialTemplates = this.getPartialTemplates();
        partialTemplates.forEach(function (partial) {
            var partialTemplate = Handlebars.templates[partial.id];
            if (typeof partialTemplate !== "undefined" && partialTemplate !== null)
                Handlebars.registerPartial(partial.name, partialTemplate);
        });
    };
    SkinSetup.prototype.getPartialTemplates = function getPartialTemplates() {
        return [
            {
                "name": "teaserWrapperPartial",
                "id": "teaserWrapperPartial"
            },
            {
                "name": "teaserHeader",
                "id": "teaserHeader"
            }
        ];
    };

    SkinSetup.prototype.registerDefaultBlocks = function registerDefaultBlocks(type) {
        this.registerBlock("txt", {
            blockClass: Personetics.teaser.TextBlock
        });
        this.registerBlock("text", {
            blockClass: Personetics.teaser.TextBlock
        });
        this.registerBlock("date-box", {
            blockClass: Personetics.teaser.DateBoxBlock
        });
        this.registerBlock("image", {
            blockClass: Personetics.teaser.ImageBlock
        });
        this.registerBlock("bar-chart", {
            blockClass: Personetics.teaser.D3BarChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                columnChartOptions: {
                    maxBarHeight: 35,
                    svgHeight: 71,
                    svgWidth: 280,
                    barTop: 10,
                    xAxisTop: 54,
                    yAxisLineDisplay: false,
                    yAxisTextDisplay: false,
                    yAxisTop: 10,

                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,//spacing variable
                        transY: 10
                    },
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: -10
                    },
                    rectangles: {
                        width: 10,
                        space: 34,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        marginFromBottom: 15,
                        marginFromLeft: 0,
                        gradients: [{
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }],
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: false
                        }
                    }
                },
                columnChartAndBoxOptions:{
                    maxBarHeight: 60, 
                    svgHeight: 95,
                    svgWidth: 187,
                    barTop: 18.8,
                    xAxisTop: 0,
                    yAxisHeight: 128,
                    yAxisLineDisplay: false,
                    yAxisTextDisplay: false,
                    yAxisTop: 0,

                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,//spacing variable
                        transY: 10
                    },
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: -10
                    },
                    rectangles: {
                        width: 7,
                        space: 20,
                        borderRadius: {
                            rx: 3,
                            ry: 3
                        },
                        marginFromBottom: 15,
                        marginFromLeft: 0,
                        gradients: [{
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }],
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: false
                        }
                    }
                },
                columnChartMultiSeriesOptions: {
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 34,
                        right: 24,
                        bottom: 72,
                        left: 24
                    },
                    totalHeight: 220,

                    labels: {
                        drawLabels: true,
                        marginTop: -16,
                        marginBottom: 4,
                        right: 3
                    },
                    rectangles: {
                        width: 9,
                        paddingTop: 30,
                        paddingLeft: -19,
                        paddingRight: 22,
                        paddingBottom: 33,
                        seriesPadding: 12.5,
                        transX: 4,
                        minHeight: 0.25,
                        borderRadius: {
                            rx: 4,
                            ry: 4
                        },
                        marginFromBottom: 5,
                        gradients: {
                            selectedInGradient: {
                                id: "selectedInGradient",
                                offset: ["0%","100%"],
                                stopColors:["#7193e2","#485f96"]
                            },
                            selectedOutGradient: {
                                id: "selectedOutGradient",
                                offset: ["0%","100%"],
                                stopColors:["#ffcc00","#ffb80a"]
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        translation: {
                            x: 2.5,
                            y: "height"
                        },
                        xAxis: {
                            hide: false,
                            tickPadding: 10,
                            minimizedPadding: {
                                top: 22,
                                bottom: 15
                            }
                        },
                        yAxis: {
                            hide: true
                        }
                    }
                },
                barChartOptions: {
                    chartHeight: 71,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 19,
                        right: 20,
                        bottom: 0,
                        left: 20

                    },
                    drawLine:false,
                    drawLabels: false,
                    rectangles: {
                        height: 4.8,//height for iphone 5 screen TODO - remove this height from configs
                        color: "rgba(169, 167, 167, 1)",
                        paddingTop: -22,//?
                        paddingLeft: 35,
                        paddingBottom: 5,
                        seriesPadding: 5,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        gradients: {
                            selectedInGradient: {
                                id: "selectedInGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#2c375f",
                                stopColor2: "#2c375f"
                            },
                            selectedOutGradient: {
                                id: "selectedOutGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#d8275d",
                                stopColor2: "#d8275d"
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        }
                    },
                    labels: {
                        paddingLeft: 40,
                        minWidth: 100
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: true
                        },
                        yAxis: {
                            hide: false,
                            paddingRight: 10,
                            transValue: -20
                        }
                    }
                },
                singleHorizontalChartOptions: {
                    chartHeight: 100,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 10,
                        right: 12,
                        bottom: 12,
                        left: 5

                    },
                    drawLabels: false,
                    rectangles: {
                        height: 7,
                        color: "rgba(169, 167, 167, 1)",
                        borderRadius: {
                            rx: 4,
                            ry: 4
                        },
                        groupMargins: {

                            //   It's possible to use negative values
                            top: -3.5,
                            left: 35
                        },
                        gradients: {
                            selectedGradient: {
                                id: "selectedGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#6888d2",
                                stopColor2: "#536fb1"
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        }
                    },
                    labels: {
                        paddingLeft: 40,
                        minWidth: 100
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: true
                        },
                        yAxis: {
                            hide: false
                        }
                    }
                },
                barGraphPalette: ['url(#selectedOutGradient)', 'url(#selectedInGradient)'],
                // barGraphPalette: function(mode){
                //     var palette;
                //     if (mode == 'In'){
                //         palette = ['url(#selectedOutGradient)', 'url(#selectedInGradient)'];
                //     } else {
                //         palette = [ 'url(#selectedInGradient)', 'url(#selectedOutGradient)'];
                //     }
                //     return palette;
                // },
                barGraphLabelsPalette: ['rgba(40, 36, 37, 1)', 'rgba(84, 113, 180, 1)'],
                multiVerticalPalette: ['url(#selectedGradient)', 'rgba(215, 215, 215, 1)'],
                multiVerticalLabelsPalette: ['rgba(147, 145, 149, 1)', 'rgba(40, 36, 37, 1)'],
                columnGraphPalette: ['#5D68C2', '#3B49B6', '#1729AF', '#111F88', '#08176C'],
                barChartMultiSeriesLabels: function (labels) {
                    return function () {
                        if (labels && labels.length > 0) {
                            var label = labels[this.series.index];
                            return ("<span class='" + this.series.name + "'>" + label + "</span>");
                        }
                        else {
                            return "";
                        }
                    }
                }
            }
        });
        this.registerBlock("new-bar-chart", {
            blockClass: Personetics.teaser.BarChartBlock,
            defaultConfig:{
                vertical:{
                    'height': 0.0492,//via simply 45 /568
                    'marginBetweenBars':4.6,// in percent
                    'amountAnimationDuration': 1500,
                    'minBarHeight': 0.0125//4
                },
                multiVertical:{
                    'height': 0.0968,//via simply 55 /568
                    'marginBetweenBars':4.8,// in percent
                    'tooltipJMarginBottom': 15,
                    'amountAnimationDuration': 1500,
                    'minBarHeight': 0.0125//4
                }
            }
        });
        this.registerBlock("multiVertical-bar-chart", {
            blockClass: Personetics.teaser.D3BarChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                columnChartOptions: {
                    maxBarHeight: 35,
                    svgHeight: 71,
                    svgWidth: 280,
                    barTop: 10,
                    xAxisTop: 54,
                    yAxisLineDisplay: false,
                    yAxisTextDisplay: false,
                    yAxisTop: 10,

                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,//spacing variable
                        transY: 10
                    },
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: -10
                    },
                    rectangles: {
                        width: 10,
                        space: 34,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        marginFromBottom: 15,
                        marginFromLeft: 0,
                        gradients: [{
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }],
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: false
                        }
                    }
                },
                columnChartAndBoxOptions:{
                    maxBarHeight: 60,
                    svgHeight: 95,
                    svgWidth: 187,
                    barTop: 18.8,
                    xAxisTop: 0,
                    yAxisHeight: 128,
                    yAxisLineDisplay: false,
                    yAxisTextDisplay: false,
                    yAxisTop: 0,

                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,//spacing variable
                        transY: 10
                    },
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: -10
                    },
                    rectangles: {
                        width: 7,
                        space: 20,
                        borderRadius: {
                            rx: 3,
                            ry: 3
                        },
                        marginFromBottom: 15,
                        marginFromLeft: 0,
                        gradients: [{
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }],
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: false
                        }
                    }
                },
                columnChartMultiSeriesOptions: {
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 34,
                        right: 24,
                        bottom: 72,
                        left: 24
                    },
                    totalHeight: 220,

                    labels: {
                        drawLabels: true,
                        marginTop: -16,
                        marginBottom: 4,
                        right: 3
                    },
                    rectangles: {
                        width: 9,
                        paddingTop: 30,
                        paddingLeft: -19,
                        paddingRight: 22,
                        paddingBottom: 33,
                        seriesPadding: 12.5,
                        transX: 4,
                        minHeight: 0.25,
                        borderRadius: {
                            rx: 4,
                            ry: 4
                        },
                        marginFromBottom: 5,
                        gradients: {
                            selectedInGradient: {
                                id: "selectedInGradient",
                                offset: ["0%","100%"],
                                stopColors:["#7193e2","#485f96"]
                            },
                            selectedOutGradient: {
                                id: "selectedOutGradient",
                                offset: ["0%","100%"],
                                stopColors:["#ffcc00","#ffb80a"]
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        translation: {
                            x: 2.5,
                            y: "height"
                        },
                        xAxis: {
                            hide: false,
                            tickPadding: 10,
                            minimizedPadding: {
                                top: 22,
                                bottom: 15
                            }
                        },
                        yAxis: {
                            hide: true
                        }
                    }
                },
                barChartOptions: {
                    chartHeight: 71,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 19,
                        right: 20,
                        bottom: 0,
                        left: 20

                    },
                    drawLine:false,
                    drawLabels: false,
                    rectangles: {
                        height: 4.8,//height for iphone 5 screen TODO - remove this height from configs
                        color: "rgba(169, 167, 167, 1)",
                        paddingTop: -22,//?
                        paddingLeft: 35,
                        paddingBottom: 5,
                        seriesPadding: 5,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        gradients: {
                            selectedInGradient: {
                                id: "selectedInGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#2c375f",
                                stopColor2: "#2c375f"
                            },
                            selectedOutGradient: {
                                id: "selectedOutGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#d8275d",
                                stopColor2: "#d8275d"
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        }
                    },
                    labels: {
                        paddingLeft: 40,
                        minWidth: 100
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: true
                        },
                        yAxis: {
                            hide: false,
                            paddingRight: 10,
                            transValue: -20
                        }
                    }
                },
                singleHorizontalChartOptions: {
                    chartHeight: 100,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 10,
                        right: 12,
                        bottom: 12,
                        left: 5

                    },
                    drawLabels: false,
                    rectangles: {
                        height: 7,
                        color: "rgba(169, 167, 167, 1)",
                        borderRadius: {
                            rx: 4,
                            ry: 4
                        },
                        groupMargins: {

                            //   It's possible to use negative values
                            top: -3.5,
                            left: 35
                        },
                        gradients: {
                            selectedGradient: {
                                id: "selectedGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#6888d2",
                                stopColor2: "#536fb1"
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        }
                    },
                    labels: {
                        paddingLeft: 40,
                        minWidth: 100
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: true
                        },
                        yAxis: {
                            hide: false
                        }
                    }
                },
                barGraphPalette: ['url(#selectedOutGradient)', 'url(#selectedInGradient)'],
                // barGraphPalette: function(mode){
                //     var palette;
                //     if (mode == 'In'){
                //         palette = ['url(#selectedOutGradient)', 'url(#selectedInGradient)'];
                //     } else {
                //         palette = [ 'url(#selectedInGradient)', 'url(#selectedOutGradient)'];
                //     }
                //     return palette;
                // },
                barGraphLabelsPalette: ['rgba(40, 36, 37, 1)', 'rgba(84, 113, 180, 1)'],
                multiVerticalPalette: ['url(#selectedGradient)', 'rgba(215, 215, 215, 1)'],
                multiVerticalLabelsPalette: ['rgba(147, 145, 149, 1)', 'rgba(40, 36, 37, 1)'],
                columnGraphPalette: ['#5D68C2', '#3B49B6', '#1729AF', '#111F88', '#08176C'],
                barChartMultiSeriesLabels: function (labels) {
                    return function () {
                        if (labels && labels.length > 0) {
                            var label = labels[this.series.index];
                            return ("<span class='" + this.series.name + "'>" + label + "</span>");
                        }
                        else {
                            return "";
                        }
                    }
                }
            }
        });
        this.registerBlock("pie-chart", {
            blockClass: Personetics.teaser.NewPieChartBlockProduct,
            defaultConfig: {
                pieGraphPalette: function (selectedTabId) {
                    var outFlowsPalette = ['#d8275d'];
                    var inFlowsPalette = ['#2c375f'];
                    if (selectedTabId == "Out")
                        return outFlowsPalette;
                    return inFlowsPalette;
                },
                pieGrayColors : function(){
                    return ["#ededed", "#d5d6d7", "#dfe0e2", "#ededed", "#dfe0e2", "#d5d6d7", "#dfe0e2"];
                },
                pieOptions: {
                    arcs: {
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        cornerRadius: {
                            radiusCorner: 0
                        },
                    },
                    centerText: {
                        fontSize: 10,
                        fontWeight: 300,
                        color: '#000033'
                    },
                    showInfoContainer: false
                }
            }
        });
        this.registerBlock("arc-chart", {
            blockClass: Personetics.teaser.PieChartBlockProduct,
            defaultConfig: {
                pieGraphPalette: function (selectedTabId) {
                    if (selectedTabId == "Out")
                        return ['#ffce40', '#ffb608', '#ff9819', '#fe7d3f', '#f9652b', '#df4c3a', '#c72735'];
                    return ['#6787d1', '#027ac4', '#7390c5', '#3095bd', '#45a5d3', '#5acafa', '#95dafb'];
                },
                pieOptions: {
                    arcs: {
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        cornerRadius: {
                            radiusCorner: 9
                        },
                    },
                    centerText: {
                        fontSize: 15,
                        fontWeight: 300
                    },
                    showInfoContainer: false
                }
            }
        });
        this.registerBlock("pin-chart", {
            blockClass: Personetics.teaser.D3PinGraphChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                pinGraphChartOptions: {
                    svgHeight: 72,
                    svgWidth: 280,
                    maxBarHeight: 35,
                    labelTop: 0,
                    barTop: 10,
                    xAxisTop: 55,
                    yAxisHeight: 0,
                    yAxisTop: 0,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,
                        transY: 10
                    },
                    totalHeight: 220,
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: 4.5
                    },
                    rectangles: {
                        width: 9,
                        space: 40,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        gradients: {
                            selectedGradient: {
                                id: "selectedGradient",
                                offset: ["0%", "100%"],
                                stopColors: ["#6888d2", "#536fb1"]
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        translation: {
                            x: 0,
                            y: "height"
                        },
                        xAxis: {
                            hide: false,
                            tickPadding: 10,
                            collapsedPadding: {
                                top: 22,
                                bottom: 15
                            }
                        },
                        yAxis: {
                            x: 0,
                            y: 0,
                            hide: true
                        }
                    }
                }
            }
        });
        this.registerBlock("pin-graph", {
            blockClass: Personetics.teaser.D3PinGraphChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                pinGraphChartOptions: {
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 35,
                        right: 20,
                        bottom: 40,
                        left: 15
                    },
                    height: 102,
                    chart: {
                        transX: 0,
                        transY: 0
                    },
                    totalHeight: 102,
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: 4.5,
                        marginRight: 5
                    },
                    rectangles: {
                        minHeightPercent: 0.15,
                        width: 8,
                        borderRadius: {
                            rx: 3,
                            ry: 3
                        },
                        marginFromBottom: 10,
                        marginFromLeft: 0,
                        gradients: {
                            selectedGradient: {
                                id: "selectedGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#6888d2",
                                stopColor2: "#536fb1"
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        translation: {
                            x: 0,
                            y: "height"
                        },
                        xAxis: {
                            hide: false,
                            tickPadding: 8,
                            minimizedPadding: {
                                top: 22,
                                bottom: 15,
                                fontSize: 12,
                                fontWeight: 300,
                                color: '#A94F48'
                            },
                            fontSize: 12,
                            fontWeight: 300,
                            color: '#000'
                        },
                        yAxis: {
                            hide: true,
                            x: 0,
                            y: 0,
                            fontSize: 0,
                            fontWeight: 0,
                            color: '#000'
                        }
                    }
                }
            }
        });
        this.registerBlock("new-pin-chart", {
            blockClass: Personetics.teaser.PinGraphChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                pinGraphChartOptions: {
                    maxWidthBarPercent: 91,
                    pinChartHeight: 0.1232 //0.32 = 182 (sympli value) / 568 (window height)
                }
            }
        });
        this.registerBlock("new-pin-graph", {
            blockClass: Personetics.teaser.PinGraphChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                pinGraphChartOptions: {
                    maxWidthBarPercent: 91,
                    pinChartHeight: 0.1232 //0.32 = 182 (sympli value) / 568 (window height)
                }
            }
        });
        this.registerBlock("line-chart",{
            blockClass: Personetics.teaser.NewlineChartBlock,
            defaultConfig: {
                lineChartOptions:{
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    //general
                    svgHeight: 71,
                    svgWidth:280,
                    //line
                    line_left: 5,
                    line_top: 14,
                    line_width:256,
                    line_height:40,
                    //line area
                    area_display: false,
                    //line style
                    lineStyle_interpolate:'cardinal',//cardinal/linear/monotone
                    lineStyle_thickness: 3,
                    //x axis
                    xAxis_display: false,
                    //y axis
                    yAxis_display: false,				
                    //transition
                    duration: 2000,
                    //dots
                    dots_radius:3.5,
                    dots_radius_selected:4.5,
                    //labels
                    labels_display: false,
                    //horizonalLine
                    horizonalLine_display:false,
        
                    highlightBy: 'last',	// defines the criteria for style dots as selected dot, there are 4 options - max/min/first/last(default).
                    dotRect:{
                        height: 19,
                        yOffset: 35,
                        radiusX: 20,
                        radiusY: 10
                    },
                    dotText:{
                        yOffset: 21,
                        paddingLeft: 7.5,
                        paddingRight: 7.5
                    },
                    dotPolygon:{
                        yOffset: 30,
                        points: "20,10 10,10 15,20"
                    }
                },
                lineChartPalette: ['rgba(169, 167, 167, 1)']
            }
        });
        this.registerBlock("h-box", {
            blockClass: Personetics.teaser.HBoxBlock
        });
        this.registerBlock("tranList", {
            blockClass: Personetics.teaser.Transactions
        });
    };

    SkinSetup.prototype.registerDefaultChartHeplers = function registerDefaultChartHeplers() {
        this.registerChartHelper("verticalHelper", {
            helperClass:Personetics.utils.d3Helpers.VerticalChartHelper
        });
        this.registerChartHelper("horizontalHelper", {
            helperClass:Personetics.utils.d3Helpers.HorizontalChartHelper
        });
        this.registerChartHelper("multiVerticalHelper", {
            helperClass:Personetics.utils.d3Helpers.MultiVerticalChartHelper
        });
        this.registerChartHelper("multiHorizontalHelper", {
            helperClass:Personetics.utils.d3Helpers.MultiHorizontalChartHelper
        });
        this.registerChartHelper("pinGraphHelper", {
            helperClass:Personetics.utils.d3Helpers.PinGraphChartHelper
        });
        //temporary call story registerChartHelper.
        Personetics.story.BlockChartFactory.registerChartHelper("lineChartHelper", {
            helperClass:Personetics.utils.d3Helpers.NewLineChartHelper
        });
    };

    SkinSetup.prototype.getTeasersConfig = function getTeasersConfig(){
        var config = {
            showArrows: false,
            minItemsForDisplayingArrows: 2,
            infiniteCarousel: true,
            numItemsDispaly: 3,
            showIndexDots: true,
            nextArrowDir: "rtl"
        }
        return config;
    };

    SkinSetup.prototype.getTeasersConfigDesktop = function getTeasersConfigDesktop(){
        var config = {
            showArrows: true,
            minItemsForDisplayingArrows: 2,
            infiniteCarousel: true,
            numItemsDispaly: 1,
            showIndexDots: true,
            nextArrowDir: "rtl"
        }
        return config;
    };

    /*SkinSetup.prototype.registerTemplates = function registerTemplates() {
        var loader = new HandlebarTemplateLoader("../skins/templates/");
        loader.load("simpleText", "simple-teaser");
        loader.load("image", "image-teaser");
        loader.load("verticalBar", "bar-teaser");
        loader.load("horizontalBarAndBox", "compare-box-teaser");
        loader.load("pinChart", "bar-teaser");
        loader.load("pie", "pies-teaser");
        loader.load("textAndButton", "buttons-teaser");
        loader.load("imageAndBox", "image-box-teaser");
        loader.load("verticalBarAndBox", "bar-box-teaser");
        loader.load("doubleBox", "double-box-teaser");
        loader.load("horizontalBar", "bar-teaser");

        loader.loadPartial("teaserHeader", "teaser-header-partial");
        loader.loadPartial("teaserWrapperPartial", "teaser-wrapper-partial");
    };*/



    window.SkinSetup = SkinSetup;

})(window, window.Personetics = window.Personetics || {}, jQuery);

(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.NewPieChartBlockProduct = Personetics.teaser.NewPieChartBlock.extend({

        beforeRender: function beforeRender(el, layoutInstructions){
            Personetics.teaser.PieChartBlock.prototype.beforeRender.call(this, el, layoutInstructions);

            //get selected tab from previous dialogs for change pie colors in outflows case
            var previousDialogs = el.parents('.pstory-dialog-frame').prev('.pstory-dialog-frame' );
            var tabsBlock = previousDialogs.find('.pstory-block-tabs');
            var selectedTab = tabsBlock.find('.pstory-button.selected');
            var selectedTabId = selectedTab.attr("pstory-id");
            this.colors = d3.scale.ordinal().range(this.getGraphPalette(selectedTabId));
            this.grayColors = d3.scale.ordinal().range(this.getGreyColors());
        },
        getGraphPalette: function (selectedTabId) {
            return this.defaultConfig.pieGraphPalette(selectedTabId);
        },
        getGreyColors: function(){
            return this.defaultConfig.pieGrayColors();
        },
        /**pie beforeRender definations */
        /**render svg base and base attributes */
        renderPieBase: function renderPieBase(el){
            Personetics.teaser.PieChartBlock.prototype.renderPieBase.call(this, el);
            this.renderGrayFilter();
        },

        renderGrayFilter: function renderGrayFilter() {
            this.svg.append("filter")
                .attr("id", this.grayscaleId)
                .append("feColorMatrix")
                .attr("type", "matrix")
                .attr("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0")
        },
        /**render the pie */
        renderArcs: function (layoutInstructions) {
            var block = this;
            Personetics.teaser.PieChartBlock.prototype.renderArcs.call(this, layoutInstructions);
            var arcs = this.frameEl.find('.pstory-pie-chart svg .perso-arc path');
            $.each(arcs, function(i, arc){
                d3.select(arc).style("fill", function(d) { return block.grayColors(d.data.category); })
            });
        },
        /**afterRender functions */
        afterRender: function(el){
            var block = this;
            //save path orders, to keep them the same
            block.arcPaths = block.frameEl.find('.pstory-pie-chart svg .perso-arc path');
            var defaultPath = this.frameEl.find('.pstory-pie-chart svg .perso-arc path.perso-selected')[0];
            var defaultPathIndex = this.getSelectedPathIndex(block.arcPaths);
            d3.select(defaultPath)
                .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                .style("filter", "")
                .style("fill", function (d, i) {
                    return block.colors(defaultPathIndex);
                });

            //move the arc path to front
            d3.select(defaultPath).moveToFront();
            //set default values in pie info container
            var selected = this.layoutInstructions.slices[this.getSelectedPathIndex(block.arcPaths)];
            block.updatePieInfoValues(selected);
            if(this.layoutInstructions.slices.length > 1){
                this.frameEl.find('.pstory-pie-data .pstory-arrow').show();
            }
            else{
                this.frameEl.find('.pstory-pie-data .pstory-arrow').hide();
            }

            //Highlight center text with slice color
            block.highlightCenterText(block.defaultConfig.pieOptions.centerText.color);
        },
        /**events functions */
        bindEvents: function(){
            var block = this;
            var $nextArrow = this.frameEl.find('.pstory-next-arrow');
            var $previousArrow = this.frameEl.find('.pstory-previous-arrow');
            var $paths = block.arcPaths;
            $nextArrow .bind('click', function (e) {
                if(block.frameEl.hasClass('perso-minimized')){
                    return;//disable click on minimize
                }
                var currentItemIndex = block.getSelectedPathIndex($paths);
                if(currentItemIndex == ($paths.length - 1)){
                    block.moveArcs(0);
                    block.handleClick(block.layoutInstructions.slices[0],0);
                } else {
                    block.moveArcs(++currentItemIndex);
                    block.handleClick(block.layoutInstructions.slices[currentItemIndex], currentItemIndex);
                }
            });

            $previousArrow.bind('click', function (e) {
                if(block.frameEl.hasClass('perso-minimized')){
                    return;//disable click on minimize
                }
                var currentItemIndex = block.getSelectedPathIndex($paths);
                if(currentItemIndex == 0){
                    block.moveArcs($paths.length - 1);
                    block.handleClick(block.layoutInstructions.slices[$paths.length - 1], $paths.length - 1)
                } else {
                    block.moveArcs(--currentItemIndex);
                    block.handleClick(block.layoutInstructions.slices[currentItemIndex], currentItemIndex);
                }
            });
        },
        onPieItemClick: function onPieItemClick(obj, clickedItemIndex, clickedItem){
            var block = this;
            var oldSelectedArc = $('.perso-arc path.perso-selected');
            var grayscaleId = this.grayscaleId;
            /**set the old selected path*/
            if (oldSelectedArc.length) {
                oldSelectedArc[0].className.baseVal= Personetics.utils.string.removeClass(oldSelectedArc[0].className,'perso-selected');
                d3.select(oldSelectedArc[0])
                    .attr("d", block.arc)
                    .style("filter", "url(#" + grayscaleId + ")");
            }

            d3.select(clickedItem)
                .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                .attr("class", "perso-selected")
                .style("filter", "")
                .style("fill", function (d, i) {
                    return block.colors(i);
                });
            d3.select(clickedItem).moveToFront();
            this.handleClick(obj, clickedItemIndex);
            this.updatePieInfoValues(obj.data);
        },
        updatePieInfoValues: function(obj){
            if(this.options.showInfoContainer) {
                var block = this;
                if (obj) {
                    var amountDiv = '<div class="pstory-pie-amount"><span>' + obj.label + '</span></div>';
                    var categoryDiv = '<div class="pstory-pie-category"><span>' + obj.category + '</span></div>';

                    var $infoContainer = this.frameEl.find('.pstory-pie-info');
                    $infoContainer.empty();
                    $infoContainer.append(amountDiv);
                    $infoContainer.append(categoryDiv);

                    //set color from Palette
                    $('.pstory-pie-amount').css('color', block.colors(obj.category))
                }
            }
        },
        // this function move the selected arc to next/prev when click on arrows
        moveArcs: function(index){
            var block = this
            var path = block.arcPaths[index];
            var oldSelectedArc = $('.perso-arc path.perso-selected');
            var grayscaleId = this.grayscaleId;
            var prevIndex = this.getSelectedIndex();
            if(path){
                if(index !== prevIndex){
                    var prevPath = block.arcPaths[prevIndex];
                    d3.select(prevPath)
                        .attr("d", block.arc)
                        .style("filter", filter)
                        .attr("class","")
                }

                d3.select(path)
                    .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                    .attr("class", "perso-selected")
                    .style("filter", "")
                    .style("fill", function (d, i) {
                        return block.colors(i);
                    });
                d3.select(path).moveToFront();

                //set default values in pie info container
                block.updatePieInfoValues(block.layoutInstructions.slices[index]);
                this.setSelectedIndex(index);
            }
        },

        highlightCenterText: function(color){
            var block = this;
            var centerTextElem = block.frameEl.find('.perso-total-txt')[0];
            d3.select(centerTextElem)
                .style('fill',color);
        },
        /**minimized animation */
        doScrollEvent:function(){
            this.minimized = typeof this.minimized != 'undefined' ? this.minimized : {};

            var heightPrevFixedElements= 0;
            var prevMinimized = $('.perso-minimized:not(.pstory-block-pie-chart)').last().find('.pstory-block-container');
            if(prevMinimized.length > 0){
                var prevMinimizedTop = prevMinimized.offset().top;
                var prevMinimizedHeight = parseFloat(prevMinimized.outerHeight(true));
                heightPrevFixedElements = prevMinimizedTop + prevMinimizedHeight;
            }
            this.minimized.heightPrevFixedElements = heightPrevFixedElements;
            this.minimized.prevMinimized = prevMinimized;
            this.minimized.elementDisplayed = this.frameEl.find('.pstory-pie-data');

            var offsetElement = this.minimized.elementDisplayed.offset();
            if(typeof this.minimized.isMinimized  != 'undefined'
                && this.minimized.isMinimized == true
                && this.frameEl.offset().top +15>= this.minimized.topFixedContainer ){/**15 is frameEl padding should check if required */
            this.minimized.isMinimized = false;
                this.unMinimized();
            }
            else if(offsetElement.top <= this.minimized.heightPrevFixedElements){
                if(typeof this.minimized.isMinimized  == 'undefined' || this.minimized.isMinimized == false){
                    this.minimized.isMinimized = true;
                    this.doMinimized();
                }
            }
        },
        doMinimized: function(){
            var fixedContainer = this.frameEl.find('.pstory-block-container');/**the fixed element */

            var marginRight = this.frameEl.css('margin-right');
            var marginLeft = this.frameEl.css('margin-left');
            fixedContainer.css({'padding-right': marginRight, 'padding-left': marginLeft});/**change margin to padding for background */

            this.frameEl.height(this.frameEl.outerHeight());/**save the wrapper height */
            /**the fixedContainer top */
            var elementHeight = this.minimized.elementDisplayed.outerHeight();//height of the showing element
            var topFixedContainer = elementHeight - fixedContainer.outerHeight() + this.minimized.heightPrevFixedElements;
            this.minimized.topFixedContainer = topFixedContainer;
            fixedContainer.css({'top': topFixedContainer + 'px'});
            /**z-index */
            var zIndex = 999;
            var prevMinimized = this.minimized.prevMinimized;
            if(prevMinimized.length > 0)
                zIndex = prevMinimized.css('z-index') -1;
            fixedContainer.css({'z-index': zIndex});
            /** */
            this.frameEl.removeClass('perso-unMinimized');
            this.frameEl.addClass('perso-minimized');
        },
        unMinimized: function(){
            this.frameEl.removeClass('perso-minimized');
            this.frameEl.addClass('perso-unMinimized');
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var d3 = Personetics.persoD3 || window.d3;
    Personetics.teaser = Personetics.teaser || {};
    Personetics.teaser.PieChartBlockProduct = Personetics.teaser.PieChartBlock.extend({

        beforeRender: function beforeRender(el, layoutInstructions){
            Personetics.teaser.PieChartBlock.prototype.beforeRender.call(this, el, layoutInstructions);

            //get selected tab from previous dialogs for change pie colors in outflows case
            var previousDialogs = el.parents('.pstory-dialog-frame').prev('.pstory-dialog-frame' );
            var tabsBlock = previousDialogs.find('.pstory-block-tabs');
            var selectedTab = tabsBlock.find('.pstory-button.selected');
            var selectedTabId = selectedTab.attr("pstory-id");
            this.colors = d3.scale.ordinal().range(this.getGraphPalette(selectedTabId));
        },
        getGraphPalette: function (selectedTabId) {
            return this.defaultConfig.pieGraphPalette(selectedTabId);
        },
        /**pie beforeRender definations */
        /**render svg base and base attributes */
        renderPieBase: function renderPieBase(el){
            Personetics.teaser.PieChartBlock.prototype.renderPieBase.call(this, el);
            this.renderGrayFilter();
        },

        renderGrayFilter: function renderGrayFilter() {
            this.svg.append("filter")
                .attr("id", this.grayscaleId)
                .append("feColorMatrix")
                .attr("type", "matrix")
                .attr("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0")
        },
        /**render the pie */
        renderArcs: function (layoutInstructions) {
            Personetics.teaser.PieChartBlock.prototype.renderArcs.call(this, layoutInstructions);
            var arcs = this.frameEl.find('.pstory-pie-chart svg .perso-arc path');
            var grayscaleId = this.grayscaleId;
            $.each(arcs, function(i, arc){
                d3.select(arc).style("filter", "url(#" + grayscaleId + ")");
            });
        },
        /**afterRender functions */
        afterRender: function(el){
            var block = this;
            //save path orders, to keep them the same
            block.arcPaths = block.frameEl.find('.pstory-pie-chart svg .perso-arc path');
            var defaultPath = this.frameEl.find('.pstory-pie-chart svg .perso-arc path.perso-selected')[0];
            var defaultPathIndex = this.getSelectedPathIndex(block.arcPaths);
            d3.select(defaultPath)
                .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                .style("filter", "")
                .style("fill", function (d, i) {
                    return block.colors(defaultPathIndex);
                });

            //move the arc path to front
            d3.select(defaultPath).moveToFront();
            //set default values in pie info container
            var selected = this.layoutInstructions.slices[this.getSelectedPathIndex(block.arcPaths)];
            block.updatePieInfoValues(selected);
            if(this.layoutInstructions.slices.length > 1){
                this.frameEl.find('.pstory-pie-data .pstory-arrow').show();
            }
            else{
                this.frameEl.find('.pstory-pie-data .pstory-arrow').hide();
            }

            //Highlight center text with slice color
            block.highlightCenterText(block.colors(defaultPathIndex))   ;
        },
        /**events functions */
        bindEvents: function(){
            var block = this;
            var $nextArrow = this.frameEl.find('.pstory-next-arrow');
            var $previousArrow = this.frameEl.find('.pstory-previous-arrow');
            var $paths = block.arcPaths;
            $nextArrow .bind('click', function (e) {
                if(block.frameEl.hasClass('perso-minimized')){
                    return;//disable click on minimize
                }
                var currentItemIndex = block.getSelectedPathIndex($paths);
                if(currentItemIndex == ($paths.length - 1)){
                    block.moveArcs(0);
                    block.handleClick(block.layoutInstructions.slices[0],0);
                } else {
                    block.moveArcs(++currentItemIndex);
                    block.handleClick(block.layoutInstructions.slices[currentItemIndex], currentItemIndex);
                }
            });

            $previousArrow.bind('click', function (e) {
                if(block.frameEl.hasClass('perso-minimized')){
                    return;//disable click on minimize
                }
                var currentItemIndex = block.getSelectedPathIndex($paths);
                if(currentItemIndex == 0){
                    block.moveArcs($paths.length - 1);
                    block.handleClick(block.layoutInstructions.slices[$paths.length - 1], $paths.length - 1)
                } else {
                    block.moveArcs(--currentItemIndex);
                    block.handleClick(block.layoutInstructions.slices[currentItemIndex], currentItemIndex);
                }
            });
        },
        onPieItemClick: function onPieItemClick(obj, clickedItemIndex, clickedItem){
            var block = this;
            var oldSelectedArc = $('.perso-arc path.perso-selected');
            var grayscaleId = this.grayscaleId;
            /**set the old selected path*/
            if (oldSelectedArc.length) {
                oldSelectedArc[0].className.baseVal= Personetics.utils.string.removeClass(oldSelectedArc[0].className,'perso-selected');
                d3.select(oldSelectedArc[0])
                    .attr("d", block.arc)
                    .style("filter", "url(#" + grayscaleId + ")");
            }

            d3.select(clickedItem)
                .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                .attr("class", "perso-selected")
                .style("filter", "")
                .style("fill", function (d, i) {
                    return block.colors(i);
                });
            d3.select(clickedItem).moveToFront();
            this.handleClick(obj, clickedItemIndex);
            this.updatePieInfoValues(obj.data);
        },
        updatePieInfoValues: function(obj){
            if(this.options.showInfoContainer) {
                var block = this;
                if (obj) {
                    var amountDiv = '<div class="pstory-pie-amount"><span>' + obj.label + '</span></div>';
                    var categoryDiv = '<div class="pstory-pie-category"><span>' + obj.category + '</span></div>';

                    var $infoContainer = this.frameEl.find('.pstory-pie-info');
                    $infoContainer.empty();
                    $infoContainer.append(amountDiv);
                    $infoContainer.append(categoryDiv);

                    //set color from Palette
                    $('.pstory-pie-amount').css('color', block.colors(obj.category))
                }
            }
        },
        // this function move the selected arc to next/prev when click on arrows
        moveArcs: function(index){
            var block = this
            var path = block.arcPaths[index];
            var oldSelectedArc = $('.perso-arc path.perso-selected');
            var grayscaleId = this.grayscaleId;
            var prevIndex = this.getSelectedIndex();
            if(path){
                if(index !== prevIndex){
                    var prevPath = block.arcPaths[prevIndex];
                    d3.select(prevPath)
                        .attr("d", block.arc)
                        .style("filter", filter)
                        .attr("class","")
                }

                d3.select(path)
                    .attr("d", block.arcOver.cornerRadius(block.cornerRadiusPie))
                    .attr("class", "perso-selected")
                    .style("filter", "")
                    .style("fill", function (d, i) {
                        return block.colors(i);
                    });
                d3.select(path).moveToFront();

                //set default values in pie info container
                block.updatePieInfoValues(block.layoutInstructions.slices[index]);
                this.setSelectedIndex(index);
            }
        },

        highlightCenterText: function(color){
            var block = this;
            var centerTextElem = block.frameEl.find('.perso-total-txt')[0];
            d3.select(centerTextElem)
                .style('fill',color);
        },
        /**minimized animation */
        doScrollEvent:function(){
            this.minimized = typeof this.minimized != 'undefined' ? this.minimized : {};

            var heightPrevFixedElements= 0;
            var prevMinimized = $('.perso-minimized:not(.pstory-block-pie-chart)').last().find('.pstory-block-container');
            if(prevMinimized.length > 0){
                var prevMinimizedTop = prevMinimized.offset().top;
                var prevMinimizedHeight = parseFloat(prevMinimized.outerHeight(true));
                heightPrevFixedElements = prevMinimizedTop + prevMinimizedHeight;
            }
            this.minimized.heightPrevFixedElements = heightPrevFixedElements;
            this.minimized.prevMinimized = prevMinimized;
            this.minimized.elementDisplayed = this.frameEl.find('.pstory-pie-data');

            var offsetElement = this.minimized.elementDisplayed.offset();
            if(typeof this.minimized.isMinimized  != 'undefined'
                && this.minimized.isMinimized == true
                && this.frameEl.offset().top +15>= this.minimized.topFixedContainer ){/**15 is frameEl padding should check if required */
            this.minimized.isMinimized = false;
                this.unMinimized();
            }
            else if(offsetElement.top <= this.minimized.heightPrevFixedElements){
                if(typeof this.minimized.isMinimized  == 'undefined' || this.minimized.isMinimized == false){
                    this.minimized.isMinimized = true;
                    this.doMinimized();
                }
            }
        },
        doMinimized: function(){
            var fixedContainer = this.frameEl.find('.pstory-block-container');/**the fixed element */

            var marginRight = this.frameEl.css('margin-right');
            var marginLeft = this.frameEl.css('margin-left');
            fixedContainer.css({'padding-right': marginRight, 'padding-left': marginLeft});/**change margin to padding for background */

            this.frameEl.height(this.frameEl.outerHeight());/**save the wrapper height */
            /**the fixedContainer top */
            var elementHeight = this.minimized.elementDisplayed.outerHeight();//height of the showing element
            var topFixedContainer = elementHeight - fixedContainer.outerHeight() + this.minimized.heightPrevFixedElements;
            this.minimized.topFixedContainer = topFixedContainer;
            fixedContainer.css({'top': topFixedContainer + 'px'});
            /**z-index */
            var zIndex = 999;
            var prevMinimized = this.minimized.prevMinimized;
            if(prevMinimized.length > 0)
                zIndex = prevMinimized.css('z-index') -1;
            fixedContainer.css({'z-index': zIndex});
            /** */
            this.frameEl.removeClass('perso-unMinimized');
            this.frameEl.addClass('perso-minimized');
        },
        unMinimized: function(){
            this.frameEl.removeClass('perso-minimized');
            this.frameEl.addClass('perso-unMinimized');
        }
    });
})(window, window.Personetics = window.Personetics || {}, jQuery);
(function (window, Personetics, $, undefined) {
    var Handlebars = Personetics.UI.Handlebars;
    var SkinSetup = function SkinSetup() {
    };


    SkinSetup.prototype.init = function registerBlocks() {
        this.registerDefaultBlocks();
        this.registerDefaultChartHeplers();
        this.registerPartialTemplates();
    };

    SkinSetup.prototype.registerBlock = function (type, config) {
        Personetics.teaser.PBlockFactory.registerBlock(type, config);
    };

    SkinSetup.prototype.registerChartHelper = function (name, clazz) {
        Personetics.story.BlockChartFactory.registerChartHelper(name, clazz);
    };

    SkinSetup.prototype.registerPartialTemplates = function registerPartialTemplates() {
        var me = this;
        var partialTemplates = this.getPartialTemplates();
        partialTemplates.forEach(function (partial) {
            var partialTemplate = Handlebars.templates[partial.id];
            if (typeof partialTemplate !== "undefined" && partialTemplate !== null)
                Handlebars.registerPartial(partial.name, partialTemplate);
        });
    };
    SkinSetup.prototype.getPartialTemplates = function getPartialTemplates() {
        return [
            {
                "name": "teaserWrapperPartial",
                "id": "teaserWrapperPartial"
            },
            {
                "name": "teaserHeader",
                "id": "teaserHeader"
            }
        ];
    };

    SkinSetup.prototype.registerDefaultBlocks = function registerDefaultBlocks(type) {
        this.registerBlock("txt", {
            blockClass: Personetics.teaser.TextBlock
        });
        this.registerBlock("text", {
            blockClass: Personetics.teaser.TextBlock
        });
        this.registerBlock("date-box", {
            blockClass: Personetics.teaser.DateBoxBlock
        });
        this.registerBlock("image", {
            blockClass: Personetics.teaser.ImageBlock
        });
        this.registerBlock("bar-chart", {
            blockClass: Personetics.teaser.D3BarChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                columnChartOptions: {
                    maxBarHeight: 35,
                    svgHeight: 71,
                    svgWidth: 280,
                    svgHeightDesktop: 98,
                    svgWidthDesktop: 300,
                    barTop: 10,
                    xAxisTop: 54,
                    yAxisLineDisplay: false,
                    yAxisTextDisplay: false,
                    yAxisTop: 10,

                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,//spacing variable
                        transY: 10
                    },
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: -10
                    },
                    rectangles: {
                        width: 10,
                        space: 34,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        marginFromBottom: 15,
                        marginFromLeft: 0,
                        gradients: [{
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }],
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: false
                        }
                    }
                },
                columnChartAndBoxOptions:{
                    maxBarHeight: 60,
                    svgHeight: 95,
                    svgWidth: 187,
                    barTop: 18.8,
                    xAxisTop: 0,
                    yAxisHeight: 128,
                    yAxisLineDisplay: false,
                    yAxisTextDisplay: false,
                    yAxisTop: 0,

                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,//spacing variable
                        transY: 10
                    },
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: -10
                    },
                    rectangles: {
                        width: 7,
                        space: 20,
                        borderRadius: {
                            rx: 3,
                            ry: 3
                        },
                        marginFromBottom: 15,
                        marginFromLeft: 0,
                        gradients: [{
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }],
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: false
                        }
                    }
                },
                columnChartMultiSeriesOptions: {
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 34,
                        right: 24,
                        bottom: 72,
                        left: 24
                    },
                    totalHeight: 220,

                    labels: {
                        drawLabels: true,
                        marginTop: -16,
                        marginBottom: 4,
                        right: 3
                    },
                    rectangles: {
                        width: 9,
                        paddingTop: 30,
                        paddingLeft: -19,
                        paddingRight: 22,
                        paddingBottom: 33,
                        seriesPadding: 12.5,
                        transX: 4,
                        minHeight: 0.25,
                        borderRadius: {
                            rx: 4,
                            ry: 4
                        },
                        marginFromBottom: 5,
                        gradients: {
                            selectedInGradient: {
                                id: "selectedInGradient",
                                offset: ["0%","100%"],
                                stopColors:["#7193e2","#485f96"]
                            },
                            selectedOutGradient: {
                                id: "selectedOutGradient",
                                offset: ["0%","100%"],
                                stopColors:["#ffcc00","#ffb80a"]
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        translation: {
                            x: 2.5,
                            y: "height"
                        },
                        xAxis: {
                            hide: false,
                            tickPadding: 10,
                            minimizedPadding: {
                                top: 22,
                                bottom: 15
                            }
                        },
                        yAxis: {
                            hide: true
                        }
                    }
                },
                barChartOptions: {
                    chartHeight: 71,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 19,
                        right: 20,
                        bottom: 0,
                        left: 20

                    },
                    drawLine:false,
                    drawLabels: false,
                    rectangles: {
                        height: 4.8,//height for iphone 5 screen TODO - remove this height from configs
                        color: "rgba(169, 167, 167, 1)",
                        paddingTop: -22,//?
                        paddingLeft: 35,
                        paddingBottom: 5,
                        seriesPadding: 5,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        gradients: {
                            selectedInGradient: {
                                id: "selectedInGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#2c375f",
                                stopColor2: "#2c375f"
                            },
                            selectedOutGradient: {
                                id: "selectedOutGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#d8275d",
                                stopColor2: "#d8275d"
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        }
                    },
                    labels: {
                        paddingLeft: 40,
                        minWidth: 100
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: true
                        },
                        yAxis: {
                            hide: false,
                            paddingRight: 10,
                            transValue: -20
                        }
                    }
                },
                singleHorizontalChartOptions: {
                    chartHeight: 100,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 10,
                        right: 12,
                        bottom: 12,
                        left: 5

                    },
                    drawLabels: false,
                    rectangles: {
                        height: 7,
                        color: "rgba(169, 167, 167, 1)",
                        borderRadius: {
                            rx: 4,
                            ry: 4
                        },
                        groupMargins: {

                            //   It's possible to use negative values
                            top: -3.5,
                            left: 35
                        },
                        gradients: {
                            selectedGradient: {
                                id: "selectedGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#6888d2",
                                stopColor2: "#536fb1"
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        }
                    },
                    labels: {
                        paddingLeft: 40,
                        minWidth: 100
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: true
                        },
                        yAxis: {
                            hide: false
                        }
                    }
                },
                barGraphPalette: ['url(#selectedOutGradient)', 'url(#selectedInGradient)'],
                // barGraphPalette: function(mode){
                //     var palette;
                //     if (mode == 'In'){
                //         palette = ['url(#selectedOutGradient)', 'url(#selectedInGradient)'];
                //     } else {
                //         palette = [ 'url(#selectedInGradient)', 'url(#selectedOutGradient)'];
                //     }
                //     return palette;
                // },
                barGraphLabelsPalette: ['rgba(40, 36, 37, 1)', 'rgba(84, 113, 180, 1)'],
                multiVerticalPalette: ['url(#selectedGradient)', 'rgba(215, 215, 215, 1)'],
                multiVerticalLabelsPalette: ['rgba(147, 145, 149, 1)', 'rgba(40, 36, 37, 1)'],
                columnGraphPalette: ['#5D68C2', '#3B49B6', '#1729AF', '#111F88', '#08176C'],
                barChartMultiSeriesLabels: function (labels) {
                    return function () {
                        if (labels && labels.length > 0) {
                            var label = labels[this.series.index];
                            return ("<span class='" + this.series.name + "'>" + label + "</span>");
                        }
                        else {
                            return "";
                        }
                    }
                }
            }
        });
        this.registerBlock("new-bar-chart", {
            blockClass: Personetics.teaser.BarChartBlock,
            defaultConfig:{
                vertical:{
                    'height': 0.0492,//via simply 45 /568
                    'marginBetweenBars':4.6,// in percent
                    'amountAnimationDuration': 1500,
                    'minBarHeight': 0.0125//4
                },
                multiVertical:{
                    'height': 0.0968,//via simply 55 /568
                    'marginBetweenBars':4.8,// in percent
                    'tooltipJMarginBottom': 15,
                    'amountAnimationDuration': 1500,
                    'minBarHeight': 0.0125//4
                }
            }
        });
        this.registerBlock("multiVertical-bar-chart", {
            blockClass: Personetics.teaser.D3BarChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                columnChartOptions: {
                    maxBarHeight: 35,
                    svgHeight: 71,
                    svgWidth: 280,
                    barTop: 10,
                    xAxisTop: 54,
                    yAxisLineDisplay: false,
                    yAxisTextDisplay: false,
                    yAxisTop: 10,

                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,//spacing variable
                        transY: 10
                    },
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: -10
                    },
                    rectangles: {
                        width: 10,
                        space: 34,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        marginFromBottom: 15,
                        marginFromLeft: 0,
                        gradients: [{
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }],
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: false
                        }
                    }
                },
                columnChartAndBoxOptions:{
                    maxBarHeight: 60,
                    svgHeight: 95,
                    svgWidth: 187,
                    barTop: 18.8,
                    xAxisTop: 0,
                    yAxisHeight: 128,
                    yAxisLineDisplay: false,
                    yAxisTextDisplay: false,
                    yAxisTop: 0,

                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,//spacing variable
                        transY: 10
                    },
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: -10
                    },
                    rectangles: {
                        width: 7,
                        space: 20,
                        borderRadius: {
                            rx: 3,
                            ry: 3
                        },
                        marginFromBottom: 15,
                        marginFromLeft: 0,
                        gradients: [{
                            id: "selectedGradient",
                            offset: ["0%", "100%"],
                            stopColors: ["#6888d2", "#536fb1"]
                        }],
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: false
                        }
                    }
                },
                columnChartMultiSeriesOptions: {
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 34,
                        right: 24,
                        bottom: 72,
                        left: 24
                    },
                    totalHeight: 220,

                    labels: {
                        drawLabels: true,
                        marginTop: -16,
                        marginBottom: 4,
                        right: 3
                    },
                    rectangles: {
                        width: 9,
                        paddingTop: 30,
                        paddingLeft: -19,
                        paddingRight: 22,
                        paddingBottom: 33,
                        seriesPadding: 12.5,
                        transX: 4,
                        minHeight: 0.25,
                        borderRadius: {
                            rx: 4,
                            ry: 4
                        },
                        marginFromBottom: 5,
                        gradients: {
                            selectedInGradient: {
                                id: "selectedInGradient",
                                offset: ["0%","100%"],
                                stopColors:["#7193e2","#485f96"]
                            },
                            selectedOutGradient: {
                                id: "selectedOutGradient",
                                offset: ["0%","100%"],
                                stopColors:["#ffcc00","#ffb80a"]
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        translation: {
                            x: 2.5,
                            y: "height"
                        },
                        xAxis: {
                            hide: false,
                            tickPadding: 10,
                            minimizedPadding: {
                                top: 22,
                                bottom: 15
                            }
                        },
                        yAxis: {
                            hide: true
                        }
                    }
                },
                barChartOptions: {
                    chartHeight: 71,
                    MultiHorizontalChartHeightDesktop: 98,
                    MultiHorizontalChartWidthDesktop: 300,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 19,
                        right: 20,
                        bottom: 0,
                        left: 20

                    },
                    drawLine:false,
                    drawLabels: false,
                    rectangles: {
                        height: 4.8,//height for iphone 5 screen TODO - remove this height from configs
                        color: "rgba(169, 167, 167, 1)",
                        paddingTop: -22,//?
                        paddingLeft: 35,
                        paddingBottom: 5,
                        seriesPadding: 5,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        gradients: {
                            selectedInGradient: {
                                id: "selectedInGradient",
                                offset: ["0%","100%"],
                                stopColors:["#2c375f","#2c375f"]
                            },
                            selectedOutGradient: {
                                id: "selectedOutGradient",
                                offset: ["0%","100%"],
                                stopColors:["#d8275d","#d8275d"]
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        }
                    },
                    labels: {
                        paddingLeft: 40,
                        minWidth: 100
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: true
                        },
                        yAxis: {
                            hide: false,
                            paddingRight: 10,
                            transValue: -20
                        }
                    }
                },
                singleHorizontalChartOptions: {
                    chartHeight: 100,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 10,
                        right: 12,
                        bottom: 12,
                        left: 5

                    },
                    drawLabels: false,
                    rectangles: {
                        height: 7,
                        color: "rgba(169, 167, 167, 1)",
                        borderRadius: {
                            rx: 4,
                            ry: 4
                        },
                        groupMargins: {

                            //   It's possible to use negative values
                            top: -3.5,
                            left: 35
                        },
                        gradients: {
                            selectedGradient: {
                                id: "selectedGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#6888d2",
                                stopColor2: "#536fb1"
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        }
                    },
                    labels: {
                        paddingLeft: 40,
                        minWidth: 100
                    },
                    selected: {},
                    axis: {
                        xAxis: {
                            hide: true
                        },
                        yAxis: {
                            hide: false
                        }
                    }
                },
                barGraphPalette: ['rgba(223, 0, 73 ,1)', 'rgba(44, 55, 95, 1)'],
                barGraphLabelsPalette: ['rgba(40, 36, 37, 1)', 'rgba(84, 113, 180, 1)'],
                multiVerticalPalette: ['url(#selectedGradient)', 'rgba(215, 215, 215, 1)'],
                multiVerticalLabelsPalette: ['rgba(147, 145, 149, 1)', 'rgba(40, 36, 37, 1)'],
                columnGraphPalette: ['#5D68C2', '#3B49B6', '#1729AF', '#111F88', '#08176C'],
                barChartMultiSeriesLabels: function (labels) {
                    return function () {
                        if (labels && labels.length > 0) {
                            var label = labels[this.series.index];
                            return ("<span class='" + this.series.name + "'>" + label + "</span>");
                        }
                        else {
                            return "";
                        }
                    }
                }
            }
        });
        this.registerBlock("pie-chart", {
            blockClass: Personetics.teaser.NewPieChartBlockProduct,
            defaultConfig: {
                pieGraphPalette: function (selectedTabId) {
                    var outFlowsPalette = ['#d8275d'];
                    var inFlowsPalette = ['#2c375f'];
                    if (selectedTabId == "Out")
                        return outFlowsPalette;
                    return inFlowsPalette;
                },
                pieGrayColors : function(){
                    return ["#ededed", "#d5d6d7", "#dfe0e2", "#ededed", "#dfe0e2", "#d5d6d7", "#dfe0e2"];
                },
                pieOptions: {
                    arcs: {
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        cornerRadius: {
                            radiusCorner: 0
                        },
                    },
                    centerText: {
                        fontSize: 10,
                        fontWeight: 300,
                        color: '#000033'
                    },
                    showInfoContainer: false
                }
            }
        });
        this.registerBlock("arc-chart", {
            blockClass: Personetics.teaser.PieChartBlockProduct,
            defaultConfig: {
                pieGraphPalette: function (selectedTabId) {
                    if (selectedTabId == "Out")
                        return ['#ffce40', '#ffb608', '#ff9819', '#fe7d3f', '#f9652b', '#df4c3a', '#c72735'];
                    return ['#6787d1', '#027ac4', '#7390c5', '#3095bd', '#45a5d3', '#5acafa', '#95dafb'];
                },
                pieOptions: {
                    arcs: {
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        cornerRadius: {
                            radiusCorner: 9
                        },
                    },
                    centerText: {
                        fontSize: 15,
                        fontWeight: 300
                    },
                    showInfoContainer: false
                }
            }
        });
        this.registerBlock("pin-chart", {
            blockClass: Personetics.teaser.D3PinGraphChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                pinGraphChartOptions: {
                    svgHeight: 72,
                    svgWidth: 280,
                    svgHeightDesktop: 98,
                    maxBarHeight: 35,
                    labelTop: 0,
                    barTop: 10,
                    xAxisTop: 55,
                    yAxisHeight: 0,
                    yAxisTop: 0,
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 43,
                        bottom: 40
                    },
                    height: 180,
                    chart: {
                        transX: 0,
                        transY: 10
                    },
                    totalHeight: 220,
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: 4.5
                    },
                    rectangles: {
                        width: 9,
                        space: 40,
                        borderRadius: {
                            rx: 0,
                            ry: 0
                        },
                        gradients: {
                            selectedGradient: {
                                id: "selectedGradient",
                                offset: ["0%", "100%"],
                                stopColors: ["#6888d2", "#536fb1"]
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        translation: {
                            x: 0,
                            y: "height"
                        },
                        xAxis: {
                            hide: false,
                            tickPadding: 10,
                            collapsedPadding: {
                                top: 22,
                                bottom: 15
                            }
                        },
                        yAxis: {
                            x: 0,
                            y: 0,
                            hide: true
                        }
                    }
                }
            }
        });
        this.registerBlock("pin-graph", {
            blockClass: Personetics.teaser.D3PinGraphChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                pinGraphChartOptions: {
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    margin: {
                        top: 35,
                        right: 20,
                        bottom: 40,
                        left: 15
                    },
                    height: 102,
                    chart: {
                        transX: 0,
                        transY: 0
                    },
                    totalHeight: 102,
                    labels: {
                        drawLabels: false,
                        marginBottom: 18,
                        marginTop: 4.5,
                        marginRight: 5
                    },
                    rectangles: {
                        minHeightPercent: 0.15,
                        width: 8,
                        borderRadius: {
                            rx: 3,
                            ry: 3
                        },
                        marginFromBottom: 10,
                        marginFromLeft: 0,
                        gradients: {
                            selectedGradient: {
                                id: "selectedGradient",
                                offset1: "0%",
                                offset2: "100%",
                                stopColor1: "#6888d2",
                                stopColor2: "#536fb1"
                            }
                        },
                        filter: {
                            dropShadow: {
                                id: "dropShadow",
                                in: "SourceGraphic",
                                stdDeviation: 3,
                                dxOffset: 1,
                                dyOffset: 2
                            }
                        },
                        transition: {
                            duration: 1000,
                            delay: 500
                        }
                    },
                    selected: {},
                    axis: {
                        translation: {
                            x: 0,
                            y: "height"
                        },
                        xAxis: {
                            hide: false,
                            tickPadding: 8,
                            minimizedPadding: {
                                top: 22,
                                bottom: 15,
                                fontSize: 12,
                                fontWeight: 300,
                                color: '#A94F48'
                            },
                            fontSize: 12,
                            fontWeight: 300,
                            color: '#000'
                        },
                        yAxis: {
                            hide: true,
                            x: 0,
                            y: 0,
                            fontSize: 0,
                            fontWeight: 0,
                            color: '#000'
                        }
                    }
                }
            }
        });
        this.registerBlock("new-pin-chart", {
            blockClass: Personetics.teaser.PinGraphChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                pinGraphChartOptions: {
                    maxWidthBarPercent: 91,
                    pinChartHeight: 0.1232 //0.32 = 182 (sympli value) / 568 (window height)
                }
            }
        });
        this.registerBlock("new-pin-graph", {
            blockClass: Personetics.teaser.PinGraphChartBlock,
            defaultConfig: {
                desktopScreenWidth: 790,
                pinGraphChartOptions: {
                    maxWidthBarPercent: 91,
                    pinChartHeight: 0.1232 //0.32 = 182 (sympli value) / 568 (window height)
                }
            }
        });
        this.registerBlock("line-chart",{
            blockClass: Personetics.teaser.NewlineChartBlock,
            defaultConfig: {
                lineChartOptions:{
                    screen: {
                        ratio_medium: 1.17,
                        ratio_large: 1.3
                    },
                    //general
                    svgHeight: 71,
                    svgWidth:280,
                    //line
                    line_left: 5,
                    line_top: 14,
                    line_width:256,
                    line_height:40,
                    //line area
                    area_display: false,
                    //line style
                    lineStyle_interpolate:'cardinal',//cardinal/linear/monotone
                    lineStyle_thickness: 3,
                    //x axis
                    xAxis_display: false,
                    //y axis
                    yAxis_display: false,
                    //transition
                    duration: 2000,
                    //dots
                    dots_radius:3.5,
                    dots_radius_selected:4.5,
                    //labels
                    labels_display: false,
                    //horizonalLine
                    horizonalLine_display:false,

                    highlightBy: 'last',	// defines the criteria for style dots as selected dot, there are 4 options - max/min/first/last(default).
                    dotRect:{
                        height: 19,
                        yOffset: 35,
                        radiusX: 20,
                        radiusY: 10
                    },
                    dotText:{
                        yOffset: 21,
                        paddingLeft: 7.5,
                        paddingRight: 7.5
                    },
                    dotPolygon:{
                        yOffset: 30,
                        points: "20,10 10,10 15,20"
                    }
                },
                lineChartPalette: ['rgba(169, 167, 167, 1)']
            }
        });
        this.registerBlock("h-box", {
            blockClass: Personetics.teaser.HBoxBlock
        });
        this.registerBlock("tranList", {
            blockClass: Personetics.teaser.Transactions
        });
    };

    SkinSetup.prototype.registerDefaultChartHeplers = function registerDefaultChartHeplers() {
        this.registerChartHelper("verticalHelper", {
            helperClass:Personetics.utils.d3Helpers.VerticalChartHelperOpenBank
        });
        this.registerChartHelper("horizontalHelper", {
            helperClass:Personetics.utils.d3Helpers.HorizontalChartHelper
        });
        this.registerChartHelper("multiVerticalHelper", {
            helperClass:Personetics.utils.d3Helpers.MultiVerticalChartHelper
        });
        this.registerChartHelper("multiHorizontalHelper", {
            helperClass:Personetics.utils.d3Helpers.MultiHorizontalChartHelperOpenBank
        });
        this.registerChartHelper("pinGraphHelper", {
            helperClass:Personetics.utils.d3Helpers.PinGraphChartHelperOpenBank
        });
        //temporary call story registerChartHelper.
        Personetics.story.BlockChartFactory.registerChartHelper("lineChartHelper", {
            helperClass:Personetics.utils.d3Helpers.NewLineChartHelper
        });
    };

    SkinSetup.prototype.getTeasersConfig = function getTeasersConfig(){
        var config = {
            showArrows: false,
            minItemsForDisplayingArrows: 2,
            infiniteCarousel: true,
            numItemsDispaly: 3,
            showIndexDots: true,
            nextArrowDir: "rtl"
        }
        return config;
    };

    SkinSetup.prototype.getTeasersConfigDesktop = function getTeasersConfigDesktop(){
        var config = {
            showArrows: true,
            minItemsForDisplayingArrows: 2,
            infiniteCarousel: true,
            numItemsDispaly: 1,
            showIndexDots: true,
            nextArrowDir: "rtl"
        }
        return config;
    };

    window.SkinSetup = SkinSetup;

})(window, window.Personetics = window.Personetics || {}, jQuery);
